(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insightList", [
      "ngLodash"
    ]);
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("sensorAlertList", {
    bindings: {
      insights: "<",
      variant: "@",
      fetching: "<",
      config: "<"
    },
    controller: SensorAlertListController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/sensorAlerts/list/sensorAlertList.html"
  });

  /**
   * @ngInject
   * @param lodash
   * @param $controller
   * @param LIST_TYPES
   * @param areaService
   * @param CachingService
   * @param herdGroupService
   * @return {SensorAlertListController}
   */
  function SensorAlertListController(
    lodash,
    $controller,
    LIST_TYPES,
    areaService,
    CachingService,
    herdGroupService
  ) {
    $controller("InsightListController", {
      vm: this
    });

    /**
     * No areas are shown by default
     * @type {boolean}
     */
    this.withAreas = false;

    /**
     * No herd groups are shown by default
     * @type {boolean}
     */
    this.withHerdGroups = false;

    /**
     * @type {Array}
     */
    this.insightList = [];

    /**
     * Create an "inherited" init function
     */
    this.$onInit = lodash.wrap(this.$onInit, function (__super__) {
      __super__();

      areaService.getAreas().then(
        function (areas) {
          this.withAreas = !!areas.length;
        }.bind(this)
      );

      herdGroupService.getHerdGroups().$promise.then(
        function (herdGroups) {
          this.withHerdGroups = !!herdGroups.length;
        }.bind(this)
      );

      this.invalidateCache();
    });

    /**
     * If new data comes in then merge it with the old data
     */
    this.$onChanges = function () {
      /**
       * Check if the data coming is new or not
       */
      var isDataNew = lodash.isEmpty(
        lodash.intersectionWith(this.insightList, this.insights, lodash.isEqual)
      );

      if (isDataNew) {
        /**
         * merge new insights with the old one and then order all the insights on the basis of
         * startEpoch in desc order
         * @type {Array}
         */
        this.insightList = lodash.orderBy(
          lodash.concat(this.insightList, this.insights),
          function (insight) {
            var cowTag = insight.dairyCow.cowTagNumber;

            return isNaN(parseFloat(cowTag)) ? cowTag : parseFloat(cowTag);
          },
          ["desc"]
        );
      }
    };

    /**
     * invalidate the sensor cache
     */
    this.invalidateCache = function () {
      if (lodash.isArray(this.config)) {
        lodash.map(
          this.config,
          function (config) {
            CachingService.invalidate(this.getTypeNameFromFilter(config.filter).typeName.any.join());
          }.bind(this)
        );
      } else {
        CachingService.invalidate(this.getTypeNameFromFilter(this.config.filter).typeName.any.join());
      }
    };

    /**
     * Get insight type name from the filter
     * @param filter
     */
    this.getTypeNameFromFilter = function (filter) {
      return filter.insightType;
    };

    /**
     * List type to be used for (among others) copy key generation
     * @type {string}
     */
    this.listType = LIST_TYPES.sensorAlerts;

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("sensorAlertEntry", {
    bindings: {
      insight: "<",
      first: "<",
      variant: "<",
      withHerdGroup: "<"
    },
    controller: SensorAlertEntryController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/sensorAlerts/entry/sensorAlertEntry.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LIST_TYPES
   * @param areaService
   * @param LocoService
   * @param GenericInsightService
   * @return {SensorAlertEntryController}
   */
  function SensorAlertEntryController(
    $controller,
    LIST_TYPES,
    areaService,
    LocoService,
    GenericInsightService
  ) {
    $controller("ListEntryController", {
      vm: this
    });

    $controller("LoaderController", {
      vm: this
    });

    /**
     * Identify the list item (used for translations and class names)
     * @type {string}
     */
    this.listType = LIST_TYPES.sensorAlerts;

    /**
     * Get insight type anem
     */
    this.getTypeName = GenericInsightService.getTypeName;

    /**
     * Tell whether the insight belongs to the actionable main list
     * @return {boolean}
     */
    this.isMainListInsight = function () {
      return this.variant === "main-list";
    };

    /**
     * Tell whether the insight belongs to the actionable secondary list
     * @return {boolean}
     */
    this.isSecondaryListInsight = function () {
      return this.variant === "secondary-list";
    };

    /**
     * Show bullet if the insight is not seen, has not expired and has not resolved
     * @param insight
     */
    this.showBullet = function (insight) {
      return (
        (this.isMainListInsight() &&
          !GenericInsightService.isSeen(insight) &&
          !GenericInsightService.isResolved(insight)) ||
        (this.isSecondaryListInsight() && !GenericInsightService.isSeen(insight))
      );
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("missingEstrusInsightList", {
    bindings: {
      insights: "<",
      variant: "@",
      fetching: "<",
      icon: "@",
      validationWidget: "@"
    },
    controller: MissingEstrusInsightListController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/missingEstrusInsights/list/missingEstrusInsightList.html"
  });

  /**
   * @ngInject
   * @param lodash
   * @param $controller
   * @param LIST_TYPES
   * @param herdGroupService
   * @param CachingService
   * @param CycleAlertService,
   * @param LocoService
   * @return {MissingEstrusInsightListController}
   */
  function MissingEstrusInsightListController(
    lodash,
    $controller,
    LIST_TYPES,
    herdGroupService,
    CachingService,
    CycleAlertService,
    LocoService
  ) {
    $controller("InsightListController", {
      vm: this
    });

    /**
     * Instantiate base list ui controller.
     */
    $controller("InsightsListUIController", {
      vm: this
    });

    $controller("MissingEstrusController", {
      vm: this
    });

    /**
     * @type {Array}
     */
    this.herdList = [];

    /**
     * @type {Array}
     */
    this.insightList = [];

    /**
     *
     * @type {boolean}
     */
    this.showModal = false;

    /**
     * @type {undefined}
     */
    this.currentActiveInsight = undefined;

    /**
     * Keep a local track of valid/invalid for resolution modal titles
     * @type {boolean}
     */
    this.insightValid = false;

    /**
     * List type to be used for (among others) copy key generation
     * @type {string}
     */
    this.listType = LIST_TYPES.missingEstrus;

    /**
     * Init
     */
    this.$onInit = function () {
      herdGroupService.getHerdGroups().$promise.then(
        function (herds) {
          this.herdList = herds;
        }.bind(this)
      );

      CachingService.invalidate(["WFMissingEstrus", "WFMissingEstrusPostCalving"].join());
      CachingService.invalidate(["WFMissingEstrusTreated", "WFMissingEstrusPostCalvingTreated"].join());
      CachingService.invalidate(["WFMissingEstrusResolved", "WFMissingEstrusPostCalvingResolved"].join());
    };

    /**
     * If new data comes in then merge it with the old data
     */
    this.$onChanges = function () {
      /**
       * Check if the data coming is new or not
       */
      var isDataNew = lodash.isEmpty(
        lodash.intersectionWith(this.insightList, this.insights, lodash.isEqual)
      );

      if (isDataNew) {
        /**
         * merge new insights with the old one and then order all the insights on the basis of
         * startEpoch in desc order
         * @type {Array}
         */
        this.insightList = lodash.concat(this.insightList, this.insights);

        /**
         * if the list if a non-cyclic one then filter out resolved insights
         */
        if (this.variant === "non-cyclic") {
          this.insightList = CycleAlertService.filterResolved(this.insightList);
        }

        this.markInsightsAsSeen(this.insightList);
      }
    };

    /**
     * get classes for cow header
     * @return {string}
     */
    this.getCowHeaderColumnClassNames = function () {
      var classes = this.getClassNamesForCowColumn();

      if (!this.herdList.length) {
        classes += " badge-not-visible";
      }

      return classes;
    };

    /**
     * @param insight
     */
    this.toggleModal = function (insight) {
      this.currentActiveInsight = insight;
      this.showModal = !!insight;
    };

    /**
     * Validate and resolve insight
     * @param insight
     * @param valid
     */
    this.validateAndResolve = function (insight, valid) {
      this.currentlyValid = valid;

      if (insight.approved !== valid) {
        this.toggleModal(insight);
      }

      this.updateInsight(insight, {
        valid: valid
      });

      CachingService.invalidate(["WFMissingEstrusResolved", "WFMissingEstrusPostCalvingResolved"].join());
      CachingService.invalidate(["WFMissingEstrusTreated", "WFMissingEstrusPostCalvingTreated"].join());
    }.bind(this);

    this.getResolutionModalTitle = function () {
      return this.currentlyValid
        ? this.missingEstrusResolutionTitle.valid
        : this.missingEstrusResolutionTitle.invalid;
    };

    /**
     * Get translated header content.
     * Override this method because in case of missing estrus we need to filter out the resolved insights
     * and then show the count
     * @param variant
     * @return {string}
     */
    this.getHeaderContent = function (variant) {
      return LocoService.translate(this.listType, variant, null, {
        insightCount: this.insightList.length
      });
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("missingEstrusInsightEntry", {
    bindings: {
      insight: "<",
      herdList: "<",
      validationWidget: "<",
      validateAndResolve: "<"
    },
    controller: MissingEstrusInsightEntryController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/missingEstrusInsights/entry/missingEstrusInsightEntry.html"
  });

  /**
   * @ngInject
   * @param lodash
   * @param $controller
   * @param LIST_TYPES
   * @param GenericInsightService
   * @param LocoService
   * @param CycleAlertService
   * @return {MissingEstrusInsightEntryController}
   */
  function MissingEstrusInsightEntryController(
    lodash,
    $controller,
    LIST_TYPES,
    GenericInsightService,
    LocoService,
    CycleAlertService
  ) {
    $controller("ListEntryController", {
      vm: this
    });

    $controller("MissingEstrusController", {
      vm: this
    });

    this.listType = LIST_TYPES.missingEstrus;

    this.getDim = GenericInsightService.getDIM;

    this.isValidInsightVariant = CycleAlertService.isValidInsightVariant;

    /**
     * get tooltip text
     */
    this.getTooltipText = function () {
      return LocoService.translate(CycleAlertService.getInsightVariant(this.insight));
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("healthInsightListBeta", {
    bindings: {
      insights: "<",
      variant: "@",
      fetching: "<",
      areaList: "<",
      icon: "@"
    },
    controller: HealthInsightListController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/healthInsightBeta/list/healthInsightList.html"
  });

  /**
   * @ngInject
   * @param lodash
   * @param $controller
   * @param LIST_TYPES
   * @param localStorageService
   * @param GenericInsightService
   * @param herdGroupService
   * @param LocoService
   * @param healthInsightService
   * @return {HealthInsightListController}
   */
  function HealthInsightListController(
    lodash,
    $controller,
    LIST_TYPES,
    localStorageService,
    GenericInsightService,
    herdGroupService,
    LocoService,
    healthInsightService
  ) {
    $controller("InsightListController", {
      vm: this
    });

    /**
     * @TODO: this is a part of legacy codebase. We cannot change it right now as it
     *        is being used in all the other insights too.
     * @type {string}
     */
    var ST_LOADED_INSIGHTS = "insights collection";
    var INSIGHTS_CATEGORY = "insights category";
    var DEFAULT_HEALTH_SORTING_MECHANISM = "ctra.defaultSortingMechanism";

    this.title = "";
    this.description = "";
    this.sortingMechanism = "";

    /**
     * Identify the list item (used for translations and class names)
     * @type {string}
     */
    this.listType = LIST_TYPES.healthInsights;

    this.$onChanges = function () {
      /**
       * Update list header
       */
      this.updateListHeaderData();

      /**
       * get the sorting mechanism
       */
      this.sortingMechanism = localStorageService.get(DEFAULT_HEALTH_SORTING_MECHANISM);

      /**
       * if the user has never set the sorting mechanism then default it to priority
       */
      if (angular.isUndefined(this.sortingMechanism) || this.sortingMechanism === null) {
        this.sortingMechanism = "priority";
        localStorageService.set(DEFAULT_HEALTH_SORTING_MECHANISM, this.sortingMechanism);
      }

      /**
       * Get all the herd groups so that we can populate the group data in each insight
       */
      var herdGroups = herdGroupService.getHerdGroups();

      /**
       * filter out all the insights that don't have a dairy cow object
       */
      this.insights = lodash.filter(this.insights, function (insight) {
        return !!insight.dairyCow;
      });

      /**
       * Add group name in each insight. The reason we are doing this is because we
       * need to sort the insights by group name too. So it's better to populate that data
       * once and then reuse it.
       */
      this.insights = lodash.map(this.insights, function (insight) {
        return lodash.merge(insight, {
          dairyCow: {
            groupName: lodash.get(
              lodash.find(herdGroups, { HerdGroupID: insight.dairyCow.herdGroupID }),
              "groupName"
            )
          }
        });
      });

      this.insights = this.sortInsights(this.insights, this.sortingMechanism);
    };

    /**
     * Update the title and the header of the list
     */
    this.updateListHeaderData = function () {
      var insightsByPriority = healthInsightService.groupInsightsByPriority(this.insights);
      var insightCount = lodash.size(lodash.flatten(lodash.values(insightsByPriority)));

      this.title = LocoService.translate(
        lodash.join([this.listType, this.variant, "list-title-by-priority"], "-"),
        {
          highPriorityInsightCount: insightsByPriority.high ? insightsByPriority.high.length : 0,
          insightCount: insightCount
        }
      );

      this.description = LocoService.translate(
        lodash.join([this.listType, this.variant, "list-description-by-priority"], "-"),
        {
          mediumPriorityInsightCount: insightsByPriority.medium ? insightsByPriority.medium.length : 0,
          lowPriorityInsightCount: insightsByPriority.low ? insightsByPriority.low.length : 0
        }
      );
    };

    /**
     * Sort the insights depending on the sorting Mechanism
     * @param insights
     * @param sortingMechanism
     * @return []
     */
    this.sortInsights = function (insights, sortingMechanism) {
      var sortedInsights = [];

      if (sortingMechanism === "date") {
        sortedInsights = healthInsightService.sortByDate(insights);
      } else if (sortingMechanism === "d.i.m") {
        sortedInsights = healthInsightService.sortByDIM(insights);
      } else if (sortingMechanism === "group") {
        sortedInsights = healthInsightService.sortByGroup(insights);
      } else {
        sortedInsights = healthInsightService.sortByPriority(insights);
      }
      return sortedInsights;
    };

    /**
     * Update insight collection in local storage to contain that section insights ids
     * whose insight we are clicking.
     * @return {void}
     */
    this.updateInsightCollection = function () {
      var idCollection = lodash.map(this.insights, "GenericInsightID");
      localStorageService.set(ST_LOADED_INSIGHTS, idCollection);
      localStorageService.set(INSIGHTS_CATEGORY, "health");
    };

    /**
     * Update the sorting mechanism
     * @param sortingMechanism
     * @return {void}
     */
    this.updateSortingMechanism = function (sortingMechanism) {
      this.sortingMechanism = sortingMechanism;
      localStorageService.set(DEFAULT_HEALTH_SORTING_MECHANISM, sortingMechanism);
      this.insights = this.sortInsights(this.insights, sortingMechanism);
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("healthInsightEntryBeta", {
    bindings: {
      insight: "<",
      areaList: "<",
      variant: "<"
    },
    controller: HealthInsightEntryController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/healthInsightBeta/entry/healthInsightEntry.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LIST_TYPES
   * @param dateTimeService
   * @param LocoService
   * @param GenericInsightService
   * @param lodash
   * @param healthInsightService
   * @return {HealthInsightEntryController}
   */
  function HealthInsightEntryController(
    $controller,
    LIST_TYPES,
    dateTimeService,
    LocoService,
    GenericInsightService,
    lodash,
    healthInsightService
  ) {
    $controller("ListEntryController", {
      vm: this
    });

    $controller("LoaderController", {
      vm: this
    });

    /**
     * Identify the list item (used for translations and class names)
     * @type {string}
     */
    this.listType = LIST_TYPES.healthInsights;
    this.getDIM = GenericInsightService.getDIM;

    /**
     * Get classes for the health insights container
     * @param insight
     * @return {string}
     */
    this.getContainerClasses = function (insight) {
      var classes = [];
      var priorityValue = null;
      var typeName = GenericInsightService.getTypeName(insight);

      if (insight.insightType.insightCategory) {
        classes.push("insight-category-" + insight.insightType.insightCategory);
      }

      if (insight.insightValid) {
        classes.push("insight-valid-" + insight.insightValid);
      }

      if (insight.insightType.typeName && (this.variant === "actionable" || this.variant === "partial")) {
        classes.push("insight-type-" + typeName);
      }

      /**
       * assign medium priority class if an insight does not have any meta data
       * and if it does have then assign priority classes on the bases of insight
       */
      if (lodash.isEmpty(angular.fromJson(insight.insightMetadata))) {
        classes.push(
          typeName === "ObviousHealthInsight" ? "insight-priority-high" : "insight-priority-medium"
        );
      } else {
        priorityValue = healthInsightService.getPriorityValue(insight);

        classes.push(
          lodash.join(["insight-priority", healthInsightService.getPriority(typeName, priorityValue)], "-")
        );
      }

      return classes.join(" ");
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("healthInsightList", {
    bindings: {
      insights: "<",
      variant: "@",
      fetching: "<",
      areaList: "<",
      icon: "@"
    },
    controller: HealthInsightListController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/healthInsight/list/healthInsightList.html"
  });

  /**
   * @ngInject
   * @param lodash
   * @param $controller
   * @param LIST_TYPES
   * @param localStorageService
   * @return {HealthInsightListController}
   */
  function HealthInsightListController(lodash, $controller, LIST_TYPES, localStorageService) {
    $controller("InsightListController", {
      vm: this
    });

    var ST_LOADED_INSIGHTS = "insights collection";
    var INSIGHTS_CATEGORY = "insights category";

    this.$onChanges = function () {
      this.insights = this.sortInsights(this.insights);
    };

    /**
     * Identify the list item (used for translations and class names)
     * @type {string}
     */
    this.listType = LIST_TYPES.healthInsights;

    /**
     * Sort health insights
     * @param insights
     * @return {*[]}
     */
    this.sortInsights = function (insights) {
      var filteredInsights;

      /**
       * @type {[]}
       */
      filteredInsights = lodash.filter(insights, function (insight) {
        return !!insight.dairyCow;
      });

      /**
       * in case of resolved list we do not need to separately sort the major and non major
       * health insights.
       */
      if (lodash.includes(this.variant, "resolved")) {
        insights = lodash.orderBy(
          filteredInsights,
          [
            function (insight) {
              return parseInt(insight.startEpoch);
            }
          ],
          ["desc"]
        );
      } else {
        var majorHealthInsights = lodash.filter(filteredInsights, function (insight) {
          return ["ObviousHealthInsight", "MajorHealthIssueInsight"].includes(insight.insightType.typeName);
        });

        var nonMajorHealthInsights = lodash.filter(filteredInsights, function (insight) {
          return !["ObviousHealthInsight", "MajorHealthIssueInsight"].includes(insight.insightType.typeName);
        });

        majorHealthInsights = lodash.orderBy(
          majorHealthInsights,
          [
            function (insight) {
              return parseInt(insight.startEpoch);
            }
          ],
          ["desc"]
        );

        nonMajorHealthInsights = lodash.orderBy(
          nonMajorHealthInsights,
          [
            function (insight) {
              return parseInt(insight.startEpoch);
            }
          ],
          ["desc"]
        );

        insights = lodash.concat(majorHealthInsights, nonMajorHealthInsights);
      }

      return insights;
    };

    /**
     * Update insight collection in local storage to contain that section insights ids
     * whose insight we are clicking.
     */
    this.updateInsightCollection = function () {
      var idCollection = lodash.map(this.insights, "GenericInsightID");
      localStorageService.set(ST_LOADED_INSIGHTS, idCollection);
      localStorageService.set(INSIGHTS_CATEGORY, "health");
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("groupInsightEntry", {
    bindings: {
      insight: "<",
      areaList: "<",
      variant: "<"
    },
    controller: GroupInsightEntryController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/groupInsights/entry/groupInsightEntry.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LIST_TYPES
   * @param LocoService
   * @param GenericInsightService
   * @param lodash
   * @return {GroupInsightEntryController}
   */
  function GroupInsightEntryController(
    $controller,
    LIST_TYPES,
    LocoService,
    GenericInsightService,
    lodash
  ) {
    $controller("ListEntryController", {
      vm: this
    });

    $controller("LoaderController", {
      vm: this
    });

    /**
     * Inherit from generic insight controller
     */
    $controller("InsightBaseController", {
      vm: this
    });

    /**
     * Identify the list item (used for translations and class names)
     * @type {string}
     */
    this.listType = LIST_TYPES.groupInsights;

    /**
     * Get translated insight title
     * @param {{}} insight
     * @return {boolean}
     */
    this.getInsightTitle = GenericInsightService.getTranslatedTitle;

    /**
     * Create an "inherited" init function
     */
    this.$onInit = lodash.wrap(this.$onInit, function (__super__) {
      __super__();
    }.bind(this));

    /**
     * Show bullet if the insight is not seen, has not expired and has not resolved
     * @param insight
     * @returns {boolean}
     */
    this.showBullet = lodash.wrap(
      this.showBullet,
      function (showBullet) {
        return showBullet(this.insight) && !GenericInsightService.isResolved(this.insight);
      },
      this.showBullet
    );

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("healthInsightEntry", {
    bindings: {
      insight: "<",
      areaList: "<",
      variant: "<"
    },
    controller: HealthInsightEntryController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/healthInsight/entry/healthInsightEntry.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LIST_TYPES
   * @param dateTimeService
   * @param LocoService
   * @param GenericInsightService
   * @return {HealthInsightEntryController}
   */
  function HealthInsightEntryController(
    $controller,
    LIST_TYPES,
    dateTimeService,
    LocoService,
    GenericInsightService
  ) {
    $controller("ListEntryController", {
      vm: this
    });

    $controller("LoaderController", {
      vm: this
    });

    /**
     * Identify the list item (used for translations and class names)
     * @type {string}
     */
    this.listType = LIST_TYPES.healthInsights;

    /**
     * Get days in milk
     * @param insight
     * @return {number}
     */
    this.getDIM = function (insight) {
      return GenericInsightService.getDIM(insight, { useFallback: true });
    };

    /**
     * Get classes for the health insights container
     * @param insight
     * @return {string}
     */
    this.getContainerClasses = function (insight) {
      var classes = [];
      if (insight.insightType.insightCategory) {
        classes.push("insight-category-" + insight.insightType.insightCategory);
      }

      if (insight.insightValid) {
        classes.push("insight-valid-" + insight.insightValid);
      }

      if (insight.insightType.typeName && (this.variant === "actionable" || this.variant === "partial")) {
        classes.push("insight-type-" + insight.insightType.typeName);
      }

      return classes.join(" ");
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insightList")
    .component("groupInsightList", {
      bindings: {
        insights: "<",
        variant: "@",
        fetching: "<"
      },
      controller: GroupInsightListController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightList/components/groupInsights/list/groupInsightList.html"
    });

  /**
   * @ngInject
   * @param lodash
   * @param $controller
   * @param LIST_TYPES
   * @return {GroupInsightListController}
   */
  function GroupInsightListController (lodash, $controller, LIST_TYPES) {
    $controller("InsightListController", {
      vm: this
    });

    /**
     * List type to be used for (among others) copy key generation
     * @type {string}
     */
    this.listType = LIST_TYPES.groupInsights;

    this.$onChanges = function() {
      this.insights = this.sortInsights(this.insights);
    };

    /**
     * sort insights in a chronological order
     * @param insights
     * @return {Array}
     */
    this.sortInsights = function(insights) {
      return lodash.orderBy(insights, [function(insight) {
        return parseInt(insight.startEpoch);
      }], ["desc"]);
    };

    return this;
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("calvingInsightList", {
    bindings: {
      insights: "<",
      variant: "@",
      fetching: "<",
      withGroupHeaders: "<",
      icon: "@"
    },
    controller: CalvingInsightListController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/calvingInsights/list/calvingInsightList.html"
  });

  /**
   * @ngInject
   * @param lodash
   * @param $controller
   * @param LIST_TYPES
   * @param areaService
   * @param INSIGHT_CATEGORIES
   * @param CachingService
   * @param calvingService
   * @param GenericInsightService
   * @param LocoService
   * @param herdGroupService
   * @param KersiaBolusService
   * @return {CalvingInsightListController}
   */
  function CalvingInsightListController(
    lodash,
    $controller,
    LIST_TYPES,
    areaService,
    INSIGHT_CATEGORIES,
    CachingService,
    calvingService,
    GenericInsightService,
    LocoService,
    herdGroupService,
    KersiaBolusService
  ) {
    $controller("InsightListController", {
      vm: this
    });

    /**
     * List of insights with bolus recommendations
     * @type {{}}
     */
    this.bolusRecommendations = {};

    /**
     * @type {Array}
     */
    this.areaList = [];

    /**
     * @type {Array}
     */
    this.insightList = [];

    /**
     * @type {Array}
     */
    this.herdList = [];

    /**
     *
     * @type {boolean}
     */
    this.showModal = false;

    /**
     * @type {undefined}
     */
    this.currentActiveInsight = undefined;

    /**
     * List type to be used for (among others) copy key generation
     * @type {string}
     */
    this.listType = LIST_TYPES.calvingInsights;

    this.$onInit = function () {
      areaService.getAreas().then(
        function (areas) {
          this.areaList = areas;
        }.bind(this)
      );

      herdGroupService.getHerdGroups().$promise.then(
        function (herds) {
          this.herdList = herds;
        }.bind(this)
      );

      CachingService.invalidate(INSIGHT_CATEGORIES.calving.join());
    };

    this.$onChanges = function () {
      var updatedInsights = this.processInsights(this.insights, {
        /**
         * Use the calving label's epoch to position the insight in the list
         * @param insight
         * @return {number}
         */
        resolveEpoch: function (insight) {
          var label = calvingService.getCalvingLabel(insight);

          return label ? label.startEpoch : insight.startEpoch;
        }
      });

      this.markInsightsAsSeen(this.insights);

      /**
       * Check if the data coming is new or not
       */
      var isDataNew = lodash.isEmpty(
        lodash.intersectionWith(this.insightList, updatedInsights, lodash.isEqual)
      );

      if (isDataNew) {
        this.insightList = this.mergeInsight(this.insightList, updatedInsights);
      }

      if (KersiaBolusService.isEnabled() && this.insights.length) {
        KersiaBolusService.fetchStatus(lodash.map(this.insights, "GenericInsightID")).then(
          function (result) {
            /**
             * At the moment we can only deal with Calcium Bolus recommendations, so anything else
             * will be elegantly ignored.
             */
            lodash.merge(
              this.bolusRecommendations,
              lodash.mapValues(result, function (recommendationList) {
                return lodash.find(recommendationList, ["recommendationType", "BolusCalcium"]);
              })
            );
          }.bind(this)
        );
      }
    };

    /**
     * Get translated header content.
     * Override this method because in case of calving we need to update the count when the user marks an insight as
     * resolved. Because we are not moving it into the next list due to which we need to do this.
     * @param variant
     * @return {string}
     */
    this.getHeaderContent = function (variant) {
      var insightCount = lodash.reduce(
        this.insightList,
        function (insightCount, value) {
          var internalSum = lodash.reduce(
            value[1],
            function (internalSum, insight) {
              if (!GenericInsightService.isResolved(insight)) {
                internalSum = internalSum + 1;
              }
              return internalSum;
            },
            0
          );
          return insightCount + internalSum;
        },
        0
      );

      return LocoService.translate(this.listType, variant, null, {
        insightCount: insightCount
      });
    };

    /**
     * Merge old insights with the new insights so a day heading should only come once.
     * @param oldInsights
     * @param newInsight
     * @returns {*|Array}
     */
    this.mergeInsight = function (oldInsights, newInsight) {
      var data = {};

      lodash.forEach(lodash.concat(oldInsights, newInsight), function (insight) {
        if (data[insight[0]]) {
          data[insight[0]] = lodash.concat(data[insight[0]], insight[1]);
        } else {
          data[insight[0]] = insight[1];
        }
      });

      return lodash.toPairs(data);
    };

    /**
     * Update calving
     * @param insight
     */
    this.updateCalving = function (insight) {
      if (lodash.isBoolean(insight.calved)) {
        this.toggleCalvingModal(insight);
      }
    };

    this.toggleCalvingModal = function (insight) {
      this.currentActiveInsight = insight;
      this.showModal = !!insight;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("calvingInsightEntry", {
    bindings: {
      insight: "<",
      herdList: "<",
      updateCalving: "&",
      recommendation: "<"
    },
    controller: CalvingInsightEntryController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightList/components/calvingInsights/entry/calvingInsightEntry.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LIST_TYPES
   * @param dateTimeService
   * @param LocoService
   * @param GenericInsightService
   * @param lodash
   * @param calvingService
   * @param $scope
   * @param $timeout
   * @return {CalvingInsightEntryController}
   */
  function CalvingInsightEntryController(
    $controller,
    LIST_TYPES,
    dateTimeService,
    LocoService,
    GenericInsightService,
    lodash,
    calvingService,
    $scope,
    $timeout
  ) {
    $controller("ListEntryController", {
      vm: this
    });

    $controller("LoaderController", {
      vm: this
    });

    $controller("CalvingBaseController", {
      vm: this
    });

    /**
     * Identify the list item (used for translations and class names)
     * @type {string}
     */
    this.listType = LIST_TYPES.calvingInsights;

    /**
     *
     * @param insight
     * @returns {string}
     */
    this.getClassNamesForCowColumn = function (insight) {
      var options = lodash.assign(
        {
          addBadgeSpace: !this.herdList.length
        },
        options
      );

      if (this.herdList.length) {
        options = lodash.assign(
          {
            areaWidth: 3
          },
          options
        );
      }

      return this.resolveClassName(insight, 5, options);
    };

    /**
     * Callback when the validation is updated.
     * We hook up deleting the calving labels here is the user hits "not calved".
     */
    this.onUpdateValidation = function () {
      var label = calvingService.getCalvingLabel(this.insight);

      if (label && this.insight.calved !== true) {
        calvingService.removeCalvingLabel(this.insight);
      }

      this.updateCalving(this.insight);
    };

    /**
     * Get calving time
     * @return {string}
     */
    this.getCalvingTime = function () {
      var label = calvingService.getCalvingLabel(this.insight);

      return dateTimeService.asDateString(label.startEpoch, "LT");
    };

    /**
     * Tell whether to show the Kersia bolus recommendation
     * @return {boolean}
     */
    this.hasRecommendation = function () {
      return !lodash.isUndefined(this.recommendation);
    };

    /**
     * Handle updates coming from the bolus modal
     */
    this.onBolusModalUpdate = function (updates) {
      lodash.assign(this.recommendation, updates);

      $timeout(function () {
        $scope.$apply();
      }.bind(this));
    };

    /**
     * Show the calcium bolud modal
     */
    this.showCalciumBolusModal = function () {
      angular
        .element("#calcium-bolus-dialog")
        .data("insight", this.insight)
        .data("recommendation", this.recommendation)
        .data("callback", this.onBolusModalUpdate.bind(this))
        .modal("show");
    };

    /**
     * Get the icon variant to display
     * @return {string}
     */
    this.getIconVariant = function () {
      if (this.hasRecommendation()) {
        switch (this.recommendation.isApplied) {
          case null:
            return "capsule";
          case true:
            return "capsule-tick";
          case false:
            return "capsule-cross";
        }
      }
    };

    /**
     * Get classname for bolus pill icon container
     * @return {string}
     */
    this.getBolusContainerClassname = function () {
      var classnames = ["kersia-bolus-icon", this.hasRecommendation() ? "col-xs-2" : "hidden"];

      return classnames.join(" ");
    };

    return this;
  }
})();

(function () {
  "use strict";

  /**
   * Insight check values.
   * @type {{True: number, False: number, NotSet: number, Maybe: number}}
   * @constant
   * @memberOf ctraUIComponents.insight.insightChecks
   */
  var INSIGHT_CHECK_VALUES = {
    True: 0,
    False: 1,
    NotSet: 2,
    Maybe: 3
  };

  /**
   * Resolution view variants.
   * @type {{topSuggestions: string, mostLikely: string, history: string, question: string, results: string}}
   */
  var RESOLUTION_VIEW_VARIANTS = {
    topSuggestions: "topSuggestions",
    mostLikely: "mostLikely",

    // Add mapping with values in VIEW_STATES for easier conversion.
    history: "topSuggestions",
    question: "topSuggestions",
    results: "mostLikely"
  };

  /**
   * Display states of the questionnaire, depending on the progress.
   * @type {{history: string, question: string, results: string}}
   */
  var VIEW_STATES = {
    history: "history",
    question: "question",
    results: "results"
  };

  angular
    .module("ctraUIComponents.insight.insightChecks", [
      "ctraUIComponents.insight"
    ])
    .constant("INSIGHT_CHECK_VALUES", INSIGHT_CHECK_VALUES)
    .constant("RESOLUTION_VIEW_VARIANTS", RESOLUTION_VIEW_VARIANTS)
    .constant("VIEW_STATES", VIEW_STATES)
    .component("insightChecks", {
      bindings: {
        insight: "<"
      },
      controller: insightChecksController,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/insightChecks/insightChecks.html"
    });

  /**
   * Insight checks controller.
   * @param insightCheckService
   * @param insightService
   * @param $q
   * @param $stateParams
   * @param $translate
   * @param lodash
   * @param VALIDATION
   * @ngInject
   */
  function insightChecksController (insightCheckService, insightService,
                                    $q, $stateParams, $translate, lodash, VALIDATION) {
    /**
     * Set context for closures.
     * @type {insightChecksController}
     */
    var $ctrl = this;

    /**
     * Insight ID.
     * @type {number}
     */
    var insightID = +$stateParams.genericInsightID;

    /**
     * Data request to use for fetching data from the server.
     * @type {Function}
     */
    var dataRequest = insightCheckService.decorateServerCall({
      before: lodash.partial(setLoading, true),
      after: lodash.partial(setLoading, false)
    });

    /**
     * Calls and handlers to use to assemble the data from.
     * @type {{
     *  history: {call: insightCheckService.getAllSeenRecommendedChecks, handler: onChecksRetrieved},
     *  historyAndNext: {call: insightCheckService.getAllSeenRecommendedChecks, handler: onChecksRetrieved},
     *  next: {call: insightCheckService.getNextRecommendedCheck, handler: onNextCheckRetrieved},
     *  resolutions: {call: insightCheckService.getResolutions, handler: onResolutionsRetrieved}
     * }}
     */
    var PARTIALS = {
      history: {
        call: insightCheckService.getAllSeenRecommendedChecks,
        handler: onChecksRetrieved
      },
      next: {
        call: insightCheckService.getNextRecommendedCheck,
        handler: onNextCheckRetrieved
      },
      resolutions: {
        call: insightCheckService.getResolutions,
        handler: onResolutionsRetrieved
      }
    };

    /**
     * Make VIEW_STATES available in the controller.
     * @memberOf insightChecksController
     * @type {{history: string, question: string, results: string}}
     */
    $ctrl.viewStates = VIEW_STATES;

    /**
     * Make resolution variants accessible to controller.
     * @memberOf insightChecksController
     * @type {{topSuggestions: string, mostLikely: string, history: string, question: string, results: string}}
     */
    $ctrl.resolutionVariants = RESOLUTION_VIEW_VARIANTS;

    /**
     * View state of the questionnaire.
     * @memberOf insightChecksController
     * @type {string}
     */
    $ctrl.currentViewState = VIEW_STATES.question;

    /**
     * Loading state indicator.
     * @memberOf insightChecksController
     * @type {boolean}
     */
    $ctrl.isLoading = true;

    /**
     * Enable back button.
     * @type {boolean}
     */
    $ctrl.mayGoBackInTime = true;

    /**
     * Enable forward button.
     * @type {boolean}
     */
    $ctrl.mayGoForwardInTime = true;

    /**
     * Possible resolutions of the current insight.
     * @memberOf insightChecksController
     * @type {Array}
     */
    $ctrl.possibleResolutions = {
      likely: [],
      possible: []
    };

    /**
     * Actions to perform when the component is initialised.
     * @memberOf insightChecksController
     * @type {function}
     */
    $ctrl.$onInit = function () {
      fetchData(PARTIALS.history, PARTIALS.next, PARTIALS.resolutions);
    };

    /**
     * Returns the classname of the container based on the page state.
     */
    function getClassName () {
      return [
        "showing-" + $ctrl.currentViewState,
        $ctrl.isLoading ? "loading" : ""
      ].join(" ");
    }

    /**
     * Fetches data from the server and takes care of handling response.
     */
    function fetchData (/* PARTIALS.history, PARTIALS.next, PARTIALS.resolutions */) {
      // Convert arguments to proper Array.
      var args = Array.prototype.slice.call(arguments);

      // Assemble an Array of end-point calls to pass to $q.
      var calls = args.map(function (partial) {
        return partial.call(insightID);
      });

      // Assemble handlers the same way as above.
      var handlers = args.map(function (partial) {
        return partial.handler;
      });

      dataRequest(
        // Release all the data calls at once and wait for them to return.
        $q.all(calls)
      ).then(function (bundledResponse) {
        // Call the appropriate response handlers.
        if (bundledResponse) {
          handlers.forEach(function (handler, idx) {
            handler.call($ctrl, bundledResponse[idx].data);
          });

          toggleTimeTravel();
        }
      });
    }

    /**
     * Set a question of given ID to a specific value in INSIGHT_CHECK_VALUES.
     * @param insightCheck - the insightCheck object to be modified (question to be answered)
     * @param value - value (checkState) to set on the question
     */
    function updateQuestion (insightCheck, value) {
      return dataRequest(
        insightCheckService.updateInsightCheck(insightCheck, {
          checkState: value
        })
      );
    }

    /**
     * Handles answering a question and refreshing user interface afterward.
     * @param insightCheck - the insightCheck object to be modified (question to be answered)
     * @param value - value (checkState) to set on the question
     */
    function questionAnswered (insightCheck, value) {
      // Prefill fetchData with the expected number of arguments.
      var updateInterface = lodash.partial(fetchData, PARTIALS.history, PARTIALS.next, PARTIALS.resolutions);

      updateQuestion(insightCheck, value).then(
        lodash.ary(updateInterface, 0) // Accept 0 arguments.
      );
    }

    /**
     * Set the loading state indicator.
     * @param {boolean} to - the value to set loading to
     */
    function setLoading (to) {
      $ctrl.isLoading = !!to;
    }

    /**
     * Return the index of the current question in history (with last insight check included).
     */
    function getCurrentQuestionIndex () {
      return lodash.findIndex(lodash.concat($ctrl.history, $ctrl.lastInsightCheck), function (item) {
        return item.CheckID === $ctrl.currentInsightCheck.CheckID;
      });
    }

    /**
     * Enable or disable time travel (back and forward button) based on current check and history.
     * @param {number} currentPosition - the index of the current question in history
     */
    function toggleTimeTravel (currentPosition) {
      currentPosition = currentPosition || getCurrentQuestionIndex();

      $ctrl.mayGoBackInTime = currentPosition > 0;
      $ctrl.mayGoForwardInTime = currentPosition < getCleanHistory($ctrl.history).length;
    }

    /**
     * Toggle history of questions.
     */
    function toggleHistory () {
      if ($ctrl.currentViewState === VIEW_STATES.history) {
        if (isValidCheck($ctrl.currentInsightCheck)) {
          $ctrl.currentViewState = VIEW_STATES.question;
        } else {
          $ctrl.currentViewState = VIEW_STATES.results;
        }
      } else {
        $ctrl.currentViewState = VIEW_STATES.history;
      }
    }

    /**
     * Travel in time with back and forward buttons.
     * @param direction
     * @returns {Function}
     */
    function moveInHistory (direction) {
      return function () {
        // Find the current position in history.
        var currentPosition = getCurrentQuestionIndex();

        // History including the last insight check.
        var inclusiveHistory = lodash.concat($ctrl.history, $ctrl.lastInsightCheck);

        // Move to the previous or next question.
        var newInsightCheck = currentPosition > -1 ?
          inclusiveHistory[currentPosition + direction] : lodash.last(inclusiveHistory);

        if (newInsightCheck) {
          $ctrl.currentInsightCheck = newInsightCheck;
          toggleTimeTravel(currentPosition + direction);
        }
      };
    }

    /**
     * Populate context with already answered checks.
     * @param {Array} response - the history of seen checks, where the last is the current question
     */
    function onChecksRetrieved (response) {
      /**
       * History of questions already answered (including the current question).
       * @memberOf insightChecksController
       * @type {Array}
       */
      $ctrl.history = getCleanHistory(response);
    }

    /**
     * Creates a history without invalid insight checks.
     * @param {Array} inclusiveHistory
     */
    function getCleanHistory (inclusiveHistory) {
      return inclusiveHistory.filter(function (insightCheck) {
        return isValidCheck(insightCheck) && insightCheck.checkState !== INSIGHT_CHECK_VALUES.NotSet;
      });
    }

    /**
     * Populate context with the current question.
     * @param {Array} response - the possible resolutions of the current insight
     */
    function onResolutionsRetrieved (response) {
      // Make sure both sets have some results for testing.
      // if (!response.likely.length) {
      //   response.likely = lodash.take(response.possible, Math.ceil(Math.random() * response.possible.length));
      //   response.possible = lodash.drop(response.possible, response.likely.length);
      // }

      // Map server response to something we can work with.
      var processed = lodash.mapValues(response, function (listOfResolutions, key) {
        return listOfResolutions.map(function (resolution) {
          return {
            id: lodash.snakeCase(resolution.resolution),
            title: resolution.resolution.toLowerCase(),
            fromResolutionSet: key // reference to where it belongs originally
          };
        });
      });

      setPossibleResolutions(processed);
    }

    /**
     * Sets possibleResolutions. Removes the already existing values from the initial set.
     * @param {Object} unfiltered
     */
    function setPossibleResolutions (unfiltered) {
      $ctrl.possibleResolutions = lodash.mapValues(unfiltered, function (listOfResolutions) {
        return lodash.reject(listOfResolutions, function (resolution) {
          return $ctrl.insight.insightResolution.map(function (item) {
            return item.id
          }).indexOf(resolution.id) > -1;
        });
      });
    }

    /**
     * Populate context with a new question.
     * @param {Object} response - the current question in line
     */
    function onNextCheckRetrieved (response) {
      /**
       * The current check to answer.
       * @memberOf insightChecksController
       * @type {Object}
       */
      $ctrl.currentInsightCheck = response;

      /**
       * Reference to the last unanswered insight check,
       * as currentInsightCheck may change as the user interacts with the app.
       * @memberOf insightChecksController
       * @type {Object}
       */
      $ctrl.lastInsightCheck = response;

      if (!isValidCheck(response)) {
        $ctrl.currentViewState = VIEW_STATES.results;
      }
    }

    /**
     * Check whether the check is valid. Naive, but does the trick so far.
     * By design, the questionnaire is finished if the last question is an empty object.
     * @param insightCheck
     * @returns {boolean}
     */
    function isValidCheck (insightCheck) {
      return insightCheck.CheckID;
    }

    /**
     * Select a resolution and save it through the insight service.
     * @param {{resolution: string}} insightResolution
     */
    function updateResolution (insightResolution) {
      /**
       * Clean up the resolution object from Angular crap.
       * @type {{}}
       */
      var newResolution = lodash.pick(insightResolution || {}, ["id", "title", "fromResolutionSet"]);

      /**
       * Insight resolution without newResolution, to prevent adding the same value twice.
       * @type {Array}
       */
      var withoutNewResolution = lodash.reject($ctrl.insight.insightResolution, function (resolution) {
        return resolution.id === newResolution.id;
      });

      /**
       * Tell whether we should remove or add a new resolution.
       * @type {boolean}
       */
      var shallRemove = $ctrl.insight.insightResolution.length > withoutNewResolution.length;

      if (shallRemove) {
        $ctrl.insight.insightResolution = withoutNewResolution;
      } else {
        $ctrl.insight.insightResolution = lodash.concat(withoutNewResolution, newResolution);
      }

      /**
       * Create the largest set of resolutions, allowing duplicates (they will be taken care of later).
       * @type {Object|*}
       */
      var largestResolutionSet = lodash.mapValues($ctrl.possibleResolutions, function (listOfResolutions, key) {
        var expandedList = lodash.concat(listOfResolutions, $ctrl.insight.insightResolution);

        // Use "fromResolutionSet" to determine where the new resolution originally belongs.
        return newResolution.fromResolutionSet === key ? lodash.concat(expandedList, newResolution) : expandedList;
      });

      // Update the list of possible resolutions accordingly.
      setPossibleResolutions(largestResolutionSet);

      /**
       * @type {string}
       */
      var validationValue = $ctrl.insight.insightResolution.length ? VALIDATION.yes : VALIDATION.noAnswer;

      // Save validation and update the insight object.
      insightService.validateInsight($ctrl.insight, validationValue);
      insightService.updateInsightResolution($ctrl.insight);
    }

    /**
     * Tell whether the questionnaier has any resolutions
     * @return {boolean}
     */
    function hasResolutions () {
      return !!$ctrl.possibleResolutions.likely.length ||
        !!$ctrl.possibleResolutions.possible.length;
    }

    /**
     * Define a public interface of the component.
     * @type {{
     *  onHistoryClicked: toggleHistory,
     *  onPreviousCheckClicked: Function,
     *  onNextCheckClicked: Function,
     *  onSelectOption: questionAnswered,
     *  onResolutionSelected: updateResolution
     * }}
     */
    var intf = {
      onHistoryClicked: toggleHistory,
      onPreviousCheckClicked: moveInHistory(-1),
      onNextCheckClicked: moveInHistory(1),
      onSelectOption: questionAnswered,
      onResolutionSelected: updateResolution,
      getClassName: getClassName,
      hasResolutions: hasResolutions
    };

    lodash.forOwn(intf, function (value, key) {
      $ctrl[key] = value;
    });

    return $ctrl;
  }


}());


(function () {
  "use strict";

  /**
   * Stateless component to answer insight related questions.
   * @property {function} optionSelected - event handler to select an option
   * @property {number} value - 0|1|3 as "yes"|"no"|"maybe"
   * @property {string} variant - "compact" or unset
   */
  angular
    .module("ctraUIComponents.insight.insightChecks")
    .component("yesNoMaybe", {
      bindings: {
        optionSelected: "&",
        value: "<",
        variant: "<"
      },
      controller: yesNoMaybeController,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/insightChecks/" +
        "question/yesNoMaybe/yesNoMaybe.html"
    });

  /**
   * Tri-state button controller.
   * @param {Object} INSIGHT_CHECK_VALUES - ctraUIComponents.insight.insightChecks.INSIGHT_CHECK_VALUES
   * @ngInject
   */
  function yesNoMaybeController (INSIGHT_CHECK_VALUES) {
    var $ctrl = this;

    /**
     * Handler to call when the user clicks on an option.
     * As passing callbacks down to multiple components do not seem to work, we call the bound function manually.
     * @memberOf yesNoMaybeController
     * @param value
     */
    $ctrl.onSelectOption = function (value) {
      $ctrl.optionSelected({
        value: value
      });
    };

    /**
     * Possible values of the component based on the given constant.
     * @type {Object}
     * @memberOf yesNoMaybeController
     */
    $ctrl.possibleValues = INSIGHT_CHECK_VALUES;
  }

})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin', [
      'ngLodash',
      'ngAnimate',
      'ngCookies',
      'ngResource',
      'ngSanitize',
      'ngTouch',
      'ui.router',
      'ui.router.state.events', // TODO: move to transitions
      'toastr',
      'ODataResources',
      'angularMoment',
      'LocalStorageModule',
      'angular-loading-bar',
      'pascalprecht.translate',// angular-translate
      'tmh.dynamicLocale',// angular-dynamic-locale
      'ui.gravatar',
      'ctraAuthentication',
      'ctraDataVisualisations',
      'ctraUIComponents',
      'angularUtils.directives.dirPagination',
      'rzModule',
      'dairyMonitorAdmin.lifeCycle',
      'dairyMonitorAdmin.reports',
      'dairyMonitorAdmin.partner',
      'dairyMonitorAdmin.insights',
      'dairyMonitorAdmin.systemMonitorChart',
      'dairyMonitorAdmin.systemMonitorsMap',
      'dairyMonitorAdmin.sensorsSummary'
    ]);

})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services
  // TODO: replace $jQuery
  /* global $:false */
  /* eslint-disable angular/angularelement */

  angular
    .module('dairyMonitorAdmin')
    .directive('systemMonitorGrandChild', systemMonitorGrandChild);

  /** @ngInject */
  function systemMonitorGrandChild() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/main/systemMonitorsPanel/systemMonitorParent/systemMonitorChild/systemMonitorGrandChild/systemMonitorGrandChild.html',
      scope: {
        monitor: "=",
        expanded: "=?",
        successThreshold: "=",
        warningThreshold: "="
      },
      controller: systemMonitorGrandChildController,
      replace: true

      // controllerAs: 'vm',
      // bindToController: true
    };

    return directive;

    /** @ngInject */
    function systemMonitorGrandChildController($scope, $log, systemMonitorService, $timeout, $element){
      $scope.expanded = false;
      $scope.loading = true;

      systemMonitorService.getMonitoringStates($scope.monitor.referenceID).then(function(states){
        $scope.monitors = states;
        $log.warn('Removing crap between [] for the monitor names ');
        angular.forEach($scope.monitors, function (value) {
          if(value.monitorName.indexOf("[") > 0){
            value.monitorName = value.monitorName.substring(0, value.monitorName.indexOf("["));
          }
        });
        $scope.loading = false;
      });

      $scope.toggleMonitorDetails = function (){
        $scope.expanded = !$scope.expanded;
        $timeout(function(){ $($element).find('[data-toggle="tooltip"]').tooltip();}, 1);
      };
    }
  }

})();

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin").directive("newSensorForm", newSensorForm);

  /** @ngInject */
  function newSensorForm() {
    var directive = {
      restrict: "E",
      templateUrl: "app/views/accountManagement/farms/farm/hardwarePanel/newSensorForm/newSensorForm.html",
      controller: newSensorFormController,
      replace: true,
      scope: {
        farmId: "=",
        successCallback: "&"
      }
    };

    return directive;

    /** @ngInject */
    function newSensorFormController(
      $window,
      $rootScope,
      $scope,
      $log,
      $state,
      sysAdminService,
      sensorBatchService,
      sensorValidationService
    ) {
      var vm = $scope;

      vm.batchCreate = false;
      vm.farms = sysAdminService.getFarms({ select: ["FarmID", "farmName"] });

      vm.herdGroups = sysAdminService.getHerdGroups(vm.farmId, {
        select: ["HerdGroupID", "groupName", "farmID"]
      });

      vm.baseStations = sysAdminService.getBaseStations(vm.farmId, {
        select: ["BaseStationID", "deviceName", "farmID"]
      });

      vm.sensors = sysAdminService.getSensors(vm.farmId, { select: ["NodeID", "deviceSerialNum"] });
      vm.cows = [];
      vm.newSensorObj = {};
      vm.sensorsBatchOptions = sensorBatchService.sensorsBatchOptions;

      vm.batch = {
        pcb: "0",
        frequency: "0",
        casing: "0",
        manuallySealed: "0",
        charged: "0"
      };

      function resetUI() {
        vm.newSensorObj.deviceSerialNum = "";
      }

      vm.newSensor = function () {
        $rootScope.loading = true;

        vm.success = "";
        vm.error = "";
        vm.updateAllExistingSensors = false;
        vm.currentQueryIndex = 0;
        vm.queryStatus = "running";
        vm.newSensors = [];
        vm.cows = [];
        vm.newSensorQueries = [];
        // vm.newSensorObj.deviceInstallationDate = vm.deviceInstallationDate;
        vm.newSensorObj.deviceManufactureDate = vm.deviceManufactureDate;
        vm.newSensorObj.deviceDescription = angular.toJson(vm.batch);

        if (vm.batchCreate) {
          var serialNumbers = vm.deviceSerialNumbers.split("\n");

          for (var i = 0; i < serialNumbers.length; i++) {
            var value = serialNumbers[i];

            // Cleanup
            value = value.trim();

            if (value === "") {
              return;
            } else if (value.includes(",")) {
              var valueArr = value.split(",");

              var longSerialNum = valueArr[0];
              var shortSerialNum = valueArr[1];

              if (!sensorValidationService.validateLongSerialNum(longSerialNum)) {
                $rootScope.loading = false;
                $window.alert("Invalid Long Serial Number " + longSerialNum);
                return false;
              }

              if (!sensorValidationService.validateShortSerialNum(shortSerialNum)) {
                $rootScope.loading = false;
                $window.alert("Invalid Short Serial Number " + shortSerialNum);
                return false;
              }

              // Validate
              vm.newSensorObj.shortSerialNum = shortSerialNum;
              vm.newSensorObj.deviceSerialNum = longSerialNum;
              vm.newSensorObj.transmissionAddress = longSerialNum;
            } else {
              vm.newSensorObj.deviceSerialNum = value;
              vm.newSensorObj.transmissionAddress = value;
            }

            vm.newSensorQueries.push(sysAdminService.newSensor(vm.newSensorObj));
          }
        } else {
          if (!vm.newSensorObj.deviceSerialNum) {
            $rootScope.loading = false;
            $window.alert("Please fill in the long serial number");
            return false;
          }

          if (!vm.newSensorObj.shortSerialNum) {
            $rootScope.loading = false;
            $window.alert("Please fill in the short serial number");
            return false;
          }

          if (!sensorValidationService.validateLongSerialNum(vm.newSensorObj.deviceSerialNum)) {
            $rootScope.loading = false;
            $window.alert("Invalid Long Serial Number " + vm.newSensorObj.deviceSerialNum);
            return false;
          }

          if (!sensorValidationService.validateShortSerialNum(vm.newSensorObj.shortSerialNum)) {
            $rootScope.loading = false;
            $window.alert("Invalid Short Serial Number " + vm.newSensorObj.shortSerialNum);
            return false;
          }

          vm.newSensorObj.transmissionAddress = vm.newSensorObj.deviceSerialNum;
          vm.newSensorQueries.push(sysAdminService.newSensor(vm.newSensorObj));
        }

        createNextSensor();
      };

      function createNextSensor() {
        var sensorQuery;
        var updateExistingSensor;

        if (vm.queryStatus !== "running") {
          $rootScope.loading = false;
          return false;
        }

        if (!vm.newSensorQueries[vm.currentQueryIndex]) {
          vm.queryStatus = "completed";
          vm.success = vm.newSensors.length + " sensor(s) have been added/updated";
          resetUI();
          $rootScope.loading = false;
          return false;
        }

        var existingSensor = vm.sensors.find(function (e) {
          return e.deviceSerialNum === vm.newSensorQueries[vm.currentQueryIndex].deviceSerialNum;
        });

        updateExistingSensor = vm.updateAllExistingSensors;

        if (!updateExistingSensor && existingSensor) {
          updateExistingSensor = $window.confirm(
            "Sensor " +
              existingSensor.deviceSerialNum +
              " already exists, do you want me to update it with the new properties?"
          );
          if (!updateExistingSensor) {
            vm.currentQueryIndex++;
            $rootScope.loading = false;
            return false;
          } else if (vm.batchCreate) {
            vm.updateAllExistingSensors = $window.confirm("Also for all other duplicates in this batch?");
          }
        }

        if (updateExistingSensor && existingSensor) {
          vm.newSensorQueries[vm.currentQueryIndex].NodeID = existingSensor.NodeID;
          sensorQuery = vm.newSensorQueries[vm.currentQueryIndex].$update();
        } else {
          sensorQuery = vm.newSensorQueries[vm.currentQueryIndex].$save();
        }

        sensorQuery.then(
          function successCallback(sensor) {
            vm.newSensors.push(sensor);

            if (vm.createAndConnectToCows) {
              vm.newCowObj.nodeID = sensor.NodeID;
              vm.newCowObj.cowTagNumber = "0";
              vm.newCowObj.cowStatus = "unknown";
              sysAdminService
                .newCow(vm.newCowObj)
                .$save()
                .then(
                  function (cow) {
                    vm.cows.push(cow);
                    vm.currentQueryIndex++;
                    createNextSensor();
                  },
                  function errorCallback() {
                    vm.error = "Something went wrong creating a cow";
                    vm.queryStatus = "error";
                    $rootScope.loading = false;
                  }
                );
            } else {
              vm.currentQueryIndex++;
              createNextSensor();
            }
          },
          function errorCallback() {
            vm.error = "Something went wrong creating a sensor";
            vm.queryStatus = "error";
            $rootScope.loading = false;
          }
        );
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('newHerdGroupForm', newHerdGroupForm);

  /** @ngInject */
  function newHerdGroupForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/farms/farm/livestockPanel/newHerdGroupForm/newHerdGroupForm.html',
      controller: newHerdGroupFormController,
      replace: true,
      scope: {
        farmId: "=",
        successCallback: "&"
      }
    };

    return directive;

    /** @ngInject */
    function newHerdGroupFormController($rootScope, $scope, $log, $window, $state, sysAdminService) {
      var vm = $scope;

      vm.newHerdGroupObj        = {};
      vm.newHerdGroupObj.farmID = vm.farmId;

      vm.farms = sysAdminService.getFarms();

      vm.newHerdGroup = function(){
        $rootScope.loading = true;

        var herdGroup = sysAdminService.newHerdGroup(vm.newHerdGroupObj);

        herdGroup.$save().then(function(result){
          
          vm.newHerdGroupObj = {};
          vm.newHerdGroupObj.farmID = vm.farmId;

          vm.success = "Herd Group has been added";
          vm.successCallback({role: result});

          $rootScope.loading = false;
        }, function(){
          vm.error = "Something went wrong with creating a herd group...";

          // Something went wrong!
          $rootScope.loading = false;
        });
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('newBaseStationForm', newBaseStationForm);

  /** @ngInject */
  function newBaseStationForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/farms/farm/hardwarePanel/newBaseStationForm/newBaseStationForm.html',
      controller: newBaseStationFormController,
      replace: true,
      scope: {
        farmId: "=",
        successCallback: "&"
      }
    };

    return directive;

    /** @ngInject */
    function newBaseStationFormController($rootScope, $scope, $log, $window, $state, sysAdminService) {
      var vm = $scope;

      vm.newBaseStationObj        = {};
      vm.newBaseStationObj.farmID = vm.farmId;

      vm.farms = sysAdminService.getFarms();

      vm.newBaseStation = function(){
        $rootScope.loading = true;
        vm.success = "";
        vm.error   = "";

        vm.newBaseStationObj.deviceInstallationDate = vm.deviceInstallationDate;
        vm.newBaseStationObj.deviceManufactureDate  = vm.deviceManufactureDate;

        var baseStation = sysAdminService.newBaseStation(vm.newBaseStationObj);

        baseStation.$save().then(function(result){

          vm.newBaseStationObj = {};

          vm.success = "Base station has been added";
          vm.successCallback({baseStation: result});

          $rootScope.loading = false;
        }, function(){
          vm.error = "Something went wrong with creating a base station...";

          // Something went wrong!
          $rootScope.loading = false;
        });
      };

    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.sharing", [
      "ngLodash"
    ]);
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.sharing")
    .component("shareRibbon", {
      transclude: true,
      bindings: {

      },
      controller: ShareRibbonController,
      templateUrl: "app/shared-components/angular-ui-components/modules/sharing" +
        "/components/shareRibbon/shareRibbon.html"
    });

  /**
   * @ngInject
   * @param $interval
   * @param moment
   * @param dateTimeService
   * @param $controller
   * @param SharingService
   * @return {ShareRibbonController}
   * @constructor
   */
  function ShareRibbonController ($interval, moment, dateTimeService, $controller, SharingService) {
    /**
     * Inherit from sharing controller
     */
    $controller("SharingController", {
      vm: this
    });

    /**
     * @type {$interval|null}
     */
    this.tick = null;

    /**
     * @type {string|null}
     */
    this.date = null;

    /**
     * @type {string|null}
     */
    this.time = null;

    this.$onInit = function () {
      this.refreshDateTime();

      /**
       * Update the date and the time every minute
       */
      this.tick = $interval(
        this.refreshDateTime.bind(this),
        dateTimeService.MINUTE * 1000
      );
    };

    this.$onDestroy = function () {
      $interval.cancel(this.tick);
    };

    /**
     * Refresh the date and time
     */
    this.refreshDateTime = function() {
      this.date = moment().format("D MMM, YYYY");
      this.time = moment().format("HH:mm");
    };

    /**
     * Get translated screenshot time
     * @return {string}
     */
    this.getContent = function () {
      return SharingService.getTranslatedContent("ribbon", "screenshot-time", {
        date: this.date,
        time: this.time
      });
    };

    return this;
  }
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.sharing")
    .component("shareInsightButton", {
      bindings: {
        data: "<",
        target: "@",
        loading: "<"
      },
      controller: ShareInsightButtonController,
      templateUrl: "app/shared-components/angular-ui-components/modules/sharing" +
        "/components/shareInsightButton/shareInsightButton.html"
    });

  /**
   * @ngInject
   * @param $controller
   * @param lodash
   * @param SharingService
   * @param $window
   * @return {ShareInsightButtonController}
   * @constructor
   */
  function ShareInsightButtonController ($controller, lodash, SharingService, $window) {
    /**
     * Inherit from sharing controller
     */
    $controller("SharingController", {
      vm: this
    });

    /**
     * @type {boolean}
     * @private
     */
    var _open = false;

    /**
     * @type {boolean}
     */
    this.isMSIE = false;

    /**
     * Screenshot URL to show in the input field
     * @type {string|null}
     */
    this.screenshotURL = null;

    this.$onInit = function () {
      this.isMSIE = SharingService.isMSIE();
    };

    /**
     * Set open state
     * @param to
     */
    this.setOpen = function (to) {
      _open = !!to;
    };

    /**
     * Tell whether we are open
     * @return {boolean}
     */
    this.isOpen = function () {
      return _open;
    };

    /**
     * Tell whether we are loading
     * @return {boolean}
     */
    this.isLoading = function () {
      return this.isTakingScreenshot() || this.loading;
    };

    /**
     * Tell whether sharing is enabled
     * @return {boolean}
     */
    this.isDisabled = function (options) {
      var disabled = false;

      options = lodash.assign({
        alerts: false
      }, options || {});

      if (this.isMSIE) {
        if (options.alerts) {
          $window.alert(
            SharingService.getTranslatedContent("alert", "no-ie-supprt")
          );
        }

        disabled = true;
      } else if (this.loading) {
        if (options.alerts) {
          $window.alert(
            SharingService.getTranslatedContent("alert", "loading")
          );
        }

        disabled = true;
      }

      return disabled;
    };

    /**
     * Resolve the screenshot filename from the insight id and the current time
     * @todo think about moving it to the sharing controller
     * @return {string}
     */
    this.resolveFileName = function () {
      /**
       * @type {string}
       */
      var now = new Date().toISOString();

      var id = this.data.id ? this.data.id : "";

      /**
       * @type {string}
       */
      var date = lodash.first(now.split("."));
      var parts = lodash.compact([this.data.type, id, date]);
      var filename = parts.join("-");

      filename = filename.replace(/[\/\\:]/g, "_");

      return filename;
    };

    /**
     * Get sharing URL params from the given insight
     * @todo think about moving it to the sharing controller
     * @return {{utm_source: *}}
     */
    this.resolveURLParams = function () {
      return {
        utm_source: this.data.farmID,
        utm_type: this.data.type
      };
    };

    /**
     * Get a class name for the wrapper element
     * @return {string}
     */
    this.getWrapperClassName = function () {
      return lodash.compact([
        this.isOpen() ? "open" : "",
        this.isDisabled() ? "disabled" : ""
      ]).join(" ");
    };

    /**
     * Get text for sharing toggle
     * @return {string}
     */
    this.getToggleText = function () {
      return this.isOpen() ? SharingService.getTranslatedContent("toggle", "expanded") : "";
    };

    /**
     * Get translated label for the given medium
     * @param medium
     * @return {*}
     */
    this.getLabel = function (medium) {
      return SharingService.getTranslatedContent("label", lodash.toLower(medium));
    };

    /**
     * Take a screenshot and toggle the sharing menu (either the native or the custom one)
     */
    this.toggle = function () {
      if (!this.isDisabled({ alerts: true })) {
        if (this.isOpen()) {
          this.setOpen(false);
        } else {
          /**
           * We take a screenshot before opening the dropdown (or sharing via native).
           */
          this.takeScreenshot().then(function (screenshot) {
            /**
             * Update screenshot url
             */
            this.screenshotURL = SharingService.getShareURL(screenshot, this.resolveURLParams());

            if (SharingService.mayUseNativeShare()) {
              SharingService.shareViaNative(
                "Share insight image",
                screenshot,
                this.resolveURLParams());
            } else {
              this.setOpen(true);
            }
          }.bind(this));
        }
      }
    };

    /**
     * Handle clicking on share screenshot
     * @param {string} medium
     */
    this.onShareScreenshotClick = function (medium) {
      this.takeScreenshot().then(function (screenshot) {
        SharingService.shareScreenshot(screenshot, medium, this.resolveURLParams());
      }.bind(this));
    };

    return this;
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.notification", [
    "ngLodash"
  ]);
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.notification")
    .component("badge", {
      bindings: {
        color: "@",
        size: "@",
        value: "@"
      },
      controller: BadgeController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "notification/components/badge/badge.html"
    });

  /**
   * @ngInject
   * @return {BadgeController}
   * @constructor
   */
  function BadgeController () {

    this.getBadgeClassNames = function() {
      return [
        "bg-" + (this.color || "red-berry"),
        "navbar-badge-" + (this.size || "medium")
      ].join(" ");
    };

    return this;
  }
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.modal", [
      "ngLodash"
    ]);
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.modal").component("missingEstrusModal", {
    bindings: {
      insight: "<",
      options: "<"
    },
    controller: MissingEstrusModalController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "modal/components/missingEstrusModal/missingEstrusModal.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LocoService
   * @return {MissingEstrusModalController}
   */
  function MissingEstrusModalController($controller, LocoService) {
    $controller("ModalBaseController", {
      vm: this
    });

    /**
     * Get Modal heading
     * @return {*}
     */
    this.getHeading = function () {
      var valid = this.options.valid ? "valid" : "invalid";

      return LocoService.translate("missing-estrus-modal-heading", valid, {
        cowTagNumber: this.insight.dairyCow.cowTagNumber
      });
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.modal")
    .component("calvingModal", {
      bindings: {
        insight: "<"
      },
      controller: CalvingModalController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "modal/components/calvingModal/calvingModal.html"
    });

  /**
   * @ngInject
   * @param $controller

   * @return {CalvingModalController}
   */
  function CalvingModalController ($controller) {
    $controller("ModalBaseController", {
      vm: this
    });

    return this;
  }
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.modal")
    .component("genericModal", {
      bindings: {
        modalContentType: "@",
        modalVisible: "<",
        hideModal: "&",
        data: "<",
        options: "<"
      },
      controller: GenericModalController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" + "modal/components/base/genericModal.html"
    })
    .run(function ($templateCache) {
      /**
       * Every time you create a modal, make sure you put it in the template cache,
       * then resolve its ID via resolveFromContentType. This way the controller
       * will always create the right component instance for the incoming insights.
       * @todo extend this list
       */
      $templateCache.put("calving-modal", "<calving-modal insight='$ctrl.data'></calving-modal>");
      $templateCache.put(
        "missing-estrus-modal",
        "<missing-estrus-modal insight='$ctrl.data' options='$ctrl.options'></missing-estrus-modal>"
      );
    });

  /**
   * @ngInject
   * @param $controller
   * @param $document
   * @return {GenericModalController}
   * @constructor
   */
  function GenericModalController($controller, $document) {
    /**
     * Inherit from the loader controller
     */
    $controller("LoaderController", {
      vm: this
    });

    /**
     * Fetch insights on init
     */
    this.$onInit = function () {
      if (!this.modalContentType) {
        throw new Error(
          "You must pass a modal-content-type prop to this component. " +
            "It is important for picking the right subclass to load."
        );
      }
    };

    this.$onChanges = function (change) {
      if (change.hasOwnProperty("modalVisible")) {
        var scrollLength = $document.getElementsByClassName("transition-scroll")[0].scrollTop;
        $document.querySelector("#resolutionModal .modal-dialog").style.top = scrollLength + "px";
      }
    };

    /**
     * Resolve the modal to render from the content type attribute
     * @return {string}
     */
    this.resolveFromContentType = function () {
      return this.modalContentType;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.navigation", [
    "ngLodash"
  ]);
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.navigation").directive("mainNavItem", mainNavItemDirective);

  /**
   * @return {{transclude: boolean, scope: {count: string, to: string},
   * replace: boolean, restrict: string, controllerAs: string, templateUrl: string}}
   */
  function mainNavItemDirective() {
    return {
      transclude: true,
      restrict: "AE",
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "navigation/components/mainNavItem/mainNavItem.html",
      controllerAs: "$ctrl",
      replace: true,
      scope: {
        count: "<",
        to: "@",
        href: "@",
        toggles: "@",
        onClick: "<"
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightValidation", [
    "ngLodash",
    "ctraUIComponents.genericInsight.insightResolution"
  ]);
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .component("validationDescription", {
      transclude: true,
      bindings: {
        insight: "<",
        suffix: "@"
      },
      controller: InsightValidationDescriptionController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightValidation/components/validationDescription/validationDescription.html"
    });

  /**
   * @ngInject
   * @param ValidationService
   * @param LocoService
   * @return {InsightValidationDescriptionController}
   */
  function InsightValidationDescriptionController (ValidationService, LocoService) {
    /**
     * Get the question content via Loco
     * @returns {string}
     */
    this.getTranslatedContent = (function () {
      /**
       * @type {string}
       */
      var copy = ValidationService.getCopyKey(this.insight, "description", this.suffix);

      return LocoService.translate(copy, { insight: this.insight });
    }).bind(this);

    return this;
  }
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .component("validationQuestion", {
      transclude: true,
      bindings: {
        insight: "<",
        suffix: "@"
      },
      controller: insightValidationQuestionController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightValidation/components/validationQuestion/validationQuestion.html"
    });

  /**
   * @ngInject
   * @param ValidationService
   * @param LocoService
   * @return {insightValidationQuestionController}
   */
  function insightValidationQuestionController (ValidationService, LocoService) {
    /**
     * Get the question content via Loco
     * @returns {string}
     */
    this.getTranslatedQuestion = (function () {
      /**
       * @type {string}
       */
      var copy = ValidationService.getCopyKey(this.insight, "title", this.suffix);

      return LocoService.translate(copy, { insight: this.insight });
    }).bind(this);

    return this;
  }
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .directive("validationButton", validationButtonDirective);

  /**
   * @return {{controller: (function(*, *, *, *): ValidationButtonController),
   * scope: {onClick: string, variant: string, value: string}, replace: boolean,
   * restrict: string, controllerAs: string, templateUrl: string}}
   */
  function validationButtonDirective () {
    return {
      restrict: "AE",
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightValidation/components/validationButton/validationButton.html",
      controller: ValidationButtonController,
      controllerAs: "$ctrl",
      replace: true,
      scope: {
        active: "<",
        variant: "@" // "yes", "no", "maybe", "na"
      }
    };
  }

  /**
   * @ngInject
   * @param $scope
   * @param LocoService
   * @param lodash
   * @param VALIDATION_VALUES
   * @return {ValidationButtonController}
   * @constructor
   */
  function ValidationButtonController ($scope, LocoService, lodash, VALIDATION_VALUES) {
    /**
     * Smoke test
     * @return {boolean}
     */
    this.smokes = function () {
      return false;
    };

    /**
     * Get button class name
     * @return {string}
     */
    this.getClassName = function () {
      return [
        "validation-button-" + lodash.toLower(VALIDATION_VALUES[$scope.variant]),
         $scope.active ? "btn-default" : "btn-white"
      ].join(" ");
    };

    /**
     * Get button text
     * @return {string}
     */
    this.getContent = function () {
      return LocoService.translate("validation-value", lodash.toLower($scope.variant));
    };

    return this;
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightValidation").component("sensorOffCowValidation", {
    bindings: {
      insight: "<"
    },
    controller: SensorOffCowInsightValidationController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightValidation/components/sensorOffCow/sensorOffCowValidation.html"
  });

  /**
   * @ngInject
   * @param $log
   * @param $controller
   * @param lodash
   * @param GenericInsightService
   * @param toastr
   * @param $q
   * @param LocoService
   * @param ValidationService
   * @param sensorService
   * @param $state
   * @param insightResolutionService
   * @param cowService
   * @param $window
   * @param CachingService
   * @param INSIGHT_CATEGORIES
   * @return {SensorOffCowInsightValidationController}
   * @constructor
   */
  function SensorOffCowInsightValidationController(
    $log,
    $controller,
    lodash,
    GenericInsightService,
    toastr,
    $q,
    LocoService,
    ValidationService,
    sensorService,
    $state,
    insightResolutionService,
    cowService,
    $window,
    CachingService,
    INSIGHT_CATEGORIES
  ) {
    /**
     * Inherit from insight resolutions controller
     */
    $controller("InsightResolutionBaseController", {
      vm: this
    });

    /**
     * Inherit from the validations base controller
     */
    $controller("InsightValidationBaseController", {
      vm: this
    });

    /**
     * @type {string[]}
     */
    this.resoutionsState = [];

    /**
     * Fetch insight validations on init
     */
    this.$onInit = function () {
      /**
       * Set existing resolutions as resolution state
       */
      this.resoutionsState = lodash.map(this.insight.insightResolution, "id");

      this.fetchValidations();
    };

    /**
     * Get the dairy cow id
     * @return {number}
     */
    this.getCowId = function () {
      return lodash.get(this.insight, ["dairyCow", "DairyCowID"]);
    };

    /**
     * Get the node ID from the insight context
     * @return {number|undefined}
     */
    this.getNodeIdFromContext = function () {
      return GenericInsightService.getContext(this.insight).nodeID;
    }.bind(this);

    /**
     * Throw an error: the sensor has been already reused on another cow
     */
    this.throwAlreadyPaired = function () {
      $log.debug("[INSIGHT VALIDATION] The cow is already wearing another sensor.");

      toastr.error(
        LocoService.translate(ValidationService.getCopyKey(this.insight, "error", "already-paired"))
      );

      throw new Error("This cow is already wearing a different sensor. The user need to unpair it first.");
    };

    /**
     * Throw an error: the sensor is unpaired and there is no insight context.
     */
    this.throwUnpairedWithoutContext = function () {
      $log.debug("[INSIGHT VALIDATION] The insight context has NO information about the sensor.");

      toastr.error(
        LocoService.translate(ValidationService.getCopyKey(this.insight, "error", "already-unpaired"))
      );

      throw new Error("The sensor has already been unpaired. We cannot undo it without insight context.");
    };

    /**
     * Throw an error when the cow is already archived.
     */
    this.throwCowIsArchived = function () {
      $log.debug("[INSIGHT VALIDATION] The cow is already archived and cannot be automatically recovered.");

      toastr.error(
        LocoService.translate(ValidationService.getCopyKey(this.insight, "error", "already-archived"))
      );

      throw new Error("The cow is already archived. The user needs to recover it manually.");
    };

    /**
     * Pair the sensor again
     * @return {Promise<any>}
     */
    this.pairSensor = function () {
      /**
       * @type {number}
       */
      var nodeID = this.getNodeIdFromContext();

      if (nodeID) {
        /**
         * Dairy cow id to use to resolve the cow object
         * @type {number}
         */
        var dairyCowID = this.getCowId();

        return cowService.getCow(dairyCowID).then(
          function (cow) {
            sensorService.pairSensor(cow, nodeID).then(
              function () {
                lodash.set(this.insight, ["dairyCow", "nodeID"], null);
              }.bind(this)
            );
          }.bind(this)
        );
      } else {
        throw new Error("The insight context has no node ID, I cannot recover the sensor anymore");
      }
    };

    /**
     * Unpair the sensor fron the cow then update the insight
     * @return {Promise<any>}
     */
    this.unpairSensor = function () {
      /**
       * Sensor node id which may need to be re-paired
       * @type { number }
       */
      var nodeID = this.getNodeIdFromContext();

      /**
       * Warning message that there is no sensor info in the insight context.
       * @type {string}
       */
      var confirmUnpair = LocoService.translate("insight-validation-confirm-no-sensor-in-context");

      /**
       * @type {boolean}
       */
      var mayUnpair = !!nodeID || (!nodeID && $window.confirm(confirmUnpair));

      if (mayUnpair) {
        /**
         * Dairy cow id to use to resolve the cow object
         * @type {number}
         */
        var dairyCowID = this.getCowId();

        return cowService.getCow(dairyCowID).then(
          function (cow) {
            sensorService.unpairSensor(cow).then(
              function () {
                lodash.set(this.insight, ["dairyCow", "nodeID"], null);
              }.bind(this)
            );
          }.bind(this)
        );
      }
    };

    /**
     * Archive the cow
     * @return {Promise<any>}
     */
    this.updateCounterrchiveCow = function () {
      /**
       * @type {number}
       */
      var dairyCowID = this.getCowId();

      return cowService.getCow(dairyCowID).then(function (cow) {
        return cowService.deleteCow(cow);
      });
    };

    /**
     * Restore an archived cow
     * @return {Promise<any>}
     */
    this.restoreCow = function () {
      /**
       * @type {number}
       */
      var dairyCowID = this.getCowId();

      return cowService.getCow(dairyCowID).then(function (cow) {
        return cowService.restoreCow(cow);
      });
    };

    /**
     * Validate cow archive status before "cow_died" is removed
     * @param {{}[]} insightResolution
     */
    this.onBeforeRemoveResolution = function (insightResolution) {
      /**
       * Use the resolution ids as a state
       * @type {string[]}
       */
      var resolutionIds = lodash.map(insightResolution, "id");

      /**
       * Tell which resolutions has been adeed or removed
       * @type {{removed: string[], added: string[]}}
       */
      var diff = insightResolutionService.diff(this.resoutionsState, resolutionIds);

      if (diff.removed.includes("cow_died") && this.isCowArchived()) {
        this.throwCowIsArchived();
      }
    };

    /**
     * Depending on the resolution we need to either unpair or recover the sensor
     * @param {{}[]} insightResolution
     */
    this.runResolutionFlow = function (insightResolution) {
      /**
       * Before any updates, invalidate sensor alerts
       */
      CachingService.invalidate(INSIGHT_CATEGORIES.sensorAlert.join());

      /**
       * Use the resolution ids as a state
       * @type {string[]}
       */
      var resolutionIds = lodash.map(insightResolution, "id");

      /**
       * Tell which resolutions has been adeed or removed
       * @type {{removed: string[], added: string[]}}
       */
      var diff = insightResolutionService.diff(this.resoutionsState, resolutionIds);

      /**
       * Update resolution state
       * @type {string[]}
       */
      this.resoutionsState = resolutionIds;

      if (diff.added.includes("cow_died")) {
        this.chain(this.unpairSensor()).then(function () {
          $log.debug("[INSIGHT VALIDATION] The cow died. The sensor is now unpaired.");
        });
      } else if (diff.removed.includes("cow_died")) {
        this.chain(this.pairSensor()).then(function () {
          $log.debug("[INSIGHT VALIDATION] Oops, the cow is still alive. The sensor is now re-attached.");
        });
      } else if (diff.added.includes("sensor_fell_off")) {
        $log.debug("[INSIGHT VALIDATION] The sensor fell off the cow, no extra action needed.");
      }

      this.updateInsightResolution(insightResolution);
    };

    /**
     * Run the sensor recovery flow (aka. try to undo an unpairing) and set a new validation value
     * @param {string} newValidationValue
     * @param {{ toggles: boolean }} options?
     */
    this.runSensorRecoveryFlow = function (newValidationValue, options) {
      /**
       * Sensor node id which may need to be re-paired
       * @type {number}
       */
      var nodeID = this.getNodeIdFromContext();

      /**
       * Current sensor node id of the cow
       * @type {number|null}
       */
      var currentNodeID = lodash.get(this.insight, ["dairyCow", "nodeID"]);

      if (nodeID) {
        $log.debug("[INSIGHT VALIDATION] The insight context has information about the sensor.");

        if (currentNodeID && currentNodeID !== nodeID) {
          this.throwAlreadyPaired();
        } else {
          if (currentNodeID) {
            this.chain(this.validate(newValidationValue, options)).then(function () {
              $log.debug(
                "[INSIGHT VALIDATION] The old sensor was still paired, " +
                  "the insight is now validated as '" +
                  newValidationValue +
                  "'."
              );
            });
          } else {
            $log.debug(
              "[INSIGHT VALIDATION] The sensor mentioned in the insight is already unpaired. " +
                "It needs to be paired again."
            );

            this.chain(this.pairSensor(), this.validate(newValidationValue, options)).then(function () {
              $log.debug(
                "[INSIGHT VALIDATION] The sensor is now re-attached " +
                  "and the insight is validated as '" +
                  newValidationValue +
                  "'."
              );
            });
          }
        }
      } else if (currentNodeID) {
        this.chain(this.validate(newValidationValue, options)).then(function () {
          $log.debug(
            "[INSIGHT VALIDATION] The old sensor was still paired, " +
              "the insight is now validated as '" +
              newValidationValue +
              "'."
          );
        });
      } else {
        this.throwUnpairedWithoutContext();
      }
    };

    /**
     * Handle "no" validation flow
     */
    this.sensorOnCow = function () {
      /**
       * Before any updates, invalidate sensor alerts
       */
      CachingService.invalidate(INSIGHT_CATEGORIES.sensorAlert.join());

      /**
       * Tell whether the insight has already been validated the opposite way
       * @type {boolean}
       */
      var alreadyValidated = this.isValidated("yes");

      /**
       * Tell whether the user wants to revert a previous "no" validation
       * @type {boolean}
       */
      var wantsToRevert = this.isValidated("no");

      if (alreadyValidated) {
        $log.debug("[INSIGHT VALIDATION] The user changed their mind and wants change a 'yes' validation.");

        this.chain(this.removeResolutions(), this.runSensorRecoveryFlow("no"));
      } else if (wantsToRevert) {
        $log.debug("[INSIGHT VALIDATION] The user changed their mind and wants undo a 'no' validation.");

        if (this.isCowArchived()) {
          this.throwCowIsArchived();
        } else {
          this.chain(this.removeResolutions(), this.runSensorRecoveryFlow("noAnswer")).then(function () {
            $log.debug(
              "[INSIGHT VALIDATION] The resolutions are removed and " +
                "the insight is not validated anymore."
            );
          });
        }
      } else {
        this.chain(this.validate("no")).then(function () {
          $log.debug("[INSIGHT VALIDATION] The insight is now validated as 'no'.");
        });
      }
    };

    /**
     * Handle "yes" validation flow
     */
    this.sensorRemoved = function () {
      /**
       * Before any updates, invalidate sensor alerts
       */
      CachingService.invalidate(INSIGHT_CATEGORIES.sensorAlert.join());

      /**
       * Tell whether the insight has already been validated the opposite way
       * @type {boolean}
       */
      var alreadyValidated = this.isValidated("no");

      /**
       * Tell whether the user wants to revert a previous "yes" validation
       * @type {boolean}
       */
      var wantsToRevert = this.isValidated("yes");

      if (alreadyValidated) {
        $log.debug("[INSIGHT VALIDATION] The user changed their mind and wants change a 'no' validation.");

        if (this.isCowArchived()) {
          this.throwCowIsArchived();
        } else {
          this.chain(this.resolve("sensor_was_removed"), this.unpairSensor(), this.validate("yes")).then(
            function () {
              $log.debug(
                "[INSIGHT VALIDATION] The resolutions are removed, the sensor is unpaired " +
                  "and the insight is now validated as 'yes'."
              );
            }
          );
        }
      } else if (wantsToRevert) {
        $log.debug("[INSIGHT VALIDATION] The user changed their mind and want to undo a 'yes' validation.");

        this.chain(this.removeResolutions(), this.runSensorRecoveryFlow("noAnswer"));
      } else {
        this.chain([this.unpairSensor(), this.validate("yes"), this.resolve("sensor_was_removed")]).then(
          function () {
            $log.debug(
              "[INSIGHT VALIDATION] The sensor is removed and the insight is now alidated as 'yes'."
            );
          }
        );
      }
    };

    /**
     * Tell whether the cow has sensor
     */
    this.hasSensor = function () {
      return !!this.insight.dairyCow.nodeID;
    };

    /**
     * Handle the maunal unpair action
     */
    this.handleUnpairClicked = function () {
      this.chain(this.unpairSensor()).then(
        function () {
          /**
           * @type {string}
           */
          var toastrMessage = LocoService.translate("unpair-sensor-completed");

          toastr.success(toastrMessage);
        },
        function () {
          /**
           * @type {string}
           */
          var toastrMessage = LocoService.translate("unpair-sensor-failed");

          toastr.error(toastrMessage);
        }
      );
    };

    /**
     * Navigate to the sensor pairing page
     */
    this.handlePairToOtherClicked = function () {
      $state.go("settings.hardware.sensorPairing", {
        cowID: this.getCowId()
      });
    };

    /**
     * Handle click on the "archive cow" button
     */
    this.handleArchiveCowClicked = function () {
      this.updateCounterrchiveCow().then(
        function () {
          /**
           * @type {string}
           */
          var toastrMessage = LocoService.translate("archive-cow-completed");

          /**
           * Set cow as deleted
           * @type {boolean}
           */
          this.insight.dairyCow.isDeleted = true;

          toastr.success(toastrMessage);
        }.bind(this),
        function () {
          /**
           * @type {string}
           */
          var toastrMessage = LocoService.translate("archive-cow-failed");

          toastr.error(toastrMessage);
        }
      );
    };

    /**
     * Handle click on the "archive cow" button
     */
    this.handleRestoreCowClicked = function () {
      this.restoreCow().then(
        function () {
          /**
           * @type {string}
           */
          var toastrMessage = LocoService.translate("restore-cow-completed");

          /**
           * Set cow as deleted
           * @type {boolean}
           */
          this.insight.dairyCow.isDeleted = false;

          toastr.success(toastrMessage);
        }.bind(this),
        function () {
          /**
           * @type {string}
           */
          var toastrMessage = LocoService.translate("restore-cow-failed");

          toastr.error(toastrMessage);
        }
      );
    };

    /**
     * Tell whether the cow is deleted
     * @return {boolean}
     */
    this.isCowArchived = function () {
      return !!this.insight.dairyCow.isDeleted;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightValidation").component("sensorIsOfflineValidation", {
    bindings: {
      insight: "<"
    },
    controller: SensorIsOfflineValidationController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightValidation/components/sensorIsOffline/sensorIsOffline.html"
  });

  /**
   * @ngInject
   * @param $log
   * @param $controller
   * @param lodash
   * @param CachingService
   * @param INSIGHT_CATEGORIES
   * @param $state
   * @return {SensorIsOfflineValidationController}
   * @constructor
   */
  function SensorIsOfflineValidationController(
    $log,
    $controller,
    lodash,
    CachingService,
    INSIGHT_CATEGORIES,
    $state
  ) {
    /**
     * Inherit from insight resolutions controller
     */
    $controller("InsightResolutionBaseController", {
      vm: this
    });

    /**
     * Inherit from the validations base controller
     */
    $controller("InsightValidationBaseController", {
      vm: this
    });

    /**
     * Initialize
     */
    this.$onInit = function () {
      this.fetchValidations();
    };

    /**
     * Handle "yes" validation flow
     */
    this.sensorOutOfRange = function () {
      /**
       * Before any updates, invalidate sensor alerts
       */
      CachingService.invalidate(INSIGHT_CATEGORIES.sensorAlert.join());

      /**
       * Tell whether the insight has already been validated the opposite way
       * @type {boolean}
       */
      var alreadyValidated = this.isValidated("no");

      /**
       * Tell whether the user wants to revert a previous "yes" validation
       * @type {boolean}
       */
      var wantsToRevert = this.isValidated("yes");

      if (alreadyValidated) {
        $log.debug("[INSIGHT VALIDATION] The user changed their mind and wants change a 'no' validation.");
        this.chain(this.resolve("out_of_range", { overwrite: true }), this.validate("yes")).then(
          function () {
            $log.debug(
              "[INSIGHT VALIDATION] The resolutions are removed, the sensor is unpaired " +
                "and the insight is now validated as 'yes'."
            );
          }
        );
      } else if (wantsToRevert) {
        $log.debug("[INSIGHT VALIDATION] The user changed their mind and want to undo a 'yes' validation.");

        this.removeResolutions();
        this.validate("noAnswer");
      } else {
        this.chain([this.validate("yes"), this.resolve("out_of_range")]);
      }
    };

    /**
     * Handle "no" validation flow
     */
    this.replaceSensor = function () {
      /**
       * Before any updates, invalidate sensor alerts
       */
      CachingService.invalidate(INSIGHT_CATEGORIES.sensorAlert.join());

      /**
       * Tell whether the insight has already been validated the opposite way
       * @type {boolean}
       */
      var alreadyValidated = this.isValidated("yes");

      /**
       * Tell whether the user wants to revert a previous "no" validation
       * @type {boolean}
       */
      var wantsToRevert = this.isValidated("no");

      if (alreadyValidated) {
        $log.debug("[INSIGHT VALIDATION] The user changed their mind and wants change a 'yes' validation.");

        this.chain(this.resolve("replace_sensor", { overwrite: true }), this.validate("no"));
      } else if (wantsToRevert) {
        $log.debug("[INSIGHT VALIDATION] The user changed their mind and wants undo a 'no' validation.");
        this.removeResolutions();
        this.validate("noAnswer");
      } else {
        this.chain([this.validate("no"), this.resolve("replace_sensor")]);
      }
    };

    /**
     * Redirect the user to sensor pairing page
     */
    this.redirectToSensorPairingPage = function () {
      $state.go("settings.hardware.sensorPairing", { cowID: this.insight.dairyCowID });
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightValidation").component("sensorIsNotTurnedOn", {
    bindings: {
      insight: "<"
    },
    controller: SensorIsNotTurnedOnController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightValidation/components/sensorIsNotTurnedOn/sensorIsNotTurnedOn.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param GenericInsightService
   * @param $state
   * @return {SensorIsNotTurnedOnController}
   * @constructor
   */
  function SensorIsNotTurnedOnController($controller, GenericInsightService, $state) {
    /**
     * Inherit from insight resolutions controller
     */
    $controller("InsightResolutionBaseController", {
      vm: this
    });

    /**
     * Inherit from the validations base controller
     */
    $controller("InsightValidationBaseController", {
      vm: this
    });

    /**
     * check whether an insight is resolved or not
     */
    this.isResolvedInsight = GenericInsightService.isResolved;

    /**
     * Add turn on sensor resolution to the insight
     */
    this.turnOnSensor = function() {
      this.resolve("connecting");
    };

    /**
     * Redirect the user to sensor pairing page
     */
    this.redirectToSensorPairingPage = function () {
      $state.go("settings.hardware.sensorPairing", { cowID: this.insight.dairyCowID });
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .component("pairSensorWidget", {
      bindings: {
        nodeId: "<"
      },
      controller: PairSensorWidgetController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightValidation/components/pairSensorWidget/pairSensorWidget.html"
    });

  /**
   * @ngInject
   * @param LocoService
   * @param sensorService
   * @param $state
   * @return {PairSensorWidgetController}
   */
  function PairSensorWidgetController (LocoService, sensorService, $state) {
    /**
     * Sensor
     * @type {{ shortSerialNum: string }}
     */
    this.sensor = {};

    this.$onInit = function () {
      this.fetchSensor();
    };

    /**
     * Fetch sensor
     */
    this.fetchSensor = function () {
      sensorService.getSensor(this.nodeId).then((function (sensor) {
        this.sensor = sensor;
      }).bind(this));
    };

    /**
     * Get the content via Loco
     * @param {string} type
     * @returns {string}
     */
    this.getContent = function (type) {
      return LocoService.translate("pair-sensor-widget", type);
    };

    /**
     * Get short serial number
     * @return {string}
     */
    this.getShortSerialNumber = function () {
      return this.sensor.shortSerialNum || "...";
    };

    /**
     * Handle clicking on the pair sensor button
     */
    this.handlePairSensorClicked = function () {
      $state.go("settings.hardware.sensorPairing", {
        nodeID: this.nodeId
      });
    };

    return this;
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightValidation").component("noSensorOnCowValidation", {
    bindings: {
      insight: "<"
    },
    controller: NoSensorOnCowValidationController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightValidation/components/noSensorOnCow/noSensorOnCow.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param lodash
   * @param $state
   * @param LocoService
   * @param cowService
   * @param toastr
   * @return {NoSensorOnCowValidationController}
   * @constructor
   */
  function NoSensorOnCowValidationController($controller, lodash, $state, LocoService, cowService, toastr) {
    /**
     * Inherit from insight resolutions controller
     */
    $controller("InsightResolutionBaseController", {
      vm: this
    });

    /**
     * Inherit from the validations base controller
     */
    $controller("InsightValidationBaseController", {
      vm: this
    });

    /**
     * Redirect the user to sensor pairing page
     */
    this.redirectToSensorPairingPage = function () {
      $state.go("settings.hardware.sensorPairing", { cowID: this.insight.dairyCowID });
    };

    /**
     * Handle click on the "archive cow" button
     */
    this.handleArchiveCowClicked = function () {
      this.resolve("cow_died", {
        overwrite: true
      });

      /**
       * Get cow details and then pass it to delete cow function to delete the
       * cow
       */
      cowService.getCow(this.insight.dairyCowID).then(function (cow) {
        cowService.deleteCow(cow).then(function () {
            /**
             * @type {string}
             */
            var toastrMessage = LocoService.translate("archive-cow-completed");

            /**
             * Set cow as deleted
             * @type {boolean}
             */
            this.insight.dairyCow.isDeleted = true;

            toastr.success(toastrMessage);
          }.bind(this),
          function () {
            /**
             * @type {string}
             */
            var toastrMessage = LocoService.translate("archive-cow-failed");

            toastr.error(toastrMessage);
          });
      }.bind(this));
    };

    /**
     * dismiss an insight
     */
    this.handleDismissInsight = function () {
      this.resolve("dismiss", {
        overwrite: true
      });
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightValidation").component("missingEstrusValidation", {
    bindings: {
      insight: "<"
    },
    controller: MissingEstrusInsightValidationController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightValidation/components/missingEstrus/missingEstrusValidation.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param lodash
   * @return {MissingEstrusInsightValidationController}
   */
  function MissingEstrusInsightValidationController($controller, lodash) {
    /**
     * Instantiate base controller.
     */
    $controller("ValidationController", {
      vm: this
    });

    $controller("MissingEstrusController", {
      vm: this
    });

    /**
     * @type {boolean}
     */
    this.isValidated = false;

    this.$onInit = function () {
      this.isValidated = this.isValid() || this.isInvalid();
    };

    this.$onChanges = function () {
      this.isValidated = this.isValid() || this.isInvalid();
    };

    /**
     * Handle yes validation
     */
    this.handleYesValidation = function () {
      /**
       * if the user clicks on the yes and no button the insightValid key still has the old value
       * due to which we had to not the result to check if the we are removing the validation or are
       * we validating the insight
       * @type {boolean}
       */
      if (this.insight.insightValid === "Yes") {
        this.isValidated = false;
      } else {
        this.isValidated = true;
      }

      this.updateInsight(this.insight, {
        valid: true
      });
    };

    /**
     * handle no validation
     */
    this.handleNoValidation = function () {
      /**
       * if the user clicks on the yes and no button the insightValid key still has the old value
       * due to which we had to not the result to check if the we are removing the validation or are
       * we validating the insight
       * @type {boolean}
       */
      if (this.insight.insightValid === "No") {
        this.isValidated = false;
      } else {
        this.isValidated = true;
      }

      this.updateInsight(this.insight, {
        valid: false
      });
    };

    /**
     * Get options for missing estrus resolution component
     */
    this.getOptions = lodash.memoize(function () {
      var isInsightValid = false;

      if (this.isValid()) {
        isInsightValid = true;
      }

      return { valid: isInsightValid };
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightValidation").component("fmsValidation", {
    bindings: {
      insight: "<"
    },
    controller: FMSValidationController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightValidation/components/fmsValidation/fmsValidation.html"
  });

  /**
   * @ngInject
   * @param GenericInsightService
   * @param LocoService
   * @param lodash
   * @return {FMSValidationController}
   * @constructor
   */
  function FMSValidationController(GenericInsightService, LocoService, lodash) {
    /**
     * Get translated title
     * @return {string}
     */
    this.getTitle = function () {
      var fms = GenericInsightService.resolveFMSFromValidation(this.insight);

      return LocoService.translate("fms-validation-title", {
        fms: fms
      });
    };

    /**
     * Get translated description
     * @return {string}
     */
    this.getDescription = function () {
      var fms = GenericInsightService.resolveFMSFromValidation(this.insight);
      var category = GenericInsightService.getCategory(this.insight);
      var typeName = GenericInsightService.getTypeName(this.insight);
      var key = ["fms-validation-description", category].join("-");
      var resolutions = GenericInsightService.getResolutions(this.insight);
      var dysonResolutions = lodash.filter(resolutions, ["source", "dyson"]);
      var humanReadable = lodash.map(dysonResolutions, "title").join(", ");

      return LocoService.translate(key, {
        fms: fms,
        typeName: typeName,
        valid: GenericInsightService.isValid(this.insight) || null,
        resolutions: dysonResolutions.length ? humanReadable : null
      });
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .component("insightValidationFactory", {
      bindings: {
        insight: "<"
      },
      controller: insightValidationFactoryController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightValidation/components/factory/insightValidationFactory.html"
    })
    .run(function ($templateCache) {
      /**
       * @todo extend this list with new insight types and validation flows
       */
      $templateCache.put(
        "SensorIsNotOnCow",
        "<sensor-off-cow-validation insight='$ctrl.insight'></sensor-off-cow-validation>"
      );
      $templateCache.put(
        "CowHasCalved",
        "<calving-insight-validation insight='$ctrl.insight'></calving-insight-validation>"
      );
      $templateCache.put(
        "SensorIsOffline",
        "<sensor-is-offline-validation insight='$ctrl.insight'></sensor-is-offline-validation>"
      );
      $templateCache.put(
        "SensorIsNotTurnedOn",
        "<sensor-is-not-turned-on insight='$ctrl.insight'></sensor-is-not-turned-on>"
      );
      $templateCache.put(
        "CowDoesNotHaveSensor",
        "<no-sensor-on-cow-validation insight='$ctrl.insight'></no-sensor-on-cow-validation>"
      );
      $templateCache.put(
        "WFMissingEstrus",
        "<missing-estrus-validation insight='$ctrl.insight'></missing-estrus-validation>"
      );
      $templateCache.put(
        "WFMissingEstrusPostCalving",
        "<missing-estrus-validation insight='$ctrl.insight'></missing-estrus-validation>"
      );
      $templateCache.put(
        "BaseStationIsOffline",
        "<base-station-is-offline-validation insight='$ctrl.insight'></base-station-is-offline-validation>"
      );
      $templateCache.put("fms-validation", "<fms-validation insight='$ctrl.insight'></fms-validation>");
    });

  /**
   * @ngInject
   * @param $controller
   * @param GenericInsightService
   * @return {insightValidationFactoryController}
   */
  function insightValidationFactoryController($controller, GenericInsightService) {
    /**
     * Resolve sub-component from insight type
     * @param insight
     * @return {string}
     */
    this.resolve = function (insight) {
      var byDyson = !!GenericInsightService.resolveFMSFromValidation(insight);

      return byDyson ? "fms-validation" : GenericInsightService.getTypeName(insight);
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightValidation").component("calvingInsightValidation", {
    bindings: {
      insight: "<"
    },
    controller: CalvingInsightValidationController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightValidation/components/calvingInsightValidation/calvingInsightValidation.html"
  });

  /**
   * @ngInject
   * @param LocoService
   * @param calvingService
   * @return {CalvingInsightValidationController}
   */
  function CalvingInsightValidationController(LocoService, calvingService) {
    /**
     * Update insight validation
     * @param insightValid
     */
    this.updateInsightValidation = function (insightValid) {
      this.insight.insightValid = insightValid;
    };

    /**
     * Get translated content
     * @param {string} variant
     * @param {string} [suffix]
     * @param {{}} [context]
     */
    this.getTranslatedContent = function (variant, suffix, context) {
      return LocoService.translate("calving-insight-validation", variant, suffix, context || {});
    };

    /**
     * Callback when the validation is updated.
     * We hook up deleting the calving labels here is the user hits "not calved".
     */
    this.onUpdateValidation = function () {
      var label = calvingService.getCalvingLabel(this.insight);

      if (label && this.insight.calved !== true) {
        calvingService.removeCalvingLabel(this.insight);
      }
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .component("baseStationIsOfflineValidation", {
      bindings: {
        insight: "<"
      },
      controller: BaseStationIsOfflineValidationController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightValidation/components/baseStationIsOffline/baseStationIsOffline.html"
    });

  /**
   * @ngInject
   * @param $controller
   * @param LocoService
   * @param $window
   * @return {BaseStationIsOfflineValidationController}
   * @constructor
   */
  function BaseStationIsOfflineValidationController(LocoService, $controller, $window) {
    /**
     * Inherit from insight resolutions controller
     */
    $controller("InsightResolutionBaseController", {
      vm: this
    });

    /**
     * Inherit from the validations base controller
     */
    $controller("InsightValidationBaseController", {
      vm: this
    });

    this.$onInit = function () {
      this.fetchValidations();
    };

    this.showIntercom = function () {
      $window.Intercom("showNewMessage");
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .component("actionButton", {
      transclude: true,
      bindings: {
        suffix: "@",
        variant: "@",
        disabled: "<"
      },
      controller: ActionButtonController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightValidation/components/actionButton/actionButton.html"
    });

  /**
   * @ngInject
   * @param LocoService
   * @return {ActionButtonController}
   */
  function ActionButtonController (LocoService) {
    /**
     * Get the question content via Loco
     * @returns {string}
     */
    this.getTranslatedContent = (function () {
      return LocoService.translate("insight-validation-action", this.suffix);
    }).bind(this);

    /**
     * Get class name for the button
     * @return {string}
     */
    this.getClassName = function () {
      var classes = [];

      classes.push("variant-" + this.variant);

      /**
       * if the button is disabled then add the disabled class too
       */
      if (this.disabled) {
        classes.push("disabled");
      }
      return classes.join(" ");
    }.bind(this);

    return this;
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightResolution", [
    "ngLodash"
  ]);
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightResolution")
    .component("missingEstrusInsightResolution", {
      bindings: {
        insight: "<",
        options: "<"
      },
      controller: MissingEstrusInsightResolutionController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightResolution/components/missingEstrusInsightResolution/missingEstrusInsightResolution.html"
    });

  /**
   * @ngInject
   * @param $controller
   * @param doNotBreedService
   * @param insightService
   * @param lodash
   * @param insightResolutionService
   * @return {MissingEstrusInsightResolutionController}
   */
  function MissingEstrusInsightResolutionController($controller, doNotBreedService, insightService, lodash, insightResolutionService) {
    /**
     * Inherit from insight resolutions controller
     */
    $controller("InsightResolutionBaseController", {
      vm: this
    });

    /**
     * Update insight resolution
     * @param insightResolution
     */
    this.updateInsightResolution = function (insightResolution) {
      this.insight.insightResolution = insightResolution;
      insightService.updateInsightResolution(this.insight, false);

      /**
       * Tell whether the DNB is applied
       */
      var dnbValue = doNotBreedService.resolvedAsDNB(this.insight);

      doNotBreedService.setDNB(this.insight.dairyCowID, dnbValue);
    };

    /**
     * Tell whether to show of hide the resolution extension
     * @todo if eg. "cow is healthy" is among the resolutions, we need to show this widget
     * @return {boolean}
     */
    this.mayShowMissingEstrusResolutionExtension = function () {
      /**
       * Prefill the usual to make the function call shorter
       */
      var checkResolution = lodash.partial(
        insightResolutionService.inResolutionList,
        this.insight.insightResolution
      );

      return (
        !!this.insight &&
        !this.options.valid &&
        (checkResolution({ id: "cow_is_healthy" }) || checkResolution({ id: "already_inseminated" }))
      );
    };

    /**
     * Depending on the insight resolution tell which extension to display.
     * @return {string}
     */
    this.getMissingEstrusResolutionExtension = function () {
      /**
       * Prefill the usual to make the function call shorter
       */
      var checkResolution = lodash.partial(
        insightResolutionService.inResolutionList,
        this.insight.insightResolution
      );

      if (checkResolution({ id: "cow_is_healthy" })) {
        return "last-estrus-picker";
      } else if (checkResolution({ id: "already_inseminated" })) {
        return "last-breeding-picker";
      } else {
        return "last-estrus-picker"; // let's say this is the default one
      }
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightResolution").component("calvingInsightResolution", {
    bindings: {
      insight: "<"
    },
    controller: CalvingInsightResolutionController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightResolution/components/calvingInsightResolution/calvingInsightResolution.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param doNotBreedService
   * @param moment
   * @param LocoService
   * @param cowService
   * @param lodash
   * @param insightResolutionService
   * @param dateTimeService
   * @param labelService
   * @param toastr
   * @param GenericInsightService
   * @param calvingService
   * @return {CalvingInsightResolutionController}
   */
  function CalvingInsightResolutionController(
    $controller,
    doNotBreedService,
    moment,
    LocoService,
    cowService,
    lodash,
    insightResolutionService,
    dateTimeService,
    labelService,
    toastr,
    GenericInsightService,
    calvingService
  ) {
    /**
     * Inherit from insight resolutions controller
     */
    $controller("InsightResolutionBaseController", {
      vm: this
    });

    $controller("CalvingBaseController", {
      vm: this
    });

    /**
     * callback to be triggered when date time changes
     * @param dateTime
     */
    this.onDateTimeChange = function (dateTime) {
      var dfd;

      if (dateTime) {
        /**
         * Make an epoch from the time picker values
         */
        dateTime = moment(dateTime.date + " " + dateTime.time).unix();

        if (this.getDatepickerValue() !== dateTime) {
          var dairyCowId = this.insight.dairyCow.DairyCowID;
          var label = calvingService.getCalvingLabel(this.insight);

          if (label) {
            dfd = labelService.getLabel(label.GenericLabelID).then(function (labelEntity) {
              /**
               * Update the label entity
               */
              labelEntity.startEpoch = dateTime;
              labelEntity.endEpoch = dateTime;

              /**
               * Update the label reference in the insight
               */
              label.startEpoch = dateTime;
              label.endEpoch = dateTime;

              return labelService.updateLabel(labelEntity);
            });
          } else {
            dfd = calvingService
              .createLabel({
                startEpoch: dateTime,
                endEpoch: dateTime,
                dairyCowID: dairyCowId,
                genericInsightID: this.insight.GenericInsightID
              })
              .then(
                function (label) {
                  this.insight.genericLabels.push(label);
                }.bind(this)
              );
          }

          dfd.then(
            function () {
              this.removeResolutionByID("i_dont_know");
            }.bind(this)
          );
        } else {
          this.removeResolutionByID("i_dont_know");
        }
      } else {
        GenericInsightService.updateResolution(this.insight, ["i_dont_know"]);
      }
    };

    /**
     * Get translated content
     * @param {string} variant
     * @param {string} [suffix]
     * @param {{}} [context]
     */
    this.getTranslatedContent = function (variant, suffix, context) {
      return LocoService.translate("calving-insight-resolution", variant, suffix, context || {});
    };

    /**
     * check if the date time picker is enabled or diabled
     * @returns {boolean}
     */
    this.isDateTimePickerDisabled = function () {
      return (
        !!this.insight &&
        !!lodash.find(this.insight.insightResolution, function (resolution) {
          return resolution.id === "i_dont_know";
        })
      );
    };

    /**
     * Get the last calving epoch value from the label (startEpoch or endEpoch) or the cow object
     * @return {number}
     */
    this.getDatepickerValue = function () {
      var label = calvingService.getCalvingLabel(this.insight);

      return label ? label.startEpoch : this.insight.startEpoch;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightHeadlineResolution", [
      "ngLodash"
    ]);
}());

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightHeadlineResolution")
    .component("missingEstrusHeadlineResolution", {
      bindings: {
        insight: "<"
      },
      controller: MissingEstrusHeadlineController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightHeadlineResolution/components/missingEstrusHeadlineResolution/missingEstrusHeadlineResolution.html"
    });

  /**
   * @ngInject
   * @param GenericInsightService
   * @return {MissingEstrusHeadlineController}
   */
  function MissingEstrusHeadlineController(GenericInsightService) {
    this.activeInsight = null;

    /**
     * check if an insight is resolved or not
     */
    this.isResolved = GenericInsightService.isResolved;

    this.$onInit = function () {
      this.activeInsight = this.insight;
      /**
       * check if we have the meta data
       */
      if (this.insight.insightMetadata) {
        var parentInsightId = angular.fromJson(this.insight.insightMetadata).parentInsightID;

        /**
         * check if we have the parent insight id
         */
        if (parentInsightId) {
          this.activeInsight = null;
          GenericInsightService.fetchSingleInsight(parseFloat(parentInsightId)).then(
            function (insight) {
              this.activeInsight = insight;
            }.bind(this)
          );
        }
      }
    };

    this.getOptions = function () {
      return { filterAllHiddenResolutions: true };
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightHeadlineResolution")
    .component("insightHeadlineResolutionFactory", {
      bindings: {
        insight: "<"
      },
      controller: InsightHeadlineResolutionFactoryController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightHeadlineResolution/components/factory/insightHeadlineResolutionFactory.html"
    })
    .run(function ($templateCache) {
      $templateCache.put(
        "generic-insight-headline-resolution",
        "<generic-insightt-headline-resolution insight='$ctrl.insight'></generic-insightt-headline-resolution>"
      );
      $templateCache.put(
        "missing-estrus-headline-resolution",
        "<missing-estrus-headline-resolution insight='$ctrl.insight'></missing-estrus-headline-resolution>"
      );
    });

  /**
   * @ngInject
   * @param GenericInsightService
   * @return {InsightHeadlineResolutionFactoryController}
   */
  function InsightHeadlineResolutionFactoryController(GenericInsightService) {
    /**
     * Resolve sub-component from insight type
     * @return {string}
     */
    this.resolve = function () {
      var typeName = GenericInsightService.getTypeName(this.insight);

      /**
       * Insight types which fall into the new category
       * @todo extend this list as soon as new insights are added
       * @type {string[]}
       */
      switch (typeName) {
        case "SensorIsNotOnCow":
        case "SensorIsOffline":
        case "SensorIsNotTurnedOn":
        case "CowDoesNotHaveSensor":
        case "HerdInsight":
        case "CowHasCalved":
          return "generic-insight-headline-resolution";
        case "WFMissingEstrus":
        case "WFMissingEstrusPostCalving":
          return "missing-estrus-headline-resolution";
      }
    }.bind(this);

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightHeadlineResolution")
    .component("genericInsighttHeadlineResolution", {
      bindings: {
        insight: "<"
      },
      controller: GenericInsightHeadlineResolution,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightHeadlineResolution/components/genericInsightHeadlineResolution/genericInsightHeadlineResolution.html"
    });

  /**
   * @ngInject
   * @param GenericInsightService
   * @return {GenericInsightHeadlineResolution}
   */
  function GenericInsightHeadlineResolution(GenericInsightService) {
    /**
     * check if an insight is resolved or not
     */
    this.isResolved = GenericInsightService.isResolved;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightHeadlineResolution")
    .component("fmsResolutionTitle", {
      bindings: {
        insight: "<"
      },
      controller: FMSResolutionTitleController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightHeadlineResolution/components/fmsResolutionTitle/fmsResolutionTitle.html"
    });

  /**
   * @ngInject
   * @param lodash
   * @param GenericInsightService
   * @returns {FMSResolutionTitleController}
   * @constructor
   */
  function FMSResolutionTitleController(lodash, GenericInsightService) {
    /**
     * Get dyson resolution
     * @return {string}
     */
    this.getResolutions = function () {
      var resolutions = GenericInsightService.getResolutions(this.insight);
      var dysonResolutions = lodash.filter(resolutions, ["source", "dyson"]);

      return lodash.map(dysonResolutions, "title").join(", ");
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insightList")
    .component("listStatus", {
      transclude: true,
      bindings: {
        variant: "@"
      },
      controller: ListStatusController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightList/components/listStatus/listStatus.html"
    });

  /**
   * @ngInject
   * @return {ListStatusController}
   */
  function ListStatusController () {
    /**
     * Get class name from variant
     * @return {string}
     */
    this.getClassName = function () {
      /**
       * @type {string}
       */
      var variant = this.variant || "info";

      return ["alert", variant].join("-");
    };

    return this;
  }
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insightList")
    .component("listWrapper", {
      bindings: {
        listType: "@",
        referenceIndex: "@",
        contentType: "@",
        config: "<",
        options: "<"
      },
      controller: ListWrapperController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightList/components/listWrapper/listWrapper.html"
    })
    .run(function ($templateCache) {
      /**
       * Every time you create a insight list, make sure you put it in the template cache,
       * then resolve its ID via resolveFromContentType. This way the controller
       * will always create the right component instance for the incoming insights.
       * @todo extend this list
       */
      $templateCache.put(
        "actionable-main-sensor-list",
        "<sensor-alert-list config='$ctrl.config' variant='main-list' fetching='$ctrl.loading' insights='$ctrl.insightListState'></sensor-alert-list>"
      );
      $templateCache.put(
        "actionable-secondary-sensor-list",
        "<sensor-alert-list config='$ctrl.config' variant='secondary-list' fetching='$ctrl.loading' insights='$ctrl.insightListState'></sensor-alert-list>"
      );
      $templateCache.put(
        "resolved-sensor-list",
        "<sensor-alert-list config='$ctrl.config' variant='resolved-list' fetching='$ctrl.loading' insights='$ctrl.insightListState'></sensor-alert-list>"
      );
      $templateCache.put(
        "active-health-insights-actionable",
        "<health-insight-list variant='actionable' fetching='$ctrl.loading' insights='$ctrl.insightListState' " +
          "area-list='$ctrl.areaListstate' icon='health-problem'></health-insight-list>"
      );
      $templateCache.put(
        "active-health-insights-resolved-maybe",
        "<health-insight-list variant='partial' fetching='$ctrl.loading' insights='$ctrl.insightListState' " +
          "area-list='$ctrl.areaListstate' icon='maybe-health'></health-insight-list>"
      );
      $templateCache.put(
        "resolved-health-insights-validated-yes",
        "<health-insight-list variant='resolved-yes' fetching='$ctrl.loading' insights='$ctrl.insightListState' " +
          "area-list='$ctrl.areaListstate' icon='resolved-yes-health-problem'></health-insight-list>"
      );
      $templateCache.put(
        "resolved-health-insights-validated-no",
        "<health-insight-list variant='resolved-no' fetching='$ctrl.loading' insights='$ctrl.insightListState' " +
          "area-list='$ctrl.areaListstate' icon='health-problem'></health-insight-list>"
      );
      $templateCache.put(
        "resolved-health-insights-validated-maybe",
        "<health-insight-list variant='resolved-maybe' fetching='$ctrl.loading' insights='$ctrl.insightListState' " +
          "area-list='$ctrl.areaListstate' icon='maybe-health'></health-insight-list>"
      );
      $templateCache.put(
        "actionable-group-insights",
        "<group-insight-list fetching='$ctrl.loading' variant='actionable' insights='$ctrl.insightListState'>" +
          "</group-insight-list>"
      );
      $templateCache.put(
        "resolved-group-insights",
        "<group-insight-list fetching='$ctrl.loading' variant='resolved' insights='$ctrl.insightListState'>" +
          "</group-insight-list>"
      );
      $templateCache.put(
        "calving-insights-current",
        "<calving-insight-list with-group-headers=false variant='current-list' fetching='$ctrl.loading' " +
          "insights='$ctrl.insightListState' icon='icon-calving'></calving-insight-list>"
      );
      $templateCache.put(
        "calving-insights-previous",
        "<calving-insight-list with-group-headers=true variant='previous-list' fetching='$ctrl.loading' " +
          "insights='$ctrl.insightListState'></calving-insight-list>"
      );
      $templateCache.put(
        "missing-estrus-non-cyclic-cows",
        "<missing-estrus-insight-list variant='non-cyclic' fetching='$ctrl.loading' icon='cycle-alert'" +
          " insights='$ctrl.insightListState' validation-widget='treatment-validation'></missing-estrus-insight-list>"
      );
      $templateCache.put(
        "missing-estrus-treated-cows",
        "<missing-estrus-insight-list variant='treated' fetching='$ctrl.loading' icon='syringe'" +
          " insights='$ctrl.insightListState'></missing-estrus-insight-list>"
      );
      $templateCache.put(
        "missing-estrus-cows-on-estrus",
        "<missing-estrus-insight-list variant='on-estrus' fetching='$ctrl.loading' icon='sperm-cell'" +
          " insights='$ctrl.insightListState'></missing-estrus-insight-list>"
      );
      $templateCache.put(
        "active-health-insights-beta-actionable",
        "<health-insight-list-beta variant='actionable' fetching='$ctrl.loading' insights='$ctrl.insightListState' " +
          "area-list='$ctrl.areaListstate' icon='health-problem'></health-insight-list-beta>"
      );
      $templateCache.put(
        "active-health-insights-beta-resolved-maybe",
        "<health-insight-list-beta variant='partial' fetching='$ctrl.loading' insights='$ctrl.insightListState' " +
          "area-list='$ctrl.areaListstate' icon='maybe-health'></health-insight-list-beta>"
      );
    });

  /**
   * @ngInject
   * @param lodash
   * @param $controller
   * @param areaService
   * @param $q
   * @param GenericInsightService
   * @param InsightListService
   * @return {ListWrapperController}
   * @constructor
   */
  function ListWrapperController(
    lodash,
    $controller,
    areaService,
    $q,
    GenericInsightService,
    InsightListService
  ) {
    /**
     * Inherit from the loader controller
     */
    $controller("LoaderController", {
      vm: this
    });

    /**
     * List of insights for this list
     * @type {{}[]}
     * @private
     */
    this.insightListState = [];

    /**
     * List of areas in the farmm
     * @type {Array}
     * @private
     */
    this.areaListstate = [];

    /**
     * Fetch insights on init
     */
    this.$onInit = function () {
      if (!this.listType) {
        throw new Error(
          "You must pass a list-type (and content-type) prop to this component. " +
            "It is important for picking the right subclass to load."
        );
      }

      this.fetchData(this.options);
    };

    /**
     * Fetch areas (if needed) and insights of the given type
     * @param {{ includeAreas: boolean }} options
     * @return {Promise<unknown>}
     */
    this.fetchData = function (options) {
      /**
       * Farm ID is a mandatory part of the fetch config
       * Farm id will remain the same for all the filters so we can extact out the
       * farm id at the start
       */
      var farmID = lodash.isArray(this.config)
        ? lodash.first(this.config).filter.farmID
        : this.config.filter.farmID;

      this.setLoading(true);

      options = lodash.assign(
        {
          includeAreas: true,
          includeLoadMoreButton: false
        },
        options || {}
      );

      var chain = [];

      if (options.includeAreas) {
        if (farmID) {
          chain.push(areaService.getAreas(farmID));
        } else {
          throw new Error("You need a farmID to fetch areas.");
        }
      }

      if (lodash.isArray(this.config)) {
        lodash.forEach(
          this.config,
          function (config) {
            chain.push(this.fetchInsights(config));
          }.bind(this)
        );
      } else {
        chain.push(this.fetchInsights(this.config));
      }

      return $q
        .all(chain)
        .then(
          function (response /* [areas, insights] */) {
            this.areaListstate = lodash.first(response);
            this.insightListState = lodash.uniqBy(lodash.flatten(lodash.tail(response)), "GenericInsightID");
            InsightListService.addToReference(this.listType, +this.referenceIndex, this.insightListState);
          }.bind(this)
        )
        .finally(
          function () {
            this.setLoading(false);
          }.bind(this)
        );
    };

    /**
     * Fetch insights
     * @param config
     * @returns {Promise}
     */
    this.fetchInsights = function (config) {
      /**
       * Tell whether we have type name filtering in the config
       * @type {string[]|undefined}
       */
      var typeNameFilter = lodash.get(config, ["filter", "insightType", "typeName", "any"]);

      /**
       * If the fetch config has a typeName filter, use those in a cached request
       */
      return typeNameFilter
        ? GenericInsightService.fetchInsightsByTypeName(typeNameFilter, config)
        : GenericInsightService.fetchInsights(config);
    };

    /**
     * Resolve the insight list to render from the list type and content type attributes
     * @return {string}
     */
    this.resolveFromContentType = function () {
      return lodash.compact([this.listType, this.contentType]).join("-");
    };

    /**
     * Fetch more insights when the user clicks on load more
     */
    this.loadMore = function () {
      /**
       * if we have multiple configs then update the offset of all the configs
       */
      if (lodash.isArray(this.config)) {
        lodash.forEach(
          this.config,
          function (value, key) {
            this.config[key].offset = this.config[key].offset + this.config[key].limit;
          }.bind(this)
        );
      } else {
        this.config.offset = this.config.offset + this.config.limit;
      }

      this.fetchData(this.options);
    };

    /**
     * Check if we need to hide the load more button
     * @type {boolean}
     */
    this.hideLoadMoreButton = function () {
      var hideLoadMoreButton = false;

      /**
       * if we have multiple configs then we will compare the number of insights
       * with the limit which is the smallest and then make a decision whether to
       * hide the load more button or not.
       */
      if (lodash.isArray(this.config)) {
        hideLoadMoreButton = this.insightListState.length < lodash.minBy(this.config, "limit").limit;
      } else {
        hideLoadMoreButton = this.insightListState.length < this.config.limit;
      }

      return this.loading || hideLoadMoreButton;
    }.bind(this);

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insightList")
    .component("listHeader", {
      transclude: true,
      bindings: {
        icon: "@",
        title: "@",
        description: "@",
        disabled: "<"
      },
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightList/components/listHeader/listHeader.html"
    });
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insightList")
    .component("listEntry", {
      transclude: true,
      bindings: {
        insight: "<"
      },
      controller: ListEntryController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightList/components/listEntry/listEntry.html"
    });

  /**
   * @ngInject
   * @param $state
   * @return {ListEntryController}
   * @constructor
   */
  function ListEntryController ($state) {
    /**
     * Handle clicking on the insight
     */
    this.handleClick = function () {
      $state.go("insight", { genericInsightID: this.insight.GenericInsightID });
    };

    return this;
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").component("fmsTag", {
    bindings: {
      insight: "<"
    },
    controller: FMSTagController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/insightList/components/fmsTag/fmsTag.html"
  });

  /**
   * @ngInject
   * @constructor
   */
  function FMSTagController($controller) {
    $controller("ListEntryController", {
      vm: this
    });

    this.$onInit = function () {
      // nothing
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightExtensions", ["ngLodash"]);
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightExtensions")
    .component("insightExtensionFactory", {
      bindings: {
        insight: "<"
      },
      controller: InsightExtensionFactoryController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightExtensions/components/factory/insightExtensionFactory.html"
    })
    .run(function ($templateCache) {
      $templateCache.put(
        "calving-insight-extension",
        "<calving-insight-extension insight='$ctrl.insight'></calving-insight-extension>"
      );
    });

  /**
   * @ngInject
   * @param GenericInsightService
   * @return {InsightExtensionFactoryController}
   */
  function InsightExtensionFactoryController(GenericInsightService) {
    /**
     * Resolve sub-component from insight type
     * @return {string}
     */
    this.resolve = function () {
      var typeName = GenericInsightService.getTypeName(this.insight);

      switch (typeName) {
        case "CowHasCalved":
          return "calving-insight-extension";
        default:
          return null;
      }
    }.bind(this);

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightExtensions").component("calvingInsightExtension", {
    bindings: {
      insight: "<",
      callback: "<"
    },
    controller: CalvingInsightExtensionController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightExtensions/components/calvingInsight/calvingInsightExtension.html"
  });

  /**
   * @ngInject
   * @param GenericInsightService
   * @param appSessionService
   * @param lodash
   * @param KersiaBolusService
   * @return {CalvingInsightExtensionController}
   * @constructor
   */
  function CalvingInsightExtensionController(
    GenericInsightService,
    appSessionService,
    lodash,
    KersiaBolusService
  ) {
    this.$onInit = function () {
      this.loading = true;

      KersiaBolusService.fetchStatus([this.insight.GenericInsightID])
        .then(
          function (result) {
            /**
             * At the moment we can only deal with Calcium Bolus recommendations, so anything else
             * will be elegantly ignored.
             */
            var filteredResult = lodash.mapValues(result, function (recommendationList) {
              return lodash.find(recommendationList, ["recommendationType", "BolusCalcium"]);
            });

            this.recommendation = filteredResult[this.insight.GenericInsightID];

            if (this.recommendation) {
              this.status = this.recommendation.isApplied
                ? "applied"
                : lodash.isNull(this.recommendation.isApplied)
                ? "open"
                : "not-applied";
            } else {
              this.status = "disabled";
            }
          }.bind(this),
          function () {
            this.status = "disabled";
          }.bind(this)
        )
        .finally(
          function () {
            this.loading = false;
          }.bind(this)
        );
    };

    /**
     * Respond to the recommendation
     * @param response
     * @return {Promise<any>}
     */
    this.respond = function (response) {
      var value = response === "applied" ? true : response === "not-applied" ? false : null;
      this.loading = true;

      return KersiaBolusService.respondWith(this.recommendation.recommendationId, value)
        .then(
          function () {
            this.status = response;

            if (lodash.isFunction(this.callback)) {
              this.callback({
                isApplied: value
              });
            }
          }.bind(this)
        )
        .finally(
          function () {
            this.loading = false;
          }.bind(this)
        );
    };

    /**
     * Tell whether the insight extension should be visible
     * @return {boolean}
     */
    this.isEnabled = function () {
      return this.status !== "disabled" && KersiaBolusService.isEnabled();
    };

    /**
     * Tell if the farmer may get a reminder
     * @return {boolean}
     */
    this.mayRemind = function () {
      var farmPreferences = angular.fromJson(appSessionService.farm.farmPreferences) || {};

      var reminderEnabled = lodash.get(
        farmPreferences,
        ["recommendations", "kersiaBolus", "reminderEnabled"],
        false
      );

      return reminderEnabled && this.status === "applied";
    };

    /**
     * Get class name for the interaction container
     */
    this.getInteractionContainerClassname = function () {
      if (this.status === "applied") {
        return "response-applied";
      } else if (this.status === "not-applied") {
        return "response-not-applied";
      }
    };

    return this;
  }
})();

/* eslint-disable angular/angularelement */
/* global $:false */

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightExtensions").component("calciumBolusDialog", {
    transclude: true,
    controller: CalciumBolusDialogController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightExtensions/components/calciumBolusDialog/calciumBolusDialog.html"
  });

  /**
   * @ngInject
   * @constructor
   */
  function CalciumBolusDialogController() {
    /**
     * View parts for bootstrap
     * @type {{wrapper: string}}
     */
    this.views = {
      wrapper: "#calcium-bolus-dialog"
    };

    this.recommendation = null;
    this.insight = null;
    this.callback = null;

    /**
     * Hook up Bootstrap event listeners
     */
    this.$onInit = function () {
      $(this.views.wrapper).on(
        "show.bs.modal",
        function (event) {
          var $this = $(event.target);

          this.recommendation = $this.data("recommendation");
          this.insight = $this.data("insight");
          this.callback = $this.data("callback");

          if (!this.recommendation || !this.insight) {
            throw new Error("You need to pass a recommendation object and an insight.");
          }
        }.bind(this)
      );

      $(this.views.wrapper).on("hide.bs.modal", function () {
        this.recommendation = null;
        this.insight = null;
        this.callback = null;

        $(this.views.wrapper).data("callback", null).data("recommendation", null).data("insight", null);
      }.bind(this));
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight", [
    "ui.router",
    "ctraAuthentication",
    "ctraUIComponents.insight",
    "ctraUIComponents.genericInsight.insightValidation",
    "ctraUIComponents.genericInsight.insightChart",
    "ctraUIComponents.genericInsight.insightHeadline",
    "ctraUIComponents.genericInsight.insightHeadlineResolution",
    "ctraUIComponents.genericInsight.insightResolution",
    "ctraUIComponents.genericInsight.insightDescription",
    "ctraUIComponents.genericInsight.insightExtensions",
    "ngLodash"
  ]);
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight")
    .component("sensorInsightHeadline", {
      bindings: {
        insight: "<"
      },
      controller: SensorInsightHeadlineController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightHeadline/components/sensorInsight/sensorInsightHeadline.html"
    });

  /**
   * @ngInject
   * @param $controller
   * @param GenericInsightService
   * @param epochToDayStringFilter
   * @return {SensorInsightHeadlineController}
   */
  function SensorInsightHeadlineController ($controller, GenericInsightService, epochToDayStringFilter) {

    $controller("InsightHeadlineController", {
      vm: this
    });

    /**
     * @type {string}
     */
    this.sensorOfflineDuration = "...";

    this.$onInit = function() {
      /**
       * since when was sensor offline
       * @type {string}
       */
      this.sensorOfflineDuration = epochToDayStringFilter(this.insight.startEpoch)
    };

    /**
     * Insight type name
     * @type {string}
     */
    this.getTypeName = GenericInsightService.getTypeName;

    /**
     * Smoke test the component
     * @return {boolean}
     */
    this.smokes = function () {
      return false;
    };

    return this;
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightHeadline", [
    "ngLodash"
  ]);
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightHeadline")
    .component("missingEstrusInsightHeadline", {
      bindings: {
        insight: "<"
      },
      controller: MissingEstrusInsightHeadlineController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightHeadline/components/missingEstrusInsight/missingEstrusInsightHeadline.html"
    });

  /**
   * @ngInject
   * @param $controller
   * @param epochToDayStringFilter
   * @param LocoService
   * @param GenericInsightService
   * @param CycleAlertService
   * @return {MissingEstrusInsightHeadlineController}
   */
  function MissingEstrusInsightHeadlineController(
    $controller,
    epochToDayStringFilter,
    LocoService,
    GenericInsightService,
    CycleAlertService
  ) {
    $controller("InsightHeadlineController", {
      vm: this
    });

    $controller("MissingEstrusController", {
      vm: this
    });

    /**
     * @type {null|string}
     */
    this.startDate = null;

    /**
     * @type {undefined}
     */
    this.parentInsight = undefined;

    /**
     * Init fucnction
     */
    this.$onInit = function () {
      this.startDate = epochToDayStringFilter(this.insight.startEpoch);
      this.getParentInsight()
    };

    /**
     * Get insight title
     * @return {string}
     */
    this.getTitle = function () {
      var typeName = GenericInsightService.getTypeName(this.insight);
      return LocoService.translate("insight-title", typeName, {
        title: CycleAlertService.getInsightVariant(this.insight)
      });
    };

    this.getParentInsight = function() {
      /**
       * check if we have the meta data
       */
      if (this.insight.insightMetadata) {
        var parentInsightId = angular.fromJson(this.insight.insightMetadata).parentInsightID;

        /**
         * check if we have the parent insight id
         */
        if (parentInsightId) {
          GenericInsightService.fetchSingleInsight(parseFloat(parentInsightId)).then(
            function (insight) {
              this.parentInsight = insight;
            }.bind(this)
          );
        }
      }
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightHeadline").component("herdInsightHeadline", {
    bindings: {
      insight: "<"
    },
    controller: HerdInsightHeadlineController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightHeadline/components/herdInsight/herdInsightHeadline.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param GenericInsightService
   * @param dateTimeService
   * @param LocoService
   * @param herdGroupService
   * @param appSessionService
   * @param lodash
   * @return {HerdInsightHeadlineController}
   */
  function HerdInsightHeadlineController(
    $controller,
    GenericInsightService,
    dateTimeService,
    LocoService,
    herdGroupService,
    appSessionService,
    lodash
  ) {
    /**
     * Inherit from generic insight controller
     */
    $controller("InsightBaseController", {
      vm: this
    });

    $controller("InsightHeadlineController", {
      vm: this
    });

    this.farmName = "";

    /**
     * Create an "inherited" init function
     */
    this.$onInit = lodash.wrap(this.$onInit, function (__super__) {
      __super__();

      this.farmName = lodash.get(appSessionService, ["farm", "farmName"], null);
    }.bind(this));

    this.translateGroupInsightTypeText = function () {
      return LocoService.translate("area-herd-insight");
    };

    /**
     * create payload for share button component
     * @return {{id: number, farmID: string, type: number}}
     */
    this.getShareButtonData = lodash.memoize(
      function () {
        return {
          id: this.insight.GenericInsightID,
          type: "herd-insight",
          farmID: this.insight.farmID
        };
      }.bind(this)
    );

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightHeadline")
    .component("insightHeadlineFactory", {
      bindings: {
        insight: "<",
        isGraphLoading: "<"
      },
      controller: InsightHeadlineFactoryController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightHeadline/components/factory/insightHeadlineFactory.html"
    })
    .run(function ($templateCache) {
      $templateCache.put(
        "sensor-insight-headline",
        "<sensor-insight-headline insight='$ctrl.insight'></sensor-insight-headline>"
      );
      $templateCache.put(
        "herd-insight-headline",
        "<herd-insight-headline insight='$ctrl.insight'></herd-insight-headline>"
      );
      $templateCache.put(
        "calving-insight-headline",
        "<calving-insight-headline insight='$ctrl.insight'></calving-insight-headline>"
      );
      $templateCache.put(
        "missing-estrus-insight-headline",
        "<missing-estrus-insight-headline insight='$ctrl.insight'></missing-estrus-insight-headline>"
      );
      $templateCache.put(
        "base-station-is-offline-insight-headline",
        "<base-station-is-offline-insight-headline insight='$ctrl.insight'></base-station-is-offline-insight-headline>"
      );
    });

  /**
   * @ngInject
   * @param $controller
   * @param lodash
   * @param GenericInsightService
   * @param InsightListService
   * @param appSessionService
   * @return {InsightHeadlineFactoryController}
   */
  function InsightHeadlineFactoryController(
    $controller,
    lodash,
    GenericInsightService,
    InsightListService,
    appSessionService
  ) {
    $controller("InsightHeadlineController", {
      vm: this
    });

    /**
     * Farm name for share ribbon
     * @type {string}
     */
    this.farmName = lodash.get(appSessionService, "farm.farmName", "");

    /**
     * Get previous insight id
     * @return {number}
     */
    this.getPreviousInsightID = function () {
      return InsightListService.getPreviousInsightID(this.insight.GenericInsightID);
    };

    /**
     * Get next insight id
     * @return {number}
     */
    this.getNextInsightID = function () {
      return InsightListService.getNextInsightID(this.insight.GenericInsightID);
    };

    /**
     * Resolve sub-component from insight type
     * @return {string}
     */
    this.resolve = function () {
      var typeName = GenericInsightService.getTypeName(this.insight);

      /**
       * Insight types which fall into the new category
       * @todo extend this list as soon as new insights are added
       * @type {string[]}
       */
      switch (typeName) {
        case "BaseStationIsOffline":
          return "base-station-is-offline-insight-headline";
        case "SensorIsNotOnCow":
        case "SensorIsOffline":
        case "SensorIsNotTurnedOn":
        case "CowDoesNotHaveSensor":
          return "sensor-insight-headline";
        case "HerdInsight":
          return "herd-insight-headline";
        case "CowHasCalved":
          return "calving-insight-headline";
        case "WFMissingEstrus":
        case "WFMissingEstrusPostCalving":
        case "WFMissingEstrusTreated":
        case "WFMissingEstrusPostCalvingTreated":
        case "WFMissingEstrusResolved":
        case "WFMissingEstrusPostCalvingResolved":
          return "missing-estrus-insight-headline";
      }
    }.bind(this);

    /**
     * Get share button data
     * @return {object}
     */
    this.getShareButtonData = lodash.memoize(function () {
      var typeName = GenericInsightService.getTypeName(this.insight);
      return {
        id: this.insight.GenericInsightID,
        type: typeName,
        farmID: this.insight.farmID
      };
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightHeadline").component("calvingInsightHeadline", {
    bindings: {
      insight: "<"
    },
    controller: CalvingInsightHeadlineController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightHeadline/components/calvingInsight/calvingInsightHeadline.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LocoService
   * @return {CalvingInsightHeadlineController}
   */
  function CalvingInsightHeadlineController($controller) {
    $controller("InsightHeadlineController", {
      vm: this
    });

    $controller("CalvingBaseController", {
      vm: this
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightHeadline")
    .component("baseStationIsOfflineInsightHeadline", {
      bindings: {
        insight: "<"
      },
      controller: BaseStationIsOfflineInsightHeadlineController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightHeadline/components/baseStationIsOfflineInsight/baseStationIsOfflineInsightHeadline.html"
    });

  /**
   * @ngInject
   * @param $controller
   * @param GenericInsightService
   * @param dateTimeService
   * @param LocoService
   * @param herdGroupService
   * @param appSessionService
   * @param lodash
   * @return {BaseStationIsOfflineInsightHeadlineController}
   */
  function BaseStationIsOfflineInsightHeadlineController(
    $controller,
    GenericInsightService,
    dateTimeService,
    LocoService,
    herdGroupService,
    appSessionService,
    lodash
  ) {
    $controller("InsightBaseController", {
      vm: this
    });

    $controller("InsightHeadlineController", {
      vm: this
    });

    $controller("InsightResolutionBaseController", {
      vm: this
    });

    this.farmName = "";

    /**
     * Create an "inherited" init function
     */
    this.$onInit = lodash.wrap(
      this.$onInit,
      function (__super__) {
        __super__();

        this.farmName = lodash.get(appSessionService, ["farm", "farmName"], null);
      }.bind(this)
    );

    /**
     * create payload for share button component
     * @return {{id: number, farmID: string, type: number}}
     */
    this.getShareButtonData = lodash.memoize(
      function () {
        return {
          id: this.insight.GenericInsightID,
          type: "base-station-is-offline-insight",
          farmID: this.insight.farmID
        };
      }.bind(this)
    );

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightChart", ["ngLodash"]);
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightChart")
    .component("missingEstrusInsightChart", {
      bindings: {
        insight: "<"
      },
      controller: MissingEstrusInsightController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightChart/components/missingEstrus/missingEstrusInsightChart.html"
    });

  /**
   * @ngInject
   * @param $scope
   * @param $timeout
   * @param dateTimeService
   * @param dataVariablesService
   * @return {MissingEstrusInsightController}
   */
  function MissingEstrusInsightController($scope, $timeout, dateTimeService, dataVariablesService) {

    this.visualisations = [];

    /**
     * Init
     */
    this.$onInit = function() {
      this.initCharts()
    };

    /**
     * initialize chart data
     */
    this.initCharts = (function() {
      this.activityValues = [];

      /**
       * @type {{allCowsOfFarm, cow, farm, herdGroup: *}}
       */
      var subjects = {
        allCowsOfFarm: this.insight.farmID,
        cow: this.insight.dairyCowID,
        farm: this.insight.farmID,
        herdGroup: this.insight.herdGroupID
      };

      dataVariablesService.getInsightVisualisations(
        this.insight.insightScope,
        this.insight.insightType.typeName,
        subjects
      ).then((function (visualisations) {
        this.visualisations = visualisations;

        /**
         * @type {number}
         */
        this.centerEpoch = (this.insight.startEpoch +
          (this.insight.endEpoch - this.insight.startEpoch) / 2)*1000;

        /**
         * @type {epoch}
         */
        this.startDate = this.centerEpoch;

        /**
         * @type {epoch}
         */
        this.endDate = this.centerEpoch;

        if (dateTimeService.since(dateTimeService.asEpoch(this.centerEpoch)) > this.visualisations.dayRange / 2) {
          // Add and subtract 1/2 of the dayRange
          var startDateDifference = dateTimeService.getDayOfMonth(this.centerEpoch) - (this.visualisations.dayRange - 1) / 2
          this.startDate = dateTimeService.withDayOfMonth(this.startDate, startDateDifference);

          var endDateDifference = dateTimeService.getDayOfMonth(this.centerEpoch) + (this.visualisations.dayRange - 1) / 2
          this.endDate = dateTimeService.withDayOfMonth(this.endDate, endDateDifference);
        } else {
          this.startDate = dateTimeService.now() ;
          this.endDate = dateTimeService.now();

          var sDateDifference = dateTimeService.getDayOfMonth(this.startDate * 1000) - (this.visualisations.dayRange - 1);
          this.startDate = dateTimeService.withDayOfMonth(this.startDate * 1000,  sDateDifference);
        }

        this.startDate = dateTimeService.asDate(this.startDate);
        this.endDate = dateTimeService.asDate(this.endDate)

        /**
         * @type {Date}
         */
        this.maxDate = dateTimeService.midnight();
        var maxDaySum = dateTimeService.getDayOfMonth(this.maxDate) + (this.visualisations.dayRange - 1) / 2;
        this.maxDate = dateTimeService.withDayOfMonth(this.maxDate, maxDaySum);

        /**
         * @type {Date}
         */
        this.eod = dateTimeService.midnight();
      }).bind(this));

      /**
       * @type {Date}
       */
      this.insightDate = dateTimeService.asDate(this.insight.insightStartEpoch);
    }).bind(this);

    /**
     * Update start and end date when the user changes the time period
     * @param startDate
     * @param endDate
     */
    this.onDateChange = function (startDate, endDate) {
      /**
       * check if end date is greater than max date. If yes then that means we are going out of
       * the range and have to adjust the start and end date
       */
      if (dateTimeService.asEpoch(endDate) > this.maxDate) {
        this.endDate = dateTimeService.asDate(this.maxDate);
        /**
         * Move max date 30 days or 7 days behind according to the value of day range and then assign
         * it to start date
         * @type {number}
         */
        var maxDateEpoch = this.maxDate;
        var maxDateDifference = dateTimeService.withDayOfMonth(maxDateEpoch, -(this.visualisations.dayRange - 1));
        this.startDate = dateTimeService.asDate(maxDateEpoch - Math.abs(maxDateDifference));
      } else {
        this.startDate = startDate;
        this.endDate = endDate;
      }

      $timeout(function () {
        $scope.$apply();
      });
    };
  }

}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightChart").component("herdInsightChart", {
    bindings: {
      insight: "<",
      setLoadingGraphs: "&"
    },
    controller: HerdInsightController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "insightChart/components/herdInsight/herdInsightChart.html"
  });

  /**
   * @ngInject
   * @param $scope
   * @param $timeout
   * @param dateTimeService
   * @param dataVariablesService
   * @return {HerdInsightController}
   */
  function HerdInsightController($scope, $timeout, dateTimeService, dataVariablesService) {
    this.visualisations = {};

    /**
     * Initialise.
     * @memberOf HerdInsightController
     */
    this.$onInit = function () {
      this.visualisations = dataVariablesService.getHerdGroupAnalyticsVisualisations({
        herdGroup: this.insight.herdGroupID,
        farm: this.insight.farmID
      });
      this.initCharts();
    };

    /**
     * Initialize the chart component
     */
    this.initCharts = function () {
      /**
       * This can either be a month or a week depending on the screen size
       * @type {number}
       */
      this.dayRange = this.visualisations.dayRange;
      /**
       * calculate the center date between start date and end date
       * @type {number}
       */
      this.centerEpoch =
        (this.insight.startEpoch + (this.insight.endEpoch - this.insight.startEpoch) / 2) * 1000;
      this.startDate = this.centerEpoch;
      this.endDate = this.centerEpoch;

      /**
       * check if the days between the time that's right now and center epoch lies somewhere outside the day range.
       * If yes then move to that center otherwise we can show the current month
       */
      if (dateTimeService.since(dateTimeService.asEpoch(this.centerEpoch)) > this.dayRange / 2) {
        /**
         * Depending on the day range move start date dayRange/2 number of days behind. If its month then
         * we will move 15 days behind and if week then 3 days
         */
        var centerEpochDayOfMonth = dateTimeService.getDayOfMonth(this.centerEpoch);
        var startDateDifference = centerEpochDayOfMonth - this.dayRange / 2;
        this.startDate = dateTimeService.withDayOfMonth(this.startDate, startDateDifference);

        /**
         * Depending on the day range move the end date dayRange/2 number of days ahead. So if it is a month
         * we will move 15 days ahead and if it's a week then 3 days ahead
         */
        var endDateDifference = dateTimeService.getDayOfMonth(this.centerEpoch) + (this.dayRange - 1) / 2;
        this.endDate = dateTimeService.withDayOfMonth(this.endDate, endDateDifference);
      } else {
        this.startDate = dateTimeService.now();
        this.endDate = dateTimeService.midnight();
        this.endDate = dateTimeService.asEpoch(this.endDate);

        /**
         * Move start day 30 or 6 day behind depending on the day range
         */
        var sDateDifference = dateTimeService.getDayOfMonth(this.startDate * 1000) - (this.dayRange - 1);
        this.startDate = dateTimeService.withDayOfMonth(this.startDate * 1000, sDateDifference);
      }

      this.startDate = dateTimeService.asDate(this.startDate);
      this.endDate = dateTimeService.asDate(this.endDate);

      /**
       * @type {Date}
       */
      this.maxDate = dateTimeService.midnight();
      var maxDaySum = dateTimeService.getDayOfMonth(this.maxDate) + (this.visualisations.dayRange - 1) / 2;
      this.maxDate = dateTimeService.asDate(dateTimeService.withDayOfMonth(this.maxDate, maxDaySum));
    };

    /**
     * Update start and end date when the user changes the time period
     * @param startDate
     * @param endDate
     */
    this.onDateChange = function (startDate, endDate) {
      /**
       * check if end date is greater than max date. If yes then that means we are going out of
       * the range and have to adjust the start and end date
       */
      if (dateTimeService.asEpoch(endDate) > dateTimeService.asEpoch(this.maxDate)) {
        this.endDate = this.maxDate;
        /**
         * Move max date 30 days or 7 days behind according to the value of day range and then assign
         * it to start date
         * @type {number}
         */
        var maxDateEpoch = dateTimeService.asEpoch(this.maxDate);
        var maxDateDifference = dateTimeService.withDayOfMonth(maxDateEpoch, -(this.dayRange - 1));
        this.startDate = dateTimeService.asDate(maxDateEpoch - Math.abs(maxDateDifference));
      } else {
        this.startDate = startDate;
        this.endDate = endDate;
      }

      $timeout(function () {
        $scope.$apply();
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightChart")
    .component("calvingInsightChart", {
      bindings: {
        insight: "<"
      },
      controller: CalvingInsightController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "insightChart/components/calvingInsight/calvingInsightChart.html"
    });

  /**
   * @ngInject
   * @param $scope
   * @param $timeout
   * @param dateTimeService
   * @param dataVariablesService
   * @return {CalvingInsightController}
   */
  function CalvingInsightController($scope, $timeout, dateTimeService, dataVariablesService) {

    this.visualisations = [];

    /**
     * Init
     */
    this.$onInit = function() {
      this.initCharts()
    };

    /**
     * initialize chart data
     */
    this.initCharts = (function() {
      this.activityValues = [];

      /**
       * @type {{allCowsOfFarm, cow, farm, herdGroup: *}}
       */
      var subjects = {
        allCowsOfFarm: this.insight.farmID,
        cow: this.insight.dairyCowID,
        farm: this.insight.farmID,
        herdGroup: this.insight.herdGroupID
      };

      dataVariablesService.getInsightVisualisations(
        this.insight.insightScope,
        this.insight.insightType.typeName,
        subjects
      ).then((function (visualisations) {
        this.visualisations = visualisations;

        /**
         * @type {number}
         */
        this.centerEpoch = (this.insight.startEpoch +
          (this.insight.endEpoch - this.insight.startEpoch) / 2)*1000;

        /**
         * @type {epoch}
         */
        this.startDate = this.centerEpoch;

        /**
         * @type {epoch}
         */
        this.endDate = this.centerEpoch;

        if (dateTimeService.since(dateTimeService.asEpoch(this.centerEpoch)) > this.visualisations.dayRange / 2) {
          // Add and subtract 1/2 of the dayRange
          var startDateDifference = dateTimeService.getDayOfMonth(this.centerEpoch) - (this.visualisations.dayRange - 1) / 2
          this.startDate = dateTimeService.withDayOfMonth(this.startDate, startDateDifference);

          var endDateDifference = dateTimeService.getDayOfMonth(this.centerEpoch) + (this.visualisations.dayRange - 1) / 2
          this.endDate = dateTimeService.withDayOfMonth(this.endDate, endDateDifference);
        } else {
          this.startDate = dateTimeService.now() ;
          this.endDate = dateTimeService.now();

          var sDateDifference = dateTimeService.getDayOfMonth(this.startDate * 1000) - (this.visualisations.dayRange - 1);
          this.startDate = dateTimeService.withDayOfMonth(this.startDate * 1000,  sDateDifference);
        }

        this.startDate = dateTimeService.asDate(this.startDate);
        this.endDate = dateTimeService.asDate(this.endDate)

        /**
         * @type {Date}
         */
        this.maxDate = dateTimeService.midnight();
        var maxDaySum = dateTimeService.getDayOfMonth(this.maxDate) + (this.visualisations.dayRange - 1) / 2;
        this.maxDate = dateTimeService.withDayOfMonth(this.maxDate, maxDaySum);

        /**
         * @type {Date}
         */
        this.eod = dateTimeService.midnight();
      }).bind(this));

      /**
       * @type {Date}
       */
      this.insightDate = dateTimeService.asDate(this.insight.insightStartEpoch);
    }).bind(this);
  }

}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightChart")
    .component("insightChartFactory", {
      bindings: {
        insight: "<",
        setLoadingGraphs: "&"
      },
      controller: InsightChartFactoryController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightChart/components/factory/insightChartFactory.html"
    })
    .run(function ($templateCache) {
      /**
       * @todo extend this list with new insight types and validation flows
       */
      $templateCache.put(
        "herd-insight-chart",
        "<herd-insight-chart insight='$ctrl.insight' set-loading-graphs='$ctrl.setLoadingGraphs({loading: loading})'></herd-insight-chart>"
      );
      $templateCache.put(
        "calving-insight-chart",
        "<calving-insight-chart insight='$ctrl.insight'></calving-insight-chart>"
      );
      $templateCache.put(
        "missing-estrus-insight-chart",
        "<missing-estrus-insight-chart insight='$ctrl.insight'></missing-estrus-insight-chart>"
      );
    });

  /**
   * @ngInject
   * @param GenericInsightService
   * @return {InsightChartFactoryController}
   */
  function InsightChartFactoryController(GenericInsightService) {
    /**
     * Resolve sub-component from insight type
     * @return {string}
     */

    this.resolve = function (insight) {
      var insightType = GenericInsightService.getTypeName(insight);

      switch (insightType) {
        case "HerdInsight":
          return "herd-insight-chart";
        case "CowHasCalved":
          return "calving-insight-chart";
        case "WFMissingEstrus":
        case "WFMissingEstrusPostCalving":
        case "WFMissingEstrusTreated":
        case "WFMissingEstrusPostCalvingTreated":
        case "WFMissingEstrusResolved":
        case "WFMissingEstrusPostCalvingResolved":
          return "missing-estrus-insight-chart";
      }
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight.insightDescription", [
    "ngLodash"
  ]);
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightDescription")
    .component("genericInsightDescription", {
      bindings: {
        insight: "<"
      },
      controller: GenericInsightDescriptionController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightDescription/components/genericDescription/genericInsightDescription.html"
    });

  /**
   * @ngInject
   * @param GenericInsightService
   * @return {GenericInsightDescriptionController}
   */
  function GenericInsightDescriptionController(GenericInsightService) {
    /**
     * Get insight description
     * @param {{}} insight
     * @return {string}
     */
    this.getInsightDescription = GenericInsightService.getTranslatedDescription;

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightDescription")
    .component("insightDescriptionFactory", {
      bindings: {
        insight: "<"
      },
      controller: InsightDescriptionFactoryController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightDescription/components/factory/insightDescriptionFactory.html"
    })
    .run(function ($templateCache) {
      $templateCache.put(
        "generic-insight-description",
        "<generic-insight-description insight='$ctrl.insight'></generic-insight-description>"
      );
      $templateCache.put(
        "missing-estrus-description",
        "<missing-estrus-insight-description insight='$ctrl.insight'></missing-estrus-insight-description>"
      );
      $templateCache.put(
        "base-station-is-offline-description",
        "<base-station-is-offline-description insight='$ctrl.insight'></base-station-is-offline-description>"
      );
    });

  /**
   * @ngInject
   * @param GenericInsightService
   * @return {InsightDescriptionFactoryController}
   */
  function InsightDescriptionFactoryController(GenericInsightService) {
    /**
     * Resolve sub-component from insight type
     * @return {string}
     */
    this.resolve = function () {
      var typeName = GenericInsightService.getTypeName(this.insight);

      /**
       * Insight types which fall into the new category
       * @todo extend this list as soon as new insights are added
       * @type {string[]}
       */
      switch (typeName) {
        case "SensorIsNotOnCow":
        case "SensorIsOffline":
        case "SensorIsNotTurnedOn":
        case "CowDoesNotHaveSensor":
        case "HerdInsight":
        case "CowHasCalved":
          return "generic-insight-description";
        case "WFMissingEstrus":
        case "WFMissingEstrusPostCalving":
        case "WFMissingEstrusTreated":
        case "WFMissingEstrusPostCalvingTreated":
        case "WFMissingEstrusResolved":
        case "WFMissingEstrusPostCalvingResolved":
          return "missing-estrus-description";
        case "BaseStationIsOffline":
          return "base-station-is-offline-description";
      }
    }.bind(this);

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightDescription")
    .component("missingEstrusInsightDescription", {
      bindings: {
        insight: "<"
      },
      controller: MissingEstrusInsightDescriptionController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightDescription/components/missingEstrusDescription/missingEstrusDescription.html"
    });

  /**
   * @ngInject
   * @param lodash
   * @param LocoService
   * @param CycleAlertService
   * @return {MissingEstrusInsightDescriptionController}
   */
  function MissingEstrusInsightDescriptionController(lodash, LocoService, CycleAlertService) {
    /**
     * check if the inight variant is valid or not
     */
    this.isValidInsightVariant = CycleAlertService.isValidInsightVariant;

    /**
     * Get description of the insight
     * @return {*}
     */
    this.getInsightDescription = function () {
      return LocoService.translate(
        lodash.join([CycleAlertService.getInsightVariant(this.insight), "DESCRIPTION"], "_")
      );
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightDescription")
    .component("baseStationIsOfflineDescription", {
      bindings: {
        insight: "<"
      },
      controller: BaseStationIsOfflineDescriptionController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "insightDescription/components/baseStationIsOfflineDescription/baseStationIsOfflineDescription.html"
    });

  /**
   * @ngInject
   * @param GenericInsightService
   * @return {BaseStationIsOfflineDescriptionController}
   */
  function BaseStationIsOfflineDescriptionController(GenericInsightService) {
    /**
     * Get insight description
     * @param {{}} insight
     * @return {string}
     */
    this.getInsightDescription = GenericInsightService.getTranslatedDescription;

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.icons", [
      "ngLodash"
    ]);
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.icons")
    .component("svgIcon", {
      bindings: {
        size: "<",
        icon: "@"
      },
      controller: IconController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "icons/components/icon/icon.html"
    });

  /**
   * @ngInject
   * @constructor
   */
  function IconController () {
    /**
     * Pick the SVG to render
     * @return {string}
     */
    this.getTemplate = function () {
      return "/assets/images/icons/svg/" + this.icon + ".svg";
    };

    /**
     * Get icon classname
     * @return {string}
     */
    this.getClassName = function () {
      return ["icon", this.icon].join("-");
    };
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight").component("sensorOffCowInsight", {
    bindings: {
      insight: "<"
    },
    controller: sensorOffCowInsightController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "genericInsight/components/sensorOffCow/sensorOffCowInsight.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param lodash
   * @param GenericInsightService
   * @param EventEmitter
   * @param sessionService
   * @param CachingService
   * @param INSIGHT_CATEGORIES
   * @param insightResolutionService
   * @return {sensorOffCowInsightController}
   */
  function sensorOffCowInsightController(
    $controller,
    lodash,
    GenericInsightService,
    EventEmitter,
    sessionService,
    CachingService,
    INSIGHT_CATEGORIES,
    insightResolutionService
  ) {
    /**
     * Inherit from generic insight controller
     */
    $controller("InsightBaseController", {
      vm: this
    });

    /**
     * @type {string[]}
     */
    this.contextParams = ["herdName", "cowStatus", "sensorSerial"];

    /**
     * Initialise
     * @memberOf genericInsight
     */
    this.$onInit = function () {
      this.setAsSeen(this.insight);
    };

    /**
     * Set insight as seen
     * @todo move to a service
     * @param insight
     */
    this.setAsSeen = function (insight) {
      if (
        insight &&
        !GenericInsightService.isSeen(insight) &&
        (this.containsOnlyReplaceSensorResolution(insight) || !GenericInsightService.isResolved(insight))
      ) {
        var partialInsightData = lodash.pick(insight, ["GenericInsightID", "seenByUserIds"]);
        var userID = sessionService.user.id;

        userID = userID + ",";

        partialInsightData.seenByUserIds = lodash.isNil(partialInsightData.seenByUserIds)
          ? userID
          : partialInsightData.seenByUserIds + userID;

        GenericInsightService.patchUpdate(partialInsightData, "seenByUserIds").then(function () {
          /**
           * Before any updates, invalidate sensor alerts
           */
          CachingService.invalidate(INSIGHT_CATEGORIES.sensorAlert.join());
          EventEmitter.emit(EventEmitter.events.navigation.updateCount, "actionable-sensor-alerts", -1, {
            relative: true
          });
        });
      }
    };

    /**
     * Check if this insight contains only replace sensor resolution
     * @param insight
     * @return {boolean}
     */
    this.containsOnlyReplaceSensorResolution = function (insight) {
      var isOnlyReplaceSensorInsight = false;
      /**
       * In case of second list we have to show the unseen badge if the insight belongs to the second list
       * but we have to make sure that only replace_sensor resolution is present in it.
       */
      if (
        insight.insightResolution.length === 1 &&
        insightResolutionService.hasResolution(insight.insightResolution, "replace_sensor")
      ) {
        isOnlyReplaceSensorInsight = true;
      }

      return isOnlyReplaceSensorInsight;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight").component("herdInsight", {
    bindings: {
      insight: "<"
    },
    controller: herdInsightController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "genericInsight/components/herdInsight/herdInsight.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param GenericInsightService
   * @param LocoService
   * @param lodash
   * @return {herdInsightController}
   */
  function herdInsightController($controller, GenericInsightService, LocoService, lodash) {
    /**
     * Inherit from generic insight controller
     */
    $controller("InsightBaseController", {
      vm: this
    });

    /**
     * Create an "inherited" init function
     */
    this.$onInit = lodash.wrap(
      this.$onInit,
      function (__super__) {
        __super__();
        this.setAsSeen();
      }.bind(this)
    );

    /**
     * Update insight resolution
     * @param insightResolution
     */
    this.updateInsightResolution = function (insightResolution) {
      this.insight.insightResolution = insightResolution;
      GenericInsightService.updateInsight(this.insight);
    }.bind(this);

    this.translateResolutionQuestion = function () {
      return LocoService.translate("group-insight", "resolution-question", {
        areaName: lodash.get(this.herdGroup, "groupName")
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight").component("noSensorOnCowInsight", {
    bindings: {
      insight: "<"
    },
    controller: noSensorOnCowInsightController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "genericInsight/components/noSensorOnCow/noSensorOnCowInsight.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @return {noSensorOnCowInsightController}
   */
  function noSensorOnCowInsightController($controller) {
    /**
     * Inherit from generic insight controller
     */
    $controller("InsightBaseController", {
      vm: this
    });

    /**
     * @type {string[]}
     */
    this.contextParams = ["herdName", "cowStatus", "dim", "lactation"];

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight").component("missingEstrusInsight", {
    bindings: {
      insight: "<"
    },
    controller: MissingEstrusInsightController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "genericInsight/components/missingEstrus/missingEstrus.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @return {MissingEstrusInsightController}
   */
  function MissingEstrusInsightController($controller) {
    /**
     * Inherit from generic insight controller
     */
    $controller("InsightBaseController", {
      vm: this
    });

    /**
     * @type {string[]}
     */
    this.contextParams = ["herdName", "DIM", "cowStatus", "lastEstrus"];

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight")
    .component("calvingInsight", {
      bindings: {
        insight: "<"
      },
      controller: CalvingInsightController,
      templateUrl: "app/shared-components/angular-ui-components/modules/" +
        "genericInsight/components/calvingInsight/calvingInsight.html"
    });

  /**
   * @ngInject
   * @param $controller
   * @return {CalvingInsightController}
   */
  function CalvingInsightController($controller) {
    /**
     * Inherit from generic insight controller
     */

    $controller("InsightBaseController", {
      vm: this
    });

  }

}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight")
    .component("insightFactory", {
      bindings: {
        insight: "<"
      },
      controller: insightFactoryController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "genericInsight/components/factory/insightFactory.html"
    })
    .run(function ($templateCache) {
      $templateCache.put("legacy-insight", "<insight insight='$ctrl.insight'></insight>");
      $templateCache.put("generic-insight", "<generic-insight insight='$ctrl.insight'></generic-insight>");
    });

  /**
   * @ngInject
   * @param $controller
   * @param lodash
   * @return {insightFactoryController}
   */
  function insightFactoryController($controller, lodash) {
    /**
     * Resolve sub-component from insight type: legacy or new
     * @return {string}
     */
    this.resolve = function () {
      /**
       * By default, we fall back to the legacy insight
       * @type {string}
       */
      var insight = "legacy-insight";

      /**
       * Insight type name
       * @type {string}
       */
      var typeName = lodash.get(this.insight, ["insightType", "typeName"]);

      /**
       * Insight types which fall into the new category
       * @todo extend this list as soon as new insights are added
       * @type {string[]}
       */
      var genericInsightTypes = [
        "BaseStationIsOffline",
        "SensorIsNotOnCow",
        "HerdInsight",
        "CowHasCalved",
        "SensorIsOffline",
        "SensorIsNotTurnedOn",
        "CowDoesNotHaveSensor",
        "WFMissingEstrus",
        "WFMissingEstrusPostCalving",
        "WFMissingEstrusTreated",
        "WFMissingEstrusPostCalvingTreated",
        "WFMissingEstrusResolved",
        "WFMissingEstrusPostCalvingResolved"
      ];

      if (genericInsightTypes.includes(typeName)) {
        insight = "generic-insight";
      }

      return insight;
    }.bind(this);

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight").component("contextDetails", {
    bindings: {
      insight: "<",
      params: "<",
      cow: "<"
    },
    controller: contextDetailsController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "genericInsight/components/contextDetails/contextDetails.html"
  });

  /**
   * @ngInject
   * @param COW_STATUS
   * @param dateTimeService
   * @param areaService
   * @param sensorService
   * @param insightService
   * @param herdGroupService
   * @param GenericInsightService
   * @param LocoService
   * @param CycleAlertService
   * @param lodash
   * @return {contextDetailsController}
   */
  function contextDetailsController(
    COW_STATUS,
    dateTimeService,
    areaService,
    sensorService,
    insightService,
    herdGroupService,
    GenericInsightService,
    LocoService,
    CycleAlertService,
    lodash
  ) {
    this.$onInit = function onInit() {
      /**
       * Initial state
       * @type {{}}
       */
      this.state = {};

      /**
       * Insight context
       * @type {{}}
       */
      this.insightContext = GenericInsightService.getContext(this.insight);

      this.params.forEach(
        function (param) {
          var resolve = this["get" + lodash.upperFirst(param)];

          if (lodash.isFunction(resolve)) {
            resolve();
          } else {
            throw new Error("I cannot resolve `" + param + "`.");
          }
        }.bind(this)
      );
    }.bind(this);

    /**
     * Get cow status
     */
    this.getCowStatus = function () {
      /**
       * @type {{title: string, suffix: string, value: string}}
       */
      this.state.cowStatus = {
        title: "context-details-cow-state",
        value: this.insightContext.cowState,
        suffix: ""
      };
    }.bind(this);

    /**
     * Get area name
     */
    this.getAreaName = function () {
      /**
       * @type {number}
       */
      var areaId = this.insightContext.areaID;

      /**
       * @type {{title: string, suffix: string, value: string}}
       */
      this.state.areaName = {
        title: "context-details-area-name",
        value: "...",
        suffix: ""
      };

      areaService.getArea(areaId).then(
        function (area) {
          this.state.areaName.value = area.areaName;
        }.bind(this)
      );
    }.bind(this);

    /**
     * Get herd name
     */
    this.getHerdName = function () {
      /**
       * @type {number}
       */
      var herdId = this.insight.dairyCow.herdGroupID;

      /**
       * @type {{title: string, suffix: string, value: string}}
       */
      this.state.herdName = {
        title: "context-details-herd-name",
        value: "...",
        suffix: ""
      };

      herdGroupService.getHerdGroup(herdId).$promise.then(
        function (herdGroup) {
          this.state.herdName.value = herdGroup.groupName;
        }.bind(this)
      );
    }.bind(this);

    /**
     * Get sensor serial number, at least the last 6 digits of it
     */
    this.getSensorSerial = function () {
      /**
       * Max display length of serial number
       * @type {number}
       */
      var maxLen = 6;

      /**
       * @type {number}
       */
      var nodeId = this.insight.dairyCow.nodeID;

      /**
       * @type {{title: string, suffix: string, value: string}}
       */
      this.state.sensorSerial = {
        title: "context-details-sensor-serial",
        value: "...",
        suffix: ""
      };

      sensorService.getSensor(nodeId).then(
        function (sensor) {
          this.state.sensorSerial.value =
            sensor.shortSerialNum.length > maxLen
              ? ["...", sensor.shortSerialNum.substr(-1 * maxLen)].join("")
              : sensor.shortSerialNum;
        }.bind(this)
      );
    }.bind(this);

    /**
     * Get a class name for the items, depending on how many there are
     * @return {string}
     */
    this.getItemClassName = function () {
      var className = [];

      /**
       * Max nr of columns in a row
       * @type {number}
       */
      var max = 12;

      /**
       * Number of columns we need
       */
      var cols = lodash.values(this.state).length || 1;

      /**
       * @type {number}
       */
      var result = max / cols;

      /**
       * @type {number}
       */
      var width = Math.floor(result);

      className.push("col-xs-" + width);

      /**
       * Offset the columns by one if `result` is not an integer.
       * It happens when `cols = 5`.
       */
      if (result !== width) {
        className.push("col-sm-offset-1");
      }

      return className.join(" ");
    }.bind(this);

    /**
     * Get days in milk value
     */
    this.getDIM = function () {
      /**
       * @type {{title: string, suffix: string, value: string}}
       */
      this.state.dim = {
        title: "context-details-dim",
        value: "...",
        suffix: ""
      };

      if (this.cow.cowStatus !== COW_STATUS.dry && this.cow.lastCalvingEpoch) {
        /**
         * @type {{title: string, value: number}}
         */
        this.state.dim.value = this.insight
          ? insightService.getDim(this.insight)
          : dateTimeService.daysBetween(
              dateTimeService.midnight(),
              new Date(this.cow.lastCalvingEpoch * 1000)
            );
      }
    }.bind(this);

    /**
     * Get lactation value
     */
    this.getLactation = function () {
      /**
       * @type {{title: string, suffix: string, value: string}}
       */
      this.state.lactation = {
        title: "context-lactation-dim",
        value: "...",
        suffix: ""
      };

      /**
       * @type {number}
       */
      var lactationNumber =
        GenericInsightService.getContext(this.insight).lactationNumber || this.cow.lactationNumber;

      if (lactationNumber) {
        /**
         * @type {{title: string, value: (string|*)}}
         */
        this.state.lactation.value = lactationNumber;
      }
    }.bind(this);

    /**
     * Get last estrus value
     */
    this.getLastEstrus = function () {
      /**
       * @type {{showAdditionBracket: boolean, translateValue: boolean, title: string, value: string, addition: string}}
       */
      this.state.lastEstrus = {
        title: "context-last-estrus",
        value: "-",
        addition: "",
        showAdditionBracket: false,
        translateValue: true
      };

      /**
       * @type {string}
       */
      var cowStatus = GenericInsightService.getContext(this.insight).cowState || this.cow.cowStatus;

      /**
       * @type {number}
       */
      var lastEstrusEpoch = this.insight
        ? GenericInsightService.getContext(this.insight).previousEstrusEpoch
        : this.cow.lastEstrusEpoch;

      if ([COW_STATUS.open, COW_STATUS.inseminated].indexOf(cowStatus) > -1) {
        if (lastEstrusEpoch) {
          /**
           * Display "Last estrus" only the days since the last estrus in the current lactation.
           * @type {boolean}
           */
          var mayShowLastEstrus = !this.cow.lastCalvingEpoch || this.cow.lastCalvingEpoch < lastEstrusEpoch;

          /**
           * Get last breeding value so that we can check if we should how inseminated
           * @type {number}
           */
          var lastBreedingEpoch =
            GenericInsightService.getContext(this.insight).previousInseminationEpoch ||
            this.cow.lastInseminationEpoch;

          /**
           * @type {number}
           */
          var lastEstrusDays = CycleAlertService.getLastEstrusValue(this.insight);

          if (mayShowLastEstrus && !!lastEstrusDays) {
            if (lastEstrusEpoch === lastBreedingEpoch) {
              this.state.lastEstrus.addition = "inseminated";
              this.state.lastEstrus.showAdditionBracket = true;
            }

            this.state.lastEstrus.value = {
              value: "days-ago",
              meta: { days: lastEstrusDays }
            };
          } else if (mayShowLastEstrus && lastEstrusDays === 0) {
            this.state.lastEstrus.value = "date-label-today";
          }
        }
      }
    }.bind(this);

    /**
     * Translate value
     * @param value
     * @return {string}
     */
    this.translateValue = function (value) {
      var translatedValue = value;
      if (lodash.isString(value)) {
        translatedValue = LocoService.translate(value);
      } else if (lodash.isObject(value)) {
        translatedValue = LocoService.translate(value.value, value.meta);
      }

      return translatedValue;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight").component("baseStationIsOffline", {
    bindings: {
      insight: "<"
    },
    controller: BaseStationIsOfflineController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "genericInsight/components/baseStationIsOffline/baseStationIsOffline.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @return {BaseStationIsOfflineController}
   */
  function BaseStationIsOfflineController($controller) {
    /**
     * Inherit from generic insight controller
     */
    $controller("InsightBaseController", {
      vm: this
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight")
    .component("genericInsight", {
      bindings: {
        insight: "<"
      },
      controller: genericInsightController,
      templateUrl:
        "app/shared-components/angular-ui-components/modules/" +
        "genericInsight/components/base/genericInsight.html"
    })
    .run(function ($templateCache) {
      /**
       * Every time you create a new subclass, make sure you put it in the template cache,
       * then resolve its ID via resolveFromInsightType. This way the generic insight controller
       * will create the right component instance for the incoming insight.
       * @todo extend this list
       */
      $templateCache.put(
        "sensor-off-cow-insight",
        "<sensor-off-cow-insight insight='$ctrl.insight'></sensor-off-cow-insight>"
      );
      $templateCache.put("herd-insight", "<herd-insight insight='$ctrl.insight'></herd-insight>");
      $templateCache.put("calving-insight", "<calving-insight insight='$ctrl.insight'></calving-insight>");
      $templateCache.put(
        "no-sensor-on-cow",
        "<no-sensor-on-cow-insight insight='$ctrl.insight'></no-sensor-on-cow-insight>"
      );
      $templateCache.put(
        "missing-estrus-insight",
        "<missing-estrus-insight insight='$ctrl.insight'></missing-estrus-insight>"
      );
      $templateCache.put(
        "base-station-is-offline",
        "<base-station-is-offline-insight insight='$ctrl.insight'></base-station-is-offline-insight>"
      );
    });

  /**
   * @ngInject
   * @param $controller
   * @param lodash
   * @param GenericInsightService
   * @return {genericInsightController}
   */
  function genericInsightController($controller, lodash, GenericInsightService) {
    /**
     * Inherit from generic insight controller
     */
    $controller("InsightBaseController", {
      vm: this
    });

    this.isGraphLoading = false;

    /**
     * Get insight description
     * @param {{}} insight
     * @return {string}
     */
    this.getInsightDescription = GenericInsightService.getTranslatedDescription;

    /**
     * Resolve sub-component from insight type
     * @todo Multiple cases may resolve the same way, set it up properly.
     * @return {string}
     */
    this.resolveFromInsightType = function () {
      /**
       * Insight type name
       * @type {string}
       */
      var typeName = GenericInsightService.getTypeName(this.insight);

      /**
       * See $templateCache above on how these values are being used.
       */
      switch (typeName) {
        case "BaseStationIsOffline":
          return "base-station-is-offline";
        case "SensorIsNotOnCow":
        case "SensorIsOffline":
        case "SensorIsNotTurnedOn":
          return "sensor-off-cow-insight";
        case "HerdInsight":
          return "herd-insight";
        case "CowHasCalved":
          return "calving-insight";
        case "CowDoesNotHaveSensor":
          return "no-sensor-on-cow";
        case "WFMissingEstrus":
        case "WFMissingEstrusPostCalving":
        case "WFMissingEstrusTreated":
        case "WFMissingEstrusPostCalvingTreated":
        case "WFMissingEstrusResolved":
        case "WFMissingEstrusPostCalvingResolved":
          return "missing-estrus-insight";
      }

      throw new Error("The insight type " + typeName + " is not yet registered as a component.");
    }.bind(this);

    /**
     * Get wrapper HTML class name based on the insight type name
     * @return {boolean}
     */
    this.getWrapperClassName = function () {
      /**
       * Insight type name
       * @type {string}
       */
      var typeName = GenericInsightService.getTypeName(this.insight);

      return "insight-type--" + typeName;
    }.bind(this);

    /**
     * Get classname from insight category
     * @return {string}
     */
    this.getCategoryClassName = function () {
      /**
       * Insight type name
       * @type {string}
       */
      var category = GenericInsightService.getCategory(this.insight);

      return "insight-" + category;
    }.bind(this);

    this.setLoadingGraphs = function (loading) {
      this.isGraphLoading = loading;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlanList", ["ngLodash"]);
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlanList").component("gamePlanList", {
    bindings: {
      gamePlans: "<",
      fetching: "<",
      variant: "@"
    },
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "gamePlanList/components/listWrapper/listWrapper.html"
  });
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlanList").component("gamePlanEntry", {
    bindings: {
      gamePlan: "<"
    },
    controller: ListEntryController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "gamePlanList/components/listEntry/listEntry.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param $state
   * @param lodash
   * @return {ListEntryController}
   * @constructor
   */
  function ListEntryController($controller, $state, lodash) {
    $controller("GamePlanBaseController", {
      vm: this
    });

    /**
     * Navigate to a game plan
     */
    this.goToGamePlan = function () {
      $state.go("gamePlan", { gamePlanID: this.gamePlan.id });
    };

    /**
     * get options for task list
     */
    this.getOptions = lodash.memoize(function () {
      return {
        hideEmptyStateMessage: true
      };
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlanList").component("gamePlanListEmptyState", {
    controller: GamePlanListEmptyStateController,
    bindings: {
      variant: "<"
    },
    templateUrl:
      "app/shared-components/angular-ui-components/modules/" +
      "gamePlanList/components/emptyList/emptyList.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @return {GamePlanListEmptyStateController}
   * @constructor
   */
  function GamePlanListEmptyStateController($controller) {
    $controller("GamePlanListBaseController", {
      vm: this
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan", ["ngLodash"]);
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").component("gamePlanTitle", {
    bindings: {
      gamePlan: "<",
      partner: "<"
    },
    controller: GamePlanTitleController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/gamePlan/components/title/gamePlanTitle.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @return {GamePlanTitleController}
   * @constructor
   */
  function GamePlanTitleController($controller) {
    $controller("GamePlanBaseController", {
      vm: this
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").directive("gamePlanTask", gamePlanTask);

  function gamePlanTask() {
    return {
      restrict: "E",
      templateUrl: "app/shared-components/angular-ui-components/modules/gamePlan/components/task/task.html",
      controller: TaskController,
      scope: {
        fetching: "<",
        task: "<",
        onStateChange: "<",
        extended: "<",
        disabled: "<",
        options: "<"
      },
      replace: true
    };
  }

  /**
   * @ngInject
   * @param $scope
   * @param lodash
   * @param dateTimeService
   * @param GamePlanService
   * @param userService
   * @return {TaskController}
   * @constructor
   */
  function TaskController($scope, lodash, dateTimeService, GamePlanService, userService) {
    this.translateContent = GamePlanService.getTranslatedContent;

    /**
     * Get a class name based on the task status
     * @return {string}
     */
    $scope.getClassName = function () {
      /**
       * @type {string[]}
       */
      var statuses = ["todo", "completed"];

      return [
        statuses[this.task.status],
        this.fetching ? "fetching" : "",
        this.extended ? "extended" : "",
        this.extended ? "x-grow-0" : "x-grow-1",
        this.extended && !this.options.showSeparateMetaViewForMobile ? "x-direction-row" : "",
        this.options.showSeparateMetaViewForMobile ? "flex-direction task-mobile-view" : ""
      ].join(" ");
    };

    /**
     * Get the next state of the task
     * @return {number}
     */
    $scope.getNextState = function () {
      /**
       * @type {number[]}
       */
      var statuses = [0, 1];

      /**
       * @type {number}
       */
      var newIdx = statuses.indexOf(this.task.status) + 1;

      return statuses[newIdx] || lodash.first(statuses);
    };

    /**
     * Get the last modified date of the task
     * @return {string}
     */
    $scope.getLastModifiedDate = function () {
      var date = this.task.status ? this.task.modifiedEpoch : dateTimeService.asEpoch(this.task.dueDateTs);

      /**
       * if the task is pending and the due date has passed then we will show the last updated date
       * or if the task has been completed
       * @type {boolean|*}
       */
      var showLastUpdatedDate = (this.task.status === 0 && !this.isTaskValid()) || this.task.status;

      return date && showLastUpdatedDate
        ? GamePlanService.getTranslatedContent("task", "last-modified", {
            date: dateTimeService.asDateString(date, "DD/MM/YYYY"),
            status: this.task.status
          })
        : "";
    };

    /**
     * Handle click
     * @return {undefined|Promise<any>}
     */
    $scope.handleClick = function () {
      /**
       * if the task is disabled or is being fetched then do nothing
       * otherwise change the state of the task
       */
      return this.disabled || this.fetching
        ? lodash.noop()
        : this.onStateChange(this.task, $scope.getNextState());
    };

    /**
     * Get user info
     */
    $scope.getUserName = function () {
      var user = "";

      if (this.task.assignedTo && userService.users) {
        user = userService.users[this.task.assignedTo];

        if (user) {
          user = lodash.compact([user.givenName, user.surName]).join(" ");
        } else {
          console.error(
            lodash.compact(["User ", this.task.assignedTo, " does not exists in the app"]).join(" ")
          );
        }
      }

      return user;
    };

    /**
     * Format due date
     * @return {*}
     */
    $scope.formatDueDate = function () {
      return dateTimeService.asDateString(dateTimeService.asEpoch(this.task.dueDateTs), "MMM DD, YYYY");
    };

    /**
     * Whether we should display the user name or not
     * @return {boolean}
     */
    $scope.showUserName = function () {
      return this.options.showUser && this.task.assignedTo && !!this.getUserName();
    };

    /**
     * Whether we should display the due date or not
     * @return {boolean}
     */
    $scope.showDueDate = function () {
      return this.options.showDate && this.task.dueDateTs;
    };

    /**
     * Check if the task is valid or not
     * @return {boolean}
     */
    $scope.isTaskValid = function () {
      var now = dateTimeService.asDate(dateTimeService.now());
      var days = dateTimeService.daysBetween(this.task.dueDateTs, now, { useDayOfYear: true });
      var isTaskValid = false;

      if (days > 0) {
        isTaskValid = true;
      }
      return isTaskValid;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").component("gamePlanTaskList", {
    bindings: {
      tasks: "<",
      inline: "<",
      disabled: "<",
      collapsedViewTaskLimit: "<",
      options: "<"
    },
    controller: TaskListController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/gamePlan/components/taskList/taskList.html"
  });

  /**
   * @ngInject
   * @param GamePlanService
   * @param lodash
   * @param EventEmitter
   * @param sessionService
   * @return {TaskListController}
   * @constructor
   */
  function TaskListController(GamePlanService, lodash, EventEmitter, sessionService) {
    /**
     * State to store the expanded state of the list
     * @type {boolean}
     */
    this.expanded = false;
    this.fetching = [];
    this.translateContent = GamePlanService.getTranslatedContent;

    this.$onInit = function() {
      this.options = lodash.assign({}, this.options);
    };

    /**
     * Update the task to a new status
     * @param {{}} task
     * @param {number} nextState
     */
    this.updateTask = function (task, nextState) {
      console.log("Task is updated from", task.status, "to", nextState);

      this.fetching.push(task.id);

      return GamePlanService.updateTask(
        task.gameplanID,
        task.id,
        lodash.assign({}, task, {
          status: nextState
        })
      )
        .then(function () {
          var count = 0;
          /**
           * if it's logged in user task then and only then make a change in game plan counter
           */
          if (task.assignedTo === sessionService.user.id) {
            /**
             *
             * if we move a task in an uncompleted state then we need to increment the gameplan
             * nav count otherwise we need to decrement
             */
            if (nextState === 0) {
              count = 1;
            } else if (nextState === 1) {
              count = -1
            }
            EventEmitter.emit(EventEmitter.events.navigation.updateCount, "game-plan-tasks", count, {
              relative: true
            });
          }

          task.status = nextState;
        })
        .finally(
          function () {
            this.fetching = lodash.without(this.fetching, task.id);
          }.bind(this)
        );
    }.bind(this);

    /**
     * Get some container class names based on the inline variant of the component
     * @return {string}
     */
    this.getClassName = function () {
      return [this.inline ? "x-direction-row" : "x-direction-column", this.inline ? "inline" : ""].join(" ");
    };

    /**
     * Toggle between expanded and collapsed list
     */
    this.toggleShowMore = function () {
      this.expanded = !this.expanded;
    };

    /**
     * Get the limit of the list
     * @return {number}
     */
    this.getListLimit = function () {
      return this.expanded ? this.tasks.length : this.collapsedViewTaskLimit;
    };

    /**
     * Get translated content for show more/show less button
     * @return {string}
     */
    this.getTranslatedContent = function () {
      /**
       * Make a label variant based on the expanded state
       * @type {string}
       */
      var variant = [this.expanded ? "less" : "more", "tasks"].join("-");

      /**
       * Make the meta based on the expanded state
       * @type {object}
       */
      var meta = this.expanded ? {} : { count: this.tasks.length - this.collapsedViewTaskLimit };

      return this.translateContent("label", variant, meta);
    };

    /**
     * Tell if the given task is fetching
     * @param {string} taskID
     * @return {boolean}
     */
    this.isFetching = function (taskID) {
      return this.fetching.indexOf(taskID) > -1;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").component("gamePlanSection", {
    bindings: {
      title: "@",
      inline: "<"
    },
    transclude: true,
    controller: GamePlanSectionController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/gamePlan/components/section/gamePlanSection.html"
  });

  /**
   * @ngInject
   * @return {GamePlanSectionController}
   * @constructor
   */
  function GamePlanSectionController() {
    /**
     * Get a class name based on props
     * @return {string}
     */
    this.getClassName = function () {
      return [this.inline ? "inline" : "", this.inline ? "x-direction-row" : "x-direction-column"].join(" ");
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").component("gamePlanMeta", {
    bindings: {
      title: "<",
      description: "<",
      value: "<",
      numeric: "<"
    },
    controller: GamePlanMetaController,
    templateUrl: "app/shared-components/angular-ui-components/modules/gamePlan/components/meta/meta.html"
  });

  /**
   * @ngInject
   * @return {GamePlanMetaController}
   * @constructor
   */
  function GamePlanMetaController() {
    /**
     * Get class name based on props
     * @return {string}
     */
    this.getClassName = function () {
      return [this.numeric ? "numeric" : ""].join(" ");
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").component("gamePlanGraph", {
    bindings: {
      url: "<"
    },
    templateUrl:
      "app/shared-components/angular-ui-components/modules/gamePlan/components/graph/gamePlanGraph.html"
  });
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").component("gamePlanDescription", {
    bindings: {
      content: "<",
      truncateWordCount: "<"
    },
    controller: GamePlanDescriptionController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/gamePlan/components/description/gamePlanDescription.html"
  });

  /**
   * @ngInject
   * @param lodash
   * @param GamePlanService
   * @return {GamePlanDescriptionController}
   * @constructor
   */
  function GamePlanDescriptionController(lodash, GamePlanService) {
    /**
     * State to store the expanded state of the content
     * @type {boolean}
     */
    this.expanded = false;

    /**
     * Tell whether the text should truncate
     * @return {boolean}
     */
    this.mayTruncate = function () {
      return lodash.words(this.content).length >= this.truncateWordCount;
    };

    /**
     * Get (truncated) content
     * @return {string}
     */
    this.getTruncatedContent = function () {
      return this.expanded ? this.content : lodash.split(this.content, " ", this.truncateWordCount).join(" ");
    };

    /**
     * Get a class name for the container
     * @return {string}
     */
    this.getClassName = function () {
      return [this.mayTruncate() ? "truncated" : ""].join(" ");
    };

    /**
     * Toggle between expanded and short content
     */
    this.toggle = function () {
      this.expanded = !this.expanded;
    };

    /**
     * Get translated button text
     * @return {string}
     */
    this.getButtonText = function () {
      /**
       * Make a label variant based on the expanded state
       * @type {string}
       */
      var variant = ["show", this.expanded ? "less" : "more"].join("-");

      return GamePlanService.getTranslatedContent("label", variant);
    };

    return this;
  }
})();

(function () {
  "use strict";
  angular.module("ctraUIComponents.askIda", ["ngLodash"]);
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.askIda").component("chartDescription", {
    bindings: {
      chart: "<",
      verbose: "<"
    },
    controller: ChartDescriptionController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/askIda/components/chartDescription/chartDescription.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LocoService
   * @param lodash
   * @constructor
   */
  function ChartDescriptionController($controller, LocoService, lodash) {
    /**
     * Inherit from the ask ida controller
     */
    $controller("AskIdaController", {
      vm: this
    });

    /**
     * Get the base description
     * @return {string}
     */
    this.getBaseDescription = function () {
      var key = "ask-ida-answer-title";
      var descriptionParams = this.chart.description;

      return LocoService.translate(key, {
        significant: this.isSignificant(),
        direction: descriptionParams.resultForBehaviour.ValueChangePercentage > 0 ? "up" : "down",
        activity: lodash.toLower(descriptionParams.behaviour)
      });
    };

    /**
     * Get short description
     * @return {string}
     */
    this.getShortDescription = function () {
      var key = "ask-ida-answer-description-short";
      var descriptionParams = this.chart.description;

      /**
       * Format the change properly
       * @type {*|defaultFormatters|{labels, values}}
       */
      var formatter = this.Formatters.get(descriptionParams.behaviour);

      return LocoService.translate(key, {
        significant: this.isSignificant(),
        activity: lodash.toLower(descriptionParams.behaviour),
        changeDelta: formatter.changeDelta(descriptionParams.resultForBehaviour),
        direction: descriptionParams.resultForBehaviour.ValueChangePercentage > 0 ? "up" : "down"
      });
    };

    /**
     * Get extended description
     * @return {string}
     */
    this.getExtendedDescription = function () {
      var key = "ask-ida-answer-description-extended";
      var descriptionParams = this.chart.description;

      /**
       * Format the change properly
       * @type {*|defaultFormatters|{labels, values}}
       */
      var formatter = this.Formatters.get(descriptionParams.behaviour);
      var values = formatter.values(descriptionParams.resultForBehaviour);

      return this.isSignificant()
        ? LocoService.translate(key, {
            activity: lodash.toLower(descriptionParams.behaviour),
            before: formatter.labels(values.before),
            after: formatter.labels(values.after)
          })
        : "";
    };

    /**
     * Tell id the change is significant
     * @return {boolean}
     */
    this.isSignificant = function () {
      return !!this.chart.description.resultForBehaviour.Significant;
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").component("gamePlan", {
    bindings: {
      gamePlan: "<"
    },
    controller: GamePlanController,
    templateUrl: "app/shared-components/angular-ui-components/modules/gamePlan/components/base/gamePlan.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param GamePlanService
   * @param lodash
   * @return {GamePlanController}
   * @constructor
   */
  function GamePlanController($controller, GamePlanService, lodash) {
    $controller("GamePlanBaseController", {
      vm: this
    });

    /**
     * Get gameplan tasks
     * @return {array}
     */
    this.getTasks = lodash.memoize(function() {
      return GamePlanService.getTasks([this.gamePlan]);
    });

    /**
     * get options for task list
     */
    this.getOptions = lodash.memoize(function () {
      return {
        showInlineMobileView: false,
        showUser: true,
        showDate: true,
        showHeader: true,
        /**
         * Adding this option because we have 3 type of views. One is inline, second one is where we show the meta
         * info in a separate line and the third one is the checkboxes one which we show in the gameplane on the
         * gamplan list page
         */
        showSeparateMetaViewForMobile: true
      };
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.askIda").component("askIdaInsight", {
    bindings: {
      idaQuestion: "<"
    },
    controller: AskIdaInsightController,
    templateUrl: "app/shared-components/angular-ui-components/modules/askIda/components/base/base.html"
  });

  /**
   * @ngInject
   * @param appSessionService
   * @param lodash
   * @param toastr
   * @param pageTransitionService
   * @param LocoService
   * @constructor
   */
  function AskIdaInsightController(appSessionService, lodash, toastr, pageTransitionService, LocoService) {
    this.farmName = lodash.get(appSessionService, ["farm", "farmName"], null);

    /**
     * Delete the question
     */
    this.deleteQuestion = function () {
      this.loading = true;

      this.idaQuestion
        .$delete()
        .then(
          function () {
            toastr.success(LocoService.translate("LABEL_TEXT_DELETED"));
            pageTransitionService.goBackward();
            history.back();
          },
          function () {
            toastr.error(LocoService.translate("LABEL_TEXT_OOPS"));
          }
        )
        .finally(
          function () {
            this.loading = false;
          }.bind(this)
        );
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.askIda").component("askIdaHeader", {
    bindings: {
      idaQuestion: "<"
    },
    controller: AskIdaHeaderController,
    templateUrl: "app/shared-components/angular-ui-components/modules/askIda/components/header/header.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param epochsToPeriodStringFilter
   * @param epochToDayStringFilter
   * @param lodash
   * @return {AskIdaHeaderController}
   */
  function AskIdaHeaderController($controller, epochsToPeriodStringFilter, epochToDayStringFilter, lodash) {
    $controller("AskIdaController", {
      vm: this
    });

    /**
     * Get question title
     * @param idaQuestion
     * @return {string}
     */
    this.getQuestionTitle = function (idaQuestion) {
      /**
       * @type {{}}
       */
      var question = idaQuestion.question;

      /**
       * @type {{}}
       */
      var metadata = {};

      /**
       * @type {string}
       */
      metadata.changeFrom = epochToDayStringFilter(question.startEpoch);

      if (question.endEpoch) {
        /**
         * @type {string}
         */
        metadata.changeUntil = epochToDayStringFilter(question.endEpoch);
      }

      /**
       * @type {string}
       */
      metadata.expectBy = epochToDayStringFilter(question.finalEpoch);

      /**
       * Build the changes array
       * @type {string}
       */
      var changes = question.changes.map(
        function (change) {
          return change.change === "other:" ? change.otherChange : this.translateContent(change.change);
        }.bind(this)
      );

      metadata.changed = lodash.join(changes, ", ").replace(/,(?=[^,]*$)/, " &");

      /**
       * Build the effects array
       * @type {any[]}
       */
      var effects = question.effects.map(
        function (effect) {
          return this.translateContent(lodash.get(effect, "effect"));
        }.bind(this)
      );

      /**
       * Build a translated list of expectations
       * @type {string}
       */
      metadata.expected = lodash.join(effects, ", ").replace(/,(?=[^,]*$)/, " &");

      /**
       * cow, farm or herdGroup
       * @type {string}
       */
      metadata.subject = question.subjectType;

      /**
       * Assign cow tag number to metadata if applicable.
       */
      if (metadata.subject === "cow") {
        metadata.cowTagNumber = question.cow.cowTagNumber;
      }

      /**
       * Assign herd group name to metadata if applicable. herdGroup
       */
      if (metadata.subject === "herd group") {
        metadata.subject = lodash.camelCase(metadata.subject);
        metadata.groupName = question.herdGroup.groupName;
      }

      metadata.changeDate = metadata.changeFrom;

      if (question.period) {
        metadata.changeDate = epochsToPeriodStringFilter([question.startEpoch, question.endEpoch]);
      }

      return this.translateContent("question-title", metadata);
    };

    /**
     * create payload for share button component
     * @return {{id: number, farmID: string, type: number}}
     */
    this.getShareData = function () {
      return {
        id: this.idaQuestion.IdaQnAID,
        type: "ask-ida",
        farmID: this.idaQuestion.farmID
      };
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.askIda").component("askIdaChart", {
    bindings: {
      idaQuestion: "<"
    },
    controller: AskIdaChartController,
    templateUrl: "app/shared-components/angular-ui-components/modules/" + "askIda/components/chart/chart.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LocoService
   * @param lodash
   * @param sessionService
   * @return {AskIdaChartController}
   */
  function AskIdaChartController($controller, LocoService, lodash, sessionService) {
    /**
     * Inherit from the ask ida controller
     */
    $controller("AskIdaController", {
      vm: this
    });

    var labels = ["Rumination", "Laying", "Walking", "Eating", "Standing"];
    var lookups = ["Ruminating", "Laying", "Walking", "Eating", "Standing"];
    var manualOrdering = [1, 2, 3, 4, 5];

    if (sessionService.hasRole("AskIdaOnMilkYield")) {
      labels.push("Milk yield");
      lookups.push("MilkYield");
      manualOrdering.push(6);
    }

    /**
     * A list of visualisation defaults made using the above informations
     */
    var visualisationDefaults = lodash.reduce(
      lodash.zip(labels, lookups, manualOrdering),
      function (result, description) {
        var title = description[0];
        var lookup = description[1];
        var order = description[2];

        var behaviour = lodash.lowerCase(title);

        result[lodash.camelCase(behaviour)] = {
          title: LocoService.translate(title),
          behaviour: behaviour,
          description: "",
          behaviours: [lookup],
          charts: [],
          significant: false,
          order: order
        };

        return result;
      },
      {}
    );

    /**
     * Init
     */
    this.$onInit = function () {
      this.initVisualisations();
    };

    /**
     * Initialise graphs for the expected effects
     */
    this.initVisualisations = function () {
      this.visualisations = lodash.orderBy(
        lodash.reduce(
          visualisationDefaults,
          function (res, visualisationSource, key) {
            /**
             * @type {boolean}
             */
            var expected = lodash.some(this.idaQuestion.question.effects, ["effect", key]);

            if (expected) {
              var visualisation = lodash.assign({}, visualisationSource);
              var lookups = visualisation.behaviours;

              lodash.forEach(
                lookups,
                function (behaviour) {
                  var value = lodash.get(this.idaQuestion, ["answer", "Results", behaviour], null);

                  if (value) {
                    var chart = this.getChartFromChange(
                      value,
                      behaviour,
                      visualisation.behaviour === this.idaQuestion.question.effect
                    );

                    visualisation.charts.push(chart);

                    if (value.Significant) {
                      visualisation.significant = true;
                    }
                  } else {
                    visualisation.error = LocoService.translate("no results");
                  }
                }.bind(this)
              );

              res.unshift(visualisation);
            }

            return res;
          }.bind(this),
          []
        ),
        ["significant", "order"],
        ["desc", "asc"]
      );
    };

    /**
     * Create chart object from change
     * @param change
     * @param key
     * @param visible
     * @return {{chartOptions: {tooltips: {callbacks: {label: tooltips.callbacks.label}},
     * scales: {yAxes: *[]}}, visible: *, datasetOverride: [{backgroundColor: [string, string],
     * borderColor: [string, string]}], data: [[*, *]], series: [*], description: {resultForBehaviour: *, behaviour: *},
     * title: *, labels: [*, *], chartColors: [string, string]}}
     */
    this.getChartFromChange = function (change, key, visible) {
      var colors = ["#CCCCCC", "#EE6611"];

      /**
       * @type {{before, after}}
       */
      var values = this.Formatters.get(key).values(change);

      return {
        title: LocoService.translate(key),
        description: {
          resultForBehaviour: change,
          behaviour: key
        },
        labels: [LocoService.translate("Before change"), LocoService.translate("After change")],
        series: [key],
        chartOptions: this.getChartOptions(key),
        chartColors: colors,
        visible: change.Significant || visible,
        data: [[values.before, values.after]],
        datasetOverride: [
          {
            backgroundColor: colors,
            borderColor: colors
          }
        ]
      };
    };

    /**
     * Get chart tooltip
     * @param visualisation
     * @return {string}
     */
    this.getTooltip = function (visualisation) {
      var variant = lodash.toLower(lodash.camelCase(visualisation.behaviour));
      var key = ["ask-ida-chart-tooltip", variant].join("-");
      var translation = LocoService.translate(key);

      return translation === key ? null : translation;
    };

    /**
     * Get chart options for a given key
     * @param {string} key
     * @return {{tooltips: {callbacks: {label: tooltips.callbacks.label}}, scales: {yAxes: *[]}}}
     */
    this.getChartOptions = function (key) {
      var formatter = this.Formatters.get(key);

      return {
        tooltips: {
          callbacks: {
            label: function (value) {
              var labelFormatter = formatter.labels;

              value.yLabel = labelFormatter(value.yLabel, true);

              return value.yLabel;
            }
          }
        },

        scales: {
          yAxes: [
            {
              ticks: {
                fontSize: 10,
                labelString: LocoService.translate("per day"),
                beginAtZero: true,
                callback: function (value) {
                  return formatter.labels(value, true);
                }
              }
            }
          ]
        }
      };
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.askIda").component("askIdaChange", {
    bindings: {
      idaQuestion: "<"
    },
    controller: AskIdaChangeController,
    templateUrl:
      "app/shared-components/angular-ui-components/modules/askIda/components/askIdaChange/askIdaChange.html"
  });

  /**
   * @ngInject
   * @param $controller
   * @param LocoService
   * @param lodash
   * @return {AskIdaController}
   */
  function AskIdaChangeController($controller, LocoService, lodash) {
    $controller("AskIdaController", {
      vm: this
    });

    /**
     * @type {{significant: Array, insignificant: Array}}
     */
    this.expectedChangesResults = {
      significant: [],
      insignificant: []
    };

    this.$onInit = function () {
      if (this.isAnalysed()) {
        this.getExpectedChangesResults(this.idaQuestion);
      }
    };

    /**
     * Get expected change results for the given question
     * @param questionObject
     * @return {{significant: Array, insignificant: Array}}
     */
    this.getExpectedChangesResults = function (questionObject) {
      angular.forEach(
        questionObject.question.effects,
        function (effectObject) {
          /**
           * @type {string}
           */
          var effect = effectObject.effect;

          /**
           * @type {string}
           */
          var answerKey = this.effectMap[effect];

          /**
           * @type {{effect: string, result: *}}
           */
          var change = {
            effect: this.translateContent(effect),
            result: questionObject.answer.Results[answerKey]
          };

          if (change.result) {
            if (change.result.Significant) {
              this.expectedChangesResults.significant.push(change.effect);
            } else {
              this.expectedChangesResults.insignificant.push(change.effect);
            }
          }
        }.bind(this)
      );
    };

    /**
     * get ask ida change description
     * @return {string}
     */
    this.getSummary = function () {
      if (this.isAnalysed()) {
        var significant = lodash
          .join(this.expectedChangesResults.significant, ", ")
          .replace(/,(?=[^,]*$)/, " &");

        var insignificant = lodash
          .join(this.expectedChangesResults.insignificant, ", ")
          .replace(/,(?=[^,]*$)/, " &");

        return this.translateContent("change", {
          significant: lodash.isEmpty(significant) ? null : significant,
          insignificant: lodash.isEmpty(insignificant) ? null : insignificant
        });
      } else {
        return this.translateContent("observing");
      }
    };
  }
})();

(function () {
  "use strict";

  /**
   * A list of possible insight resolutions to chose from.
   * @property {Array} insight
   * @property {Object} resolutions - a list of likely and possible resolutions
   * @property {string} variant - depending on the questionnaire, we may show different UI elements (not in use)
   * @property {Function} resolutionSelected
   */
  angular
    .module("ctraUIComponents.insight.insightChecks")
    .component("resolutionList", {
      bindings: {
        insight: "<",
        resolutions: "<",
        variant: "<",
        resolutionSelected: "&"
      },
      controller: resolutionController,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/insightChecks/" +
        "resolutions/resolutions.html"
    });

  /**
   * Resolution list controller.
   * @param {Object} RESOLUTION_VIEW_VARIANTS - ctraUIComponents.insight.insightChecks.RESOLUTION_VIEW_VARIANTS
   * @ngInject
   */
  function resolutionController (RESOLUTION_VIEW_VARIANTS) {
    var $ctrl = this;

    /**
     * Possible resolution view variants.
     * @type {Object}
     * @memberOf resolutionController
     */
    $ctrl.resolutionViewVariants = RESOLUTION_VIEW_VARIANTS;

    /**
     * Handler to call when the user clicks on a resolution.
     * @memberOf resolutionController
     * @param insightResolution
     */
    $ctrl.onSelectResolution = function (insightResolution) {
      $ctrl.resolutionSelected({
        insightResolution: insightResolution
      });
    };
  }

})();

(function () {
  "use strict";

  /**
   * Stateless question component to display for insight checks.
   * @property {function} optionSelected - event handler to select an option
   * @property {number} value - 0|1|3 as "yes"|"no"|"maybe"
   * @property {string} variant - "compact" or unset
   */
  angular
    .module("ctraUIComponents.insight.insightChecks")
    .component("question", {
      transclude: true,
      bindings: {
        optionSelected: "&",
        value: "<",
        variant: "@"
      },
      controller: questionController,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/insightChecks/" +
        "question/question.html"
    });

  /**
   * Question controller to take care of some className handling.
   * I guess it still qualifies as a pure component? Right?
   * @param {Object} INSIGHT_CHECK_VALUES - ctraUIComponents.insight.insightChecks.INSIGHT_CHECK_VALUES
   * @param lodash
   * @returns {questionController}
   * @ngInject
   */
  function questionController (INSIGHT_CHECK_VALUES, lodash) {
    var $ctrl = this;

    /**
     * Init hook.
     * @type {setClassName}
     * @memberOf questionController
     */
    $ctrl.$onInit = setClassName;

    /**
     * Component change hook.
     * @type {setClassName}
     */
    $ctrl.$onChanges = setClassName;

    /**
     * Handler to call when the user clicks on an option.
     * As passing callbacks down to multiple components do not seem to work, we call the bound function manually.
     * @memberOf questionController
     * @param value
     */
    $ctrl.onSelectOption = function (value) {
      $ctrl.optionSelected({
        value: value
      });
    };

    /**
     * Set the className based on the component value.
     */
    function setClassName () {
      var noValue = lodash.isUndefined($ctrl.value) || $ctrl.value === INSIGHT_CHECK_VALUES.NotSet;

      /**
       * Class name to render on the question component.
       * @memberOf questionController
       * @type {string}
       */
      $ctrl.className = [
        $ctrl.variant,
        noValue ? "unset" : ""
      ].join(" ");
    }

    return this;
  }

})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services
  // TODO: replace $jQuery
  /* global $:false */
  /* eslint-disable angular/angularelement */

  angular
    .module('dairyMonitorAdmin')
    .directive('systemMonitorChild', systemMonitorChild);

  /** @ngInject */
  function systemMonitorChild() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/main/systemMonitorsPanel/systemMonitorParent/systemMonitorChild/systemMonitorChild.html',
      scope: {
        monitor: "=",
        expanded: "=?",
        successThreshold: "=",
        warningThreshold: "="
      },
      controller: systemMonitorChildController,
      replace: true

      // controllerAs: 'vm',
      // bindToController: true
    };

    return directive;

    /** @ngInject */
    function systemMonitorChildController($scope, systemMonitorService, $timeout, $element){
      $scope.expanded = false;
      $scope.loading = true;
      systemMonitorService.getMonitoringStates($scope.monitor.referenceID).then(function(states){
        $scope.monitors = states;
        $scope.loading = false;
      });

      $scope.toggleMonitorDetails = function (){
        $scope.expanded = !$scope.expanded;
        $timeout(function(){ $($element).find('[data-toggle="tooltip"]').tooltip();}, 1);
      };
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.lifeCycle', [
      'ctraUIComponents'
    ]);
}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.lifeCycle')
    .component('lifeCycleDropDown', {
      bindings: {
        title: "@",
        list: "<",
        formData: "=",
        formDataKey: "@"
      },
      templateUrl: 'app/views/hardware/lifeCycle/components/dropDown/dropDown.html'
    });
}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('hardwarePanel', hardwarePanel);

  /** @ngInject */
  function hardwarePanel() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/farms/farm/hardwarePanel/hardwarePanel.html',
      controller: hardwarePanelController,
      replace: true,
      scope: {
        farmId: "="
      }
    };

    return directive;

    /** @ngInject */
    function hardwarePanelController($scope, $window, $state, $log, sysAdminService) {
      var vm = $scope;

      vm.farm;
      vm.baseStations;
      vm.sensors;
      vm.cows;

      vm.farm         = sysAdminService.getFarm(vm.farmId);
      vm.farm.$promise.then(function successCallback() {
        vm.farms      = [vm.farm];
      });

      vm.baseStations = sysAdminService.getBaseStations(vm.farmId);
      vm.baseStations.$promise.then(function successCallback() {
        vm.sensors    = sysAdminService.getSensors(vm.baseStations)
      });

      vm.cows         = sysAdminService.getCows(vm.farmId);


      // vm.$watch('currentListItem', function() {
      //   vm.status = {};
      // });

      // vm.saveBaseStation = function (baseStation) {
      //   vm.status.saving = true;
      //   vm.status.saved = false;
      //   vm.status.failed = false;
      //
      //   baseStation.$update().then(function(){
      //     vm.status.saving = false;
      //     vm.status.saved  = true;
      //   }, function(){
      //     vm.status.saving = false;
      //     vm.status.failed = true;
      //   });
      // }

      vm.baseStationAdded = function (baseStation) {
        vm.baseStations.push(baseStation);
        vm.showForm = '';
      }

      vm.sensorAdded = function (sensors) {
        angular.forEach(sensors, function (sensor) {
          vm.sensors.push(sensor);
        });
        vm.showForm = '';
      }


    } /* function hardwarePanelController() */
  }
})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('livestockPanel', livestockPanel);

  /** @ngInject */
  function livestockPanel() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/farms/farm/livestockPanel/livestockPanel.html',
      controller: livestockPanelController,
      replace: true,
      scope: {
        farmId: "="
      }
    };

    return directive;

    /** @ngInject */
    function livestockPanelController($scope, $window, $state, $log, sysAdminService) {
      var vm = $scope;

      vm.farm;
      vm.baseStations;
      vm.sensors;
      vm.herdGroups;
      vm.cows;

      vm.farm         = sysAdminService.getFarm(vm.farmId);
      vm.farm.$promise.then(function successCallback() {
        vm.farms      = [vm.farm];
      });

      vm.baseStations = sysAdminService.getBaseStations(vm.farmId);
      vm.baseStations.$promise.then(function successCallback() {
        vm.sensors    = sysAdminService.getSensors(vm.baseStations)
      });

      vm.cows         = sysAdminService.getCows(vm.farmId);
      vm.herdGroups   = sysAdminService.getHerdGroups(vm.farmId);


      // vm.$watch('currentListItem', function() {
      //   vm.status = {};
      // });

      // vm.saveBaseStation = function (baseStation) {
      //   vm.status.saving = true;
      //   vm.status.saved = false;
      //   vm.status.failed = false;
      //
      //   baseStation.$update().then(function(){
      //     vm.status.saving = false;
      //     vm.status.saved  = true;
      //   }, function(){
      //     vm.status.saving = false;
      //     vm.status.failed = true;
      //   });
      // }

      vm.herdGroupAdded = function (herdGroup) {
        vm.herdGroups.push(herdGroup);
      }

      vm.cowAdded = function (cows) {
        angular.forEach(cows, function (cow) {
          vm.cows.push(cow);
        });
        vm.showForm = '';
      }


    } /* function livestockPanelController() */
  }
})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('farmDetailsPanel', farmDetailsPanel);

  /** @ngInject */
  function farmDetailsPanel() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/farms/farm/farmDetailsPanel/farmDetailsPanel.html',
      controller: farmDetailsPanelController,
      scope: {
        farm: "="
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function farmDetailsPanelController($scope, $log, sysAdminService) {
      var vm = $scope;
      vm.status = {};

      vm.customers = sysAdminService.getCustomers();

      vm.updateFarm = function ( ){
        vm.status.saving = true;
        vm.status.saved = false;
        vm.status.failed = false;


        vm.farm.$update().then(function successCallback(){

          vm.status.saving = false;
          vm.status.saved = true;

        },function errorCallback(){

          $log.error("Saving obj failed");
          vm.status.saving = false;
          vm.status.failed = true;

        });
      }

    }// function farmDetailsPanelController()
  }
})();

(function() {
  'use strict';

  angular
    .module('ctraDataVisualisations', [
      'ctraUIComponents',
      //'ctraDataVisualisations.insightsList',
      'ctraDataVisualisations.dataVisualisation',
      'ctraDataVisualisations.dataVariables',
      'angular-inview',
      'rt.debounce']);

})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services
  // TODO: replace $jQuery
  /* global $:false */
  /* global d3:false */
  /* eslint-disable angular/angularelement */
  /* eslint-disable no-mixed-spaces-and-tabs */

  angular
    .module('ctraDataVisualisations')
    .directive('insightsTimelineChart', insightsTimelineChart);

  /** @ngInject */
  function insightsTimelineChart() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/shared-components/angular-data-visualisations/components/insightsTimeline/insightsTimelineChart/insightsTimelineChart.html',
      controller: insightsTimelineChartController,
      scope: {
        reportData:      '<',
        startDate:       '<',
        endDate:         '<',
        timeMarkers:     '<',
        options:         '<',
        queryChanged:    '&',

        farms:              '=',
        cows:               '=',
        dayRange:           '=',
        showXAxis:          "=",
        currentInsight:     "="
      },
      replace: true
      // controllerAs: 'vm',
      // bindToController: true
    };

    return directive;

    /** @ngInject */
    function insightsTimelineChartController($rootScope, $http, $scope, $window, $log, $element) {
      var vm = $scope;

      var self = this;
      self.farmLanes   = vm.farms;

      self.expandedLane = null;

      vm.closeInsight = function () {
        vm.currentInsight = null;
      }
      vm.insightUpdated = function () {
        self.drawInsightsTimeline();
      }

      vm.showRefreshButton = false;

      vm.$watchGroup(['startDate', 'endDate', 'reportData'], function(newVar, oldVar){
        if(newVar && newVar !== oldVar){
          self.drawInsightsTimeline();
        }
      });


      this.drawInsightsTimeline = function(){

        var margin               = {top: 0, right: 0, bottom: 0, left: 0};

        var mainLaneHeight       = 60,
            mainInsightGroupSize = 30,
            mainInsightSize      = 25,
            mainTimelineHeight   = 30,
            mainHeight           = self.farmLanes.length * mainLaneHeight + mainTimelineHeight+5;

        var miniLaneHeight       = 20,
            miniTimelineHeight   = 25,
            miniHeight           = self.farmLanes.length * miniLaneHeight + miniTimelineHeight;

        if(!vm.zoomable){
            miniHeight           = 0
        }

        var width                = $($element).width() - margin.right - margin.left,
      			height               =  mainHeight + miniHeight;


    		//scales
        var x1 = d3.scale.linear()
    				.range([0, width]);
        var x1b = d3.scale.linear()
    				.range([0, width]);

        var mainXAxisScale = d3.time.scale().range([0, width]);
        var mainXAxis = d3.svg.axis().scale(mainXAxisScale)
            .orient("top").ticks(width/60);

    		var yMainLanes = d3.scale.linear()
    				.domain([0, self.farmLanes.length])
    				.range([0, self.farmLanes.length * mainLaneHeight]);

        var radiusMainInsightGroups = d3.scale.linear()
    				.domain([0, 1])
    				.range([5, mainInsightGroupSize/2]);

        var radiusMainInsights = d3.scale.linear()
    				.domain([3, 1])
    				.range([5, mainInsightSize/2]);



        // The main chart
    		self.chart = d3.select($($element).find('#insightsTimelineChart')[0]).html('')
					.append("svg")
					.attr("width", width + margin.right + margin.left)
					.attr("height", height+ margin.top + margin.bottom)
					.attr("class", "chart");



        var pad = function(num, size) {
            var s = "000000000" + num;
            return s.substr(s.length-size);
        };



        var tooltip = d3.select(".insightsTimelineChartTooltip");
        if(!tooltip[0] || !tooltip[0][0]){
          tooltip = d3.select("body").append('div')
            .attr("class", "tooltip right insightsTimelineChartTooltip")
            .style("opacity", 0);

          tooltip.html("<div class='tooltip-arrow'></div><div class='tooltip-inner'></div>");
        }

        self.showTooltip = function(d) {
          tooltip.transition()
            .duration(200)
            .style("display", 'block')
            .style("opacity", .9);

          var date = new Date(d.insightStartEpoch*1000);

          tooltip.style("left", (d3.event.pageX + 0) + "px")
            .style("top", (d3.event.pageY - 13) + "px")
            .select('.tooltip-inner').html("<strong>Cow: "+d.dairyCowIDs+"</strong> <small class='gray'>" + pad(date.getHours(),2)+':'+pad(date.getMinutes(),2)+':'+pad(date.getSeconds(),2) + "</small>");
        }

        self.hideTooltip = function() {
          tooltip.transition()
            .duration(500)
            .style("opacity", 0)
            .style("display", 'none');
        }


        var infoBox = d3.select(".insightsTimelineChartInfoBox");
        if(!infoBox[0] || !infoBox[0][0]){
          infoBox = d3.select("body").append('div')
            .attr("class", "tooltip tooltip-light top insightsTimelineChartInfoBox")
            .style("opacity", 0);

          infoBox.html("<div class='tooltip-arrow'></div><div class='tooltip-inner'></div>");
        }

        self.showInfoBox = function(d) {

          var date = new Date(d.insight.insightStartEpoch*1000);

          var cows = vm.cows.filter(function (thisCow) {
            return thisCow.DairyCowID === parseInt(d.insight.cowID);
          })

          var cow = (cows[0] ? cows[0] : null)

          if(!cow) return false;

          var insightDescriptionsText = "";

          angular.forEach(d.insight.insightDescription.split(", "), function (value) {
            insightDescriptionsText = insightDescriptionsText+value+"<br>"
          });

          var infoBoxInner = ""+
                              "<h5><strong>Cow: #"+cow.cowTagNumber+"</strong></h5> "+
                              "<p><strong>"+d.insight.insightTitle+"</strong><p>"+
                              "<p>Node ID: <code>#"+cow.nodeID+"</code></br>"+
                              "Probability: "+(Math.round(d.insight.insightProbability*100))+"%</br>"+
                              "Data Quality: "+(Math.round(d.insight.dataQuality*100))+"%</br>"+
                              "Insight Model: "+d.insight.insightModel+"<p>"+
                              "<div class='text-right'><small class='gray'>" + date.getDate() + "/" + (date.getMonth()+1) + "/" + date.getFullYear() + " @ " + pad(date.getHours(),2)+':'+pad(date.getMinutes(),2)+':'+pad(date.getSeconds(),2) + "</small></div>";

          infoBox.select('.tooltip-inner').html(infoBoxInner);
          infoBox.style("opacity", 1).style("display", 'block')
            .style("left",  "0px")
            .style("top", "0px");
        }

        self.moveInfoBox = function() {
          var e = d3.event;
            infoBox.style("left", (e.pageX - infoBox.node().getBoundingClientRect().width/2) + "px")
              .style("top", (e.pageY - infoBox.node().getBoundingClientRect().height-0) + "px").style("opacity", 1)
        }

        self.hideInfoBox = function() {
            infoBox.style("opacity", 0)
              .style("display", 'none');

        }

        // MAIN is the zoomed area
        self.main = self.chart.append("g")
          .attr("transform", "translate(" + margin.left + "," + 0 + ")")
          .attr("width", width)
          .attr("height", mainHeight)
          .attr("class", "main");



        if(vm.showXAxis){
          self.main.append("g")            // Add the X Axis
            .attr("class", "x axis")
            .attr("transform", "translate(0,"+mainTimelineHeight+")")
            .call(mainXAxis);
        }


    		//main self.farmLanes and texts
    		self.mainLanesContainer = self.main.append("g")
          .attr("transform", "translate(0," + (mainTimelineHeight) + ")")
          .attr("width", width)
          .attr("height", mainHeight)
          .attr("class", "main-lanes");

        // Create clipping mask for the zoomed ares
        self.mainLanesContainer.append("defs").append("clipPath")
          .attr("id", "clip")
          .append("rect")
          .attr("width", width)
          .attr("height", mainHeight);

        self.mainLanesContext = self.mainLanesContainer.append("g");

        self.mainLanesInsights = self.mainLanesContainer.append("g")
          .attr("clip-path", "url(#clip)");


        self.expandLines = function(){

          self.chart.transition().duration(300).attr("height", height + margin.top + margin.bottom + self.expandedLane.insightsHeight)


          self.mainLanesContainer.selectAll(".lane").transition().duration(300).attr("transform", function(d, i){
            var moveY = 0;
            if(self.expandedLane && d.farmID > self.expandedLane.farmID){
              moveY = self.expandedLane.insightsHeight;
            }

            return "translate(0," + (yMainLanes(i)+moveY) + ")";


          });

        }

        self.collapseLines = function(){

          self.chart.transition().delay(500).duration(300).attr("height", height + margin.top + margin.bottom);


          self.mainLanesContainer.selectAll(".lane").transition().delay(500).duration(300).attr("transform", function(d, i){
            return "translate(0," + (yMainLanes(i)) + ")";
          });

        }


    		self.drawMainTimeline = function(){

          var minExtent = parseInt(vm.startDate.getTime()/1000);
          var maxExtent = parseInt(vm.endDate.getTime()/1000);



          mainXAxisScale.domain([new Date(minExtent*1000), new Date(maxExtent*1000)]);
          x1.domain([minExtent, maxExtent]);
          x1b.domain([0, maxExtent-minExtent]);

          if(vm.showXAxis){
            self.main.select(".x.axis").call(mainXAxis);
          }





          var lanes = self.mainLanesContainer.selectAll(".lane")
      			.data(vm.reportData, function(d) { return d.farm.FarmID; });

          lanes.exit().remove();


    			var lanesNew = lanes.enter()
            .append("g")
            .attr("class", "lane")
            .attr("transform", function(d, i){ return "translate(0," + yMainLanes(i) + ")"})

          lanesNew.append("line")
      			.attr("x1", 0)
      			.attr("y1", function() {return yMainLanes(0.5);})
      			.attr("x2", width)
      			.attr("y2", function() {return yMainLanes(0.5);})
            .attr("stroke", "lightgray")
            .attr("stroke-width", "3px")
            .attr("stroke-linecap", "round");


      		// lanesNew.append("text")
      		// 	.text(function(d) {return d.farm.farmName;})
      		// 	.attr("x", -10)
      		// 	.attr("y", function() {return yMainLanes(0.5);})
      		// 	.attr("dy", ".5ex")
      		// 	.attr("text-anchor", "end")
      		// 	.attr("class", "laneText");


          lanes = self.mainLanesContainer.selectAll(".lane")

            var mainInsightGroups = lanes.selectAll(".insight-group")
              .data(function(d){ return d.insightGroups },  function(d) { return d.epoch; });

            var mainInsightGroupsNew = mainInsightGroups.enter()
              .append("g")
              .attr("class", "insight-group")
              .attr("transform", function(d){return "translate("+x1(d.epoch)+","+yMainLanes(0.5)+")"})
              .on("mouseover", function (d) {
                if(d.insights.length > 1){
                  self.expandedLane = {farmID: d.farmID, insightsHeight: (radiusMainInsightGroups(2.5)+radiusMainInsightGroups((d.insights.length-1)*3))};

                  d3.select(this).selectAll(".connection-line")
                    .transition().duration(300)
                    .attr("y2", radiusMainInsightGroups(2.5)+radiusMainInsightGroups((d.insights.length-1)*3))
                    .attr("opacity", 1);

                  d3.select(this).selectAll(".insights")
                    .transition().duration(300)
                    .attr("display", "none")
                    .delay(100)
                    .attr("opacity", 1)
                    .attr("display", "block");


                  d3.select(this).selectAll(".insight")
                    .transition().duration(300)
                    .attr("transform", function(d, i){return "translate(0,"+(radiusMainInsightGroups(2.5)+radiusMainInsightGroups(i*3))+")"})
                      .attr("display", "block")
                      .selectAll("text")
                      .attr("display", "block");

                  self.expandLines();
                }
              })
              .on("mouseout", function (d) {
                if(d.insights.length > 1){
                  self.expandedLane = null;

                  d3.select(this).selectAll(".connection-line")
                    .transition().delay(500).duration(300)
                    .attr("y2", 0)
                    .attr("opacity", 0);

                  d3.select(this).selectAll(".insights")
                    .transition().delay(500).duration(300)
                    .attr("opacity", 0);

                  d3.select(this).selectAll(".insight")
                    .transition().delay(500).duration(300)
                    .attr("transform", "translate(0,0)")
                      .selectAll("text")
                      .attr("display", "none");

                  self.collapseLines();

                }

              });


            mainInsightGroupsNew.append("line")
              .attr("class", "connection-line")
              .attr("x1", 0)
              .attr("y1", 0)
              .attr("x2", 0)
              .attr("y2", 0)
              .attr("stroke", "lightgray")
              .attr("stroke-width", "3px")
              .attr("stroke-linecap", "round")
              .attr("opacity", 0);

            mainInsightGroupsNew.append("circle")
              .attr("r", function () { return radiusMainInsightGroups(1); })
              .attr("display", function(d) { return (d.insights.length > 1 ? "block" : "none")});

            mainInsightGroupsNew.append("text")
              .attr("y", "4")
              .attr("text-anchor", "middle")
              .text(function(d){ return d.insights.length; })
              .attr("display", function(d) { return (d.insights.length > 1 ? "block" : "none")});

            mainInsightGroupsNew.append("g")
              .attr("class", "insights")
              .attr("display", function(d) { return (d.insights.length > 1 ? "none" : "block")});

      		  mainInsightGroups.exit().remove();


          var mainInsights = mainInsightGroups.select(".insights").selectAll(".insights .insight")
            .data(function(d){ return d.insights },  function(d) { return d.insight.GenericInsightID; });

          var mainInsightsNew = mainInsights.enter()
            .append("g")
            .attr("class", function (d) {
              var r = "insight "+(d.validations[0] && d.validations[0].confirmed === "invalid" ? 'insight-invalid' : '')

              if(!d.insight.isActive){
                r += " insight-inactive";
              }
              return r;
            })
            .attr("transform", "translate(0,0)")
            .on("mouseover", self.showInfoBox)
            .on("mouseout", self.hideInfoBox)
            .on("mousemove", self.moveInfoBox)
            .on("click", function (d) {
                if(vm.currentInsight !== d){
                  vm.currentInsight = d;
                  vm.$apply();
                }else{
                  vm.closeInsight();
                }
              });



          mainInsightsNew.append("circle")
    				.attr("class", function(d) {return "insight-bubble fill" + d.insight.insightType})
            .attr("r", function () {  return radiusMainInsights(1);}) //return radiusMainInsights(d.insight.insightPriority); })



          mainInsightsNew.append("image")
           .attr("xlink:href", function (d) { return "assets/images/icon-"+d.insight.insightType+".svg"})
           .attr('width', function () { return radiusMainInsights(1); /*radiusMainInsights(d.insightPriority);*/ })
           .attr('height', function () { return radiusMainInsights(1); /*radiusMainInsights(d.insightPriority);*/ })
           .attr("x", function () { return "-"+radiusMainInsights(1)/2; /*radiusMainInsights(d.insightPriority)/2;*/})
           .attr("y", function () { return "-"+radiusMainInsights(1)/2; /*radiusMainInsights(d.insightPriority)/2;*/ });

         mainInsightsNew.append("circle")
   				.attr("class", function(d) { if(d.validations[0]){ return "validation-bubble fill-"+d.validations[0].confirmed}else{ return "validation-bubble" }})
           .attr("r", function () {  return radiusMainInsights(3);}) //return radiusMainInsights(d.insight.insightPriority); })
           .attr("cx", function () { return radiusMainInsights(1)/1.1; /*radiusMainInsights(d.insightPriority)/2;*/})
           .attr("cy", function () { return -radiusMainInsights(1)/1.3; /*radiusMainInsights(d.insightPriority)/2;*/ });


          mainInsightsNew.append("text")
            .attr("x", function () { return radiusMainInsights(1);}) //return radiusMainInsights(d.insight.insightPriority)+5})
            .attr("y", function () { return radiusMainInsights(1);}) //return radiusMainInsights(d.insight.insightPriority)-2})
            .attr("dy", -7)
            .attr("dx", 2)
            .text(function(d){
              var cows = vm.cows.filter(function (thisCow) {
                return thisCow.DairyCowID === parseInt(d.insight.cowID);
              })

              var cow = (cows[0] ? cows[0] : null)
              if(cow){
                return " #"+cow.cowTagNumber;
              }
              return "unknown";
            })
            .attr("display", "none");


    		  mainInsights.exit().remove();
        }



        self.drawMainTimeline();


      };
      this.drawInsightsTimeline();
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.utils", [
      "ngLodash"
    ]);
})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular.module("ctraUIComponents.utils").service("EventEmitter", EventEmitter);

  /**
   * Event emitting functionality based on root scope
   * @ngInject
   * @param lodash
   * @param $rootScope
   * @return {EventEmitter}
   * @constructor
   */
  function EventEmitter(lodash, $rootScope) {
    /**
     * All events which get dispatched
     * @type {{navigation: {updateCount: string, stateChangeStart: string}, sensors: {mappingCompleted: string}}}
     */
    this.events = {
      navigation: {
        stateChangeStart: "$stateChangeStart",
        updateCount: "navigation/update-count"
      },
      sensors: {
        mappingCompleted: "sensors/mapping-completed"
      }
    };

    /**
     * Subscribe
     * @param {string} event
     * @param {function(): *} handler
     */
    this.on = function (event, handler) {
      $rootScope.$on(
        "$destroy",
        $rootScope.$on(event, function () {
          /**
           * @type {*[]}
           */
          var args = [].slice.call(arguments, 1);

          handler.apply(null, args);
        })
      );
    };

    /**
     * Emit an event
     */
    this.emit = function (/* event */) {
      $rootScope.$emit.apply($rootScope, arguments);
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.sharing").service("SharingService", SharingService);

  /**
   * RegExp to detect mobile browsers
   * @type {RegExp}
   * @private
   */
  var _mobileRx =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i;

  /**
   * RegExp to detect mobile browsers
   * @type {RegExp}
   * @private
   */
  var _mobileRx2 =
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;

  /**
   * RegExp for detecting Internet Explorer
   * @type {RegExp}
   * @private
   */
  var _msIERx = /MSIE \d|Trident.*rv:/;

  /**
   * Sharing domain
   * @type {string}
   * @private
   */
  var _shareDomain = "https://share.ida.io";

  /**
   * @ngInject
   * @param $window
   * @param $httpParamSerializer
   * @param MEDIUMS
   * @param $http
   * @param lodash
   * @param toastr
   * @param LocoService
   * @param insightService
   * @param INSIGHT_CATEGORIES
   * @constructor
   */
  function SharingService(
    $window,
    $httpParamSerializer,
    MEDIUMS,
    $http,
    lodash,
    toastr,
    LocoService,
    insightService,
    INSIGHT_CATEGORIES
  ) {
    /**
     * Tell whether the current browser runs on a mobile device
     * @return {boolean}
     */
    this.isMobile = function () {
      /**
       * @type {string}
       */
      var agent = navigator.userAgent || navigator.vendor || $window.opera;

      return _mobileRx.test(agent) || _mobileRx2.test(agent.substr(0, 4));
    };

    /**
     * Tell whether the current browser is IE
     * @return {boolean}
     */
    this.isMSIE = function () {
      return _msIERx.test(navigator.userAgent);
    };

    /**
     * Tell whether native share may be used
     * @return {boolean}
     */
    this.mayUseNativeShare = function () {
      return lodash.isFunction(navigator.share);
    };

    /**
     * Upload a screenshot to the server
     * @param {{ name: string, image: string }} data
     * @return {HttpPromise}
     */
    this.upload = function (data) {
      /**
       * @type {{method: string, data: {name: string, image: string}, url: string}}
       */
      var req = {
        method: "POST",
        url: _shareDomain + "/upload",
        data: data
      };

      return $http(req);
    };

    /**
     * Share a screenshot using the native share functionality
     * @param {string} title
     * @param {{ name: string, image: string, url: string }} screenshot
     * @param {{ utm_source: string }} params
     */
    this.shareViaNative = function (title, screenshot, params) {
      /**
       * @type {string}
       */
      var url = _shareDomain + "/" + screenshot.name + ".png";

      /**
       * @type {string}
       */
      var query = $httpParamSerializer(
        lodash.assign(
          {
            utm_medium: "native"
          },
          params || {}
        )
      );

      navigator.share({
        title: title,
        url: [url, query].join("?")
      });
    };

    /**
     * Share a screenshot via WhatsApp
     * @param {{ url: string, image: string, name: string }} screenshot
     * @param {{ utm_source: string }} params
     * @private
     */
    this._shareViaWhatsApp = function (screenshot, params) {
      /**
       * @type {string}
       */
      var url = "whatsapp://send";

      /**
       * @type {string}
       */
      var query = $httpParamSerializer({
        text: [
          screenshot.url,
          $httpParamSerializer(
            lodash.assign(
              {
                utm_medium: lodash.toLower(MEDIUMS.whatsapp)
              },
              params || {}
            )
          )
        ].join("?")
      });

      if (!this.isMobile()) {
        $window.alert(this.getTranslatedContent("alert", "whatsapp"));
      } else {
        $window.open([url, query].join("?"), "_blank");
      }
    };

    /**
     * Share a screenshot via email
     * @param {{ url: string, image: string, name: string }} screenshot
     * @param {{ utm_source: string }} params
     * @private
     */
    this._shareViaEmail = function (screenshot, params) {
      /**
       * @type {string}
       */
      var query = $httpParamSerializer(
        lodash.assign(
          {
            utm_medium: MEDIUMS.email
          },
          params || {}
        )
      );

      $window.open("mailto:?&body=" + encodeURIComponent([screenshot.url, query].join("?")));
    };

    /**
     * Share a screenshot via copy-to-clipboard
     * @param {{ url: string, image: string, name: string }} screenshot
     * @param {{ utm_source: string }} params
     * @private
     */
    this._shareViaCopy = function (screenshot, params) {
      $window.copyToClipboard(this.getShareURL(screenshot, params));

      /**
       * Notify the user that the link is successfully copied
       */
      toastr.success(this.getTranslatedContent("notification", "link-copied"));
    };

    /**
     * Get a default share URL from the given screenshot
     * @param {{ url: string, image: string, name: string }} screenshot
     * @param {{ utm_source: string }} params
     */
    this.getShareURL = function (screenshot, params) {
      /**
       * @type {string}
       */
      var query = $httpParamSerializer(
        lodash.assign(
          {
            utm_medium: "url"
          },
          params || {}
        )
      );

      return [screenshot.url, query].join("?");
    };

    /**
     * Share a screenshot
     * @param {{ name: string, url: string, image: string }} screenshot
     * @param {string} medium
     * @param {{ utm_source: string }} params
     */
    this.shareScreenshot = function (screenshot, medium, params) {
      /**
       * Local function name to call
       * @type {string}
       */
      var fnName = "_shareVia" + lodash.upperFirst(medium);

      if (lodash.isFunction(this[fnName])) {
        this[fnName](screenshot, params);
      } else {
        throw new Error("Unknown medium `" + medium + "`.");
      }
    };

    /**
     * Translate component text
     * @param {string} variant
     * @param {string} suffix
     * @param {{}} [context]
     * @return {string}
     */
    this.getTranslatedContent = function (variant, suffix, context) {
      return LocoService.translate("sharing", variant, suffix, context || {});
    };

    /**
     * Get type of an insight
     * this function is only for representational purposes and not standard naming
     * @param insight
     */
    this.getInsightType = function (insight) {
      var category = insight.insightType.insightCategory;
      var typeName = insight.insightType.typeName;
      var scope = insight.insightScope;

      var type = null;

      if (scope === "farm") {
        type = "farm";
      } else if (
        category === "fertility" &&
        lodash.includes(INSIGHT_CATEGORIES.cycleAlertWorkflow, typeName)
      ) {
        type = "non-cyclic";
      } else if (category === "fertility") {
        type = "insemination";
      } else if (category === "health") {
        type = "health";
      }

      return type;
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.sharing")
    .controller("SharingController", SharingController);

  /**
   * @ngInject
   * @param vm
   * @param LocoService
   * @param $q
   * @param MEDIUMS
   * @param lodash
   * @param SharingService
   * @param toastr
   * @constructor
   */
  function SharingController (vm, LocoService, $q, MEDIUMS, lodash, SharingService, toastr) {
    /**
     * @type {boolean}
     * @private
     */
    var _takingScreenshot = false;

    /**
     * Expose mediums to be used in templating
     */
    vm.MEDIUMS = MEDIUMS;

    /**
     * Get target element
     */
    vm.getTarget = lodash.memoize(function () {
      return document.getElementById(vm.target);
    });

    /**
     * Update the target component class name
     * @param {boolean} toggle
     */
    vm.updateTarget = function (toggle) {
      /**
       * @type {boolean}
       */
      var condition = lodash.isBoolean(toggle) ? toggle : vm.isTakingScreenshot();

      /**
       * @type {string}
       */
      var action = condition ? "add" : "remove";

      vm.getTarget().classList[action]("taking-screenshot");
    };

    /**
     * Resolve a filename
     */
    vm.resolveFileName = function () {
      throw new Error("Implement `resolveFileName` in subclass.");
    };

    /**
     * Set "taking screenshot" state
     * @param to
     */
    vm.setTakingScreenshot = function (to) {
      _takingScreenshot = !!to;
    };

    /**
     * Tell whether we are taking a screenshot
     * @return {boolean}
     */
    vm.isTakingScreenshot = function () {
      return _takingScreenshot;
    };

    /**
     * Take a screenshot and upload it to the server
     * @return {Promise}
     */
    vm.takeScreenshot = lodash.memoize(function () {
      var deferred = $q.defer();
      var filename = vm.resolveFileName();

      /**
       * Prepare the screenshot object
       * @type {{image: null, name: null, url: null}}
       */
      var screenshot = {
        name: filename,
        image: null,
        url: null
      };

      /**
       * Set loading
       */
      vm.setTakingScreenshot(true);

      /**
       * Flash the ribbon for html2canvas
       */
      vm.updateTarget(true);

      html2canvas(vm.getTarget(), {
        allowTaint: true,
        useCORS: true
      }).then(function (canvas) {
        screenshot.image = canvas.toDataURL("image/png");

        SharingService.upload(screenshot).then(function (response) {
          screenshot.url = response.data.url;

          deferred.resolve(screenshot);
        }, function () {
          toastr.error(LocoService.translate("LABEL_TEXT_OOPS"));

          deferred.reject("Could not upload the screenshot");
        }).finally(function () {
          vm.setTakingScreenshot(false);
        });
      });

      /**
       * Remove the ribbon from view
       */
      vm.updateTarget(false);

      return deferred.promise;
    });

    /**
     * Download the given screenshot
     * @param {{name: string, image: string, url: string}} screenshot
     */
    vm.downloadScreenshot = function (screenshot) {
      /**
       * Create an empty link
       * @type {HTMLAnchorElement}
       */
      var link = document.createElement("a");

      document.body.appendChild(link);

      /**
       * @type {string}
       */
      link.download = screenshot.name;

      /**
       * @type {string}
       */
      link.href = screenshot.url;

      /**
       * @type {string}
       */
      link.target = "_blank";

      link.click();
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.sensor", [
      "ngLodash"
    ]);
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.sensor").service("sensorService", sensorService);

  /**
   * @param appConfig
   * @param $window
   * @param $odata
   * @param $odataresource
   * @param $q
   * @param $http
   * @param $log
   * @param baseStationService
   * @ngInject
   */
  function sensorService(appConfig, $window, $odata, $odataresource, $q, $http, $log, baseStationService) {
    var self = this;

    /**
     * Sensors endpoint
     */
    var Sensor = $odataresource(
      appConfig.APIURL + "odata/DairyMonitors",
      {},
      {},
      {
        odatakey: "NodeID"
      }
    );

    /**
     * Get all sensors
     * @return {*}
     */
    self.getSensors = function () {
      var deferred = $q.defer();

      if (!self.sensors) {
        var predicates = [];

        baseStationService.getBaseStations().$promise.then(function (baseStations) {
          angular.forEach(baseStations, function (value) {
            predicates.push(new $odata.Predicate("baseStationID", value.BaseStationID));
          });

          $log.info("Fetching DairyMonitors from the database");

          var query = Sensor.odata();

          query.select([
            "NodeID",
            "deviceSerialNum",
            "shortSerialNum",
            "deviceDMLastPingTime",
            "baseStationID",
            "deviceState",
            "lifeCycleState"
          ]);

          if (predicates.length) {
            query.filter($odata.Predicate.or(predicates));
            self.sensors = query.query();

            self.sensors.$promise.then(
              function () {
                deferred.resolve(self.sensors);
              },
              function errorCallback(error) {
                deferred.reject(error);
              }
            );
          } else {
            self.sensors = [];
            deferred.resolve(self.sensors);
          }
        });
      } else {
        deferred.resolve(self.sensors);
      }

      return deferred.promise;
    };

    /**
     * Get sensor by ID
     * @param nodeID
     * @return {*}
     */
    self.getSensor = function (nodeID) {
      var deferred = $q.defer();

      nodeID = parseInt(nodeID) || null;

      var sensor = self.sensors
        ? self.sensors.find(function (e) {
            return e.NodeID === nodeID;
          })
        : false;

      if (sensor) {
        deferred.resolve(sensor);
      } else {
        Sensor.odata()
          .filter("NodeID", nodeID)
          .single()
          .$promise.then(
            function (value) {
              deferred.resolve(value);
            },
            function (error) {
              deferred.reject(error);
            }
          );

        $log.info("Fetching DairyMonitor from the database", nodeID);
      }
      return deferred.promise;
    };

    /**
     * Create new sensor
     * @param sensorDetails
     * @param addToGlobalArray
     * @return {*}
     */
    self.newSensor = function (sensorDetails, addToGlobalArray) {
      var sensor = new Sensor();

      angular.forEach(
        sensorDetails,
        function (value, key) {
          this[key] = value;
        },
        sensor
      );

      $log.info("Currently setting the deviceDMLastEvent to Online when creating a new Sensor");
      sensor.deviceDMLastEvent = "Online";

      var promise = sensor.$save();

      promise.then(
        function (data) {
          sensor.NodeID = data.NodeID;
          if (addToGlobalArray) {
            self.sensors.push(sensor);
          }
        },
        function () {
          $window.alert("Error! Something went wrong adding the sensor, please try again later");
        }
      );

      return promise;
    };

    /**
     * Set a new node id on the given cow
     * @param {number} dairyCowID
     * @param {number} nodeID
     * @return {Promise}
     * @todo this is already cleaned up, just write unit tests
     */
    this.changeDairyMonitorToCow = function (dairyCowID, nodeID) {
      /**
       * @type {string}
       */
      var api = appConfig.APIURL + "odata/ChangeDairyMonitorNode";

      /**
       * @type {string}
       */
      var params = "(dairyCowID=" + dairyCowID + ",newNodeID=" + nodeID + ")";

      /**
       * @type {string}
       */
      var url = api + params;

      return $http({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json"
        }
      });
    };

    /**
     * Unlink the given cow from its sensor
     * @param {{ nodeID, DairyCowID, watchEnabled }} cow
     * @return {Promise}
     * @todo this is already cleaned up, just write unit tests
     */
    this.unpairSensor = function (cow) {
      /**
       * @type {Promise}
       */
      var dfd = this.changeDairyMonitorToCow(cow.DairyCowID, 0);

      dfd.then(
        function () {
          /**
           * Set node id to null
           * @type {null}
           */
          cow.nodeID = null;

          /**
           * Turn off "watch enabled"
           * @type {boolean}
           */
          cow.watchEnabled = false;
        }.bind(this)
      );

      return dfd;
    };

    /**
     * Pairs a sensor to the cow
     * @param {{ nodeID, watchEnabled, $update, DairyCowID }} cow
     * @param {number} nodeID
     */
    this.pairSensor = function (cow, nodeID) {
      if (cow.nodeID) {
        throw new Error("The cow already has a sensor, you need to unpair that first.");
      } else {
        cow.nodeID = nodeID;
        cow.watchEnabled = true;

        this.changeDairyMonitorToCow(cow.DairyCowID, nodeID);
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.odataUtils", [
    "ngLodash"
  ]);
}());

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular.module("ctraUIComponents.odataUtils").service("OdataService", OdataService);

  /**
   * Odata service for manipulating oData queries
   * @ngInject
   * @param lodash
   * @param $odata
   * @return {OdataService}
   * @constructor
   */
  function OdataService(lodash, $odata) {
    /**
     * Bulk-expand an odata query without repeating "expend" all the time
     * @param {{}} query
     * @param {string[]} withKeys
     * @return {*}
     */
    this.expand = function (query, withKeys) {
      return withKeys.reduce(function (query, key) {
        return query.expand(key);
      }, query);
    };

    /**
     * Filter the query
     * @param {{}} query
     * @param {string} filterName
     * @param {string} condition
     * * @param {string|string[]} values
     * @param {"and"|"or"|null} operator
     * @return {{}}
     */
    this.filter = function (query, filterName, condition, values, operator) {
      if (arguments.length < 5) {
        throw new Error("An argument is missing.");
      }

      if (lodash.isArray(values)) {
        var predicates = values.map(function (value) {
          return new $odata.Predicate(filterName, condition, value);
        });

        query.filter($odata.Predicate[operator](predicates));
      } else {
        query.filter(filterName, condition, values);
      }

      return query;
    };

    /**
     * Filters for a given validation value
     * @param {{}} query
     * @param {"any"|"all"} func
     * @param {string} condition
     * @param {string} key
     * @param {string|string[]} values
     * @param {"and"|"or"|null} operator
     * @param {{ enum: boolean, allowEmpty: boolean }} options
     * @return {*}
     */
    this.filterValidations = function (query, func, key, condition, values, operator, options) {
      var predicate;

      options = lodash.assign(
        {
          enum: false
        },
        options || {}
      );

      if (arguments.length < 7) {
        throw new Error("An argument is missing.");
      }

      /**
       * Use this predicate to ignore any validation made by Admin.
       * This way only user validations matching the criteria will be included in the results.
       */
      var nonAdminValidation = new $odata.Predicate("validation/validationByID", "ne", "Admin");

      if (lodash.isArray(values)) {
        var conditions = values.map(function (value) {
          return new $odata.Predicate.and([
            nonAdminValidation,
            new $odata.Predicate(
              "validation/" + key,
              condition,
              options.enum ? new $odata.Property(value) : value
            )
          ]);
        });

        predicate = $odata.Predicate[operator](conditions);
      } else {
        predicate = new $odata.Predicate.and([
          nonAdminValidation,
          new $odata.Predicate(
            "validation/" + key,
            condition,
            options.enum ? new $odata.Property(values) : values
          )
        ]);
      }

      var lambda = new $odata.Func(func, "insightValidations", "validation", predicate);

      if (options.allowEmpty) {
        /**
         * Here we wiretap the `execute` function of an odata filter to
         * inject a literal query value to the end query. The injected
         * "not insightValidations/any()" means that an empty
         * insightValidation list ([]) will also fulfill the conditions.
         */
        query.filter({
          execute: function () {
            return ["(", [lambda.execute(), "or", "not insightValidations/any()"].join(" "), ")"].join("");
          }
        });
      } else {
        query.filter(lambda);
      }

      return query;
    };

    /**
     * Expect the given key to not be NULL
     * @param {{}} query
     * @param {string} key
     * @return {{}}
     */
    this.notNull = function (query, key) {
      query.filter(key, "ne", null);

      return query;
    };

    /**
     * Create a filter for JSON string
     * @param {{}} query
     * @param {string} key
     * @param {string} value
     * @param {boolean} expectation
     * @param {"and"|"or"} operator
     * @return {{}}
     * @private
     */
    function _getJSONFilters(query, key, value, expectation, operator) {
      var filter;

      if (lodash.isArray(value)) {
        var predicates = value.map(function (v) {
          return new $odata.Predicate(new $odata.Func("contains", key, v), "eq", expectation);
        });

        filter = new $odata.Predicate[operator](predicates);
      } else {
        filter = new $odata.Predicate(new $odata.Func("contains", key, value), "eq", expectation);
      }

      return filter;
    }

    /**
     * Filter in stringified JSON values
     * @param {{}} query
     * @param {string} key
     * @param {string} value
     * @param {"and"|"or"} operator
     * @return {{}}
     */
    this.inJSON = function (query, key, value, operator) {
      var filter = _getJSONFilters(query, key, value, true, operator);

      query.filter(filter);

      return query;
    };

    /**
     * Filter in stringified JSON values
     * @param {{}} query
     * @param {string} key
     * @param {string} value
     * @param {{ nullable: boolean }} options
     * @return {{}}
     */
    this.notInJSON = function (query, key, value, options) {
      options = lodash.assign(
        {
          nullable: false
        },
        options || {}
      );

      var filter = _getJSONFilters(query, key, value, false, "and");

      if (options.nullable) {
        filter = new $odata.Predicate.or([new $odata.Predicate(key, "eq", null), filter]);
      } else {
        query = this.notNull(query, key);
      }

      query.filter(filter);

      return query;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.modal")
    .controller("ModalBaseController", ModalBaseController);

  /**
   * Base controller for generic insights
   * @ngInject
   * @param vm
   * @constructor
   */
  function ModalBaseController (vm) {
    /**
     * Smoke test the component
     * @return {boolean}
     */
    vm.smokes = function () {
      return false;
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.loco", [
    "ngLodash",
    "pascalprecht.translate"
  ]);
}());

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.loco")
    .service("LocoService", LocoService);

  /**
   * Localise.biz functionality
   * @ngInject
   * @param lodash
   * @param $translate
   * @param appSessionService
   * @return {LocoService}
   * @constructor
   */
  function LocoService (lodash, $translate, appSessionService) {
    /**
     * Make a copy key by joining all the given string arguments
     * @return {string}
     */
    this.makeCopyKey = function () {
      /**
       * @type {string[]}
       */
      var args = lodash.compact(lodash.filter([].slice.apply(arguments), lodash.isString));

      return args.join("-");
    };

    /**
     * Generate a copy key and translate it with the given context
     * @return {string|Object|{}}
     */
    this.translate = function () {
      /**
       * @type {string}
       */
      var copyKey = this.makeCopyKey.apply(this, arguments);

      /**
       * @type {{}[]}
       */
      var contextArgs = lodash.compact(lodash.filter([].slice.apply(arguments), lodash.isObject));

      /**
       * Context
       * @type {{}}
       */
      var context = contextArgs.reduce(function (ctx, item) {
        return lodash.assign(ctx, item);
      }, {});

      return $translate.instant(copyKey, lodash.assign({
        unitSystem: lodash.get(appSessionService, ["localization", "unitSystem"], "SI")
      }, context), "messageformat");
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.loco")
    .factory("locoLoader", translateFactory);

  /**
   * @ngInject
   * @param $q
   * @param $http
   * @return {function(*): *}
   */
  function translateFactory ($q, $http) {
    var url = "https://translate.connecterra.workers.dev/";

    return function (options) {
      return $http(angular.extend({
        url: [url, "?lang=", options.key].join(""),
        method: "GET",
        simple: true
      }, options.$http)).then(function (result) {
        return result.data;
      }, function () {
        return $q.reject(options.key);
      });
    };
  }

})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .service("ValidationService", ValidationService);

  /**
   * Insight validation service
   * @ngInject
   * @param lodash
   * @param $odataresource
   * @param appConfig
   * @param VALIDATION_VALUES
   * @param sessionService
   * @param dateTimeService
   * @param LocoService
   * @param $window
   * @param $q
   * @return {ValidationService}
   */
  function ValidationService(
    lodash,
    $odataresource,
    appConfig,
    VALIDATION_VALUES,
    sessionService,
    dateTimeService,
    LocoService,
    $window,
    $q
  ) {
    /**
     * Smoke test
     * @return {boolean}
     */
    this.smokes = function () {
      return false;
    };

    /**
     * Insight validation oData resource
     */
    var InsightValidation = $odataresource(
      appConfig.APIURL + "odata/InsightValidations",
      {},
      {},
      {
        odatakey: "InsightValidationID"
      }
    );

    /**
     * Fetch insight validations
     * @param genericInsightID
     */
    this.fetchInsightValidations = function (genericInsightID) {
      if (!genericInsightID) {
        throw new Error("I need a `genericInsightID` to fetch insight validations for.");
      }

      return InsightValidation.odata().filter("genericInsightID", parseInt(genericInsightID)).query()
        .$promise;
    };

    /**
     * Create a new validation object from the given values
     * @param {{ genericInsightID: number }} values
     * @return {{}}
     */
    this.createValidation = function (values) {
      if (!values.genericInsightID) {
        throw new Error("You need to pass `genericInsightID` in `values` to create a new validation.");
      }

      /**
       * @type {{validationByID: string, validation: string}}
       */
      var details = lodash.assign(
        {
          validationByID: sessionService.user.id,
          validation: VALIDATION_VALUES.noAnswer
        },
        values
      );

      /**
       * Create a new insight validation object
       */
      var insightValidation = new InsightValidation();

      angular.forEach(
        details,
        function (value, key) {
          this[key] = value;
        },
        insightValidation
      );

      return insightValidation;
    };

    /**
     * Tell whether the validation matches the given value
     * @param {{ validation: string }} insightValidation
     * @param {string} value
     * @return {boolean}
     */
    this.matchesValidation = function (insightValidation, value) {
      return lodash.get(insightValidation, ["validation"]) === VALIDATION_VALUES[value];
    };

    /**
     * Tell if the insight is validated as any of the given values
     * @param {{ validation: string }} insightValidation
     * @return {boolean}
     */
    this.validatedAs = function (insightValidation) {
      var args = [].slice.call(arguments, 1);

      return args.reduce(
        function (matches, value) {
          return matches || this.matchesValidation(insightValidation, value);
        }.bind(this),
        false
      );
    };

    /**
     * Tell whether a user validation is not the same as the current user
     * @param validation
     * @return {boolean}
     */
    this.isValidatedByOthers = function (validation) {
      return validation.validationByID !== sessionService.user.id;
    };

    /**
     * Updates an insight validation (whether by creating a new entry in the DB or updating the existing one)
     * @param {{ InsightValidationID?, validation, validationByID, validationEpoch }} insightValidation
     * @param {"yes"|"no"|"NA"} value
     * @param {{ toggles: boolean }} options
     * @return {Promise}
     */
    this.updateValidation = function (insightValidation, value, options) {
      options = lodash.assign(
        {
          toggles: true
        },
        options || {}
      );

      /**
       * Tell whether we need to create a new validation or update an existing one
       * @type {boolean}
       */
      var createsNewValidation = !insightValidation.InsightValidationID;

      /**
       * Existing validation value
       * @type {string}
       */
      var existingValidationValue = insightValidation.validation;

      /**
       * Get the real value of the validation
       * @type {string}
       */
      var newValidationValue = VALIDATION_VALUES[value];

      /**
       * Tell whether we should toggle the validation off
       * @type {boolean}
       */
      var togglesOff = newValidationValue === existingValidationValue;

      /**
       * @type {boolean}
       */
      var validatedByOthers = this.isValidatedByOthers(insightValidation);

      /**
       * Tell whether the user needs to confirm the new validation
       * @type {boolean}
       */
      var needConfirmationFromUser =
        !!existingValidationValue &&
        existingValidationValue !== VALIDATION_VALUES.noAnswer &&
        validatedByOthers;

      /**
       * @todo rename copy key
       * @type {string}
       */
      var confirmationMessage = LocoService.translate("INSIGHT_CHANGE_VALIDATION_CONFIRMATION");

      if (needConfirmationFromUser && !$window.confirm(confirmationMessage)) {
        throw new Error("The user has not confirmed this action.");
      }

      if (togglesOff && !options.toggles) {
        /**
         * If toggling is disabled, we do not update the validation,
         * just return an empty, resolved promise.
         */
        var dfd = $q.defer();

        dfd.resolve(insightValidation);

        return dfd.promise;
      } else {
        /**
         * Set the new validation value
         */
        insightValidation.validation = togglesOff ? VALIDATION_VALUES.noAnswer : newValidationValue;

        /**
         * Set as if it was validated by the logged in user.
         */
        insightValidation.validationByID = sessionService.user.id;

        /**
         * Set new epoch on validation.
         * @type {number}
         */
        insightValidation.validationEpoch = dateTimeService.now();

        return createsNewValidation ? insightValidation.$save() : insightValidation.$update();
      }
    };

    /**
     * Make a copy key for the given insight type name, variant and suffix
     * @param {{ insightType: { typeName: string }}} insight
     * @param {string} variant
     * @param {string} [suffix]
     * @return {string}
     */
    this.getCopyKey = function (insight, variant, suffix) {
      /**
       * @type {string}
       */
      var typeName = insight.insightType.typeName;

      return LocoService.makeCopyKey("insight-validation", variant, typeName, suffix);
    };

    /**
     * Resolves any validation conflict in the insight
     * @param {{ InsightValidationID: number, validationByID: string }[]} validationList
     * @return {{ InsightValidationID: number, validationByID: string }[]}
     */
    this.resolveValidationConflicts = function (validationList) {
      var dysonPrefix = "Dyson-";
      var nonAdmin = lodash.reject(validationList, ["validationByID", "Admin"]);
      var sorted = lodash.sortBy(nonAdmin, "InsightValidationID");

      var userValidations = lodash.reject(sorted, function (v) {
        return lodash.startsWith(v.validationByID, dysonPrefix);
      });

      var conflict = !!userValidations.length && userValidations.length !== nonAdmin.length;

      return conflict ? userValidations : sorted;
    }

    /**
     * Picks the validation value from a list of validations
     * @param {{ InsightValidationID: number, validationByID: string }[]} insightValidations
     * @return {string}
     */
    this.pickValidationValue = function (insightValidations) {
      var clean = this.resolveValidationConflicts(insightValidations);

      return lodash.get(lodash.first(clean), ["validation"], VALIDATION_VALUES.noAnswer);
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .controller("InsightValidationBaseController", InsightValidationBaseController);

  /**
   * Base controller for insight validation
   * @ngInject
   * @param vm
   * @param lodash
   * @param ValidationService
   * @param VALIDATION_VALUES
   * @param dateTimeService
   * @param GenericInsightService
   * @param $q
   * @param $controller
   * @constructor
   */
  function InsightValidationBaseController (vm, lodash, ValidationService, VALIDATION_VALUES, dateTimeService,
                                            GenericInsightService, $q, $controller) {
    /**
     * Inherit from LoadingController
     */
    $controller("LoaderController", {
      vm: vm
    });

    /**
     * Smoke test the component
     * @return {boolean}
     */
    vm.smokes = function () {
      return false;
    };

    /**
     * Fetch insight validations
     * @return {PromiseLike<any> | Promise<any> | *}
     */
    vm.fetchValidations = function () {
      return ValidationService.fetchInsightValidations(vm.insight.GenericInsightID)
        .then(vm.processValidations);
    };

    /**
     * Process insight validations and pick the right one
     * @param {{ InsightValidationID: number }[]} validations
     */
    vm.processValidations = function (validations) {
      /**
       * Sort validations, newer comes first
       * @type {[]}
       */
      var sorted = validations.sort(function (a, b) {
        return a.InsightValidationID < b.InsightValidationID ? -1 : 1;
      });

      /**
       * Set the insight validation as the newest, non-admin validation.
       * @type {{}}
       */
      var cherryPicked = sorted.find(function (validation) {
        return validation.validationByID !== "Admin";
      });

      /**
       * @type {{}}
       */
      vm.insightValidation = cherryPicked || ValidationService.createValidation({
        genericInsightID: vm.insight.GenericInsightID
      });
    };

    /**
     * Tell whether the insight is validated as the given value
     * @param value
     * @return {boolean}
     */
    vm.isValidated = function (value) {
      return ValidationService.validatedAs.apply(ValidationService, [
        vm.insightValidation,
        value
      ]);
    };

    /**
     * Tell if the insight is validated as the given value (or not answered yet)
     * @param {string} value
     * @return {boolean}
     */
    vm.maybeValidated = function (value) {
      return ValidationService.validatedAs.apply(ValidationService, [
        vm.insightValidation,
        "noAnswer",
        value
      ]);
    };

    /**
     * Validate insight
     * @param {"yes"|"no"|"noAnswer"} value
     * @param {{ toggles: boolean }} options
     */
    vm.validate = function (value, options) {
      options = lodash.assign({
        toggles: true
      }, options || {});

      return ValidationService.updateValidation(vm.insightValidation, value, options).then(function () {
        /**
         * Update the internal "insightValid" value of the insight
         * @todo think of moving this to a service
         * @todo think of pushing the new insight validation object to insight.insightValidations
         * @type {"Yes"|"No"|"NA"}
         */
        vm.insight.insightValid = VALIDATION_VALUES[value];
      });
    };

    /**
     * Chain a bunch of promises into each other.
     * If any argument is an array of promises, then we consider it a q.all.
     * @return {Promise<any>}
     */
    vm.chain = function () {
      /**
       * Get the promises by converting all the arguments.
       */
      var calls = lodash.compact([].slice.call(arguments));

      vm.setLoading(true);

      /**
       * Start with the first item, then go to the next, etc.
       * If it detects an array, it wraps it in $q.all
       */
      var final = calls.reduce(function (chain, call) {
        var promise = lodash.isArray(call) ? $q.all(call) : call;

        if (chain) {
          return chain.then(promise);
        } else {
          return promise;
        }
      }, null);

      return final.finally(function() {
        vm.setLoading(false);
      });
    };
  }
})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightResolution")
    .service("insightResolutionService", ResolutionService);

  /**
   * Insight resolution service
   * @ngInject
   * @return {ResolutionService}
   */
  function ResolutionService (lodash, legacyInsightResolutionService) {
    /**
     * Inherit from the legacy service until we move all the functionality over
     */
    angular.extend(ResolutionService.prototype, legacyInsightResolutionService);

    /**
     * Smoke test
     * @return {boolean}
     */
    this.smokes = function () {
      return false;
    };

    /**
     * Tell whether the insight is resolved as ALL of the passed resolutions
     * @param {{ insightResolution: {}[] }} insight
     * @return {boolean}
     */
    this.isResolved = function (insight) {
      /**
       * @type {boolean}
       */
      var resolved = false;

      /**
       * @type {string[]}
       */
      var resolutionsToMatch = [].slice.call(arguments, 1);

      if (insight.insightResolution && insight.insightResolution.length) {
        if (resolutionsToMatch.length) {
          resolved = resolutionsToMatch.reduce(function (result, resolution) {
            return result && lodash.find(insight.insightResolution, { id: resolution });
          }, true);
        } else {
          resolved = true;
        }
      }

      return resolved;
    };

    /**
     * Tell what resolutions has been removed or added
     * @param {string[]} previousResolutionIds
     * @param {string[]} newResolutionIds
     * @return {{removed: string[], added: string[]}}
     */
    this.diff = function (previousResolutionIds, newResolutionIds) {
      /**
       * @type {{removed: [], added: []}}
       */
      var diff = {
        added: [],
        removed: []
      };

      if (previousResolutionIds.length) {
        if (newResolutionIds.length) {
          diff.removed = lodash.difference(previousResolutionIds, newResolutionIds);
          diff.added = lodash.difference(newResolutionIds, previousResolutionIds);
        } else {
          diff.removed = previousResolutionIds;
        }
      } else {
        diff.added = newResolutionIds;
      }

      return diff;
    };

    /**
     * Get a resolution by its id
     * @param {string} id
     */
    this.getResolution = function (id) {
      return lodash.find(this.getResolutions(), ["id", id]);
    };

    /**
     * Check if a resolution is present in the resolutions array
     * @param {array} resolutions
     * @param {string} id
     * @return {boolean}
     */
    this.hasResolution = function(resolutions, id) {
      return lodash.find(resolutions, ["id", id]);
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightResolution")
    .controller("InsightResolutionBaseController", InsightResolutionBaseController);

  /**
   * Base controller for insight resolutions
   * @ngInject
   * @param vm
   * @param insightResolutionService
   * @param $q
   * @param lodash
   * @param GenericInsightService
   * @constructor
   */
  function InsightResolutionBaseController(vm, insightResolutionService, $q, lodash, GenericInsightService) {
    /**
     * Smoke test the component
     * @return {boolean}
     */
    vm.smokes = function () {
      return false;
    };

    /**
     * Tell whether the insight is resolved as one or more of the passed resolutions
     * @return {boolean}
     */
    vm.isResolved = function () {
      /**
       * @type {string[]}
       */
      var resolutions = [].slice.call(arguments);

      return insightResolutionService.isResolved.apply(null, lodash.concat(vm.insight, resolutions));
    };

    /**
     * Resolve the insight with the given ID
     * @param resolutionId
     * @param {{overwrite: boolean}} options
     * @return {Promise}
     */
    vm.resolve = function (resolutionId, options) {
      options = lodash.assign(
        {
          overwrite: false
        },
        options || {}
      );

      /**
       * @type {{}}
       */
      var resolution = insightResolutionService.getResolution(resolutionId);

      /**
       * @type {{}[]}
       */
      var existingResolutions = lodash.get(vm.insight, ["insightResolution"], []);

      return vm.updateInsightResolution(
        options.overwrite ? [resolution] : lodash.concat(existingResolutions, resolution)
      );
    };

    /**
     * Update insight resolutions
     * @param {{}[]} insightResolution
     * @return {Promise}
     */
    vm.updateInsightResolution = function (insightResolution) {
      vm.insight.insightResolution = insightResolution;

      /**
       * Save the resolutions in the BE as well
       */
      return GenericInsightService.updateInsight(vm.insight);
    };

    /**
     * Remove insight resolutions
     * @return {Promise}
     */
    vm.removeResolutions = function () {
      vm.insight.insightResolution = [];

      /**
       * Save the resolutions in the BE as well
       */
      return GenericInsightService.updateInsight(vm.insight);
    };

    vm.removeResolutionByID = function (resolutionId) {
      vm.insight.insightResolution = vm.insight.insightResolution.filter(function (resolution) {
        return resolution.id !== resolutionId;
      });

      /**
       * Save the resolutions in the BE as well
       */
      return GenericInsightService.updateInsight(vm.insight);
    };
  }
})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").service("InsightListService", InsightListService);

  /**
   * Insight list service
   * @ngInject
   * @param $log
   * @param lodash
   * @param GenericInsightService
   * @param sessionService
   * @return {InsightListService}
   * @constructor
   */
  function InsightListService($log, lodash, GenericInsightService, sessionService) {
    /**
     * Local state to store insight lists
     * @type {{[string]: GenericInsightID[]}}
     * @private
     */
    this._referenceLists = {};

    /**
     * Local state used to find which insight belongs to which reference list
     * @type {{}}
     * @private
     */
    this._referenceListLookups = {};

    /**
     * Find the insight list which the given insight belongs to
     * @param genericInsightID
     * @private
     */
    this._findList = function (genericInsightID) {
      var pointer = this._referenceListLookups[genericInsightID];
      var listName = lodash.first(pointer);

      return lodash.flatten(this._referenceLists[listName]);
    };

    /**
     * Move the pointer in a reference list to a given direction and return its value
     * @param genericInsightID
     * @param direction
     * @private
     */
    this._advance = function (genericInsightID, direction) {
      var list = this._findList(genericInsightID);

      if (list) {
        var pointer = list.indexOf(genericInsightID);
        var newPosition = pointer + direction;

        return pointer > -1 && newPosition >= 0 ? list[newPosition] : null;
      }

      return null;
    };

    /**
     * Fill in the references using the insights lists passed to this function
     * @param {string} ref
     * @param {number} index
     */
    this.addToReference = function (ref, index /** , GenericInsight[], GenericInsight[], ... */) {
      /**
       * Set the default reference index to 0, this will tell where the list content shall be inserted
       * @type {number}
       */
      index = !index || isNaN(index) ? 0 : index;

      /**
       * Pick the insight lists from the arguments
       * @type {(GenericInsight[])[]}
       */
      var insightLists = [].slice.call(arguments, 2);

      /**
       * Make a list of duplicate-free concatenated insight ids
       * @type {GenericInsightID[]}
       */
      var ids = lodash.uniq(
        lodash.reduce(
          insightLists,
          function (result, list) {
            return lodash.concat(result, lodash.map(list, "GenericInsightID"));
          },
          lodash.get(this._referenceLists, [ref, index]) || []
        )
      );

      /**
       * Backreference the id to its list
       */
      ids.forEach(
        function (id) {
          this._referenceListLookups[id] = [ref, index];
        }.bind(this)
      );

      lodash.set(this._referenceLists, [ref, index], ids);

      $log.debug(
        "[INSIGHT LISTS] insights",
        ids,
        "are added to reference",
        ref,
        "at index",
        index,
        this._referenceLists
      );
    };

    /**
     * Get the previous insight id
     * @param genericInsightID
     */
    this.getPreviousInsightID = function (genericInsightID) {
      return this._advance(genericInsightID, -1);
    };

    /**
     * Get the next insight id
     * @param genericInsightID
     */
    this.getNextInsightID = function (genericInsightID) {
      return this._advance(genericInsightID, 1);
    };

    /**
     * Mark the given insights as seen
     * @param insights
     * @return Promise<any>
     * @todo move it to GenericInsightService
     */
    this.markAsSeen = function (insights) {
      var userID = sessionService.user.id;

      var validAndUnseen = lodash.overEvery([
        lodash.negate(GenericInsightService.isSeen),
        lodash.negate(GenericInsightService.hasExpired)
      ]);

      /**
       * Collect the unseen insights
       * @type {{}[]|*}
       */
      var unseenInsights = GenericInsightService.collect(insights, validAndUnseen, [
        "GenericInsightID",
        "seenByUserIds"
      ]);

      userID = userID + ",";

      lodash.each(unseenInsights, function (insight) {
        insight.seenByUserIds = lodash.isNil(insight.seenByUserIds) ? userID : insight.seenByUserIds + userID;
      });

      /**
       * Batch update the list
       * @todo may need to be updated this when the new API is in place
       */
      return GenericInsightService.batchUpdate(unseenInsights, "seenByUserIds");
    };

    return this;
  }
})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").service("healthInsightService", healthInsightService);

  function healthInsightService(herdGroupService, lodash, GenericInsightService) {
    /**
     * Lucina priority cut off
     * @type {{high: number, low: number, medium: number}}
     */
    var lucinaCutOff = {
      high: 0.9,
      low: 0.8
    };

    /**
     * health priority cut off
     * @type {{high: number, low: number, medium: number}}
     */
    var healthCutOffs = {
      high: 0.3,
      low: 0.17
    };

    /**
     * Sort health insights
     * @param insights
     * @return {[]}
     */
    this.sortByDate = lodash.memoize(function (insights) {
      return lodash.orderBy(
        insights,
        [
          function (insight) {
            return parseInt(insight.startEpoch);
          }
        ],
        ["desc"]
      );
    });

    /**
     * Sort all the herd insight on the basis of herd group value
     * @param insights
     * @return []
     */
    this.sortByGroup = lodash.memoize(function (insights) {
      return herdGroupService.sortGroupsfilter(insights, { groupName: "dairyCow.groupName" });
    });

    /**
     * Sort all the insights on the basis of dim value
     * @param insights
     * @return []
     */
    this.sortByDIM = lodash.memoize(function (insights) {
      return lodash.orderBy(
        insights,
        function (insight) {
          var dim = 0;

          if (insight.dairyCow.lastCalvingEpoch !== 0) {
            dim = GenericInsightService.getDIM(insight, { useFallback: true });
          }
          return dim;
        }.bind(this),
        ["asc"]
      );
    });

    /**
     * get lucina insight priority value
     * @param insight
     * @return {number}
     */
    this.getLucinaPriorityValue = function (insight) {
      return lodash.get(
        lodash.last(lodash.get(angular.fromJson(insight.insightMetadata), "outputs")),
        "probabilities.sick"
      );
    };

    /**
     * get health insight priority value
     * @param insight
     * @return {number}
     */
    this.getHealthInsightPriorityValue = function (insight) {
      var score = lodash.last(lodash.get(angular.fromJson(insight.insightMetadata), "scores"));

      if (!score) {
        console.error(insight, "metadata scores could not be resolved");
      }

      return score ? score.msrl : void 0;
    };

    /**
     * Get priority values of an insight based on it's typeName
     * @param insight
     * @return {number}
     */
    this.getPriorityValue = lodash.memoize(
      function (insight) {
        var priorityValue = null;
        var insightTypeName = GenericInsightService.getTypeName(insight);

        if (insightTypeName === "Lucina") {
          priorityValue = this.getLucinaPriorityValue(insight);
        } else if (insightTypeName === "HealthInsight") {
          priorityValue = this.getHealthInsightPriorityValue(insight);
        } else if (insightTypeName === "ObviousHealthInsight") {
          priorityValue = Infinity;
        } else {
          throw insightTypeName + " is not supported";
        }

        return priorityValue;
      }.bind(this)
    );

    /**
     * get priority depending on the priority value
     * @param insightTypeName
     * @param priorityValue
     * @return {string}
     */
    this.getPriority = lodash.memoize(function (insightTypeName, priorityValue) {
      var getPriorityType = {
        healthInsight: function (priority) {
          if (priority > healthCutOffs.high) {
            return "high";
          } else if (priority >= healthCutOffs.low && priority <= healthCutOffs.high) {
            return "medium";
          } else if (priority < healthCutOffs.low) {
            return "low";
          }
          throw new Error("Send correct priority value to get the priority");
        },
        obviousHealthInsight: function () {
          return "high";
        },
        lucina: function (priority) {
          if (priority >= lucinaCutOff.high) {
            return "high";
          } else if (priority >= lucinaCutOff.low && priority < lucinaCutOff.high) {
            return "medium";
          } else if (priority < lucinaCutOff.low) {
            return "low";
          }
          throw new Error("Send correct priority value to get the priority");
        }
      };

      return getPriorityType[lodash.camelCase(insightTypeName)](priorityValue);
    });

    /**
     * Lodash merge customizer
     * @param objValue
     * @param srcValue
     * @return {*}
     * @private
     */
    function _customizer(objValue, srcValue) {
      if (lodash.isArray(objValue)) {
        return objValue.concat(srcValue);
      }
    }

    /**
     * group all the insights by priority
     * @param insights
     * @return {{high: [], medium: [], low: []}}
     */
    this.groupInsightsByPriority = lodash.memoize(
      function (insights) {
        /**
         * Pre-group insights. If they have no metadata, some basic rule apply.
         * @type {{ high: *, medium: *, ungrouped: * }}
         */
        var preProcessed = lodash.groupBy(insights, function (insight) {
          var metadata = angular.fromJson(insight.insightMetadata);

          if (lodash.isEmpty(metadata)) {
            return insight.insightType.typeName === "ObviousHealthInsight" ? "high" : "medium";
          }

          return "ungrouped";
        });

        /**
         * Group the insights into high, medium and low
         * @type {{ high: *, medium: *, low: * }}
         */
        var insightsByPriority = lodash.groupBy(
          preProcessed.ungrouped,
          function (insight) {
            var priorityValue = this.getPriorityValue(insight);
            var insightType = GenericInsightService.getTypeName(insight);

            return this.getPriority(insightType, priorityValue);
          }.bind(this)
        );

        return lodash.mergeWith(insightsByPriority, lodash.omit(preProcessed, "ungrouped"), _customizer);
      }.bind(this)
    );

    /**
     * Sort all the insights by the priority score assigned to them
     * @param {array} insights
     * @return {array}
     */
    this.sortInsightsByPriority = lodash.memoize(
      function (insights) {
        return lodash.orderBy(
          insights,
          [
            function (insight) {
              return this.getPriorityValue(insight);
            }.bind(this)
          ],
          ["desc"]
        );
      }.bind(this)
    );

    /**
     * Sort insights by priority
     * @param {array} insights
     */
    this.sortByPriority = lodash.memoize(
      function (insights) {
        if (insights.length) {
          var grouped = this.groupInsightsByPriority(insights);
          var sorted = lodash.mapValues(grouped, this.sortInsightsByPriority);

          insights = lodash.compact(lodash.concat(sorted.high, sorted.medium, sorted.low));
        }

        return insights;
      }.bind(this)
    );
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insightList")
    .controller("MissingEstrusController", MissingEstrusController);

  /**
   * Missing Estrus Controller
   * @ngInject
   * @param vm
   * @param lodash
   * @param insightService
   * @constructor
   */
  function MissingEstrusController (vm, lodash, insightService) {
    /**
     * Get "days in milk" column width class name
     * @return {string}
     */
    vm.getDIMColumnClassName = function () {
      /**
       * Default width of column
       * @type {number}
       */
      var width = 6;

      if (vm.herdList.length) {
        width -= 3;
      }

      if (vm.validationWidget) {
        width -= 1;
      }

      return ["col-xs-", width].join("");
    };

    /**
     * Get cow column width
     * @param insight
     * @return {string}
     */
    vm.getClassNamesForCowColumn = function (insight) {
      var options = lodash.assign(
        {
          addBadgeSpace: !vm.herdList.length
        },
        options
      );

      return vm.resolveClassName(insight, 2, options);
    };

    /**
     * Update minssing estrus insight
     * @param insight
     * @param params
     */
    vm.updateInsight = function (insight, params) {
      if (lodash.has(params, "valid")) {
        /**
         * @type {boolean|null}
         */
        var approved = insight.approved === params.valid ? null : params.valid;

        insightService.logFromWorkflow(insight, approved);
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").controller("ListEntryController", ListEntryController);

  /**
   * Base controller for insight list entries
   * @ngInject
   * @param vm
   * @param GenericInsightService
   * @param lodash
   * @param $controller
   * @param areaService
   * @param LocoService
   * @param herdGroupService
   * @constructor
   */
  function ListEntryController(
    vm,
    GenericInsightService,
    lodash,
    $controller,
    areaService,
    LocoService,
    herdGroupService
  ) {
    /**
     * Area name
     * @type {string|null}
     */
    vm.areaName = null;

    /**
     * herd group name
     * @type {string|null}
     */
    vm.herdGroupName = null;

    /**
     * Inherit from the base controller
     */
    $controller("InsightListBaseController", {
      vm: vm
    });

    /**
     * Inherit from the loader controller
     */
    $controller("LoaderController", {
      vm: vm
    });

    /**
     * Create an "inherited" init function
     */
    vm.$onInit = lodash.wrap(
      vm.$onInit,
      function (__super__) {
        __super__();

        vm.fetchAreaName();
        vm.fetchHerdName();
      },
      vm.$onInit
    );

    /**
     * Smoke test the component
     * @return {boolean}
     */
    vm.smokes = function () {
      return false;
    };

    /**
     * Get translated insight title
     * @return {string}
     */
    vm.getTranslatedTitle = function () {
      return GenericInsightService.getTranslatedTitle(vm.insight);
    };

    /**
     * Get a human readable string of insight resolution titles
     * @return {string}
     */
    vm.getResolutions = function () {
      return GenericInsightService.getHumanReadableResolutions(vm.insight);
    };

    /**
     * Tell whether the insight is resolved or not
     * @return {boolean}
     */
    vm.isResolved = function () {
      return GenericInsightService.isResolved(vm.insight);
    };

    /**
     * Tell whether the insight is validated
     * @return {boolean}
     */
    vm.isValidated = function () {
      return GenericInsightService.isValid(vm.insight) || GenericInsightService.isInvalid(vm.insight);
    };

    /**
     * Show bullet if the insight is not seen, has not expired and has not resolved
     * @param insight
     */
    vm.showBullet = function (insight) {
      return !GenericInsightService.isSeen(insight) && !GenericInsightService.hasExpired(insight);
    };

    /**
     * Resolve class name
     * @param insight
     * @param totalWidth
     * @param options
     * @return {string}
     */
    vm.resolveClassName = function (insight, totalWidth, options) {
      options = lodash.assign(
        {
          areaWidth: null
        },
        options
      );

      /**
       * Default width of column
       * @type {number}
       */
      var width = totalWidth;
      var classes = [];

      if (options.areaWidth) {
        width -= options.areaWidth;
      }

      if (options.validationWidgetWidth) {
        width -= options.validationWidgetWidth;
      }

      classes.push("col-xs-" + width);

      if (insight && !vm.showBullet(insight) && options.addBadgeSpace) {
        classes.push("badge-not-visible");
      }

      return classes.join(" ");
    };

    /**
     * Fetch area name area name
     */
    vm.fetchAreaName = function () {
      /**
       * Some herd level insights has no reference to a single cow,
       * thus fetching for an area name is useless.
       */
      if (vm.insight.dairyCow) {
        /**
         * @type {number|null}
         */
        var areaID = vm.insight.dairyCow.areaID;

        if (areaID) {
          vm.setLoading(true);

          areaService
            .getArea(areaID)
            .then(
              function (area) {
                vm.areaName = area.areaName;
              }.bind(vm)
            )
            .finally(
              function () {
                vm.setLoading(false);
              }.bind(vm)
            );
        }
      }
    };

    /**
     * Fetch herd name
     */
    vm.fetchHerdName = function () {
      /**
       * @type {number|null}
       */
      var herdID = vm.insight.dairyCow.herdGroupID;

      if (herdID) {
        vm.setLoading(true);

        herdGroupService
          .getHerdGroup(herdID)
          .$promise.then(function (herdGroup) {
            vm.herdGroupName = herdGroup.groupName;
          })
          .finally(
            function () {
              vm.setLoading(false);
            }.bind(vm)
          );
      }
    };

    /**
     * Get area name
     * @return {string}
     */
    vm.getAreaName = function () {
      if (vm.loading) {
        return "...";
      } else if (vm.areaName) {
        return vm.areaName;
      } else {
        return LocoService.translate(vm.listType, "list-entry", "no-area");
      }
    };

    /**
     * Ger herd name
     * @return {string}
     */
    vm.getHerdGroupName = function () {
      if (vm.loading) {
        return "...";
      } else if (vm.herdGroupName) {
        return vm.herdGroupName;
      } else {
        return LocoService.translate(vm.listType, "list-entry", "no-herd-group");
      }
    };

    /**
     * @return {string|null}
     */
    vm.resolveFMSFromValidation = GenericInsightService.resolveFMSFromValidation;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insightList").controller("InsightListController", InsightListController);

  /**
   * Controller for insight lists
   * @todo think about folding it to InsightListBaseController
   * @ngInject
   * @param vm
   * @param $controller
   * @param lodash
   * @param dateTimeService
   * @param LocoService
   * @param sessionService
   * @param GenericInsightService
   * @param InsightListService
   * @constructor
   */
  function InsightListController(
    vm,
    $controller,
    lodash,
    dateTimeService,
    LocoService,
    sessionService,
    GenericInsightService,
    InsightListService
  ) {
    /**
     * Inherit from the base controller
     */
    $controller("InsightListBaseController", {
      vm: vm
    });

    /**
     * Mark the given insights as seen
     * @param insights
     */
    vm.markInsightsAsSeen = InsightListService.markAsSeen;

    /**
     * Smoke test the component
     * @return {boolean}
     */
    vm.smokes = function () {
      return false;
    };

    /**
     * Get translated header content
     * @param variant
     * @param options
     * @return {string}
     */
    vm.getHeaderContent = function (variant, options) {
      options = lodash.assign(
        {
          count: 0
        },
        options || {}
      );

      return vm.getTranslatedContent(variant, null, {
        insightCount: options.count ? options.count : vm.insights.length
      });
    };

    /**
     * Group insights by date, and give them some shape which we can iterate on
     * @param values
     * @param options
     * @example [["05/12/2018", [...insights]], ["04/12/2018", [...insights]], ["03/12/2018", [...insights]]]
     * @return {{freshInsights: *, previousInsights: any[], all: []}}
     */
    vm.processInsights = function (values, options) {
      options = lodash.assign(
        {
          resolveEpoch: function (insight) {
            return insight.startEpoch;
          }
        },
        options || {}
      );

      /**
       * Group insights per date
       * @type {*|{}}
       */
      var grouped = values.reduce(function (result, insight) {
        /**
         * @type {string}
         */
        var ds = dateTimeService.asDateString(options.resolveEpoch(insight), "MM/DD/YYYY");

        if (result[ds]) {
          result[ds].push(insight);
        } else {
          result[ds] = [insight];
        }

        return result;
      }, {});

      /**
       * Insights ordered by area.
       * @type {Object|*}
       */
      var sortedByArea = lodash.mapValues(grouped, function (insights) {
        return lodash.sortBy(insights, [
          function (insight) {
            return insight.dairyCow.areaID && +insight.dairyCow.areaID;
          }
        ]);
      });

      /**
       * Insights ordered by date.
       * @type {Array}
       */
      var sortedByDate = lodash.orderBy(
        lodash.toPairs(sortedByArea),
        [
          function (pair) {
            return dateTimeService.asEpoch(pair[0]) * 1000;
          }
        ],
        ["desc"]
      );

      /**
       * Prettify the date strings in the data and then return the data
       * @type {any[]}
       */

      return sortedByDate.map(function (group) {
        var label = lodash.first(group);
        var insights = lodash.last(group);

        /**
         * @type {string}
         */
        var newLabel = LocoService.translate("date-label-date", {
          date: dateTimeService.asDate(dateTimeService.asEpoch(label))
        });

        return [newLabel, insights];
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insightList")
    .controller("InsightListBaseController", InsightListBaseController);

  /**
   * Base controller for insight lists
   * @ngInject
   * @param vm
   * @param lodash
   * @param LocoService
   * @constructor
   */
  function InsightListBaseController (vm, lodash, LocoService) {
    /**
     * List type, used (mainly) for proper translation key generation
     * @type {string|null}
     * @todo declare in subclass
     */
    vm.listType = null;

    vm.$onInit = function () {
      if (!vm.listType) {
        throw new Error("Please set a `listType` attribute on your controller " +
          "which inherits from InsightListBaseController.");
      }
    };

    /**
     * Get translated content
     * @param {string} variant
     * @param {string} [suffix]
     * @param {{}} [context]
     */
    vm.getTranslatedContent = function (variant, suffix, context) {
      return LocoService.translate(vm.listType, variant, suffix, context || {});
    }
  }
})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightExtensions")
    .service("KersiaBolusService", KersiaBolusService);

  /**
   * @ngInject
   * @param lodash
   * @param $http
   * @param $q
   * @param appConfig
   * @param appSessionService
   * @constructor
   */
  function KersiaBolusService(lodash, $http, $q, appConfig, appSessionService) {
    /**
     * Tell if the Kersia Bolus recommendations is enabled on the farm
     */
    this.isEnabled = function () {
      var farmPreferences = angular.fromJson(appSessionService.farm.farmPreferences) || {};

      return lodash.get(farmPreferences, ["recommendations", "kersiaBolus", "enabled"], false);
    };

    /**
     * Fetch the status for a list of insights
     * @param genericInsightIDList
     * @return {Promise<any>}
     * @todo maybe merge with the single insight version
     */
    this.fetchStatus = function (genericInsightIDList) {
      var dfd = $q.defer();

      /**
       * Construct a URL
       * @type {string}
       */
      var url = [
        appConfig.RECOMMENDATIONSURL,
        "insights?ids=",
        angular.toJson(genericInsightIDList)
      ].join("");

      $http.get(url).then(
        function (response) {
          dfd.resolve(response.data.data);
        },
        function (e) {
          dfd.reject(e);
        }
      );

      return dfd.promise;
    };

    /**
     * Update the BE with the product decision
     * @param recommendationId
     * @param isProductApplied
     * @return {Promise<any>}
     */
    this.respondWith = function (recommendationId, isProductApplied) {
      /**
       * Construct a URL
       * @type {string}
       */
      var url = [appConfig.RECOMMENDATIONSURL, "recommendations/", recommendationId].join("");

      return $http.patch(url, {
        isApplied: isProductApplied
      });
    };
  }
})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight.insightChart")
    .service("ChartService", ChartService);

  /**
   * Insight Chart service
   * @ngInject
   * @return {ChartService}
   */
  function ChartService () {

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight")
    .controller("InsightHeadlineController", InsightHeadlineController);

  /**
   * Base controller for generic insights
   * @ngInject
   * @param vm
   * @param GenericInsightService
   * @param authenticationService
   * @param InsightListService
   * @constructor
   */
  function InsightHeadlineController(vm, GenericInsightService, authenticationService, InsightListService) {
    /**
     * Tell whether the insight is resolved
     * @param {{}} insight
     * @return {boolean}
     */
    vm.isResolved = GenericInsightService.isResolved;

    /**
     * Get translated insight title
     * @param {{}} insight
     * @return {boolean}
     */
    vm.getInsightTitle = GenericInsightService.getTranslatedTitle;

    /**
     * Get wrapper HTML classnames based on the insight category
     * @return {boolean}
     */
    vm.getWrapperClassName = function (insight) {
      /**
       * @type {string}
       */
      var typename = GenericInsightService.getTypeName(insight);

      /**
       * @type {string}
       */
      var category = GenericInsightService.getCategory(insight);

      /**
       * @type {string[]}
       */
      var className = [
        "insight-headline-" + typename,
        "bg-" + typename,
        "bg-" + category,
        GenericInsightService.isInvalid(insight) ? "bg-gray" : ""
      ];

      return className.join(" ");
    }.bind(this);

    /**
     * Init navigation between insights
     */
    vm.initNavigation = function () {
      vm.previousInsight = InsightListService.getPreviousInsightID(vm.insight.GenericInsightID);
      vm.nextInsight = InsightListService.getNextInsightID(vm.insight.GenericInsightID);
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight")
    .service("InsightFilteringService", InsightFilteringService);

  /**
   * @param lodash
   * @param dateTimeService
   * @param GenericInsightService
   * @param filteringService
   * @ngInject
   */
  function InsightFilteringService(lodash, dateTimeService, GenericInsightService, filteringService) {
    /**
     * Update the query config to exclude stale insights
     * @param config
     * @param options
     * @return {{}}
     */
    this.setStaleness = function (config, options) {
      config.filter.startEpoch = GenericInsightService.getStalenessThreshold(options);

      return config;
    };

    /**
     * Set area and herd group id
     * @param config
     * @return {{}}
     */
    this.setAreaAndHerdId = function (config) {
      config.query.filter.dairyCow.areaID = filteringService.get("area");
      config.query.filter.dairyCow.herdGroupID = filteringService.get("herdGroup");

      return config;
    };
  }
})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight").service("InsightCountService", InsightCountService);

  /**
   * Service to count insights
   * @param lodash
   * @param appSessionService
   * @param GenericInsightService
   * @param CachingService
   * @param INSIGHT_CATEGORIES
   * @param sessionService
   * @param $q
   * @constructor
   */
  function InsightCountService(
    lodash,
    appSessionService,
    GenericInsightService,
    CachingService,
    INSIGHT_CATEGORIES,
    sessionService,
    $q
  ) {
    /**
     * Count pending sensor alerts
     * @param {{ pending: boolean, hasSensor: boolean, insightTypes: array}} options
     */
    this.countSensorAlerts = CachingService.memoize(
      function (options) {
        /**
         * By default, we do not expand, filter for farm id and some insight states
         * @type {{filter: {insightState: [string, string, string], farmID: *}, expand: []}}
         */
        var defaultConfig = {
          expand: [],
          filter: {
            startEpoch: 1591228800, // 4th of June, 2020
            farmID: appSessionService.farmID,
            insightState: ["Live", "ForcedLive"]
          }
        };

        /**
         * Pending insights are non-validated, non-resolved and all cows have sensors
         * @type {{filter: {validated: boolean, resolved: boolean}}}
         */
        var pending = {
          filter: {
            resolved: false,
            validated: false
          }
        };

        /**
         * Sensor insights that have a sensor attached to them
         * @type {{filter: {dairyCow: {hasSensor: boolean}, insightContext: {any: string}}}}
         */
        var hasSensor = {
          filter: {
            dairyCow: {
              hasSensor: true
            },
            insightContext: {
              any: "nodeID"
            }
          }
        };

        /**
         * Unseen insights are either null or have not been viewed by the current user
         * @type {{filter: {seen: {none: string[]}}}}
         */
        var unseen = {
          filter: {
            seen: {
              none: [sessionService.user.id]
            }
          }
        };

        var chain = [];

        if (lodash.isArray(options)) {
          lodash.map(
            options,
            function (option) {
              chain.push(
                this.fetchSensorAlertCount(
                  {
                    defaultConfig: defaultConfig,
                    pending: pending,
                    hasSensor: hasSensor,
                    unseen: unseen
                  },
                  option
                )
              );
            }.bind(this)
          );
        } else {
          chain.push(
            this.fetchSensorAlertCount(
              {
                defaultConfig: defaultConfig,
                pending: pending,
                hasSensor: hasSensor,
                unseen: unseen
              },
              options
            )
          );
        }

        return $q.all(chain);
      }.bind(this),
      {
        key: "actionable-sensor-alert-count",
        link: {
          type: "topic",
          /**
           * This ID matches the id for the topic key of GenericInsightService.fetchInsightsByTypeName.
           * If any of the insights get updated, this cache is invalidated too.
           */
          id: INSIGHT_CATEGORIES.sensorAlert.join()
        }
      }
    );

    /**
     * Get insight type names configuration
     * @param options
     * @return {{filter: {insightType: {typeName: {any: []}}}}}
     */
    this.getInsightTypeConfiguration = function (options) {
      /**
       * Sensor alerts fall under the following insight types
       * @type {{filter: {insightType: {typeName: {any: [string]}}}}}
       */
      return {
        filter: {
          insightType: {
            typeName: {
              any: options.insightTypes.length ? options.insightTypes : INSIGHT_CATEGORIES.sensorAlert
            }
          }
        }
      };
    };

    /**
     * Get options for creating fetch configuration for counting sensor alert
     * @param options
     * @return {*}
     */
    this.getCountSensorAlertOptions = function (options) {
      return lodash.assign(
        {
          pending: false,
          hasSensor: true,
          insightTypes: []
        },
        options || {}
      );
    };

    /**
     * Fetch sensor alert count
     * @param config
     * @param option
     * @return {*}
     */
    this.fetchSensorAlertCount = function (config, option) {
      /**
       * @type {{pending: boolean, hasSensor: boolean, insightTypes: array}}
       */
      option = this.getCountSensorAlertOptions(option);
      /**
       * @type {{filter: {insightType: {typeName: {any: []}}}}}
       */
      var insightType = this.getInsightTypeConfiguration(option);
      /**
       * @type {{}}
       */
      var fetchConfig = lodash.merge(
        {},
        config.defaultConfig,
        insightType,
        option.pending ? config.pending : {},
        option.unseen ? config.unseen : {},
        option.hasSensor ? config.hasSensor : {},
        {
          filter: {
            startEpoch: option.startEpoch ? option.startEpoch : config.defaultConfig.filter.startEpoch
          }
        }
      );

      return GenericInsightService.countInsights(fetchConfig);
    };
  }
})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular.module("ctraUIComponents.genericInsight").service("GenericInsightService", GenericInsightService);

  /**
   * Insight service, the new one
   * @ngInject
   * @param lodash
   * @param $odataresource
   * @param appConfig
   * @param VALIDATION_VALUES
   * @param LocoService
   * @param insightService
   * @param OdataService
   * @param DOMINANT_EPOCH
   * @param DEFAULT_FETCH_INSIGHT_CONFIG
   * @param ValidationService
   * @param $q
   * @param dateTimeService
   * @param CachingService
   * @param sessionService
   * @param $http
   * @param insightResolutionService
   * @param $log
   * @param INSIGHT_CATEGORIES
   * @return {GenericInsightService}
   * @constructor
   */
  function GenericInsightService(
    lodash,
    $odataresource,
    appConfig,
    VALIDATION_VALUES,
    LocoService,
    insightService,
    OdataService,
    DOMINANT_EPOCH,
    DEFAULT_FETCH_INSIGHT_CONFIG,
    ValidationService,
    $q,
    dateTimeService,
    CachingService,
    sessionService,
    $http,
    insightResolutionService,
    $log,
    INSIGHT_CATEGORIES
  ) {
    /**
     * Process a raw insight list
     * @param {{}[]} rawInsightList
     * @return {{}[]}
     * @private
     */
    function _processInsights(rawInsightList) {
      return rawInsightList.map(_processInsight);
    }

    /**
     * Set arbitrary flags on the insight based on resolution values
     * @param {{}} insight
     * @param {{[string]: {on: string, off: string}}} flags
     * @example setFlags(insight, {inseminated: {on: "inseminated", off: "not_inseminated"}});
     * @private
     */
    function _setFlags(insight, flags) {
      lodash.forOwn(flags, function (flagStates, flagKey) {
        insight[flagKey] = null;

        /**
         * Zip the conditions with their consecutive boolean values
         */
        var zipped = lodash.zip(["on", "off"], [true, false]);

        /**
         * Set a flag on the insight object if the insight is resolved as our condition
         */
        var setValue = lodash.spread(function (condition, flag) {
          if (insightResolutionService.isResolved(insight, flagStates[condition])) {
            insight[flagKey] = flag;
          }
        });

        lodash.forEach(zipped, setValue);
      });
    }

    /**
     * Process a single insight
     * @param {{ GenericInsightID: number }} rawInsightData
     * @return {{}}
     * @private
     */
    function _processInsight(rawInsightData) {
      var assigned = lodash.assign(rawInsightData, {
        insightResolution: angular.fromJson(rawInsightData.insightResolution) || [],
        insightValid: ValidationService.pickValidationValue(rawInsightData.insightValidations)
      });

      /**
       * Set the flags on the insight object based on resolutions
       */
      _setFlags(assigned, {
        inseminated: {
          on: "inseminated",
          off: "not_inseminated"
        },
        calved: {
          on: "calved",
          off: "not_calved"
        },
        approved: {
          on: "approved",
          off: "not_approved"
        }
      });

      return assigned;
    }

    /**
     * Smoke test
     * @return {boolean}
     */
    this.smokes = function () {
      return false;
    };

    /**
     * @type {Array}
     */
    this.GROUP_INSIGHT = ["HerdInsight"];

    /**
     * Generic insight oData resource
     */
    var GenericInsight = $odataresource(
      appConfig.APIURL + "odata/GenericInsights",
      {},
      {},
      {
        odatakey: "GenericInsightID"
      }
    );

    /**
     * Get insight context
     * Memoize the results as `fromJson` would return a new
     * object every time causing rendering issues.
     * @param {{ insightContext: string }} insight
     * @return {{}}
     */
    this.getContext = lodash.memoize(function (insight) {
      return angular.fromJson(insight.insightContext) || {};
    });

    /**
     * Get insight metadata
     * Memoize the results as `fromJson` would return a new
     * object every time causing rendering issues.
     * @param {{ insightMetadata: string }} insight
     */
    this.getMetadata = lodash.memoize(function (insight) {
      return angular.fromJson(insight.insightMetadata) || {};
    });

    /**
     * Get insight resolutions
     * @param {{ insightResolution: string }} insight
     */
    this.getResolutions = function (insight) {
      return angular.fromJson(insight.insightResolution) || [];
    };

    /**
     * Update the insight with the given resolutions
     * @param insight
     * @param resolutionIds
     * @return {Promise<any>}
     */
    this.updateResolution = function (insight, resolutionIds) {
      var resolutions = lodash.map(resolutionIds, function (resolutionId) {
        return insightResolutionService.getResolutionById(resolutionId);
      });

      insight.insightResolution = lodash.uniqBy(
        lodash.filter(lodash.concat(insight.insightResolution, resolutions), null),
        "id"
      );

      return this.updateInsight(insight);
    };

    /**
     * Tell whether the given insight is valid
     * @param {{ insightValid: string }} insight
     * @return {boolean}
     * @todo think about moving to validation service
     */
    this.isValid = function (insight) {
      return insight.insightValid === VALIDATION_VALUES.yes;
    };

    /**
     * Tell whether the given insight is invalid
     * @param {{ insightValid: string }} insight
     * @return {boolean}
     * @todo think about moving to validation service
     */
    this.isInvalid = function (insight) {
      return insight.insightValid === VALIDATION_VALUES.no;
    };

    /**
     * Tell whether the given insight is resolved
     * @param {{ insightResolution: {}[] }} insight
     * @return {boolean}
     */
    this.isResolved = function (insight) {
      return lodash.isArray(insight.insightResolution) && !!insight.insightResolution.length;
    };

    /**
     * Get translated insight title
     * @param {{ insightTitle: string }} insight
     * @param {{ legacy: boolean }} options
     * @return {string}
     */
    this.getTranslatedTitle = function (insight, options) {
      var translated;

      /**
       * @type {{}}
       */
      var metadata = this.getMetadata(insight);

      options = lodash.assign(
        {
          legacy: false
        },
        options || {}
      );

      if (options.legacy && lodash.isEmpty(metadata)) {
        translated = LocoService.translate(lodash.trim(insight.insightTitle));
      } else {
        /**
         * Insight type name
         * @type {string}
         */
        var typeName = this.getTypeName(insight);

        translated = LocoService.translate(
          "insight-title",
          typeName,
          lodash.assign(dateTimeService.convertEpochs(metadata), lodash.omit(options, "legacy"))
        );
      }

      return translated;
    }.bind(this);

    /**
     * Get translated insight description
     * @param {{ insightDescription: string }} insight
     * @param {{ legacy: boolean }} options
     * @return {string}
     */
    this.getTranslatedDescription = function (insight, options) {
      var translated;

      /**
       * @type {{}}
       */
      var metadata = this.getMetadata(insight);

      options = lodash.assign(
        {
          legacy: false
        },
        options || {}
      );

      if (options.legacy && lodash.isEmpty(metadata)) {
        translated = LocoService.translate(lodash.trim(insight.insightDescription));
      } else {
        /**
         * Insight type name
         * @type {string}
         */
        var typeName = this.getTypeName(insight);

        translated = LocoService.translate(
          "insight-description",
          typeName,
          lodash.assign(dateTimeService.convertEpochs(metadata), lodash.omit(options, "legacy"))
        );
      }

      return translated;
    }.bind(this);

    /**
     * Get a formatted resolution list
     * @param insight
     * @return {string}
     */
    this.getHumanReadableResolutions = function (insight) {
      var ids = lodash.map(insight.insightResolution, "id");

      return ids.length > 1
        ? ids.reduce(function (result, id, idx) {
            /**
             * @type {boolean}
             */
            var last = idx === ids.length;

            return result + last ? ", " : " & " + LocoService.translate(id);
          }, "")
        : LocoService.translate(lodash.first(ids));
    };

    /**
     * Get insight type name
     * @param {{ insightType: { typeName: string }}} insight
     * @return {string|undefined}
     */
    this.getTypeName = function (insight) {
      if (!insight) {
        throw new Error("You need to pass an insight to determine the type name.");
      }

      return lodash.get(insight, ["insightType", "typeName"]);
    };

    /**
     * Get insight category
     * @param {{ insightType: { insightCategory: string }}} insight
     * @return {string|undefined}
     */
    this.getCategory = function (insight) {
      if (!insight) {
        throw new Error("You need to pass an insight to determine the category.");
      }

      return lodash.get(insight, ["insightType", "insightCategory"]);
    };

    /**
     * Validate insight fetching config and throw errors if it is not valid
     * @param {{}} config
     */
    this.validateConfig = function (config) {
      /**
       * @type {string[]}
       */
      var errors = [];

      if (!config.filter.farmID && !config.filter.GenericInsightID) {
        errors.push("`farmID` or `GenericInsightID` is missing from `config.filter`");
      }

      errors.forEach(function (error) {
        throw new Error(error);
      });
    };

    /**
     * Customize merge so the `expand` can be overwritten
     * @param objValue
     * @param srcValue
     * @param key
     * @return {void}
     * @private
     */
    function _customizer (objValue, srcValue, key) {
      if (key === "expand") {
        return srcValue;
      }
    }

    /**
     * Build an insight fetching query
     * @param {{}} config
     * @return {Array}
     */
    this.buildQuery = function (config) {
      /**
       * Make a proper config before collecting insights
       */
      config = lodash.mergeWith(lodash.cloneDeep(DEFAULT_FETCH_INSIGHT_CONFIG), config || {}, _customizer);

      /**
       * Validate config and throw errors when anything is missing
       */
      this.validateConfig(config);

      /**
       * Build a basic query
       * @type {Array}
       */
      var query = OdataService.expand(GenericInsight.odata(), config.expand).orderBy(
        config.orderBy,
        config.order
      );

      /**
       * Filter for insight id
       */
      if (config.filter.GenericInsightID) {
        query = OdataService.filter(query, "GenericInsightID", "=", config.filter.GenericInsightID, null);
      }

      /**
       * Filter for farm id
       */
      if (config.filter.farmID) {
        query = OdataService.filter(query, "farmID", "=", config.filter.farmID, null);
      }

      /**
       * Filter for insight states
       */
      if (config.filter.insightState) {
        query = OdataService.filter(query, "insightState", "=", config.filter.insightState, "or");
      }

      /**
       * Filter for resolved status
       */
      if (lodash.isBoolean(config.filter.resolved)) {
        /**
         * @type {string[]}
         */
        var nonResolvedValues = ["[]", "null", null];

        if (config.filter.resolved) {
          /**
           * Filter out anything which does not have a resolution
           */
          query = OdataService.filter(query, "insightResolution", "!=", nonResolvedValues, "and");
        } else {
          /**
           * Allow only resolved insights
           */
          query = OdataService.filter(query, "insightResolution", "=", nonResolvedValues, "or");
        }
      }

      /**
       * Filter the insights by a single resolution
       * @example {filter: {resolution: "management_change"}}
       */
      if (lodash.isString(config.filter.resolved)) {
        query = OdataService.notNull(query, "insightResolution");
        query = OdataService.inJSON(query, "insightResolution", config.filter.resolved, null);
      }

      /**
       * Filter the insights by multiple resolutions
       * @example {filter: {resolution: ["management_change"]}}
       */
      if (lodash.isArray(config.filter.resolved)) {
        query = OdataService.notNull(query, "insightResolution");
        query = OdataService.inJSON(query, "insightResolution", config.filter.resolved, "or");
      }

      if (lodash.isBoolean(config.filter.validated)) {
        /**
         * Filter for validated (Yes or No) or not validated (not Yes and No) insights
         * using their corresponding enum values
         */
        query = OdataService.filterValidations(
          query,
          "any",
          "validation",
          config.filter.validated ? "=" : "ne",
          [
            "Connecterra.DataContract.Insights.Validation'" + VALIDATION_VALUES.yes + "'",
            "Connecterra.DataContract.Insights.Validation'" + VALIDATION_VALUES.no + "'"
          ],
          config.filter.validated ? "or" : "and",
          { enum: true, allowEmpty: !config.filter.validated }
        );
      }

      /**
       * Filter the insight depending on the validation value passed
       */
      if (lodash.isString(config.filter.validated)) {
        query = OdataService.filterValidations(
          query,
          "any",
          "validation",
          "=",
          "Connecterra.DataContract.Insights.Validation'" + config.filter.validated + "'",
          null,
          { enum: true, allowEmpty: false }
        );
      }

      /**
       * Filter the insights according the validation passed
       * @example {filter: {validated: ["Yes", "No"]}}
       */
      if (lodash.isArray(config.filter.validated)) {
        var allowEmpty = lodash.includes(config.filter.validated, null);

        var validation = lodash.map(lodash.pull(config.filter.validated, null), function (value) {
          return "Connecterra.DataContract.Insights.Validation'" + value + "'";
        });

        query = OdataService.filterValidations(query, "any", "validation", "=", validation, "or", {
          enum: true,
          allowEmpty: allowEmpty
        });
      }

      /**
       * Filter for any of the given insight types
       */
      if (config.filter.insightType.typeName.any) {
        query = OdataService.filter(
          query,
          "insightType/typeName",
          "=",
          config.filter.insightType.typeName.any,
          "or"
        );
      }

      /**
       * Exclude the given type names from the results
       */
      if (config.filter.insightType.typeName.none) {
        query = OdataService.filter(
          query,
          "insightType/typeName",
          "!=",
          config.filter.insightType.typeName.any,
          "and"
        );
      }

      /**
       * Filter for any of the given substrings of the insight context
       */
      if (config.filter.insightContext.any) {
        query = OdataService.inJSON(query, "insightContext", config.filter.insightContext.any, "or");
      }

      /**
       *Filter for all of the given substrings of the insight context
       */
      if (config.filter.insightContext.all) {
        query = OdataService.inJSON(query, "insightContext", config.filter.insightContext.all, "and");
      }

      /**
       * Filter all the cows which have not be breed
       */
      if (lodash.isBoolean(config.filter.dairyCow.doNotBreed)) {
        query = OdataService.filter(
          query,
          "dairyCow/DoNotBreed",
          "=",
          config.filter.dairyCow.doNotBreed,
          null
        );
      }

      /**
       * Filter for any of the given insight categories
       */
      if (config.filter.insightCategory.any) {
        var insightsCategory = config.filter.insightCategory.any;
        query = OdataService.filter(query, "insightType/insightCategory", "=", insightsCategory, "or");
      }

      /**
       * Exclude all the given insight categories
       */
      if (config.filter.insightCategory.none) {
        query = OdataService.filter(
          query,
          "insightType/insightCategory",
          "!=",
          config.filter.insightCategory.none,
          "and"
        );
      }

      /**
       * Filter for the seen or unseen insights
       * @example {filter: {seen: true}}
       */
      if (lodash.isBoolean(config.filter.seen)) {
        /**
         * @type {string}
         */
        var operator = config.filter.seen ? "ne" : "=";

        query = OdataService.filter(query, "seenByUserIds", operator, null, null);
      }

      /**
       * Filter for the seen insights by a single user id
       * @example {filter: {seen: "user-id-1"}}
       */
      if (lodash.isString(config.filter.seen)) {
        query = OdataService.notNull(query, "seenByUserIds");
        query = OdataService.inJSON(query, "seenByUserIds", config.filter.seen, null);
      }

      /**
       * Filter for the seen insights by multiple user ids
       * @example {filter: {seen: ["user-id-1", "user-id-2"]}}
       */
      if (lodash.isArray(config.filter.seen)) {
        query = OdataService.notNull(query, "seenByUserIds");
        query = OdataService.inJSON(query, "seenByUserIds", config.filter.seen, "or");
      }

      /**
       * Filter insights which has been seen by any of the given ids
       * * @example {filter: {seen: {any: ["user-id-1", "user-id-2"]}}}
       */
      if (lodash.isObject(config.filter.seen) && config.filter.seen.any) {
        query = OdataService.notNull(query, "seenByUserIds");
        query = OdataService.inJSON(query, "seenByUserIds", config.filter.seen.any, "or");
      }

      /**
       * Filter insights which has been seen by all the given ids
       * * @example {filter: {seen: {all: ["user-id-1", "user-id-2"]}}}
       */
      if (lodash.isObject(config.filter.seen) && config.filter.seen.all) {
        query = OdataService.notNull(query, "seenByUserIds");
        query = OdataService.inJSON(query, "seenByUserIds", config.filter.seen.all, "and");
      }

      /**
       * Filter insights which has been seen by non of the given ids
       * @example {filter: {seen: {none: ["user-id-1", "user-id-2"]}}}
       */
      if (lodash.isObject(config.filter.seen) && config.filter.seen.none) {
        query = OdataService.notInJSON(query, "seenByUserIds", config.filter.seen.none, { nullable: true });
      }

      /**
       * Filter according to insight scopes
       */
      if (config.filter.insightType.insightScope) {
        query = OdataService.filter(
          query,
          "insightType/insightScope",
          "=",
          config.filter.insightType.insightScope,
          null
        );
      }

      /**
       * Filter for cows which has sensor
       */
      if (lodash.isBoolean(config.filter.dairyCow.hasSensor)) {
        query = OdataService.filter(
          query,
          "dairyCow/nodeID",
          config.filter.dairyCow.hasSensor ? "!=" : "=",
          null,
          null
        );
      }

      /**
       * Filter out insights before the given startEpoch
       */
      if (config.filter.startEpoch) {
        query = OdataService.filter(query, DOMINANT_EPOCH, ">", config.filter.startEpoch, null);
      }

      /**
       * Filter out insights after the given endEpoch
       */
      if (config.filter.endEpoch) {
        query = OdataService.filter(query, DOMINANT_EPOCH, "<", config.filter.endEpoch, null);
      }

      /**
       * Skip the first N insights
       */
      if (config.offset) {
        query.skip(config.offset);
      }

      /**
       * Take the first M insights
       */
      if (config.limit) {
        query.take(config.limit);
      }

      /**
       * Filter out values for the given area id
       */
      if (config.filter.dairyCow.areaID) {
        query = OdataService.filter(query, "dairyCow/areaID", "=", config.filter.dairyCow.areaID, null);
      }

      /**
       * Filter out values for the given herd id
       */
      if (config.filter.dairyCow.herdGroupID) {
        query = OdataService.filter(
          query,
          "dairyCow/herdGroupID",
          "=",
          config.filter.dairyCow.herdGroupID,
          null
        );
      }

      return query;
    };

    /**
     * Fetch insights from the server
     * @todo DO NOT MEMOIZE THIS FUNCTION
     * @param {{}} config
     */
    this.fetchInsights = function (config) {
      var dfd = $q.defer();

      /**
       * Build an oData query from the config
       * @type {Array}
       */
      var query = this.buildQuery(config);

      query.query().$promise.then(
        function (insights) {
          dfd.resolve(_processInsights(insights));
        }.bind(this),
        function (error) {
          throw new Error(error);
        }
      );

      return dfd.promise;
    }.bind(this);

    /**
     * Pre-fill the insight type in the fetching (handy for cached calls)
     * @type {(function(): Promise)|*}
     */
    this.fetchInsightsByTypeName = CachingService.memoize(
      lodash.curry(
        function (typeNames, config) {
          return this.fetchInsights(
            lodash.merge({}, config, {
              filter: {
                insightType: {
                  typeName: {
                    any: typeNames
                  }
                }
              }
            })
          );
        }.bind(this)
      ),
      {
        /**
         * Use the stringified fetch config as a memoise key
         * @param {string[]} typeNames
         * @param {{}} config
         * @return {string}
         */
        key: function (typeNames, config) {
          return angular.toJson(config);
        },
        /**
         * Set the insight type names to be the cache topic
         * @param {string[]} typeNames
         * @return {{id: string, type: string}}
         */
        link: function (typeNames) {
          return {
            type: "topic",
            id: typeNames.join()
          };
        }
      }
    );

    /**
     * Fetch a single insight
     * @todo DO NOT MEMOIZE THIS FUNCTION
     * @param {number} genericInsightID
     */
    this.fetchSingleInsight = function (genericInsightID) {
      var dfd = $q.defer();

      var config = {
        filter: {
          GenericInsightID: genericInsightID,
          insightState: null // Set insight state to be "any"
        }
      };

      /**
       * @type {Array}
       */
      var query = this.buildQuery(config);

      query.single().$promise.then(
        function (insight) {
          dfd.resolve(_processInsight(insight));
        }.bind(this),
        function (error) {
          throw new Error(error);
        }
      );

      return dfd.promise;
    };

    /**
     * Fetch insights from the server
     * @todo DO NOT MEMOIZE THIS FUNCTION
     * @param {{}} config
     */
    this.countInsights = function (config) {
      var dfd = $q.defer();

      var query = this.buildQuery(config);

      query.count().$promise.then(
        function (response) {
          dfd.resolve(response.result);
        },
        function (error) {
          $log.error(error);
          throw new Error("An error occurred while retrieving insight count.");
        }
      );

      return dfd.promise;
    };

    /**
     * Update the insight using the legacy service
     * @param {{ GenericInsightID: number }} insight
     * @return {Promise}
     */
    this.updateInsight = function (insight) {
      var id = insight.GenericInsightID;

      /**
       * Invalidate everything in the cache which is related to this insight
       */
      CachingService.invalidate("GenericInsightID", id);

      return insightService.updateInsight(insight);
    };

    /**
     * Depending on the condition extract out all the key from that data that are being sent in keysToCollect
     * @example
     * // return [{a: 1, b: 2}]
     * collect([{a: 1, b: 2}, {a: 3}], lodash.overEvery([Service.unseen, Service.valid]), ['a', "b"])
     * @param data
     * @param condition
     * @param keysToCollect
     * @return {[{}]}
     */
    this.collect = function (data, condition, keysToCollect) {
      return lodash.map(lodash.filter(data, condition), lodash.partialRight(lodash.pick, keysToCollect));
    };

    /**
     * Update all the insights value for the given key
     * @TODO: should this function be responsible for updating the data and then sending the request?
     * @TODO: What if we want to update multiple things??
     * @param insights
     * @param key
     * @param value
     * @param overwrite
     */
    this.batchUpdate = function (insights, key) {
      /**
       * Add user to the insight seen list
       * @param insights
       */
      var promiseChain = [];

      insights.forEach(
        function (insight) {
          promiseChain.push(this.patchUpdate(insight, key));
        }.bind(this)
      );
      return $q.all(promiseChain);
    };

    /**
     * Send a patch request to update data
     * @param insight
     * @param key
     * @return {HttpPromise}
     */
    this.patchUpdate = function (insight, key) {
      /**
       * Request auth header
       * @type {{headers: {Authorization: string}}}
       */
      var config = { headers: { Authorization: "Bearer " + sessionService.token.access_token } };

      /**
       * @TODO: Check why this is not working {[key]: insight[key]}
       * @type {{}}
       */
      var dataToUpdate = {};
      dataToUpdate[key] = insight[key];

      /**
       * Update the data
       */
      return $http.patch(
        appConfig.APIURL + "odata/GenericInsights(" + insight.GenericInsightID + ")",
        dataToUpdate,
        config
      );
    };

    /**
     * Check if the insight has been seen by the given user id
     * @TODO: Update this function to handle seen by anyone usecase
     * @param insight
     * @return {boolean}
     */
    this.isSeen = function (insight) {
      return insight.seenByUserIds && lodash.includes(insight.seenByUserIds, sessionService.user.id);
    };

    /**
     * Check if the insight has expired
     * @param insight
     * @return {boolean}
     */
    this.hasExpired = function (insight) {
      var insightCategory = insight.insightType.insightCategory;
      var insightTypeName = insight.insightType.typeName;
      var insightScope = insight.insightScope;

      var validDurationEpoch = this.getStalenessThreshold({
        category: insightCategory,
        typeName: insightTypeName,
        scope: insightScope
      });

      return insight.endEpoch < validDurationEpoch;
    }.bind(this);

    /**
     * Pick a staleness threshold for any given insight query
     * @param {{category: string, typeName: string, scope: string}} options
     * @return {null|number}
     */
    this.getStalenessThreshold = function (options) {
      var duration = null;

      if (options.scope === "farm") {
        duration = dateTimeService.now() - dateTimeService.MONTH;
      } else if (
        options.category === "fertility" &&
        lodash.includes(INSIGHT_CATEGORIES.cycleAlertWorkflow, options.typeName)
      ) {
        duration = dateTimeService.now() - dateTimeService.DAY * 90;
      } else if (
        options.category === "fertility" &&
        lodash.includes(INSIGHT_CATEGORIES.calving, options.typeName)
      ) {
        duration = dateTimeService.now() - dateTimeService.DAY;
      } else if (options.category === "fertility") {
        duration = dateTimeService.now();
      } else if (options.category === "health" || options.typeName === "HerdInsight") {
        duration = dateTimeService.now() - dateTimeService.WEEK;
      }

      return duration;
    };

    /**
     * Get days in milk
     * @param insight
     * @return {number}
     */
    this.getDIM = function (insight, options) {
      var lastCalvingEpoch;

      options = lodash.assign({ useFallback: false }, options || {});

      if (this.getContext(insight) && !options.useFallback) {
        lastCalvingEpoch = this.getContext(insight).previousCalvingEpoch;
      } else {
        lastCalvingEpoch = insight.dairyCow.lastCalvingEpoch;
      }

      return lastCalvingEpoch
        ? dateTimeService.daysBetween(new Date(), new Date(lastCalvingEpoch * 1000))
        : null;
    }.bind(this);

    /**
     * Get "last breeding"
     * @param insight
     * @param fromCow
     * @return {number}
     */
    this.getLB = function (insight, fromCow) {
      var previousInseminationEpoch = fromCow
        ? insight.dairyCow.lastInseminationEpoch
        : this.getContext(insight).previousInseminationEpoch;

      /**
       * @type {string}
       */
      var result = null;

      if (previousInseminationEpoch) {
        if (fromCow) {
          /**
           * @type {Date}
           */
          var now = dateTimeService.midnight();

          result = dateTimeService.daysBetween(now, dateTimeService.asDate(previousInseminationEpoch));
        } else {
          /**
           * @type {number}
           */
          var contextEpoch = this.getContext(insight).contextEpoch;

          result = dateTimeService.daysBetween(
            dateTimeService.asDate(contextEpoch),
            dateTimeService.asDate(previousInseminationEpoch)
          );
        }
      }

      return result;
    }.bind(this);

    /**
     * Get FMS
     * @return {string|null}
     */
    this.resolveFMSFromValidation = lodash.memoize(function (insight) {
      var dysonPrefix = "Dyson-";

      /**
       * Reject admin validations
       */
      var validations = lodash.reject(insight.insightValidations, ["validationByID", "Admin"]);

      if (!validations.length) {
        return null;
      }

      /**
       * Pick the user validations by rejecting anything from Dyson
       */
      var userValidations = lodash.reject(validations, function (v) {
        return lodash.startsWith(v.validationByID, dysonPrefix);
      });

      /**
       * Tell if there is a conflict in the validations (user & dyson validations together)
       * @type {boolean}
       */
      var conflict = !!userValidations.length && userValidations.length !== validations.length;

      if (conflict) {
        return null;
      }

      var byDyson = lodash.filter(validations, function (v) {
        return lodash.startsWith(v.validationByID, dysonPrefix);
      });

      if (!byDyson.length) {
        return null;
      }

      /**
       * Keep the `validationByID` values
       */
      var validatedBy = lodash.uniq(lodash.map(validations, "validationByID"));

      return lodash.first(validatedBy).replace(dysonPrefix, "");
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight")
    .controller("InsightBaseController", InsightBaseController);

  /**
   * Base controller for generic insights
   * @ngInject
   * @param vm
   * @param GenericInsightService
   * @param authenticationService
   * @param sessionService
   * @param lodash
   * @param herdGroupService
   * @constructor
   */
  function InsightBaseController(
    vm,
    GenericInsightService,
    authenticationService,
    sessionService,
    lodash,
    herdGroupService
  ) {
    /**
     * Tell whether the user is authorised as a given role
     * @param {string} role
     * @return {boolean}
     */
    vm.isAuthorized = authenticationService.isAuthorized;

    /**
     * Tell whether the given insight is valid
     * @param insight
     * @return {boolean}
     */
    vm.isValid = GenericInsightService.isValid;

    /**
     * Parameters to display in the context details bar
     * @type {string[]}
     */
    vm.contextParams = ["areaName", "cowStatus"];

    /**
     * @type {null}
     */
    vm.herdGroup = null;

    vm.$onInit = function () {
      if (vm.insight.herdGroupID) {
        vm.fetchHerdGroup();
      }
    };

    /**
     * Smoke test the component
     * @return {boolean}
     */
    vm.smokes = function () {
      return false;
    };

    /**
     * Set insight as seen
     * @return {Promise<any>}
     * @todo move to a service
     */
    vm.setAsSeen = function () {
      if (
        vm.insight &&
        !GenericInsightService.isSeen(vm.insight) &&
        !GenericInsightService.isResolved(vm.insight)
      ) {
        var partialInsightData = lodash.pick(vm.insight, ["GenericInsightID", "seenByUserIds"]);
        var userID = sessionService.user.id;

        userID = userID + ",";

        partialInsightData.seenByUserIds = lodash.isNil(partialInsightData.seenByUserIds)
          ? userID
          : partialInsightData.seenByUserIds + userID;

        return GenericInsightService.patchUpdate(partialInsightData, "seenByUserIds");
      }
    };

    /**
     * fetch herd group details
     */
    vm.fetchHerdGroup = function () {
      return herdGroupService.getHerdGroup(vm.insight.herdGroupID).$promise.then(function (herdGroup) {
        vm.herdGroup = herdGroup;
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.genericInsight")
    .controller("CalvingBaseController", CalvingBaseController);

  /**
   * Base controller for calving insights
   * @ngInject
   * @param vm
   * @param calvingService
   * @param dateTimeService
   * @constructor
   */
  function CalvingBaseController(vm, calvingService, dateTimeService) {
    /**
     * Tell if the insight has a user-defined calving label
     * @return {boolean}
     */
    vm.hasCalvingLabel = function () {
      return !!calvingService.getCalvingLabel(vm.insight);
    };

    /**
     * Remove calving label from the insight
     */
    vm.removeCalvingLabel = function () {
      calvingService.removeCalvingLabel(vm.insight);
    };

    /**
     * Get the user defined calving time
     * @return {string}
     */
    vm.getUserDefinedCalvingTime = function () {
      var label = calvingService.getCalvingLabel(vm.insight);

      return dateTimeService.asCalendarString(label.startEpoch);
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.gamePlan")
    .controller("GamePlanListBaseController", GamePlanListBaseController);

  /**
   * Base controller for game plan lists
   * @ngInject
   * @param vm
   * @param GamePlanService
   * @param lodash
   * @param appSessionService
   * @constructor
   */
  function GamePlanListBaseController(vm, GamePlanService, lodash, appSessionService) {
    vm.getTranslatedContent = GamePlanService.getTranslatedContent;

    /**
     * @type {{...gamePlanProps}[]}
     */
    vm.gamePlanList = [];

    /**
     * Fetch game plans for the current farm
     */
    vm.fetchGamePlanList = function () {
      /**
       * @type {boolean}
       */
      vm.fetching = true;

      return GamePlanService.fetchGamePlans()
        .then(
          function (gamePlanList) {
            if (!lodash.isEqual(gamePlanList, vm.gamePlanList)) {
              vm.gamePlanList = lodash.values(gamePlanList);
            }
          },
          function () {
            throw new Error(
              "An error occurred. I could not fetch the game plans for this farm: " + appSessionService.farmID
            );
          }
        )
        .finally(function () {
          vm.fetching = false;
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.caching", [
      "ngLodash"
    ]);
}());

/* eslint-disable angular/module-getter */

/**
 * Memoize link object
 * @typedef {{type: string, id: string}} MemoizeLink
 */

/**
 * Memoize key object
 * @typedef {{serviceKey: string, internalKey: string}} MemoizeKeys
 */

/**
 * Options to be passed to memoize
 * @typedef {{
 *   timeout: number,
 *   key: function(): string|string,
 *   link: function(): MemoizeLink|MemoizeLink
 * }} MemoizeOptions
 */

/**
 * Create a v4 UUID
 * @todo move to a separate service
 * @return {string}
 */
function uuid () {
  /**
   * Get current date time
   * @type {number}
   */
  var dt = new Date().getTime();

  /**
   * @type {string}
   */
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (dt + Math.random() * 16) % 16 | 0;

    dt = Math.floor(dt / 16);

    return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
  });

  return uuid;
}

/**
 * @todo move to constants
 * @type {{topic: string, entity: string}}
 */
var LINK_TYPES = {
  entity: "entity",
  topic: "topic"
};

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.caching")
    .service("CachingService", CachingService);

  /**
   * Service to cache anything
   * @param lodash
   * @param dateTimeService
   * @param $q
   * @constructor
   */
  function CachingService (lodash, dateTimeService, $q) {
    /**
     * Default cache timeout in minutes
     * @type {number}
     * @private
     */
    var _defaultCacheTimeout = dateTimeService.HOUR / 4;

    /**
     * Service cache
     * @type {{}}
     * @private
     */
    var _cache = {};

    /**
     * Link the cache to the entities
     * @type {{}}
     * @private
     */
    var _lookups = {};

    /**
     * Push a memoized function to the service cache
     * @param {string} key
     * @param {memoized} memoized
     * @private
     */
    this._toCache = function (key, memoized) {
      _cache[key] = memoized;
    };

    /**
     * Return a memoized function from the cache
     * @param key
     * @return {memoized}
     * @private
     */
    this._fromCache = function (key) {
      return _cache[key];
    };

    /**
     * Get cache
     * @return {{}}
     * @private
     */
    this._getCache = function () {
      return _cache;
    };

    /**
     * Get lookups
     * @return {{}}
     * @private
     */
    this._getLookups = function () {
      return _lookups;
    };

    /**
     * Apply the input if it is a string or function
     * @param {*|function(): *} input
     * @param args
     * @return {*}
     * @private
     */
    this._apply = function (input, args) {
      return lodash.isFunction(input) ?
        input.apply(null, args) : input
    };

    /**
     * Validate memoize options
     * @param {MemoizeOptions} options
     * @private
     */
    this._validateOptions = function (options) {
      if (!options.link) {
        throw new Error("You need to specify an entity or topic to use as reference for the cached content. " +
          "Format: {type: string, id: string}|function(): {type: string, id: string}")
      }

      if (!options.key) {
        throw new Error("You must specify a cache key, or generate one using the arguments. " +
          "Format: string|function(): string");
      }
    };

    /**
     * @param {string|null}internalKey
     * @param {string|null} serviceKey
     * @return {MemoizeKeys}
     * @private
     */
    this._makeKeys = function (internalKey, serviceKey) {
      return {
        internalKey: internalKey,
        serviceKey: serviceKey
      }
    };

    /**
     * Update lookups without creating duplicates
     * @param {MemoizeKeys} cacheKeys
     * @param {MemoizeKeys[]|undefined} links
     * @return {MemoizeKeys[]}
     * @private
     */
    this._updateLookups = function (
      cacheKeys,
      links
    ) {
      var result;

      if (links) {
        if (lodash.find(links, cacheKeys)) {
          result = links;
        } else {
          result = lodash.concat(links, cacheKeys)
        }
      } else {
        result = [cacheKeys];
      }

      return result;
    };

    /**
     * Get cache path for the given content
     * @param {MemoizeLink} link
     * @param {{}} content
     * @return {string[]}
     * @private
     */
    this._getCachePath = function (link, content) {
      var path = null;

      switch (link.type) {
        case LINK_TYPES.entity:
          path = [link.id, content[link.id]];
          break;
        case LINK_TYPES.topic:
          path = [link.id];
          break;
        default:
          throw new Error("Please define a path for link type '" + link.type + "'");
      }

      return path;
    };

    /**
     * Link content to cache keys
     * @param {MemoizeKeys} cacheKeys
     * @param {{}|{}[]}content
     * @param {MemoizeLink} link
     * @private
     */
    this._link = function (cacheKeys, content, link) {
      var getPath = lodash.partial(this._getCachePath, link);
      var updater = lodash.partial(this._updateLookups, cacheKeys);

      /**
       * If the link type is "entity", then we may set the link id to the ID of the content.
       * Eg. GenericInsight(GenericInsightID) will use GenericInsightID to cache content.
       * Similarly, if the content comes as a list of entities, we cache each item in the list.
       * @example _lookups.GenericInsightID[insight.GenericInsightID] => Promise[]
       */
      if (link.type === LINK_TYPES.entity && lodash.isArray(content)) {
        lodash.forEach(content, function (entry) {
          lodash.updateWith(_lookups, getPath(entry), updater, Object);
        }.bind(this));
      }
      /**
       * If the link type is "topic", then we use that value to group Promises.
       * @example _lookups[link.topic] => Promise[]
       */
      else {
        lodash.updateWith(_lookups, getPath(content), updater, Object);
      }
    };

    /**
     * Memoize an async function
     * @param {function} fn
     * @param {MemoizeOptions} options
     * @return {function(): Promise}
     */
    this.memoize = function (fn, options) {
      options = lodash.assign({
        link: null,
        key: null,
        timeout: _defaultCacheTimeout
      }, options || {});

      this._validateOptions(options);

      /**
       * Make cache keys (for internal use only)
       * @type {MemoizeKeys}
       * @private
       */
      var _cacheKeys = this._makeKeys(null, uuid());

      /**
       * Memoize the function and expose the cache key
       * @type {memoized}
       */
      var memoized = lodash.memoize(fn, function () {
        /**
         * Make an internal cache key for the memoized function
         * @type {string}
         */
        _cacheKeys.internalKey = this._apply(options.key, arguments);

        return _cacheKeys.internalKey;
      }.bind(this));

      /**
       * Keep an eye on the memoized function.
       * One memoized function may have many internal keys.
       */
      this._toCache(_cacheKeys.serviceKey, memoized);

      return function () {
        /**
         * Get all the arguments
         * @type {*[]}
         */
        var args = [].slice.apply(arguments);

        /**
         * Make a deferred
         */
        var dfd = $q.defer();

        /**
         * Call the memoized function, then cache
         */
        memoized.apply(null, arguments).then(function (response) {
          /**
           * Make sure future changes in _cacheKeys do not get carried over
           * @type {MemoizeKeys}
           */
          var cacheKeys = lodash.assign({}, _cacheKeys);

          /**
           * Create a timeout for clearing the cache
           */
          if (!memoized.timeout) {
            /**
             * @type {number}
             */
            memoized.timeout = setTimeout(function () {
              this.clear(cacheKeys);
            }.bind(this), options.timeout);
          }

          /**
           * Set up content linking: topic or entity
           */
          var link = this._apply(options.link, lodash.concat(args, response));

          /**
           * Create the link
           */
          this._link(cacheKeys, response, link);

          dfd.resolve(response);
        }.bind(this), function (error) {
          /**
           * Make sure future changes in _cacheKeys do not get carried over
           * @type {MemoizeKeys}
           */
          var cacheKeys = lodash.assign({}, _cacheKeys);

          /**
           * Invalidate the cache, failed requests do not need caching
           */
          this.clear(cacheKeys);

          dfd.reject(error);
        }.bind(this));

        return dfd.promise;
      }.bind(this);
    };

    /**
     * Get the cache keys at the given path
     * @param {string} descriptor
     * @param {string|number} [id]
     * @return {MemoizeKeys[]|undefined}
     */
    this.lookup = function (descriptor, id) {
      return lodash.get(_lookups, lodash.compact([descriptor, id]));
    };

    /**
     * Invalidate cache keys or clear the whole cache in a given key
     * @param {MemoizeKeys} keys
     */
    this.clear = function (keys) {
      /**
       * @type {Map}
       */
      var cache = this._fromCache(keys.serviceKey).cache;

      if (keys.internalKey) {
        cache.delete(keys.internalKey);
      } else {
        cache.clear();
      }
    };

    /**
     * Invalidate all cache keys for the given descriptor/id pair
     * @param {string} descriptor - topic or entity to invalidate
     * @param {string|number} [id]
     */
    this.invalidate = function (descriptor, id) {
      var cacheKeys = this.lookup(descriptor, id);

      lodash.forEach(cacheKeys, function (key) {
        this.clear(key);
      }.bind(this));
    };

    /**
     * Expose to global for debugging purposes
     * @type {CachingService}
     */
    window.CachingService = this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").service("GamePlanService", GamePlanService);

  /**
   * Game plan functionality
   * @ngInject
   * @param lodash
   * @param $q
   * @param dateTimeService
   * @param CachingService
   * @param $http
   * @param appSessionService
   * @param LocoService
   * @param appConfig
   * @param sessionService
   * @return {GamePlanService}
   * @constructor
   */
  function GamePlanService(
    lodash,
    $q,
    dateTimeService,
    CachingService,
    $http,
    appSessionService,
    LocoService,
    appConfig,
    sessionService
  ) {
    /**
     * Make a scorecard url
     * @private
     */
    var _makeScorecardURL = lodash.template(
      appConfig.SCORECARDURL + "api/scorecard/value/<%= dataDescriptorID %>/<%= farmID %>"
    );

    /**
     * Make a data descriptor URL
     * @private
     */
    var _makeDataDescriptorURL = lodash.template(
      appConfig.DATADICTIONARYURL + "api/datadictionary/<%= dataDescriptorID %>"
    );

    /**
     * Make a game plan URL
     */
    var _makeGamePlanURL = lodash.template(appConfig.GAMEPLANSURL + "gameplans/<%= gamePlanID %>");

    /**
     * Make a URL for updating a game plan task
     */
    var _makeUpdateTaskURL = lodash.template(
      appConfig.GAMEPLANSURL + "gameplans/<%= gamePlanID %>/task/<%= taskID %>"
    );

    /**
     * Store previously fetched game plans
     * @type {{}}
     */
    this.gamePlanState = {};

    /**
     * Game-plan related data descriptors
     * @type {{}}
     */
    this.dataDescriptorState = {};

    /**
     * Game-plan related chart URLs
     * @type {{}}
     */
    this.chartState = {};

    /**
     * Fetch game plans for the given farm id
     * @return {Promise<any>}
     */
    this.fetchGamePlans = CachingService.memoize(
      function () {
        var url = appConfig.GAMEPLANSURL + "gameplans/farms";

        return $http
          .get(url, {
            params: {
              farmID: appSessionService.farm.FarmID
            }
          })
          .then(
            function (response) {
              this.gamePlanState = response.data.reduce(function (state, gp) {
                state[gp.id] = gp;

                return state;
              }, {});

              return this.gamePlanState;
            }.bind(this)
          );
      }.bind(this),
      {
        key: function () {
          return appSessionService.farm.FarmID;
        },
        link: {
          type: "topic",
          id: "game-plans"
        }
      }
    );

    /**
     * Fetch a single game plan
     * @param {string}gamePlanID
     * @return {Promise<any>}
     */
    this.fetchGamePlan = CachingService.memoize(
      function (gamePlanID) {
        var url = _makeGamePlanURL({
          gamePlanID: gamePlanID
        });

        return $http.get(url).then(
          function (response) {
            var gamePlan = response.data;

            this.gamePlanState[gamePlan.id] = gamePlan;

            return gamePlan;
          }.bind(this)
        );
      }.bind(this),
      {
        key: function (gamePlanID) {
          return gamePlanID;
        },
        link: {
          type: "topic",
          id: "game-plans"
        }
      }
    );

    /**
     * Fetch the given data descriptor from the server
     * @param {string} dataDescriptorID
     * @return {Promise<any>}
     */
    this.fetchDataDescriptor = CachingService.memoize(
      function (dataDescriptorID) {
        var url = _makeDataDescriptorURL({
          dataDescriptorID: dataDescriptorID
        });

        return $http.get(url).then(
          function (response) {
            this.dataDescriptorState[dataDescriptorID] = response.data;

            return this.dataDescriptorState[dataDescriptorID];
          }.bind(this)
        );
      }.bind(this),
      {
        key: function (dataDescriptorID) {
          return dataDescriptorID;
        },
        link: {
          type: "topic",
          id: "data-descriptors"
        }
      }
    );

    /**
     * Fetch a mongo chart URL from the server
     * @param {string} mongoChartID
     * @param {{ daysOffset: number, minimumDisplayInterval: number }} options
     */
    this.fetchMongoChart = CachingService.memoize(
      function (mongoChartID, options) {
        var url = appConfig.DATADICTIONARYURL + "api/datadictionary/supportedcharts/rendermongochart";
        /**
         * Check this answer to see why I set the default value  of minimumDisplayInterval to P0
         * https://stackoverflow.com/a/29824127/4468132
         */
        options = lodash.merge({ daysOffset: 0, minimumDisplayInterval: "P0" }, options);
        /**
         * number of days to move the start epoch back from endEpoch
         * @type {number}
         */
        var minimumStartOffsetDuration = dateTimeService.isoDurationValue(options.minimumDisplayInterval);

        var body = {
          chartID: mongoChartID,
          epochEnd: this.getChartEndEpoch(options.daysOffset),
          epochStart: this.getChartStartEpoch(options.daysOffset, minimumStartOffsetDuration),
          farmIDs: [appSessionService.farm.FarmID]
        };

        return $http.post(url, body).then(
          function (response) {
            this.chartState[mongoChartID] = response.data;

            return this.chartState[mongoChartID];
          }.bind(this)
        );
      }.bind(this),
      {
        key: function (mongoChartID) {
          return mongoChartID;
        },
        link: {
          type: "topic",
          id: "mongo-charts"
        }
      }
    );

    /**
     * Fetch the KPI average for the game plan
     * @param {string} dataDescriptorID
     * @param {{ daysOffset: number }} options
     * @return {Promise<any>}
     */
    this.fetchKPIAverage = CachingService.memoize(
      function (dataDescriptorID, options) {
        options = lodash.merge({ daysOffset: 0 }, options);

        var url = _makeScorecardURL({
          dataDescriptorID: dataDescriptorID,
          farmID: appSessionService.farm.FarmID
        });

        return $http.get(url, {
          params: {
            aggregator: "avg",
            rangeEnd: this.getChartEndEpoch(options.daysOffset),
            rangeStart: this.getChartStartEpoch(
              options.daysOffset,
              /**
               * convert seconds to milliseconds
               */
              dateTimeService.MONTH * 1000
            )
          }
        });
      }.bind(this),
      {
        key: function (dataDescriptorID) {
          return dataDescriptorID;
        },
        link: {
          type: "topic",
          id: "kpi-averages"
        }
      }
    );

    /**
     * Update a task in a given game plan
     * @param {string} gamePlanID
     * @param {string} taskID
     * @param {{}} payload
     * @return Promise<any>
     */
    this.updateTask = function (gamePlanID, taskID, payload) {
      var url = _makeUpdateTaskURL({
        gamePlanID: gamePlanID,
        taskID: taskID
      });

      return $http.put(url, payload).then(
        function () {},
        function (e) {
          console.error(e);

          throw new Error("I could not update the game plan task.");
        }
      );
    };

    /**
     * Get translated content
     * @param {string} variant
     * @param {string} suffix
     * @param {{}} metadata
     */
    this.getTranslatedContent = function (variant, suffix, metadata) {
      return LocoService.translate("game-plan", variant, suffix, metadata || {});
    };

    /**
     * Get translated kpi content
     * @param {string} copyKey
     * @param {string} dataTypeName
     */
    this.getTranslatedKpiContent = function (copyKey, dataTypeName) {
      /**
       * We can expect any kind of dataTypeName string from the backend.
       * Everything gets converted to PascalCase.
       * @example
       * // CowsInHerd
       * lodash.upperFirst(lodash.camelCase("cows-In+herd"));
       */
      dataTypeName = lodash.upperFirst(lodash.camelCase(dataTypeName));

      return LocoService.translate(["kpi", copyKey].join("."), dataTypeName);
    };

    /**
     * Get chart config
     * @param {string} chartID
     * @param {array} charts
     * @return {object}
     */
    this.getChart = function (chartID, charts) {
      return (
        charts.find(function (chart) {
          return chart.chartID === chartID;
        }) || lodash.first(charts)
      );
    };

    /**
     * Calculate chart end epoch using dataLagOffsetDays
     * @param {number} dataLagOffset
     * @return {number}
     */
    this.getChartEndEpoch = function (dataLagOffset) {
      return dateTimeService.daysAgo(dataLagOffset) * 1000;
    };

    /**
     * Calculate chart epoch start
     * @param {number} dataLagOffset
     * @param {number} minimumStartOffsetDuration
     * @return {number}
     */
    this.getChartStartEpoch = function (dataLagOffset, minimumStartOffsetDuration) {
      return this.getChartEndEpoch(dataLagOffset) - minimumStartOffsetDuration;
    };

    /**
     * Get all the task from the list of the gameplans depending on the options
     * @param {array} gameplans
     * @param {object} options
     */
    this.getTasks = lodash.memoize(function (gameplans, options) {
      options = lodash.assign(
        {
          getOnlyLoggedInUserTasks: false,
          onlyPendingTasks: false
        },
        options
      );

      /**
       * Populate the gamePlan id in all the tasks
       */
      var tasks = lodash.flatten(
        lodash.map(gameplans, function (gameplan) {
          return lodash.map(gameplan.taskList, function (task) {
            task.gameplanID = gameplan.id;
            return task;
          });
        })
      );

      if (options.getOnlyLoggedInUserTasks) {
        /**
         * Get all the tasks of the logged in user
         */
        tasks = lodash.filter(tasks, function (task) {
          return task.assignedTo === sessionService.user.id;
        });
      }

      /**
       * Get only those tasks that are pending
       */
      if (options.onlyPendingTasks) {
        tasks = lodash.filter(tasks, function (task) {
          return task.status === 0;
        });
      }

      return tasks;
    }.bind(this));

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.gamePlan").controller("GamePlanBaseController", GamePlanBaseController);

  /**
   * Base controller for game plans
   * @ngInject
   * @param vm
   * @param GamePlanService
   * @param $q
   * @param lodash
   * @param authenticationService
   * @param dateTimeService
   * @param userService
   * @param appSessionService
   * @constructor
   */
  function GamePlanBaseController(
    vm,
    GamePlanService,
    $q,
    lodash,
    authenticationService,
    dateTimeService,
    userService,
    appSessionService
  ) {
    vm.getTranslatedContent = GamePlanService.getTranslatedContent;
    vm.getTranslatedKpiContent = GamePlanService.getTranslatedKpiContent;

    /**
     * The data descriptor which the game plan is based on
     * @type {null}
     */
    vm.dataDescriptor = null;

    /**
     * The default mongo chart of the data descriptor
     * @type {null}
     */
    vm.mongoChart = null;

    /**
     * The KPI average of the data descriptor
     * @type {null}
     */
    vm.kpiAverage = null;

    /**
     * The partner info of a game plan
     * @todo this is legacy for backward compatibility only
     * @type {null}
     */
    vm.partner = null;

    /**
     * The user who created the game plan
     * @type {null}
     */
    vm.user = null;

    /**
     * Fetch the data descriptor and the Mongo chart for the game plan
     */
    vm.$onInit = function () {
      GamePlanService.fetchDataDescriptor(vm.gamePlan.dataDescriptorID).then(
        function (dataDescriptor) {
          vm.dataDescriptor = dataDescriptor;

          /**
           * @type {object}
           */
          var chartConfig = GamePlanService.getChart(
            dataDescriptor.defaultMongoChartsID,
            dataDescriptor.supportedCharts
          );

          GamePlanService.fetchMongoChart(chartConfig.chartID, {
            daysOffset: chartConfig.dataLagOffsetDays,
            minimumDisplayInterval: chartConfig.minimumDisplayInterval
          }).then(
            function (mongoChart) {
              vm.mongoChart = mongoChart;
            },
            function (e) {
              console.error("I could not fetch your Mongo chart.", e);
            }
          );

          GamePlanService.fetchKPIAverage(dataDescriptor.id, {
            daysOffset: dataDescriptor.currentValueOffsetDaysAgo
          }).then(
            function (response) {
              vm.kpiAverage = response.data.value;
            },
            function (e) {
              console.error("I could not fetch your KPI average.", e);
            }
          );
        },
        function (e) {
          console.error("I could not fetch your data descriptor.", e);
        }
      );

      if (vm.gamePlan.createdBy) {
        vm.getUserInfo(vm.gamePlan.createdBy);
      }
    };

    /**
     * Get a human readable KPI value
     * @param value
     * @return {string}
     */
    vm.getHumanReadableMeta = function (value) {
      var loading = "...";

      if (vm.dataDescriptor && value) {
        var unit = vm.dataDescriptor.valueUnit;

        /**
         * Make a nicely formatted "1234 kg" or "23%"
         * @type {string}
         */
        var joiner = unit === "%" ? "" : " ";

        return [(+value).toFixed(2), unit].join(joiner);
      }

      return loading;
    };

    /**
     * Get a translated "created by" value
     * @return {string}
     */
    vm.getCreatedBy = function () {
      /**
       * Show ...(ellipses) when we do not have information for created by
       * @type {string}
       */
      var createdBy = "...";

      /**
       * If we have the partner information, then extract the user information out of that.
       * Otherwise fallback to game plan createdBy
       */
      if (vm.user) {
        createdBy = userService.getDisplayName(vm.user);
      }

      return GamePlanService.getTranslatedContent("label", "created-by", {
        createdBy: createdBy
      });
    };

    /**
     * Get user information for game plan
     */
    vm.getUserInfo = function () {
      userService.getAllUsers().then(
        function () {
          vm.updateUserInfo();
        },
        function (e) {
          console.log("I could not fetch the user info.", e);
        }
      );
    };

    /**
     * Return the game plan date range
     * @return {string}
     */
    vm.getDateRange = function () {
      var format = lodash.partialRight(dateTimeService.asDateString, "DD MMMM YYYY");

      return [format(vm.gamePlan.startEpoch / 1000), format(vm.gamePlan.endEpoch / 1000)].join(" - ");
    };

    /**
     * Update the partner info
     */
    vm.updateUserInfo = function () {
      vm.user = userService.resolveFromUserID(vm.gamePlan.createdBy);
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.baseStation", [
      "ngLodash"
    ]);
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.baseStation").service("baseStationService", baseStationService);

  /**
   * @ngInject
   * @param lodash
   * @param $rootScope
   * @param $odataresource
   * @param $http
   * @param appConfig
   * @param appSessionService
   * @param sessionService
   * @param $log
   * @todo clean up and write unit tests
   */
  function baseStationService(
    lodash,
    $rootScope,
    $odataresource,
    $http,
    appConfig,
    appSessionService,
    sessionService,
    $log
  ) {
    /**
     * Store all base stations
     * @type {null}
     */
    this.baseStations = null;

    /**
     * Base station oData endpoint
     */
    var BaseStation = $odataresource(
      appConfig.APIURL + "odata/BaseStations",
      {},
      {},
      {
        odatakey: "BaseStationID"
      }
    );

    /**
     * Get base stations
     * @param options
     * @return {null|*}
     */
    this.getBaseStations = function (options) {
      options = lodash.assign(
        {
          refetch: false
        },
        options || {}
      );

      if (options.refetch || !this.baseStations) {
        var farmID = appSessionService.farmID;

        $log.debug("[BASE STATIONS] Fetching base stations from the database");

        this.baseStations = BaseStation.odata().filter("farmID", farmID).query();
      }

      return this.baseStations;
    };

    /**
     * Get single base station
     * @param id
     * @return {*}
     */
    this.getBaseStation = function (id) {
      return BaseStation.odata().filter("BaseStationID", id).single();
    };

    /**
     * Update base station mapping
     * @param sensor
     * @param cow
     * @return {*}
     */
    this.updateBaseStationMapping = function (sensor, cow) {
      /**
       * @type {{method: string, url: string, data: {farmName: *, baseStationID: *, nodeID: *,
       * sensorSerial: string, cowID: (string), cowTagNumber: *, user: (emailInputType|Document.email|null|*|Kr|Oc)}}}
       */
      var req = {
        method: "POST",
        url: "https://ida-nodejs.azurewebsites.net/updateBaseStationMapping",
        data: {
          farmName: appSessionService.farm.farmName,
          baseStationID: sensor.baseStationID,
          nodeID: cow.nodeID ? sensor.NodeID : "UNLINKED " + sensor.NodeID,
          sensorSerial: cow.nodeID ? sensor.shortSerialNum : "UNLINKED " + sensor.shortSerialNum,
          cowID: cow.DairyCowID,
          cowTagNumber: cow.cowTagNumber,
          user: sessionService.user.email
        }
      };

      return $http(req);
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.askIda").controller("AskIdaController", AskIdaController);

  /**
   * Base controller for generic insights
   * @ngInject
   * @param vm
   * @param LocoService
   * @param lodash
   * @param appSessionService
   * @constructor
   */
  function AskIdaController(vm, LocoService, lodash, appSessionService) {
    /**
     * Format weight units
     * @param {number} value
     * @return {string}
     */
    vm.formatWeight = function (value) {
      var unitSystem = lodash.get(appSessionService, ["localization", "unitSystem"], "SI");
      var convertedValue = unitSystem === "SI" ? value : (value * 2.20462).toFixed(2); // convert to pounds
      var unit = unitSystem === "SI" ? "kg" : "lb";

      return [convertedValue, unit].join(" ");
    };

    /**
     * @type {{standing: string, laying: string, walking: string, eating: string, rumination: string, milkYield: string}}
     */
    vm.effectMap = {
      rumination: "Ruminating",
      laying: "Laying",
      walking: "Walking",
      eating: "Eating",
      standing: "Standing",
      milkYield: "MilkYield"
    };

    /**
     * Format minutes
     * @param {number} value
     * @param {boolean} abbreviated
     * @return {string}
     */
    vm.formatTime = function (value, abbreviated) {
      var secString = LocoService.translate(abbreviated ? "secondAbbreviation" : "seconds");
      var minString = LocoService.translate(abbreviated ? "minuteAbbreviation" : "minutes");
      var hrString = LocoService.translate(abbreviated ? "hourAbbreviation" : "hours");

      var hours = Math.floor(value);
      var minutes = Math.floor((value * 3600 - hours * 3600) / 60);
      var seconds = Math.floor(value * 3600 - minutes * 60 - hours * 3600);
      var output = seconds ? seconds + " " + secString : seconds;

      if (minutes) {
        output = minutes + " " + minString;
      }

      if (hours) {
        output = hours + " " + hrString + (minutes ? " " + minutes + " " + minString : "");
      }

      return output;
    };

    /**
     * @type {{
     *   MilkYield: {labels: formatWeight, changeDelta: changeDelta, values: values},
     *   defaultFormatters: {labels: formatTime, changeDelta: changeDelta, values: values}, get: get
     * }}
     */
    vm.Formatters = {
      MilkYield: {
        labels: vm.formatWeight,

        /**
         * @param {{ValueBefore, ValueAfter, ExpectedAfter, ExpectedBefore}} change
         * @return {{before: string, after: string}}
         */
        values: function (change) {
          return {
            before: (change.ExpectedBefore || change.ValueBefore).toFixed(2),
            after: (change.ExpectedAfter || change.ValueAfter).toFixed(2)
          };
        },

        /**
         * @param {{ValueChangePercentage, ExpectedBefore, ExpectedAfter}} change
         * @return {string}
         */
        changeDelta: function (change) {
          var expectedPercentage = null;

          if (change.ExpectedBefore && change.ExpectedAfter) {
            expectedPercentage = ((change.ExpectedAfter / change.ExpectedBefore) - 1) * 100;
          }

          /**
           * @note use the one below for weight
           * Math.abs(change.ValueBefore - change.ValueAfter).toFixed(2);
           */
          return Math.abs(expectedPercentage || change.ValueChangePercentage).toFixed(1);
        }
      },

      defaultFormatters: {
        labels: vm.formatTime,

        /**
         * @param {{ValueBefore, ValueAfter}} change
         * @return {{before: number, after: number}}
         */
        values: function (change) {
          return {
            before: change.ValueBefore / 3600,
            after: change.ValueAfter / 3600
          };
        },

        /**
         * @param {{ValueBefore, ValueAfter, ValueChangePercentage}} change
         * @return {number}
         */
        changeDelta: function (change) {
          return Math.abs(change.ValueChangePercentage).toFixed(1);
        }
      },

      /**
       * Get formatters for the given chart type.
       * @param key
       * @return {*|defaultFormatters|{labels, values}}
       */
      get: function (key) {
        return vm.Formatters[key] || vm.Formatters.defaultFormatters;
      }
    };

    /**
     * Check if we have answers be comparing the results with the expected behaviors
     */
    vm.isAnalysed = function () {
      /**
       * Pick the desired effects from the question
       * @type {Array}
       */
      var desiredEffects = lodash.values(
        lodash.pick(vm.effectMap, lodash.map(this.idaQuestion.question.effects, "effect"))
      );

      /**
       * Get the answers
       * @type {Array}
       */
      var answers = lodash.keys(lodash.get(vm.idaQuestion, ["answer", "Results"], {}));

      return lodash.intersection(desiredEffects, answers).length > 0;
    };

    /**
     *
     * @param content
     * @param options
     */
    vm.translateContent = function (content, options) {
      return LocoService.translate("ask-ida", content, options);
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.area", [
      "ngLodash"
    ]);
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.area")
    .service("areaService", AreaService);

  /**
   * @ngInject
   * @param $odataresource
   * @param appConfig
   * @param $q
   * @param lodash
   * @param CachingService
   * @param appSessionService
   * @return {AreaService}
   * @constructor
   */
  function AreaService ($odataresource, appConfig, $q, lodash, CachingService, appSessionService) {
    /**
     * Make an oData endpoint for areas
     */
    var Area = $odataresource(appConfig.APIURL + "odata/Areas", {}, {}, { odatakey: "AreaID" });

    /**
     * Area state
     * @type {{[areaID]: {}}}
     * @private
     */
    var _areas = {};

    /**
     * Fetch areas for the given farm id and store locally
     * @param {number} farmID
     * @return {Promise}
     */
    this.getAreas = CachingService.memoize(function (farmID) {
      var dfd = $q.defer();

      /**
       * Default farmID to the current farm id
       */
      farmID = farmID || appSessionService.farmID;

      /**
       * @type {Promise}
       */
      var promise = Area.odata().filter("farmID", farmID).query().$promise;

      promise.then(function (areas) {
        _areas = areas.reduce(function (state, area) {
          state[area.AreaID] = area;

          return state;
        }, {});

        dfd.resolve(lodash.values(_areas));
      }, function (error) {
        dfd.reject(error);
      });

      return dfd.promise;
    }, {
      key: function (farmID) {
        return farmID;
      },
      link: {
        type: "topic",
        id: "areas"
      }
    });

    /**
     * Fetch single area
     * @param {number} areaID
     * @return {Promise}
     */
    this.getArea = CachingService.memoize(function (areaID) {
      var promise, existing = _areas[areaID];

      if (existing) {
        var dfd = $q.defer();

        dfd.resolve(existing);

        promise = dfd.promise;
      } else {
        promise = Area.odata().filter("AreaID", areaID).single().$promise;

        promise.then(function (area) {
          _areas[area.AreaID] = area;
        });
      }

      return promise;
    }, {
      key: function (areaID) {
        return areaID;
      },
      link: {
        type: "topic",
        id: "areas"
      }
    });

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents", [
    "ctraUIComponents.insight",
    "ctraUIComponents.genericInsight",
    "ctraUIComponents.sensor",
    "ctraUIComponents.baseStation",
    "ctraUIComponents.labels",
    "ctraUIComponents.odataUtils",
    "ctraUIComponents.insightList",
    "ctraUIComponents.icons",
    "ctraUIComponents.sharing",
    "ctraUIComponents.navigation",
    "ctraUIComponents.caching",
    "ctraUIComponents.area",
    "ctraUIComponents.utils",
    "ctraUIComponents.notification",
    "ctraUIComponents.loco",
    "ctraUIComponents.modal",
    "ctraUIComponents.gamePlan",
    "ctraUIComponents.gamePlanList"
  ]);
})();

(function () {
  "use strict";
  angular
    .module("ctraUIComponents")
    .directive("goForward", goForward);

  /**
   * @return {{restrict: string, controller: goForwardLink}}
   * @ngInject
   */
  function goForward () {
    /**
     * @type {{restrict: string, controller: goForwardLink}}
     */
    var directive = {
      restrict: "A",
      controller: goForwardLink
    };

    return directive;

    /**
     * @param $scope
     * @param $element
     * @param pageTransitionService
     * @ngInject
     */
    function goForwardLink ($scope, $element, pageTransitionService) {
      $element.bind("click", goForward);

      function goForward () {
        pageTransitionService.goForward();
      }
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("ctraUIComponents")
    .directive("goBack", goBack);

  /**
   * @return {{restrict: string, controller: goBackLink}}
   * @ngInject
   */
  function goBack () {
    /**
     * @type {{restrict: string, controller: goBackLink}}
     */
    var directive = {
      restrict: "A",
      controller: goBackLink
    };

    return directive;

    /**
     * @param $scope
     * @param $element
     * @param pageTransitionService
     * @ngInject
     */
    function goBackLink ($scope, $element, pageTransitionService) {
      $element.bind("click", goBackward);

      function goBackward () {
        pageTransitionService.goBackward();
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.labels.newLabel", [
      "ctraUIComponents.labels.labelDetailsForm"
    ]);
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.labels.newLabel").component("newLabel", {
    controller: newLabelCtrl,
    templateUrl: "app/shared-components/angular-ui-components/components/labels/newLabel/newLabel.html",
    bindings: {
      label: "<",
      farms: "<",
      hideFields: "<"
    }
  });

  /**
   * @param $window
   * @param $timeout
   * @param $state
   * @param sessionService
   * @param labelService
   * @param toastr
   * @param $translate
   * @param dataApiService
   * @param authenticationService
   * @param pageTransitionService
   * @param cowService
   * @ngInject
   */
  function newLabelCtrl(
    $window,
    $timeout,
    $state,
    sessionService,
    labelService,
    toastr,
    $translate,
    dataApiService,
    authenticationService,
    pageTransitionService,
    cowService
  ) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.save = save;
    $ctrl.labelFormValid = labelFormValid;

    /**
     * Init
     */
    function onInit() {
      $ctrl.label.createdByUserID = sessionService.user.id;

      if (authenticationService.isAuthorized("Admin")) {
        $ctrl.label.customerVisible = false;
        $ctrl.label.tags = ["curated"];
      } else {
        $ctrl.label.customerVisible = true;
      }

      $ctrl.label = labelService.newLabel($ctrl.label);

      if (!!$ctrl.label.dairyCowID || !!$ctrl.label.title) {
        $ctrl.themedHeader = true;
      }
    }

    /**
     * Validate label form
     * @return {boolean}
     */
    function labelFormValid() {
      var hasTitle = $ctrl.label.title;
      var hasCowID = $ctrl.label.labelScope === "cow" && $ctrl.label.dairyCowID;
      var isHerdEvent = $ctrl.label.labelScope === "herd" && $ctrl.label.herdGroupID;
      var hasEpoch = $ctrl.label.startEpoch && $ctrl.label.endEpoch;
      var dateValid = $ctrl.label.startEpoch <= $ctrl.label.endEpoch;
      var isFarmEvent = $ctrl.label.labelScope === "farm";

      return (!!hasTitle && !!(hasCowID || isHerdEvent) && !!hasEpoch && dateValid) || isFarmEvent;
    }

    /**
     * Save
     * @param obj
     * @return {boolean}
     */
    function save(obj) {
      if (labelFormValid()) {
        /**
         * @type {string}
         */
        $ctrl.error = "";

        /**
         * @type {string}
         */
        $ctrl.success = "";

        /**
         * @type {boolean}
         */
        $ctrl.loading = true;

        labelService.saveLabel(obj).then(
          function (label) {
            cowService.getCow(label.dairyCowID, { localFetch: false }).then(function (cow) {
              cowService.updateLocalCowData(label.dairyCowID ,cow);
              successCallback()
            }, function () {
              successCallback()
            });
          },
          function () {
            $ctrl.loading = false;
            $ctrl.error = $translate.instant("LABEL_TEXT_OOPS");
            toastr.error($translate.instant("LABEL_TEXT_OOPS"));
          }
        );
      } else {
        $window.alert("Please fill in the required fields");
      }
    }

    function successCallback() {
      $ctrl.loading = false;
      toastr.success($translate.instant("LABEL_TEXT_SAVED"));
      dataApiService.clearDataFromCache("GenericLabels");
      pageTransitionService.goBackward();
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.labels.labelsList", [])
    .component("labelsList", {
      bindings: {
        labels: "<"
      },
      controller: labelsListCtrl,
      templateUrl: "app/shared-components/angular-ui-components/components/labels/labelsList/labelsList.html"
    });

  /**
   * @param $state
   * @param insightService
   * @param cowService
   * @param toastr
   * @param $translate
   * @ngInject
   */
  function labelsListCtrl ($state, insightService, cowService, toastr, $translate) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.rowClicked = rowClicked;
    $ctrl.update = update;
    $ctrl.delete = deleteObj;
    $ctrl.addSpaces = addSpaces;

    /**
     * Init
     */
    function onInit () {
      $ctrl.cows = cowService.getCows();
    }

    /**
     * Handle row clicked
     * @param label
     */
    function rowClicked (label) {
      $state.go("label", { genericLabelID: label.GenericLabelID });
    }

    /**
     * Update label list
     * @param obj
     */
    function update (obj) {
      $ctrl.loading = true;

      obj.$update().then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_SAVED"));
      }, function () {
        $ctrl.loading = false;
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });
    }

    /**
     * Delete label
     * @param obj
     */
    function deleteObj (obj) {
      $ctrl.loading = true;

      obj.$delete().then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_DELETED"));

        $ctrl.labels = $ctrl.labels.filter(function (e) {
          return e.GenericLabelID !== obj.GenericLabelID;
        });
      }, function () {
        $ctrl.loading = false;
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });
    }

    /**
     * Add spaces
     * @param string
     * @return {*}
     */
    function addSpaces (string) {
      return string.replace(/([a-z])(?=[A-Z])/g, "$1 ").trim();
    }
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.labels.labelEvents", []).component("labelEvents", {
    controller: labelEventController,
    templateUrl: "app/shared-components/angular-ui-components/components/labels/labelEvents/labelEvents.html",
    bindings: {
      labelEventType: "@",
      selectedEventIds: "<",
      updateEvent: "&"
    }
  });

  /**
   * @ngInject
   * @param lodash
   * @param labelService
   * @return {labelEventController}
   */
  function labelEventController(lodash, labelService) {
    this.activeEvents = [];
    this.showAddOtherForm = false;
    this.customEvent = "";

    /**
     * Group events
     * @type {{active: boolean, id: string, title: string, labelEventType: string}[]}
     */
    this.events = labelService.events;

    this.$onInit = function () {
      this.activeEvents = lodash.filter(this.events, { labelEventType: this.labelEventType });

      lodash.map(
        this.selectedEventIds,
        function (eventId) {
          var event = null;
          var selectedEvent = lodash.find(this.activeEvents, { id: eventId });

          if (selectedEvent) {
            lodash.find(this.activeEvents, { id: eventId }).active = true;
          } else {
            this.activeEvents.push({
              labelEventType: "group_event",
              id: eventId,
              title: lodash.join(lodash.split(eventId, "_"), " "),
              active: true
            });
          }

          return event;
        }.bind(this)
      );
    };

    /**
     * Get the id list of all active events
     * @return {string[]}
     */
    this.getActiveEventIds = function () {
      return lodash.map(lodash.filter(this.activeEvents, { active: true }), "id");
    };

    /**
     * Add an event to the active event list
     * @param event
     */
    this.addEvent = function (event) {
      /**
       * If the event is already in the event list, toggle its active state
       * @type {boolean}
       */
      lodash.find(this.activeEvents, { id: event.id }).active = true;

      this.updateEvent({ events: this.getActiveEventIds() });
    }.bind(this);

    /**
     * Remove the event from the active event. If it is a custom event,
     * then remove it from the active event array, otherwise toggle its active flag.
     * @param eventToRemove
     */
    this.removeEvent = function (eventToRemove) {
      var isCustomEvent = !lodash.find(this.events, { id: eventToRemove.id });

      if (isCustomEvent) {
        this.activeEvents = lodash.filter(this.activeEvents, function (event) {
          return event.id !== eventToRemove.id;
        });
      } else {
        lodash.find(this.activeEvents, { id: eventToRemove.id }).active = false;
      }

      this.updateEvent({ events: this.getActiveEventIds() });
    }.bind(this);

    /**
     * Save a custom event
     */
    this.saveCustomEvent = function () {
      var eventId = lodash.join(lodash.split(this.customEvent, " "), "_");

      this.activeEvents.push({
        labelEventType: "group_event",
        id: eventId,
        title: this.customEvent,
        active: true
      });

      this.updateEvent({ events: this.getActiveEventIds() });
      this.toggleAddOtherForm();
    }.bind(this);

    /**
     * Toggle form for adding a custom event
     */
    this.toggleAddOtherForm = function () {
      this.showAddOtherForm = !this.showAddOtherForm;
      this.customEvent = "";
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.labels.labelDetailsForm", ["ctraUIComponents.labels.labelEvents"])
    .component("labelDetailsForm", {
      bindings: {
        label: "=",
        hideFields: "<",
        themedHeader: "<",
        farms: "<",
        limitedTags: "<"
      },
      controller: labelDetailsFormCtrl,
      templateUrl:
        "app/shared-components/angular-ui-components/components/labels/labelDetailsForm/labelDetailsForm.html"
    });

  /**
   * @ngInject
   * @param $scope
   * @param $state
   * @param cowService
   * @param dataVariablesService
   * @param lodash
   * @param labelService
   * @param dateTimeService
   * @param pageTransitionService
   * @param authenticationService
   * @param herdGroupService
   */
  function labelDetailsFormCtrl(
    $scope,
    $state,
    cowService,
    dataVariablesService,
    lodash,
    labelService,
    dateTimeService,
    pageTransitionService,
    authenticationService,
    herdGroupService
  ) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.addTagToLabel = addTagToLabel;
    $ctrl.removeTagFromLabel = removeTagFromLabel;
    $ctrl.isEstrusLabel = isEstrusLabel;
    $ctrl.loadFarmData = loadFarmData;
    $ctrl.changeLabelCategory = changeLabelCategory;
    $ctrl.changeLabelScope = changeLabelScope;
    $ctrl.changeLabelSubject = changeLabelSubject;
    $ctrl.onDateChange = onDateChange;
    $ctrl.onRangePickerChanged = onRangePickerChanged;
    $ctrl.onInsightClicked = onInsightClicked;
    $ctrl.manualStartChanged = manualStartChanged;
    $ctrl.manualEndChanged = manualEndChanged;
    $ctrl.toggleMarkers = toggleMarkers;
    $ctrl.updateEvent = updateEvent;

    /**
     * Tell if the data picker is enabled
     * @return {boolean}
     */
    $ctrl.isDatePickerEnabled = function () {
      var onFarm = $ctrl.label.labelScope === "farm";
      var hasVisualisations = $ctrl.visualisations || $ctrl.label.labelScope === "herd";
      var hasID = $ctrl.label.dairyCowID || $ctrl.label.herdGroupID;

      return onFarm || (hasVisualisations && hasID);
    };

    /**
     * This is just a piece of steaming shit. Angular getter/setter, I hate you.
     * Need to pass the whole now epoch from asDateString and then back to epoch because we need to remove seconds
     * @see https://docs.angularjs.org/api/ng/directive/ngModel#binding-to-a-getter-setter
     */
    var dtpStartEpoch = dateTimeService.asEpoch(
        dateTimeService.asDateString(dateTimeService.now() - dateTimeService.HOUR * 3, "MM/DD/YYYY, HH:mm")
      ),
      dtpEndEpoch = dateTimeService.asEpoch(
        dateTimeService.asDateString(dateTimeService.now() + dateTimeService.HOUR * 2, "MM/DD/YYYY, HH:mm")
      ),
      dtpStartDate = dateTimeService.asDate(dtpStartEpoch),
      dtpEndDate = dateTimeService.asDate(dtpEndEpoch);

    /**
     * @type {Array}
     */
    $ctrl.events = [];

    /**
     * Private label object with start and end which come from the date-time imput.
     * This gets later converted to epoch and copied to the label. Big ZBAGHETTI, but
     * need it fast.
     * @type {{startEpoch: startEpoch, endEpoch: endEpoch}}
     * @private
     */
    $ctrl._label = {
      /**
       * Get or set a start epoch. When value is present, we set.
       * @param value
       * @return {*}
       */
      startEpoch: function (value) {
        var result, asEpoch;

        if (value) {
          asEpoch = dateTimeService.asEpoch(value);
          result = dtpStartEpoch = asEpoch;
          dtpStartDate = dateTimeService.asDate(dtpStartEpoch);
        } else {
          result = dtpStartDate;
        }

        return result;
      },

      /**
       * Get or set an end epoch. When value is present, we set.
       * @param value
       * @return {*}
       */
      endEpoch: function (value) {
        var result, asEpoch;

        if (value) {
          asEpoch = dateTimeService.asEpoch(value);
          result = dtpEndEpoch = asEpoch;
          dtpEndDate = dateTimeService.asDate(dtpEndEpoch);
        } else {
          result = dtpEndDate;
        }

        return result;
      }
    };

    /**
     * @type {boolean}
     */
    $ctrl.isAuthorized = authenticationService.isAuthorized;

    /**
     * Estrus labels.
     * @todo Move into constant which gets filled up from back-end. No hardcoded strings please. :)
     * @type {string[]}
     */
    $ctrl.ESTRUS_LABEL_TITLES = ["Estrus"];

    /**
     * Store the label markers when they get disabled so we can toggle them
     */
    $ctrl.hasMarkers = false;
    var labelMarkers;

    /**
     * Init
     */
    function onInit() {
      /**
       * @type {string[]}
       */
      $ctrl.labelScopes = ["cow", "herd", "farm"];

      /**
       * @type {*[]}
       */
      $ctrl.labelCategories = [
        {
          name: "health",
          id: "health"
        },
        {
          name: "feed",
          id: "feed"
        },
        {
          name: "fertility",
          id: "fertility"
        },
        {
          name: "system",
          id: "system"
        },
        {
          name: "other",
          id: "other"
        }
      ];

      /**
       * @type {string[]}
       */
      $ctrl.tags =
        $ctrl.limitedTags && $ctrl.limitedTags.length > 0
          ? $ctrl.limitedTags
          : ["checked", "curated", "no estrus found", "fuzzy", "farmer reported"];

      if (!$ctrl.label.GenericLabelID) {
        $ctrl.label.category = $ctrl.label.category || $ctrl.labelCategories[0].id;
        $ctrl.label.title = $ctrl.label.title || "";
        $ctrl.label.labelScope = $ctrl.label.labelScope || $ctrl.labelScopes[0];
        $ctrl.label.dairyCowID = $ctrl.label.dairyCowID || null;
        $ctrl.label.startEpoch = $ctrl.label.startEpoch || dtpStartEpoch;
        $ctrl.label.endEpoch =
          $ctrl.label.endEpoch ||
          ($ctrl.label.duration ? $ctrl.label.startEpoch + $ctrl.label.duration : dtpEndEpoch);
        $ctrl.label.tags = $ctrl.label.tags || [];
      } else {
        dtpStartDate = dateTimeService.asDate($ctrl.label.startEpoch);
        dtpEndDate = dateTimeService.asDate($ctrl.label.endEpoch);
      }

      $ctrl.hasMarkers =
        $ctrl.label.description &&
        $ctrl.label.description.markers &&
        $ctrl.label.description.markers.length > 0;
      $ctrl.showMarkers = $ctrl.hasMarkers;

      /**
       * @type {Array}
       */
      $ctrl.events = lodash.compact(lodash.split($ctrl.label.title, ","));

      loadFarmData();
      initCharts();
    }

    /**
     * Load farm data
     */
    function loadFarmData() {
      if ($ctrl.label.farmID) {
        $ctrl.cows = cowService.getCows($ctrl.label.farmID);
      } else {
        $ctrl.cows = null;
      }
      $ctrl.herdGroups = herdGroupService.getHerdGroups($ctrl.label.farmID);
      changeLabelSubject();
    }

    /**
     * Add tag
     * @param tag
     */
    function addTagToLabel(tag) {
      return labelService.addTag($ctrl.label, tag, {
        updateLabel: false
      });
    }

    /**
     * Remove tag
     * @param tag
     */
    function removeTagFromLabel(tag) {
      return labelService.removeTag($ctrl.label, tag, {
        updateLabel: false
      });
    }

    /**
     * Tell whether the given label is an estrus label.
     * @param label
     * @returns {boolean}
     */
    function isEstrusLabel(label) {
      return $ctrl.ESTRUS_LABEL_TITLES.indexOf(label.title) > -1;
    }

    /**
     * Change label category
     * @param type
     */
    function changeLabelCategory(type) {
      $ctrl.label.category = type;
      refreshCharts();
    }

    /**
     * Change label scope
     * @param subject
     */
    function changeLabelScope(subject) {
      if (subject === "herd") {
        $ctrl.label.dairyCowID = null;
      }

      if ($ctrl.label.labelScope !== subject) {
        $ctrl.label.labelScope = subject;
        changeLabelSubject();
      }
    }

    /**
     * Change label subject
     */
    function changeLabelSubject() {
      refreshCharts();
    }

    /**
     * Init charts
     */
    function initCharts() {
      /**
       * @type {{}}
       */
      $ctrl.rangePickerObj = {};

      /**
       * @type {number}
       */
      $ctrl.rangePickerObj.startEpoch = $ctrl.label.startEpoch;

      /**
       * @type {number}
       */
      $ctrl.rangePickerObj.endEpoch = $ctrl.label.endEpoch;

      /**
       * @type {string}
       */
      $ctrl.rangePickerObj.id = $ctrl.label.GenericLabelID || "temp_insight_id";

      /**
       * @type {{}}
       */
      $ctrl.rangePickerObj.origin = $ctrl.label;

      $ctrl.rangePickerObj.markers = $ctrl.label.description ? $ctrl.label.description.markers || [] : [];

      /**
       * @type {number}
       */
      var labelLengthSeconds = $ctrl.label.endEpoch - $ctrl.label.startEpoch;

      /**
       * @type {number}
       */
      var centerEpoch = ($ctrl.label.startEpoch + labelLengthSeconds / 2) * 1000;

      /**
       * @type {Date}
       */
      $ctrl.startDate = new Date(centerEpoch);

      /**
       * @type {Date}
       */
      $ctrl.endDate = new Date(centerEpoch);

      /**
       * If a label is longer than 3 days, make the view range 7 day
       * @type {number}
       */
      if (labelLengthSeconds / 86400 < 3) {
        $ctrl.dayRange = 3;
      } else if (labelLengthSeconds / 86400 < 7) {
        $ctrl.dayRange = 7;
      } else {
        $ctrl.dayRange = 31;
      }

      $ctrl.startDate.setDate($ctrl.startDate.getDate() - $ctrl.dayRange / 2);
      $ctrl.endDate.setDate($ctrl.endDate.getDate() + $ctrl.dayRange / 2);

      refreshCharts();
    }

    /**
     * Refresh charts
     * @return {boolean}
     */
    function refreshCharts() {
      var hasRangePicker = $ctrl.rangePickerObj;
      var hasFarmID = $ctrl.label.farmID;
      var hasLabelScope = $ctrl.label.labelScope;
      var hasCowID = $ctrl.label.labelScope === "cow" && $ctrl.label.dairyCowID;

      if (hasRangePicker && hasFarmID && hasLabelScope && hasCowID) {
        $ctrl.rangePickerObj.color = $ctrl.label.category;

        dataVariablesService
          .getLabelVisualisations($ctrl.label.labelScope, $ctrl.label.category, {
            cow: $ctrl.label.dairyCowID,
            farm: $ctrl.label.farmID
          })
          .then(function (visualisations) {
            $ctrl.visualisations = visualisations;
          });
      } else {
        $ctrl.visualisations = null;
      }
    }

    /**
     * Handle date change
     * @param startDate
     * @param endDate
     */
    function onDateChange(startDate, endDate) {
      $ctrl.startDate = startDate;
      $ctrl.endDate = endDate;

      $scope.$apply();
    }

    /**
     * Handle change of date-time picker start
     */
    function manualStartChanged() {
      $ctrl.rangePickerObj.startEpoch = dtpStartEpoch;
      $ctrl.onRangePickerChanged($ctrl.rangePickerObj, {
        applyScope: false
      });

      refreshCharts();
    }

    /**
     * Handle change of date-time picker end
     */
    function manualEndChanged() {
      $ctrl.rangePickerObj.endEpoch = dtpEndEpoch;
      $ctrl.onRangePickerChanged($ctrl.rangePickerObj, {
        applyScope: false
      });

      refreshCharts();
    }

    function toggleMarkers() {
      if ($ctrl.rangePickerObj.markers && $ctrl.rangePickerObj.markers.length) {
        labelMarkers = $ctrl.rangePickerObj.markers;
        $ctrl.rangePickerObj.markers = [];
      } else {
        $ctrl.rangePickerObj.markers = labelMarkers;
      }
      $ctrl.onRangePickerChanged($ctrl.rangePickerObj, {
        applyScope: false
      });

      refreshCharts();
    }

    /**
     * Handle range change
     * @param rangePicker
     */
    function onRangePickerChanged(rangePicker, params) {
      params = lodash.assign(
        {
          applyScope: true
        },
        params || {}
      );

      $ctrl.rangePickerObj = rangePicker;
      $ctrl.label.startEpoch = rangePicker.startEpoch;
      $ctrl.label.endEpoch = rangePicker.endEpoch;
      if ($ctrl.label.description && $ctrl.label.description.markers) {
        $ctrl.label.description.markers = lodash.cloneDeep(rangePicker.markers);

        // The graph adds a lot of properties to the markers
        //  let's remove the unwanted properties, only keep title and epoch
        var validKeys = ["title", "epoch"];
        angular.forEach($ctrl.label.description.markers, function (marker) {
          Object.keys(marker).forEach(function (key) {
            return validKeys.includes(key) || delete marker[key];
          });
        });
      }

      if (params.applyScope) {
        $ctrl._label.startEpoch(dateTimeService.asDate(rangePicker.startEpoch));
        $ctrl._label.endEpoch(dateTimeService.asDate(rangePicker.endEpoch));

        $scope.$apply();
      }
    }

    /**
     * Handle insight clicked
     * @param insight
     */
    function onInsightClicked(insight) {
      pageTransitionService.goForward();

      if (insight.GenericInsightID) {
        $state.go("insight", {
          genericInsightID: insight.GenericInsightID
        });
      }

      if (insight.GenericLabelID) {
        $state.go("label", {
          genericLabelID: insight.GenericLabelID
        });
      }
    }

    /**
     *
     * @param events
     */
    function updateEvent(events) {
      $ctrl.label.title = lodash.join(events, ",");
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.labels.editLabel", [
      "ctraUIComponents.labels.labelDetailsForm"
    ]);
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.labels.editLabel")
    .component("editLabel", {
      controller: editLabelCtrl,
      templateUrl: "app/shared-components/angular-ui-components/components/labels/editLabel/editLabel.html",
      bindings: {
        label: "<"
      }
    });

  /**
   * @param $window
   * @param $scope
   * @param $state
   * @param sessionService
   * @param labelService
   * @param cowService
   * @param toastr
   * @param $translate
   * @param dataApiService
   * @param pageTransitionService
   * @ngInject
   */
  function editLabelCtrl ($window, $scope, $state, sessionService, labelService,
                          cowService, toastr, $translate, dataApiService, pageTransitionService) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.update = update;
    $ctrl.delete = deleteLabel;

    function onInit () {
      $ctrl.cows = cowService.getCows();
      $ctrl.themedHeader = true;

      if (isEstrusLabel($ctrl.label)) {
        $ctrl.hideFields = true;
      } else {
        $ctrl.hideFields = ["farm", "scope", "subject", "category"];
      }
    }

    /**
     * Estrus labels.
     * @todo Move into constant which gets filled up from back-end. No hardcoded strings please. :)
     * @type {string[]}
     */
    $ctrl.ESTRUS_LABEL_TITLES = [
      "Estrus"
    ];

    /**
     * Tell whether the given label is an estrus label.
     * @param label
     * @returns {boolean}
     */
    function isEstrusLabel (label) {
      return $ctrl.ESTRUS_LABEL_TITLES.indexOf(label.title) > -1;
    }

    /**
     * Valigate label form
     * @return {*|boolean|string}
     */
    function labelFormValid () {
      var hasTitle = $ctrl.label.title;
      var isCowScope = $ctrl.label.labelScope === "cow" && $ctrl.label.dairyCowID;
      var isHerdGroupScope = $ctrl.label.labelScope === "herd" && $ctrl.label.herdGroupID;
      var hasEpoch = $ctrl.label.startEpoch && $ctrl.label.endEpoch;
      var dateValid = $ctrl.label.startEpoch <= $ctrl.label.endEpoch;

      return hasTitle && (isCowScope || isHerdGroupScope) && !!hasEpoch && dateValid;
    }

    /**
     * Handle XHR error
     */
    function handleError () {
      $ctrl.loading = false;
      toastr.error($translate.instant("LABEL_TEXT_OOPS"));
    }

    /**
     * Delete a label
     * @param obj
     */
    function deleteLabel (obj) {
      if ($window.confirm($translate.instant("ARE_YOU_SURE"))) {
        $ctrl.loading = true;

        obj.$delete().then(function () {
          $ctrl.loading = false;

          toastr.success($translate.instant("LABEL_TEXT_DELETED"));
          dataApiService.clearDataFromCache("GenericLabels");
          pageTransitionService.goBackward();

          history.back();
        }, handleError);
      }
    }

    /**
     * Update label
     * @param obj
     * @return {boolean}
     */
    function update (obj) {
      if (!labelFormValid()) {
        $window.alert("Please fill in the required fields");
        return false;
      }

      $ctrl.error = "";
      $ctrl.loading = true;

      labelService.updateLabel(obj).then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_UPDATED"));
        dataApiService.clearDataFromCache("GenericLabels");
      }, handleError);
    }
  }

}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight.legacyValidationQuestion", [])
    .component("legacyValidationQuestion", {
      transclude: true,
      bindings: {
        insight: "<"
      },
      controller: validationQuestionController,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/validationQuestion/validationQuestion.html"
    });

  /**
   * lodash
   * insightService
   * cowService
   * $translate
   * @ngInject
   */
  function validationQuestionController (lodash, insightService, cowService, $translate) {
    var $ctrl = this;

    /**
     * Get generic question
     * @param insight
     * @return {string}
     */
    function getGenericQuestion (insight) {
      /**
       * @type {{typeName: string, InsightTypeID: number}}
       */
      var insightType = insight.insightType;

      return $translate.instant("insightValidationTitle_" + insightType.typeName);
    }

    /**
     * Get generic repeat offender question
     * @param insight
     * @return {string}
     */
    function getUnresolvedRepeatOffenderQuestion (insight) {
      /**
       * @type {{typeName: string, InsightTypeID: number}}
       */
      var insightType = insight.insightType;

      return $translate.instant("insightValidationTitle_repeatOffender_" + insightType.typeName);
    }

    /**
     * Get question for already resolved repeat offender
     * @param insight
     * @return {string}
     */
    function getRepeatOffenderQuestion (insight) {
      /**
       * @type {string}
       */
      var question = getUnresolvedRepeatOffenderQuestion(insight);

      /**
       * @type {*[]}
       */
      var resolutions = insightService.getInsightResolutions(insight);

      if (resolutions.length) {
        /**
         * @type {string[]}
         */
        var titles = lodash.map(resolutions, "title");

        /**
         * @type {string}
         */
        var joined = titles.join(", ");

        question = $translate.instant("insightValidationTitle_repeatOffender_resolved", {
          resolution: joined
        });
      }

      return question;
    }

    /**
     * Get question tailored for the specific insight
     * @return {string}
     */
    $ctrl.getQuestion = function () {
      /**
       * @type {{dairyCow: {}, insightType: {typeName: string, InsightTypeID: number}}}
       */
      var insight = $ctrl.insight;

      /**
       * Tell whether the insight comes from a repeat offender
       * @type {boolean}
       */
      var repeatOffender = insightService.isRepeatOffender(insight);

      return repeatOffender ? getRepeatOffenderQuestion(insight) : getGenericQuestion(insight);
    };
  }
}());

/* eslint-disable angular/angularelement */
/* global $:false */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight.muteRepeatOffenderModal", [])
    .component("muteRepeatOffenderModal", {
      bindings: {
        insight: "<",
        modalVisible: "<",
        hideModal: "&"
      },
      controller: muteRepeatOffenderModalController,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/muteRepeatOffenderModal/muteRepeatOffenderModal.html"
    });

  /**
   * @param lodash
   * @param $window
   * @param $translate
   * @param cowService
   * @param dateTimeService
   * @ngInject
   */
  function muteRepeatOffenderModalController (lodash, $window, $translate, cowService, dateTimeService) {
    var $ctrl = this;

    $ctrl.$onChanges = onChanges;
    $ctrl.getTitle = getTitle;
    $ctrl.setMuteInterval = setMuteInterval;
    $ctrl.customMutePeriodChanged = customMutePeriodChanged;
    $ctrl.presetClicked = presetClicked;
    $ctrl.onClose = onClose;

    /**
     * Button variants
     * @type {{close: (string|Object), saveAndClose: (string|Object)}}
     */
    var buttonVariants = {
      close: $translate.instant("BUTTON_TEXT_CLOSE"),
      saveAndClose: $translate.instant("BUTTON_TEXT_SAVE_AND_CLOSE")
    };

    /**
     * Custom mute period
     * @type {number}
     */
    $ctrl.customMutePeriod = lodash.noop();

    /**
     * @type {string|Object}
     */
    $ctrl.closeButtonText = buttonVariants.close;

    /**
     * Interval presets for muting
     * @type {*[]}
     */
    $ctrl.intervals = [{
      label: $translate.instant("one week"),
      length: dateTimeService.WEEK
    }, {
      label: $translate.instant("one month"),
      length: dateTimeService.MONTH
    }, {
      label: $translate.instant("two months"),
      length: dateTimeService.MONTH * 2
    }];

    /**
     * @param change
     */
    function onChanges (change) {
      if (change.hasOwnProperty("modalVisible")) {
        $("#muteRepeatOffenderModal .modal-dialog").css("top", $(".transition-scroll").scrollTop());
      }
    }

    /**
     * Det dialog title
     * @return {string|Object}
     */
    function getTitle () {
      return $translate.instant("REPEAT_OFFENDER_MUTE_QUESTION", {
        insightType: $ctrl.insight.insightType.insightCategory
      });
    }

    /**
     * Change custom interval
     * @type {Function|*}
     */
    function customMutePeriodChanged () {
      if ($ctrl.customMutePeriod >= 1) {
        $ctrl.closeButtonText = buttonVariants.saveAndClose;
      } else {
        $ctrl.closeButtonText = buttonVariants.close;
      }
    }

    /**
     * Handle modal close
     */
    function onClose () {
      if ($ctrl.customMutePeriod >= 1) {
        /**
         * @type {number}
         */
        var interval = {
          length: dateTimeService.DAY * $ctrl.customMutePeriod
        };

        setMuteInterval(interval).then(function () {
          $ctrl.customMutePeriod = lodash.noop();
          $ctrl.closeButtonText = buttonVariants.close;
          $ctrl.hideModal();
        });
      } else {
        $ctrl.hideModal();
      }
    }

    /**
     * Handle preset clicked.
     * @param interval
     */
    function presetClicked (interval) {
      setMuteInterval(interval, { resetCustom: true }).then($ctrl.hideModal);
    }

    /**
     * Apply mute interval to the given insight/cow
     * @param interval
     * @param options
     */
    function setMuteInterval (interval, options) {
      /**
       * @type {number}
       */
      var now = dateTimeService.now();

      if ((options || {}).resetCustom) {
        $ctrl.customMutePeriod = lodash.noop();
      }

      /**
       * @type {number}
       */
      var until = now + interval.length;

      return cowService.mute($ctrl.insight.dairyCow, $ctrl.insight.insightType.InsightTypeID, until);
    }
  }
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight.insightValidation", [])
    .component("insightValidation", {
      bindings: {
        insight: "<",
        updateInsightValidation: "&"
      },
      controller: insightValidationCtrl,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/insightValidation/insightValidation.html"
    });

  /**
   * @param $scope
   * @param $window
   * @param $q
   * @param $translate
   * @param authenticationService
   * @param sessionService
   * @param insightService
   * @param cowService
   * @ngInject
   */
  function insightValidationCtrl ($scope, $window, $q, $translate, authenticationService,
                                  sessionService, insightService, cowService) {
    var insightValidations;
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.validateInsight = validateInsight;
    $ctrl.onMuteClicked = onMuteClicked;
    $ctrl.getButtonClassName = getButtonClassName;
    $ctrl.showRepeatOffenderModal = showRepeatOffenderModal;
    $ctrl.hideRepeatOffenderModal = hideRepeatOffenderModal;

    $ctrl.isRepeatOffender = insightService.isRepeatOffender;
    $ctrl.isAuthorized = authenticationService.isAuthorized;

    function onInit () {
      $ctrl.loading = true;

      var validationsLoader = insightService.getInsightValidations($ctrl.insight.GenericInsightID);

      validationsLoader.then(function (result) {
        insightValidations = result;
        initValidations();
        $ctrl.loading = false;
      });
    }

    /**
     * Init insight validations.
     */
    function initValidations () {
      /**
       * @type {[]}
       */
      var sorted = insightValidations.sort(function (a, b) {
        return a.InsightValidationID < b.InsightValidationID;
      });

      /**
       * Rule out admin validations
       */
      $ctrl.insightValidation = sorted.find(function (element) {
        return element.validationByID !== "Admin";
      });

      if (!$ctrl.insightValidation) {
        $ctrl.insightValidation = newInsightValidation();
      }
    }

    /**
     * Create a new insight validation
     * @return {{validationByID: *, genericInsightID: *, validation: string}}
     */
    function newInsightValidation () {
      /**
       * @type {{validationByID: *, genericInsightID: *, validation: string}}
       */
      var insightValidation = {
        validationByID: sessionService.user.id,
        genericInsightID: $ctrl.insight.GenericInsightID,
        validation: "NA"
      };

      insightValidation = insightService.newInsightValidation(insightValidation);

      return insightValidation;
    }

    /**
     * Set loading
     * @param to
     */
    function setLoading (to) {
      $ctrl.loading = !!to;
    }

    /**
     * Validate insight
     * @param validation
     * @param answer
     * @return {boolean}
     */
    function validateInsight (validation, answer) {
      /**
       * @type {Date}
       */
      var now = new Date();

      /**
       * @type {boolean}
       */
      var validatedByOthers = validation.validationByID !== sessionService.user.id;

      /**
       * @type {string}
       */
      var NA = "NA";

      /**
       * If the insight validation is set, and its previously not set by you, show an alert.
       */
      if (validation.validation && validation.validation !== NA && validatedByOthers) {
        if (!$window.confirm($translate.instant("INSIGHT_CHANGE_VALIDATION_CONFIRMATION"))) {
          return false;
        }
      }

      /**
       * Reset to NA if the intention is to turn it off.
       * @type {string}
       */
      validation.validation = validation.validation === answer ? NA : answer;

      /**
       * Set new epoch on validation.
       * @type {number}
       */
      validation.validationEpoch = Math.round(now.getTime() / 1000);

      /**
       * Set as if it was validated by me.
       */
      validation.validationByID = sessionService.user.id;

      setLoading(true);

      if (validation.InsightValidationID) {
        validation.$update().then(function () {
          $ctrl.updateInsightValidation({
            insightValidation: validation.validation
          });

          setLoading(false);
        });
      } else {
        validation = insightService.newInsightValidation(validation);

        validation.$save().then(function (result) {
          $ctrl.updateInsightValidation({
            insightValidation: validation.validation
          });

          $ctrl.insightValidation = result;
          setLoading(false);
        });
      }
    }

    /**
     * Get button class name for a given answer
     * @param forValue
     * @return {string}
     */
    function getButtonClassName (forValue) {
      /**
       * @type {string[]}
       */
      var defaultValues = [forValue, "NA"];

      /**
       * @type {boolean}
       */
      var usesDefault = $ctrl.insightValidation && defaultValues.indexOf($ctrl.insightValidation.validation) > -1;

      return usesDefault ? "btn-default" : "btn-white";
    }

    /**
     * show repeat offender modal
     */
    function showRepeatOffenderModal () {
      $ctrl.repeatOffenderModalVisible = true;
    }

    /**
     * Hide repeat offender modal
     */
    function hideRepeatOffenderModal () {
      $ctrl.repeatOffenderModalVisible = false;
    }

    /**
     * Handle clicking on mute/unmute button
     */
    function onMuteClicked () {
      /**
       * @type {{}}
       */
      var cow = $ctrl.insight.dairyCow;

      /**
       * @type {number}
       */
      var insightTypeId = $ctrl.insight.insightType.InsightTypeID;

      /**
       * @type {boolean}
       */
      var isMuted = cowService.isMuted(cow, insightTypeId);

      return isMuted ? cowService.unmute(cow, insightTypeId) : showRepeatOffenderModal();
    }
  }
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight.insightRibbon", [])
    .component("insightRibbon", {
      transclude: true,
      bindings: {
        text: "<"
      },
      controller: insightRibbonController,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/insightRibbon/insightRibbon.html"
    });

  /**
   * @param authenticationService
   * @ngInject
   */
  function insightRibbonController (authenticationService) {
    var $ctrl = this;

    /**
     * Get admin classname
     * @return {string}
     */
    $ctrl.getAdminClassName = function () {
      return authenticationService.isAuthorized("Admin") ? "is-admin" : "";
    };
  }
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight.muteRepeatOffender", [])
    .component("muteRepeatOffender", {
      bindings: {
        className: "@",
        insight: "<"
      },
      controller: muteRepeatOffenderController,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/muteRepeatOffender/muteRepeatOffender.html"
    });

  /**
   * lodash
   * cowService
   * $translate
   * @ngInject
   */
  function muteRepeatOffenderController (lodash, insightService, cowService, $translate) {
    var $ctrl = this;

    /**
     * Tell whether the insight is muted
     * @return {number}
     */
    function isMuted () {
      /**
       * @type {{}}
       */
      var cow = $ctrl.insight.dairyCow;

      /**
       * @type {number}
       */
      var insightTypeId = $ctrl.insight.insightType.InsightTypeID;

      return !!cowService.isMuted(cow, insightTypeId);
    }

    /**
     * Get button text
     * @return {string}
     */
    $ctrl.getButtonText = function () {
      return $translate.instant(isMuted() ? "unmute" : "mute");
    };

    /**
     * Get button class name
     * @return {string}
     */
    $ctrl.getClassName = function () {
      /**
       * @type {string[]}
       */
      var classes = [
        "mute-repeat-offender",
        isMuted() ? "is-muted" : "is-not-muted",
        "btn",
        "btn-block",
        $ctrl.className
      ];

      return classes.join(" ");
    };
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.insight.insightResolutionTitle", []).component("insightResolutionTitle", {
    bindings: {
      insight: "<",
      dairyCow: "<",
      showCowTag: "<",
      showSubTitle: "<",
      update: "<",
      maxLength: "<",
      pickResolutions: "<",
      options: "<"
    },
    controller: insightResolutionTitleCtrl,
    templateUrl:
      "app/shared-components/angular-ui-components/components/insight/insightResolutionTitle/insightResolutionTitle.html"
  });

  /**
   * @ngInject
   * @param $scope
   * @param $window
   * @param authenticationService
   * @param sessionService
   * @param insightService
   * @param $translate
   * @param lodash
   */
  function insightResolutionTitleCtrl(
    $scope,
    $window,
    authenticationService,
    sessionService,
    insightService,
    $translate,
    lodash
  ) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.$onChanges = onChanges;
    /**
     * Init
     */
    function onInit() {
      $ctrl.resolutionTitle = getResolutionTitle();
      $ctrl.subTitle = getSubTitle();
    }

    /**
     * Handle change
     */
    function onChanges() {
      $ctrl.resolutionTitle = getResolutionTitle();
      $ctrl.getSubTitle = getSubTitle();
    }

    /**
     * Get resolution title
     * @return {string}
     */
    function getResolutionTitle() {
      /**
       * @type {object}
       */
      var options = lodash.assign({}, $ctrl.options);

      /**
       * load the translation object
       */
      var translations = $translate.getTranslationTable();

      /**
       * @type {string}
       */
      var title = "";

      /**
       * Pick the resolutions which are allowed to show.
       */
      var resolutionPool = lodash.isFunction($ctrl.pickResolutions)
        ? $ctrl.pickResolutions($ctrl.insight.insightResolution)
        : $ctrl.insight.insightResolution || [];

      /**
       * Filter out the resolutions which are useless and just make
       * title guessing harder
       */
      resolutionPool = lodash.filter(lodash.uniqBy(resolutionPool, "id"), function (r) {
        return r.id !== "i_dont_know";
      });

      if (resolutionPool.length > 1 || options.filterAllHiddenResolutions) {
        /**
         * Filter out hidden resolutions.
         */
        resolutionPool = resolutionPool.filter(function (e) {
          return !e.hidden;
        });
      }

      /**
       * Limit the number from the list for easier display.
       */
      var selectedResolutuions = lodash.isNumber($ctrl.maxLength)
        ? lodash.take(resolutionPool, $ctrl.maxLength)
        : resolutionPool;

      selectedResolutuions.forEach(function (resolution, $index) {
        title += selectedResolutuions.length > 1 && selectedResolutuions.length - 1 === $index ? " & " : " ";
        title += $translate.instant(translations[resolution.id] ? resolution.id : resolution.title);
        title += selectedResolutuions.length > 1 && selectedResolutuions.length - 2 > $index ? ", " : "";
      });

      return title;
    }

    /**
     * Get subtitle
     * @return {*}
     */
    function getSubTitle() {
      var subTitle;

      if ($ctrl.showSubTitle) {
        /**
         * @type {string[]}
         */
        var nonFertilityTypeNames = [
          "Health",
          "CowHealthIssue",
          "FeedingEfficiencyHighInsight",
          "FeedingEfficiencyLowInsight",
          "MajorHealthIssueInsight",
          "ObviousHealthInsight"
        ];

        if (nonFertilityTypeNames.indexOf($ctrl.insight.insightType.typeName) > -1) {
          if ($ctrl.insight.insightValid === "Yes") {
            subTitle = $translate.instant($ctrl.insight.insightTitle);
          } else if ($ctrl.insight.insightValid === "No") {
            subTitle = $translate.instant("No health problem");
          }
        } else if ($ctrl.insight.insightType.typeName === "Estrus") {
          if ($ctrl.insight.insightValid === "Yes") {
            subTitle = $translate.instant("On estrus");
          } else if ($ctrl.insight.insightValid === "No") {
            subTitle = $translate.instant("Not on estrus");
          }
        }
      }

      return subTitle;
    }
  }
})();

/* eslint-disable angular/angularelement */
/* global $:false */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight.insightResolutionModal", ["ctraUIComponents.insight.insightResolution"])
    .component("insightResolutionModal", {
      bindings: {
        insight: "<",
        modalVisible: "<",
        title: "<",
        hideModal: "&"
      },
      transclude: true,
      controller: insightResolutionModalCtrl,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/insightResolutionModal/insightResolutionModal.html"
    });

  /**
   * @param $window
   * @param insightService
   * @param doNotBreedService
   * @ngInject
   */
  function insightResolutionModalCtrl ($window, insightService, doNotBreedService) {
    var $ctrl = this;

    $ctrl.$onChanges = onChanges;
    $ctrl.updateInsightResolution = updateInsightResolution;
    $ctrl.isDysonEnabled = doNotBreedService.isDysonEnabled;
    $ctrl.resolvedAsDNB = doNotBreedService.resolvedAsDNB;

    /**
     * Text content
     * @type {{dnbWarning: string}}
     */
    $ctrl.copy = {
      dnbWarning: doNotBreedService.copy.insightDysonEnabledWarning
    };

    /**
     * @param insightResolution
     */
    function updateInsightResolution (insightResolution) {
      $ctrl.insight.insightResolution = insightResolution;
      insightService.updateInsightResolution($ctrl.insight, false);

      /**
       * Tell whether the DNB is applied
       */
      var dnbValue = doNotBreedService.resolvedAsDNB($ctrl.insight);

      doNotBreedService.setDNB($ctrl.insight.dairyCowID, dnbValue);
    }

    /**
     * @param change
     */
    function onChanges (change) {
      if (change.hasOwnProperty("modalVisible")) {
        $("#resolutionModal .modal-dialog").css("top", $(".transition-scroll").scrollTop());
      }
    }
  }
}());

(function () {
  "use strict";

  /**
   * Insight resolution component. Displays facets and search bar.
   * @property insight
   * @property {string} insightIsValid
   * @property insightResolution
   * @property {Function} updateInsightResolution
   */
  angular
    .module("ctraUIComponents.insight.insightResolution", [])
    .component("insightResolution", {
      bindings: {
        insight: "<",
        insightIsValid: "<",
        insightResolution: "<",
        updateInsightResolution: "&",
        onBeforeRemoveResolution: "&",
        onBeforeAddResolution: "&",
        visibleResolutionLimit: "<",
        options: "<"
      },
      transclude: true,
      controller: insightResolutionController,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/" +
        "insightResolution/insightResolution.html"
    });

  /**
   * Insight resolution controller.
   * @param authenticationService
   * @param insightService
   * @param insightResolutionService
   * @param $scope
   * @param $translate
   * @param lodash
   * @param $window
   * @return {insightResolutionController}
   * @ngInject
   */
  function insightResolutionController(authenticationService, insightService, insightResolutionService, $scope, $translate, lodash, $window, $q) {
    var $ctrl = this;

    /**
     * Init hook.
     * @type {onInit}
     * @memberOf insightResolutionController
     */
    $ctrl.$onInit = onInit;

    /**
     * Change hook.
     * @type {onChanges}
     * @memberOf insightResolutionController
     */
    $ctrl.$onChanges = onChanges;

    /**
     * Tell whether the user is authorized.
     * @type {boolean}
     * @memberOf insightResolutionController
     */
    $ctrl.isAuthorized = authenticationService.isAuthorized;

    /**
     * Set the loading state indicator.
     * @param {boolean} to - the value to set loading to
     */
    function setLoading (to) {
      /**
       * @memberOf insightResolutionController
       * @type {boolean}
       */
      $ctrl.isLoading = !!to;
    }

    /**
     * A list of applicable insight resolutions. Gets populated by loadResolutions.
     * @type {Array}
     */
    var insightResolutions = [];

    /**
     * Insight resolutions which are applied to the current insight.
     * @memberOf insightResolutionController
     * @type {Array}
     */
    $ctrl.insightResolution = [];

    function onInit() {
      /**
       * Tell whether we are currently editing the resolutions.
       * @todo Make sure this gets declared properly.
       * @memberOf insightResolutionController
       * @type {boolean}
       */
      $ctrl.editingResolutions = true;

      /**
       * Tell whether the "add resolution" input field is visible.
       * @todo Make sure this gets declared properly.
       * @see showOtherResolutionForm
       * @memberOf insightResolutionController
       * @type {boolean}
       */
      $ctrl.showingOtherResolutionForm = false;

      setLoading(true);

      loadResolutions()
        .then(onResolutionsLoaded)
        .finally(lodash.partial(setLoading, false));
    }

    /**
     * Load the applicable resolutions from the service.
     * @returns {Deferred}
     */
    function loadResolutions () {
      var loadFromService = insightResolutionService
        .getInsightResolutions($ctrl.insight.insightType);

      var loadFromLocalStorage = insightResolutionService
        .getLocalStorageResolutions($ctrl.insight.insightType.insightCategory);

      return $q.all([loadFromService, loadFromLocalStorage]);
    }

    /**
     * Translate and filter resolutions.
     * @param results
     */
    function onResolutionsLoaded (results) {
      var merged = lodash.flatten(results);

      /**
       * Add translation to the resolutions.
       * @type {any[]}
       */
      insightResolutions = merged.map(function (resolution) {
        return lodash.assign({}, resolution, {
          translation: $translate.instant(resolution.title)
        });
      });

      filterResolutions();
    }

    /**
     * Filter resolutions on update.
     * @param change
     */
    function onChanges (change) {
      if (change.hasOwnProperty("insightIsValid")) {
        filterResolutions();
      }
    }

    /**
     * Filter out resolutions which are invalid for the given insight.
     */
    function filterResolutions () {
      /**
       * Tell whether the cow is a repeat offender. If so, we consider the insight
       * already having a resolution, so we show it.
       * @type {boolean}
       */
      var isRepeatOffender = insightService.getContext($ctrl.insight).isRepeatOffender;

      var validResolutions = insightResolutions.filter(function (resolution) {
        /**
         * FUCK IT!!!! Calving and workflow insights need different strategy than others.
         * So we use the magic number to settle on that different strategy.
         * @type {boolean}
         */
        var strict = [17, 39, 42, 43].indexOf($ctrl.insight.insightType.InsightTypeID) > -1;

        /**
         * Tell whether a validation key is present on the resolution object.
         * If it is not, then it is a non-validating resolution, thus we show it.
         * @type {boolean}
         */
        var isValidationKeySet = !!resolution.validation;

        /**
         * The ones which match the validation of the insight are shown as well.
         * @type {boolean}
         */
        var matchesValidation = $ctrl.insightIsValid === resolution.validation;

        /**
         * The insight is not validated OR validated as NA
         * @type {boolean}
         */
        var validationUnknown = !$ctrl.insightIsValid ||
          $ctrl.insightIsValid === insightService.VALIDATION_TYPES.noAnswer;

        /**
         * Valid if validation is equal to the resolution validation. (The farmer said "yes" or "no")
         * OR if the validation key is not even present on the resolution object
         * @type {boolean}
         */
        return matchesValidation || (!isValidationKeySet && (strict ? validationUnknown : true));
      });

      /**
       * Tell whether to show resolution options or not.
       * @memberOf insightResolutionController
       * @type {boolean}
       */
      $ctrl.showResolutions = isRepeatOffender || !!validResolutions.length;

      /**
       * Filtered resolutions to show.
       * @memberOf insightResolutionController
       * @type {*[]}
       */
      $ctrl.resolutionsFiltered = validResolutions.filter(function (resolution) {
        var isHidden = resolution.hidden;

        /**
         * Tell whether the resolution has be already selected.
         * @type {boolean}
         */
        var alreadyInResolutionList = insightResolutionService.inResolutionList($ctrl.insightResolution, resolution);

        // Only allow valid, visible resolutions which are not already listed.
        return !isHidden && !alreadyInResolutionList;
      });

      if ($ctrl.options && $ctrl.options.onlyIncludeInsightWithTypeName) {
        /**
         * Filter out the insights that don't have insight type keys
         */
        $ctrl.resolutionsFiltered = $ctrl.resolutionsFiltered.filter(function(resolution) {
          return !!resolution.insightTypes
        })
      }
    }

    /**
     * Apply a resolution to the insight.
     * @param {Object} resolution
     * @param {{}} params
     */
    function addResolution(resolution, params) {
      params = lodash.assign({
        toggleMode: false
      }, params || {});

      if (insightResolutionService.inResolutionList($ctrl.insightResolution, resolution) && params.toggleMode) {
        removeResolution(resolution);
      } else {
        if (lodash.isFunction($ctrl.onBeforeAddResolution)) {
          $ctrl.onBeforeAddResolution(resolution);
        }

        $ctrl.insightResolution.push(resolution);

        if (resolution.id === "culled") {
          var doNotBreedRes = insightResolutions.find(function (element) {
            return element.id === "do_not_breed";
          });

          if (doNotBreedRes) {
            $ctrl.insightResolution.push(doNotBreedRes);
          }
        }
      }

      saveAndUpdate();
    }

    /**
     * Remove a given resolution from the list.
     * @param {Object} resolution
     */
    function removeResolution (resolution) {
      var confirmed = $window.confirm(
        $translate.instant("Are you sure you want to remove this resolution?")
      );

      if (confirmed) {
        var resolutionIdsToRemove = [resolution.id];

        if (resolution.id === "culled") {
          resolutionIdsToRemove.push("do_not_breed");
        }

        if (lodash.isFunction($ctrl.onBeforeRemoveResolution)) {
          $ctrl.onBeforeRemoveResolution(resolutionIdsToRemove);
        }

        $ctrl.insightResolution = $ctrl.insightResolution.filter(function (applied) {
          return !resolutionIdsToRemove.includes(applied.id)
        });

        if (!$ctrl.insightResolution.length) {
          $ctrl.editingResolutions = true;
        }

        saveAndUpdate();
      }
    }

    /**
     * Save and update the applied and available insight resolutions.
     */
    function saveAndUpdate () {
      $ctrl.updateInsightResolution({
        insightResolution: $ctrl.insightResolution
      });

      filterResolutions();
    }

    /**
     * Show the "other resolution" form.
     */
    function showOtherResolutionForm () {
      $ctrl.showingOtherResolutionForm = true;
    }

    /**
     * Hide the "other resolution" form.
     */
    function hideOtherResolutionForm () {
      $ctrl.showingOtherResolutionForm = false;
    }

    /**
     * Select a resolution.
     * @param selected
     */
    function resolutionSelected (selected) {
      if (selected) {
        /**
         * @type {string}
         */
        var title = selected.originalObject.title;

        /**
         * adding a null and empty check on added resolution
         * to prevent adding undefined and empty resolutions
         */
        if( (!title) || (title.trim().length == 0))
          return;

        /**
         * Selected resolution object.
         * @type {{insightCategory: *, id: number, title: *}}
         * @memberOf insightResolutionController
         */
        $ctrl.selectedResolution = findResolutionByTitle(title) || createResolutionFromTitle(title);

        addResolution($ctrl.selectedResolution, { toggleMode: false });
      } else {
        $ctrl.selectedResolution = null;
      }
    }

    /**
     * Store the input field value as it changes.
     * @param {string} input
     */
    function updateResolutionInputValue (input) {
      /**
       * @memberOf insightResolutionController
       * @type {string}
       */
      $ctrl.resolutionInput = input;
    }

    /**
     * Create an ad-hoc resolution object
     * @param title
     * @returns {{insightCategory: *, id: number, title: *}}
     */
    function createResolutionFromTitle (title) {
      return {
        insightCategory: lodash.get($ctrl, "insight.insightType.insightCategory"),
        id: lodash.snakeCase(title),
        title: title
      };
    }

    /**
     * Clear the input field and add the value as a resolution.
     */
    function clearFormAndSaveResolution () {
      $scope.$broadcast("angucomplete-alt:clearInput", "resolutionAutocomplete");

      /**
       * @type {string}
       */
      var title = $ctrl.resolutionInput;

      /**
         * adding a null and empty check on added resolution
         * to prevent adding undefined and empty resolutions
         */
        if( (!title) || (title.trim().length == 0))
          return;

      /**
       * @type {{insightCategory: *, id: number, title: *}|undefined}
       */
      var existing = findResolutionByTitle(title);

      /**
       * @type {{insightCategory: *, id: number, title: *}}
       */
      var resolution = existing || createResolutionFromTitle(title);

      addResolution(resolution, { toggleMode: false });

      if (!existing) {
        insightResolutionService.addNewCustomResolution($ctrl.insight.insightType.insightCategory, resolution);

        /**
         * Make sure the newly added resolution gets loaded again.
         * This triggers a UI update so the autocomplete will pick it up even when the user
         * decides to delete and add the resolution again.
         */
        loadResolutions().then(onResolutionsLoaded);
      }
    }

    /**
     * Find a resolution object using its title.
     * @param {string} title
     * @returns {Object}
     */
    function findResolutionByTitle (title) {
      return $ctrl.resolutionsFiltered.find(function(found) {
        return found.title === title;
      });
    }

    /**
     * Define a public interface of the component.
     * @type {{
     *  addResolution: addResolution,
     *  removeResolution: removeResolution,
     *  inResolutionList: inResolutionList,
     *  showOtherResolutionForm: showOtherResolutionForm,
     *  hideOtherResolutionForm: hideOtherResolutionForm,
     *  resolutionSelected: resolutionSelected,
     *  resolutionInputChanged: updateResolutionInputValue,
     *  resolutionFormSubmitted: clearFormAndSaveResolution
     * }}
     */
    var intf = {
      addResolution: addResolution,
      removeResolution: removeResolution,
      inResolutionList: insightResolutionService.inResolutionList,
      showOtherResolutionForm: showOtherResolutionForm,
      hideOtherResolutionForm: hideOtherResolutionForm,
      resolutionSelected: resolutionSelected,
      resolutionInputChanged: updateResolutionInputValue,
      resolutionFormSubmitted: clearFormAndSaveResolution
    };

    lodash.forOwn(intf, function (method, methodName) {
      $ctrl[methodName] = method;
    });

    return this;
  }

}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight.insightResolution")
    .service("legacyInsightResolutionService", insightResolutionService);

  /**
   * @type {{yes: string, no: string, noAnswer: string}}
   */
  var VALIDATION_TYPES = {
    yes: "Yes",
    no: "No",
    maybe: "Maybe",
    noAnswer: "NA"
  };

  /**
   * All the possible resolutions
   * @type {*[]}
   */
  var allResolutions = [
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 1,
      id: "mastitis",
      title: "mastitis"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 10,
      id: "rumen_acidosis",
      title: "rumen acidosis"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 7,
      id: "displaced_abomasum",
      title: "displaced abomasum"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 3,
      id: "digestive_problems",
      title: "digestive problems"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 5,
      id: "respiratory_problem",
      title: "respiratory problem"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 6,
      id: "metritis",
      title: "metritis"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 8,
      id: "milk_fever",
      title: "milk fever"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 10,
      id: "heat_stress",
      title: "heat stress"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 2,
      id: "lameness",
      title: "lameness"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 4,
      id: "ketosis",
      title: "ketosis"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 20,
      id: "salmonella",
      title: "salmonella"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 20,
      id: "hoof_infection",
      title: "hoof infection"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 20,
      id: "gut worms",
      title: "gut worms"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 20,
      id: "calving_distress",
      title: "calving distress"
    },
    { insightCategory: "health", validation: VALIDATION_TYPES.yes, order: 20, id: "death", title: "death" },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 20,
      id: "diarrhea",
      title: "diarrhea"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      order: 9,
      id: "pneumonia",
      title: "pneumonia"
    },

    { insightCategory: "health", validation: VALIDATION_TYPES.no, order: 10, id: "ok", title: "ok" },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "calving",
      title: "calving"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "calving_distress",
      title: "calving distress"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "stuck_in_headlock",
      title: "stuck in headlock"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "hoofs_trimmed",
      title: "hoofs trimmed"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "no_food",
      title: "no food"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "on_estrus",
      title: "on estrus"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "sensor_removed",
      title: "sensor removed"
    },

    /**
     * These are the generic fertility workflow approved/dismissed resolutions. Consider them as helper resolutions, such as
     * "inseminated", "not_inseminated", "calved", "not_calved".
     * @todo Add the other insight types for dry-off.
     */
    {
      insightCategory: "fertility",
      insightTypes: [
        "WFMissingEstrus",
        "WFMissingEstrusPostCalving",
        "WFMissingEstrusTreated",
        "WFMissingEstrusPostCalvingTreated",
        "WFMissingEstrusResolved",
        "WFMissingEstrusPostCalvingResolved"
      ],
      validation: VALIDATION_TYPES.yes,
      order: 5,
      id: "approved",
      title: "approved",
      hidden: true
    },
    {
      insightCategory: "fertility",
      insightTypes: [
        "WFMissingEstrus",
        "WFMissingEstrusPostCalving",
        "WFMissingEstrusTreated",
        "WFMissingEstrusPostCalvingTreated",
        "WFMissingEstrusResolved",
        "WFMissingEstrusPostCalvingResolved"
      ],
      validation: VALIDATION_TYPES.no,
      order: 5,
      id: "not_approved",
      title: "not_approved",
      hidden: true
    },

    /**
     * These are the resolutions for the missing estrus workflow.
     * @todo add new resolutions which make sense
     */
    {
      insightCategory: "fertility",
      insightTypes: ["WFMissingEstrus", "WFMissingEstrusPostCalving"],
      validation: VALIDATION_TYPES.yes,
      order: 10,
      id: "metritis_treatment",
      title: "metritis treatment"
    },
    {
      insightCategory: "fertility",
      insightTypes: ["WFMissingEstrus", "WFMissingEstrusPostCalving"],
      validation: VALIDATION_TYPES.yes,
      order: 10,
      id: "ov_synch_treatment",
      title: "ov synch treatment"
    },
    {
      insightCategory: "fertility",
      insightTypes: ["WFMissingEstrus", "WFMissingEstrusPostCalving"],
      validation: VALIDATION_TYPES.yes,
      order: 10,
      id: "energy_balance",
      title: "energy balance"
    },
    {
      insightCategory: "fertility",
      insightTypes: ["WFMissingEstrus", "WFMissingEstrusPostCalving"],
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "dnb",
      title: "do not breed"
    },
    {
      insightCategory: "fertility",
      insightTypes: ["WFMissingEstrus", "WFMissingEstrusPostCalving"],
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "cow_is_healthy",
      title: "cow has been on estrus"
    },
    {
      insightCategory: "fertility",
      insightTypes: ["WFMissingEstrus", "WFMissingEstrusPostCalving"],
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "with_bull",
      title: "with bull"
    },
    {
      insightCategory: "fertility",
      insightTypes: ["WFMissingEstrus", "WFMissingEstrusPostCalving"],
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "already_inseminated",
      title: "already inseminated"
    },

    { insightCategory: "fertility", order: 1, id: "not_on_estrus", title: "not on estrus" },
    {
      insightCategory: "fertility",
      order: 2,
      id: "too_early_after_calving",
      title: "too early after calving"
    },
    { insightCategory: "fertility", order: 3, id: "do_not_breed", title: "do not breed" },
    { insightCategory: "fertility", order: 4, id: "agitation", title: "agitation" },
    { insightCategory: "fertility", order: 5, id: "noticed_too_late", title: "noticed too late" },
    { insightCategory: "fertility", order: 6, id: "too_young", title: "too young" },
    { insightCategory: "fertility", order: 10, id: "not_found", title: "not found" },
    { insightCategory: "fertility", order: 10, id: "metritis", title: "metritis" },
    { insightCategory: "fertility", order: 10, id: "culled", title: "will be culled" },
    { insightCategory: "fertility", order: 10, id: "hoofs_trimmed", title: "hoofs trimmed" },
    {
      insightCategory: "fertility",
      order: 10,
      id: "not_inseminated",
      title: "not inseminated",
      hidden: true
    },
    { insightCategory: "fertility", order: 10, id: "inseminated", title: "inseminated", hidden: true },

    {
      insightCategory: "fertility",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["CowHasCalved"],
      order: 5,
      id: "calved",
      title: "calved",
      hidden: true
    },
    {
      insightCategory: "fertility",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["CowHasCalved"],
      order: 1,
      id: "calving_distress",
      title: "calving distress"
    },
    {
      insightCategory: "fertility",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["CowHasCalved"],
      order: 2,
      id: "still_birth",
      title: "stillbirth"
    },
    {
      insightCategory: "fertility",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["CowHasCalved"],
      order: 3,
      id: "twins",
      title: "twins"
    },
    {
      insightCategory: "fertility",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["CowHasCalved"],
      order: 5,
      id: "i_dont_know",
      title: "I don't know",
      hidden: true
    },
    {
      insightCategory: "fertility",
      validation: VALIDATION_TYPES.no,
      insightTypes: ["CowHasCalved"],
      order: 5,
      id: "not_calved",
      title: "not calved",
      hidden: true
    },
    {
      insightCategory: "fertility",
      validation: VALIDATION_TYPES.no,
      insightTypes: ["CowHasCalved"],
      order: 5,
      id: "noticed_too_late",
      title: "noticed too late"
    },
    {
      insightCategory: "fertility",
      validation: VALIDATION_TYPES.no,
      insightTypes: ["CowHasCalved"],
      order: 5,
      id: "calving_not_started",
      title: "calving not started"
    },

    {
      insightCategory: "feed",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "no_food",
      title: "no food available"
    },
    {
      insightCategory: "feed",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "agitation",
      title: "agitation"
    },
    {
      insightCategory: "feed",
      validation: VALIDATION_TYPES.no,
      order: 10,
      id: "free_grazing",
      title: "free grazing"
    },

    {
      insightCategory: "feed",
      validation: VALIDATION_TYPES.yes,
      order: 10,
      id: "low_fiber_content_in_feed",
      title: "low fiber content in feed"
    },
    {
      insightCategory: "feed",
      validation: VALIDATION_TYPES.yes,
      order: 10,
      id: "low_quality_feed",
      title: "low quality feed"
    },
    {
      insightCategory: "feed",
      order: 10,
      id: "bad_accessibility_to_feed",
      title: "bad accessibility to feed"
    },

    {
      insightCategory: "herd",
      insightTypes: ["HerdInsight"],
      order: 1,
      id: "feeding_schedule",
      title: "feeding schedule"
    },
    {
      insightCategory: "herd",
      insightTypes: ["HerdInsight"],
      order: 2,
      id: "management_change",
      title: "management change"
    },
    {
      insightCategory: "herd",
      insightTypes: ["HerdInsight"],
      order: 3,
      id: "grazing_schedule",
      title: "grazing schedule"
    },
    { insightCategory: "herd", insightTypes: ["HerdInsight"], order: 4, id: "bedding", title: "bedding" },
    { insightCategory: "herd", insightTypes: ["HerdInsight"], order: 5, id: "agitation", title: "agitation" },
    {
      insightCategory: "herd",
      insightTypes: ["HerdInsight"],
      order: 6,
      id: "hoof_trimming",
      title: "hoof trimming"
    },
    {
      insightCategory: "herd",
      insightTypes: ["HerdInsight"],
      order: 7,
      id: "heat_stress",
      title: "heat stress"
    },
    {
      insightCategory: "herd",
      insightTypes: ["HerdInsight"],
      order: 8,
      id: "ration_change",
      title: "ration change"
    },
    { insightCategory: "herd", insightTypes: ["HerdInsight"], order: 9, id: "unknown", title: "unknown" },

    {
      insightCategory: "health",
      insightTypes: ["farmLayingDecrease"],
      order: 5,
      id: "heat_stress",
      title: "heat stress"
    },
    {
      insightCategory: "health",
      insightTypes: ["farmLayingDecrease"],
      order: 5,
      id: "bedding_issues",
      title: "bedding issues"
    },
    {
      insightCategory: "health",
      insightTypes: ["farmLayingDecrease"],
      order: 5,
      id: "claw_problem",
      title: "claw problem"
    },

    {
      insightCategory: "health",
      insightTypes: ["farmAgitated"],
      order: 5,
      id: "hoof_trimmer",
      title: "hoof trimmer"
    },
    {
      insightCategory: "health",
      insightTypes: ["farmAgitated"],
      order: 5,
      id: "disruption_in_the_barn",
      title: "disruption in the barn"
    },
    {
      insightCategory: "health",
      insightTypes: ["farmAgitated"],
      order: 5,
      id: "first_time_pasture",
      title: "first time to pasture"
    },

    {
      insightCategory: "system",
      insightTypes: ["SensorIsNotOnCow"],
      order: 1,
      id: "sensor_fell_off",
      validation: VALIDATION_TYPES.no,
      title: "the sensor fell off"
    },
    {
      insightCategory: "system",
      insightTypes: ["SensorIsNotOnCow"],
      order: 10,
      id: "cow_died",
      validation: VALIDATION_TYPES.no,
      title: "the cow died"
    },
    {
      insightCategory: "system",
      insightTypes: ["SensorIsNotOnCow"],
      order: 10,
      id: "sensor_is_on_cow",
      validation: VALIDATION_TYPES.no,
      title: "the sensor is on the cow"
    },
    {
      insightCategory: "system",
      insightTypes: ["SensorIsNotOnCow"],
      id: "sensor_was_removed",
      validation: VALIDATION_TYPES.yes,
      title: "sensor removed"
    },

    {
      insightCategory: "sensor",
      insightTypes: ["SensorIsOffline"],
      id: "out_of_range",
      validation: VALIDATION_TYPES.yes,
      title: "out of range"
    },
    {
      insightCategory: "sensor",
      insightTypes: ["SensorIsOffline"],
      id: "replace_sensor",
      validation: VALIDATION_TYPES.no,
      title: "replace sensor"
    },

    {
      insightCategory: "system",
      insightTypes: ["SensorIsNotTurnedOn"],
      id: "replace_sensor",
      title: "replace sensor"
    },
    {
      insightCategory: "system",
      insightTypes: ["SensorIsOffline", "SensorIsNotTurnedOn"],
      id: "replaced",
      title: "replaced"
    },

    {
      insightCategory: "sensor",
      insightTypes: ["SensorIsNotTurnedOn"],
      id: "connecting",
      title: "connecting..."
    },
    { insightCategory: "system", insightTypes: ["SensorIsNotTurnedOn"], id: "turned_on", title: "turned on" },

    { insightCategory: "sensor", insightTypes: ["CowDoesNotHaveSensor"], id: "cow_died", title: "cow died" },
    { insightCategory: "sensor", insightTypes: ["CowDoesNotHaveSensor"], id: "dismiss", title: "dismiss" },
    {
      insightCategory: "system",
      insightTypes: ["CowDoesNotHaveSensor"],
      id: "sensor_paired",
      title: "sensor paired"
    },

    {
      insightCategory: "system",
      insightTypes: ["BaseStationIsOffline"],
      id: "base_station_is_back_online",
      title: "base station is back online"
    },

    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["Lucina"],
      order: 1,
      id: "ketosis",
      title: "ketosis"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["Lucina"],
      order: 2,
      id: "milk_fever",
      title: "milk fever"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["Lucina"],
      order: 3,
      id: "metritis",
      title: "metritis"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["Lucina"],
      order: 4,
      id: "calving_distress",
      title: "calving distress"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["Lucina"],
      order: 5,
      id: "digestive_problems",
      title: "digestive problems"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["Lucina"],
      order: 6,
      id: "diarrhea",
      title: "diarrhea"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["Lucina"],
      order: 7,
      id: "pneumonia",
      title: "pneumonia"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.yes,
      insightTypes: ["Lucina"],
      order: 8,
      id: "displaced_abomasum",
      title: "displaced abomasum"
    },

    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      insightTypes: ["Lucina"],
      order: 1,
      id: "she_calved",
      title: "she calved"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      insightTypes: ["Lucina"],
      order: 2,
      id: "pen_change",
      title: "pen change"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      insightTypes: ["Lucina"],
      order: 3,
      id: "sensor_removed",
      title: "sensor removed"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      insightTypes: ["Lucina"],
      order: 4,
      id: "no_feed",
      title: "no feed"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      insightTypes: ["Lucina"],
      order: 5,
      id: "hoofs_trimmed",
      title: "hoofs trimmed"
    },
    {
      insightCategory: "health",
      validation: VALIDATION_TYPES.no,
      insightTypes: ["Lucina"],
      order: 6,
      id: "stuck_in_headlock",
      title: "stuck in headlock"
    }
  ];

  /**
   * @ngInject
   * @param $odataresource
   * @param appConfig
   * @param $q
   * @param localStorageService
   * @param lodash
   * @return {insightResolutionService}
   */
  function insightResolutionService($odataresource, appConfig, $q, localStorageService, lodash) {
    var self = this;

    /**
     * Get all the resolutions
     * @return {{}[]}
     */
    self.getResolutions = function () {
      return allResolutions;
    };

    /**
     * Filter resolutions
     * @param resolutions
     * @param insightType
     * @return {[]}
     */
    function filterInsightResolutions(resolutions, insightType) {
      return resolutions.filter(function (e) {
        // First: if the resolution has a `insightType` set AND if it matches = show it
        if (e.insightTypes && e.insightTypes.indexOf(insightType.typeName) > -1) return true;

        // Second if `insightType` is not set AND the category matches = show it
        if (!e.insightTypes && e.insightCategory === insightType.insightCategory) return true;

        //  DON'T show it
        return false;
      });
    }

    /**
     * Sort resolutions
     * @param resolutions
     * @return {[]}
     */
    function sortInsightResolutions(resolutions) {
      return resolutions.sort(function (a, b) {
        return a.order > b.order ? 1 : -1;
      });
    }

    /**
     * Get resolutions per insight type
     * @param insightType
     * @return {[]}
     */
    self.getInsightResolutions = function (insightType) {
      var deferred = $q.defer();

      /**
       * @type {*[]}
       */
      var resolutions = filterInsightResolutions(allResolutions, insightType);

      resolutions = sortInsightResolutions(resolutions);
      deferred.resolve(resolutions);

      return deferred.promise;
    };

    /**
     * @type {string}
     */
    var localStorageKey = "customResolutions";

    /**
     * @type {{health: Array, feed: Array, fertility: Array}}
     */
    var emptyCustomResolutions = {
      health: [],
      feed: [],
      fertility: [],
      system: []
    };

    /**
     * @type {{health: Array, feed: Array, fertility: Array}}
     */
    self.resolutions = localStorageService.get(localStorageKey) || emptyCustomResolutions;

    /**
     * Get the user resolutions for the goven insight category
     * @param category
     * @returns {*}
     */
    self.getLocalStorageResolutions = function (category) {
      var deferred = $q.defer();

      /**
       * Fall back for empty list, some categries may not be here.
       * @type {*|Array}
       */
      var resolutions = self.resolutions[category] || [];

      /**
       * @type {T[]}
       */
      var filteredResolutions = resolutions.filter(function (resolution) {
        return resolution.insightCategory === category;
      });

      deferred.resolve(filteredResolutions || emptyCustomResolutions);

      return deferred.promise;
    };

    /**
     * Tell whether the given resolution is already applied.
     * @params array, resolution
     * @returns {boolean}
     */
    self.inResolutionList = function (resolutionsArray, resolution) {
      if (angular.isArray(resolutionsArray) && resolution !== angular.isUndefined) {
        return resolutionsArray.find(function (applied) {
          return applied.id === resolution.id;
        });
      }
    };

    /**
     * Resolve a value [Yes, No, NA] from a list of resolutions.
     * @param resolutionList
     * @return {*}
     */
    self.resolveValidation = function (resolutionList) {
      var resolved = VALIDATION_TYPES.noAnswer;

      if (resolutionList) {
        /**
         * Pick the ones which has a validation.
         * @type {{}[]}
         */
        var withValidation = resolutionList.filter(function (current) {
          return (
            current.validation && [VALIDATION_TYPES.yes, VALIDATION_TYPES.no].indexOf(current.validation) > -1
          );
        });

        if (withValidation.length) {
          /**
           * Validated as "Yes"
           * @type {{}[]}
           */
          var ofYes = withValidation.filter(function (current) {
            return current.validation === VALIDATION_TYPES.yes;
          });

          if (withValidation.length === ofYes.length) {
            resolved = VALIDATION_TYPES.yes;
          } else if (ofYes.length === 0) {
            resolved = VALIDATION_TYPES.no;
          }
        }
      }

      return resolved;
    };

    /**
     * Add a new resolution to the cookie
     * @param category
     * @param resolution
     */
    self.addNewCustomResolution = function (category, resolution) {
      // check if in list already push
      if (!self.inResolutionList(self.resolutions[category], resolution)) {
        self.resolutions[category].push(resolution);
      }

      // check array length and remove if too high
      if (self.resolutions[category].length > 4) {
        self.resolutions[category] = lodash.drop(self.resolutions[category]);
      }

      localStorageService.set(localStorageKey, self.resolutions);
    };

    self.getResolutionById = function (resolutionId) {
      return lodash.find(allResolutions, lodash.matchesProperty("id", resolutionId));
    };

    /**
     * @type {{yes: string, no: string, noAnswer: string}}
     */
    self.VALIDATION_TYPES = VALIDATION_TYPES;

    return self;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insight.insightInsemination", []).component("insightInsemination", {
    bindings: {
      insight: "<",
      buttonStyle: "<",
      updateInsightInsemination: "&"
    },
    controller: insightInseminationCtrl,
    templateUrl:
      "app/shared-components/angular-ui-components/components/insight/insightInsemination/insightInsemination.html"
  });

  /**
   * @ngInject
   * @param lodash
   * @param insightService
   * @param GenericInsightService
   */
  function insightInseminationCtrl(lodash, insightService, GenericInsightService) {
    var $ctrl = this;

    /**
     * Toggle insemination
     * @param insight
     * @param inseminated
     */
    function inseminationToggle(insight, inseminated) {
      if (!GenericInsightService.resolveFMSFromValidation($ctrl.insight)) {
        /**
         * @type {null}
         */
        var isInseminated = insight.inseminated === inseminated ? null : inseminated;

        insight = insightService.logInsemination(insight, isInseminated);

        $ctrl.updateInsightInsemination({
          insight: insight
        });
      }
    }

    function getToggleColor() {
      if ($ctrl.insight.inseminated === true) {
        return "color-success";
      } else if ($ctrl.insight.inseminated === false) {
        var notOnEstrus =
          $ctrl.insight.insightResolution.filter(function (r) {
            return r.id === "not_on_estrus";
          }).length > 0;

        return notOnEstrus ? "color-danger" : "";
      } else {
        return "";
      }
    }

    /**
     * Tell whether the insight is resolved
     * @return {boolean}
     */
    function hasResolution() {
      return $ctrl.insight.insightResolution !== null && !!$ctrl.insight.insightResolution.length;
    }

    /**
     * Tell whether to show the tick
     * @return {boolean}
     */
    $ctrl.showTick = function () {
      var showTick = false;

      if ($ctrl.insight.inseminated === true) {
        showTick = true;
      } else if ($ctrl.hasResolution()) {
        showTick = false;
      } else if (lodash.isNull($ctrl.insight.inseminated)) {
        showTick = true;
      }

      return showTick;
    };

    /**
     * Tell whether to show the cross
     * @return {boolean}
     */
    $ctrl.showCross = function () {
      var showCross = false;

      if ($ctrl.insight.inseminated === false || lodash.isNull($ctrl.insight.inseminated)) {
        showCross = true;
      }

      return showCross;
    };

    /**
     * Get class name for touched elements
     * @return {string}
     */
    $ctrl.getTouchedClassName = function () {
      var cn = "touched";

      if (!hasResolution() && lodash.isNull($ctrl.insight.inseminated)) {
        cn = "untouched";
      }

      return cn;
    };

    $ctrl.hasResolution = hasResolution;
    $ctrl.inseminationToggle = inseminationToggle;
    $ctrl.getToggleColor = getToggleColor;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight.insightAdminDetails", [])
    .component("insightAdminDetails", {
      bindings: {
        insight: "<"
      },
      controller: insightAdminDetailsCtrl,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/insightAdminDetails/insightAdminDetails.html"
    });

  /**
   * @param farmService
   * @param insightService
   * @ngInject
   */
  function insightAdminDetailsCtrl (farmService, insightService) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.updateInsight = insightService.updateInsight;

    $ctrl.timeBetween = timeBetween;

    /**
     * Init
     */
    function onInit () {
      $ctrl.farm = farmService.getFarm($ctrl.insight.farmID);
      $ctrl.insightStates = ["Hold", "Live", "ForcedLive", "Archived", "Disabled"];

    }

    /**
     * Time between 2 epoch
     * @param epoch1
     * @param epoch2
     * @return {{years: number, months: number, days: number, hours: number, minutes: number}}
     */
    function timeBetween (epoch1, epoch2) {
      var date1 = new Date(epoch1 * 1000);
      var date2 = new Date(epoch2 * 1000);

      if (date1 > date2) { // swap
        /**
         * @type {{years: number, months: number, days: number, hours: number, minutes: number}}
         */
        var result = timeBetween(date2, date1);

        result.years = -result.years;
        result.months = -result.months;
        result.days = -result.days;
        result.hours = -result.hours;
        result.minutes = -result.minutes;

        return result;
      }

      /**
       * @type {{years: number, months: number, days: number, hours: number, minutes: number}}
       */
      result = {
        years: date2.getYear() - date1.getYear(),
        months: date2.getMonth() - date1.getMonth(),
        days: date2.getDate() - date1.getDate(),
        hours: date2.getHours() - date1.getHours(),
        minutes: date2.getMinutes() - date1.getMinutes()
      };

      if (result.hours < 0) {
        result.days--;
        result.hours += 24;
      }

      if (result.days < 0) {
        result.months--;

        /**
         * @type {Date}
         */
        var copy1 = new Date(date1.getTime());

        copy1.setDate(32);
        result.days = 32 - date1.getDate() - copy1.getDate() + date2.getDate();
      }

      if (result.months < 0) {
        result.years--;
        result.months += 12;
      }

      return result;
    }
  }
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.insight.calvingValidation", []).component("calvingValidation", {
    bindings: {
      insight: "<",
      buttonStyle: "<",
      updateCalvingValidation: "&",
      showResolutions: "<",
      disabled: "<"
    },
    controller: calvingValidationCtrl,
    templateUrl:
      "app/shared-components/angular-ui-components/components/insight/calvingValidation/calvingValidation.html"
  });

  /**
   * @param insightService
   * @ngInject
   */
  function calvingValidationCtrl(insightService) {
    var $ctrl = this;

    /**
     * Toggle calving
     * @param insight
     * @param calved
     */
    function toggleCowHasCalved(insight, calved) {
      if (!$ctrl.disabled) {
        /**
         * @type {null}
         */
        var hasCalved = insight.calved === calved ? null : calved;

        insight = insightService.logCalving(insight, hasCalved);

        $ctrl.updateCalvingValidation({
          insight: insight
        });
      }
    }

    $ctrl.toggleCowHasCalved = toggleCowHasCalved;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents.insight.cowDetailsBar", []).component("cowDetailsBar", {
    bindings: {
      cow: "<",
      insight: "<",
      category: "<",
      mainClass: "<",
      detailsClass: "<",
      options: "<"
    },
    controller: cowDetailsBarCtrl,
    templateUrl:
      "app/shared-components/angular-ui-components/components/insight/cowDetailsBar/cowDetailsBar.html"
  });

  /**
   * @ngInject
   * @param COW_STATUS
   * @param $translate
   * @param areaService
   * @param insightService
   * @param doNotBreedService
   * @param dateTimeService
   * @param herdGroupService
   * @param GenericInsightService
   * @param lodash
   */
  function cowDetailsBarCtrl(
    COW_STATUS,
    $translate,
    areaService,
    insightService,
    doNotBreedService,
    dateTimeService,
    herdGroupService,
    GenericInsightService,
    lodash
  ) {
    var $ctrl = this;

    /**
     * @type {Date}
     */
    var now = dateTimeService.midnight();

    $ctrl.$onInit = function () {
      /**
       * @type {{}}
       */
      $ctrl.details = {};

      /**
       * @type {{}}
       */
      this.options = lodash.assign({ showLastEstrus: true }, this.options);

      /**
       * On the insemination insight, if the cow has no previous calving date, show the ‘AGE’ (instead of DIM)
       * of the cow in days if cowAge in the insemination insight is NULL, we should show an icon (see comments)
       * If cow has a previous calving date (lactation 1 and higher) show DIM (as currently is the case)
       */

      /**
       * @type {boolean}
       */
      var mayShowCowAge =
        $ctrl.insight && // insight is present
        !getContext($ctrl.insight).previousCalvingEpoch && // has no previous calving
        !getContext($ctrl.insight).lactationNumber && // insight has no lactation number
        !$ctrl.cow.lactationNumber; // cow has no lactation number

      /**
       * Show cow age only if we don't have previous insemination Epoch and lactation valye
       */
      if (mayShowCowAge) {
        getCowAge();
      } else {
        getDIM();
        getLactation();
      }

      getHerdGroup();
      getDnb();
      getStatus();

      if (this.options.showLastEstrus) {
        getLastEstrus();
      }

      getClassNames();
    };

    /**
     * Get context from insight.
     * @param insight
     * @return {{areaID: number, contextEpoch: number, cowState: string, dairyCowID: number,
     * daysInMilk: number, farmID: number, herdGroupID: number, lactationNumber: number,
     * previousCalvingEpoch: number, previousEstrusEpoch: number, previousInseminationEpoch: number}}
     */
    var getContext = lodash.memoize(function (insight) {
      return insight ? angular.fromJson(insight.insightContext) || {} : {};
    });

    /**
     * Get days in milk
     */
    function getDIM() {
      if ($ctrl.cow.cowStatus !== COW_STATUS.dry && $ctrl.cow.lastCalvingEpoch) {
        /**
         * @type {{title: string, value: number}}
         */
        $ctrl.details.dim = {
          title: "d.i.m",
          value: $ctrl.insight
            ? GenericInsightService.getDIM($ctrl.insight)
            : dateTimeService.daysBetween(now, new Date($ctrl.cow.lastCalvingEpoch * 1000))
        };
      }
    }

    function getLactation() {
      /**
       * @type {number}
       */
      var lactationNumber = getContext($ctrl.insight).lactationNumber || $ctrl.cow.lactationNumber;

      if (lactationNumber) {
        /**
         * @type {{title: string, value: (string|*)}}
         */
        $ctrl.details.lactation = {
          title: "lactation",
          value: lactationNumber
        };
      }
    }

    function getDnb() {
      if ($ctrl.cow.DoNotBreed) {
        /**
         * @type {{title: string, value: string}}
         */
        $ctrl.details.dnb = {
          title: doNotBreedService.copy.cowDetailsLabel,
          value: $translate.instant(doNotBreedService.copy.cowDetailsValue, {}, "messageformat")
        };
      }
    }

    /**
     * Populate herd group data
     */
    function getHerdGroup() {
      /**
       * @type {number}
       */
      var herdGroupID = (getContext($ctrl.insight) || $ctrl.cow).herdGroupID;

      if (herdGroupID) {
        /**
         * @type {{title: string, value: string}}
         */
        $ctrl.details.herdGroupID = { title: "herd", value: "..." };

        herdGroupService.getHerdGroup(herdGroupID).$promise.then(function (value) {
          $ctrl.details.herdGroupID.value = value.groupName;
        });
      }
    }

    function getStatus() {
      /**
       * @type {string}
       */
      var cowStatus = getContext($ctrl.insight).cowState || $ctrl.cow.cowStatus;

      if (cowStatus) {
        /**
         * @type {{title: string, value: (string|Object), addition: *}}
         */
        $ctrl.details.status = {
          title: "status",
          value: $translate.instant(cowStatus)
        };
      }
    }

    function getLastEstrus() {
      /**
       * @type {{title: string, value: string}}
       */
      var empty = {
        title: "last estrus",
        value: "-"
      };

      /**
       * @type {string}
       */
      var cowStatus = getContext($ctrl.insight).cowState || $ctrl.cow.cowStatus;

      /**
       * @type {number}
       * @note according to PE-1386, lastEstrusEpoch shall be considered
       * the more recent between estrus vs. insemination
       */
      var lastEstrusEpoch = Math.max(
        getContext($ctrl.insight).previousEstrusEpoch || $ctrl.cow.lastEstrusEpoch,
        getContext($ctrl.insight).previousInseminationEpoch || $ctrl.cow.lastInseminationEpoch
      );

      if ([COW_STATUS.open, COW_STATUS.inseminated].indexOf(cowStatus) > -1) {
        if (lastEstrusEpoch) {
          var estrusAddition;

          /**
           * Display "Last estrus" only the days since
           * the last estrus in the current lactation.
           * @type {boolean}
           */
          var mayShowLastEstrus = !$ctrl.cow.lastCalvingEpoch || $ctrl.cow.lastCalvingEpoch < lastEstrusEpoch;

          /**
           * @type {number}
           */
          var lastBreedingEpoch =
            getContext($ctrl.insight).previousInseminationEpoch || $ctrl.cow.lastInseminationEpoch;

          /**
           * @type {number}
           */
          var lastEstrusDays = Math.max(
            dateTimeService.daysBetween(
              $ctrl.insight ? new Date($ctrl.insight.startEpoch * 1000) : now,
              new Date(lastEstrusEpoch * 1000)
            ),
            0
          );

          if (mayShowLastEstrus && !!lastEstrusDays) {
            /**
             * @type {string|Object}
             */
            var lastEstrusDaysString = $translate.instant("{{days}} days ago", { days: lastEstrusDays });

            if (lastEstrusEpoch === lastBreedingEpoch) {
              estrusAddition = " (" + $translate.instant("inseminated") + ")";
            }

            /**
             * @type {{title: string, value: (string|Object), addition: string}}
             */
            $ctrl.details.lastEstrus = {
              title: "last estrus",
              value: lastEstrusDaysString,
              addition: estrusAddition
            };
          } else if (mayShowLastEstrus && lastEstrusDays === 0) {
            $ctrl.details.lastEstrus = {
              title: "last estrus",
              value: $translate.instant("date-label-today", {}, "messageformat")
            };
          } else {
            $ctrl.details.lastEstrus = empty;
          }
        } else {
          $ctrl.details.lastEstrus = empty;
        }
      }
    }

    function getCowAge() {
      /**
       * @type {number}
       */
      var cowAge = getContext($ctrl.insight).cowAge;

      /**
       * Cow Age
       * @type {{title: string, value: null}}
       */
      $ctrl.details.cowAge = {
        title: "cow-details-age",
        value: cowAge
      };
    }

    function getClassNames() {
      var keys = Object.keys($ctrl.details);

      /**
       * @type {string}
       */
      $ctrl.mainClass = $ctrl.mainClass || "cow-details-bar";

      /**
       * @type {string}
       */
      $ctrl.detailsClassFirst = "";

      if (!keys.length) {
        $ctrl.details = null;
      }

      if (!$ctrl.detailsClass) {
        $ctrl.detailsClass = "alpha omega ";

        if (keys.length % 5 === 0) {
          $ctrl.detailsClass += "col-xs-2";
          $ctrl.detailsClassFirst = "col-sm-offset-1";
        } else if (keys.length % 4 === 0) {
          $ctrl.detailsClass += "col-xs-3";
        } else if (keys.length % 3 === 0) {
          $ctrl.detailsClass += "col-xs-4";
        } else if (keys.length % 2 === 0) {
          $ctrl.detailsClass += "col-xs-6";
        } else {
          $ctrl.detailsClass += "col-xs-12";
        }
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight.adminInsightValidations", [])
    .component("adminInsightValidations", {
      bindings: {
        genericInsightId: "<"
      },
      controller: adminInsightValidationsCtrl,
      templateUrl: "app/shared-components/angular-ui-components/components/insight/adminInsightValidations/adminInsightValidations.html"
    });

  /**
   * @param sessionService
   * @param insightService
   * @ngInject
   */
  function adminInsightValidationsCtrl (sessionService, insightService) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.validateInsight = validateInsight;
    $ctrl.addAdminValidation = addAdminValidation;

    var insightValidations;

    function onInit () {
      $ctrl.loading = true;

      insightService.getInsightValidations($ctrl.genericInsightId).then(function (result) {
        insightValidations = result;
        initValidations();
        $ctrl.loading = false;
      });
    }

    /**
     * Init validations
     */
    function initValidations () {
      $ctrl.adminValidation = insightValidations.find(function (element) {
        return element.validationByID === "Admin";
      });

      if (!$ctrl.adminValidation) {
        addAdminValidation();
      }
    }

    /**
     * Add admin validation
     */
    function addAdminValidation () {
      /**
       * @type {{validationByID: string, genericInsightID: *, validation: string}}
       */
      var insightValidation = {
        validationByID: "Admin",
        genericInsightID: $ctrl.genericInsightId,
        validation: "NA"
      };

      $ctrl.adminValidation = insightService.newInsightValidation(insightValidation);
    }

    /**
     * Validate insight
     * @param validation
     * @param answer
     */
    function validateInsight (validation, answer) {
      /**
       * @type {Date}
       */
      var now = new Date();

      validation.validation = (validation.validation !== answer ? answer : "NA");
      validation.validationEpoch = parseInt(now.getTime() / 1000);

      $ctrl.loading = true;

      if (validation.InsightValidationID) {
        validation.$update().then(function () {
          $ctrl.loading = false;
        });
      } else {
        validation = insightService.newInsightValidation(validation);

        validation.$save().then(function (result) {
          $ctrl.adminValidation = result;
          $ctrl.loading = false;
        });
      }
    }
  }
}());

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('systemMonitorChartPanel', systemMonitorChartPanel);

  /** @ngInject */
  function systemMonitorChartPanel() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/main/systemMonitorsPanel/systemMonitorChartPanel/systemMonitorChartPanel.html',
      controller: systemMonitorChartPanelController,
      replace: true,
      scope:{
        monitorId: "=",
        childMonitors: "=",
        dayOptions: "="
      }
    };

    return directive;

    /** @ngInject */
    function systemMonitorChartPanelController($scope) {
      if(!$scope.childMonitors || $scope.childMonitors.length <= 1){
        $scope.displayValues = [{
          name: $scope.monitorId,
          id: $scope.monitorId,
          style: 'stackedBar',
          dataType: 'percentage',
          color: '#90c422'
        }];
      }else{
        $scope.displayValues = [];

        angular.forEach($scope.childMonitors, function (value) {
          $scope.displayValues.push({
            name: value.monitorName,
            id: value.referenceID,
            style: 'area',
            dataType: 'percentage'
          })
        });
      }




      $scope.onDateChange = onDateChange;

      $scope.loading   = false;
      $scope.startDate = new Date();
      $scope.endDate   = new Date();
      $scope.dayRange  = 3;
      $scope.maxDate   = new Date();
      $scope.maxDate.setHours(23,59,59,99);


      $scope.startDate.setHours(0,0,0,0);
      $scope.startDate.setDate($scope.startDate.getDate()-($scope.dayRange-1));
      $scope.endDate.setHours(23,59,59,99);

      function onDateChange(startDate, endDate, dayRange) {
        if(endDate.getTime() > $scope.maxDate.getTime()){
          $scope.endDate.setDate($scope.maxDate.getDate());
          $scope.endDate.setHours(23,59,59,99);

          $scope.startDate.setDate($scope.endDate.getDate()-($scope.dayRange-1));
        }else{
          $scope.startDate = startDate;
          $scope.endDate   = endDate;
        }

        $scope.dayRange  = dayRange || $scope.dayRange;
        $scope.$apply();
      }

    }
  }
})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services
  // TODO: replace $jQuery
  /* global $:false */
  /* eslint-disable angular/angularelement */

  angular
    .module('dairyMonitorAdmin')
    .directive('systemMonitorParent', systemMonitorParent);

  /** @ngInject */
  function systemMonitorParent() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/main/systemMonitorsPanel/systemMonitorParent/systemMonitorParent.html',
      scope: {
        monitor: "=",
        successThreshold: "=",
        warningThreshold: "="
      },
      controller: systemMonitorParentController,
      replace: true
      // controllerAs: 'vm',
      // bindToController: true,
    };

    return directive;

    /** @ngInject */
    function systemMonitorParentController($scope, systemMonitorService, $timeout, $element){
      $scope.expanded = false;
      $scope.loading = false;
      var loadingSystemMonitors = false;

      function getSystemMonitors(){
        if(loadingSystemMonitors) return false;
        $scope.loading = true;
        systemMonitorService.getMonitoringStates($scope.monitor.referenceID).then(function(states){
          $scope.monitors = states;
          $timeout(function(){ $($element).find('[data-toggle="tooltip"]').tooltip();}, 1);
          $scope.loading  = false;
        });
        loadingSystemMonitors = true;
      }


      $scope.toggleMonitorDetails = function (){
        $scope.expanded = !$scope.expanded;
        getSystemMonitors();
      };
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.newInsightType', [
      'dairyMonitorAdmin.insights.insightTypeDetailsForm'
    ])

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.newInsightType')
    .component('newInsightType', {
      bindings: {
      },
      controller: newInsightTypeCtrl,
      templateUrl: 'app/views/insights/insightTypes/newInsightType/newInsightType.html'
    });

  /** @ngInject */
  function newInsightTypeCtrl(insightService, toastr, $translate) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.save    = save;

    function onInit() {
      var insightType = {};
      insightType.title = '';
      insightType.typeName = '';
      insightType.insightCategory = '';
      insightType.slidingWindowInterval = '';
      insightType.insightScope = '';

      $ctrl.insightType = insightService.newInsightType(insightType);
    }


    function save(obj){
      $ctrl.loading = true;
      obj.slidingWindowInterval = parseInt(obj.slidingWindowInterval);

      obj.$save().then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_SAVED"));
        onInit();
      }, function () {
        $ctrl.loading = false;
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });
    }
  }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.insightTypesList', [
      'dairyMonitorAdmin.insights.insightModelsList'
    ])

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.insightTypesList')
    .component('insightTypesList', {
      bindings: {
        insightTypes: '<'
      },
      controller: insightTypesListCtrl,
      templateUrl: 'app/views/insights/insightTypes/insightTypesList/insightTypesList.html'
    });

  /** @ngInject */
  function insightTypesListCtrl(insightService, toastr, $translate) {
    var $ctrl = this;

    $ctrl.$onInit       = onInit;
    $ctrl.rowClicked    = rowClicked;
    $ctrl.switchSection = switchSection;
    $ctrl.update        = update;
    $ctrl.delete        = deleteObj;
    $ctrl.addSpaces     = addSpaces;

    function onInit() {
      $ctrl.hiddenVariables = [];
      $ctrl.noEditVariables = 'InsightTypeID';

      $ctrl.sectionNavItems = [];
      $ctrl.sectionNavItems.push({ sectionID: 'insightTypeDetails', title: 'Details' });
      $ctrl.sectionNavItems.push({ sectionID: 'insightModels',  title: 'Models' });
    }

    function rowClicked(insightType) {
      $ctrl.currentListItem = ($ctrl.currentListItem === insightType.InsightTypeID ? $ctrl.currentListItem = null : $ctrl.currentListItem = insightType.InsightTypeID)
      switchSection($ctrl.sectionNavItems[0])
    }

    function switchSection(section){
      $ctrl.currentSection = section.sectionID;
      if($ctrl.currentSection === 'insightModels'){
        loadInsightModels();
      }
    }

    function loadInsightModels() {
      $ctrl.insightModels = [];
      insightService.getInsightModels($ctrl.currentListItem).then(function (result) {
        $ctrl.insightModels = result;
      });
    }

    function update(obj){
      $ctrl.loading = true;
      obj.slidingWindowInterval = parseInt(obj.slidingWindowInterval);
      obj.$update().then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_SAVED"));
      }, function () {
        $ctrl.loading = false;
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });
    }

    function deleteObj(obj){
      $ctrl.loading = true;
      obj.$delete().then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_DELETED"));

        $ctrl.insightTypes = $ctrl.insightTypes.filter(function (e) {
          return e.InsightTypeID !== obj.InsightTypeID;
        });

      }, function () {
        $ctrl.loading = false;
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });
    }

    function addSpaces(string) {
      return string.replace(/([a-z])(?=[A-Z])/g, '$1 ').trim();
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.insightTypeDetailsForm', [])
    .component('insightTypeDetailsForm', {
      bindings: {
        insightType: '='
      },
      controller: insightTypeDetailsFormCtrl,
      templateUrl: 'app/views/insights/insightTypes/insightTypeDetailsForm/insightTypeDetailsForm.html'
    })

  /** @ngInject */
  function insightTypeDetailsFormCtrl() {
    var $ctrl = this;

    $ctrl.$onInit       = onInit;

    function onInit() {
      $ctrl.categories = [
        'fertility',
        'health',
        'feed',
        'yield',
        'system'
      ];

      $ctrl.insightScopes = [
        'cow',
        'herd',
        'farm'
      ]
    }
  }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.newInsightModel', [
      'dairyMonitorAdmin.insights.insightModelDetailsForm'
    ])

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.newInsightModel')
    .component('newInsightModel', {
      bindings: {
        insightTypes: '<'
      },
      controller: newInsightModelCtrl,
      templateUrl: 'app/views/insights/insightModels/newInsightModel/newInsightModel.html'
    });

  /** @ngInject */
  function newInsightModelCtrl(insightService, toastr, $translate, $stateParams) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.save    = save;

    function onInit() {
      var insightModel = {};
      if($stateParams.insightTypeID){
        insightModel.insightTypeID = parseInt($stateParams.insightTypeID);
      }

      $ctrl.insightModel = insightService.newInsightModel(insightModel);
    }


    function save(obj){
      $ctrl.loading = true;

      obj.$save().then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_SAVED"));
        onInit();
      }, function () {
        $ctrl.loading = false;
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });
    }
  }

}());

(function () {
  'use strict';

  angular.module('dairyMonitorAdmin.insights.insightModelsList',[
      'dairyMonitorAdmin.insights.insightModelDetailsForm'
    ]);

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.insightModelsList')
    .component('insightModelsList', {
      bindings: {
        insightModels: '<'
      },
      controller: insightModelsListCtrl,
      templateUrl: 'app/views/insights/insightModels/insightModelsList/insightModelsList.html'
    });

  /** @ngInject */
  function insightModelsListCtrl(toastr, $translate, insightService) {
    var $ctrl = this;

    $ctrl.$onInit   = onInit;
    $ctrl.update    = update;
    $ctrl.delete    = deleteObj;

    function onInit() {
      $ctrl.hiddenVariables = [];
      $ctrl.noEditVariables = 'InsightModelID';
      insightService.getInsightTypes().then(function (result) {
        $ctrl.insightTypes = result;
      });
    }

    function update(obj){
      $ctrl.loading = true;
      obj.$update().then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_SAVED"));
      }, function () {
        $ctrl.loading = false;
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });
    }

    function deleteObj(obj){
      $ctrl.loading = true;
      obj.$delete().then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_DELETED"));

        $ctrl.insightModels = $ctrl.insightModels.filter(function (e) {
          return e.InsightModelID !== obj.InsightModelID;
        });

      }, function () {
        $ctrl.loading = false;
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.insightModelDetailsForm', [])
    .component('insightModelDetailsForm', {
      bindings: {
        insightModel: '=',
        insightTypes: '<'
      },
      controller: insightModelDetailsFormCtrl,
      templateUrl: 'app/views/insights/insightModels/insightModelDetailsForm/insightModelDetailsForm.html'
    })

  /** @ngInject */
  function insightModelDetailsFormCtrl() {
    var $ctrl = this;

    $ctrl.$onInit       = onInit;

    function onInit() {
      $ctrl.releaseStates = [
        'development',
        'trial',
        'released',
        'deprecated'
      ];

    }
  }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.reports.report', [
      'rt.debounce',
      'ctraAuthentication',
      'ctraUIComponents',
      'ctraDataVisualisations',
      'ctraDataVisualisations.dataVisualisation',
      'ctraDataVisualisations.contextMenu'
    ]);

}());

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin.reports.report").component("report", {
    bindings: {
      subjectTypes: "<",
      farms: "<",
      herdGroups: "<",
      //cows: "<",
      startDate: "<",
      endDate: "<",
      dayRange: "<",
      maxDate: "<"
    },
    controller: reportsCtrl,
    templateUrl: "app/views/dataExplorer/reports/report/report.html"
  });

  /** @ngInject */
  function reportsCtrl($window, $location, $scope, $q, sysAdminService, lodash, contextMenuService) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.$onChanges = onChanges;

    $ctrl.onSubjectTypeChange = onSubjectTypeChange;
    $ctrl.onDateChange = onDateChange;
    $ctrl.toggleGroup = toggleGroup;
    $ctrl.groupStyleChanged = groupStyleChanged;
    $ctrl.settingFiltersChanged = settingFiltersChanged;
    $ctrl.isWholeGroupVisible = isWholeGroupVisible;

    $ctrl.onFarmSelected = onFarmSelected;
    $ctrl.onHerdGroupSelected = onHerdGroupSelected;
    $ctrl.onCowSelected = onCowSelected;

    $ctrl.onInsightClicked = onInsightClicked;

    $ctrl.updateCowsFilter = updateCowsFilter;

    $ctrl.setVisualisations = setVisualisations;
    $ctrl.updateVisualisations = updateVisualisations;

    $ctrl.settingGroups = [];

    function onInit() {
      $ctrl.farm = "null";
      $ctrl.subjectType = $ctrl.subjectTypes[0];
      $ctrl.subjectID = null;

      $ctrl.useCustomAggWindow = false;
      $ctrl.useUnscaledStats = true;
      $ctrl.useCustomAggInterval = false;

      var h = 3600;
      $ctrl.customAgWindow = h * 24;
      $ctrl.customAgInterval = h * 6;

      $ctrl.agSliderOptions = {
        floor: h / 12,
        ceil: h * 24,
        stepsArray: [h / 12, h / 6, h / 2, h, h * 2, h * 3, h * 4, h * 6, h * 8, h * 12, h * 24],
        translate: function (value) {
          return parseInt(value) / 3600 + " hours";
        },
        onEnd: updateVisualisations
      };

      var now = new Date();

      $ctrl.nowEpoch = now.getTime() / 1000;

      $ctrl.searchString = "";
      $ctrl.onlyCowsWithNodes = true;

      /**
       * Cow statuses.
       * @type {{open: string, inseminated: string, pregnant: string, dry: string, unknown: string}}
       */
      var COW_STATUSES = {
        open: "open",
        inseminated: "inseminated",
        pregnant: "pregnant",
        dry: "dry",
        unknown: "unknown"
      };

      /**
       * Cow status objects.
       * @type {Array}
       * @memberOf cowsListController
       */
      $ctrl.cowStatuses = lodash.map(lodash.values(COW_STATUSES), function (status) {
        return {
          title: ["COW_STATUS_", status].join(""),
          value: status
        };
      });
    }

    function onChanges(change) {
      if (change.hasOwnProperty("cows") && $ctrl.cows && $ctrl.cows.length) {
        updateCowsFilter();
      }
    }

    function onSubjectTypeChange(subjectType) {
      $ctrl.subjectType = subjectType;
      $ctrl.subjectId = null;

      if ($ctrl.subjectType.id === "farm") {
        if ($ctrl.farm) {
          $ctrl.subjectId = $ctrl.farm.FarmID;
          onFarmSelected($ctrl.farm);
        }
      }
      if ($ctrl.subjectType.id === "herdGroup") {
        if ($ctrl.herdGroup) {
          $ctrl.subjectId = $ctrl.herdGroup.HerdGroupID;
          onHerdGroupSelected($ctrl.herdGroup);
        }

        $ctrl.subjectId = $ctrl.herdGroup ? $ctrl.herdGroup.HerdGroupID : null;
      }
      if ($ctrl.subjectType.id === "cow") {
        if ($ctrl.cow) {
          $ctrl.subjectId = $ctrl.cow.DairyCowID;
          onCowSelected($ctrl.cow);
        }
      }

      setVisualisations();
    }

    function onDateChange(startDate, endDate, dayRange) {
      if (endDate.getTime() > $ctrl.maxDate.getTime()) {
        $ctrl.endDate.setDate($ctrl.maxDate.getDate());
        $ctrl.endDate.setHours(23, 59, 59, 99);

        $ctrl.startDate.setDate($ctrl.endDate.getDate() - ($ctrl.dayRange - 1));
      } else {
        $ctrl.startDate = startDate;
        $ctrl.endDate = endDate;
      }

      $ctrl.dayRange = dayRange || $ctrl.dayRange;
      $scope.$apply();
    }

    function toggleGroup(group) {
      angular.forEach(group.settings, function (value) {
        value.isVisible = group.isVisible;
      });

      updateVisualisations();
    }

    function groupStyleChanged(group) {
      angular.forEach(group.settings, function (value) {
        value.style = group.style;
      });

      updateVisualisations();
    }

    /**
     * Apply a filter
     * @param setting
     * @param filter
     */
    function settingFiltersChanged(setting, filter) {
      setting.isVisible = setting.isVisible || !!filter;
      setting.filters = filter ? filter : null;

      updateVisualisations();
    }

    function isWholeGroupVisible(group) {
      var result = true;

      angular.forEach(group.settings, function (value) {
        result = !value.isVisible ? false : result;
      });

      return result;
    }

    function onFarmSelected(farm) {
      sysAdminService.getHerdGroups(farm ? farm.FarmID : null).$promise.then(function (result) {
        $ctrl.herdGroups = result;
      });

      sysAdminService.getCows(farm ? farm.FarmID : null).$promise.then(function (result) {
        $ctrl.cows = result.sort(function (a, b) {
          if (parseInt(a.cowTagNumber) > parseInt(b.cowTagNumber)) return 1;
          return -1;
        });

        updateCowsFilter();
      });

      if ($ctrl.subjectType.id === "farm") {
        $ctrl.selectedFarms = [farm];
        setVisualisations();
      }
    }

    function onHerdGroupSelected(herdGroup) {
      if ($ctrl.subjectType.id === "herdGroup") {
        $ctrl.selectedHerdGroups = [herdGroup];
        setVisualisations();
      }
    }

    function onCowSelected(cow) {
      if ($ctrl.subjectType.id === "cow") {
        $ctrl.selectedCows = [cow];
        setVisualisations();
      }
    }

    function setVisualisations() {
      var visualisations = [];

      if ($ctrl.subjectType.id === "cow") {
        angular.forEach($ctrl.selectedCows, function (cow) {
          var visual = {};
          visual.id = cow.DairyCowID;
          visual.title = "#" + cow.cowTagNumber + " " + (cow.cowName ? cow.cowName : "");
          visual.subjects = { cow: cow.DairyCowID, farm: cow.farmID };
          visual.displayValues = getDisplayValues(visual.subjects);
          visual.contextMenu = contextMenuService.getAddEventMenu("cow", visual.subjects);
          visual.subject = cow;
          visual.scope = "cow";
          visualisations.push(visual);
        });
      }

      if ($ctrl.subjectType.id === "herdGroup") {
        angular.forEach($ctrl.selectedHerdGroups, function (herdGroup) {
          var visual = {};
          visual.id = herdGroup.HerdGroupID;
          visual.title = herdGroup.groupName;
          visual.subjects = { herdGroup: herdGroup.HerdGroupID };
          visual.displayValues = getDisplayValues(visual.subjects);
          visualisations.push(visual);
        });
      }

      if ($ctrl.subjectType.id === "farm") {
        angular.forEach($ctrl.selectedFarms, function (farm) {
          var visual = {};
          visual.id = farm.FarmID;
          visual.title = farm.farmName;
          visual.subjects = { farm: farm.FarmID, allCowsOfFarm: farm.FarmID, herd: farm.FarmID };
          visual.displayValues = getDisplayValues(visual.subjects);
          visual.contextMenu = contextMenuService.getAddEventMenu("farm", visual.subjects);
          visualisations.push(visual);
        });
      }

      $ctrl.visualisations = visualisations;
    }

    function updateVisualisations() {
      angular.forEach($ctrl.visualisations, function (e) {
        e.displayValues = getDisplayValues(e.subjects);
      });
    }

    function onInsightClicked(insight) {
      /* eslint-disable angular/no-private-call */
      var baseUrl = $location.$$absUrl
        .toString()
        .substring(
          0,
          decodeURIComponent($location.$$absUrl)
            .toString()
            .indexOf($location.$$path.toString(), $location.$$absUrl.toString().indexOf("#")) + 1
        );

      if (insight.GenericInsightID) {
        $window.open(baseUrl + "insight/" + insight.GenericInsightID, "_blank");
      }

      if (insight.GenericLabelID) {
        $window.open(baseUrl + "label/" + insight.GenericLabelID, "_blank");
      }
    }

    function updateCowsFilter() {
      if (!$ctrl.cows) return false;

      $ctrl.filteredCows = $ctrl.cows.filter(function (e) {
        var _return = true;

        // if ($ctrl.farm && $ctrl.farm.FarmID && _return) {
        //   if (e.farmID !== $ctrl.farm.FarmID) _return = false;
        // }

        if ($ctrl.searchString && _return) {
          if (
            e.cowTagNumber.toLowerCase().indexOf($ctrl.searchString.toLowerCase()) === -1 &&
            e.DairyCowID !== parseInt($ctrl.searchString)
          )
            _return = false;
        }

        if ($ctrl.onlyCowsWithNodes && _return) {
          if (!e.nodeID) _return = false;
        }

        if ($ctrl.cowStatus && _return) {
          if (e.cowStatus !== $ctrl.cowStatus) _return = false;
        }

        return _return;
      });
    }

    function getAllSettings() {
      return $ctrl.subjectType.settings.reduce(function (prev, settingsGroup) {
        // Make a copy so the properties can be adjusted later
        return prev.concat(angular.copy(settingsGroup.settings));
        //return prev.concat(settingsGroup.settings);
      }, []);
    }

    function getVisibleData() {
      return getAllSettings().reduce(function (prev, setting) {
        if (setting.isVisible) {
          return prev.concat(setting);
        }
        return prev;
      }, []);
    }

    /**
     * Get display values from subjects.
     * @param subjects
     * @return {*[]}
     */
    function getDisplayValues(subjects) {
      /**
       * @type {{dynamicStatsUnscaled: string, dynamicStatsWindowed: string}}
       */
      var statTypes = {
        dynamicStatsUnscaled: "dynamicStatsUnscaled",
        dynamicStatsWindowed: "dynamicStatsWindowed"
      };

      /**
       * @type {[]}
       */
      var values = getVisibleData();

      angular.forEach(values, function (value) {
        value.subjectId = subjects[value.scope];

        /** Set custom aggregation window and interval. */
        if ($ctrl.useCustomAggWindow) {
          value = setAggregationWindow(value);
          value = setAggregationInterval(value);
        }

        /** If applicable, use windowed or unscaled stat type. */
        if (lodash.values(statTypes).indexOf(value.source) > -1) {
          value = setStatType(
            value,
            $ctrl.useUnscaledStats ? statTypes.dynamicStatsUnscaled : statTypes.dynamicStatsWindowed
          );
        }

        return value;
      });

      return values;
    }

    function setAggregationWindow(dataPoint) {
      dataPoint.getAggregationWindow = function () {
        return $ctrl.customAgWindow;
      };

      return dataPoint;
    }

    function setStatType(dataPoint, value) {
      dataPoint.getStatType = function () {
        return value;
      };

      return dataPoint;
    }

    function setAggregationInterval(dataPoint) {
      dataPoint.getAggregationInterval = function () {
        return $ctrl.useCustomAggInterval ? $ctrl.customAgInterval : $ctrl.customAgWindow;
      };

      return dataPoint;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .component('insightDetailsForm', {
      bindings: {
        insight: '=',
        insightTypes: '<'
      },
      controller: insightDetailsFormCtrl,
      templateUrl: 'app/views/insight/editInsight/insightDetailsForm/insightDetailsForm.html'
    })

  /** @ngInject */
  function insightDetailsFormCtrl() {
    var $ctrl = this;

    $ctrl.$onInit       = onInit;
    $ctrl.addSpaces     = addSpaces;


    function onInit() {
      $ctrl.insightStates = ['hold','live','archive','disabled'];
      $ctrl.hiddenVariables = [
                                'insightTasks',
                                'insightValidations',
                                'insightComments',
                                'insightChecks',
                                'dairyCow',
                                'insightType',
                                'insightProbability'
                              ];
      $ctrl.noEditVariables = [
                                'InsightID',
                                'customerID',
                                'farmID',
                                'dairyCowID',
                                'insightTypeID'
                              ];
    }
    function addSpaces(string) {
      return string.replace(/([a-z])(?=[A-Z])/g, '$1 ').trim();
    }

  }

}());

/* global L */
(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.farmsMap', ['ui-leaflet'])
    .component('farmsMap', {
      bindings: {
        farms: '<',
        colorKey: '@',
        selectedFarm: '<'
      },
      controller: farmsMapCtrl,
      template: '<leaflet class="angular-leaflet-map" defaults="$ctrl.defaults" markers="$ctrl.markers"></leaflet>'
    });

  /** @ngInject */
  function farmsMapCtrl(leafletData) {
    var $ctrl = this;

    $ctrl.defaults = {
      scrollWheelZoom: false
    };
    $ctrl.markers = [];
    $ctrl.$onChanges = onChanges;

    var iconSize     = [20, 30];
    var iconAnchor   = [10, 30];
    var popupAnchor  = [0, -25]
    var shadowUrl    = 'assets/images/marker-shadow.svg';
    var shadowSize   = [25, 25];
    var shadowAnchor = [2, 23];

    var defaultIcon = {
      iconUrl:    'assets/images/marker-inactive.svg',
      iconSize:   iconSize,
      iconAnchor: iconAnchor,
      popupAnchor: popupAnchor,
      shadowUrl: shadowUrl,
      shadowSize: shadowSize,
      shadowAnchor: shadowAnchor
    };
    var successIcon = {
      iconUrl:    'assets/images/marker-success.svg',
      iconSize:   iconSize,
      iconAnchor: iconAnchor,
      popupAnchor: popupAnchor,
      shadowUrl: shadowUrl,
      shadowSize: shadowSize,
      shadowAnchor: shadowAnchor
    };
    var warningIcon = {
      iconUrl:    'assets/images/marker-warning.svg',
      iconSize:   iconSize,
      iconAnchor: iconAnchor,
      popupAnchor: popupAnchor,
      shadowUrl: shadowUrl,
      shadowSize: shadowSize,
      shadowAnchor: shadowAnchor
    };
    var dangerIcon = {
      iconUrl:    'assets/images/marker-danger.svg',
      iconSize:   iconSize,
      iconAnchor: iconAnchor,
      popupAnchor: popupAnchor,
      shadowUrl: shadowUrl,
      shadowSize: shadowSize,
      shadowAnchor: shadowAnchor
    };


    function onChanges(change) {
      if (change.hasOwnProperty('farms') && change.farms.currentValue) {
        setMarkers();
        centerMap();
      }
      if (change.hasOwnProperty('colorKey')) {
        setMarkers();
      }
      if (change.hasOwnProperty('selectedFarm')) {
        selectFarm();
      }
    }

    function setMarkers() {
      var riseOnHover = true;

      if ($ctrl.farms) {
        $ctrl.markers = $ctrl.farms
          .filter(function(farm) {
            return !!farm.farmGPSCoordinates;
          })
          .reduce(function(markers, farm) {
            var coordinates = farm.farmGPSCoordinates.split(',');
            var marker = {
              group: (farm.group ? farm.group : null),
              lat: +coordinates[0],
              lng: +coordinates[1],
              message: farm.farmName,
              icon: setIcon(farm),
              riseOnHover: riseOnHover
            };
            markers[farm.FarmID] = marker;
            return markers;
          }, {});
      }
    }

    function centerMap() {
      if ($ctrl.markers && Object.keys($ctrl.markers).length > 0) {
        var arrayOfLatLngs = Object.keys($ctrl.markers).map(function(key) {
          return [$ctrl.markers[key].lat, $ctrl.markers[key].lng];
        });

        var bounds = new L.LatLngBounds(arrayOfLatLngs);
        leafletData.getMap().then(function(map) {
          map.fitBounds(bounds);
        });
      }
    }

    function selectFarm() {
      if ($ctrl.markers && $ctrl.selectedFarm) {
        $ctrl.markers[$ctrl.selectedFarm.FarmID].focus = true;
      }
    }

    // TODO: proper implementation when data is available.
    function setIcon(farm) {
      if ($ctrl.colorKey && farm.hasOwnProperty($ctrl.colorKey)) {
        var value = farm[$ctrl.colorKey];
        if (value === 'success') {
          return successIcon;
        } else if (value  === 'warning') {
          return warningIcon;
        } else if(value  === 'danger'){
          return dangerIcon;
        } else {
          return defaultIcon;
        }
      } else {
        return defaultIcon;
      }
    }

  }

})();

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('NewSensorController', function ($window, $rootScope, $scope, $timeout, $interval, $log, sysAdminService) {
    var vm = $scope;

    vm.customers    = sysAdminService.getCustomers();
    vm.farms        = sysAdminService.getFarms();
    vm.baseStations = sysAdminService.getBaseStations();

    vm.selectedNewSensor = [];

    vm.sensorAdded = function (sensors) {
      angular.forEach(sensors, function (sensor) {
        vm.sensors.push(sensor);
      });
      vm.showForm = '';
    }


});

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('roleList', roleList);

  /** @ngInject */
  function roleList() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/roles/roleList/roleList.html',
      controller: roleListController,
      scope: {
        roles: "=",
        customers: "=",
        farms: "="
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function roleListController($scope, $log, $window, $state, roleService) {
      var vm = $scope;

      vm.deleteRole = function (role) {
        var sure = $window.confirm("Are you sure you want to delete this?\nThis action cannot be undone!");
        if(sure){
          var really = $window.confirm("PLEASE DOUBLE CHECK!\nYou are deleting the following:\n"+angular.toJson(role.name));
          if(really){

            roleService.deleteRole(role).then(function () {
              $state.go($state.current, {}, {reload: true});
            }, function () {
              $window.alert('Something went wrong, please try again later');
            });
          }
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('newFarmForm', newFarmForm);

  /** @ngInject */
  function newFarmForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/farms/newFarmForm/newFarmForm.html',
      controller: newFarmFormController,
      scope: {
        successCallback: "&"
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function newFarmFormController($rootScope, $scope, $log, $window, $state, sysAdminService) {
      var vm = $scope;

      vm.newFarmObj = {};
      vm.farms      = sysAdminService.getFarms();
      vm.customers  = sysAdminService.getCustomers();

      vm.newFarm = function(){
        $rootScope.loading = true;
        vm.success = "";
        vm.error   = ""

        var farm = sysAdminService.newFarm(vm.newFarmObj);

        farm.$save().then(function(result){

          vm.newFarmObj = {};

          vm.success = "Farm has been added";
          vm.successCallback({farm: result});

          $rootScope.loading = false;
        }, function(){
          vm.error = "Something went wrong with creating a farm...";

          // Something went wrong!
          $rootScope.loading = false;
        });
      };

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('newRoleForm', newRoleForm);

  /** @ngInject */
  function newRoleForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/roles/newRoleForm/newRoleForm.html',
      controller: newRoleFormController,
      scope: {
        successCallback: "&"
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function newRoleFormController($rootScope, $scope, $log, $window, $state, roleService) {
      var vm = $scope;

      vm.newRoleObj = {};

      vm.newRole = function(){
        $rootScope.loading = true;
        vm.success = "";
        vm.error   = "";

        roleService.newRole(vm.newRoleObj).then(function successCallback(result){

          vm.newRoleObj = {};
          vm.success = "Role has been added";
          vm.successCallback({role: result});

          $rootScope.loading = false;
        }, function(){
          vm.error = "Something went wrong with creating a role...";

          // Something went wrong!
          $rootScope.loading = false;
        });
      };

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('farmList', farmList);

  /** @ngInject */
  function farmList() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/farms/farmList/farmList.html',
      controller: farmListController,
      scope: {
        farms: "=",
        customers: "="
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function farmListController($scope, $log, $window, $state, $location) {
      var vm = $scope;

      vm.loading = true;
      vm.farms.$promise.then(function () { vm.loading = false; })

      vm.goToFarm = function (farmID) {
        $location.url("/account-management/farms/farm?farmID="+farmID);
      }

      vm.delete = function (odataObj) {
        var sure = $window.confirm("Are you sure you want to delete this?\nThis action cannot be undone!");
        if(sure){
          var really = $window.confirm("PLEASE DOUBLE CHECK!\nYou are deleting the following:\n"+angular.toJson(odataObj));
          if(really){
            odataObj.$delete().then(function () {
              $state.go($state.current, {}, {reload: true});
            }, function () {
              $window.alert('Something went wrong, please try again later');
            });
          }
        }
      }
    }
  }
})();

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('FarmController', function ($scope, $log, $stateParams, $element, sysAdminService) {
    var vm = $scope;

    //vm.activate();




      vm.farm = sysAdminService.getFarm($stateParams.farmID);

      vm.sectionNavItems = [
        {sectionID: 'farmDetails', title: 'Farm Details'},
        {sectionID: 'hardware',    title: 'Hardware'},
        {sectionID: 'livestock',   title: 'Livestock'}
      ];

      vm.currentSection = 'farmDetails';






});

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin").component("userRolesForm", {
    controller: userRolesFormCtrl,
    templateUrl: "app/views/accountManagement/users/userRolesForm/userRolesForm.html",
    bindings: {
      rolesList: "<",
      onChange: "&"
    }
  });

  function userRolesFormCtrl(roleService, lodash) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.updateRoles = updateRoles;

    function onInit() {
      roleService.getRoles().then(function successCallback(response) {
        /**
         * Separate out the roles that start with Has
         */
        var roleStartingWithHas = lodash.remove(response, function (role) {
          return lodash.includes(role.name, "Has");
        });
        /**
         * Sort the remaining response
         */
        response = lodash.orderBy(response, ["name"], ["asc"]);
        /**
         * concatenate both list in such a way that the sorted roles come first and the ones
         * starting with has come at the end
         */
        $ctrl.roles = lodash.concat(response, roleStartingWithHas);
      });
    }

    function updateRoles(role) {
      /**
       * if we are creating the user the first time the role list is empty
       * @type {Array}
       */
      $ctrl.rolesList = $ctrl.rolesList ? $ctrl.rolesList : [];

      var index = $ctrl.rolesList.indexOf(role);

      // Is currently selected
      if (index > -1) {
        $ctrl.rolesList.splice(index, 1);
      }

      // Is newly selected
      else {
        $ctrl.rolesList.push(role);
      }

      $ctrl.onChange({ rolesList: $ctrl.rolesList });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('userList', userList);

  /** @ngInject */
  function userList() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/users/userList/userList.html',
      controller: userListController,
      scope: {
        users: "=",
        customers: "=",
        farms: "="
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function userListController($scope, $log, $window, $state, userService, toastr) {
      var vm = $scope;

      vm.status = {}

      vm.addSpaces = function (string) {
        return string.replace(/([a-z])(?=[A-Z])/g, '$1 ').trim();
      };

      vm.update = function (obj){
        vm.status.saving = true;

        userService.updateUser(obj).then(function successCallback(){

          vm.status.saving = false;
          toastr.success("Saved!");

        },function errorCallback(){

          vm.status.saving = false;
          toastr.error("Something went wrong! :-(");

        });
      }



      vm.deleteUser = function (user) {
        var sure = $window.confirm("Are you sure you want to delete this?\nThis action cannot be undone!");
        if(sure){
          var really = $window.confirm("PLEASE DOUBLE CHECK!\nYou are deleting the following:\n"+angular.toJson(user.email));
          if(really){

            userService.deleteUser(user).then(function () {
              $state.go($state.current, {}, {reload: true});
            }, function () {
              $window.alert('Something went wrong, please try again later');
            });
          }
        }
      }

      vm.resetPassword = function (email) {
        var confirmation = $window.confirm("Are you sure you want to reset the password for " + email);

        if (confirmation) {
          userService.resetUserPassword(email).then(function (response) {
            $window.alert('An email containing instructions to reset password is sent to the email you provided');
          }, function (error) {
            $window.alert('Something went wrong, please try again later');
          });
        }
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin").component("userDetailsForm", {
    controller: userDetailsFormCtrl,
    templateUrl: "app/views/accountManagement/users/userDetailsForm/userDetailsForm.html",
    bindings: {
      user: "<",
      onChange: "&"
    }
  });

  /**
   * @ngInject
   * @param sysAdminService
   * @param lodash
   */
  function userDetailsFormCtrl(sysAdminService, lodash) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.updateUser = updateUser;
    $ctrl.updateUserRoles = updateUserRoles;
    $ctrl.needsCustomer = needsCustomer;

    function onInit() {
      sysAdminService.getCustomers().$promise.then(function successCallback(customers) {
        $ctrl.customers = customers;
      });
    }

    function updateUser() {
      $ctrl.onChange({ user: $ctrl.user });
    }

    function updateUserRoles(rolesList) {
      $ctrl.user.rolesList = rolesList;
      updateUser();
    }

    function needsCustomer() {
      return (
        lodash.isArray($ctrl.user.rolesList) &&
        lodash.includes($ctrl.user.rolesList, "Farmer")
      );
    }
  }
})();

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin").directive("newUserForm", newUserForm);

  /** @ngInject */
  function newUserForm() {
    var directive = {
      restrict: "E",
      templateUrl: "app/views/accountManagement/users/newUserForm/newUserForm.html",
      controller: newUserFormController,
      scope: {
        successCallback: "&"
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function newUserFormController($rootScope, $scope, $log, $window, $state, userService, toastr, lodash) {
      var vm = $scope;

      vm.newUserObj = {};

      vm.updateUser = function (user) {
        vm.newUserObj = user;
        checkUserVariables(user);
      };

      function checkUserVariables(user) {
        vm.allUserChecksPassed = false;

        if (!user.rolesList.length) return false;
        if (!user.email) return false;
        if (vm.needsCustomer(user) && !user.customerID) return false;
        if (!vm.passwordChecksPassed) return false;

        vm.allUserChecksPassed = true;
      }

      vm.needsCustomer = function (user) {
        return lodash.isArray(user.rolesList) && lodash.includes(user.rolesList, "Farmer");
      };

      vm.newUser = function () {
        $rootScope.loading = true;

        vm.newUserObj.confirmPassword = vm.newUserObj.password;

        userService.newUser(vm.newUserObj).then(
          function successCallback(result) {
            vm.newUserObj = {};
            toastr.success("User has been added");

            vm.successCallback({ user: result });

            $rootScope.loading = false;
          },
          function (error) {
            toastr.error(error);
            // Something went wrong!
            $rootScope.loading = false;
          }
        );
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('newCustomerForm', newCustomerForm);

  /** @ngInject */
  function newCustomerForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/customers/newCustomerForm/newCustomerForm.html',
      controller: newCustomerFormController,
      scope: {
        successCallback: "&"
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function newCustomerFormController($rootScope, $scope, $log, $window, $state, sysAdminService, userService) {
      var vm = $scope;

      vm.newCustomerObj                     = {};
      vm.newCustomerObj.primaryUser         = null;
      vm.newCustomerObj.additionalUsersList = [];

      vm.selectedAdditionalUser = null;
      vm.users;
      vm.farms     = sysAdminService.getFarms();
      vm.customers = sysAdminService.getCustomers();

      userService.getUsers().then(function successCallback(response) {
        vm.users = response;
      });

      vm.newCustomer = function(){
        $rootScope.loading = true;

        vm.newCustomerObj.primaryUserID = vm.primaryUser.id

        var customer = sysAdminService.newCustomer(vm.newCustomerObj);

        customer.$save().then(function(result){

          vm.primaryUser.customerID = result.CustomerID;
          userService.updateUser(vm.primaryUser).then(function successCallback() {

            vm.newCustomerObj = {};
            vm.success = "Customer has been added";
            vm.successCallback({customer: result});
            $rootScope.loading = false;

          }, function errorCallback() {

            vm.error = "Customer has been created, but was unable to change the customerID for the user... ";
            $rootScope.loading = false;
          });

        }, function(reason){
          vm.error = "Something went wrong with creating a customer... "+reason.data.error.message;

          // Something went wrong!
          $rootScope.loading = false;
        });
      };

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('customerList', customerList);

  /** @ngInject */
  function customerList() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/customers/customerList/customerList.html',
      controller: customerListController,
      scope: {
        customers: "=",
        users: "=",
        farms: "="
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function customerListController($scope, $log, $window, $state) {
      var vm = $scope;
      vm.status = {};

      vm.loading = true;
      vm.customers.$promise.then(function () { vm.loading = false; })

      vm.update = function (odataObj){
        vm.status.saving = true;
        vm.status.saved = false;
        vm.status.failed = false;


        odataObj.$update().then(function successCallback(){

          vm.status.saving = false;
          vm.status.saved = true;

        },function errorCallback(){

          $log.error("Saving obj failed");
          vm.status.saving = false;
          vm.status.failed = true;

        });
      }


      vm.delete = function (odataObj) {
        var sure = $window.confirm("Are you sure you want to delete this?\nThis action cannot be undone!");
        if(sure){
          var really = $window.confirm("PLEASE DOUBLE CHECK!\nYou are deleting the following:\n"+angular.toJson(odataObj));
          if(really){
            odataObj.$delete().then(function () {
              $state.go($state.current, {}, {reload: true});
            }, function () {
              $window.alert('Something went wrong, please try again later');
            });
          }
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('newCowForm', newCowForm);

  /** @ngInject */
  function newCowForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/accountManagement/cows/newCowForm/newCowForm.html',
      controller: newCowFormController,
      scope: {
        successCallback: "&",
        herdGroupId:     "=",
        farmId:          "="
      },
      replace: true
    };

    return directive;

    /** @ngInject */
    function newCowFormController($rootScope, $scope, $log, $window, $state, sysAdminService, $q, $timeout) {
      var vm = $scope;

      vm.newCowObj             = {};
      vm.newCowObj.herdGroupId = vm.herdGroupId;
      vm.newCowObj.farmID      = vm.farmId;

      vm.farms      = sysAdminService.getFarms();
      vm.herdGroups = sysAdminService.getHerdGroups();

      vm.batchSize   = 1;


      vm.newCow = function(){
        $rootScope.loading = true;
        vm.success = "";
        vm.error   = "";

        vm.newCowObj.cowBirthDate = vm.cowBirthDate;

        var newCows = [];

        var startNumber = parseInt(vm.newCowObj.cowTagNumber);

        for(var i = 0; i<vm.batchSize; i++){

          vm.newCowObj.cowTagNumber = (startNumber+i)+'';
          newCows.push(sysAdminService.newCow(vm.newCowObj));

        }

        var requests = [];

        angular.forEach(newCows, function (value, index) {
          $timeout(function () {
            requests.push(value.$save());
          }, index*200);
        });

        $timeout(function () {
          $q.all(requests).then(function(results){

            vm.newCowObj = {};
            vm.newCowObj.herdGroupId = vm.herdGroupId;
            vm.newCowObj.farmID      = vm.farmId;

            vm.success = "Cows has been added";
            vm.successCallback({cows: results});

            $rootScope.loading = false;
          }, function(){
            vm.error = "Something went wrong with creating the cows...";

            // Something went wrong!
            $rootScope.loading = false;
          });
        }, newCows.length*200);

      };

    }
  }
})();

(function () {
  "use strict";

  angular.module("ctraDataVisualisations").service("dataApiService", dataApiService);

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services
  // TODO: replace rootScope variables with the variables coming from the service
  // TODO: save the detections in localStorage so we don't have to get all the detections every time we refresh a cow details page
  /* global d3:false */

  /** @ngInject */
  function dataApiService(
    $window,
    $rootScope,
    $log,
    $q,
    appConfig,
    $odata,
    $odataresource,
    $http,
    localStorageService,
    $translate,
    cowService,
    sessionService,
    lodash,
    labelService
  ) {
    var self = this;

    self.dataCache = {};
    self.maxCacheAge = 30 * 60 * 1000; // 30 minutes in milliseconds
    self.clearDataFromCache = clearDataFromCache;

    this.getData = function (api, source, scope, id, dateFrom, dateTill, interval, agWindow) {
      dateFrom.setHours(0, 0, 0, 0);
      dateTill.setHours(23, 59, 59, 99);
      var fromEpoch = Math.round(dateFrom.getTime() / 1000);
      var tillEpoch = Math.round(dateTill.getTime() / 1000);

      interval = interval || 1800;
      agWindow = agWindow || 86400;

      var deferred = $q.defer();

      var days = days_between(fromEpoch, tillEpoch);
      var requestsToApi = [];
      var pendingRequestsToApi = [];

      // loop throug every day, saving the data of that day
      for (var day = 0; day < days; day++) {
        var dayStart = fromEpoch + day * 24 * 60 * 60;
        var dayEnd = dayStart + 24 * 60 * 60 - 1;

        // Get the data from cache
        var fromCache = getDataFromCache(source, scope, id, dayStart, interval, agWindow);
        if (fromCache) {
          requestsToApi.push(fromCache);
        } else {
          if (
            pendingRequestsToApi.length &&
            pendingRequestsToApi[pendingRequestsToApi.length - 1].end + 1 === dayStart
          ) {
            // if there is already a pending request that looking for data of
            //  the day before this one, add this request to it by changing the "end" variable
            pendingRequestsToApi[pendingRequestsToApi.length - 1].end = dayEnd;
          } else {
            // Create a new pending request
            pendingRequestsToApi.push({ start: dayStart, end: dayEnd });
          }
        }
      }

      // Execute API calls
      angular.forEach(pendingRequestsToApi, function (value) {
        requestsToApi.push(
          getDataFromAPI(api, source, scope, id, value.start, value.end, interval, agWindow)
        );
      });

      // Wait for all the call to complete
      $q.all(requestsToApi).then(
        function (response) {
          var result = mergeAPIData(response, source);
          // Clone the result so the receiver can modify the variables without disturbing the rest
          deferred.resolve(angular.fromJson(angular.toJson(result)));
        },
        function (error) {
          // If something went wrong, clear the cache to make sure the incorrect API call is not cached
          clearDataFromCache(source);
          deferred.reject(error);
        }
      );

      return deferred.promise;
    };

    function getDataFromAPI(api, source, scope, id, fromEpoch, tillEpoch, interval, agWindow) {
      if (api === "dataAPI") {
        return getDataFromDataApi(source, scope, id, fromEpoch, tillEpoch, interval, agWindow);
      } else if (api === "oDataAPI") {
        return getDataFromOdataAPI(source, scope, id, fromEpoch, tillEpoch, interval, agWindow);
      } else if (api === "frontEndAPI") {
        return getDataFromFrontEndAPI(source, scope, id, fromEpoch, tillEpoch, interval, agWindow);
      }
      return false;
    }

    function mergeAPIData(data, source) {
      var result;

      // GenericInsights are an array of objects so we merge those in a different way
      if (source === "GenericInsights" || source === "GenericLabels") {
        result = {};
        result[source] = [];

        angular.forEach(data, function (value) {
          result[source] = result[source].concat(value[source]);
        });
      } else {
        result = [];
        angular.forEach(data, function (value) {
          result = result.concat(value);
        });
      }
      return result;
    }

    function cacheRequest(promise, source, scope, id, fromEpoch, tillEpoch, interval, agWindow) {
      // Create a place to store the data
      if (!self.dataCache[source]) {
        self.dataCache[source] = {};
      }
      if (!self.dataCache[source][scope]) {
        self.dataCache[source][scope] = {};
      }
      if (!self.dataCache[source][scope][interval]) {
        self.dataCache[source][scope][interval] = {};
      }
      if (!self.dataCache[source][scope][interval][agWindow]) {
        self.dataCache[source][scope][interval][agWindow] = {};
      }
      if (!self.dataCache[source][scope][interval][agWindow][id]) {
        self.dataCache[source][scope][interval][agWindow][id] = {};
      }

      // separate the data into days
      var days = days_between(fromEpoch, tillEpoch);

      // loop throug every day, saving the data of that day
      for (var day = 0; day < days; day++) {
        var deferred = $q.defer();
        var dayStart = fromEpoch + day * 24 * 60 * 60;
        var dayEnd = dayStart + 24 * 60 * 60 - 1;

        self.dataCache[source][scope][interval][agWindow][id][dayStart] = {};
        self.dataCache[source][scope][interval][agWindow][id][dayStart].cacheTimestamp = new Date().getTime();
        self.dataCache[source][scope][interval][agWindow][id][dayStart].promise = deferred.promise;

        (function (deferred, dayStart, dayEnd) {
          promise.then(function (data) {
            var result = getTimeRangeReport(data, source, dayStart, dayEnd);
            self.dataCache[source][scope][interval][agWindow][id][dayStart].data = result;

            deferred.resolve(result);
          });
        })(deferred, dayStart, dayEnd);
      }
    }

    function getDataFromCache(source, scope, id, fromEpoch, interval, agWindow) {
      if (
        !self.dataCache[source] ||
        !self.dataCache[source][scope] ||
        !self.dataCache[source][scope][interval] ||
        !self.dataCache[source][scope][interval][agWindow] ||
        !self.dataCache[source][scope][interval][agWindow][id]
      ) {
        return false;
      }

      // check if the request was for data in the past 24 hours
      // if so, check if the request maxCacheAge has surpassed
      if (
        self.dataCache[source][scope][interval][agWindow][id][fromEpoch] &&
        days_between(fromEpoch, new Date()) <= 2 &&
        new Date().getTime() -
          self.dataCache[source][scope][interval][agWindow][id][fromEpoch].cacheTimestamp >
          self.maxCacheAge
      ) {
        // Remove old data cache
        self.dataCache[source][scope][interval][agWindow][id][fromEpoch] = null;
        return false;
      }

      /* eslint-disable angular/no-private-call */
      if (
        self.dataCache[source][scope][interval][agWindow][id][fromEpoch] &&
        self.dataCache[source][scope][interval][agWindow][id][fromEpoch].promise.$$state
      ) {
        return self.dataCache[source][scope][interval][agWindow][id][fromEpoch].promise;
      }

      if (
        self.dataCache[source][scope][interval][agWindow][id][fromEpoch] &&
        self.dataCache[source][scope][interval][agWindow][id][fromEpoch].data &&
        !self.dataCache[source][scope][interval][agWindow][id][fromEpoch].promise.$$state
      ) {
        var deferred = $q.defer();

        deferred.resolve(self.dataCache[source][scope][interval][agWindow][id][fromEpoch].data);

        return (self.dataCache[source][scope][interval][agWindow][id][fromEpoch].promise = deferred.promise);
      }

      return false;
    }

    // TODO: Implement this function
    function clearDataFromCache(source) {
      if (source) {
        self.dataCache[source] = {};
      } else {
        self.dataCache = {};
      }
    }

    function getTimeRangeReport(data, source, fromEpoch, tillEpoch) {
      var timeRangeData;

      if (source === "dailyStatisticsFixed") {
        timeRangeData = {};
        timeRangeData.dailySummaries = data.dailySummaries.filter(function (value) {
          return value.Epoch >= fromEpoch && value.Epoch <= tillEpoch;
        });

        timeRangeData.meals = data.meals.filter(function (value) {
          return (
            (value.Start >= fromEpoch && value.Start <= tillEpoch) ||
            (value.End >= fromEpoch && value.End <= tillEpoch)
          );
        });
      } else if (
        source === "dynamicStats" ||
        source === "dynamicStatsUnscaled" ||
        source === "dynamicStatsWindowed" ||
        source === "weatherInfo" ||
        source === "milkYield"
      ) {
        timeRangeData = {};
        timeRangeData = data.filter(function (value) {
          return value.Epoch >= fromEpoch && value.Epoch <= tillEpoch;
        });
      } else if (source === "dailyStatistics") {
        timeRangeData = data;
      } else if (source === "GenericInsights") {
        timeRangeData = {};
        timeRangeData.GenericInsights = data.GenericInsights.filter(function (value) {
          return value.endEpoch >= fromEpoch && value.endEpoch <= tillEpoch;
        });
      } else if (source === "GenericLabels") {
        timeRangeData = {};
        timeRangeData.GenericLabels = data.GenericLabels.filter(function (value) {
          return value.endEpoch >= fromEpoch && value.endEpoch <= tillEpoch;
        });
      } else if (source === "eventsCSV") {
        timeRangeData = [];
        timeRangeData = data.filter(function (value) {
          return value.DetectionTime >= fromEpoch && value.DetectionTime <= tillEpoch;
        });
      } else if (source === "insightsCSV") {
        timeRangeData = [];
        timeRangeData = data.filter(function (value) {
          return value.insightStartEpoch >= fromEpoch && value.insightStartEpoch <= tillEpoch;
        });
      } else if (source === "insightOutcomesCSV") {
        timeRangeData = [];
        timeRangeData = data.filter(function (value) {
          return value.StartEpoch >= fromEpoch && value.StartEpoch <= tillEpoch;
        });
      } else if (source === "summaryCSV") {
        timeRangeData = [];
        timeRangeData = data.filter(function (value) {
          return value.Timestamp >= fromEpoch && value.Timestamp <= tillEpoch;
        });
      }

      return timeRangeData;
    }

    function getDataFromFrontEndAPI(source, scope, id, fromEpoch, tillEpoch, interval, agWindow) {
      var deferred = $q.defer();

      if (source === "CowsWithHealthInsights" && scope === "farm") {
        var cows, insights;

        // get cows of type (farm)
        cows = cowService.getCows();

        // get all insights of type (farm)
        var insightsQuery = self.getData(
          "dataAPI",
          "insightContainers",
          scope,
          id,
          new Date((fromEpoch - agWindow) * 1000),
          new Date(tillEpoch * 1000),
          interval,
          agWindow
        );
        insightsQuery.then(function (result) {
          insights = processInsightContainers(result).filter(function (value) {
            return value.isActive && value.insightType === "HealthInsight";
          });
        });

        $q.all([cows.$promise, insightsQuery]).then(
          function () {
            // TODO: remove this:
            agWindow = interval;

            var dataPoints = [],
              intervalEpoch = tillEpoch;
            //c             = 1;

            while (intervalEpoch >= fromEpoch) {
              var startWindow = intervalEpoch - agWindow;

              var intervalInsights = insights.filter(function (insight) {
                return (
                  insight.insightStartEpoch > startWindow && insight.insightStartEpoch <= intervalEpoch //||
                  //(insight.insightEndEpoch > startWindow && insight.insightEndEpoch <= intervalEpoch) ||
                  //(insight.insightStartEpoch <= startWindow && insight.insightEndEpoch >= intervalEpoch)
                );
              });

              var dataPoint = {
                Epoch: intervalEpoch - interval / 2,
                interval: interval,
                aggregationStart: intervalEpoch - interval,
                aggregationEnd: intervalEpoch,
                insights: intervalInsights,
                healthInsights: intervalInsights.length
              };

              dataPoints.push(dataPoint);

              intervalEpoch -= interval;
            }

            angular.forEach(dataPoints, function (value) {
              var insightCows = {};
              value.UniqueCowHealthInsights = value.insights.filter(function (insight) {
                if (insightCows[insight.cowID]) {
                  return false;
                }
                insightCows[insight.cowID] = true;
                return true;
              });

              value.TotalInsightDuration = 0;
              value.TotalInsightDurationDay = 0;

              angular.forEach(value.UniqueCowHealthInsights, function (insight) {
                var duration = insight.insightEndEpoch - insight.insightStartEpoch;
                value.TotalInsightDuration += duration;
              });

              angular.forEach(value.UniqueCowHealthInsights, function (insight) {
                var duration = insight.insightEndEpoch - insight.insightStartEpoch;
                value.TotalInsightDurationDay += duration > 86400 ? 86400 : duration;
              });

              value.AverageInsightDuration = value.UniqueCowHealthInsights.length
                ? value.TotalInsightDuration / value.UniqueCowHealthInsights.length
                : 0;
              value.AverageInsightDurationDay = value.UniqueCowHealthInsights.length
                ? value.TotalInsightDurationDay / value.UniqueCowHealthInsights.length
                : 0;

              value.CowsWithHealthInsights = value.UniqueCowHealthInsights.length;
              value.CowsWithHealthInsightsPercentage = value.CowsWithHealthInsights / cows.length;
              value.CowsWithHealthInsightsPercentageTotalDuration = [
                { id: "CowsWithHealthInsightsPercentage", value: value.CowsWithHealthInsightsPercentage },
                { id: "AverageInsightDurationDay", value: value.AverageInsightDurationDay / 86400 }
              ];
            });

            deferred.resolve(dataPoints);
          },
          function (error) {
            deferred.reject(error);
          }
        );

        // When resolved
        // [x] Loop through all the interval moments
        // [x] Find insights that started within this interval
        // [x] Calculate how many cows had health insights
        // [x] Calculate % of total cows had insights
        // [x] Return the data that is requested
      }

      return deferred.promise;
    }

    function getDataFromOdataAPI(source, scope, id, fromEpoch, tillEpoch, interval, agWindow) {
      var deferred = $q.defer();
      if (source === "GenericInsights") {
        getGenericInsightsBetween(scope, id, fromEpoch, tillEpoch).then(function (results) {
          deferred.resolve({ GenericInsights: results });
        });
      }
      if (source === "GenericLabels") {
        getGenericLabelsBetween(scope, id, fromEpoch, tillEpoch).then(function (results) {
          deferred.resolve({ GenericLabels: results });
        });
      }
      cacheRequest(deferred.promise, source, scope, id, fromEpoch, tillEpoch, interval, agWindow);
      return deferred.promise;
    }

    /**
     * Generic insight data resource.
     */
    var GenericInsight = $odataresource(
      appConfig.APIURL + "odata/GenericInsights",
      {},
      {},
      {
        odatakey: "InsightID"
      }
    );

    /**
     * Get generic insights between two dates.
     * @param scope
     * @param id
     * @param fromEpoch
     * @param tillEpoch
     */
    function getGenericInsightsBetween(scope, id, fromEpoch, tillEpoch) {
      var deferred = $q.defer();

      var isAdmin = sessionService.userRoles.indexOf("Admin") > -1;

      var query = GenericInsight.odata()
        .filter("endEpoch", ">", fromEpoch)
        .filter("endEpoch", "<", tillEpoch)
        .expand("dairyCow")
        .expand("insightValidations")
        .expand("insightType")
        .orderBy("endEpoch", "desc");

      /* eslint-disable angular/module-getter */

      if (scope === "farm") {
        query.filter("farmID", id);
        query.filter("insightType/insightScope", "farm");
      } else if (scope === "herd") {
        query.filter("farmID", id);
      } else if (scope === "herdGroup") {
        query.filter("herdGroupID", id);
        query.filter("insightType/insightScope", "herd");
      } else if (scope === "allCowsOfFarm") {
        query.filter("farmID", id);
        query.filter("insightType/insightScope", "cow");
      } else if (scope === "cow") {
        query.filter("dairyCowID", id);
      }

      if (sessionService.userRoles.indexOf("Admin") === -1) {
        var predicate1 = new $odata.Predicate("insightState", "!==", "disabled");
        var predicate2 = new $odata.Predicate("insightState", "!==", "hold");
        var combination = $odata.Predicate.and([predicate1, predicate2]);

        query.filter(combination);
      }

      $log.info("Fetching GenericInsights from the database");

      // Add an epoch variable to use for the visualisation
      query.query().$promise.then(
        function (results) {
          angular.forEach(results, function (e) {
            var title = $translate.instant(e.insightTitle);

            e.rawTitle = title;

            if (e.insightScope === "cow") {
              e.title = ["#", e.dairyCow.cowTagNumber, " ", title].join("");
            } else {
              e.title = title;
            }
            if (e.insightResolution) {
              e.footer = (angular.fromJson(e.insightResolution) || [])
                .map(function (elem) {
                  return $translate.instant(elem.title);
                })
                .join(", ");
            }

            e.disabled =
              e.insightState === "Disabled" || e.insightState === "Archived" || e.insightState === "Hold";
            e.category = e.insightType.insightCategory;
            e.dataType = "insight";

            if (sessionService.userRoles.indexOf("Admin") === -1) {
              e.insightValidations = e.insightValidations
                .filter(function (validation) {
                  return validation.validationByID !== "Admin";
                })
                .sort(function (a, b) {
                  return a.InsightValidationID < b.InsightValidationID;
                });
            }

            /**
             * Pick the user validations by rejecting anything from Dyson
             */
            var userValidations = lodash.reject(e.insightValidations, function (v) {
              return lodash.startsWith(v.validationByID, "Dyson-");
            });

            /**
             * Tell if there is a conflict in the validations (user & dyson validations together)
             * @type {boolean}
             */
            var conflict = !!userValidations.length && userValidations.length !== e.insightValidations.length;

            if (conflict) {
              e.insightValidations = userValidations;
            }

            angular.forEach(e.insightValidations, function (v) {
              if (v.validationEpoch < e.endEpoch) {
                v.epoch = v.validationEpoch;
              } else {
                v.epoch = e.endEpoch;
              }

              v.title = $translate.instant("INSIGHT_VALIDATION_" + v.validation);
              v.footer = isAdmin ? $translate.instant("INSIGHT_CHECKED_BY") + " " + v.validationByID : null;
            });
          });

          deferred.resolve(results);
        },
        function (error) {
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    var GenericLabel = $odataresource(
      appConfig.APIURL + "odata/GenericLabels",
      {},
      {},
      { odatakey: "InsightID" }
    );
    function getGenericLabelsBetween(scope, id, fromEpoch, tillEpoch) {
      var deferred = $q.defer();

      var isAdmin = sessionService.userRoles.indexOf("Admin") > -1;

      var query = GenericLabel.odata()
        .filter("endEpoch", ">", fromEpoch)
        .filter("endEpoch", "<", tillEpoch)
        .orderBy("endEpoch", "desc");

      // filter customer invisible labels if !admin
      if (!isAdmin) {
        query = query.filter("customerVisible", true);
      }

      /* eslint-disable angular/module-getter */
      if (scope === "farm") {
        query.filter("farmID", id);
        query.filter("dairyCowID", null);
      } else if (scope === "herdGroup") {
        query.filter("herdGroupID", id);
        query.filter("dairyCowID", null);
      } else if (scope === "allCowsOfFarm") {
        query.filter("farmID", id);
        query.expand("dairyCow");
      } else if (scope === "herdGroup") {
        query.filter("herdGroupID", id);
        query.filter("dairyCowID", null);
      } else if (scope === "cow") {
        query.filter("dairyCowID", id);
        query.expand("dairyCow");
      }

      $log.info("Fetching GenericLabels from the database");

      // Add an epoch variable to use for the visualisation
      query.query().$promise.then(
        function (results) {
          angular.forEach(results, function (e) {
            var title = labelService.translateLabelTitle(e);

            e.rawTitle = title;

            if (e.labelScope === "cow") {
              e.title = ["#", e.dairyCow.cowTagNumber, " ", title].join("");
            } else {
              e.title = title;
            }

            if (isAdmin && e.tags) {
              var tags = e.tags;
              tags = angular.fromJson(e.tags).join(", ");
              e.footer = tags + (e.description ? "<br>" + $translate.instant(e.description) : "");
            } else {
              e.footer = $translate.instant(e.description);
            }

            if (e.description && e.description[0] === "{") {
              e.markers = angular.fromJson(e.description).markers || [];
            }

            e.dataType = "label";
            e.disabled = !e.customerVisible;
          });
          deferred.resolve(results);
        },
        function (error) {
          deferred.reject(error);
        }
      );

      // Add an epoch variable to use for the visualisation
      // query.query().$promise.then(function (results) {
      //   angular.forEach(results, function (e) {
      //     var title = $translate.instant(e.insightTitle);
      //
      //     e.rawTitle = title;
      //
      //     if (e.insightScope === "cow") {
      //       e.title = ["#", e.dairyCow.cowTagNumber, " ", title].join("");
      //     } else {
      //       e.title = title;
      //     }
      //
      //     //e.title = e.insightTitle;
      //     e.disabled = (e.insightState === "Disabled" || e.insightState === "Archived");
      //     e.category = e.insightType.insightCategory;
      //     e.dataType = "insight";
      //
      //     angular.forEach(e.insightValidations, function (v) {
      //       v.epoch = (v.validationEpoch < e.endEpoch ? v.validationEpoch : e.endEpoch);
      //       v.title = $translate.instant("INSIGHT_VALIDATION_" + v.validation);
      //       v.footer = sessionService.userRoles.indexOf("Admin") > -1 ?
      //         $translate.instant("INSIGHT_CHECKED_BY") + " " + v.validationByID : null;
      //     });
      //   });
      //
      //   deferred.resolve(results);
      // }, function (error) {
      //   deferred.reject(error);
      // });

      return deferred.promise;
    }

    function getDataFromDataApi(source, scope, id, fromEpoch, tillEpoch, interval, agWindow) {
      var deferred = $q.defer();

      $log.info("Fetching Data from API, source: " + source + ", scope: " + scope + ", id: " + id);

      var idPadded = id !== "all" ? pad(id, 8) : id;
      var url =
        appConfig.DATAAPIURL + source + "/" + scope + "/" + idPadded + "/" + fromEpoch + "/" + tillEpoch;

      if (
        source === "dynamicStatsUnscaled" ||
        source === "dynamicStatsWindowed" ||
        source === "weatherInfo" ||
        source === "milkYield"
      ) {
        //interval = 86400/4; //hour: 3600, day: 86400, week: 604800, month: 2629744,
        //agWindow = 86400/4; //hour: 3600, day: 86400, week: 604800, month: 2629744,
        url =
          appConfig.DATAAPIURL +
          source +
          "/" +
          scope +
          "/" +
          idPadded +
          "/" +
          interval +
          "/" +
          agWindow +
          "/" +
          fromEpoch +
          "/" +
          tillEpoch;
      }

      $http({
        method: "GET",
        url: url
      }).then(
        function successCallback(response) {
          var result = response.data;

          if (source.indexOf("CSV") > -1) {
            result = d3.csvParse(result);
          }

          deferred.resolve(result);
        },
        function errorCallback(error) {
          deferred.reject(error);
        }
      );

      cacheRequest(deferred.promise, source, scope, id, fromEpoch, tillEpoch, interval, agWindow);

      return deferred.promise;
    }

    this.stripPredictions = function (data, style) {
      var nowEpoch = new Date().getTime() / 1000;

      if (
        style === "line" ||
        style === "bar" ||
        style === "stackedBar" ||
        style === "area" ||
        style === "stackedArea" ||
        style === "bubblePlot"
      ) {
        angular.forEach(data, function (type, key) {
          var cleanedArray = [];
          angular.forEach(type, function (value) {
            if (value.Epoch <= nowEpoch) {
              cleanedArray.push(value);
            }
          });
          data[key] = cleanedArray;
        });
      } else if (style === "insight") {
        angular.forEach(data, function (type, key) {
          var cleanedArray = [];
          angular.forEach(type, function (value) {
            if (value.startEpoch <= nowEpoch) {
              cleanedArray.push(value);
            }
          });
          data[key] = cleanedArray;
        });
      }

      return data;
    };

    /**
     * Call data processor
     * @param data
     * @param source
     * @param style
     * @param interval
     * @param filters
     * @return {*}
     */
    this.processDataForDataExplorer = function (data, source, style, interval, filters) {
      /**
       * @type {boolean}
       */
      var styleMatches =
        ["line", "bar", "stackedBar", "area", "stackedArea", "bubblePlot"].indexOf(style) > -1;

      /**
       * @type {boolean}
       */
      var sourceMatches =
        [
          "dynamicStatsUnscaled",
          "dynamicStatsWindowed",
          "milkYield",
          "weatherInfo",
          "CowsWithHealthInsights"
        ].indexOf(source) > -1;

      if (styleMatches && sourceMatches) {
        return processDynamicStatsDataForDataExplorerLine(data, interval);
      }

      /**
       * @type {{insightContainers_insight: (function(*=)), insightsCSV_line: (function(*=)),
       * insightOutcomesCSV_line: (function(*=)),
       * eventsCSV_timeline: (function(*=): {stream1: *[], stream2: *[], stream3: *[]}),
       * eventsCSV_scatterPlot: (function(*=): {EventLatency: Array})}}
       */
      var processorMap = {
        insightContainers_insight: processInsightContainersForDataExplorerInsight,
        insightsCSV_line: processInsightsProbabilityDataForDataExplorerLine,
        insightOutcomesCSV_line: processInsightsProbabilityKafkaDataForDataExplorerLine,
        eventsCSV_timeline: processEventsDataForDataExplorerTimeline,
        eventsCSV_scatterPlot: processEventsDataForDataExplorerScatterPlot,
        GenericInsights_insight: processGenericInsightDataForDataExplorer
      };

      /**
       * @type {string}
       */
      var key = [source, style].join("_");

      /**
       * @type {function}
       */
      var processor = processorMap[key];

      return processor ? processor(data, filters) : data;
    };

    function processDynamicStatsDataForDataExplorerLine(data, interval) {
      var reportData = {};

      var ignoredKeys = ["Epoch", "ActivityCount", "Meals", "ID"];

      data.sort(function (a, b) {
        if (a.Epoch > b.Epoch) return 1;
        return -1;
      });

      angular.forEach(data, function (day) {
        angular.forEach(day, function (value, key) {
          if (ignoredKeys.indexOf(key) > -1) return false;

          var dataPoint = {};
          dataPoint.date = new Date(day.Epoch * 1000);
          dataPoint.value = Number(value) || 0; // Fallback in case the value is "NaN"
          dataPoint.interval = +day.interval || interval;
          dataPoint.aggregationStart = +day.aggregationStart || +day.Epoch - interval;
          dataPoint.aggregationEnd = +day.aggregationEnd || +day.Epoch;
          dataPoint.id = key;

          dataPoint.Epoch = +day.Epoch;

          if (!reportData[key]) reportData[key] = [];
          reportData[key].push(dataPoint);

          // if(dataPoint.Epoch <= nowEpoch){
          //   reportData[key].push(dataPoint);
          // }else if(!lastDayAdded){
          //   dataPoint.Epoch = nowEpoch;
          //   reportData[key].push(dataPoint);
          //   isLastDay = true;
          // }
        });
        //lastDayAdded = isLastDay;
      });

      return reportData;
    }

    /**
     * Process insight containers
     * @param data
     */
    function processInsightContainersForDataExplorerInsight(data) {
      /**
       * @type {Array}
       */
      var processedData = processInsightContainers(data);

      /**
       * @type {{}}
       */
      var reportData = {};

      angular.forEach(processedData, function (value) {
        /**
         * @type {string}
         */
        var insightType = value.insightType;

        if (!reportData[insightType]) {
          reportData[insightType] = [];
        }

        reportData[insightType].push(value);
      });

      return reportData;
    }

    /**
     * @param data
     * @param filters
     * @return {*}
     */
    function processGenericInsightDataForDataExplorer(data, filters) {
      /**
       * @type {[]}
       */
      var insights = data.GenericInsights;

      /**
       * @type {boolean}
       */
      var hasFilters = !lodash.isEmpty(filters);

      /**
       * @type {[]}
       */
      var filtered = hasFilters ? lodash.filter(insights, filters) : insights;

      if (hasFilters) {
        $log.info(insights, "is reduced to", filtered, "using filters", filters);
      }

      return lodash.assign({}, data, {
        GenericInsights: filtered
      });
    }

    function processInsightsProbabilityDataForDataExplorerLine(data) {
      var reportData = {};

      var nowEpoch = new Date().getTime() / 1000;

      angular.forEach(data, function (insight) {
        var dataPoint = {};
        dataPoint.Epoch = parseInt(insight.insightStartEpoch);
        dataPoint.date = new Date(dataPoint.Epoch * 1000);
        dataPoint.value = +insight.insightProbability;

        var key = insight.insightModel;

        if (!reportData[key]) reportData[key] = [];

        if (dataPoint.Epoch <= nowEpoch) {
          reportData[key].push(dataPoint);
        }
      });

      angular.forEach(reportData, function (insightReport) {
        insightReport.sort(function (a, b) {
          if (a.Epoch > b.Epoch) {
            return 1;
          }
          if (a.Epoch === b.Epoch && a.value < b.value) {
            return 1;
          }
          return -1;
        });
      });

      return reportData;
    }

    function processInsightsProbabilityKafkaDataForDataExplorerLine(data) {
      var reportData = {};

      var nowEpoch = new Date().getTime() / 1000;

      angular.forEach(data, function (insight) {
        var dataPoint = {};
        dataPoint.Epoch = parseInt(insight.StartEpoch);
        dataPoint.date = new Date(dataPoint.Epoch * 1000);
        dataPoint.value = +insight.Probability;

        var key = insight.ModelName;

        if (!reportData[key]) reportData[key] = [];

        if (dataPoint.Epoch <= nowEpoch) {
          reportData[key].push(dataPoint);
        }
      });

      angular.forEach(reportData, function (insightReport) {
        insightReport.sort(function (a, b) {
          if (a.Epoch > b.Epoch) {
            return 1;
          }
          if (a.Epoch === b.Epoch && a.value < b.value) {
            return 1;
          }
          return -1;
        });
      });

      return reportData;
    }

    this.processInsightContainers = processInsightContainers;
    function processInsightContainers(data) {
      var result = [];

      angular.forEach(data, function (value) {
        if (sessionService.userRoles.indexOf("Admin") === -1 && !value.insight.isActive) return false;

        var insight = value.insight;
        insight.insightActions = value.actions;
        insight.insightValidations = value.validations;
        insight.logs = value.logs;

        // If not Admin, hide the admin validations
        if (sessionService.userRoles.indexOf("Admin") === -1) {
          insight.insightValidations = insight.insightValidations
            .filter(function (validation) {
              return validation.source !== "Admin";
            })
            .sort(function (a, b) {
              return a.InsightValidationID < b.InsightValidationID;
            });
        }

        insight.insightStatus = insight.autoGenerated ? "new" : "read";
        insight.insightValidated = false;

        angular.forEach(insight.insightValidations, function (validation) {
          validation.timestamp = parseInt(validation.epoch);
          validation.epoch =
            validation.epoch > insight.insightEndEpoch ? insight.insightEndEpoch : validation.epoch;
          validation.title = validation.confirmed
            ? $translate.instant("INSIGHT_VALIDATION_" + validation.confirmed)
            : "";
          validation.footer =
            sessionService.userRoles.indexOf("Admin") > -1
              ? $translate.instant("INSIGHT_CHECKED_BY") + " " + validation.source
              : null;

          insight.insightValidated = validation.confirmed;
          insight.insightStatus = validation.confirmed === "invalid" ? "archived" : "read";
        });

        var cow = insight.dairyCowID ? insight.dairyCow : null;
        var title = insight.autoGenerated ? $translate.instant(insight.insightTitle) : insight.insightTitle;

        insight.rawTitle = title;

        if (cow) {
          insight.title = "#" + cow.cowTagNumber + " " + title;
        } else {
          insight.title = title;
        }
        insight.footer = sessionService.userRoles.indexOf("Admin") > -1 ? insight.GenericInsightID : null;

        result.push(insight);
      });
      return result;
    }

    this.getInsightCollections = getInsightCollections;
    function getInsightCollections(insights) {
      var insightCollections = [];

      angular.forEach(insights, function (insight) {
        var date = new Date(insight.insightStartEpoch * 1000);
        date.setHours(0, 0, 0, 0);
        var dayStart = date.getTime() / 1000;

        var insightCollection = insightCollections.find(function (collection) {
          return collection.epoch === dayStart && collection.insightType === insight.insightType;
        });

        if (!insightCollection) {
          insightCollection = {
            title: "INSIGHT_COLLECTION_TITLE_" + insight.insightType,
            epoch: dayStart,
            startEpoch: insight.insightStartEpoch,
            endEpoch: insight.insightEndEpoch,
            insightType: insight.insightType,
            insights: [],
            insightStatus: null
          };
          insightCollections.push(insightCollection);
        }

        if (insightCollection.startEpoch < insight.insightStartEpoch)
          insightCollection.startEpoch = insight.insightStartEpoch;
        if (insightCollection.endEpoch > insight.insightEndEpoch)
          insightCollection.endEpoch = insight.insightEndEpoch;
        if (insight.insightStatus === "new") insightCollection.insightStatus = insight.insightStatus;

        insightCollection.insights.push(insight);
      });

      insightCollections.sort(function (a, b) {
        if (a.endEpoch > b.endEpoch) return -1;
        return 1;
      });

      return insightCollections;
    }

    function processEventsDataForDataExplorerTimeline(data) {
      data = cleanEventsData(data);
      data = stitchEvents(data);

      var reportData = {
        stream1: data.filter(function (e) {
          return e.StreamID === 1;
        }),
        stream2: data.filter(function (e) {
          return e.StreamID === 2;
        }),
        stream3: data.filter(function (e) {
          return e.StreamID === 3;
        })
      };

      return reportData;
    }

    function processEventsDataForDataExplorerScatterPlot(data) {
      // Pre-process event data
      data = cleanEventsData(data);
      data = stitchEvents(data);

      var result = [];

      // Split data into a scatter plot of 2 types,
      // 1 detection time and latency
      // 2 cloud receive time and latency

      angular.forEach(data, function (dataPoint) {
        var date1 = new Date(dataPoint.DetectionTime * 1000);
        var date2 = new Date(dataPoint.CloudRecieveTime * 1000);

        var string =
          "<strong>Detection time:</strong> <small class='gray'>" +
          pad(date1.getHours(), 2) +
          ":" +
          pad(date1.getMinutes(), 2) +
          ":" +
          pad(date1.getSeconds(), 2) +
          "</small><br>";
        string +=
          "<strong>Cloud Received:</strong> <small class='gray'>" +
          pad(date2.getHours(), 2) +
          ":" +
          pad(date2.getMinutes(), 2) +
          ":" +
          pad(date2.getSeconds(), 2) +
          "</small><br>";
        string +=
          "<strong>Latency:</strong> <small class='gray'>" +
          formatMinutes(dataPoint.CloudRecieveTime - dataPoint.startEpoch) +
          "</small>";

        dataPoint.description = string;

        var detectionTime = angular.copy(dataPoint);
        detectionTime.id = "detectionTime";
        detectionTime.key = dataPoint.CowID + dataPoint.DetectionTime + dataPoint.event + "DetectionTime";
        detectionTime.Epoch = dataPoint.startEpoch;
        detectionTime.value = dataPoint.CloudRecieveTime - dataPoint.startEpoch;
        detectionTime.title = "Detection Time";
        result.push(detectionTime);

        var cloudRecieveTime = angular.copy(dataPoint);
        cloudRecieveTime.id = "cloudRecieveTime";
        cloudRecieveTime.key =
          dataPoint.CowID + dataPoint.DetectionTime + dataPoint.event + "CloudRecieveTime";
        cloudRecieveTime.Epoch = dataPoint.CloudRecieveTime;
        cloudRecieveTime.value = dataPoint.CloudRecieveTime - dataPoint.startEpoch;
        cloudRecieveTime.title = "Cloud Recieved Time";
        result.push(cloudRecieveTime);
      });

      var reportData = { EventLatency: result };

      return reportData;
    }

    function cleanEventsData(events) {
      var results = [];

      angular.forEach(events, function (event) {
        angular.forEach(event, function (value, key) {
          event[key] = Number(value) || value; // convert into number
        });

        event.id = event.CowID + event.DetectionTime + event.Event;
        event.event = event.Event;
        event.title = event.Event;
        event.startEpoch = +event.DetectionTime;
        event.endEpoch = event.startEpoch + +event.Duration;
        event.duration = +event.Duration;

        results.push(event);
      });

      // remove events with negative or 0 duration
      results = results.filter(function (d) {
        return d.duration > 0;
      });

      return results;
    }

    function stitchEvents(events) {
      var result = [];

      angular.forEach(events, function (value, key) {
        if (value.Duration <= 0) {
          return false;
        }

        if (events[key - 1] && events[key - 1].event === value.event) {
          // Check what the timegap is
          var timeGap = value.startEpoch - events[key - 1].endEpoch;

          // If it's tiny, lets merge this event with the previous event, and NOT add this to the new array
          if (timeGap < 0.1) {
            result[result.length - 1].endEpoch += timeGap + value.duration;
          } else {
            result.push(value);
          }
        } else {
          result.push(value);
        }
      });

      $log.log(
        "Data reduction by merging events: " +
          parseInt(100 - (result.length / events.length) * 100) +
          "%, from " +
          events.length +
          " events to " +
          result.length +
          " events"
      );

      return result;
    }

    this.groupInsightsByDay = function (data, startDate, endDate) {
      startDate.setHours(0, 0, 0, 0);
      var fromEpoch = Math.round(startDate.getTime() / 1000);

      var days = days_between(startDate, endDate);
      var results = [];

      // loop throug every day, adding insights of that day
      for (var day = 0; day < days; day++) {
        var dayStart = fromEpoch + day * 24 * 60 * 60;
        var dayEnd = dayStart + 24 * 60 * 60;

        var thisDay = {
          epoch: dayStart,
          dayStart: dayStart,
          dayEnd: dayEnd,
          insights: []
        };

        thisDay.insights = data.filter(function (value) {
          return value.insightStartEpoch >= dayStart && value.insightStartEpoch < dayEnd;
        });

        thisDay.insights.sort(function (a, b) {
          if (a.insightStartEpoch > b.insightStartEpoch) return -1;
          return 1;
        });

        if (thisDay.insights.length) {
          results.push(thisDay);
        }
      }

      results.sort(function (a, b) {
        if (a.epoch > b.epoch) return -1;
        return 1;
      });

      return results;
    };

    // Helper functions
    function formatMinutes(d) {
      var hours = Math.floor(d / 3600),
        minutes = Math.floor((d - hours * 3600) / 60),
        seconds = Math.floor(d - minutes * 60 - hours * 3600);

      var output = seconds ? seconds + "s" : seconds;
      if (minutes) {
        //output = minutes + 'm' + (seconds ? ' ' + seconds + 's' : '');
        output = minutes + "m";
      }
      if (hours) {
        output = hours + "h" + (minutes ? " " + minutes + "m" : "");
      }
      return output;
    }

    function pad(num, size) {
      var s = "000000000" + num;
      return s.substr(s.length - size);
    }

    function days_between(date1, date2) {
      // The number of milliseconds in one day
      var ONE_DAY = 1000 * 60 * 60 * 24;

      /* eslint-disable angular/typecheck-object */
      // Convert both dates to milliseconds
      var date1_ms = angular.isObject(date1) ? date1.getTime() : date1 * 1000;
      var date2_ms = angular.isObject(date2) ? date2.getTime() : date2 * 1000;

      // Calculate the difference in milliseconds
      var difference_ms = Math.abs(date1_ms - date2_ms);

      // Convert back to days and return
      return Math.round(difference_ms / ONE_DAY);
    }
  }
})();

(function () {
  "use strict";

  angular.module("ctraDataVisualisations.dataVisualisation.graph", []);
})();

/* global d3 */
(function () {
  "use strict";

  angular.module("ctraDataVisualisations.dataVisualisation.graph").component("graph", {
    bindings: {
      displayData: "<",
      rangePicker: "<",
      graphLegend: "<",
      domain: "<",
      highlightedData: "<",
      hiddenData: "<",
      contextMenu: "<",
      onInsightClicked: "&",
      onRangePickerChanged: "&",
      onDomainChange: "&"
    },
    controller: graphController,
    template: ""
  });

  /**
   * @ngIngject
   * @param $element
   * @param $window
   * @param $translate
   * @param insightService
   * @param localeService
   * @param lodash
   * @param GraphLocalizationService
   * @param INSIGHT_CATEGORIES
   */
  function graphController(
    $element,
    $window,
    $translate,
    insightService,
    localeService,
    lodash,
    GraphLocalizationService,
    INSIGHT_CATEGORIES
  ) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.$onChanges = onChanges;
    $ctrl.$onDestroy = onDestroy;

    var id = Date.now();
    var isMobile;
    var svg;
    var svgG;
    var dataG;
    var areasG;
    var stackedAreasG;
    var linesG;
    var stackedBarsG;
    var barsG;
    var scatterPlotsG;
    var bubblePlotsG;
    var rangePickerG;
    var insightG;
    var timelineG;
    var legendG;
    var color;
    var tooltip;
    var rangeG;
    var clipPath;
    var areaFun;
    var stackedAreaFun;
    var stackedAreaLineFun;
    var lineFun;
    var stackFun;
    var xScale, xScaleT;
    var yScales = {};
    var yScalesConf = { width: 30 };
    var xScaleStackedBar;
    var xScaleBar;
    var zoom;
    var insightsRows = [];
    var InsightIDRowMap = {};

    var areaData = [];
    var stackedAreaData = [];
    var linesData = [];
    var stackedBarData = [];
    var barsData = [];
    var scatterPlotsData = [];
    var bubblePlotsData = [];
    var rangePickerData = [];
    var insightsData = [];
    var timelinesData = [];
    var legend = {};
    var legendData = [];

    var conf = { topMargin: 15, rightMargin: 10, bottomMargin: 50, leftMargin: 0 };
    var width;

    var mainChartHeight;

    var rangePickerConf = { height: 20, borderRadius: 2, topMargin: 6, bottomMargin: 2 };
    var rangePickerHeight;

    var insightsConf = { rect: 20, padding: 1, topMargin: 6, bottomMargin: 2, rowSpacing: 3 };
    var insightsHeight;

    var timelinesConf = { height: 50, borderRadius: 2, topMargin: 6, bottomMargin: 2, rowSpacing: 3 };
    var timelinesHeight;

    var legendConf = { topMargin: 35, height: 25 };
    var legendHeight;

    /**
     * Init component
     */
    function onInit() {
      /**
       * @type {Array}
       */
      $ctrl.highlightedData = $ctrl.highlightedData || [];

      /**
       * @type {Array}
       */
      $ctrl.hiddenData = $ctrl.hiddenData || [];

      /**
       * @type {boolean}
       */
      isMobile = $window.innerWidth <= 768;

      initGraph();

      angular.element($window).on("resize", renderGraph);
    }

    /**
     * Listen to graph changes
     * @param change
     */
    function onChanges(change) {
      var newScaleValue, newTranslateXValue;

      if (svgG) {
        if (change.hasOwnProperty("domain")) {
          /**
           * @type {number}
           */
          newScaleValue = width / (xScale($ctrl.domain[1]) - xScale($ctrl.domain[0]));

          /**
           * @type {number}
           */
          newTranslateXValue = -xScale($ctrl.domain[0]);

          svg
            .transition()
            .duration(500)
            .call(zoom.transform, d3.zoomIdentity.scale(newScaleValue).translate(newTranslateXValue, 0));
        }

        if (change.hasOwnProperty("displayData")) {
          updateData();
          setYScales();
          setYScaleDomains();
          drawAxisYScales();
        }

        renderGraph();
      }
    }

    /**
     * Handle graph destroy
     */
    function onDestroy() {
      angular.element($window).off("resize", renderGraph);
      tooltip.remove();
    }

    /**
     * Init graph
     */
    function initGraph() {
      updateDimensions($element[0].clientWidth);

      xScale = d3.scaleTime();
      xScale.domain($ctrl.domain);
      xScale.range([0, width]);

      xScaleT = d3.scaleTime();
      xScaleT.range(xScale.range());
      xScaleT.domain(xScale.domain());

      xScaleStackedBar = d3.scaleLinear();
      xScaleBar = d3.scaleLinear();

      color = d3.scaleOrdinal(d3.schemeCategory10);

      /**
       * Line generator
       * @type {*}
       */
      lineFun = createLineFun();

      /**
       * Area generator
       * @type {*}
       */
      areaFun = createAreaFun();

      /**
       * Stacked area generator
       * @type {*}
       */
      stackedAreaFun = createStackedAreaFun();

      /**
       * Stagked line generator
       * @type {*}
       */
      stackedAreaLineFun = createStackedAreaLineFun();

      /**
       * Stack generator
       * @type {*}
       */
      stackFun = createStackFun();

      svg = d3.select($element[0]).append("svg");

      createTooltip();
      createDefs();
      createSVGWrappers();
      enableZoom();
      drawAxisX();
      renderGraph();
      initContextMenu();
    }

    /**
     * Create a function to generate a "stack"
     * @note What is a stack?
     * @return {*}
     */
    function createStackFun() {
      return d3.stack().order(d3.stackOrderNone).offset(d3.stackOffsetNone);
    }

    /**
     * Create a function which generates stacked line graph
     * @return {*}
     */
    function createStackedAreaLineFun() {
      return d3
        .area()
        .curve(d3.curveMonotoneX)
        .x(function (d) {
          return xScaleT(d.data.Epoch * 1000);
        })
        .y(function (d) {
          return yScales[d.data.dataType].scale(d[1]);
        });
    }

    /**
     * Create a function to generate stacked areas
     * @return {*}
     */
    function createStackedAreaFun() {
      return d3
        .area()
        .curve(d3.curveMonotoneX)
        .x(function (d) {
          return xScaleT(d.data.Epoch * 1000);
        })
        .y0(function (d) {
          return yScales[d.data.dataType].scale(d[0]);
        })
        .y1(function (d) {
          return yScales[d.data.dataType].scale(d[1]);
        });
    }

    /**
     * Create a function to generate a line graph
     * @return {*}
     */
    function createLineFun() {
      return d3
        .line()
        .curve(d3.curveMonotoneX)
        .x(function (d) {
          return xScaleT(d.Epoch * 1000);
        })
        .y(function (d) {
          return yScales[d.dataType].scale(d.value);
        });
    }

    /**
     * Create a function to generate area graph
     * @return {*}
     */
    function createAreaFun() {
      return d3
        .area()
        .curve(d3.curveMonotoneX)
        .x(function (d) {
          return xScaleT(d.Epoch * 1000);
        })
        .y0(function (d) {
          return yScales[d.dataType].scale.range()[0];
        })
        .y1(function (d) {
          return yScales[d.dataType].scale(d.value);
        });
    }

    /**
     * Enable zooming
     */
    function enableZoom() {
      zoom = d3
        .zoom()
        .touchable(function touchable() {
          return false;
        })
        .on("zoom", zooming)
        .on("end", zoomend);

      svg.call(zoom).on("wheel.zoom", null).on("dblclick.zoom", null);
      //   .on('touchstart.zoom', null)
      //   .on('touchmove.zoom', null)
      //   .on('touchend.zoom', null);
    }

    /**
     * Create clip path
     */
    function createDefs() {
      var defs = svg.append("defs");

      clipPath = defs
        .append("clipPath")
        .attr("id", "clip" + id)
        .append("rect");
    }

    /**
     * Create tooltip
     */
    function createTooltip() {
      tooltip = d3.select("body").append("div").attr("class", "tooltip top").style("opacity", 0);
    }

    /**
     * Create SVG wrappers
     */
    function createSVGWrappers() {
      svgG = svg.append("g");
      dataG = svgG.append("g").attr("clip-path", "url(#clip" + id + ")");
      stackedBarsG = dataG.append("g").attr("class", "stackedBars");
      barsG = dataG.append("g").attr("class", "bars");
      areasG = dataG.append("g").attr("class", "areas");
      stackedAreasG = dataG.append("g").attr("class", "stacked-areas");
      linesG = dataG.append("g").attr("class", "lines");
      scatterPlotsG = dataG.append("g").attr("class", "scatterPlots");
      bubblePlotsG = dataG.append("g").attr("class", "bubblePlots");
      rangePickerG = dataG.append("g").attr("class", "rangePicker");
      insightG = dataG.append("g").attr("class", "insights");
      timelineG = dataG.append("g").attr("class", "timelines");
      legendG = svg.append("g");
      rangeG = dataG.append("g").attr("class", "range").style("opacity", 0);
      rangeG.append("rect").attr("class", "range-start");
      rangeG.append("rect").attr("class", "range-end");
    }

    /**
     * Render graph
     * @return {boolean}
     */
    function renderGraph() {
      if ($element[0].clientWidth) {
        updateDimensions($element[0].clientWidth);
        setMainChartHeight();
        setRangePickerHeight(rangePickerData);
        setInsightsHeight(insightsData);
        setTimelinesHeight(timelinesData);
        setLegendHeight();
        setRangeHeight();
        setYScaleRanges();
        updateAxisYScales();

        /**
         * @type {number}
         */
        var baseHeight = mainChartHeight + rangePickerHeight + insightsHeight + timelinesHeight;

        /**
         * @type {number}
         */
        var chartHeight = baseHeight + legendHeight || 50;

        /**
         * @type {number}
         */
        var svgHeight = conf.topMargin + chartHeight + conf.bottomMargin;

        svg.attr("width", width + conf.leftMargin + conf.rightMargin).attr("height", svgHeight);

        // Update svg wrappers
        clipPath.attr("width", width).attr("height", baseHeight);
        svgG.attr("transform", "translate(" + conf.leftMargin + "," + conf.topMargin + ")");
        rangePickerG.attr("transform", "translate(0," + (mainChartHeight + insightsConf.topMargin) + ")");
        insightG.attr(
          "transform",
          "translate(0," + (mainChartHeight + rangePickerHeight + insightsConf.topMargin) + ")"
        );
        timelineG.attr(
          "transform",
          "translate(0," +
            (mainChartHeight + rangePickerHeight + insightsHeight + timelinesConf.topMargin) +
            ")"
        );
        legendG.attr(
          "transform",
          "translate(" + conf.leftMargin + "," + (conf.topMargin + legendConf.topMargin + baseHeight) + ")"
        );

        drawAreas(areaData);
        drawStackedAreas(stackedAreaData);
        drawLines(linesData);
        drawStackedBars(stackedBarData);
        drawBars(barsData);
        drawScatterPlots(scatterPlotsData);
        drawBubblePlots(bubblePlotsData);
        drawRangePicker(rangePickerData);
        drawInsights(insightsData);
        drawTimelines(timelinesData);
        updateAxisX();
        drawLegend();
      }
    }

    /**
     * Init context menu
     */
    function initContextMenu() {
      if ($ctrl.contextMenu && $ctrl.contextMenu.menu) {
        $ctrl.contextMenu.onOpen = function () {
          $ctrl.contextMenu.epoch = parseInt(xScaleT.invert(d3.mouse(this)[0]).getTime() / 1000);
        };

        svgG.on(
          "contextmenu",
          d3.contextMenu($ctrl.contextMenu.menu, {
            onOpen: $ctrl.contextMenu.onOpen
          })
        );

        // Close the contextMenu on clicking or dragging the chart

        svg.on("click", function () {
          d3.contextMenu("close");
        });

        zoom.on("start", function () {
          d3.contextMenu("close");
        });
      }
    }

    /**
     * Scale graph
     */
    function scaleGraph() {
      scaleAreas();
      scaleStackedAreas();
      scaleLines();
      scaleStackedBars();
      scaleBars();
      scaleScatterPlots();
      scaleBubblePlots();
      scaleRangePickers();
      scaleInsights();
      scaleTimeline();
      updateAxisX();
    }

    /**
     * Handle onZoom
     */
    function zooming() {
      xScaleT = d3.event.transform.rescaleX(xScale);
      scaleGraph();
    }

    /**
     * Handle zoomEnd
     */
    function zoomend() {
      //console.log("zoomend", d3.event, d3.event.sourceEvent);

      if (d3.event.sourceEvent) {
        $ctrl.onDomainChange({ domain: xScaleT.domain() });
      }
    }

    /**
     * Update data
     */
    function updateData() {
      linesData = getData("line");
      areaData = getData("area");
      stackedAreaData = getData("stackedArea");
      barsData = getData("bar");
      stackedBarData = getData("stackedBar");
      scatterPlotsData = getData("scatterPlot");
      bubblePlotsData = getData("bubblePlot");
      rangePickerData = getRangePickers();
      insightsData = getInsights();
      timelinesData = getTimelines();
      legend = getLegend();
      legendData = getLegendData();
    }

    /**
     * Get data functions
     * @param style
     * @return {*}
     */
    function getData(style) {
      if ($ctrl.displayData) {
        return $ctrl.displayData.reduce(function (prev, setting) {
          if (setting.style === style && setting.data) {
            setting.data.map(function (datapoint) {
              datapoint.dataType = setting.dataType;
              return datapoint;
            });

            return prev.concat(setting);
          }
          return prev;
        }, []);
      }

      return [];
    }

    /**
     * Get range picker
     * @return {*}
     */
    function getRangePickers() {
      return $ctrl.rangePicker ? [$ctrl.rangePicker] : [];
    }

    /**
     * Get insights
     * @return {*}
     */
    function getInsights() {
      return $ctrl.displayData.reduce(function (prev, setting) {
        if (setting.style === "insight" && setting.data) {
          return prev.concat(
            setting.data.map(function (ds) {
              return ds;
            })
          );
        }
        return prev;
      }, []);
    }

    /**
     * Get timelines
     * @return {*}
     */
    function getTimelines() {
      return $ctrl.displayData.reduce(function (prev, setting) {
        if (setting.style === "timeline" && setting.data) {
          return prev.concat(setting);
        }
        return prev;
      }, []);
    }

    /**
     * Get legends
     */
    function getLegend() {
      /**
       * @type {{}}
       */
      var thisLegend = {};

      angular.forEach($ctrl.displayData, function (value) {
        if (!value.data || !value.data.length || (value.data.data && !value.data.data.length)) return false;

        if (value.colors) {
          angular.forEach(value.colors, function (color, key) {
            var title = $translate.instant("LEGEND_TEXT_" + key);

            title = title.indexOf("LEGEND_TEXT_") > -1 ? key : title;

            thisLegend[key] = {
              id: key,
              title: title,
              style: value.style,
              color: color
            };
          });
        } else {
          var title = $translate.instant("LEGEND_TEXT_" + value.id);

          title = title.indexOf("LEGEND_TEXT_") > -1 ? value.name : title;

          thisLegend[value.id] = {
            id: value.id,
            title: title,
            style: value.style,
            color: value.color || color(value.id)
          };
        }
      });

      return thisLegend;
    }

    /**
     * Get legend data
     * @return {Array}
     */
    function getLegendData() {
      legendData = [];

      angular.forEach(legend, function (value) {
        if (value.style === "insight") return false;
        legendData.push(value);
      });

      return legendData;
    }

    /**
     * Update dimensions
     * @param parentWidth
     */
    function updateDimensions(parentWidth) {
      updateMargins();
      width = parentWidth - conf.leftMargin - conf.rightMargin;
    }

    /**
     * Update margins
     */
    function updateMargins() {
      /**
       * @type {number}
       */
      var yScalesCount = Object.keys(yScales).length;

      if (!yScalesCount) {
        conf.leftMargin = yScalesConf.width;
        //conf.rightMargin = yScalesConf.width;
      }

      if (yScalesCount > 0) {
        conf.leftMargin = yScalesConf.width;
      }

      if (yScalesCount > 1) {
        conf.rightMargin = yScalesConf.width;
      }
    }

    /**
     * Set main chart height
     */
    function setMainChartHeight() {
      if (bubblePlotsData.length) {
        mainChartHeight = 250;
      } else if (
        linesData.length ||
        areaData.length ||
        stackedAreaData.length ||
        barsData.length ||
        stackedBarData.length ||
        scatterPlotsData.length
      ) {
        mainChartHeight = 150;
      } else {
        mainChartHeight = 0;
      }
    }

    /**
     * AREA CHART
     */

    /**
     * Draw area chart
     * @param dataset
     */
    function drawAreas(dataset) {
      var areas = areasG.selectAll(".area").data(dataset, function (d) {
        return d.id;
      });

      areas.attr("d", function (d) {
        return areaFun(d.data);
      });

      var newAreas = areas.enter().append("g").attr("class", "area");

      newAreas
        .append("path")
        .attr("class", "fill")
        .attr("stroke", function (d) {
          return legend[d.id] ? legend[d.id].color : color(d.id);
        })
        .attr("fill", function (d) {
          return legend[d.id] ? legend[d.id].color : color(d.id);
        })
        .attr("opacity", 0.2);

      newAreas
        .append("path")
        .attr("class", "line")
        .attr("stroke", function (d) {
          return legend[d.id] ? legend[d.id].color : color(d.id);
        })
        .attr("fill", "none")
        .attr("opacity", 1);

      areas.exit().remove();

      scaleAreas();
    }

    /**
     * Scale areas
     */
    function scaleAreas() {
      areasG
        .selectAll(".area")
        .select(".fill")
        .attr("d", function (d) {
          return areaFun(d.data);
        });
      areasG
        .selectAll(".area")
        .select(".line")
        .attr("d", function (d) {
          return lineFun(d.data);
        });
    }

    /**
     * Draw stacked areas
     * @param dataset
     */
    function drawStackedAreas(dataset) {
      stackFun.keys(getKeys(dataset));

      var data = stackFun(processForStackedChart(dataset));

      var stackedAreas = stackedAreasG.selectAll(".stacked-area").data(data, function (d) {
        return d.key;
      });

      var newStackedAreas = stackedAreas.enter().append("g").attr("class", "stacked-area");

      newStackedAreas
        .append("path")
        .attr("class", "fill")
        .attr("stroke", function (d) {
          return legend[d.key] ? legend[d.key].color : color(d.key);
        })
        .attr("fill", function (d) {
          return legend[d.key] ? legend[d.key].color : color(d.key);
        })
        .attr("opacity", 0.2);

      newStackedAreas
        .append("path")
        .attr("class", "line")
        .attr("stroke", function (d) {
          return legend[d.key] ? legend[d.key].color : color(d.key);
        })
        .attr("fill", "none")
        .attr("opacity", 1);

      stackedAreas.exit().remove();

      scaleStackedAreas();
    }

    /**
     * Scale stacked areas
     */
    function scaleStackedAreas() {
      stackedAreasG.selectAll(".stacked-area").select(".fill").attr("d", stackedAreaFun);
      stackedAreasG.selectAll(".stacked-area").select(".line").attr("d", stackedAreaLineFun);
    }

    /**
     * Process data for stacked chart
     * @param dataInput
     * @return {Array}
     */
    function processForStackedChart(dataInput) {
      /**
       * @type {Array}
       */
      var output = [];

      /**
       * @type {{}}
       */
      var temp = {};

      angular.forEach(dataInput, function (e) {
        angular.forEach(e.data, function (f) {
          if (!temp[f.Epoch]) {
            temp[f.Epoch] = {
              Epoch: f.Epoch,
              dataType: f.dataType,
              interval: f.interval
            };
          }

          temp[f.Epoch][e.id] = f.value;
        });
      });

      angular.forEach(temp, function (e) {
        output.push(e);
      });

      return output;
    }

    /**
     * Group data by day
     * @param dataInput
     * @return {Array}
     */
    function groupDataByDay(dataInput) {
      /**
       * @type {Array}
       */
      var output = [];

      /**
       * @type {{}}
       */
      var temp = {};

      angular.forEach(dataInput, function (e) {
        if (!temp[e.Epoch]) {
          temp[e.Epoch] = {
            Epoch: e.Epoch,
            data: []
          };
        }

        temp[e.Epoch].data.push(e.value);
      });

      angular.forEach(temp, function (e) {
        output.push(e);
      });

      return output;
    }

    /**
     * Get ids from data
     * @param data
     * @return {Array}
     */
    function getKeys(data) {
      /**
       * @type {Array}
       */
      var output = [];

      angular.forEach(data, function (e) {
        output.push(e.id);
      });

      return output;
    }

    /**
     * LINE CHART
     */

    /**
     * Draw line graph
     * @param dataset
     */
    function drawLines(dataset) {
      var lines = linesG.selectAll(".line").data(dataset, function (d) {
        return d.id;
      });

      lines.attr("d", function (d) {
        return lineFun(d.data);
      });

      lines
        .enter()
        .append("path")
        .attr("class", "line")
        .attr("stroke", function (d) {
          return legend[d.id] ? legend[d.id].color : color(d.id);
        })
        .attr("stroke-width", 2)
        .attr("stroke-dasharray", function (d) {
          return d.options.strokeDashed ? "5, 5" : "none";
        })
        .attr("fill", "none")
        .attr("d", function (d) {
          return lineFun(d.data);
        });

      lines.exit().remove();
    }

    /**
     * Scale lines
     */
    function scaleLines() {
      linesG.selectAll(".line").attr("d", function (d) {
        return lineFun(d.data);
      });
    }

    /**
     * STACKED BARS CHART
     */

    /**
     * Draw stacked bars
     * @param dataset
     */
    function drawStackedBars(dataset) {
      stackFun.keys(getKeys(dataset));

      var data = stackFun(processForStackedChart(dataset));

      /**
       * Stacked bar layers
       */
      var layer = stackedBarsG.selectAll(".layer").data(data, function (d) {
        return d.key;
      });

      layer
        .enter()
        .append("g")
        .attr("class", "layer")
        .style("fill", function (d, i) {
          return legend[d.key] ? legend[d.key].color : color(i);
        });

      layer.exit().remove();

      /**
       * Bar chunks (rects)
       */
      var layerRects = stackedBarsG
        .selectAll(".layer")
        .selectAll("rect")
        .data(
          function (d) {
            return d;
          },
          function (d) {
            return d.data.Epoch;
          }
        );

      layerRects.enter().append("rect");
      layerRects.exit().remove();

      scaleStackedBars();
    }

    /**
     * Scale stacked bars
     */
    function scaleStackedBars() {
      var layerRectsItems = stackedBarsG.selectAll("rect");

      // Bar width scale
      xScaleStackedBar.domain([0, xScaleT.domain()[1] - xScaleT.domain()[0]]);
      xScaleStackedBar.range(xScaleT.range());

      layerRectsItems
        .attr("x", function (d) {
          return (
            xScaleT((d.data.Epoch - d.data.interval / 2) * 1000) +
            Math.max(0.5, xScaleStackedBar(d.data.interval * 1000) * 0.05)
          );
        })
        .attr("width", function (d) {
          return Math.max(1, xScaleStackedBar(d.data.interval * 1000) * 0.9);
        })
        .attr("y", function (d) {
          return yScales[d.data.dataType].scale(d[1]);
        })
        .attr("height", function (d) {
          return yScales[d.data.dataType].scale(d[0]) - yScales[d.data.dataType].scale(d[1]) || 0;
        });
    }

    /**
     * BAR CHART
     */

    /**
     * draw bar chart
     * @param dataset
     */
    function drawBars(dataset) {
      /**
       * Stacked bars groups
       */
      var barGroups = barsG.selectAll(".barGroup").data(dataset, function (d) {
        return d.id + d.interval;
      });

      barGroups.enter().append("g").attr("class", "barGroup");

      barGroups.exit().remove();

      /**
       * Bars (rects)
       */
      var bars = barsG
        .selectAll(".barGroup")
        .selectAll("g")
        .data(
          function (d) {
            return d.data;
          },
          function (d) {
            return d.id + d.epoch + d.interval;
          }
        );

      bars
        .enter()
        .append("g")
        .append("path")
        .attr("fill", function (d) {
          return legend[d.id] ? legend[d.id].color : color(d.id);
        });

      bars.exit().remove();

      scaleBars();
    }

    /**
     * Scale bar chart
     */
    function scaleBars() {
      barsG.selectAll(".barGroup").attr("transform", function (d, i, j) {
        d.i = i;
        d.c = j.length;
      });

      var bars = barsG.selectAll(".barGroup").selectAll("path");

      // Bar width scale
      xScaleBar.domain([0, xScaleT.domain()[1] - xScaleT.domain()[0]]);
      xScaleBar.range(xScaleT.range());

      bars.attr("d", function (d) {
        var parent = d3.select(this.parentNode.parentNode).datum();
        var _width = Math.max(1, xScaleBar(d.interval * 1000) * 0.9) / parent.c,
          _height = yScales[d.dataType].scale(0) - yScales[d.dataType].scale(d.value) || 0,
          _x =
            xScaleT((d.Epoch - d.interval / 2) * 1000) +
            _width * parent.i +
            xScaleBar(d.interval * 1000) * 0.05,
          _y = yScales[d.dataType].scale(d.value),
          _radius = _width < 6 ? 0 : 2;

        return rounded_rect(_x, _y, _width, _height, _radius, true, true, false, false);
      });
    }

    /**
     * SCATTER PLOT CHART
     */

    /**
     * Draw scatter plot chart
     * @param dataset
     */
    function drawScatterPlots(dataset) {
      /**
       * Scatter Plot groups
       */
      var scatterPlots = scatterPlotsG.selectAll(".scatterPlot").data(dataset, function (d) {
        return d.id;
      });

      scatterPlots.enter().append("g").attr("class", "scatterPlot");

      scatterPlots.exit().remove();

      /**
       * Dots
       */
      var dots = scatterPlotsG
        .selectAll(".scatterPlot")
        .selectAll("circle")
        .data(
          function (d) {
            return d.data;
          },
          function (d) {
            return d.key;
          }
        );

      dots
        .enter()
        .append("circle")
        .attr("fill", function (d) {
          return legend[d.id] ? legend[d.id].color : color(d.id);
        })
        .attr("opacity", 0.5)
        .attr("r", 4)
        .on("mouseover", mouseoverDot)
        .on("mousemove", mousemoveDot)
        .on("mouseout", mouseoutDot);

      dots.exit().remove();

      function mouseoverDot() {
        showTooltip();
        d3.select(this).transition().attr("r", 6).attr("opacity", 1);
      }

      function mousemoveDot(d) {
        setTooltip(d.title, d.description);
      }

      function mouseoutDot() {
        hideTooltip();
        d3.select(this).transition().attr("r", 4).attr("opacity", 0.5);
      }

      scaleScatterPlots();
    }

    /**
     * Scale scatter plots
     */
    function scaleScatterPlots() {
      scatterPlotsG
        .selectAll("circle")
        .attr("cx", function (d) {
          return xScaleT(d.Epoch * 1000);
        })
        .attr("cy", function (d) {
          return yScales[d.dataType].scale(d.value);
        });
    }

    /**
     * BUBBLE PLOT GRAPH
     */

    /**
     * Draw bubble plot graph
     * @param dataset
     */
    function drawBubblePlots(dataset) {
      /**
       * Bubble Plot groups
       */
      var bubblePlots = bubblePlotsG.selectAll(".bubblePlot").data(dataset, function (d) {
        return d.id;
      });

      bubblePlots.enter().append("g").attr("class", "bubblePlot");

      bubblePlots.exit().remove();

      /**
       * Dots
       */
      var dots = bubblePlotsG
        .selectAll(".bubblePlot")
        .selectAll("circle")
        .data(
          function (d) {
            return d.data;
          },
          function (d) {
            return d.key;
          }
        );

      dots
        .enter()
        .append("circle")
        .attr("fill", function (d) {
          return legend[d.id] ? legend[d.id].color : color(d.id);
        })
        .attr("opacity", 0.5)
        .on("mouseover", mouseoverBubble)
        .on("mousemove", mousemoveBubble)
        .on("mouseout", mouseoutBubble);

      dots.exit().remove();

      /**
       * Handle mouse over bubble
       * @param d
       */
      function mouseoverBubble(d) {
        showTooltip();
        showRange();
        setRange(d.aggregationStart, d.aggregationEnd);

        d3.select(this)
          .transition()
          .attr("r", function (d) {
            return d.value[1].value * 25 * 1.1;
          })
          .attr("opacity", 1);
      }

      /**
       * Handle mouse move
       * @param d
       */
      function mousemoveBubble(d) {
        /**
         * @type {string}
         */
        var description = "";

        angular.forEach(d.value, function (value) {
          description += value.id + ": " + parseInt(value.value * 100);
          description += "<br>";
        });

        setTooltip(d.date, description);
      }

      /**
       * Handle mouse leave
       */
      function mouseoutBubble() {
        hideTooltip();
        hideRange();

        d3.select(this)
          .transition()
          .attr("r", function (d) {
            return d.value[1].value * 25;
          })
          .attr("opacity", function (d) {
            return Math.max(0.2, d.value[1].value);
          });
      }

      scaleBubblePlots();
    }

    /**
     * Scale bubble plot
     */
    function scaleBubblePlots() {
      bubblePlotsG
        .selectAll("circle")
        .attr("cx", function (d) {
          return xScaleT(d.Epoch * 1000);
        })
        .attr("cy", function (d) {
          return yScales[d.dataType].scale(d.value[0].value);
        })
        .attr("opacity", function (d) {
          return Math.max(0.2, d.value[1].value);
        })
        .attr("r", function (d) {
          return d.value[1].value * 25;
        });
    }

    /**
     * DRAW RANGE PICKER
     */

    /**
     * Draw range picker
     * @param dataset
     */
    function drawRangePicker(dataset) {
      /**
       * Drag start
       * @param d
       */
      function dragstartedMain(d) {
        d3.select(this.parentNode).raise().classed("active", true);

        d.dragOffset1 = d.x1 - d3.event.x;
        d.dragOffset2 = d.x2 - d3.event.x;
        d.dragStart1 = d.x1;
        d.dragStart2 = d.x2;
      }

      /**
       * While dragging
       * @param d
       */
      function draggedMain(d) {
        d.x1 = d3.event.x + d.dragOffset1;
        d.x2 = d.x1 + d.width;

        d.startEpoch = parseInt(xScaleT.invert(d.x1).getTime() / 1000);
        d.endEpoch = parseInt(xScaleT.invert(d.x2).getTime() / 1000);

        d.markers.forEach(function (m) {
          m.epoch = d.startEpoch + (m.labelEpoch || 0);
        });

        scaleRangePickers();
      }

      /**
       * Handle main drag end
       * @param d
       */
      function dragendedMain(d) {
        if (Math.abs(d.dragStart1 - d.x1) > 2 || Math.abs(d.dragStart2 - d.x2)) {
          $ctrl.onRangePickerChanged({ rangePicker: d });
        }
      }
      function dragstartedMarker(d) {
        //if(!d.draggable) return;

        d3.select(this.parentNode).raise().classed("active", true);
        d.dragOffset = d.x - d3.event.x || 0;
        d.dragStart = d.x || 0;
      }

      function draggedMarker(d) {
        var x = d3.event.x; //+ d.dragOffset// - d3.select(this.parentNode).attr('x');
        if (x > 0 && x < d3.select(this.parentNode).select("rect").attr("width")) {
          d.x = x;
        } else if (x <= 0) {
          d.x = 0;
        } else {
          d.x = parseInt(d3.select(this.parentNode).select("rect").attr("width"));
        }
        d.epoch = parseInt(
          xScaleT.invert(d.x + parseFloat(d3.select(this.parentNode).attr("x"))).getTime() / 1000
        );

        scaleRangePickers();
      }

      /**
       * Handle drag start on epoch
       * @param d
       */
      function draggedStartEpoch(d) {
        var x = d3.event.x + d.dragOffset1;

        if (x < d.x2) {
          d.x1 = x;
          d.startEpoch = parseInt(xScaleT.invert(d.x1).getTime() / 1000);
        } else {
          d.startEpoch = d.endEpoch - 300; // minimum of 5 minutes
        }

        d.markers.forEach(function (m) {
          if (d.startEpoch >= m.epoch) m.epoch = d.startEpoch;
        });

        scaleRangePickers();
      }

      /**
       * Handle drag end of epoch
       * @param d
       */
      function draggedEndEpoch(d) {
        var x = d3.event.x + d.dragOffset2;

        if (x > d.x1) {
          d.x2 = x;
          d.endEpoch = parseInt(xScaleT.invert(d.x2).getTime() / 1000);
        } else {
          d.endEpoch = d.startEpoch + 300; // minimum of 5 minutes
        }

        d.markers.forEach(function (m) {
          if (d.endEpoch <= m.epoch) m.epoch = d.endEpoch;
        });

        scaleRangePickers();
      }

      function dragendedMarker(d) {
        if (Math.abs(d.dragStart - d.x) > 2) {
          $ctrl.onRangePickerChanged({ rangePicker: $ctrl.rangePicker });
        }
      }

      var rangePickers = rangePickerG.selectAll(".range-picker").data(dataset, function (d) {
        return d.id;
      });
      // ENTER

      var rangePickerGroup = rangePickers.enter().append("g").attr("class", "range-picker");

      rangePickerGroup
        .append("g")
        .attr("class", "main")
        .attr("height", rangePickerConf.height)
        .style("cursor", "pointer")
        .call(d3.drag().on("start", dragstartedMain).on("drag", draggedMain).on("end", dragendedMain))
        .append("rect")
        .attr("height", rangePickerConf.height)
        .style("fill", function (d) {
          return legend[d.color] ? legend[d.color].color : color(d.color);
        });

      var rangePickerMarkers = rangePickerGroup
        .select(".main")
        .selectAll(".range-picker-markers")
        .data(
          function (d) {
            return d.markers;
          },
          function (d) {
            return d;
          }
        );

      rangePickerGroup
        .append("rect")
        .attr("class", "start-epoch")
        .attr("height", rangePickerConf.height)
        .attr("width", rangePickerConf.height)
        .attr("rx", rangePickerConf.borderRadius)
        .attr("opacity", 0.5)
        .style("fill", function (d) {
          return legend[d.color] ? legend[d.color].color : color(d.color);
        })
        .style("cursor", "pointer")
        .call(d3.drag().on("start", dragstartedMain).on("drag", draggedStartEpoch).on("end", dragendedMain));

      rangePickerGroup
        .append("rect")
        .attr("class", "end-epoch")
        .attr("height", rangePickerConf.height)
        .attr("width", rangePickerConf.height)
        .attr("rx", rangePickerConf.borderRadius)
        .attr("opacity", 0.5)
        .style("fill", function (d) {
          return legend[d.color] ? legend[d.color].color : color(d.color);
        })
        .style("cursor", "pointer")
        .call(d3.drag().on("start", dragstartedMain).on("drag", draggedEndEpoch).on("end", dragendedMain));

      var rangePickerMarkerGroups = rangePickerMarkers
        .enter()
        .append("g")
        .attr("class", "epoch-marker-group")
        .style("cursor", "pointer")
        .call(d3.drag().on("start", dragstartedMarker).on("drag", draggedMarker).on("end", dragendedMarker));

      rangePickerMarkerGroups
        .append("rect")
        //.attr('class', 'start-epoch-cover')
        .attr("height", mainChartHeight + rangePickerConf.topMargin)
        .attr("width", 2)
        .attr("rx", 2)
        .attr("x", -1)
        .attr("y", -(rangePickerConf.topMargin + mainChartHeight))
        .attr("opacity", 0.5)
        .style("fill", "#000");

      rangePickerMarkerGroups
        .append("circle")
        // .attr('height', rangePickerConf.height)
        // .attr('width', rangePickerConf.height)
        .attr("r", rangePickerConf.height / 2.5)
        .attr("cy", rangePickerConf.height / 2)
        .attr("opacity", 0.7)
        .style("fill", "#FFFFFF");

      rangePickerMarkerGroups
        .append("rect")
        //.attr('class', 'start-epoch-cover')
        .attr("height", 19)
        .attr("width", function (d) {
          return d.title.length * 7;
        })
        .attr("rx", 2)
        .attr("x", -1)
        .attr("y", -(rangePickerConf.topMargin + mainChartHeight))
        .attr("opacity", 0.5)
        .style("fill", "#000");

      rangePickerMarkerGroups
        .append("text")
        .attr("x", -1)
        .attr("y", -(rangePickerConf.topMargin + mainChartHeight) + 13)
        .attr("dx", "0.5em")
        .attr("textAnchor", "middle")
        .attr("fill", "#FFFFFF")
        .text(function (d) {
          return d.title.toLowerCase();
        });

      rangePickerGroup
        .append("rect")
        .attr("class", "start-epoch-cover")
        .attr("height", mainChartHeight)
        .attr("y", -(rangePickerConf.topMargin + mainChartHeight))
        .attr("opacity", 0.2)
        .style("fill", "#000");

      rangePickerGroup
        .append("rect")
        .attr("class", "end-epoch-cover")
        .attr("height", mainChartHeight)
        .attr("y", -(rangePickerConf.topMargin + mainChartHeight))
        .attr("opacity", 0.2)
        .style("fill", "#000");

      rangePickerGroup
        .append("rect")
        .attr("class", "end-epoch-cover")
        .attr("height", mainChartHeight)
        .attr("y", -(rangePickerConf.topMargin + mainChartHeight))
        .attr("opacity", 0.2)
        .style("fill", "#000");

      // EXIT

      rangePickers.exit().remove();

      scaleRangePickers();
    }

    /**
     * Scale range pickers
     */
    function scaleRangePickers() {
      var rangePickers = rangePickerG.selectAll(".range-picker");

      rangePickers
        .select(".main")
        .attr("transform", function (d) {
          d.x1 = xScaleT(d.startEpoch * 1000);
          d.x2 = xScaleT(d.endEpoch * 1000);
          d.width = Math.max(d.x2 - d.x1, 0);

          return "translate(" + d.x1 + ",0)";
        })
        .attr("startEpoch", function (d) {
          return d.startEpoch;
        })
        .attr("endEpoch", function (d) {
          return d.endEpoch;
        })
        .attr("x", function (d) {
          return d.x1;
        })
        .select("rect")
        .attr("width", function (d) {
          return d.width;
        });

      rangePickers.selectAll(".epoch-marker-group").attr("transform", function (d) {
        d.labelEpoch = d.epoch - parseInt(d3.select(this.parentNode).attr("startEpoch"));
        d.x = xScaleT(d.epoch * 1000) - d3.select(this.parentNode).attr("x");
        return "translate(" + d.x + ",0)";
      });

      rangePickers.select(".start-epoch").attr("x", function (d) {
        return d.x1 - rangePickerConf.height;
      });
      rangePickers.select(".end-epoch").attr("x", function (d) {
        return d.x2;
      });

      rangePickers.select(".start-epoch-cover").attr("width", function (d) {
        return Math.max(d.x1, 0);
      });
      rangePickers
        .select(".end-epoch-cover")
        .attr("x", function (d) {
          return d.x2;
        })
        .attr("width", function (d) {
          return Math.max(width - d.x2, 0);
        });
    }

    /**
     * Set range picker height
     * @param rangePickers
     */
    function setRangePickerHeight(rangePickers) {
      rangePickerHeight = rangePickers.length
        ? rangePickerConf.topMargin +
          rangePickerConf.bottomMargin +
          rangePickers.length * rangePickerConf.height
        : 0;
    }

    /**
     * Get insight stroke color
     * @param d
     * @return {*}
     */
    function insightStrokeColor(d) {
      var thisColor = legend[d.category] ? legend[d.category].color : color(d.category);
      var insightType = d.insightType ? d.insightType.typeName : null;

      if (insightType === "DoNotBreedEstrusInsight") {
        return d3.hsl(thisColor);
      } else if ($ctrl.highlightedData.indexOf(d.GenericInsightID || d.GenericLabelID) > -1) {
        return d3.hsl(thisColor).darker(1);
      }

      return false;
    }

    /**
     * Get insight opacity
     * @param d
     * @return {number}
     */
    function insightOpacity(d) {
      /**
       * @type {number}
       */
      var opacity = 0.8;

      if ($ctrl.highlightedData.indexOf(d.GenericInsightID || d.GenericLabelID) > -1) {
        opacity = 1;
      }

      return opacity;
    }

    /**
     * Get insight display value
     * @param d
     * @return {string}
     */
    function insightDisplay(d) {
      /**
       * @type {string}
       */
      var display = "block";

      if ($ctrl.hiddenData.indexOf(d.GenericInsightID || d.GenericLabelID) > -1) {
        display = "none";
      }

      return display;
    }

    /**
     * Draw insights
     * @param {Array<Insight>} dataset
     */
    function drawInsights(dataset) {
      var insights = insightG.selectAll(".insight").data(dataset, function (d) {
        return d.GenericInsightID || d.GenericLabelID;
      });

      // ENTER

      var insightGroup = insights
        .enter()
        .append("g")
        .attr("class", "insight")
        .attr("transform", insightTransform)
        .style("opacity", function (d) {
          return !d.disabled ? 1 : 0.3;
        })
        .style("display", insightDisplay)
        .on("click", clickInsight);

      // TODO insert vwp variant here
      // Similarly to "fill", create a function (or more) which
      // returns different properties based on the insight context

      insightGroup
        .append("rect")
        .attr("height", insightsConf.rect)
        .style("fill", function (d) {
          var ctx = insightService.getContext(d);
          var insightType = d.insightType ? d.insightType.typeName : null;
          var fill;

          if (insightType === "DoNotBreedEstrusInsight") {
            /**
             * When the insight context indicates that the cow is DNB,
             * we use a white fill.
             * @type {string}
             */
            fill = "white";
          } else if (
            lodash.concat(INSIGHT_CATEGORIES.lecacyHeat, INSIGHT_CATEGORIES.heat).indexOf(insightType) > -1 &&
            ctx.inVWP
          ) {
            /**
             * When insight context indicates VWP, we use an white fill,
             * as an indication of "empty" insight.
             * @type {string}
             */
            fill = "white";
          } else if (legend[d.category]) {
            fill = legend[d.category].color;
          } else {
            fill = color(d.category);
          }

          return fill;
        })
        .style("stroke", insightStrokeColor)
        .style("stroke-width", "2px")
        .style("opacity", insightOpacity)
        .style("cursor", "pointer")
        .on("mouseover", showTooltip)
        .on("mousemove", mousemoveInsight)
        .on("mouseout", mouseoutInsight);

      insightGroup
        .selectAll(".validation")
        .data(
          function (d) {
            return d.insightValidations || (d.validation ? [d.validation] : []);
          },
          function (d) {
            return d.InsightValidationID;
          }
        )
        .enter()
        .append("circle")
        .attr("class", "validation")
        .attr("fill", function (d) {
          return legend["insightValidation" + d.validation]
            ? legend["insightValidation" + d.validation].color
            : color("insightValidation" + d.validation);
        })
        .attr("stroke", "#FFF")
        .attr("stroke-width", "1px")
        .on("mouseover", showTooltip)
        .on("mousemove", mousemoveValidation)
        .on("mouseout", hideTooltip);

      // UPDATE
      insights.attr("transform", insightTransform);

      var rangePickerMarkers = insightGroup.selectAll(".range-picker-markers").data(
        function (d) {
          return d.markers || [];
        },
        function (d) {
          return d;
        }
      );

      var rangePickerMarkerGroups = rangePickerMarkers
        .enter()
        .append("g")
        .attr("class", "epoch-marker-group");

      rangePickerMarkerGroups
        .append("circle")
        .attr("r", rangePickerConf.height / 3.5)
        .attr("cy", rangePickerConf.height / 2)
        .attr("opacity", 0.7)
        .style("fill", "#FFFFFF")
        .on("mouseover", showTooltip)
        .on("mousemove", mousemoveMarker)
        .on("mouseout", hideTooltip);

      // EXIT

      insights.exit().remove();

      /**
       * Insight transform
       * @param d
       * @return {string}
       */
      function insightTransform(d) {
        var row = getInsightRow(d.GenericInsightID || d.GenericLabelID);

        d.y = row * (insightsConf.rect + insightsConf.rowSpacing);

        return "translate(0, " + d.y + ")";
      }

      /**
       * Handle mouse move on insight
       * @param d
       */
      function mousemoveInsight(d) {
        d3.select(this.parentNode).selectAll("rect").style("opacity", 1);

        return setTooltip(d.title, null, d.footer);
      }

      /**
       * Handle mouse leave on insight
       */
      function mouseoutInsight() {
        d3.select(this.parentNode).selectAll("rect").style("opacity", insightOpacity);

        return hideTooltip();
      }

      /**
       * Handle mouse move on validation
       * @param d
       */
      function mousemoveValidation(d) {
        return setTooltip(d.title, null, d.footer);
      }
      function mousemoveMarker(d) {
        return setTooltip(d.title, null, null);
      }

      /**
       * Handle click insight
       * @param d
       */
      function clickInsight(d) {
        $ctrl.onInsightClicked({ insight: d });
      }

      scaleInsights();
    }

    /**
     * Set corner radius of rectangle
     * @param d
     * @return {number}
     */
    function rectCorner(d) {
      /**
       * @type {number}
       */
      var cornerRadius = insightsConf.rect / 2;

      if (d.width < insightsConf.rect) {
        cornerRadius = d.width / 2;
      }

      if (d.GenericLabelID) cornerRadius = cornerRadius / 3;

      return cornerRadius;
    }

    /**
     * Scale insights
     */
    function scaleInsights() {
      var circleRadiusM = insightsConf.rect / 3;
      var insights = insightG.selectAll(".insight");

      insights
        .select("rect")
        .attr("x", function (d) {
          d.x1 = xScaleT(d.startEpoch * 1000);
          d.x2 = xScaleT(d.endEpoch * 1000);
          d.width = d.x2 - d.x1;

          if (d.width < insightsConf.rect) {
            d.x1 = d.x1 - (insightsConf.rect - d.width) / 2;
            d.width = insightsConf.rect;
          }

          return d.x1;
        })
        .attr("width", function (d) {
          return d.width;
        })
        .attr("rx", rectCorner);

      insights
        .selectAll(".validation")
        .attr("cx", function (d) {
          var cx = xScaleT(d.epoch * 1000) - insightsConf.rect / 2;

          var parentX = d3.select(this.parentNode).datum().x1;

          if (cx - circleRadiusM < parentX) {
            cx = parentX + insightsConf.rect / 2;
          }

          return cx;
        })
        .attr("cy", insightsConf.rect / 2)
        .attr("r", circleRadiusM);

      insights.selectAll(".epoch-marker-group").attr("transform", function (d) {
        d.labelEpoch = d.epoch - parseInt(d3.select(this.parentNode).attr("startEpoch"));
        d.x = xScaleT(d.epoch * 1000) - d3.select(this.parentNode).attr("x");
        return "translate(" + d.x + ",0)";
      });
    }

    /**
     * Set insight section height
     * @param insights
     */
    function setInsightsHeight(insights) {
      var rows = countInsightsRows(insights);

      insightsHeight = rows
        ? insightsConf.topMargin +
          insightsConf.bottomMargin +
          rows * (insightsConf.rect + insightsConf.rowSpacing)
        : 0;
    }

    /**
     * Set timeline height
     * @param timelines
     */
    function setTimelinesHeight(timelines) {
      var rows = timelines.length;

      timelinesHeight = rows
        ? timelinesConf.topMargin +
          timelinesConf.bottomMargin +
          rows * (timelinesConf.height + timelinesConf.rowSpacing)
        : 0;
    }

    /**
     * Count insight rows
     * @param insights
     * @return {number}
     */
    function countInsightsRows(insights) {
      insightsRows = []; // Reset rows

      insights.forEach(function (insight) {
        var InsightID = insight.GenericInsightID || insight.GenericLabelID;

        InsightIDRowMap[InsightID] = calculateInsightRow(insight.startEpoch, insight.endEpoch, InsightID);
      });

      return insightsRows.length;
    }

    /**
     * Calculate ? insight row
     * @param x1
     * @param x2
     * @param id
     * @return {number}
     */
    function calculateInsightRow(x1, x2, id) {
      /**
       * @type {number}
       */
      var n = insightsRows.length;

      /**
       * @type {{id: *, x1: *, x2: *}}
       */
      var insight = {
        id: id,
        x1: x1,
        x2: x2
      };

      // First insight
      if (n === 0) {
        insightsRows[n] = [];
        insightsRows[n].push(insight);

        return 0;
      }

      for (var i = 0; i < n; i++) {
        /**
         * @type {Array<{id: *, x1: *, x2: *}>}
         */
        var row = insightsRows[i];

        /**
         * @type {boolean}
         */
        var spaceInThisRow = true;

        for (var j = 0, len = row.length; j < len; j++) {
          var currentInsight = row[j];

          if (
            (x1 >= currentInsight.x1 && x1 <= currentInsight.x2) ||
            (x2 >= currentInsight.x1 && x2 <= currentInsight.x2) ||
            (x1 < currentInsight.x1 && x2 > currentInsight.x2)
          ) {
            spaceInThisRow = false;
          }
        }

        if (spaceInThisRow) {
          insightsRows[i].push(insight);
          return i;
        }
      }

      // New row
      insightsRows[n] = [];
      insightsRows[n].push(insight);

      return n;
    }

    /**
     * Get insight row
     * @param id
     * @return {*}
     */
    function getInsightRow(id) {
      return InsightIDRowMap[id];
    }

    /**
     * TIMELINE CHART
     */

    /**
     * Draw timeline
     * @param dataset
     */
    function drawTimelines(dataset) {
      var timelines = timelineG.selectAll(".timeline").data(dataset, function (d) {
        return d.id;
      });

      // ENTER

      timelines.enter().append("g").attr("class", "timeline").attr("transform", timelineTransform);

      // UPDATE

      timelines.attr("transform", timelineTransform);

      // EXIT

      timelines.exit().remove();

      var events = timelineG
        .selectAll(".timeline")
        .selectAll(".event")
        .data(
          function (d) {
            return d.data;
          },
          function (d) {
            return d.id;
          }
        );

      // ENTER

      events
        .enter()
        .append("rect")
        .attr("class", "event")
        .attr("height", timelinesConf.height)
        .style("fill", function (d) {
          return legend[d.event] ? legend[d.event].color : color(d.event);
        })
        .on("mouseover", showTooltip)
        .on("mousemove", mousemoveEvent)
        .on("mouseout", hideTooltip)
        .on("click", clickEvent);

      // EXIT

      events.exit().remove();

      /**
       * Timeline transform
       * @param d
       * @param i
       * @return {string}
       */
      function timelineTransform(d, i) {
        /**
         * @type {number}
         */
        var y = i * (timelinesConf.height + timelinesConf.rowSpacing);

        return "translate(0, " + y + ")";
      }

      /**
       * Handle mouse move
       * @param d
       */
      function mousemoveEvent(d) {
        return setTooltip(d.title);
      }

      /**
       * Handle click
       * @param d
       */
      function clickEvent(d) {
        $ctrl.onEventClicked({ event: d });
      }

      scaleTimeline();
    }

    /**
     * Scale timeline
     */
    function scaleTimeline() {
      var events = timelineG.selectAll(".event");

      events
        .attr("x", function (d) {
          d.x1 = xScaleT(d.startEpoch * 1000);
          return d.x1;
        })
        .attr("width", function (d) {
          d.x2 = xScaleT(d.endEpoch * 1000);
          return d.x2 - d.x1;
        })
        .attr("rx", function (d) {
          return d.x2 - d.x1 > timelinesConf.borderRadius * 4 ? timelinesConf.borderRadius : 0;
        });
    }

    /**
     * SCALES
     */

    /**
     * Set Y scale domains
     */
    function setYScaleDomains() {
      angular.forEach(yScales, function (s) {
        var dataset = getDataOfDataType(s.dataType);

        /**
         * @type {number}
         */
        var max = 1;

        /**
         * @type {number}
         */
        var min = 0;

        if (s.isStacked) {
          max = d3.max(groupDataByDay(dataset), function (d) {
            return d3.sum(d.data);
          });
        } else {
          max = d3.max(dataset, function (d) {
            return d.value;
          });
          min = d3.min(dataset, function (d) {
            return d.value;
          });
        }

        if (s.dataType === "percentage") {
          s.scale.domain([0, max >= 0.5 ? max : 0.5]).nice();
        } else if (s.dataType === "degrees") {
          s.scale.domain([d3.min([min, 0]), max]).nice();
        } else {
          s.scale.domain([0, max]).nice();
        }
      });
    }

    /**
     * Set Y scales
     */
    function setYScales() {
      var dataTypes = $ctrl.displayData.reduce(function (prev, data) {
        if (data.dataType) {
          return prev.concat({
            dataType: data.dataType,
            isStacked: data.style.indexOf("stacked") > -1 ? true : false
          });
        }
        return prev;
      }, []);

      /**
       * @type {{}}
       */
      yScales = {};

      angular.forEach(dataTypes, function (value) {
        if (!yScales[value.dataType]) {
          yScales[value.dataType] = {};
          yScales[value.dataType].scale = d3.scaleLinear();
          yScales[value.dataType].dataType = value.dataType;
          yScales[value.dataType].isStacked = value.isStacked;
        }
      });
    }

    /**
     * Set Y scale ranges
     */
    function setYScaleRanges() {
      angular.forEach(yScales, function (s) {
        s.scale.range([mainChartHeight, 0]);
      });
    }

    /**
     * Get data from datatype
     * @param dataType
     * @return {*}
     */
    function getDataOfDataType(dataType) {
      return $ctrl.displayData.reduce(function (prev, setting) {
        if (setting.dataType === dataType && setting.data) {
          if (setting.data.data) {
            return prev.concat(setting.data.data);
          }
          return prev.concat(setting.data);
        }
        return prev;
      }, []);
    }

    /**
     * X-AXIS
     */

    /**
     * Draw X axis
     */
    function drawAxisX() {
      svgG.append("g").attr("class", "x-axis");
    }

    /**
     * Update X axis
     */
    function updateAxisX() {
      var dateTickFormat = GraphLocalizationService.getTickFormat(localeService.getCurrentLocale());

      svgG
        .select(".x-axis")
        .attr(
          "transform",
          "translate(0," + (mainChartHeight + rangePickerHeight + insightsHeight + timelinesHeight) + ")"
        )
        .call(
          d3
            .axisBottom(xScaleT)
            .tickSize(-(rangePickerHeight + insightsHeight + timelinesHeight))
            .tickArguments(getXAxisTickArguments())
            .tickPadding(10)
            .tickFormat(dateTickFormat)
        );

      setTickClasses();
    }

    /**
     * Set tick classnames
     */
    function setTickClasses() {
      svgG
        .select(".x-axis")
        .selectAll("text")
        .each(function () {
          if (this.textContent.indexOf("AM") === -1 && this.textContent.indexOf("PM") === -1) {
            // day
            this.classList.add("day");
          }
        });

      svgG
        .select(".x-axis")
        .selectAll("text")
        .each(function () {
          this.classList.remove("higlighted");
          if (!/\d/.test(this.textContent)) {
            //month
            this.classList.add("month");
          }
        });
    }

    /**
     * Get X asis tick interval hours
     * @return {*}
     */
    function getXAxisTickIntervalHours() {
      var interval;

      /**
       * @type {number}
       */
      var dayRange = daysBetween(xScaleT.domain()[0], xScaleT.domain()[1]) + 1;

      if (isMobile) {
        if (dayRange <= 1) {
          interval = 6;
        } else if (dayRange <= 3) {
          interval = 12;
        } else if (dayRange <= 7) {
          interval = 24;
        } else if (dayRange <= 31) {
          interval = 24 * 7;
        } else if (dayRange <= 183) {
          interval = 24 * 61;
        }
      } else {
        if (dayRange <= 1) {
          interval = 2;
        } else if (dayRange <= 3) {
          interval = 6;
        } else if (dayRange <= 7) {
          interval = 24;
        } else if (dayRange <= 31) {
          interval = 24 * 2;
        }
      }

      return interval;
    }

    /**
     * Get X axis tick args
     * @return {Array}
     */
    function getXAxisTickArguments() {
      var _tickArguments = [];
      var tickInterval = getXAxisTickIntervalHours();

      if (tickInterval) {
        if (tickInterval < 24) {
          _tickArguments.push(d3.timeHour.every(tickInterval));
        } else if (tickInterval < 24 * 31) {
          _tickArguments.push(d3.timeDay.every(tickInterval / 24));
        } else {
          _tickArguments.push(d3.timeMonth.every(tickInterval / 24 / 30));
        }
      }

      return _tickArguments;
    }

    /**
     * Get tick values in seconds
     * @param scale
     * @return {Array}
     */
    function getSecondsTickValues(scale) {
      var h = 3600;
      var maxSeconds = d3.max(scale.domain());
      var everySeconds = h * 0.5; // Smallest tick step is 30 minutes
      var everyHours = 1;

      // If there are more than 6 ticks with the current everySeconds value
      // increase it to 1 hour, and add 1 hour untill there are less than 6 ticks
      while (maxSeconds / everySeconds > 5) {
        everySeconds = h * everyHours;
        everyHours++;
      }

      var values = [];
      var i;

      for (i = 0; i <= maxSeconds / everySeconds; i++) {
        values.push(i * everySeconds);
      }

      return values;
    }

    /**
     * Draw X axis scales
     */
    function drawAxisYScales() {
      /**
       * Create array with axis info
       * @type {Array}
       */
      var yAxisArray = [];

      angular.forEach(yScales, function (s) {
        yAxisArray.push({ key: s.dataType, scale: s.scale });
      });

      var yAxis = svgG.selectAll(".y-axis").data(yAxisArray, function (d) {
        return d.key;
      });

      yAxis
        .enter()
        .append("g")
        .attr("class", function (d) {
          return "y-axis data-type-" + d.key;
        });

      yAxis.exit().remove();

      updateAxisYScales();
    }

    /**
     * Update X axis scales
     */
    function updateAxisYScales() {
      var i = 0;

      angular.forEach(yScales, function (s) {
        var axisCall;

        if (i > 0) {
          axisCall = d3.axisRight(s.scale);
        } else {
          axisCall = d3.axisLeft(s.scale);
        }

        axisCall.tickSize(-width).tickSizeOuter(0);

        if (s.dataType === "percentage") {
          axisCall.tickFormat(d3.format(".0%"));
        } else if (s.dataType === "seconds") {
          //axisCall.tickArguments(getYAxisTickArguments(s));
          axisCall.tickValues(getSecondsTickValues(s.scale));
          axisCall.tickFormat(formatMinutes);
        } else {
          axisCall.ticks(4).tickSizeOuter(0);
        }

        svgG
          .select(".y-axis.data-type-" + s.dataType)
          .attr("transform", i > 0 ? "translate(" + width + ",0)" : "translate(0,0)")
          .transition()
          .call(axisCall);

        i++;
      });
    }

    /**
     * LEGENDS
     */

    /**
     * Set legend height
     */
    function setLegendHeight() {
      var accTranslateX = 0;
      var accTranslateY = 0;

      angular.forEach(legendData, function (legendItem) {
        var nLetters = legendItem.title.split("").length;
        var legendItemWidth = nLetters * 8 + 30;

        if (accTranslateX + legendItemWidth > width) {
          accTranslateY += legendConf.height;
          accTranslateX = 0;
        }

        legendItem.x = accTranslateX;
        legendItem.y = accTranslateY;
        accTranslateX += legendItemWidth;
      });

      legendHeight = accTranslateY + legendConf.height;
    }

    /**
     * Set range height
     */
    function setRangeHeight() {
      /**
       * @type {number}
       */
      var baseHeight = mainChartHeight + rangePickerHeight + insightsHeight + timelinesHeight;

      rangeG.selectAll("rect").attr("height", baseHeight);
    }

    /**
     * Draw legends
     */
    function drawLegend() {
      var legends = legendG.selectAll(".legend").data(legendData, function (d) {
        return d.id;
      });

      // ENTER

      var legendItemG = legends.enter().append("g").attr("class", "legend");

      legendItemG.each(function (d) {
        var g = d3.select(this);
        if (d.style === "line" || d.style === "area" || d.style === "stackedArea") {
          g.append("rect")
            .attr("y", 5)
            .attr("width", 10)
            .attr("height", 3)
            .attr("rx", 1.5)
            .style("fill", function (d) {
              return d.color || color(d.id);
            });
        } else if (d.style === "insight" || d.style === "scatterPlot") {
          g.append("circle")
            .attr("cy", 6)
            .attr("cx", 5)
            .attr("r", 5)
            .style("fill", function (d) {
              return d.color || color(d.id);
            });
        } else {
          g.append("rect")
            .attr("y", 0)
            .attr("width", 10)
            .attr("height", 10)
            .attr("rx", 2)
            .style("fill", function (d) {
              return d.color || color(d.id);
            });
        }
      });

      legendItemG
        .append("text")
        .attr("x", 9)
        .attr("y", 10)
        .attr("dx", "0.5em")
        .text(function (d) {
          return d.title;
        });

      // UPDATE

      legendItemG
        .merge(legends)
        .transition()
        .attr("transform", function (d) {
          return "translate(" + d.x + ", " + d.y + ")";
        });

      // EXIT

      legends.exit().transition().remove();
    }

    /**
     * TOOLTIP
     */

    /**
     * Show tooltip
     */
    function showTooltip() {
      tooltip.style("opacity", 0.9);
    }

    /**
     * Set tooltip content
     * @param title
     * @param body
     * @param footer
     */
    function setTooltip(title, body, footer) {
      /**
       * @type {string}
       */
      var html =
        "" +
        '<div class="tooltip-arrow"></div>' +
        '<div class="tooltip-inner">' +
        "<strong>" +
        title +
        "</strong>" +
        (body ? "<div>" + body + "</div>" : "") +
        (footer ? '<div class="small gray">' + footer + "</div>" : "") +
        "</div>";

      tooltip
        .html(html)
        .style("left", d3.event.pageX - tooltip.node().getBoundingClientRect().width / 2 + "px")
        .style("top", d3.event.pageY - tooltip.node().getBoundingClientRect().height + "px");
    }

    /**
     * Hide tooltip
     */
    function hideTooltip() {
      tooltip.style("opacity", 0);
    }

    /**
     * RANGE
     */

    /**
     * Show range
     */
    function showRange() {
      rangeG.style("opacity", 0.5);

      rangeG
        .selectAll("rect")
        .attr("width", 1)
        .attr("stroke-dasharray", "5,5")
        .attr("fill", "transparent")
        .attr("stroke", "#000");
    }

    /**
     * Set range
     * @param startEpoch
     * @param endEpoch
     */
    function setRange(startEpoch, endEpoch) {
      rangeG.selectAll("rect");

      rangeG.select(".range-start").attr("x", function () {
        return xScaleT(startEpoch * 1000);
      });

      rangeG.select(".range-end").attr("x", function () {
        return xScaleT(endEpoch * 1000);
      });
    }

    /**
     * Hide range
     */
    function hideRange() {
      rangeG.style("opacity", 0);
    }

    /**
     * TOOLS
     */

    /**
     * Format minutes
     * @param d
     * @return {*}
     */
    function formatMinutes(d) {
      var hours = Math.floor(d / 3600),
        minutes = Math.floor((d - hours * 3600) / 60),
        seconds = Math.floor(d - minutes * 60 - hours * 3600);

      var output = seconds ? seconds + "s" : seconds;

      if (minutes) {
        //output = minutes + 'm' + (seconds ? ' ' + seconds + 's' : '');
        output = minutes + "m";
      }

      if (hours) {
        output = hours + "h" + (minutes ? " " + minutes + "m" : "");
      }

      return output;
    }
  }

  /**
   * Give the days between 2 dates
   * @param date1
   * @param date2
   * @return {number}
   */
  function daysBetween(date1, date2) {
    /**
     * @type {number}
     */
    var ONE_DAY = 1000 * 60 * 60 * 24;

    /**
     * Calculate the difference in milliseconds
     * @type {number}
     */
    var difference_ms = Math.abs(date1.getTime() - date2.getTime());

    return Math.floor(difference_ms / ONE_DAY);
  }

  /**
   * Create an SVG path for rounded rectangle
   * @param x
   * @param y
   * @param w
   * @param h
   * @param r
   * @param tl
   * @param tr
   * @param bl
   * @param br
   * @return {string}
   */
  function rounded_rect(x, y, w, h, r, tl, tr, bl, br) {
    var path;

    path = "M" + (x + r) + "," + y;
    path += "h" + (w - 2 * r);

    if (tr) {
      path += "a" + r + "," + r + " 0 0 1 " + r + "," + r;
    } else {
      path += "h" + r;
      path += "v" + r;
    }

    path += "v" + (h - 2 * r);

    if (br) {
      path += "a" + r + "," + r + " 0 0 1 " + -r + "," + r;
    } else {
      path += "v" + r;
      path += "h" + -r;
    }

    path += "h" + (2 * r - w);

    if (bl) {
      path += "a" + r + "," + r + " 0 0 1 " + -r + "," + -r;
    } else {
      path += "h" + -r;
      path += "v" + -r;
    }

    path += "v" + (2 * r - h);

    if (tl) {
      path += "a" + r + "," + r + " 0 0 1 " + r + "," + -r;
    } else {
      path += "v" + -r;
      path += "h" + r;
    }

    path += "z";

    return path;
  }
})();

/* global d3 */

(function () {
  "use strict";

  angular
    .module("ctraDataVisualisations.dataVisualisation.graph")
    .service("GraphLocalizationService", GraphLocalizationService);

  /**
   * Default locale formats
   * @type {{dateTime: string, date: string, periods: [string, string], time: string}}
   */
  var localeDefaults = {
    periods: ["AM", "PM"],
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p"
  };

  /**
   * A d3 locale object
   * @typedef {{
   *   dateTime: string,
   *   date: string,
   *   periods: [string, string],
   *   time: string,
   *   months: string[],
   *   shortMonths: string[],
   *   shortDays: string[],
   *   days: string[]
   * }} Locale
   */

  /**
   * English
   * @type {Locale}
   */
  var en = {
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: ["AM", "PM"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  };

  /**
   * Dutch
   * @type {Locale}
   */
  var nl = {
    days: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
    shortDays: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    months: [
      "Januari",
      "Februari",
      "Maart",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Augustus",
      "September",
      "Oktober",
      "November",
      "December"
    ],
    shortMonths: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]
  };

  /**
   * Spanish
   * @type {Locale}
   */
  var es = {
    days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    shortDays: ["do", "lu", "ma", "mi", "ju", "vi", "sa"],
    months: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    shortMonths: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
  };

  /**
   * Danish
   * @type {Locale}
   */
  var dk = {
    days: ["Søndag", "Mandag", "Tirsdag", "Onsdag", " Torsdag ", "Fredag", "Lørdag"],
    shortDays: ["sø", "ma", "ti", "on", "to", "fr", " lø"],
    months: [
      "Januar",
      "Februar",
      "Marts",
      "April",
      "Maj",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "December"
    ],
    shortMonths: [
      "jan.",
      "feb.",
      "mar.",
      "apr.",
      "maj",
      "jun.",
      "jul.",
      "aug.",
      "sep.",
      "okt.",
      "nov.",
      "dec."
    ]
  };

  /**
   * Hungarian
   * @type {Locale}
   */
  var hu = {
    days: ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
    shortDays: ["va", "hé", "ke", "sz", "cs", "pé", "sz"],
    months: [
      "Január ",
      "Február ",
      "Március",
      "április",
      "Május",
      "Június",
      "Július",
      "Augusztus",
      "Szeptember",
      "Október",
      "November",
      "December"
    ],
    shortMonths: [
      "jan.",
      "febr.",
      " márc.",
      " ápr.",
      "máj.",
      "jún.",
      "júl.",
      "aug.",
      "szept.",
      "okt.",
      "nov.",
      "dec."
    ]
  };

  /**
   * German
   * @type {Locale}
   */
  var de = {
    days: ["Sonntag", "Montag", "Dinstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    shortDays: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    months: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    shortMonths: [
      "Jan.",
      "Feb.",
      "März",
      "Apr.",
      "Mai",
      "Jun.",
      "Jul.",
      "Aug.",
      "Sept.",
      "Okt.",
      "Nov.",
      "Dez."
    ]
  };

  /**
   * French
   * @type {Locale}
   */
  var fr = {
    dateTime: "%A %e %B %Y à %X",
    date: "%d/%m/%Y",
    time: "%H:%M:%S",
    periods: ["AM", "PM"],
    days: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
    shortDays: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    months: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    shortMonths: [
      "janv.",
      "févr.",
      "mars",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ]
  };

  /**
   * Russian
   * @type {Locale}
   */
  var ru = {
    dateTime: "%A, %e %B %Y г. %X",
    date: "%d.%m.%Y",
    time: "%H:%M:%S",
    periods: ["AM", "PM"],
    days: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
    shortDays: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
    months: [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря"
    ],
    shortMonths: ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"]
  };

  /**
   * Portugese
   * @type {Locale}
   */
  var pt = {
    dateTime: "%A, %e de %B de %Y. %X",
    date: "%d/%m/%Y",
    time: "%H:%M:%S",
    periods: ["AM", "PM"],
    days: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    shortDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    months: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ],
    shortMonths: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"]
  };

  /**
   * Anything related to graph localizations
   * @ngInject
   * @return {GraphLocalizationService}
   * @constructor
   */
  function GraphLocalizationService() {
    /**
     * List of locales which are available for the graph
     * @note options may include "da-DK", "de-DE", "en-US", "es-ES", "fr-FR", "hu-HU", "nl-NL", "pt", "ru-RU"
     * @see LOCALES.locales
     * @type {{
     *   "ru-RU": Locale,
     *   "de-DE": Locale,
     *   "hu-HU": Locale,
     *   "nl-NL": Locale,
     *   "en-US": Locale,
     *   pt: Locale,
     *   "es-ES": Locale,
     *   "da-DK": Locale,
     *   "fr-FR": Locale,
     *   "es-MX": Locale}
     * }
     */
    this.locales = {
      "da-DK": Object.assign({}, localeDefaults, dk),
      "de-DE": Object.assign({}, localeDefaults, de),
      "en-US": Object.assign({}, localeDefaults, en),
      "es-ES": Object.assign({}, localeDefaults, es),
      "es-MX": Object.assign({}, localeDefaults, es),
      "fr-FR": Object.assign({}, localeDefaults, fr),
      "hu-HU": Object.assign({}, localeDefaults, hu),
      "nl-NL": Object.assign({}, localeDefaults, nl),
      pt: Object.assign({}, localeDefaults, pt),
      "ru-RU": Object.assign({}, localeDefaults, ru)
    };

    /**
     * Set the d3 locale
     * @param locale
     * @return {function(*=): *}
     */
    this.getTickFormat = function (locale) {
      var definitions = this.locales[locale] || this.locales["en-US"];
      var formatter = d3.timeFormatLocale(definitions);

      var formatMillisecond = formatter.format(".%L"),
        formatSecond = formatter.format(":%S"),
        formatMinute = formatter.format("%I:%M"),
        formatHour = formatter.format("%I %p"),
        formatDay = formatter.format("%a %d"),
        formatWeek = formatter.format("%b %d"),
        formatMonth = formatter.format("%B"),
        formatYear = formatter.format("%Y");

      return function multiFormat(date) {
        return (d3.timeSecond(date) < date
          ? formatMillisecond
          : d3.timeMinute(date) < date
          ? formatSecond
          : d3.timeHour(date) < date
          ? formatMinute
          : d3.timeDay(date) < date
          ? formatHour
          : d3.timeMonth(date) < date
          ? d3.timeWeek(date) < date
            ? formatDay
            : formatWeek
          : d3.timeYear(date) < date
          ? formatMonth
          : formatYear)(date);
      };
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraDataVisualisations.dataVisualisation", [
    "rt.debounce",
    "ctraDataVisualisations",
    "ctraDataVisualisations.dataVisualisation.graph"
  ]);
})();

(function () {
  "use strict";

  angular.module("ctraDataVisualisations.dataVisualisation").component("ctraDataVisualisation", {
    bindings: {
      displayValues: "<",
      rangePicker: "<",
      startDate: "<",
      endDate: "<",
      highlightedData: "<",
      hiddenData: "<",
      contextMenu: "<",
      onDateChange: "&",
      onInsightClicked: "&",
      onRangePickerChanged: "&",
      isLoading: "&"
    },
    controller: dataVisualisationCtrl,
    templateUrl:
      "app/shared-components/angular-data-visualisations/components/data-visualisation/data-visualisation.html"
  });

  function dataVisualisationCtrl($window, $q, dataApiService, debounce, $translate) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.$onChanges = onChanges;

    $ctrl.onChartDomainChange = onChartDomainChange;

    var loadDataDebounced = debounce(200, getData);
    var dataLoader = null;
    var dataQueries = [];

    function onInit() {
      $ctrl.legend = getLegend();

      updateChartDomain();
    }

    function onChanges(change) {
      if (
        change.hasOwnProperty("displayValues") ||
        change.hasOwnProperty("startDate") ||
        change.hasOwnProperty("endDate")
      ) {
        loadDataDebounced();
      }

      if (change.hasOwnProperty("displayValues")) {
        $ctrl.legend = getLegend();
      }
      if (change.hasOwnProperty("startDate") || change.hasOwnProperty("endDate")) {
        updateChartDomain();
      }
    }

    function updateChartDomain() {
      $ctrl.chartDomain = [$ctrl.startDate.getTime(), $ctrl.endDate.getTime()];
    }

    function onChartDomainChange(domain) {
      if ($ctrl.onDateChange) {
        $ctrl.onDateChange({ startDate: domain[0], endDate: domain[1] });
      } else {
        $ctrl.startDate = domain[0];
        $ctrl.endDate = domain[1];
        loadDataDebounced();
      }
    }

    function getData() {
      $ctrl.error = "";
      $ctrl.info = "";
      $ctrl.showChart = true;

      if (!$ctrl.startDate) {
        $ctrl.showChart = false;
        return ($ctrl.error = "No start date selected");
      }
      if (!$ctrl.endDate) {
        $ctrl.showChart = false;
        return ($ctrl.error = "No start date selected");
      }
      if (!$ctrl.displayValues.length) {
        $ctrl.info = "Please select display variables";
      }

      if (dataLoader) {
        // Cancel current loaders and queries
        dataLoader.reject("cancel");
        angular.forEach(dataQueries, function (dataQuery) {
          dataQuery.reject("cancel");
        });
      }
      dataLoader = $q.defer();
      $ctrl.isLoading({ loading: true });

      $ctrl.showChart = true;
      $ctrl.loading = true;

      var dayRange = daysBetween($ctrl.startDate, $ctrl.endDate);
      var displayValues = getDisplayValues();

      dataQueries = [];
      var dataPromises = [];

      angular.forEach(displayValues, function (dataPoint) {
        var dataBleed = 0;
        if (dataPoint.bleed) {
          if (Number.isInteger(dataPoint.bleed)) {
            dataBleed = Math.ceil(dayRange / (dataPoint.bleed / 86400));
          } else if (dataPoint.bleed.indexOf("%") > -1) {
            dataBleed = Math.ceil((parseFloat(dataPoint.bleed) / 100) * dayRange);
          }
        }

        var queryStartDate = new Date($ctrl.startDate.getTime());
        queryStartDate.setHours(0, 0, 0, 0);
        queryStartDate.setDate(queryStartDate.getDate() - dataBleed);

        var queryEndDate = new Date($ctrl.endDate.getTime());
        queryEndDate.setHours(23, 59, 59, 99);
        queryEndDate.setDate(queryEndDate.getDate() + dataBleed);

        var aggregationInterval = dataPoint.getAggregationInterval
          ? dataPoint.getAggregationInterval(dayRange)
          : getAggregationInterval(dayRange);
        var aggregationWindow = dataPoint.getAggregationWindow
          ? dataPoint.getAggregationWindow(dayRange)
          : getAggregationWindow(dayRange);
        var source = dataPoint.getStatType ? dataPoint.getStatType() : dataPoint.source;

        // if the aggregationInterval is 1 week
        // Normalise start and end dates to to weeks, starting on jan 1st + 7days
        if (aggregationInterval === 604800) {
          // one week
          queryStartDate.setDate(queryStartDate.getDate() - (queryStartDate.getDOY() % 7));
          queryEndDate.setDate(queryEndDate.getDate() + (7 - (queryEndDate.getDOY() % 7)));
        }
        dataPoint.query = $q.defer();

        dataApiService
          .getData(
            dataPoint.api,
            source,
            dataPoint.scope,
            dataPoint.subjectId,
            queryStartDate,
            queryEndDate,
            aggregationInterval,
            aggregationWindow
          )
          .then(
            function successCallback(result) {
              var data = dataApiService.processDataForDataExplorer(
                result,
                source,
                dataPoint.style,
                aggregationInterval,
                dataPoint.filters
              );
              data = !dataPoint.showPredictions
                ? dataApiService.stripPredictions(data, dataPoint.style)
                : data;

              dataPoint.query.resolve(data[dataPoint.id] || []);
            },
            function errorCallback(reason) {
              dataPoint.query.reject(reason);
            }
          );

        dataPoint.query.promise.then(
          function successCallback(data) {
            dataPoint.data = data;
          },
          function errorCallback(reason) {
            if (reason !== "cancel") {
              dataPoint.data = [];
            }
          }
        );

        dataQueries.push(dataPoint.query);
        dataPromises.push(dataPoint.query.promise);
      });

      $q.all(dataPromises).then(
        function successCallback() {
          dataLoader.resolve();
        },
        function errorCallback(reason) {
          if (reason !== "cancel") {
            dataLoader.reject(reason);
          }
        }
      );

      dataLoader.promise.then(
        function successCallback() {
          $ctrl.displayData = displayValues;
          $ctrl.loading = false;
          $ctrl.isLoading({ loading: false });
        },
        function errorCallback(reason) {
          if (reason !== "cancel") {
            $ctrl.error = $translate.instant("LABEL_TEXT_OOPS");
            $ctrl.loading = false;
            $ctrl.isLoading({ loading: false });
          }
        }
      );

      return false;
    }

    function getAggregationWindow(dayRange) {
      return getAggregationInterval(dayRange);
    }

    function getAggregationInterval(dayRange) {
      var agInterval = 3600 / 2;
      var h = 3600;

      if (dayRange <= 1) {
        agInterval = h;
      } else if (dayRange <= 3) {
        agInterval = h;
      } else if (dayRange <= 31) {
        agInterval = h * 24;
      } else if (dayRange <= 92) {
        agInterval = h * 48;
      } else {
        agInterval = h * 168;
      }

      return agInterval;
    }

    function daysBetween(date1, date2) {
      // The number of milliseconds in one day
      var ONE_DAY = 1000 * 60 * 60 * 24;

      // Calculate the difference in milliseconds
      var difference_ms = Math.abs(date1.getTime() - date2.getTime());

      // Convert back to days and return
      return Math.floor(difference_ms / ONE_DAY);
    }

    function getDisplayValues() {
      return $ctrl.displayValues.reduce(function (prev, value) {
        //return prev.concat(value);
        return prev.concat(angular.copy(value));
      }, []);
    }

    function getLegend() {
      // var isThereAnyInsight = false;
      // var legend = $ctrl.settings.reduce(function(prev, settingsGroup) {
      //   return prev.concat(settingsGroup.settings.filter(function (setting) {
      //     if (setting.isVisible && setting.style === 'insight') {
      //       isThereAnyInsight = true;
      //     }
      //     return setting.isVisible;
      //   }));
      // }, []);
      // if (legend.length > 0 && isThereAnyInsight) {
      //   legend.push({ name: 'Actions', style: 'insight', color: 'blue' });
      // }
      //
      //

      var legend = $ctrl.displayValues;
      return legend;
    }
  }

  Date.prototype.isLeapYear = function () {
    var year = this.getFullYear();
    if ((year & 3) != 0) return false;
    return year % 100 != 0 || year % 400 == 0;
  };

  // Get Day of Year
  Date.prototype.getDOY = function () {
    var dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
    var mn = this.getMonth();
    var dn = this.getDate();
    var dayOfYear = dayCount[mn] + dn;
    if (mn > 1 && this.isLeapYear()) dayOfYear++;
    return dayOfYear;
  };
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.sharing")
    .constant("MEDIUMS", {
      whatsapp: "WhatsApp",
      email: "email",
      copy: "copy"
    });
})();


(function () {
  "use strict";

  /**
   * Validation values
   * @type {{yes: string, no: string, noAnswer: string}}
   */
  var VALIDATION_VALUES = {
    yes: "Yes",
    no: "No",
    maybe: "Maybe",
    noAnswer: "NA"
  };

  angular
    .module("ctraUIComponents.genericInsight.insightValidation")
    .constant("VALIDATION_VALUES", VALIDATION_VALUES)
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insightList")
    .constant("LIST_TYPES", {
      sensorAlerts: "sensor-alerts",
      healthInsights: "health-insights",
      calvingInsights: "calving-insights",
      groupInsights: "group-insights",
      missingEstrus: "missing-estrus"
    });
}());

(function () {
  "use strict";

  /**
   * All the insight types for a given category
   * @type {{heat: string[], calving: string[], cycleAlert: string[], legacyHeat: string[],
   * sensorAlert: string[], health: string[], cycleAlertWorkflow: string[]}}
   */
  var INSIGHT_CATEGORIES = {
    heat: ["Venus"],
    legacyHeat: [
      "Estrus",
      "Estrus2H_01",
      "Vote_5d_2H",
      "FirstEstrusAfterCalving",
      "CowIsInEstrus",
      "CowCanBeInseminated",
      "CowInEstrus",
      "Vote_5d_2H_NDP",
      "ComposedEstrusInsight"
    ],
    health: [],
    calving: ["CowHasCalved"],
    sensorAlert: ["SensorIsNotOnCow", "SensorIsOffline", "CowDoesNotHaveSensor", "SensorIsNotTurnedOn"],
    cycleAlertWorkflow: [
      "WFMissingEstrus",
      "WFMissingEstrusPostCalving",
      "WFMissingEstrusTreated",
      "WFMissingEstrusPostCalvingTreated",
      "WFMissingEstrusResolved",
      "WFMissingEstrusPostCalvingResolved"
    ],
    cycleAlert: [
      "WFMissingEstrus",
      "WFMissingEstrusPostCalving"
    ]
  };

  /**
   * This is the epoch we use for all the queries
   * @type {string}
   */
  var DOMINANT_EPOCH = "endEpoch";

  /**
   * Default config for fetching insights
   * @type {{filter: {validated: null, insightState: [string, string], dairyCow: {hasSensor: null},
   * endEpoch: null, insightContext: null, farmID: null, insightType: {typeName: {none: null, any: null}},
   * startEpoch: null, resolved: null}, expand: string[], offset: number, limit: number, orderBy: string, order: string}}
   */
  var DEFAULT_FETCH_INSIGHT_CONFIG = {
    expand: ["dairyCow", "insightValidations", "insightType", "genericLabels"],
    orderBy: DOMINANT_EPOCH,
    order: "desc",
    filter: {
      farmID: null,
      insightState: ["Live", "ForcedLive"],
      resolved: null,
      validated: null,
      insightType: {
        typeName: {
          any: null,
          none: null
        },
        insightScope: null
      },
      insightContext: {
        any: null,
        all: null
      },
      dairyCow: {
        hasSensor: null,
        doNotBreed: null,
        areaID: null,
        herdGroupID: null
      },
      startEpoch: null,
      endEpoch: null,
      insightCategory: {
        any: null,
        none: null
      },
      seen: null
    },
    offset: 0,
    limit: 0
  };

  angular
    .module("ctraUIComponents.genericInsight")
    .constant("INSIGHT_CATEGORIES", INSIGHT_CATEGORIES)
    .constant("DOMINANT_EPOCH", DOMINANT_EPOCH)
    .constant("DEFAULT_FETCH_INSIGHT_CONFIG", DEFAULT_FETCH_INSIGHT_CONFIG);
})();


/* global $:false */
/* eslint-disable angular/angularelement */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("subNav", subNav);

  /**
   * @return {{restrict: string, templateUrl: string, scope: {items: string}, controller: *[]}}
   * @ngInject
   */
  function subNav () {
    /**
     * @type {{restrict: string, templateUrl: string, scope: {items: string}, controller: *[]}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-ui-components/components/subNav/subNav.html",
      scope: {
        items: "="
      },
      controller: ["$element", function ($element) {
        $($element).find("a").on("click", function () {
          $(".navbar-toggle:visible").click();
        });
      }]
    };

    return directive;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("sectionNav", sectionNav);

  /**
   * @return {{restrict: string, templateUrl: string, scope: {items: string}}}
   * @ngInject
   */
  function sectionNav () {
    return  {
      restrict: "E",
      templateUrl: "app/shared-components/angular-ui-components/components/sectionNav/sectionNav.html",
      scope: {
        items: "="
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .component("scrollingStackedBars", {
      bindings: {
        sections: "<",
        scrollPosition: "=",
        onScroll: "&",
        onScrollStart: "&",
        onScrollEnd: "&"
      },
      controller: DarkCircusOfPleasure,
      templateUrl: "app/shared-components/angular-ui-components/components/" +
        "scrollingStackedBars/scrollingStackedBars.html"
    });

  /**
   * @param lodash
   * @constructor
   * @ngInject
   */
  function DarkCircusOfPleasure (lodash) {
    var $ctrl = this;

    /**
     * Returns a given function or noop.
     * @param fn
     * @returns {*}
     */
    function noopize (fn) {
      return fn || lodash.noop;
    }

    $ctrl.$onInit = function () {
      /**
       * Slider options
       * @type {{floor: number, ceil: number, step: number, onStart: *, onChange: *, onEnd: *}}
       */
      $ctrl.sliderOptions = {
        floor: 0,
        ceil: 100,
        step: 1,

        /**
         * Callback for starting a scroll
         * @type {function}
         */
        onStart: noopize($ctrl.onScrollStart),

        /**
         * Mid-scroll callback
         * @type {function}
         */
        onChange: function () {
          noopize($ctrl.onScroll)({
            percentage: $ctrl.scrollPosition
          });
        },

        /**
         * Scroll-end callback
         * @type {function}
         */
        onEnd: noopize($ctrl.onScrollEnd)
      };
    };

    /**
     * @memberOf DarkCircusOfPleasure
     * @param section
     * @returns {{width: string}}
     */
    $ctrl.getInlineStyle = function (section) {
      var total = lodash.reduce($ctrl.sections, function (result, section) {
        return result + section.value;
      }, 0);

      return {
        width: (section.value / total * 100) + "%"
      };
    };
  }

})();

(function() {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("saveStatusInline", saveStatusInline);

  /**
   * @return {{restrict: string, template: string, scope: {status: string}}}
   * @ngInject
   */
  function saveStatusInline() {
    /**
     * @type {{restrict: string, template: string, scope: {status: string}}}
     */
    var directive = {
      restrict: "E",
      template: "" +
        '<h5>' +
          '<span ng-if="status.saving" class="appear">' +
            '<loading-spinner class="inline-block primary"></loading-spinner> saving' +
          '</span>' +
          '<strong ng-show="status.saved" class="color-success appear">' +
            'saved!' +
          '</strong>' +
          '<strong ng-show="status.failed" class="color-danger appear">' +
            'saving failed...' +
          '</strong>' +
        '</h5>',
      scope: {
        status: "="
      }
    };

    return directive;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .component("cowEntry", {
      bindings: {
        cow: "<",
        heading: "<",
        forGroup: "@"
      },
      controller: CowEntryController,
      templateUrl: "app/shared-components/angular-ui-components/components/ranking/cowEntry.html"
    });

  /**
   * @param cowService
   * @param lodash
   * @constructor
   * @ngInject
   */
  function CowEntryController (cowService, lodash, $translate) {
    var $ctrl = this;

    /**
     * @type {{lower: string, middle: string, upper: string}}
     */
    var classNameMap = {
      lower: "performance-bad",
      middle: "performance-average",
      upper: "performance-good"
    };

    /**
     * Get class name based on cow data.
     * @memberOf CowEntryController
     * @returns {string}
     */
    $ctrl.getClassName = function () {
      return classNameMap[$ctrl.forGroup];
    };

    /**
     * Makes a camelCased string human readable.
     * @param camelCased
     * @return {string|*}
     */
    $ctrl.getLabel = function (camelCased) {
      return lodash.capitalize($translate.instant(lodash.lowerCase(camelCased)));
    };

    /**
     * Get heading class name
     * @memberOf CowEntryController
     * @returns {string}
     */
    $ctrl.getHeadingClassName = function () {
      return classNameMap[$ctrl.heading.for];
    };

    /**
     * Get ordered progress bars
     * @return {[]}
     */
    $ctrl.getProgressbars = lodash.memoize(function () {
      return lodash.map($ctrl.cow.SubScores, function (v, k) {
        return {
          values: v,
          className: k
        };
      });
    });

    /**
     * Go to cow.
     */
    $ctrl.goToCow = function (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      cowService.goToCow($ctrl.cow.CowID);
    };

    /**
     * Get translated cow state.
     */
    $ctrl.getCowState = function () {
      return $translate.instant("COW_STATE_" + $ctrl.cow.State.toUpperCase());
    }
  }

})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .component("coloredProgressBar", {
      bindings: {
        label: "@",
        value: "<",
        className: "@"
      },
      templateUrl: "app/shared-components/angular-ui-components/components/progressBar/progressbar.html"
    });
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents").component("pageAlert", {
    transclude: true,
    templateUrl: "app/shared-components/angular-ui-components/components/pageAlert/pageAlert.html"
  });
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .service("pageTransitionService", pageTransitionService);

  /**
   * @return {{goForward: goForward, goBackward: goBackward,
   * unsetDirection: unsetDirection, getDirection: (function(): *)}}
   */
  function pageTransitionService () {
    /**
     * @type {string}
     */
    this.direction = "";

    return {
      goForward: function () {
        this.direction = "forward";
      },
      goBackward: function () {
        this.direction = "backward";
      },
      unsetDirection: function () {
        this.direction = null;
      },
      getDirection: function () {
        return this.direction;
      }
    };
  }
}());

(function () {
  "use strict";
  angular
    .module("ctraUIComponents")
    .directive("pageTransition", pageTransition);

  /**
   * @return {{restrict: string, controller: pageTransitionLink}}
   * @ngInject
   */
  function pageTransition () {
    /**
     * @type {{restrict: string, controller: pageTransitionLink}}
     */
    var directive = {
      restrict: "A",
      controller: pageTransitionLink
    };

    return directive;

    /**
     * @param $rootScope
     * @param $scope
     * @param $element
     * @param pageTransitionService
     * @ngInject
     */
    function pageTransitionLink ($rootScope, $scope, $element, pageTransitionService) {
      var vm = $scope;

      // Listen to UI Router navigation changes
      var onTransitionPage = $rootScope.$on("$stateChangeStart", transitionPage);

      $rootScope.$on("$destroy", onTransitionPage);

      /**
       * Transition page
       */
      function transitionPage () {
        var view = $element.find("ui-view");

        view.removeClass("transition-scrolled");

        if (pageTransitionService.getDirection()) {
          /**
           * @type {string}
           */
          vm.anim = "transition-scrolled";
        } else {
          /**
           * @type {string}
           */
          vm.anim = "";
        }

        if (pageTransitionService.getDirection() === "backward") {
          $element.addClass("transition-backward");
        } else {
          $element.removeClass("transition-backward");
        }

        pageTransitionService.unsetDirection();

        view.addClass(vm.anim);
      }
    }
  }
})();

(function () {

  "use strict";

  angular
    .module("ctraUIComponents")
    .component("missingEstrusFormFields", {
      templateUrl: "app/shared-components/angular-ui-components/components/missingEstrusFormFields/missingEstrusFormFields.html",
      controller: missingEstrusFormFieldsController,
      bindings: {
        farmPreferences: "=",
        onBlur: "<"
      }
    });

  /**
   * @ngInject
   * @param $element
   */
  function missingEstrusFormFieldsController ($element) {
    var $ctrl = this;

    angular.element($element).find("input").keypress(function (e) {
      if (e.which === 13) {
        angular.element(this).blur();
      }
    });

    angular.element($element).find("input").blur(function () {
      $ctrl.onBlur();
    });
  }

})();

/*eslint angular/di: [2,"array"]*/

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("mainPageButton", [
      "StateManagementService",
      "authenticationService",
      "$state",
      mainPageButton
    ]);

  /**
   * @param StateManagementService
   * @param authenticationService
   * @param $state
   * @ngInject
   * @return {{restrict: string, link: mainPageButtonLink}}
   */
  function mainPageButton(StateManagementService, authenticationService, $state) {
    /**
     * @type {{restrict: string, link: mainPageButtonLink}}
     */
    var directive = {
      restrict: "A",
      link: mainPageButtonLink
    };

    return directive;

    /**
     * @ngInject
     * @param scope
     * @param element
     */
    function mainPageButtonLink(scope, element) {
      element.bind("click", goToMainPage);

      function goToMainPage() {
        var statesDiff = StateManagementService.getDifferenceToMainPageStates();
        /**
         * If the backStack length is 1, that means that the user is going back to the initial position from where they entered
         * the app. So now we have to redirect the uses to their homepage depending on their role type
         * Reason for doing this is because if the user e.g visited setting page directly and they click on back button
         * the history api will take them to the browser page
         */
        if (StateManagementService.getBackStackLength() === 1) {
          StateManagementService.clearFromBottom(Math.max(statesDiff, 1));
          if (authenticationService.isAuthorized("BigFarmUser")) {
            $state.go("dashboard");
          } else {
            $state.go("insightsTimeline");
          }
        } else {
          StateManagementService.clearFromBottom(Math.max(statesDiff, 1));
          history.go(Math.max(statesDiff, 1) * -1);
          scope.$apply();
        }
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents").component("localSearch", {
    bindings: {
      filterFarms: "&"
    },
    controller: LocalSearchController,
    templateUrl: "app/shared-components/angular-ui-components/components/localSearch/localSearch.html"
  });

  function LocalSearchController() {

    this.searchStr = "";

    this.filterResult = function(searchString) {
      this.filterFarms({searchString: searchString});
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("loadingUdder", loadingUdder);

  /**
   * @return {{restrict: string, templateUrl: string, replace: boolean}}
   * @ngInject
   */
  function loadingUdder () {
    /**
     * @type {{restrict: string, templateUrl: string, replace: boolean}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-ui-components/components/loadingUdder/loadingUdder.html",
      replace: true
    };

    return directive;
  }
})();

(function() {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("loadingSpinner", loadingSpinner);

  /**
   * @return {{restrict: string, template: string, replace: boolean}}
   * @ngInject
   */
  function loadingSpinner() {
    /**
     * @type {{restrict: string, template: string, replace: boolean}}
     */
    var directive = {
      restrict: "E",
      template: ""+
        '<div class="sk-fading-circle">'+
          '<div class="sk-circle1 sk-circle"></div>'+
          '<div class="sk-circle2 sk-circle"></div>'+
          '<div class="sk-circle3 sk-circle"></div>'+
          '<div class="sk-circle4 sk-circle"></div>'+
          '<div class="sk-circle5 sk-circle"></div>'+
          '<div class="sk-circle6 sk-circle"></div>'+
          '<div class="sk-circle7 sk-circle"></div>'+
          '<div class="sk-circle8 sk-circle"></div>'+
          '<div class="sk-circle9 sk-circle"></div>'+
          '<div class="sk-circle10 sk-circle"></div>'+
          '<div class="sk-circle11 sk-circle"></div>'+
          '<div class="sk-circle12 sk-circle"></div>'+
        '</div>',
      replace: true
    };

    return directive;
  }
})();

(function() {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("loadingBar", loadingBar);

  /**
   * @return {{restrict: string, template: string, replace: boolean}}
   * @ngInject
   */
  function loadingBar() {
    /**
     * @type {{restrict: string, template: string, replace: boolean}}
     */
    var directive = {
      restrict: "E",
      template: "" +
        '<div class="sk-wave">' +
          '<div class="sk-rect sk-rect1"></div>' +
          '<div class="sk-rect sk-rect2"></div>' +
          '<div class="sk-rect sk-rect3"></div>' +
          '<div class="sk-rect sk-rect4"></div>' +
          '<div class="sk-rect sk-rect5"></div>' +
          '<div class="sk-rect sk-rect6"></div>' +
          '<div class="sk-rect sk-rect7"></div>' +
          '<div class="sk-rect sk-rect8"></div>' +
          '<div class="sk-rect sk-rect9"></div>' +
          '<div class="sk-rect sk-rect10"></div>' +
        '</div>',
      replace: true
    };

    return directive;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("loadingBottle", loadingBottle);

  /**
   * @return {{restrict: string, templateUrl: string, replace: boolean}}
   * @ngInject
   */
  function loadingBottle () {
    /**
     * @type {{restrict: string, templateUrl: string, replace: boolean}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-ui-components/components/loadingBottle/loadingBottle.html",
      replace: true
    };

    return directive;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .component("lastBreedingPicker", {
      templateUrl: "app/shared-components/angular-ui-components/components/lastBreedingPicker/lastBreedingPicker.html",
      controller: lastBreedingPickerController,
      bindings: {
        insight: "<",
        onDateChange: "<"
      }
    });

  /**
   * @ngInject
   * @param lodash
   * @param $translate
   */
  function lastBreedingPickerController (lodash, $translate) {
    var $ctrl = this;

    /**
     * Handle date change
     * @param lastInseminationEpoch
     */
    $ctrl.onChange = function (lastInseminationEpoch) {
      $ctrl.onDateChange($ctrl.insight, {
        lastInseminationEpoch: lastInseminationEpoch
      });
    };

    /**
     * Get widget header text
     * @return {string}
     */
    $ctrl.getHeaderText = function () {
      return $translate.instant("last-breeding-picker-title");
    };
  }

})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .component("lastEstrusPicker", {
      templateUrl: "app/shared-components/angular-ui-components/components/lastEstrusPicker/lastEstrusPicker.html",
      controller: lastEstrusPickerController,
      bindings: {
        insight: "<",
        onDateChange: "<"
      }
    });

  /**
   * @ngInject
   * @param lodash
   * @param $translate
   */
  function lastEstrusPickerController (lodash, $translate) {
    var $ctrl = this;

    /**
     * Handle date change
     * @param lastEstrusEpoch
     */
    $ctrl.onChange = function (lastEstrusEpoch) {
      $ctrl.onDateChange($ctrl.insight, {
        lastEstrusEpoch: lastEstrusEpoch
      });
    };

    /**
     * Get widget header text
     * @return {string}
     */
    $ctrl.getHeaderText = function () {
      return $translate.instant("last-estrus-picker-title");
    };
  }

})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.labels", [
      "ctraUIComponents.labels.labelsList",
      "ctraUIComponents.labels.newLabel",
      "ctraUIComponents.labels.editLabel"
    ]);
}());

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.labels")
    .component("labels", {
      bindings: {
        labels: "<"
      },
      templateUrl: "app/shared-components/angular-ui-components/components/labels/labels.html"
    });
}());

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular.module("ctraUIComponents.labels").service("labelService", labelService);

  /**
   * @ngInject
   * @param $q
   * @param $odata
   * @param $odataresource
   * @param $log
   * @param appConfig
   * @param sessionService
   * @param appSessionService
   * @param lodash
   * @param cowService
   * @param LocoService
   */
  function labelService(
    $q,
    $odata,
    $odataresource,
    $log,
    appConfig,
    sessionService,
    appSessionService,
    lodash,
    cowService,
    LocoService
  ) {
    this.getLabel = getLabel;
    this.getLabels = getLabels;
    this.newLabel = newLabel;
    this.updateLabel = updateLabel;
    this.saveLabel = saveLabel;
    this.getLabelBlueprint = getLabelBlueprint;
    this.makeUserTag = makeUserTag;

    /**
     * Label endpoint
     */
    var Label = $odataresource(
      appConfig.APIURL + "odata/GenericLabels",
      {},
      {},
      { odatakey: "GenericLabelID" }
    );

    /**
     * Group events
     * @type {{active: boolean, id: string, title: string, labelEventType: string}[]}
     */
    this.events = [
      { labelEventType: "group_event", id: "ration_change", title: "ration change", active: false },
      { labelEventType: "group_event", id: "heat_stress", title: "heat stress", active: false },
      {
        labelEventType: "group_event",
        id: "bad_accessibility_to_feed",
        title: "bad accessibility to feed",
        active: false
      },
      { labelEventType: "group_event", id: "bedding", title: "bedding", active: false },
      { labelEventType: "group_event", id: "management_change", title: "management change", active: false },
      { labelEventType: "group_event", id: "grazing_schedule", title: "grazing schedule", active: false },
      { labelEventType: "group_event", id: "feeding_schedule", title: "feeding schedule", active: false },
      { labelEventType: "group_event", id: "hoof_trimming", title: "hoof trimming", active: false }
    ];

    /**
     * Make a user label
     * @return {string}
     */
    function makeUserTag() {
      return "checked-by-" + sessionService.user.id;
    }

    /**
     * Add a tag to the given label
     */
    this.addTag = function (label, tag, options) {
      options = lodash.assign(
        {
          updateLabel: true
        },
        options || {}
      );

      var tags = lodash.compact([tag, tag === "checked" ? this.makeUserTag() : ""]);

      label.tags = lodash.uniq(lodash.concat(label.tags, tags));

      if (options.updateLabel) {
        return this.updateLabel(label);
      }
    }.bind(this);

    /**
     * Reemove a tag to the given label
     * @param {object} label
     * @param {array} tag
     * @param {object} options
     */
    this.removeTag = function (label, tag, options) {
      options = lodash.assign(
        {
          updateLabel: true
        },
        options || {}
      );

      var tags = lodash.compact([tag, tag === "checked" ? this.makeUserTag() : ""]);

      label.tags = lodash.difference(label.tags, tags);

      if (options.updateLabel) {
        return this.updateLabel(label);
      }
    }.bind(this);

    /**
     * Get label by ID
     * @param genericLabelID
     * @return {*}
     */
    function getLabel(genericLabelID) {
      var deferred = $q.defer();

      genericLabelID = parseInt(genericLabelID) || null;

      Label.odata()
        .filter("GenericLabelID", genericLabelID)
        .single()
        .$promise.then(
          function (value) {
            value = processLabel(value);
            deferred.resolve(value);
          },
          function (error) {
            deferred.reject(error);
          }
        );

      $log.info("Fetching Label from the database", genericLabelID);

      return deferred.promise;
    }

    /**
     * Get filtered labels
     * @param farmID
     * @param limit
     * @param offset
     * @param options
     * @param countOnly
     * @return {*}
     */
    function getLabels(farmID, limit, offset, options, countOnly) {
      var deferred = $q.defer();

      /**
       * @type {boolean}
       */
      var isAdmin = sessionService.userRoles.indexOf("Admin") > -1;

      var query = Label.odata().expand("dairyCow");

      if (!isAdmin) {
        query.filter("customerVisible", true);
      }

      if (farmID) {
        query.filter("farmID", farmID);
      }

      if (offset) {
        query.skip(offset);
      }

      if (limit) {
        query.take(limit);
      }

      if (options.orderBy) {
        query.orderBy(options.orderBy.variable, options.orderBy.direction);
      } else {
        query.orderBy("endEpoch", "desc");
      }

      if (options.tag && !options.notTagged) {
        query.filter(new $odata.Func("contains", "tags", options.tag), true);
      }

      if (options.notTagged && !options.tag) {
        var predicate1 = new $odata.Predicate(new $odata.Func("contains", "tags", options.notTagged), false);
        var predicate2 = new $odata.Predicate("tags", null);

        query.filter($odata.Predicate.or([predicate1, predicate2]));
      }

      if (options.tag && options.notTagged) {
        var predicate3 = new $odata.Predicate(new $odata.Func("contains", "tags", options.notTagged), false);
        var predicate4 = new $odata.Predicate(new $odata.Func("contains", "tags", options.tag), true);

        var combination2 = $odata.Predicate.and([predicate3, predicate4]);
        query.filter(combination2);
      }

      if (options.tags) {
        var predicates = [];
        angular.forEach(options.tags, function (tag) {
          predicates.push(new $odata.Predicate(new $odata.Func("contains", "tags", tag), true));
        });

        var combination = $odata.Predicate.and(predicates);
        query.filter(combination);
      }

      if (options.title) {
        query.filter(new $odata.Func("contains", "title", options.title));
      }

      if (options.category) {
        query.filter("category", options.category);
      }

      $log.info(
        "Fetching Labels from the database, farmID: " +
          (farmID ? farmID : "not set") +
          " limit: " +
          limit +
          ", offset: " +
          offset
      );

      if (countOnly) {
        query.count().$promise.then(
          function (value) {
            deferred.resolve(value.result);
          },
          function (error) {
            deferred.reject(error);
          }
        );
      } else {
        query.query().$promise.then(
          function (value) {
            value = processLabels(value);
            deferred.resolve(value);
          },
          function (error) {
            deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    /**
     * Create new label
     * @param details
     * @return {*}
     */
    function newLabel(details) {
      var label = new Label();

      /**
       * @type {Date}
       */
      var now = new Date();

      angular.forEach(
        details,
        function (value, key) {
          this[key] = value;
        },
        label
      );

      /**
       * @type {number}
       */
      label.createdEpoch = label.createdEpoch || parseInt(now / 1000);

      return label;
    }

    /**
     * Get a label blueprint: current farm, current user, basic data filled in.
     * @param category
     * @param title
     * @param scope
     */
    function getLabelBlueprint(category, title, scope) {
      return {
        farmID: appSessionService.farmID,
        category: category,
        title: title,
        labelScope: scope,
        createdByUserID: sessionService.user.id,
        customerVisible: false,
        /**
         * TODO maybe add this to params as well
         */
        tags: angular.toJson(["curated"]),
        /**
         * Set these ones yourself
         */
        dairyCowID: null,
        endEpoch: null,
        startEpoch: null,
        createdEpoch: null
      };
    }

    /**
     * Update label
     * @param label
     * @return {Promise<any>}
     */
    function updateLabel(label) {
      return prepLabelForOdata(label).then(function (cleanLabel) {
        cleanLabel.$update();
      });
    }

    /**
     * Save label
     * @param label
     * @return {Promise<any>}
     */
    function saveLabel(label) {
      return prepLabelForOdata(label).then(function (cleanLabel) {
        cleanLabel.$save();
      });
    }

    /**
     * Fix farm reference, if for any reason
     * the label is created for a cow which is in another farm
     * @return {Promise<any>}
     */
    function fixFarmReference(label) {
      var dfd = $q.defer();

      if (label.labelScope === "cow") {
        cowService.getCow(label.dairyCowID).then(function (cow) {
          if (label.farmID !== cow.farmID) {
            label.farmID = cow.farmID;
          }

          dfd.resolve(label);
        });
      } else {
        dfd.resolve(label);
      }

      return dfd.promise;
    }

    /**
     * Prepare label for oData call
     * @param label
     * @return {Promise<any>}
     */
    function prepLabelForOdata(label) {
      return fixFarmReference(label).then(
        function (fixedLabel) {
          var labelClone = angular.copy(fixedLabel);

          /**
           * HACK: the backend does not like it when the object has linked objects inside
           */
          delete labelClone.dairyCow;
          delete labelClone.duration;

          /**
           * @type {string}
           */
          labelClone.tags = angular.toJson(labelClone.tags);

          if (angular.isObject(labelClone.description)) {
            labelClone.description = angular.toJson(labelClone.description);
          }

          return labelClone;
        }
      );
    }

    /**
     * Process labels
     * @param input
     * @return {*}
     */
    function processLabels(input) {
      if (angular.isArray(input)) {
        angular.forEach(input, function (label) {
          processLabel(label);
        });
      } else if (angular.isObject(input)) {
        input = processLabel(input);
      }

      return input;
    }

    /**
     * Process single label
     * @param label
     * @return {*}
     */
    function processLabel(label) {
      /**
       * @type {[]}
       */

      label.tags = angular.fromJson(label.tags) || [];

      if (label.description && label.description[0] === "{") {
        label.description = angular.fromJson(label.description) || {};
      }

      return label;
    }

    /**
     * Translate group labels
     * @param label
     * @return {string}
     * @private
     */
    function _translatefeedGroupLabel(label) {
      var eventIds = lodash.split(label, ",");

      var translateEventIdsArray = eventIds.reduce(
        function (translateEventIdsArray, eventId) {
          /**
           * Translate the event if it's present in the array and if it is not present
           * then that means they were custom events and we just replace the _ from them
           */
          if (lodash.find(this.events, { id: eventId })) {
            translateEventIdsArray.push(LocoService.translate(eventId));
          } else {
            translateEventIdsArray.push(eventId.replace(/_/g, " "));
          }

          return translateEventIdsArray;
        }.bind(this),
        []
      );

      return translateEventIdsArray.join(", ");
    }

    /**
     * Translate label title
     * @param label
     * @return {string}
     */
    this.translateLabelTitle = function (label) {
      var title = "";

      if (label.category === "feed" && label.labelScope === "herd") {
        title = _translatefeedGroupLabel.call(this, label.title);
      } else {
        title = LocoService.translate(label.title);
      }

      return title;
    }.bind(this);
  }
})();

(function () {
  "use strict";

  /**
   * Validation values.
   * @type {{yes: string, no: string, noAnswer: string}}
   */
  var VALIDATION = {
    yes: "Yes",
    no: "No",
    maybe: "Maybe",
    noAnswer: "NA"
  };

  angular
    .module("ctraUIComponents.insight", [
      "ui.router",
      "ctraAuthentication",
      "ctraDataVisualisations",
      "ctraDataVisualisations.dataVariables",
      "ctraDataVisualisations.dataVisualisation",
      "ctraUIComponents.insight.adminInsightValidations",
      "ctraUIComponents.insight.insightAdminDetails",
      "ctraUIComponents.insight.insightChecks",
      "ctraUIComponents.insight.insightValidation",
      "ctraUIComponents.insight.insightRibbon",
      "ctraUIComponents.insight.legacyValidationQuestion",
      "ctraUIComponents.insight.muteRepeatOffender",
      "ctraUIComponents.insight.muteRepeatOffenderModal",
      "ctraUIComponents.insight.insightInsemination",
      "ctraUIComponents.insight.insightResolution",
      "ctraUIComponents.insight.insightResolutionModal",
      "ctraUIComponents.insight.insightResolutionTitle",
      "ctraUIComponents.insight.cowDetailsBar"
    ])
    .constant("VALIDATION", VALIDATION);
}());

(function () {
  "use strict";

  angular.module("ctraUIComponents.insight").component("insight", {
    bindings: {
      insight: "<"
    },
    controller: insightCtrl,
    templateUrl: "app/shared-components/angular-ui-components/components/insight/insight.html"
  });

  /**
   * @param $window
   * @param $rootScope
   * @param $scope
   * @param $q
   * @param $timeout
   * @param $state
   * @param sessionService
   * @param authenticationService
   * @param $translate
   * @param toastr
   * @param dataVariablesService
   * @param pageTransitionService
   * @param insightService
   * @param cowService
   * @param dateTimeService
   * @param VALIDATION
   * @param lodash
   * @param localStorageService
   * @param appSessionService
   * @param doNotBreedService
   * @param GenericInsightService
   * @param SharingService
   * @param moment
   * @ngInject
   */
  function insightCtrl(
    $window,
    $rootScope,
    $scope,
    $q,
    $timeout,
    $state,
    sessionService,
    authenticationService,
    $translate,
    toastr,
    dataVariablesService,
    pageTransitionService,
    insightService,
    cowService,
    dateTimeService,
    VALIDATION,
    lodash,
    localStorageService,
    appSessionService,
    doNotBreedService,
    GenericInsightService,
    SharingService,
    moment
  ) {
    var $ctrl = this;

    var INSIGHTS_CATEGORY = "insights category";
    var INSIGHT_ARGS = "insight arguments";
    var ST_LOADED_INSIGHTS = "insights collection";

    $ctrl.$onInit = onInit;
    $ctrl.onDateChange = onDateChange;
    $ctrl.onInsightClicked = onInsightClicked;
    $ctrl.updateInsightValidation = updateInsightValidation;
    $ctrl.updateInsightResolution = updateInsightResolution;
    $ctrl.mayHelpDiagnose = mayHelpDiagnose;
    $ctrl.handleUnmute = handleUnmute;
    $ctrl.getRibbonText = getRibbonText;
    $ctrl.isMuted = isMuted;
    $ctrl.getShareData = lodash.memoize(getShareData);
    $ctrl.getSires = getSires;

    $ctrl.setLoadingGraphs = setLoadingGraphs;

    $ctrl.getInsightTitle = GenericInsightService.getTranslatedTitle;
    $ctrl.getInsightDescription = GenericInsightService.getTranslatedDescription;
    $ctrl.isDysonEnabled = doNotBreedService.isDysonEnabled;
    $ctrl.resolvedAsDNB = doNotBreedService.resolvedAsDNB;

    $ctrl.updateInsight = insightService.updateInsight;
    $ctrl.isAuthorized = authenticationService.isAuthorized;
    $ctrl.isEstrusInsight = insightService.isEstrusInsight;
    $ctrl.resolveFMS = GenericInsightService.resolveFMSFromValidation;

    $ctrl.updateInsemination = updateInsemination;
    $ctrl.hideResolutionModal = hideResolutionModal;
    $ctrl.insightsIdList = localStorageService.get(ST_LOADED_INSIGHTS) || [];

    $ctrl.currentInsightId = 0;

    /**
     * Get farm name and default to NULL when we are in admin
     */
    $ctrl.farmName = lodash.get(appSessionService, ["farm", "farmName"], null);

    /**
     * Text content
     * @type {{diagnoseButton: string, diagnoseContent: string, inseminationQuestion: string,
     * calvingQuestion: string, dnbWarning: string, diagnoseHeader: string}}
     */
    $ctrl.copy = {
      diagnoseHeader: "I can help you diagnose the cow!",
      diagnoseContent:
        "By answering a few questions, I can help you find the most likely health problem of this cow.",
      diagnoseButton: "Start diagnosis",
      calvingQuestion: "Is the cow now calving or has calved in the last 24 hours",
      inseminationQuestion: "Have you inseminated this cow?",
      dnbWarning: doNotBreedService.copy.insightDysonEnabledWarning,
      sireSelection: "insight-context-sire-selection"
    };

    /**
     * options that might have to be pass to the resolution component
     * @TODO: this should be in a health insight detail page component but because we don't have a separate health insight
     *         detail page, so we have to add it over here
     * @type {{}}
     */
    $ctrl.insightResolutionOptions = {};

    /**
     * opions that we need to pass to the cow detail bar
     * @TODO: this should also be in health insight detail page component but because we don't have a separate
     *        component we have to do this
     * @type {{}}
     */
    $ctrl.cowDetailBarOptions = {};

    /**
     * Reject Dyson resolutions
     * @param {[]} insightResolutions
     * @return {[]}
     */
    this.rejectDysonResolutions = function (insightResolutions) {
      return lodash.reject(insightResolutions, ["source", "dyson"]);
    };

    /**
     * Tell if the insight is resolved
     * @return {boolean}
     */
    this.isResolved = function () {
      var count = this.rejectDysonResolutions(this.insight.insightResolution).length;

      if (this.resolveFMS(this.insight)) {
        count = !!this.insight.insightResolution.length;
      }

      return !!count;
    };

    /**
     * Get sire/bull info
     * @return {string|null}
     */
    function getSires() {
      var sireData = GenericInsightService.getContext($ctrl.insight).selectedSires;
      var sires = lodash.map(sireData ? angular.fromJson(sireData) : [], "code");

      return sires.length ? sires.join(", ") : null;
    }

    /**
     * Tell whether the diagnostic tool shall be visible.
     * @returns {boolean}
     */
    function mayHelpDiagnose() {
      /**
       * Diagnosis tool shall show only if the insight is not yet validated or the answer is "maybe".
       * @type {boolean}
       */
      var validationPass =
        [VALIDATION.maybe, VALIDATION.noAnswer]
          .map(lodash.lowerCase)
          .indexOf($ctrl.insight.insightValid.toLowerCase()) > -1;

      /**
       * Show diagnosis tool only for cow-lever insights.
       * @type {boolean}
       */
      var insightTypePass = $ctrl.insight.insightScope === "cow";

      /**
       * Not for fertility and system
       * @type {boolean}
       */
      var categoryPasss = ["fertility", "system"].indexOf($ctrl.insight.insightType.insightCategory) === -1;

      /**
       * Not for Lucina
       * @type {boolean}
       */
      var typeNamePass = ["Lucina"].indexOf($ctrl.insight.insightType.typeName) === -1;

      return insightTypePass && validationPass && categoryPasss && typeNamePass;
    }

    /**
     * Init
     */
    function onInit() {
      $rootScope.bodyClass += " insight-" + $ctrl.insight.insightType.insightCategory;
      $ctrl.currentInsightId = $ctrl.insight.GenericInsightID;

      $ctrl.notInseminateTitle = "Why did you not inseminate #{{ cowTagNumber }}?";

      if (appSessionService.farmID) {
        initNavigation();
      }

      initCharts();
      markInsightAsRead();
      updateInsightOptions();
    }

    function updateInsightOptions() {
      /**
       * In case of Lucina we need to show only those resolutions that have a insightType key assigned to them
       * @type {boolean}
       */
      if (["Lucina"].indexOf($ctrl.insight.insightType.typeName) !== -1) {
        $ctrl.insightResolutionOptions = {
          onlyIncludeInsightWithTypeName: true
        };

        $ctrl.cowDetailBarOptions = {
          showLastEstrus: false
        };
      }
    }

    /**
     * Callback for whenever new insights have loaded when you reach the last insight in current
     * insightsIdList
     *
     * @param data - insights returned as a result of promise
     */

    function onInsightsLoaded(data) {
      var category = localStorageService.get(INSIGHTS_CATEGORY) || "";

      if (category === "inseminations" || category === "timeline") {
        data = filterNonBreedableCows(data);
      } else if (category === "farm/health") {
        var isCurrentInsightResolved = insightService.isResolved($ctrl.insight);

        if (isCurrentInsightResolved) {
          data = data.filter(insightService.isResolved);
        } else {
          var resolvedItems = data.filter(insightService.isResolved);
          data = data.filter(function (element) {
            return !resolvedItems.includes(element);
          });
        }
      }

      /**
       * @type {[]}
       */
      var newCollections = insightService.getInsightCollections(data);
      var prevIdArrayLength = $ctrl.insightsIdList.length;

      $ctrl.insightCollections = newCollections;

      angular.forEach($ctrl.insightCollections, function (insightCollection) {
        angular.forEach(insightCollection.insights, function (insight) {
          $ctrl.insightsIdList.push(insight.GenericInsightID);
        });
      });

      /**
       * Bug fix for : next arrow disappears on insight page if you jump directly to
       * an insight that is last in the list. Now, as soon as the promise is resolved,
       * the nextInsightID is also updated
       */

      $ctrl.insightsIdList = Array.from(new Set($ctrl.insightsIdList));

      $ctrl.nextInsightID = $ctrl.insightsIdList[prevIdArrayLength];
      localStorageService.set(ST_LOADED_INSIGHTS, $ctrl.insightsIdList);

      if ($ctrl.nextInsightID) {
        fetchNextInsight();
      }
    }

    function filterNonBreedableCows(data) {
      return data.filter(function (element) {
        return !(
          element.dairyCow &&
          element.dairyCow.doNotBreed &&
          insightService.CULLED_TYPE_BLACK_LIST.includes(element.insightType.typeName.toLowerCase())
        );
      });
    }

    /**
     * Get next insightId in the list. If the current ID is the last item in the current list, then load next 20
     * insights inside a promise.
     *
     * @param insightID - Current insight ID
     */
    function getNextInsightID(insightID) {
      /**
       * @type {integer}
       */
      var currentIdx = $ctrl.insightsIdList.lastIndexOf(insightID);
      var nextIdx = 0;

      /**
       * Last index in the current list. Get next 20 insightIDs
       */
      if (currentIdx >= $ctrl.insightsIdList.length - 1) {
        nextIdx = currentIdx + 1;

        var insightsCategory = localStorageService.get(INSIGHTS_CATEGORY);
        var query = angular.fromJson(localStorageService.get(INSIGHT_ARGS));

        var insightsPerPage = 20;
        var insightsOffset = $ctrl.insightsIdList.length;

        if (insightsCategory === "timeline") {
          // account for filtered items?????
          insightService
            .getGenericInsights(appSessionService.farm.FarmID, query, null, insightsPerPage, insightsOffset)
            .then(onInsightsLoaded)
            .catch(function () {
              nextIdx = null;
            });
        } else if (insightsCategory === "farm/health") {
          insightService
            .getGenericInsightsTodos(
              appSessionService.farm.FarmID,
              query,
              false,
              insightsPerPage,
              insightsOffset
            )
            .then(onInsightsLoaded)
            .catch(function () {
              nextIdx = null;
            });
        } else if (insightsCategory === "inseminations" || insightsCategory === "calvings") {
          // account for filtered items?????
          insightService
            .getGenericInsightsTodos(
              appSessionService.farm.FarmID,
              query,
              false,
              insightsPerPage,
              insightsOffset,
              { includeStaleInsights: true }
            )
            .then(onInsightsLoaded)
            .catch(function () {
              nextIdx = null;
            });
        }
      } else {
        nextIdx = currentIdx + 1;
      }

      return $ctrl.insightsIdList[nextIdx];
    }

    /**
     * Get previous Insight ID in the list
     *
     * @param insightID - Current insight ID
     */
    function getPrevInsightID(insightID) {
      /**
       * @type {number}
       */
      var currentIdx = $ctrl.insightsIdList.indexOf(insightID);
      var prevIdx = 0;

      if (currentIdx == 0) {
        prevIdx = null;
      } else {
        prevIdx = currentIdx - 1;
      }

      return $ctrl.insightsIdList[prevIdx];
    }

    /**
     * Initialise the prev-next navigation
     */
    function initNavigation() {
      insightService.getGenericInsight(getPrevInsightID($ctrl.currentInsightId)).then(function (prev) {
        $ctrl.previousInsightID = prev.GenericInsightID;
      });

      fetchNextInsight();
    }

    function fetchNextInsight() {
      var nextInsightId = getNextInsightID($ctrl.currentInsightId);

      if (nextInsightId) {
        insightService.getGenericInsight(nextInsightId).then(function (next) {
          $ctrl.nextInsightID = next.GenericInsightID;
        });
      }
    }

    /**
     * Init charts
     */
    function initCharts() {
      $ctrl.activityValues = [];

      /**
       * @type {{allCowsOfFarm, cow, farm, herdGroup: *}}
       */
      var subjects = {
        allCowsOfFarm: $ctrl.insight.farmID,
        cow: $ctrl.insight.dairyCowID,
        farm: $ctrl.insight.farmID,
        herdGroup: $ctrl.insight.herdGroupID
      };

      dataVariablesService
        .getInsightVisualisations($ctrl.insight.insightScope, $ctrl.insight.insightType.typeName, subjects)
        .then(function (visualisations) {
          $ctrl.visualisations = visualisations;

          /**
           * @type {number}
           */
          $ctrl.centerEpoch =
            $ctrl.insight.startEpoch + ($ctrl.insight.endEpoch - $ctrl.insight.startEpoch) / 2;

          /**
           * @type {Date}
           */
          $ctrl.centerDate = new Date($ctrl.centerEpoch * 1000);

          /**
           * @type {Date}
           */
          $ctrl.startDate = new Date($ctrl.centerEpoch * 1000);

          /**
           * @type {Date}
           */
          $ctrl.endDate = new Date($ctrl.centerEpoch * 1000);

          /**
           * Make sure there is at least one day between start and end
           */
          var radius = Math.max($ctrl.visualisations.dayRange - 1, 1);

          if (daysSince($ctrl.centerDate) > $ctrl.visualisations.dayRange / 2) {
            // Add and subtract 1/2 of the dayRange
            $ctrl.startDate = moment($ctrl.centerDate)
              .subtract((radius / 2) * 24, "hours")
              .toDate();
            $ctrl.endDate = moment($ctrl.centerDate)
              .add((radius / 2) * 24, "hours")
              .toDate();
          } else {
            $ctrl.startDate = new Date();
            $ctrl.endDate = new Date();
            $ctrl.startDate.setDate($ctrl.startDate.getDate() - radius);
            $ctrl.endDate.setDate($ctrl.endDate.getDate());
          }

          /**
           * @type {Date}
           */
          $ctrl.maxDate = new Date();
          $ctrl.maxDate.setHours(23, 59, 59, 99);
          $ctrl.maxDate.setDate($ctrl.maxDate.getDate() + ($ctrl.visualisations.dayRange - 1) / 2);

          /**
           * @type {Date}
           */
          $ctrl.eod = new Date();
          $ctrl.eod.setHours(23, 59, 59, 99);
        });

      /**
       * @type {Date}
       */
      $ctrl.insightDate = new Date($ctrl.insight.insightStartEpoch * 1000);
    }

    /**
     * Handle date change
     * @param startDate
     * @param endDate
     * @param dayRange
     */
    function onDateChange(startDate, endDate, dayRange) {
      if (endDate.getTime() > $ctrl.maxDate.getTime()) {
        $ctrl.endDate.setDate($ctrl.maxDate.getDate());
        $ctrl.endDate.setHours(23, 59, 59, 99);
        $ctrl.startDate.setDate($ctrl.endDate.getDate() - ($ctrl.visualisations.dayRange - 1));
      } else {
        $ctrl.startDate = startDate;
        $ctrl.endDate = endDate;
      }

      $ctrl.visualisations.dayRange = dayRange || $ctrl.visualisations.dayRange;
      $scope.$apply();
    }

    /**
     * Handle insight checked
     * @param insight
     */
    function onInsightClicked(insight) {
      pageTransitionService.goForward();

      if (insight.GenericInsightID) {
        $state.go("insight", { genericInsightID: insight.GenericInsightID });
      }

      if (insight.GenericLabelID) {
        $state.go("label", { genericLabelID: insight.GenericLabelID });
      }
    }

    /**
     * Update insight resolution
     * @param insightResolution
     */
    function updateInsightResolution(insightResolution) {
      $ctrl.insight.insightResolution = insightResolution;
      insightService.updateInsightResolution($ctrl.insight);

      /**
       * Tell whether the DNB is applied
       */
      var dnbValue = doNotBreedService.resolvedAsDNB($ctrl.insight);

      doNotBreedService.setDNB($ctrl.insight.dairyCowID, dnbValue);
    }

    /**
     * U[date insight validation
     * @param insightValid
     */
    function updateInsightValidation(insightValid) {
      $ctrl.insight.insightValid = insightValid;
    }

    /**
     * Mark insight as read
     */
    function markInsightAsRead() {
      if (!$ctrl.insight.seenByUserIds) {
        $ctrl.insight.seenByUserIds = "";
      }

      if ($ctrl.insight.seenByUserIds.indexOf(sessionService.user.id) === -1) {
        /**
         * @type {string}
         */
        var userId =
          $ctrl.insight.seenByUserId === "" ? sessionService.user.id : sessionService.user.id + ",";

        $ctrl.insight.seenByUserIds += userId;
        insightService.updateInsight($ctrl.insight);
      }
    }

    /**
     * Days since the given date
     * @param date
     * @return {number}
     */
    function daysSince(date) {
      /**
       * @type {Date}
       */
      var dateNow = new Date();

      // The number of milliseconds in one day
      var ONE_DAY = 1000 * 60 * 60 * 24;

      // Convert both dates to milliseconds
      var date_ms = date.getTime();
      var dateNow_ms = dateNow.getTime();

      // Calculate the difference in milliseconds
      var difference_ms = Math.abs(date_ms - dateNow_ms);

      // Convert back to days and return
      return Math.floor(difference_ms / ONE_DAY);
    }

    /**
     * Update insesmination
     * @param insight
     */
    function updateInsemination(insight) {
      $ctrl.insight = insight;

      if (insight.inseminated === false) {
        showResolutionModal(insight);
      }
    }

    /**
     * Show resolution modal
     */
    function showResolutionModal() {
      $ctrl.resolutionModalVisible = true;
    }

    /**
     * Hide resolution modal
     */
    function hideResolutionModal() {
      $ctrl.resolutionModalVisible = false;
      $ctrl.currentInsight = null;
    }

    /**
     * Get ribbon text
     * @return {string}
     */
    function getRibbonText() {
      /**
       * @type {string}
       */
      var tpl = "REPEAT_OFFENDER_RIBBON_TEXT";

      /**
       * @type {{}}
       */
      var insightType = $ctrl.insight.insightType;

      /**
       * @type {string}
       */
      var category = insightType.insightCategory;

      /**
       * @type {{}}
       */
      var cow = $ctrl.insight.dairyCow;

      /**
       * @type {number}
       */
      var cowTagNumber = cow.cowTagNumber;

      /**
       * @type {number}
       */
      var endEpoch = cowService.isMuted(cow, insightType.InsightTypeID).MutedUntilEpoch;

      /**
       * @type {string}
       */
      var until = dateTimeService.until(endEpoch, $translate);

      /**
       * Translate eg. "2 days"
       * @type {string|Object}
       */
      var translatedUntil = $translate.instant(until.tpl, {
        count: until.count
      });

      return lodash.upperFirst(
        $translate.instant(tpl, {
          category: category,
          cowTagNumber: cowTagNumber,
          until: translatedUntil
        })
      );
    }

    /**
     * Tell whether the cow is not muted.
     * @return {boolean}
     */
    function isMuted() {
      /**
       * @type {{}}
       */
      var cow = $ctrl.insight.dairyCow;

      /**
       * @type {number}
       */
      var insightTypeId = $ctrl.insight.insightType.InsightTypeID;

      return !!cowService.isMuted(cow, insightTypeId);
    }

    /**
     * Handle unmuting the insight for the cow
     */
    function handleUnmute() {
      /**
       * @type {{}}
       */
      var cow = $ctrl.insight.dairyCow;

      /**
       * @type {number}
       */
      var insightTypeId = $ctrl.insight.insightType.InsightTypeID;

      cowService.unmute(cow, insightTypeId);
    }

    /**
     * Set the graphs loading state
     * @param {boolean} loading
     */
    function setLoadingGraphs(loading) {
      $ctrl.loadingGraphs = loading;
    }

    /**
     * create payload for share button component
     * @return {{id: number, farmID: string, type: number}}
     */
    function getShareData() {
      var insight = $ctrl.insight;

      return {
        id: insight.GenericInsightID,
        type: SharingService.getInsightType(insight),
        farmID: appSessionService.farm.FarmID
      };
    }
  }
})();

/* global $:false */
/* eslint-disable angular/angularelement */
/* eslint-disable angular/controller-as-vm */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("farmDetailsFormFields", farmDetailsFormFields);

  /**
   * @return {{restrict: string, templateUrl: string, controller: farmDetailsFormFieldsController,
   * replace: boolean, scope: {farm: string, onBlur: string}}}
   * @ngInject
   */
  function farmDetailsFormFields () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: farmDetailsFormFieldsController,
     * replace: boolean, scope: {farm: string, onBlur: string}}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-ui-components/components/farmDetailsFormFields/farmDetailsFormFields.html",
      controller: farmDetailsFormFieldsController,
      replace: true,
      scope: {
        farm: "=",
        onBlur: "&"
      }
    };

    return directive;

    /**
     * @param $scope
     * @param $element
     * @ngInject
     */
    function farmDetailsFormFieldsController ($scope, $element) {
      var vm = $scope;

      $($element).find("input, textarea").keypress(function (e) {
        if (e.which === 13) {
          $(this).blur();
        }
      });

      $($element).find("input, textarea").blur(vm.onBlur);
      $($element).find("select").change(vm.onBlur);
    }
  }
})();

/* eslint-disable angular/di */

(function () {
  "use strict";

  angular
    .module("ctraDataVisualisations")
    .directive("elastic", [
      "$timeout",

      /**
       * @param $timeout
       * @return {{restrict: string, link: elastic.link}}
       */
      function ($timeout) {
        return {
          restrict: "A",

          /**
           * @param $scope
           * @param element
           */
          link: function ($scope, element) {
            $scope.initialHeight = $scope.initialHeight || element[0].style.height;

            var resize = function () {
              element[0].style.height = $scope.initialHeight;
              element[0].style.height = "" + element[0].scrollHeight + "px";
            };

            element.on("input change", resize);
            $timeout(resize, 0);
          }
        };
      }
    ]);
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .component("sliderGroup", {
      bindings: {
        config: "<",
        values: "="
      },
      controller: SliderGroupController,
      templateUrl: "app/shared-components/angular-ui-components/components/fancySlider/sliderGroup.html"
    });

  /**
   *
   * @constructor
   * @ngInject
   */
  function SliderGroupController (lodash) {
    var $ctrl = this;

    /**
     * Default slider options.
     * @type {{linking: {}, sliders: Array, options: {floor: number, ceil: number, step: number}}}
     */
    var defaults = {
      /**
       * Link individual sliders and set a maximum total value.
       * @property {boolean} enabled
       * @property {number} max
       */
      linking: {
        /* enabled, max */
      },

      /**
       * All sliders must have an id.
       * @property {string} id
       * @property {string} label
       */
      sliders: [
        /* { id, label } */
      ],

      /**
       * Slider options.
       * @see http://angular-slider.github.io/angularjs-slider/index.html
       */
      options: {
        ceil: 100,
        floor: 0,
        step: 1,
        showSelectionBar: true
      }
    };

    /**
     * Get a reduction value.
     * @param buffer
     * @param sharedBetween
     * @returns {number}
     */
    function getReduction (buffer, sharedBetween) {
      return Math.ceil(buffer / (sharedBetween - 1));
    }

    /**
     * Get the total from a value object.
     * @param valueObject
     * @returns {number}
     */
    function getTotal (valueObject) {
      return lodash.reduce(lodash.values(valueObject), function (result, value) {
        return result + value;
      }, 0)
    }

    /**
     * Creates ordered key-value pairs from the value object.
     * @param valueObject
     * @returns {[]}
     */
    function createOrderedPairs (valueObject) {
      return lodash.toPairs(valueObject).sort(function (a, b) {
        return a[1] > b[1];
      })
    }

    /**
     * Get previous values.
     * @returns {*}
     */
    function getPreviousValues () {
      return $ctrl.previousValues;
    }

    /**
     * Set previous values.
     * @param values
     * @returns {*}
     */
    function setPreviousValues (values) {
      return $ctrl.previousValues = lodash.assign({}, values);
    }

    /**
     * Change linked values.
     * @param id
     */
    function changeLinked (id) {
      var previousValues = getPreviousValues();
      var currentValues = $ctrl.values;

      /**
       * Change from the previous value.
       * @type {number}
       */
      var delta = currentValues[id] - previousValues[id];

      /**
       * The total of all the values.
       * @type {number}
       */
      var total = getTotal(currentValues);

      if (delta > 0 && total > $ctrl.config.linking.max) {
        /**
         * Convert currentValues to Array and sort by value. Reduce the smallest values first.
         * @type {any[]}
         */
        var orderedValues = createOrderedPairs(currentValues);

        /**
         * The remaining amount to share between sliders.
         * @type {number}
         */
        var buffer = delta;

        /**
         * Ideal reduction value.
         * @type {number}
         */
        var reduction = getReduction(buffer, orderedValues.length);

        /**
         * Decrease the values.
         * @type {any[]}
         */
        var newValues = orderedValues.map(function (keyValuePair, idx) {
          var result;

          /** @type {string} */
          var key = lodash.first(keyValuePair);

          /** @type {number} */
          var value = lodash.last(keyValuePair);

          /** Do not touch the one we just changed. */
          if (key === id) {
            result = keyValuePair;
            reduction = getReduction(buffer, orderedValues.length - idx);
          }
          /** Reduce to 0, keep the rest in buffer and recalculate reduction. */
          else if (value < reduction) {
            result = [key, 0];
            buffer -= value;
            reduction = getReduction(buffer, orderedValues.length - idx);
          }
          /** Reduce with reduction, update buffer. */
          else {
            result = [key, value - reduction];
            buffer -= reduction;
          }

          return result;
        });

        $ctrl.values = lodash.fromPairs(newValues);
        setPreviousValues($ctrl.values);
      }
    }

    /**
     * Initialise.
     * @memberOf SliderGroupController
     */
    $ctrl.$onInit = function () {
      /** Extend default config with the one from props. */
      var config = lodash.merge({}, defaults, $ctrl.config);

      /** Memoize values. */
      setPreviousValues($ctrl.values);

      /**
       * Add options to individual sliders.
       * @memberOf SliderGroupController
       * @type {*|Array|*[]}
       */
      $ctrl.sliders = config.sliders.map(function (slider) {
        var sliderConfig = lodash.assign({}, config.options);

        /**
         * Interlink values if applicable.
         * @type {changeLinked}
         */
        sliderConfig.onEnd = config.linking.enabled ? changeLinked : lodash.noop;

        /**
         * Assign options.
         */
        slider.options = lodash.assign(sliderConfig, lodash.pick(slider, "id"));

        return slider;
      });
    }
  }

})();

(function () {

  "use strict";

  angular
    .module("ctraUIComponents")
    .component("dryOffFormFields", {
      templateUrl: "app/shared-components/angular-ui-components/components/dryOffFormFields/dryOffFormFields.html",
      controller: dryOffFormFieldsController,
      bindings: {
        farm: "=",
        onBlur: "<"
      }
    });

  /**
   * @ngInject
   * @param $element
   */
  function dryOffFormFieldsController ($element) {
    var $ctrl = this;

    angular.element($element).find("input").keypress(function (e) {
      if (e.which === 13) {
        angular.element(this).blur();
      }
    });

    angular.element($element).find("input").blur(function () {
      $ctrl.onBlur();
    });
  }

})();

(function () {
  "use strict";

  angular.module("ctraUIComponents").component("dateTimeWidget", {
    bindings: {
      dateTime: "<",
      onDateTimeChange: "&",
      widgetDisabled: "<"
    },
    controller: DateTimeWidgetController,
    templateUrl:
      "app/shared-components/angular-ui-components/components/" + "dateTimeWidget/dateTimeWidget.html"
  });

  /**
   * @ngInject
   * @param moment
   * @param LocoService
   * @param lodash
   * @param dateTimeService
   * @return {DateTimeWidgetController}
   */
  function DateTimeWidgetController(moment, LocoService, lodash, dateTimeService) {
    this.today = dateTimeService.midnight();
    this.date = null;
    this.time = null;
    this.disabled = false;

    this.$onInit = function () {
      this.intializeValues();
    };

    this.$onChanges = function () {
      this.intializeValues();
    };

    /**
     * Initalize the values
     */
    this.intializeValues = function () {
      if (this.widgetDisabled) {
        this.disabled = this.widgetDisabled;
      } else if (this.dateTime) {
        this.time = new Date(this.dateTime * 1000);
        this.date = new Date(this.dateTime * 1000);
        this.disabled = false;
      }
    }.bind(this);

    /**
     * submit date time entered by the user to the callback
     */
    this.submitDateTime = function () {
      if (this.date && this.time && !this.disabled) {
        var dateTime = {
          time: moment(this.time).format("HH:mm:ss"),
          date: moment(this.date).format("YYYY-MM-DD")
        };

        this.onDateTimeChange({ dateTime: dateTime });
      }
    }.bind(this);

    /**
     * Disable the field when the user does not know the date and time
     */
    this.toggleDisabledFlag = function () {
      if (this.disabled) {
        this.time = new Date(this.dateTime * 1000);
        this.date = new Date(this.dateTime * 1000);
        this.disabled = !this.disabled;

        this.submitDateTime();
      } else {
        this.date = null;
        this.time = null;

        this.onDateTimeChange({ dateTime: null });
        this.disabled = !this.disabled;
      }
    }.bind(this);

    /**
     * Get translated content
     * @param {string} variant
     * @param {string} [suffix]
     * @param {{}} [context]
     */
    this.getTranslatedContent = function (variant, suffix, context) {
      return LocoService.translate("date-time-widget", variant, suffix, context || {});
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("dateRangePicker", dateRangePicker);

  /**
   * @return {{restrict: string, template: string, controller: DateRangePickerController,
   * scope: {startDate: string, endDate: string, maxDate: string, dayRange: string}}}
   * @ngInject
   */
  function dateRangePicker () {
    /**
     * @type {{restrict: string, template: string, controller: DateRangePickerController,
     * scope: {startDate: string, endDate: string, maxDate: string, dayRange: string}}}
     */
    var directive = {
      restrict: "E",
      template: ''+
        '<div class="row">'+
          '<div class="col-sm-6 col-xs-6">'+
            '<date-picker date="startDate" max-date="maxDate"></date-picker>'+
          '</div>'+
          '<div class="col-sm-6 col-xs-6">'+
            '<date-picker date="endDate" max-date="maxDate"></date-picker>'+
          '</div>'+
        '</div>',
      controller: DateRangePickerController,
      scope: {
        startDate: "=",
        endDate: "=",
        maxDate: "=",
        dayRange: "="
      }
    };

    return directive;

    /**
     * @param $scope
     * @constructor
     * @ngInject
     */
    function DateRangePickerController ($scope) {
      /**
       * Update range
       */
      var updateRange = function () {
        $scope.dayRange = Math.round(
          Math.abs(
            ($scope.startDate.getTime() - $scope.endDate.getTime()) / (24 * 60 * 60 * 1000)
          )
        );
      };

      $scope.$watch("startDate", function (a, b) {
        if (a !== b) {
          updateRange();
        }
      });

      $scope.$watch("endDate", function (a, b) {
        if (a !== b) {
          updateRange();
        }
      });
    }
  }
})();

/* global $:false */
/* eslint-disable angular/angularelement */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("datePicker", datePicker);

  /**
   * @return {{restrict: string, template: string, controller: DatePickerController,
   * scope: {date: string, maxDate: string, required: string, format: string, dateChange: string}}}
   * @ngInject
   */
  function datePicker () {
    /**
     * @type {{restrict: string, template: string, controller: DatePickerController,
     * scope: {date: string, maxDate: string, required: string, format: string, dateChange: string}}}
     */
    var directive = {
      restrict: "E",
      template: "" +
        "<div class=\"input-group datePicker\">" +
        "<input type=\"text\" class=\"form-control\" ng-required=\"required\"/>" +
        "<span class=\"input-group-addon\">" +
        "<span class=\"glyphicon glyphicon-calendar\"></span>" +
        "</span>" +
        "</div>",
      controller: DatePickerController,
      scope: {
        date: "=",
        maxDate: "=",
        epoch: "@",
        required: "=false",
        format: "=",
        dateChange: "&"
      }
    };

    return directive;

    /**
     * Import date to be able to deal with epoch as well.
     * @param date
     * @param isEpoch
     * @return {Date}
     */
    function importDate (date, isEpoch) {
      var imported = new Date();

      if (date && isEpoch) {
        imported = new Date(date * 1000);
      } else if (date) {
        imported = date;
      }

      return imported;
    }

    /**
     * Export date depending on epoch setting.
     * @param date
     * @param isEpoch
     * @return {*}
     */
    function exportDate (date, isEpoch) {
      var exported = null;

      if (date && isEpoch) {
        exported = date / 1000;
      } else if (date) {
        exported = date.toDate();
      }

      return exported;
    }

    /**
     * @param $scope
     * @param $log
     * @param $element
     * @param $translate
     * @constructor
     * @ngInject
     */
    function DatePickerController ($scope, $log, $element, $translate) {
      /**
       * Internalize input
       * @type {Date}
       */
      var internalizedDate = importDate($scope.date, $scope.epoch);

      /**
       * This is for compatibility.
       * The picker needs to pick up the initial value, and hook up the bindings.
       * Unfortunately we cannot set this when epoch is true, yet).
       */
      if (!$scope.epoch) {
        $scope.date = internalizedDate;
      }

      $($element).find(".datePicker").datetimepicker({
        defaultDate: internalizedDate,
        maxDate: $scope.maxDate,
        format: $scope.format || "ddd D MMM YYYY LT",
        stepping: 5,
        showClose: true,
        showClear: true,
        allowInputToggle: true,
        locale: $translate.use()
      }).on("dp.change", function (e) {
        $scope.date = exportDate(e.date, $scope.epoch);
        $scope.$apply();
        $scope.dateChange({ $value: $scope.date });
      });
    }
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents").directive("datePeriodSelector", datePeriodSelector);

  /**
   * @return {{restrict: string, templateUrl: string, controller: datePeriodSelectorController,
   * scope: {startDate: string, endDate: string, maxDate: string, dayRange: string, dayOptions: string,
   * centerEpoch: string, inViewEpoch: string, onDateChange: string}}}
   * @ngInject
   */
  function datePeriodSelector() {
    /**
     * @type {{restrict: string, templateUrl: string, controller: datePeriodSelectorController,
     * scope: {startDate: string, endDate: string, maxDate: string, dayRange: string, dayOptions: string,
     * centerEpoch: string, inViewEpoch: string, onDateChange: string}}}
     */
    var directive = {
      restrict: "E",
      templateUrl:
        "app/shared-components/angular-ui-components/components/datePeriodSelector/datePeriodSelector.html",
      controller: datePeriodSelectorController,
      scope: {
        startDate: "=",
        endDate: "=",
        maxDate: "=",
        dayRange: "=",
        dayOptions: "=",
        centerEpoch: "=",
        inViewEpoch: "=",
        onDateChange: "&"
      }
    };

    return directive;

    /**
     * @param $scope
     * @ngInject
     */
    function datePeriodSelectorController($scope) {
      if (!$scope.startDate) {
        $scope.startDate = new Date();
      }

      if (!$scope.endDate) {
        $scope.endDate = new Date();
      }

      if (!$scope.dayRange) {
        $scope.dayRange = 7;
      }

      if (!$scope.dayOptions) {
        $scope.dayOptions = [7, 31, 92, 183, 365];
      }

      /**
       * Change date
       */
      function changeDate() {
        checkMaxDate();
        updateNextBtnVisible();
        $scope.onDateChange({
          startDate: $scope.startDate,
          endDate: $scope.endDate,
          dayRange: $scope.dayRange
        });
      }

      /**
       * Check max date
       */
      function checkMaxDate() {
        if ($scope.maxDate && $scope.endDate.getTime() > $scope.maxDate.getTime()) {
          $scope.endDate = new Date($scope.maxDate.getTime());
          $scope.startDate = new Date($scope.maxDate.getTime());
          $scope.startDate.setDate($scope.startDate.getDate() - $scope.dayRange);
        }
      }

      /**
       * Update next button
       */
      function updateNextBtnVisible() {
        $scope.nextBtnVisible = !$scope.maxDate || $scope.endDate.getTime() < $scope.maxDate.getTime();
      }

      /**
       * Update start date
       */
      function updateStartDate() {
        $scope.startDate = new Date($scope.endDate.getTime());
        $scope.startDate.setDate($scope.endDate.getDate() - $scope.dayRange);
      }

      /**
       * Tell whether epoch is in view
       * @param epoch
       * @return {boolean}
       */
      function isEpochInView(epoch) {
        return epoch > $scope.startDate.getTime() / 1000 && epoch < $scope.endDate.getTime() / 1000;
      }

      /**
       * Update day range
       */
      function updateDayRange() {
        var centerEpochMilliseconds, stayInView;

        if ($scope.centerEpoch && isEpochInView($scope.centerEpoch)) {
          centerEpochMilliseconds = $scope.centerEpoch * 1000;
        }

        if ($scope.inViewEpoch && isEpochInView($scope.inViewEpoch)) {
          stayInView = true;
        }

        // Find the center of the date view
        centerEpochMilliseconds =
          centerEpochMilliseconds || ($scope.startDate.getTime() + $scope.endDate.getTime()) / 2;

        // Set dates to be the center of the charts
        $scope.startDate = new Date(centerEpochMilliseconds);
        $scope.endDate = new Date(centerEpochMilliseconds);

        // From the center substract and add days
        $scope.startDate.setDate($scope.startDate.getDate() - $scope.dayRange / 2);
        $scope.endDate.setDate($scope.endDate.getDate() + $scope.dayRange / 2);

        if (stayInView && !isEpochInView($scope.inViewEpoch)) {
          $scope.startDate = new Date($scope.inViewEpoch * 1000);
          $scope.endDate = new Date($scope.inViewEpoch * 1000);

          if ($scope.inViewEpoch > centerEpochMilliseconds / 1000) {
            // Keep the end date as is, change the start date
            $scope.startDate.setDate($scope.startDate.getDate() - $scope.dayRange * 0.9);
            $scope.endDate.setDate($scope.endDate.getDate() + $scope.dayRange * 0.1);
          } else {
            // Keep the start date as is, change the end date
            $scope.startDate.setDate($scope.startDate.getDate() - $scope.dayRange * 0.1);
            $scope.endDate.setDate($scope.endDate.getDate() + $scope.dayRange * 0.9);
          }
        }
      }

      /**
       * Next period
       */
      $scope.nextPeriod = function () {
        $scope.endDate.setDate($scope.endDate.getDate() + getPeriodStep());

        // Trigger the $digest loop
        $scope.endDate = new Date($scope.endDate.getTime());

        updateStartDate();
        changeDate();
      };

      /**
       * Previous period
       */
      $scope.previousPeriod = function () {
        $scope.endDate.setDate($scope.endDate.getDate() - getPeriodStep());

        // Trigger the $digest loop
        $scope.endDate = new Date($scope.endDate.getTime());

        updateStartDate();
        changeDate();
      };

      /**
       * Update chart on day range changes
       */
      $scope.$watch("dayRange", function (newValue, oldValue) {
        if (oldValue !== newValue) {
          updateDayRange();
          changeDate();
        }
      });

      /**
       * Get period step
       * @return {number}
       */
      function getPeriodStep() {
        var step = Math.ceil($scope.dayRange / 2);

        if ($scope.dayRange <= 3) {
          step = 1;
        } else if ($scope.dayRange <= 7) {
          step = 4;
        } else if ($scope.dayRange <= 31) {
          step = 14;
        }

        return step;
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("dairyMonitorDropdown", dairyMonitorDropdown);

  /**
   * @return {{restrict: string, template: string, controller: dairyMonitorDropdownController,
   * scope: {dairyMonitors: string, selectedDairyMonitor: string, onChange: string}}}
   * @ngInject
   */
  function dairyMonitorDropdown () {
    /**
     * @type {{restrict: string, template: string, controller: dairyMonitorDropdownController,
     * scope: {dairyMonitors: string, selectedDairyMonitor: string, onChange: string}}}
     */
    var directive = {
      restrict: "E",
      template: "" +
        "<select class=\"form-control\" id=\"selectedDairyMonitor\" ng-model=\"selectedDairyMonitor\" " +
        "ng-options=\"dairyMonitor as ('#'+dairyMonitor.NodeID+' ['+dairyMonitor.shortSerialNum+'] - '+dairyMonitor.deviceName) for dairyMonitor in dairyMonitors\" " +
        "ng-change=\"onChangeCallback()\">" +
        "<option value=\"\">{{\"NoSensor\" | translate}}</option>" +
        "</select>",
      controller: dairyMonitorDropdownController,
      scope: {
        dairyMonitors: "=",
        selectedDairyMonitor: "=",
        onChange: "&"
      }
    };

    return directive;

    /**
     * @param $scope
     * @param $timeout
     * @ngInject
     */
    function dairyMonitorDropdownController ($scope, $timeout) {
      var vm = $scope;

      /**
       * Handle change
       */
      vm.onChangeCallback = function () {
        $timeout(vm.onChange, 1);
      };
    }
  }
})();

(function () {
  "use strict";
  // TODO: replace $jQuery
  angular
    .module("ctraUIComponents")
    .directive("customerUsersForm", customerUsersForm);

  /**
   * @return {{restrict: string, templateUrl: string, controller: customerUsersFormController,
   * replace: boolean, scope: {customer: string, users: string, status: string, onBlur: string}}}
   * @ngInject
   */
  function customerUsersForm () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: customerUsersFormController,
     * replace: boolean, scope: {customer: string, users: string, status: string, onBlur: string}}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-ui-components/components/customerUsersForm/customerUsersForm.html",
      controller: customerUsersFormController,
      replace: true,
      scope: {
        customer: "=",
        users: "=",
        status: "=",
        onBlur: "&"
      }
    };

    return directive;

    /**
     * @param $scope
     * @param $element
     * @param $log
     * @param userService
     * @ngInject
     */
    function customerUsersFormController ($scope, $element, $log, userService) {
      var vm = $scope;

      vm.additionalUsersList = vm.users.filter(function (e) {
        return e.customerID === vm.customer.CustomerID && e.id !== vm.customer.primaryUserID;
      });

      /**
       * Update user
       * @param user
       */
      var updateUser = function (user) {
        vm.status.saving = true;
        vm.status.saved = false;
        vm.status.failed = false;
        userService.updateUser(user).then(function successCallback () {
          vm.status.saving = false;
          vm.status.saved = true;
        }, function () {
          vm.status.saving = false;
          vm.status.failed = true;
        });
      };

      /**
       * Add new user
       * @param user
       */
      vm.addAdditonalUser = function (user) {
        if (user && vm.customer.additionalUsersList.indexOf(user) < 0) {
          vm.additionalUsersList.push(user);
          user.customerID = vm.customer.CustomerID;
          updateUser(user);
        }
      };

      /**
       * Remove user
       * @param user
       */
      vm.removeAdditonalUser = function (user) {
        vm.additionalUsersList.splice(vm.additionalUsersList.indexOf(user), 1);
        user.customerID = null;
        updateUser(user);
      };

      /**
       * Filter user
       * @param value
       * @return {boolean}
       */
      vm.additionalUserFilter = function (value) {
        return vm.customer.primaryUserID !== value.id &&
          (!vm.additionalUsersList || vm.additionalUsersList.indexOf(value.id) < 0);
      };

      /**
       * Change user ID
       * @param user
       */
      vm.changedPrimaryUserID = function (user) {
        vm.customer.primaryUserID = user.id;
        user.customerID = vm.customer.CustomerID;
        vm.onBlur();
        updateUser(user);
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("cowDropdown", cowDropdown);

  /**
   * @return {{restrict: string, replace: boolean, template: string, controller: cowDropdownController,
   * scope: {cows: string, selectedCow: string, onChange: string}}}
   * @ngInject
   */
  function cowDropdown () {
    /**
     * @type {{restrict: string, replace: boolean, template: string, controller: cowDropdownController,
     * scope: {cows: string, selectedCow: string, onChange: string}}}
     */
    var directive = {
      restrict: "E",
      replace: true,
      template: "" +
        "<select class=\"form-control\" id=\"selectedCow\" ng-model=\"selectedCow\" " +
        "ng-options=\"cow as ('#'+cow.cowTagNumber+(cow.cowName ? ' - '+cow.cowName : '')) for cow in cows\" " +
        "ng-change=\"onChangeCallback()\">" +
        "<option value=\"\">-</option>" +
        "</select>",

      controller: cowDropdownController,
      scope: {
        cows: "=",
        selectedCow: "=",
        onChange: "&"
      }
    };

    return directive;

    /**
     * @param $scope
     * @param $timeout
     * @ngInject
     */
    function cowDropdownController ($scope, $timeout) {
      var vm = $scope;

      /**
       * Handle change
       */
      vm.onChangeCallback = function () {
        $timeout(vm.onChange, 1);
      };
    }
  }
})();

/* global $:false */
/* eslint-disable angular/angularelement */
/* eslint-disable angular/controller-as-vm */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("customerDetailsFormFields", customerDetailsFormFields);

  /**
   * @return {{restrict: string, templateUrl: string, controller: customerDetailsFormFieldsController,
   * replace: boolean, scope: {customer: string, users: string, onBlur: string}}}
   * @ngInject
   */
  function customerDetailsFormFields () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: customerDetailsFormFieldsController,
     * replace: boolean, scope: {customer: string, users: string, onBlur: string}}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-ui-components/components/customerDetailsFormFields/customerDetailsFormFields.html",
      controller: customerDetailsFormFieldsController,
      replace: true,
      scope: {
        customer: "=",
        users: "=",
        onBlur: "&"
      }
    };

    return directive;

    /**
     * @param $scope
     * @param $element
     * @ngInject
     */
    function customerDetailsFormFieldsController ($scope, $element) {
      var vm = $scope;

      $($element).find("input, textarea").keypress(function (e) {
        if (e.which === 13) {
          $(this).blur();
        }
      });

      $($element).find("input, textarea").blur(vm.onBlur);
    }
  }
})();

/* global $:false */
/* eslint-disable angular/angularelement */
/* eslint-disable angular/controller-as-vm */

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("cowDetailsFormFields", cowDetailsFormFields);

  /**
   * @return {{restrict: string, templateUrl: string, controller: cowDetailsFormFieldsController,
   * replace: boolean, scope: {cow: string, herdGroups: string, farms: string, onBlur: string}}}
   * @ngInject
   */
  function cowDetailsFormFields () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: cowDetailsFormFieldsController,
     * replace: boolean, scope: {cow: string, herdGroups: string, farms: string, onBlur: string}}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-ui-components/components/cowDetailsFormFields/cowDetailsFormFields.html",
      controller: cowDetailsFormFieldsController,
      replace: true,
      scope: {
        cow: "=",
        herdGroups: "=",
        farms: "=",
        onBlur: "&"
      }
    };

    return directive;

    /**
     * @param $scope
     * @param $element
     * @ngInject
     */
    function cowDetailsFormFieldsController ($scope, $element) {
      var vm = $scope;

      $($element).find("input, textarea").keypress(function (e) {
        if (e.which === 13) {
          $(this).blur();
        }
      });

      $($element).find("input, textarea").blur(function () {
        vm.onBlur({ cow: vm.cow });
      });

      $($element).find("select").change(function () {
        vm.onBlur({ cow: vm.cow });
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .directive("backButton", backButton);

  /**
   * @ngInject
   * @return {{restrict: string, link: backButtonLink}}
   */
  function backButton () {
    /**
     * @type {{restrict: string, link: backButtonLink}}
     */
    var directive = {
      restrict: "A",
      link: backButtonLink
    };

    return directive;

    /**
     * @ngInject
     * @param scope
     * @param element
     */
    function backButtonLink (scope, element) {
      element.bind("click", goBack);

      function goBack () {
        history.back();
        scope.$apply();
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraAuthentication", [
      "ngPasswordStrength",
      "LocalStorageModule",
      "ODataResources"
    ])
})();

/* global $:false */
/* eslint-disable angular/angularelement */

(function () {
  "use strict";

  angular
    .module("ctraAuthentication")
    .directive("userProfileForm", userProfileForm);

  /**
   * @return {{restrict: string, templateUrl: string, controller: userProfileFormController,
   * transclude: boolean, replace: boolean, scope: {user: string}}}
   * @ngInject
   */
  function userProfileForm () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: userProfileFormController,
     * transclude: boolean, replace: boolean, scope: {user: string}}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-authentication/components/userProfileForm/userProfileForm.html",
      controller: userProfileFormController,
      transclude: true,
      replace: true,
      scope: {
        user: "="
      }
    };

    return directive;

    /**
     * @param $rootScope
     * @param $scope
     * @param $element
     * @param $log
     * @param authenticationService
     * @ngInject
     */
    function userProfileFormController ($rootScope, $scope, $element, $log, authenticationService) {
      var vm = $scope;

      /**
       * @type {{}}
       */
      vm.status = {};

      activate();

      /**
       * Update user
       */
      function updateUser () {
        /**
         * @type {boolean}
         */
        vm.status.saving = true;

        /**
         * @type {boolean}
         */
        vm.status.saved = false;

        /**
         * @type {boolean}
         */
        vm.status.failed = false;

        authenticationService.updateUser(vm.user).then(function () {
          vm.status.saving = false;
          vm.status.saved = true;
        }, function () {
          vm.status.saving = false;
          vm.status.failed = true;
        });
      }

      /**
       * Activate form
       */
      function activate () {
        $($element).find("input").blur(updateUser);

        $($element).find("input").keypress(function (e) {
          if (e.which === 13) {
            $(this).blur();
          }
        });

        $($element).find("select").change(updateUser);
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraAuthentication")
    .directive("registrationPanel", registrationPanel);

  /**
   * @return {{restrict: string, templateUrl: string, controller: registrationPanelController, controllerAs: string}}
   * @ngInject
   */
  function registrationPanel () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: registrationPanelController, controllerAs: string}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-authentication/components/registrationPanel/registrationPanel.html",
      controller: registrationPanelController,
      controllerAs: "vm"
    };

    return directive;

    /**
     * @param $window
     * @param $rootScope
     * @param $scope
     * @param $state
     * @param $log
     * @param authenticationService
     * @ngInject
     */
    function registrationPanelController ($window, $rootScope, $scope, $state, $log, authenticationService) {
      var vm = $scope;

      /**
       * Register user
       */
      vm.register = function () {
        /**
         * @type {boolean}
         */
        $rootScope.loading = true;

        /**
         * @type {boolean}
         */
        vm.error = false;

        /**
         * @type {boolean}
         */
        vm.success = false;

        /**
         * @type {{email: *, username: *, password: *, confirmPassword: Document.confirmPassword}}
         */
        var user = {
          "email": vm.emailAddress,
          "username": vm.emailAddress,
          "password": vm.password,
          "confirmPassword": vm.confirmPassword
        };

        authenticationService.newUser(user).then(function () {
          $rootScope.loading = false;
          vm.success = true;
        }, function (reason) {
          $rootScope.loading = false;
          vm.error = reason;
        });
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraAuthentication")
    .directive("resetPasswordPanel", resetPasswordPanel);

  /**
   * @return {{restrict: string, templateUrl: string, controller: resetPasswordPanelController, controllerAs: string}}
   * @ngInject
   */
  function resetPasswordPanel () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: resetPasswordPanelController, controllerAs: string}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-authentication/components/resetPasswordPanel/resetPasswordPanel.html",
      controller: resetPasswordPanelController,
      controllerAs: "vm"
    };

    return directive;

    /**
     * @param $rootScope
     * @param $scope
     * @param $stateParams
     * @param $translate
     * @param authenticationService
     * @ngInject
     */
    function resetPasswordPanelController ($rootScope, $scope, $stateParams, $translate, authenticationService) {
      var vm = $scope;

      /**
       * Reset password
       */
      vm.resetPassword = function () {
        /**
         * @type {string}
         */
        vm.success = "";

        /**
         * @type {string}
         */
        vm.error = "";

        /**
         * @type {boolean}
         */
        vm.showPassword = false;

        /**
         * @type {boolean}
         */
        vm.loading = true;

        /**
         * @type {{UserId: string, Password: string, ConfirmPassword: string, Code: string}}
         */
        var details = {
          UserId: $stateParams.userId,
          Password: vm.newPassword,
          ConfirmPassword: vm.newPassword,
          Code: $stateParams.code
        };

        authenticationService.resetPassword(details).then(function () {
          vm.loading = false;
          vm.success = $translate.instant("resetPasswordSuccessMessage");
        }, function () {
          vm.loading = false;
          vm.error = $translate.instant("LABEL_TEXT_OOPS");
        });
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraAuthentication")
    .directive("passwordStrength", passwordStrength);

  /**
   * @return {{restrict: string, templateUrl: string, controller: passwordStrengthController,
   * scope: {password: string, passwordPassed: string}}}
   * @ngInject
   */
  function passwordStrength () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: passwordStrengthController,
     * scope: {password: string, passwordPassed: string}}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-authentication/components/passwordStrength/passwordStrength.html",
      controller: passwordStrengthController,
      scope: {
        password: "<",
        passwordPassed: "="
      }
    };

    return directive;

    /**
     * @param $scope
     * @ngInject
     */
    function passwordStrengthController ($scope) {
      var vm = $scope;

      vm.$watch("password", checkPassword);

      /**
       * @type {{}}
       */
      vm.passwordChecks = {};

      /**
       * @type {{rules: RegExp, title: string}}
       */
      vm.passwordChecks.hasUppercase = {
        rules: new RegExp("^(?=.*[A-Z])"),
        title: "One uppercase character"
      };

      /**
       * @type {{rules: RegExp, title: string}}
       */
      vm.passwordChecks.hasLowercase = {
        rules: new RegExp("^(?=.*[a-z])"),
        title: "One lowercase character"
      };

      /**
       * @type {{rules: RegExp, title: string}}
       */
      vm.passwordChecks.hasMinimum6Characters = {
        rules: new RegExp("^(?=.{6,})"),
        title: "6 characters minimum"
      };

      /**
       * @type {{rules: RegExp, title: string}}
       */
      vm.passwordChecks.hasDigit = {
        rules: new RegExp("^(?=.*[0-9])"),
        title: "One number"
      };

      /**
       * @type {{rules: RegExp, title: string}}
       */
      vm.passwordChecks.hasSpecialCharacter = {
        rules: new RegExp("^(?=.*[!@#\$%\^&\*])"),
        title: "One special character"
      };

      /**
       * Check password
       * @param value
       */
      function checkPassword (value) {
        /**
         * @type {string}
         */
        var password = escapeRegExp(value || "");

        /**
         * @type {boolean}
         */
        vm.passwordPassed = true;

        angular.forEach(vm.passwordChecks, function (check) {
          /**
           * @type {boolean}
           */
          check.passed = check.rules.test(password);

          if (!check.passed) {
            vm.passwordPassed = false;
          }
        });
      }

      /**
       * Escape string
       * @param str
       * @return {string}
       */
      function escapeRegExp (str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraAuthentication")
    .directive("loginPanel", loginPanel);

  /**
   * @return {{restrict: string, templateUrl: string, controller: loginPanelController, controllerAs: string}}
   * @ngInject
   */
  function loginPanel () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: loginPanelController, controllerAs: string}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-authentication/components/loginPanel/loginPanel.html",
      controller: loginPanelController,
      controllerAs: "vm"
    };

    return directive;

    /**
     * @param $window
     * @param $rootScope
     * @param $scope
     * @param $log
     * @param authenticationService
     * @ngInject
     */
    function loginPanelController ($window, $rootScope, $scope, $log, authenticationService) {
      var vm = $scope;

      /**
       * @type {boolean}
       */
      vm.stayLoggedIn = true;

      /**
       * Log user in
       * @return {boolean}
       */
      vm.login = function () {
        if (vm.emailAddress && vm.password) {
          /**
           * Clear the error message
           * @type {string}
           */
          vm.error = "";


          $rootScope.loading = true;

          authenticationService.login(
            vm.emailAddress,
            vm.password,
            vm.stayLoggedIn
          ).then(function () {
            $rootScope.loading = false;
          }, function (error) {
            vm.error = error.message;

            if (error.code === "wrongPassword") {
              vm.password = "";
            }

            if (error.code === "lockedOut") {
              vm.password = "";
              vm.lockedOut = true;
            }

            $rootScope.loading = false;
          });
        } else {
          /**
           * @type {string}
           */
          vm.error = "Please fill in the fields below";

          return false;
        }
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraAuthentication")
    .directive("forgotPasswordPanel", forgotPasswordPanel);

  /**
   * @return {{restrict: string, templateUrl: string, controller: forgotPasswordPanelController, controllerAs: string}}
   * @ngInject
   */
  function forgotPasswordPanel () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: forgotPasswordPanelController, controllerAs: string}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-authentication/components/forgotPasswordPanel/forgotPasswordPanel.html",
      controller: forgotPasswordPanelController,
      controllerAs: "vm"
    };

    return directive;

    /**
     * @param $rootScope
     * @param $scope
     * @param $stateParams
     * @param $translate
     * @param authenticationService
     * @ngInject
     */
    function forgotPasswordPanelController ($rootScope, $scope, $stateParams, $translate, authenticationService) {
      var vm = $scope;

      vm.emailAddress = $stateParams.emailAddress;

      vm.forgotPassword = function () {
        /**
         * @type {string}
         */
        vm.success = "";

        /**
         * @type {string}
         */
        vm.error = "";

        /**
         * @type {boolean}
         */
        vm.loading = true;

        authenticationService.forgotPassword(vm.emailAddress).then(function () {
          vm.loading = false;
          vm.success = $translate.instant("forgotPasswordSuccessMessage");
        }, function () {
          vm.loading = false;
          vm.error = $translate.instant("LABEL_TEXT_OOPS");
        });
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraAuthentication")
    .directive("confirmEmailPanel", confirmEmailPanel);

  /**
   * @return {{restrict: string, templateUrl: string, controller: confirmEmailPanelController, controllerAs: string}}
   * @ngInject
   */
  function confirmEmailPanel () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: confirmEmailPanelController, controllerAs: string}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-authentication/components/confirmEmailPanel/confirmEmailPanel.html",
      controller: confirmEmailPanelController,
      controllerAs: "vm"
    };

    return directive;

    /**
     * @param $scope
     * @param $state
     * @param $stateParams
     * @param $log
     * @param authenticationService
     * @ngInject
     */
    function confirmEmailPanelController ($scope, $state, $stateParams, $log, authenticationService) {
      var vm = $scope;

      /**
       * @type {boolean}
       */
      vm.loading = true;

      authenticationService.verifyEmail($stateParams.userId, $stateParams.code).then(function () {
        vm.loading = false;
        vm.success = true;
      }, function () {
        vm.loading = false;
        $state.go("alert", { message: "unableToVerify", level: "danger" });
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraAuthentication")
    .directive("changePasswordForm", changePasswordForm);

  /**
   * @return {{restrict: string, templateUrl: string, controller: changePasswordFormController,
   * transclude: boolean, replace: boolean, scope: {account: string}}}
   * @ngInject
   */
  function changePasswordForm () {
    /**
     * @type {{restrict: string, templateUrl: string, controller: changePasswordFormController,
     * transclude: boolean, replace: boolean, scope: {account: string}}}
     */
    var directive = {
      restrict: "E",
      templateUrl: "app/shared-components/angular-authentication/components/changePasswordForm/changePasswordForm.html",
      controller: changePasswordFormController,
      transclude: true,
      replace: true,
      scope: {
        account: "="
      }
    };

    return directive;

    /**
     * @param $scope
     * @param $log
     * @param authenticationService
     * @ngInject
     */
    function changePasswordFormController ($scope, $log, authenticationService) {
      var vm = $scope;

      /**
       * @type {{}}
       */
      vm.changePasswordDetails = {};

      /**
       * @type {{}}
       */
      vm.status = {};

      /**
       * Change password
       * @return {boolean}
       */
      vm.changePassword = function () {
        if (vm.changePasswordDetails.OldPassword && vm.changePasswordDetails.NewPassword) {
          /**
           * @type {string}
           */
          vm.success = "";

          /**
           * @type {string}
           */
          vm.error = "";

          /**
           * @type {boolean}
           */
          vm.status.saving = true;

          /**
           * @type {boolean}
           */
          vm.status.saved = false;

          /**
           * @type {boolean}
           */
          vm.status.failed = false;

          vm.changePasswordDetails.ConfirmPassword = vm.changePasswordDetails.NewPassword;

          authenticationService.changePassword(vm.changePasswordDetails).then(function () {
            vm.success = "Successfully changed your password";
            vm.changePasswordDetails = {};

            vm.status.saving = false;
            vm.status.saved = true;
          }, function (reason) {
            vm.status.saving = false;
            vm.status.failed = true;

            if (!reason.data.modelState) {
              vm.error = "LABEL_TEXT_OOPS";
            } else {
              vm.error = "";

              angular.forEach(reason.data.modelState, function (value) {
                vm.error += "ERROR_" + value + " \n";
              });
            }
          });
        } else {
          vm.error = "Please fill in all the form fields";
        }
      };
    }
  }
})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services
  // TODO: replace $jQuery
  /* global $:false */
  /* eslint-disable angular/angularelement */

  angular
    .module('dairyMonitorAdmin')
    .directive('systemMonitorsPanel', systemMonitorsPanel);

  /** @ngInject */
  function systemMonitorsPanel() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/main/systemMonitorsPanel/systemMonitorsPanel.html',
      scope: {
      },
      controller: systemMonitorsPanelController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function systemMonitorsPanelController($scope, systemMonitorService, $element, $timeout, sysAdminService) {

      $scope.loading = true;
      $scope.monitorStates = [];
      $scope.parentMonitor = "root";

      $scope.successThreshold = 75;
      $scope.warningThreshold = 65;

      var ignoredFarmIDs = [1, 2, 3, 4, 8, 12, 13, 18, 17, 21];

      sysAdminService.getFarms().$promise.then(function (result) {
        $scope.farms = result.filter(function(farm) {
          return ignoredFarmIDs.indexOf(farm.FarmID) < 0;
        });
        $scope.ignoredFarms = result.filter(function(farm) {
          return ignoredFarmIDs.indexOf(farm.FarmID) > -1;
        });
      });

      $scope.refreshMonitorStates = function(){
        $scope.loading = true;
        systemMonitorService.getMonitoringStates($scope.parentMonitor).then(function(states){

          angular.forEach(states, function (state) {
            state.farmID = parseInt(state.monitorName.replace(/\D/g,''));
            state.farmName = state.monitorName.replace('[Farm]','');
            state.farmName = state.farmName.replace(/\d/g,'');
          });

          $scope.monitors = states.filter(function(state) {
            return ignoredFarmIDs.indexOf(state.farmID) < 0;
          });

          $scope.loading = false;
          $timeout(function(){
            $($element).find('[data-toggle="tooltip"]').tooltip();
          }, 1);
        });
      };
      $scope.refreshMonitorStates();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.systemMonitorsMap', ['ui-leaflet'])
    .component('systemMonitorsMap', {
      bindings: {
        monitors: '<',
        farms: '<'
      },
      controller: systemMonitorsMapCtrl,
      template: '<farms-map farms="$ctrl.farmsMonitors" color-key="monitorState" selected-farm="$ctrl.selectedFarm"></farms-map>'
    });

  /** @ngInject */
  function systemMonitorsMapCtrl() {
    var $ctrl = this;

    $ctrl.$onChanges = onChanges;

    function onChanges(change) {
      if((change.hasOwnProperty('farms') && change.farms.currentValue) ||
        (change.hasOwnProperty('monitors') && change.monitors.currentValue)) {
        //match monitors and farms
        mergeFarmMonitors()
      }
    }

    function mergeFarmMonitors(){
      if(!$ctrl.farms || !$ctrl.monitors) return false;

      $ctrl.farmsMonitors = $ctrl.farms;

      angular.forEach($ctrl.farmsMonitors, function (farm) {
        farm.monitor = $ctrl.monitors.find(function (monitor) {
          return monitor.farmID === farm.FarmID;
        })

        if(farm.monitor){
          if(farm.monitor.passRate < 0.65){
            farm.monitorState = "danger";
          }else if(farm.monitor.passRate >= 0.65 && farm.monitor.passRate < 0.75){
            farm.monitorState = "warning";
          }else{
            farm.monitorState = "success";
          }
        }else{
          farm.monitorState = "default";
        }

      });


    }

  }

})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.sensorsSummary', [])
    .component('sensorsSummary', {
      bindings: {
        farmId: "<",
        showTotal: "<"
      },
      controller: sensorsSummaryCtrl,
      templateUrl: 'app/views/main/sensorsSummary/sensorsSummary.html'
    });

  /** @ngInject */
  function sensorsSummaryCtrl($q, $timeout, sysAdminService) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;


    function onInit() {
      var ignoredFarmIDs = [1, 2, 3, 4, 8, 12, 13, 18, 17, 21];

      $ctrl.loading = true;

      sysAdminService.getBaseStations($ctrl.farmId).$promise.then(function(baseStations){

        if($ctrl.farmId){
          $ctrl.baseStations = baseStations;
        }else{
          $ctrl.baseStations = baseStations.filter(function (e) {
            return ignoredFarmIDs.indexOf(e.farmID) === -1;
          });
        }

        $ctrl.baseStationIDs = baseStations.reduce(function (prev, curr) {
          return prev.concat(curr.BaseStationID);
        }, []);

        var sensorLoader = sysAdminService.getSensors($ctrl.baseStations).$promise;
        sensorLoader.then(function(sensors){
          $ctrl.sensors = sensors.filter(function (e) {
            // e.baseStation = $ctrl.baseStations.find(function (f) {
            //   e.baseStationID === f.BaseStationID;
            // })
            // e.farmID = e.baseStation.farmID;

            return $ctrl.baseStationIDs.indexOf(e.baseStationID) > -1;
          });

        });

        var cowLoader = sysAdminService.getCows($ctrl.farmId).$promise;
        cowLoader.then(function(cows){
          $ctrl.cows = cows.filter(function (e) {
            return ignoredFarmIDs.indexOf(e.farmID) === -1;
          });
        });

        $q.all([sensorLoader, cowLoader]).then(function () {

          var connectedSensorsIDs = $ctrl.cows.reduce(function (prev, curr) {
            if(curr.nodeID) return prev.concat(curr.nodeID);
            return prev;
          }, []);

          $ctrl.connectedSensors = $ctrl.sensors.filter(function (e) {
            return connectedSensorsIDs.indexOf(e.NodeID) > -1;
          });

          $ctrl.unconnectedSensors = $ctrl.sensors.filter(function (e) {
            return connectedSensorsIDs.indexOf(e.NodeID) === -1;
          });

          var now = new Date();
          var m = 60; //1 minute
          var h = m*60; //1 hour
          var minPingTime = h*24;

          $ctrl.liveConnectedSensors = $ctrl.connectedSensors.filter(function (e) {
            var ping = new Date(e.deviceDMLastPingTime);
            return (now.getTime()-ping.getTime())/1000 < minPingTime;
          });


          $ctrl.offlineConnectedSensors = $ctrl.connectedSensors.filter(function (e) {
            var ping = new Date(e.deviceDMLastPingTime);
            // console.log(e, ((now.getTime()-ping.getTime()/1000)/60)+"minutes");
            return (now.getTime()-ping.getTime())/1000 >= minPingTime;
          });


          /* eslint-disable angular/angularelement */
          /* global $ */
          $timeout(function(){
            $('[data-toggle="tooltip"]').tooltip();
          }, 200);

          $ctrl.loading = false;
        }, function () {
          $ctrl.loading = false;
        });
      });
    }




  }
})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.labelCurating', [
      'ctraUIComponents.labels.labelDetailsForm'
    ])

}());

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin.insights.labelCurating").component("labelCurating", {
    controller: labelCuratingCtrl,
    templateUrl: "app/views/insights/labelCurating/labelCurating.html"
  });

  /** @ngInject */
  function labelCuratingCtrl(
    $scope,
    $window,
    $timeout,
    $state,
    $q,
    sessionService,
    sysAdminService,
    labelService,
    toastr,
    $translate,
    dataApiService
  ) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.save = save;
    $ctrl.labelFormValid = labelFormValid;
    $ctrl.saveAndNext = saveAndNext;
    $ctrl.skipLabel = skipLabel;
    $ctrl.noEstrusFound = noEstrusFound;
    $ctrl.exit = exit;
    $ctrl.nextLabel = nextLabel;
    $ctrl.getToDoStatus = getToDoStatus;

    var labelsToCurate = 0;

    function onInit() {
      $ctrl.themedHeader = false;
      $ctrl.hideFields = [
        "header",
        "visibility",
        "category",
        "farm",
        "scope",
        "subject",
        "title",
        "description",
        "startEndDate"
      ];

      $ctrl.title = "Estrus";
      $ctrl.category = "fertility";
      $ctrl.farms = sysAdminService.getFarms();
      $ctrl.playerNames = ["Andres", "Arwin", "Daniel", "Fred", "Hyeokjin", "Igor", "Irena", "Jan Jaap", "Jean Marc", "Jenn", "Jorge", "Judary", "Julie", "Leonie", "Mandar", "Marjolein", "Martin", "Nielsm", "Nielsr", "Nynke", "Paul", "Saad", "Sandor", "Snezhana", "Stacey", "Talha", "Thijs", "Timo", "Whitney","Yasir", "Yulia", "Zulfikar", "Extra user 1", "Extra user 2", "Extra user 3", "Extra user 4", "Extra user 5", "Extra user 6", "Extra user 7", "Extra user 8", "Extra user 9", "Extra user 10"];
      $ctrl.players = [];
      angular.forEach($ctrl.playerNames, addPlayer);
      $ctrl.labelsOffset = null;

      $ctrl.sourcelabel = null;

      $ctrl.tags = [sessionService.user.id + "-curated", "fuzzy"];

      getToDoStatus();
    }

    function getToDoStatus() {
      $q.all([getToDoCount(), getDoneCount()]).then(function (n) {
        $ctrl.progress = {};
        $ctrl.progress.todo = n[0];
        $ctrl.progress.done = n[1];
        $ctrl.progress.total = n[0] + n[1];
        $ctrl.progress.percentageDone = parseInt(($ctrl.progress.done / $ctrl.progress.total) * 100);

        labelsToCurate = n[0];
      });
    }

    function addPlayer(name) {
      $ctrl.players.push({ name: name, id: $ctrl.players.length });
    }

    function nextLabel() {
      $ctrl.label = null;

      getSourceLabel().then(
        function (sourcelabel) {
          $ctrl.sourcelabel = sourcelabel;
          addTagToLabel($ctrl.sourcelabel, "ctra-checked");
          $ctrl.label = {};
          $ctrl.label.farmID = parseInt(sourcelabel.farmID);
          $ctrl.label.category = "fertility"; //$stateParams.category;
          $ctrl.label.title = "estrus"; //$stateParams.title;
          $ctrl.label.labelScope = "cow"; //$stateParams.scope || ($stateParams.cowID ? 'cow' : null);
          $ctrl.label.dairyCowID = parseInt(sourcelabel.dairyCowID);
          $ctrl.label.startEpoch = parseInt(sourcelabel.startEpoch);
          $ctrl.label.endEpoch = parseInt(sourcelabel.endEpoch);
          $ctrl.label.createdByUserID = sessionService.user.id;

          $ctrl.label.customerVisible = false;
          $ctrl.label.tags = [sessionService.user.id + "-curated"];

          $ctrl.label.description = {};
          $ctrl.label.description.sourceLabelID = sourcelabel.GenericLabelID;
          $ctrl.label.description.sourceLabelDescription = sourcelabel.description;
          $ctrl.label.description.markers = [
            {
              title: "activityPeak",
              epoch: $ctrl.label.startEpoch + ($ctrl.label.endEpoch - $ctrl.label.startEpoch) / 2
            }
          ];

          $ctrl.label = labelService.newLabel($ctrl.label);
        },
        function errorCallback() {
          alert("No more insights!");
          $window.location.reload();
        }
      );

      getToDoStatus();
    }

    function saveAndNext() {
      save($ctrl.label).then(function () {
        nextLabel();
      });
    }

    function noEstrusFound() {
      addTagToLabel($ctrl.sourcelabel, sessionService.user.id + "-no estrus found");
      nextLabel();
    }

    function skipLabel() {
      addTagToLabel($ctrl.sourcelabel, sessionService.user.id + "-skipped");
      nextLabel();
    }

    function exit() {
      removeTagFromLabel($ctrl.sourcelabel, "ctra-checked");
      $ctrl.labelsOffset = null;
    }

    function addTagToLabel(label, tag) {
      return labelService.addTag(label, tag);
    }

    function removeTagFromLabel(label, tag) {
      return labelService.removeTag(label, tag);
    }

    function getSourceLabel() {
      var deferred = $q.defer();

      $ctrl.loading = true;

      $ctrl.labelsOffset = Math.floor(Math.random() * labelsToCurate);

      labelService
        .getLabels($ctrl.farm, 1, $ctrl.labelsOffset, {
          orderBy: { variable: "startEpoch", direction: "desc" },
          notTagged: "ctra-checked",
          tags: "tt-checked",
          title: $ctrl.title,
          category: $ctrl.category
        })
        .then(function (labels) {
          if (labels[0]) {
            deferred.resolve(labels[0]);
          } else {
            deferred.reject();
          }

          $ctrl.loading = false;
        });

      return deferred.promise;
    }

    function getToDoCount() {
      var deferred = $q.defer();

      labelService
        .getLabels(
          $ctrl.farm,
          null,
          null,
          {
            notTagged: "ctra-checked",
            tag: "tt-checked",
            title: $ctrl.title,
            category: $ctrl.category
          },
          true
        )
        .then(function (count) {
          deferred.resolve(count);
        });

      return deferred.promise;
    }
    function getDoneCount() {
      var deferred = $q.defer();

      labelService
        .getLabels(
          $ctrl.farm,
          null,
          null,
          {
            tags: ["tt-checked", "ctra-checked"],
            title: $ctrl.title,
            category: $ctrl.category
          },
          true
        )
        .then(function (count) {
          deferred.resolve(count);
        });

      return deferred.promise;
    }

    function labelFormValid() {
      if (!$ctrl.label.title) {
        return false;
      }
      if ($ctrl.label.labelScope === "cow" && !$ctrl.label.dairyCowID) {
        return false;
      }
      if (!$ctrl.label.startEpoch || !$ctrl.label.endEpoch) {
        return false;
      }
      return true;
    }

    function save(obj) {
      if (!labelFormValid()) {
        $window.alert("Something went wrong");
        return false;
      }

      $ctrl.error = "";
      $ctrl.success = "";
      $ctrl.loading = true;

      var promise = labelService.saveLabel(obj);

      promise.then(
        function () {
          $ctrl.loading = false;
          toastr.success($translate.instant("LABEL_TEXT_SAVED"));
          dataApiService.clearDataFromCache("GenericLabels");
        },
        function () {
          $ctrl.loading = false;
          $ctrl.error = $translate.instant("LABEL_TEXT_OOPS");
          toastr.error($translate.instant("LABEL_TEXT_OOPS"));
        }
      );

      return promise;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin.insights.labelsExplorer", []);

}());

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin.insights.labelsExplorer")
    .component("labelsExplorer", {
      templateUrl: "app/views/insights/labelsExplorer/labelsExplorer.html",
      controller: labelsExplorerCtrl
    });

    /** @ngInject */
    function labelsExplorerCtrl($scope, $state, $window, $timeout, $interval, sysAdminService, labelService, debounce) {
      var $ctrl = this;

      $ctrl.$onInit = onInit;
      $ctrl.onLabelClicked = onLabelClicked;
      $ctrl.sortBy = sortBy;
      $ctrl.sortedBy = null;

      $ctrl.getLabelsDebounce = debounce(500, getLabels);
      $ctrl.getLabels = getLabels;
      var refreshIntervalSeconds;
      var labelRefresher;


      function onInit() {
        $ctrl.title = "";
        $ctrl.tags = ["not checked", "checked", "not curated", "curated", "skipped", "no estrus found", "fuzzy", "farmer reported"]
        $ctrl.tag = null;
        $ctrl.farms = sysAdminService.getFarms();
        $ctrl.labelsPerPageOptions = [10, 50, 100, 200, 400, 600, 800, 1000, 10000];
        $ctrl.labelsPerPage = $ctrl.labelsPerPageOptions[1];

        refreshIntervalSeconds = 15;
        $ctrl.refreshTimer = refreshIntervalSeconds;
        $ctrl.autoRefresh = false;
        getLabels();
        startAutoRefreshLabels();
      }

      function startAutoRefreshLabels(){
        labelRefresher = $interval(function(){
          if(!$ctrl.autoRefresh) return false;
          if(!$ctrl.loading) $ctrl.refreshTimer--; // Only count down when not loading;
          if($ctrl.refreshTimer <= 0){
            getLabels();
          }
        }, 1000)
      }

      function getLabels(){
        $ctrl.loading = true;
        $ctrl.refreshTimer = refreshIntervalSeconds;

        var tag = ($ctrl.tag && $ctrl.tag.indexOf('not ') === -1 ? $ctrl.tag : '');
        var notTagged = ($ctrl.tag && $ctrl.tag.indexOf('not ') > -1  ? $ctrl.tag.replace('not ', '') : '');


        labelService.getLabels(
          $ctrl.farm,
          $ctrl.labelsPerPage,
          $ctrl.labelsOffset,
          {
            orderBy: {variable: 'createdEpoch', direction: 'desc'},
            tag: tag,
            notTagged: notTagged,
            title: $ctrl.title
          }
        ).then(function(labels){

          $ctrl.labels = labels;

          sortBy('createdEpoch')

          $ctrl.loading = false;
          applyTooltip();
        });
      }

      function applyTooltip(){
        /* eslint-disable angular/angularelement */
        /* global $ */
        $timeout(function () {
          $('[data-toggle="tooltip"]').tooltip();
        }, 300);
      }


      function onLabelClicked(genericLabelID){
        var url = $state.href('label', {genericLabelID: genericLabelID});
        $window.open(url,'_blank');
      }

      function sortBy(property){

        $ctrl.labels = $ctrl.labels.sort(function (a, b) {
          if(a[property] > b[property]) return -1;
          if(a[property] === b[property]){
            if(a.farmID > b.farmID) return -1;
            if(a.farmID === b.farmID){
              if(parseInt(a.dairyCow.cowTagNumber) > parseInt(b.dairyCow.cowTagNumber)) return 1;
              return -1;
            }
            return 1;
          }
          return 1;

        });

        $ctrl.sortedBy = property;

      }

      $scope.$on('$destroy', function() {
        // Make sure that the interval is destroyed
        if(angular.isDefined(labelRefresher)){
          $interval.cancel(labelRefresher);
          labelRefresher = undefined;
        }
      });

    }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.insightTypes', [
      'dairyMonitorAdmin.insights.insightTypesList',
      'dairyMonitorAdmin.insights.newInsightType'
    ])

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.insightTypes')
    .component('insightTypes', {
      bindings: {
        insightTypes: '<'
      },
      controller: insightTypesCtrl,
      templateUrl: 'app/views/insights/insightTypes/insightTypes.html'
    });

  /** @ngInject */
  function insightTypesCtrl() {
    var $ctrl = this;

    $ctrl.$onInit = onInit;

    function onInit() {
    }
  }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.insightModels', [
      'dairyMonitorAdmin.insights.insightModelsList',
      'dairyMonitorAdmin.insights.newInsightModel'
    ])

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.insightModels')
    .component('insightModels', {
      bindings: {
        insightModels: '<'
      },
      controller: insightModelsCtrl,
      templateUrl: 'app/views/insights/insightModels/insightModels.html'
    });

  /** @ngInject */
  function insightModelsCtrl() {
    var $ctrl = this;

    $ctrl.$onInit = onInit;

    function onInit() {
    }
  }

}());

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin.insights.insightAccuracy", []);

}());

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin.insights.insightAccuracy")
    .component("insightAccuracy", {
      templateUrl: "app/views/insights/insightAccuracy/insightAccuracy.html"
    });

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.healthLabelCurating', [
      'ctraUIComponents.labels.labelDetailsForm'
    ])

}());

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin.insights.healthLabelCurating").component("healthLabelCurating", {
    controller: healthLabelCuratingCtrl,
    templateUrl: "app/views/insights/healthLabelCurating/healthLabelCurating.html"
  });

  /** @ngInject */
  function healthLabelCuratingCtrl(
    $scope,
    $window,
    $timeout,
    $interval,
    $state,
    $q,
    sessionService,
    sysAdminService,
    labelService,
    toastr,
    $translate,
    dataApiService
  ) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.save = save;
    $ctrl.labelFormValid = labelFormValid;
    $ctrl.saveAndNext = saveAndNext;
    $ctrl.skipLabel = skipLabel;
    $ctrl.noBehaviourChangeFound = noBehaviourChangeFound;
    $ctrl.exit = exit;
    $ctrl.nextLabel = nextLabel;
    $ctrl.getToDoStatus = getToDoStatus;

    function onInit() {
      $ctrl.themedHeader = false;
      $ctrl.hideFields = [
        "header",
        "visibility",
        "category",
        "farm",
        "scope",
        "subject",
        "title",
        "description",
        "startEndDate"
      ];

      $ctrl.title = "";
      $ctrl.category = "health";
      $ctrl.farms = sysAdminService.getFarms();
      $ctrl.playerNames = ["Andres", "Arwin", "Daniel", "Fred", "Hyeokjin", "Igor", "Irena", "Jan Jaap", "Jean Marc", "Jenn", "Jorge", "Judary", "Julie", "Leonie", "Mandar", "Marjolein", "Martin", "Nielsm", "Nielsr", "Nynke", "Paul", "Saad", "Sandor", "Snezhana", "Stacey", "Talha", "Thijs", "Timo", "Whitney","Yasir", "Yulia", "Zulfikar", "Extra user 1", "Extra user 2", "Extra user 3", "Extra user 4", "Extra user 5", "Extra user 6", "Extra user 7", "Extra user 8", "Extra user 9", "Extra user 10"];
      $ctrl.players = [];
      angular.forEach($ctrl.playerNames, addPlayer);
      $ctrl.labelsOffset = null;

      $ctrl.sourcelabel = null;

      $ctrl.tags = ["curated", "fuzzy"];

      getToDoStatus();
    }

    function getToDoStatus() {
      $q.all([getToDoCount(), getDoneCount()]).then(function (n) {
        $ctrl.progress = {};
        $ctrl.progress.todo = n[0];
        $ctrl.progress.done = n[1];
        $ctrl.progress.total = n[0] + n[1];
        $ctrl.progress.percentageDone = parseInt(($ctrl.progress.done / $ctrl.progress.total) * 100);
      });
    }

    function addPlayer(name) {
      $ctrl.players.push({ name: name, id: $ctrl.players.length });
    }

    function nextLabel() {
      $ctrl.label = null;

      getSourceLabel().then(
        function (sourcelabel) {
          $ctrl.sourcelabel = sourcelabel;
          addTagToLabel($ctrl.sourcelabel, "checked");
          $ctrl.label = {};
          $ctrl.label.farmID = parseInt(sourcelabel.farmID);
          $ctrl.label.category = "health"; //$stateParams.category;
          $ctrl.label.title = sourcelabel.title; //$stateParams.title;
          $ctrl.label.description = sourcelabel.description; //$stateParams.description;
          $ctrl.label.labelScope = "cow"; //$stateParams.scope || ($stateParams.cowID ? 'cow' : null);
          $ctrl.label.dairyCowID = parseInt(sourcelabel.dairyCowID);
          $ctrl.label.startEpoch = parseInt(sourcelabel.startEpoch);
          $ctrl.label.endEpoch = parseInt(sourcelabel.endEpoch);
          $ctrl.label.createdByUserID = sessionService.user.id;

          $ctrl.label.customerVisible = false;
          $ctrl.label.tags = ["curated"];

          $ctrl.label.description = {};
          $ctrl.label.description.sourceLabelID = sourcelabel.GenericLabelID;
          $ctrl.label.description.sourceLabelDescription = sourcelabel.description;
          $ctrl.label.description.markers = [
            { title: "isSick", epoch: $ctrl.label.startEpoch },
            { title: "recovering", epoch: $ctrl.label.endEpoch }
          ];

          $ctrl.label = labelService.newLabel($ctrl.label);
        },
        function errorCallback() {
          alert("No more insights!");
          $window.location.reload();
        }
      );
    }

    function saveAndNext() {
      save($ctrl.label).then(function () {
        nextLabel();
      });
    }

    function noBehaviourChangeFound() {
      addTagToLabel($ctrl.sourcelabel, "no behaviour change found");
      nextLabel();
    }

    function skipLabel() {
      addTagToLabel($ctrl.sourcelabel, "skipped");
      nextLabel();
    }

    function exit() {
      removeTagFromLabel($ctrl.sourcelabel, "checked");
      $ctrl.labelsOffset = null;
    }

    function addTagToLabel(label, tag) {
      return labelService.addTag(label, tag);
    }

    function removeTagFromLabel(label, tag) {
      return labelService.removeTag(label, tag);
    }

    function getSourceLabel() {
      var deferred = $q.defer();

      $ctrl.loading = true;

      labelService
        .getLabels($ctrl.farm, 1, $ctrl.labelsOffset, {
          orderBy: { variable: "startEpoch", direction: "desc" },
          notTagged: "checked",
          tag: "to-be-curated",
          title: $ctrl.title,
          category: $ctrl.category
        })
        .then(function (labels) {
          if (labels[0]) {
            deferred.resolve(labels[0]);
          } else {
            deferred.reject();
          }

          $ctrl.loading = false;
        });

      return deferred.promise;
    }

    function getToDoCount() {
      var deferred = $q.defer();

      labelService
        .getLabels(
          $ctrl.farm,
          null,
          null,
          {
            notTagged: "checked",
            tag: "to-be-curated",
            title: $ctrl.title,
            category: $ctrl.category
          },
          true
        )
        .then(function (count) {
          deferred.resolve(count);
        });

      return deferred.promise;
    }
    function getDoneCount() {
      var deferred = $q.defer();

      labelService
        .getLabels(
          $ctrl.farm,
          null,
          null,
          {
            tags: ["to-be-curated", "checked"],
            title: $ctrl.title,
            category: $ctrl.category
          },
          true
        )
        .then(function (count) {
          deferred.resolve(count);
        });

      return deferred.promise;
    }

    function labelFormValid() {
      if (!$ctrl.label.title) {
        return false;
      }
      if ($ctrl.label.labelScope === "cow" && !$ctrl.label.dairyCowID) {
        return false;
      }
      if (!$ctrl.label.startEpoch || !$ctrl.label.endEpoch) {
        return false;
      }
      return true;
    }

    function save(obj) {
      if (!labelFormValid()) {
        $window.alert("Something went wrong");
        return false;
      }

      $ctrl.error = "";
      $ctrl.success = "";
      $ctrl.loading = true;

      var promise = labelService.saveLabel(obj);

      promise.then(
        function () {
          $ctrl.loading = false;
          toastr.success($translate.instant("LABEL_TEXT_SAVED"));
          dataApiService.clearDataFromCache("GenericLabels");
        },
        function () {
          $ctrl.loading = false;
          $ctrl.error = $translate.instant("LABEL_TEXT_OOPS");
          toastr.error($translate.instant("LABEL_TEXT_OOPS"));
        }
      );

      return promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.estrusLabelCurating', [
      'ctraUIComponents.labels.labelDetailsForm'
    ])

}());

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin.insights.estrusLabelCurating").component("estrusLabelCurating", {
    controller: estrusLabelCuratingCtrl,
    templateUrl: "app/views/insights/estrusLabelCurating/estrusLabelCurating.html"
  });

  /** @ngInject */
  function estrusLabelCuratingCtrl(
    $scope,
    $window,
    $timeout,
    $state,
    $q,
    sessionService,
    sysAdminService,
    labelService,
    toastr,
    $translate,
    dataApiService
  ) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.save = save;
    $ctrl.labelFormValid = labelFormValid;
    $ctrl.saveAndNext = saveAndNext;
    $ctrl.skipLabel = skipLabel;
    $ctrl.noEstrusFound = noEstrusFound;
    $ctrl.exit = exit;
    $ctrl.nextLabel = nextLabel;
    $ctrl.getToDoStatus = getToDoStatus;

    function onInit() {
      $ctrl.themedHeader = false;
      $ctrl.hideFields = [
        "header",
        "visibility",
        "category",
        "farm",
        "scope",
        "subject",
        "title",
        "description",
        "startEndDate"
      ];

      $ctrl.title = "Estrus";
      $ctrl.category = "fertility";
      $ctrl.farms = sysAdminService.getFarms();
      $ctrl.playerNames = ["Andres", "Arwin", "Daniel", "Fred", "Hyeokjin", "Igor", "Irena", "Jan Jaap", "Jean Marc", "Jenn", "Jorge", "Judary", "Julie", "Leonie", "Mandar", "Marjolein", "Martin", "Nielsm", "Nielsr", "Nynke", "Paul", "Saad", "Sandor", "Snezhana", "Stacey", "Talha", "Thijs", "Timo", "Whitney","Yasir", "Yulia", "Zulfikar", "Extra user 1", "Extra user 2", "Extra user 3", "Extra user 4", "Extra user 5", "Extra user 6", "Extra user 7", "Extra user 8", "Extra user 9", "Extra user 10"];
      $ctrl.players = [];
      angular.forEach($ctrl.playerNames, addPlayer);
      $ctrl.labelsOffset = null;

      $ctrl.sourcelabel = null;

      $ctrl.tags = [sessionService.user.id + "-curated", "fuzzy"];

      getToDoStatus();
    }

    function getToDoStatus() {
      $q.all([getToDoCount(), getDoneCount()]).then(function (n) {
        $ctrl.progress = {};
        $ctrl.progress.todo = n[0];
        $ctrl.progress.done = n[1];
        $ctrl.progress.total = n[0] + n[1];
        $ctrl.progress.percentageDone = parseInt(($ctrl.progress.done / $ctrl.progress.total) * 100);
      });
    }

    function addPlayer(name) {
      $ctrl.players.push({ name: name, id: $ctrl.players.length });
    }

    function nextLabel() {
      $ctrl.label = null;

      getSourceLabel().then(
        function (sourcelabel) {
          $ctrl.sourcelabel = sourcelabel;
          addTagToLabel($ctrl.sourcelabel, "tt-checked");
          $ctrl.label = {};
          $ctrl.label.farmID = parseInt(sourcelabel.farmID);
          $ctrl.label.category = "fertility"; //$stateParams.category;
          $ctrl.label.title = "estrus"; //$stateParams.title;
          $ctrl.label.labelScope = "cow"; //$stateParams.scope || ($stateParams.cowID ? 'cow' : null);
          $ctrl.label.dairyCowID = parseInt(sourcelabel.dairyCowID);
          $ctrl.label.startEpoch = parseInt(sourcelabel.startEpoch);
          $ctrl.label.endEpoch = parseInt(sourcelabel.endEpoch);
          $ctrl.label.createdByUserID = sessionService.user.id;

          $ctrl.label.customerVisible = false;
          $ctrl.label.tags = [sessionService.user.id + "-curated"];

          $ctrl.label.description = {};
          $ctrl.label.description.sourceLabelID = sourcelabel.GenericLabelID;
          $ctrl.label.description.sourceLabelDescription = sourcelabel.description;
          $ctrl.label.description.markers = [
            {
              title: "activityPeak",
              epoch: $ctrl.label.startEpoch + ($ctrl.label.endEpoch - $ctrl.label.startEpoch) / 2
            }
          ];

          $ctrl.label = labelService.newLabel($ctrl.label);
        },
        function errorCallback() {
          alert("No more insights!");
          $window.location.reload();
        }
      );
    }

    function saveAndNext() {
      save($ctrl.label).then(function () {
        nextLabel();
      });
    }

    function noEstrusFound() {
      addTagToLabel($ctrl.sourcelabel, sessionService.user.id + "-no estrus found");
      nextLabel();
    }

    function skipLabel() {
      addTagToLabel($ctrl.sourcelabel, sessionService.user.id + "-skipped");
      nextLabel();
    }

    function exit() {
      removeTagFromLabel($ctrl.sourcelabel, "tt-checked");
      $ctrl.labelsOffset = null;
    }

    function addTagToLabel(label, tag) {
      return labelService.addTag(label, tag);
    }

    function removeTagFromLabel(label, tag) {
      return labelService.removeTag(label, tag);
    }

    function getSourceLabel() {
      var deferred = $q.defer();

      $ctrl.loading = true;

      labelService
        .getLabels($ctrl.farm, 1, $ctrl.labelsOffset, {
          orderBy: { variable: "startEpoch", direction: "desc" },
          notTagged: "tt-checked",
          tag: "to-be-curated",
          title: $ctrl.title,
          category: $ctrl.category
        })
        .then(function (labels) {
          if (labels[0]) {
            deferred.resolve(labels[0]);
          } else {
            deferred.reject();
          }

          $ctrl.loading = false;
        });

      return deferred.promise;
    }

    function getToDoCount() {
      var deferred = $q.defer();

      labelService
        .getLabels(
          $ctrl.farm,
          null,
          null,
          {
            notTagged: "tt-checked",
            tag: "to-be-curated",
            title: $ctrl.title,
            category: $ctrl.category
          },
          true
        )
        .then(function (count) {
          deferred.resolve(count);
        });

      return deferred.promise;
    }
    function getDoneCount() {
      var deferred = $q.defer();

      labelService
        .getLabels(
          $ctrl.farm,
          null,
          null,
          {
            tags: ["tt-checked", "to-be-curated"],
            title: $ctrl.title,
            category: $ctrl.category
          },
          true
        )
        .then(function (count) {
          deferred.resolve(count);
        });

      return deferred.promise;
    }

    function labelFormValid() {
      if (!$ctrl.label.title) {
        return false;
      }
      if ($ctrl.label.labelScope === "cow" && !$ctrl.label.dairyCowID) {
        return false;
      }
      if (!$ctrl.label.startEpoch || !$ctrl.label.endEpoch) {
        return false;
      }
      return true;
    }

    function save(obj) {
      if (!labelFormValid()) {
        $window.alert("Something went wrong");
        return false;
      }

      $ctrl.error = "";
      $ctrl.success = "";
      $ctrl.loading = true;

      var promise = labelService.saveLabel(obj);

      promise.then(
        function () {
          $ctrl.loading = false;
          toastr.success($translate.instant("LABEL_TEXT_SAVED"));
          dataApiService.clearDataFromCache("GenericLabels");
        },
        function () {
          $ctrl.loading = false;
          $ctrl.error = $translate.instant("LABEL_TEXT_OOPS");
          toastr.error($translate.instant("LABEL_TEXT_OOPS"));
        }
      );

      return promise;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin.insights.estrusInsights", []);

}());

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin.insights.estrusInsights")
    .component("estrusInsights", {
      templateUrl: "app/views/insights/estrusInsights/estrusInsights.html",
      controller: estrusInsightsCtrl
    });

    /** @ngInject */
    function estrusInsightsCtrl($state, $window, sysAdminService, insightService) {
      var $ctrl = this;

      $ctrl.$onInit = onInit;
      $ctrl.getInsights = getInsights;
      $ctrl.onInsightClicked = onInsightClicked;
      $ctrl.sortBy = sortBy;
      $ctrl.sortedBy = null;

      function onInit() {

        $ctrl.farms = sysAdminService.getFarms();
        $ctrl.insightsPerPageOptions = [50, 100, 200, 400, 600, 800, 1000, 10000];
        $ctrl.insightsPerPage = 100;


        getInsights();
      }

      function getInsights(){
        $ctrl.loading = true;

        /**
         * Filters.
         * @type {{category: string, insightType: string[], resolved: null, areaID: null|*}}
         */
        var insightServiceFilters = {
          category: "fertility",
          insightType: insightService.ESTRUS_INSIGHT_TYPES,
          resolved: null
        };

        var insightsOffset = 0;

        insightService.getGenericInsightsTodos(
          $ctrl.farm,
          insightServiceFilters,
          false,
          $ctrl.insightsPerPage,
          insightsOffset, {
            includeStaleInsights: true
          }
        ).then(function(insights){

          insights = insights.filter(function(insight){
            var adminValidations = insight.insightValidations.filter(function(validation){
              return validation.validationByID === "Admin";
            });

            if(adminValidations.length > 0) return false;
            return true;
          })

          $ctrl.insights = insights;

          sortBy('createdEpoch')

          $ctrl.loading = false;
        });
      }

      function onInsightClicked(genericInsightID){
        var url = $state.href('insight', {genericInsightID: genericInsightID});
        $window.open(url,'_blank');
      }

      function sortBy(property){

        $ctrl.insights = $ctrl.insights.sort(function (a, b) {
          if(a[property] < b[property]) return -1;
          if(a[property] === b[property]){
            if(a.farmID > b.farmID) return -1;
            if(a.farmID === b.farmID){
              if(parseInt(a.dairyCow.cowTagNumber) > parseInt(b.dairyCow.cowTagNumber)) return 1;
              return -1;
            }
            return 1;
          }
          return 1;

        });

        $ctrl.sortedBy = property;

      }

    }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.estrusInsightCurating', [
      'ctraUIComponents.labels.labelDetailsForm'
    ])

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.insights.estrusInsightCurating')
    .component('estrusInsightCurating', {
      controller: estrusInsightCuratingCtrl,
      templateUrl: 'app/views/insights/estrusInsightCurating/estrusInsightCurating.html'
    });

  /** @ngInject */
  function estrusInsightCuratingCtrl($window, $timeout, $state, $q, sessionService, sysAdminService, labelService, toastr, $translate, dataApiService, insightService) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.save    = save;
    $ctrl.labelFormValid = labelFormValid;
    $ctrl.saveAndNext = saveAndNext;
    $ctrl.skipLabel = skipLabel;
    $ctrl.noEstrusFound = noEstrusFound;
    $ctrl.exit = exit;
    $ctrl.nextLabel = nextLabel;
    $ctrl.getToDoStatus = getToDoStatus;


    function onInit() {

      $ctrl.themedHeader = false;
      $ctrl.hideFields = ["header", "visibility", "category", "farm", "scope", "subject", "title", "description", "startEndDate"]

      $ctrl.title = "inseminated";
      $ctrl.tags = ["curated", "fuzzy"]
      $ctrl.farms = sysAdminService.getFarms();
      $ctrl.playerNames = ["Andres", "Arwin", "Daniel", "Fred", "Hyeokjin", "Igor", "Irena", "Jan Jaap", "Jean Marc", "Jenn", "Jorge", "Judary", "Julie", "Leonie", "Mandar", "Marjolein", "Martin", "Nielsm", "Nielsr", "Nynke", "Paul", "Saad", "Sandor", "Snezhana", "Stacey", "Talha", "Thijs", "Timo", "Whitney","Yasir", "Yulia", "Zulfikar", "Extra user 1", "Extra user 2", "Extra user 3", "Extra user 4", "Extra user 5", "Extra user 6", "Extra user 7", "Extra user 8", "Extra user 9", "Extra user 10"];
      $ctrl.players = [];
      angular.forEach($ctrl.playerNames, addPlayer);
      $ctrl.insightsOffset = null;

      $ctrl.sourceInsight = null;

      getToDoStatus();

    }

    function getToDoStatus(){
      $q.all([getToDoCount(), getDoneCount()]).then(function (n) {
        $ctrl.progress = {};
        $ctrl.progress.todo = n[0];
        $ctrl.progress.done = n[1];
        $ctrl.progress.total = n[0]+n[1];
        $ctrl.progress.percentageDone = parseInt(($ctrl.progress.done/$ctrl.progress.total)*100);
      })
    }

    function addPlayer(name){
      $ctrl.players.push({name: name, id: $ctrl.players.length});
    }

    function nextLabel(){

      $ctrl.label = null;

      getSourceInsight().then(function (sourceInsight) {
        $ctrl.sourceInsight = sourceInsight;
        setChecked($ctrl.sourceInsight, true);
        initValidations();
        $ctrl.label = {};
        $ctrl.label.farmID     = parseInt(sourceInsight.farmID);
        $ctrl.label.category   = "fertility"; //$stateParams.category;
        $ctrl.label.title      = "estrus"; //$stateParams.title;
        $ctrl.label.labelScope = "cow"; //$stateParams.scope || ($stateParams.cowID ? 'cow' : null);
        $ctrl.label.dairyCowID = parseInt(sourceInsight.dairyCowID);
        $ctrl.label.startEpoch = parseInt(sourceInsight.startEpoch);
        $ctrl.label.endEpoch   = parseInt(sourceInsight.endEpoch);
        $ctrl.label.createdByUserID = sessionService.user.id;

        $ctrl.label.customerVisible = false;
        $ctrl.label.tags = ["curated"];

        $ctrl.label.description = {}
        $ctrl.label.description.sourceLabelID = sourceInsight.GenericInsightID;
        $ctrl.label.description.sourceLabelDescription = sourcelabel.description;
        $ctrl.label.description.markers = [
          {title: "activityPeak", epoch: $ctrl.label.startEpoch+($ctrl.label.endEpoch-$ctrl.label.startEpoch)/2}
        ];

        $ctrl.label = labelService.newLabel($ctrl.label);
      }, function errorCallback(){
        alert("No more insights!");
        $window.location.reload();
      });
    }


    function saveAndNext(){
      validateInsight('Yes')
      save($ctrl.label).then(function () {
        nextLabel();
      });
    }

    function noEstrusFound(){
      validateInsight('No')
      nextLabel();
    }
    function skipLabel(){
      validateInsight('NA')
      nextLabel();
    }
    function exit(){
      setChecked($ctrl.sourceInsight, false);
      $ctrl.insightsOffset = null;
    }


    function initValidations() {
      $ctrl.adminValidation = $ctrl.sourceInsight.insightValidations.find(function(element){
        return element.validationByID === "Admin";
      });
      if(!$ctrl.adminValidation) addAdminValidation();


    }

    function addAdminValidation() {
      // Create a new insight
      var insightValidation = {
        validationByID:   "Admin",
        genericInsightID: $ctrl.sourceInsight.GenericInsightID,
        validation:       'NA'
      }
      $ctrl.adminValidation = insightService.newInsightValidation(insightValidation);
    }

    function validateInsight(answer) {
      var now = new Date();

      $ctrl.adminValidation.validation      = ($ctrl.adminValidation.validation !== answer ? answer : 'NA');
      $ctrl.adminValidation.validationEpoch = parseInt(now.getTime()/1000);
      $ctrl.adminValidation = insightService.newInsightValidation($ctrl.adminValidation)

      if($ctrl.adminValidation.InsightValidationID){
        $ctrl.adminValidation.$update()
      }else{
        $ctrl.adminValidation.$save()
      }

    }




    function setChecked(insight, checked){
      insight.notificationSent = checked;
      insightService.updateInsight(insight);
    }


    function getSourceInsight(){
      var deferred = $q.defer();

      $ctrl.loading = true;


      var insightServiceFilters = {
        category: "fertility",
        insightType: insightService.ESTRUS_INSIGHT_TYPES,
        resolved: null,
        adminChecked: false
      };

      insightService.getGenericInsightsTodos(
        $ctrl.farm,
        insightServiceFilters,
        false,
        1,
        $ctrl.insightsOffset, {
          includeStaleInsights: true
        }
      ).then(function(insights){

        if(insights[0]){
          deferred.resolve(insights[0]);
        }else{
          deferred.reject();
        }

        $ctrl.loading = false;

      });

      return deferred.promise;

    }

    function getToDoCount(){
      var deferred = $q.defer();

      var insightServiceFilters = {
        category: "fertility",
        insightType: insightService.ESTRUS_INSIGHT_TYPES,
        resolved: null,
        adminChecked: false
      };

      insightService.getGenericInsightsTodos(
        $ctrl.farm,
        insightServiceFilters,
        true,
        null,
        $ctrl.insightsOffset, {
          includeStaleInsights: true
        }
      ).then(function(count){

        deferred.resolve(count);

        $ctrl.loading = false;

      });
      return deferred.promise;
    }
    function getDoneCount(){
      var deferred = $q.defer();

      var insightServiceFilters = {
        category: "fertility",
        insightType: insightService.ESTRUS_INSIGHT_TYPES,
        resolved: null,
        adminChecked: true
      };

      insightService.getGenericInsightsTodos(
        $ctrl.farm,
        insightServiceFilters,
        true,
        null,
        $ctrl.insightsOffset, {
          includeStaleInsights: true
        }
      ).then(function(count){

        deferred.resolve(count);

        $ctrl.loading = false;

      });

      return deferred.promise;
    }



    function labelFormValid() {
      if(!$ctrl.label.title){
        return false;
      }
      if($ctrl.label.labelScope === 'cow' && !$ctrl.label.dairyCowID){
        return false;
      }
      if(!$ctrl.label.startEpoch || !$ctrl.label.endEpoch){
        return false;
      }
      return true;
    }



    function save(obj){

      if(!labelFormValid()){
        $window.alert("Something went wrong");
        return false;
      }

      $ctrl.error = '';
      $ctrl.success = '';
      $ctrl.loading = true;

      var promise = labelService.saveLabel(obj);

      promise.then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_SAVED"));
        dataApiService.clearDataFromCache("GenericLabels");
      }, function () {
        $ctrl.loading = false;
        $ctrl.error = $translate.instant('LABEL_TEXT_OOPS');
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });

      return promise;
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.reports', [
      'ui.router',
      'ctraAuthentication',
      'ctraDataVisualisations',
      'ctraDataVisualisations.dataVariables',
      'dairyMonitorAdmin.reports.report'
    ]);

}());

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin.reports").config(routerConfig);

  function routerConfig($stateProvider, USER_ROLES) {
    $stateProvider.state("dataExplorer.reports", {
      url: "/reports",
      component: "reports",
      resolve: {
        subjectTypes: function (dataVariablesService) {
          return dataVariablesService.getSubjectTypes();
        }
      },
      data: {
        authorizedRoles: [USER_ROLES.admin]
      }
    });
  }
})();

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin.reports").component("reports", {
    bindings: {
      subjectTypes: "<"
    },
    controller: reportsCtrl,
    templateUrl: "app/views/dataExplorer/reports/reports.html"
  });

  /**
   * @ngInject
   * @param $window
   * @param $scope
   * @param $q
   * @param sysAdminService
   */
  function reportsCtrl($window, $scope, $q, sysAdminService) {
    var $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.onDateChange = onDateChange;
    $ctrl.addVisualisation = addVisualisation;

    function onInit() {
      $ctrl.subjectType = $ctrl.subjectTypes[0];
      $ctrl.subjectID = null;

      $ctrl.startDate = new Date();
      $ctrl.endDate = new Date();
      $ctrl.dayRange = 7;

      $ctrl.startDate.setHours(0, 0, 0, 0);
      $ctrl.startDate.setDate($ctrl.startDate.getDate() - ($ctrl.dayRange - 1));
      $ctrl.endDate.setHours(23, 59, 59, 99);
      $ctrl.endDate.setDate($ctrl.endDate.getDate());

      $ctrl.maxDate = new Date();
      $ctrl.maxDate.setHours(23, 59, 59, 99);

      $ctrl.farms = [];

      var ignoredFarmIDs = [2, 3, 4, 8, 12, 13, 18, 17, 21];

      sysAdminService.getFarms().$promise.then(function (result) {
        $ctrl.farms = result.filter(function (farm) {
          return ignoredFarmIDs.indexOf(farm.FarmID) < 0;
        });
      });

      $ctrl.reports = [1];
    }

    function addVisualisation() {
      $ctrl.reports.push($ctrl.reports.length + 1);
    }

    function onDateChange(startDate, endDate, dayRange) {
      if (endDate.getTime() > $ctrl.maxDate.getTime()) {
        $ctrl.endDate.setDate($ctrl.maxDate.getDate());
        $ctrl.endDate.setHours(23, 59, 59, 99);

        $ctrl.startDate.setDate($ctrl.endDate.getDate() - ($ctrl.dayRange - 1));
      } else {
        $ctrl.startDate = startDate;
        $ctrl.endDate = endDate;
      }

      $ctrl.dayRange = dayRange || $ctrl.dayRange;
      $scope.$apply();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .component('editInsight', {
      bindings: {
        insight: '<'
      },
      controller: editInsightCtrl,
      templateUrl: 'app/views/insight/editInsight/editInsight.html'
    });

  /** @ngInject */
  function editInsightCtrl($window, $state, $q, $translate, toastr) {
    var $ctrl = this;


    $ctrl.$onInit             = onInit;
    $ctrl.update  = updateInsight;
    $ctrl.delete  = deleteInsight;

    function onInit() {
    }


    function updateInsight(){
      var insightClone = angular.copy($ctrl.insight);

      // HACK: the backend does not like it when the object has linked objects inside
      delete insightClone.insightValidations;
      delete insightClone.dairyCow;
      delete insightClone.insightChecks;
      delete insightClone.insightTasks;
      delete insightClone.insightComments;
      delete insightClone.insightType;

      $ctrl.loading = true;
      insightClone.$update().then(function () {
        $ctrl.loading = false;
        toastr.success($translate.instant("LABEL_TEXT_SAVED"));
      }, function () {
        $ctrl.loading = false;
        toastr.error($translate.instant("LABEL_TEXT_OOPS"));
      });
    }

    function deleteInsight(){
      if($window.confirm('Are you sure you want to delete this insight?')){
        $ctrl.loading = true;
        $ctrl.insight.$delete().then(function () {
          $ctrl.loading = false;
          toastr.success($translate.instant("LABEL_TEXT_DELETED"));
          $state.go('main');
        }, function () {
          $ctrl.loading = false;
          toastr.error($translate.instant("LABEL_TEXT_OOPS"));
        });
      }
    }

  }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.partner', [
      'ui.router',
      'ctraAuthentication',
      'dairyMonitorAdmin.farmsMap'
    ]);

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.partner')
    .service('partnerService', partnerService);

  function partnerService($q) {

    var allPartners = [
      {
        id: 1,
        partnerName: "Danone"
      },
      {
        id: 2,
        partnerName: "Schippers"
      }
    ];



    return {
      getPartners: function () {
        return $q.when(allPartners);
      }
    }

  }

}());

(function () {
  'use strict';

  angular.module('dairyMonitorAdmin.partner').config(routerConfig);

  function routerConfig($stateProvider, USER_ROLES) {

    $stateProvider
      .state('dataExplorer.partner', {
        url: '/partner',
        component: 'partner',
        resolve: {
          partners: function (partnerService) {
            return partnerService.getPartners();
          },
          farms: function (sysAdminService) {
            return sysAdminService.getFarms().$promise;
          }
        },
        data: { authorizedRoles: [USER_ROLES.admin] }
      });

  }

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.partner')
    .component('partner', {
      bindings: {
        partners: '<',
        farms: '<'
      },
      controller: partnerCtrl,
      templateUrl: 'app/views/dataExplorer/partner/partner.html'
    });

  /** @ngInject */
  function partnerCtrl() {
    var $ctrl = this;

    $ctrl.$onInit             = onInit;

    function onInit() {
    }

  }

}());

'use strict';

/* global $:false */
/* eslint-disable angular/angularelement */
/* eslint-disable angular/controller-as-vm */

angular.module('dairyMonitorAdmin')
  .controller('SensorDataController', function ($window, $rootScope, $scope, $timeout, $interval, $log, sysAdminService, dataVariablesService) {
    var vm = $scope;

    vm.filters         = {};
    vm.farms           = [];
    vm.cows            = [];
    vm.customers       = [];
    vm.sensors         = [];
    vm.baseStations    = [];
    vm.selectedCows    = [];
    vm.selectedSensors = [];
    vm.expandedBaseStations = [];

    vm.autoRefresh          = false;
    vm.autoRefreshTimer     = null;
    vm.autoRefreshTimestamp = null;
    vm.autoRefreshCountdown = null;
    vm.autoRefreshInterval  = 60;
    vm.autoRefreshSeconds   = null;

    vm.showCsvDownload      = true;

    vm.zoomable  = true;
    vm.startDate = new Date();
    vm.endDate   = new Date();
    vm.dayRange  = 1;

    vm.startDate.setHours(0,0,0,0);
    vm.startDate.setDate(vm.startDate.getDate()-(vm.dayRange-1));
    vm.endDate.setHours(23,59,59,99);
    vm.endDate.setDate(vm.endDate.getDate());

    vm.maxDate       = new Date();
    vm.maxDate.setHours(23,59,59,99);

    $('.nav-tabs a[href]').click(function (e) {
      e.preventDefault();
      $(this).tab('show');
    });

    vm.selectedCows    = [];
    vm.selectedSensors = [];

    var displayValues = [];
    dataVariablesService.getEventsVariables().then(function(variables){
      displayValues = displayValues.concat(variables);
    });



    vm.$watchCollection('selectedSensors', function (newVal, oldVal) {

      // We have to compile a list of cows that belong to the selectedSensors
      // First loop through the selectedSensors ID's and find the sensors
      // Then if the dairyCowID of the sensor is set, add the cow to the selectedCows
      if(newVal !== oldVal){
        vm.selectedCows = [];
        vm.selectedSensors.forEach(function (NodeID) {
          vm.cows.forEach(function(e){
            if(e.nodeID === NodeID){
              vm.selectedCows.push(e);
            }
          });
          updateVisualisations()
        });
      }
    });


    function updateVisualisations(){
      vm.visualisations = [];
      angular.forEach(vm.selectedCows, function (cow) {
        var visual = {};
        visual.id = cow.DairyCowID;
        visual.title = "#"+cow.cowTagNumber+" "+(cow.cowName ? cow.cowName : '');
        visual.displayValues = dataVariablesService.setSubjects(angular.copy(displayValues), {cow: cow.DairyCowID});
        vm.visualisations.push(visual);
      });

    }



    vm.onDateChange = function (startDate, endDate) {
      if(endDate.getTime() > vm.maxDate.getTime()){
        vm.endDate.setDate(vm.maxDate.getDate());
        vm.endDate.setHours(23,59,59,99);

        vm.startDate.setDate(vm.endDate.getDate()-(vm.dayRange-1));
      }else{
        vm.startDate = startDate;
        vm.endDate   = endDate;
      }

      vm.$apply();
    }





    function updateCountdown() {
      var diff = Math.abs(new Date() - vm.autoRefreshTimestamp);
      var seconds = Math.floor((diff/1000));

      vm.autoRefreshSeconds = vm.autoRefreshInterval-seconds;
    }


    vm.refreshData = function() {
      vm.cows         = sysAdminService.getCows();
      vm.sensors      = sysAdminService.getSensors();
      vm.baseStations = sysAdminService.getBaseStations();

      if(vm.autoRefresh){
        vm.autoRefreshTimer     = $timeout(vm.refreshData, vm.autoRefreshInterval*1000);
        vm.autoRefreshTimestamp = new Date();
        vm.autoRefreshSeconds   = vm.autoRefreshInterval;
        vm.autoRefreshCountdown = $interval(updateCountdown, 1000);
      }
    };

    vm.loadData = function () {
      vm.customers = sysAdminService.getCustomers();
      vm.farms     = sysAdminService.getFarms();
      vm.refreshData();
    };
    vm.loadData();

    vm.$watch('autoRefresh', function (newVal, oldVal) {
      if(newVal && newVal !== oldVal){
        vm.refreshData()
      }
      if(!newVal){
        $timeout.cancel(vm.autoRefreshTimer);
        $interval.cancel(vm.autoRefreshCountdown);
      }
    });


    // vm.filterChanged = function(){
    //   if(vm.watchEnabled){
    //     vm.filters.watchEnabled = true;
    //   }else{
    //     delete vm.filters.watchEnabled;
    //   }
    // };

    vm.rowClicked = function(BaseStationID){
      vm.toggleDetails(BaseStationID, vm.expandedBaseStations);
    }

    vm.toggleDetails = function(id, array) {
       var idx = array.indexOf(id);

       // is currently selected
       if (idx > -1) {
         array.splice(idx, 1);
       }else {
         array.push(id);
       }
    };


    // vm.deleteSelectedCows = function(){
    //   var really = $window.confirm("Are you sure you want to delete "+vm.selectedCows.length+" cows?\nThis action cannot be undone!");
    //   if(really){
    //     vm.selectedCows.forEach(function (cowID) {
    //       vm.cows.forEach(function(e,i){
    //         if(e.DairyCowID === cowID){
    //           cowService.deleteCow(e);
    //           vm.cows.splice(i, 1);
    //         }
    //       });
    //     });
    //     vm.selectedCows = [];
    //   }
    // };
    //
    // vm.watchSelectedCows = function(){
    //   vm.selectedCows.forEach(function (cowID) {
    //     vm.cows.forEach(function(e){
    //       if(e.DairyCowID === cowID){
    //         e.watchEnabled = true;
    //         e.$update();
    //       }
    //     });
    //   });
    // };
    //
    // vm.unwatchSelectedCows = function(){
    //   vm.selectedCows.forEach(function (cowID) {
    //     vm.cows.forEach(function(e){
    //       if(e.DairyCowID === cowID){
    //         e.watchEnabled = false;
    //         e.$update();
    //       }
    //     });
    //   });
    // };

    vm.selectAll = function(source, dest, key){
      source.forEach(function (obj) {
        if(dest.indexOf(obj[key]) < 0){
          dest.push(obj[key]);
        }
      });
    };


    vm.unlinkSelectedSensors = function(){
      vm.selectedSensors.forEach(function (id) {
        vm.sensors.forEach(function(e){
          if(e.NodeID === id){
            e.dairyCowID = 0;
            e.$update();
          }
        });
      });
    };


    vm.deleteSelectedSensors = function(){
      var really = $window.confirm("Are you sure you want to delete "+vm.selectedSensors.length+" sensors?\nThis action cannot be undone!");
      if(really){
        vm.selectedSensors.forEach(function (id) {
          vm.sensors.forEach(function(e, i){
            if(e.NodeID === id){
              e.$delete();
              vm.sensors.splice(i, 1);
            }
          });
        });
        vm.selectedSensors = [];
      }
    };



    // vm.goToCow = function(cowID){
    //   cowService.goToCow(cowID);
    // };


    // toggle selectedCows for a given CowID
    vm.toggleSelection = function(id, array) {
      var idx = array.indexOf(id);

      // is currently selected
      if (idx > -1) {
        array.splice(idx, 1);
      }else {
        array.push(id);
      }
    };


    vm.$on("$destroy", function() {
      $timeout.cancel(vm.autoRefreshTimer);
    });
});

'use strict';

/* eslint-disable angular/controller-as-vm */

angular.module('dairyMonitorAdmin')
  .controller('ApiTestController', function ($window, $rootScope, $scope, $timeout, $interval, $log, sysAdminService, dataApiService) {
    var vm = $scope;

    vm.startDate = new Date();
    vm.endDate   = new Date();
    vm.dayRange  = 7;

    vm.startDate.setHours(0,0,0,0);
    vm.startDate.setDate(vm.startDate.getDate()-(vm.dayRange-1));
    vm.endDate.setHours(23,59,59,99);
    vm.endDate.setDate(vm.endDate.getDate());

    vm.maxDate       = new Date();
    vm.maxDate.setHours(23,59,59,99);

    vm.slider = {
      min: 750,
      max: 1500,
      options: {
        floor: 0,
        ceil: 2000,
        step: 50,
        translate: function(value) {
          return value+'ms';
        }
      }
    };

    vm.farms = sysAdminService.getFarms();
    vm.cows  = sysAdminService.getCows();

    vm.farms.$promise.then(function () {
      vm.farms.unshift({farmName: "Select Farm", FarmID: undefined})
      vm.selectedFarm = vm.farms[0];
    });

    vm.selectedCows = [];
    vm.selectedFarms = [];
    vm.selectedFarm = null;

    vm.queries = [];
    vm.currentQueryIndex = 0;
    vm.queryResults = [];
    vm.apiTestStatus = 'inactive';


    vm.runApitest = function () {
      vm.queries           = [];
      vm.currentQueryIndex = 0;
      vm.queryResults      = [];
      vm.apiTestStatus     = 'running';

      angular.forEach(vm.showCharts, function (value, key) {
        $log.log(key, value);

        if(!value) return false;

        angular.forEach(vm.selectedFarms, function (value) {
          if(!value.FarmID) return false;
          vm.queries.push({
            title: value.farmName,
            dataType: key,
            type: 'farm',
            id: value.FarmID,
            startDate: vm.startDate,
            endDate: vm.endDate
          });
        })

        angular.forEach(vm.selectedCows, function (value) {
          if(!value.DairyCowID) return false;
          vm.queries.push({
            title: "#"+value.cowTagNumber,
            dataType: key,
            type: 'cow',
            id: value.DairyCowID,
            startDate: vm.startDate,
            endDate: vm.endDate,
            completed: false
          });
        });
      });

      runNextQuery();
    }

    vm.cancelApitest = function () {
      vm.apiTestStatus = 'cancelled';
    }


    function runNextQuery() {
      var thisQuery = vm.queries[vm.currentQueryIndex];

      if(vm.apiTestStatus === 'cancelled'){
        return false;
      }

      if(!thisQuery){
        vm.apiTestStatus = 'completed';
        return false;
      }

      var requestStartTime = new Date();

      vm.queries[vm.currentQueryIndex].loading = true;

      dataApiService.getData('data', thisQuery.dataType, thisQuery.type, thisQuery.id, thisQuery.startDate, thisQuery.endDate, true, true).then(function successCallback(data) {
        var resultTime = new Date();

        vm.queries[vm.currentQueryIndex].responseTime = (resultTime.getTime() - requestStartTime.getTime());
        vm.queries[vm.currentQueryIndex].successful = true;
        vm.queries[vm.currentQueryIndex].completed = true;
        vm.queries[vm.currentQueryIndex].loading = false;
        vm.queries[vm.currentQueryIndex].sizeEstimation = memorySizeOf(data);
        vm.queries[vm.currentQueryIndex].result = data;

        if(vm.queries[vm.currentQueryIndex].responseTime > vm.slider.options.ceil){
          vm.slider.options.ceil = Math.ceil(vm.queries[vm.currentQueryIndex].responseTime/vm.slider.options.step)*vm.slider.options.step;
        }


        vm.currentQueryIndex++;
        runNextQuery();
      }, function errorCallback() {
        var resultTime = new Date();

        vm.queries[vm.currentQueryIndex].responseTime = (resultTime.getTime() - requestStartTime.getTime());
        vm.queries[vm.currentQueryIndex].successful = false;
        vm.queries[vm.currentQueryIndex].completed = true;
        vm.queries[vm.currentQueryIndex].loading = false;

        vm.currentQueryIndex++;
        runNextQuery();
      });
    }


    function memorySizeOf(obj) {
        var bytes = 0;

        function sizeOf(obj) {
            if(angular.isDefined(obj)) {
                switch(typeof obj) {
                case 'number':
                    bytes += 8;
                    break;
                case 'string':
                    bytes += obj.length * 2;
                    break;
                case 'boolean':
                    bytes += 4;
                    break;
                case 'object':
                    var objClass = Object.prototype.toString.call(obj).slice(8, -1);
                    if(objClass === 'Object' || objClass === 'Array') {
                        for(var key in obj) {
                            if(!obj.hasOwnProperty(key)) continue;
                            sizeOf(obj[key]);
                        }
                    } else bytes += obj.toString().length * 2;
                    break;
                }
            }
            return bytes;
        }

        function formatByteSize(bytes) {
            if(bytes < 1024) return bytes + " bytes";
            else if(bytes < 1048576) return(bytes / 1024).toFixed(3) + " KiB";
            else if(bytes < 1073741824) return(bytes / 1048576).toFixed(3) + " MiB";
            else return(bytes / 1073741824).toFixed(3) + " GiB";
        }

        return formatByteSize(sizeOf(obj));
    }
});

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('InsightsController', function ($window, $rootScope, $scope, $timeout, $interval, $log, sysAdminService) {
    var vm = $scope;

    vm.farms           = [];
    vm.cows            = [];
    vm.customers       = [];

    vm.startDate = new Date();
    vm.endDate   = new Date();
    vm.dayRange  = 3;

    vm.startDate.setHours(0,0,0,0);
    vm.startDate.setDate(vm.startDate.getDate()-(vm.dayRange-1));
    vm.endDate.setHours(23,59,59,99);
    vm.endDate.setDate(vm.endDate.getDate());

    vm.maxDate       = new Date();
    vm.maxDate.setHours(23,59,59,99);

    var displayFarms = [
      2,  // Infinita
      15, // Schippers
      19, // Granja Guzman Vicente
      20, // Stef Penders
      22, // Geurt Kets
      23 // Aitken Farm
    ];

    vm.loadData = function () {
      vm.customers = sysAdminService.getCustomers();
      sysAdminService.getFarms().$promise.then(function (farms) {
        vm.farms = farms.filter(function (value) {
          return displayFarms.indexOf(value.FarmID) > -1;
        });
      })
      vm.cows      = sysAdminService.getCows();
    };
    vm.loadData();

});

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('SensorsController', function ($window, $rootScope, $scope, $timeout, $interval, $log, sysAdminService) {
    var vm = $scope;

    vm.customers    = sysAdminService.getCustomers();
    vm.farms        = sysAdminService.getFarms();
    vm.baseStations = sysAdminService.getBaseStations();
    vm.sensors      = sysAdminService.getSensors();
    vm.cows         = sysAdminService.getCows();

    vm.selectedSensors = [];

    vm.sensorAdded = function (sensors) {
      angular.forEach(sensors, function (sensor) {
        vm.sensors.push(sensor);
      });
      vm.showForm = '';
    }


});

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.lifeCycle')
    .component('lifeCycle', {
      controller: LifeCycleController,
      templateUrl: 'app/views/hardware/lifeCycle/lifeCycle.html'
    });

  /**
   * @ngInject
   * @param sysAdminService
   * @param lodash
   * @param baseStationService
   * @param boxService
   * @param toastr
   * @return {LifeCycleController}
   */
  function LifeCycleController(sysAdminService, lodash, baseStationService, boxService, toastr) {
    var $ctrl = this;

    /**
     * @type {[]}
     */
    this.baseStations = [];

    /**
     * @type {[]}
     */
    this.sensors = [];

    /**
     * @type {boolean}
     */
    this.isBaseStationListLoading = false;

    /**
     *
     * @type {boolean}
     */
    this.isSensorListLoading = false;

    /**
     * life cycle state
     * @type {[]}
     */
    this.lifeCycleState = [
      "Inventory",
      "In transit (to farm)",
      "Stock (farm)",
      "Waiting for return",
      "In transit (from farm)",
      "Return received",
      "RCA requested",
      "Root caused",
      "To be refurbished"
    ].map(function (item) {
      return { id: item, value: item };
    });

    /**
     * Init
     */
    this.$onInit = function() {
      this.isBaseStationListLoading = true;
      this.isSensorListLoading = true;
      sysAdminService.getBaseStations().$promise.then(function(data) {
        this.baseStations = this.createList(data, {
          id: "BaseStationID",
          value: "deviceName"
        });
        this.isBaseStationListLoading = false;
      }.bind(this));

      sysAdminService.getSensors().$promise.then(function(data) {
        this.sensors = data;
        this.isSensorListLoading = false;
      }.bind(this));
    };

    /**
     * Update a base station life cycle
     * @param {object} baseStation
     */
    this.updateBaseStationLifeCycle = function(baseStation) {
      baseStationService.updateLifeCycle(baseStation.id, baseStation.lifeCycleState).then(function() {
        toastr.success("Base Station life cycle updated");
      }, function(error) {
        toastr.error("Something went wrong while updating the lifecycle");
      })
    };

    /**
     * Update a box life cycle
     * @param {object} box
     */
    this.updateBoxLifeCycle = function(box) {
      boxService.updateLifeCycle(box.id, box.lifeCycleState).then(function() {
        toastr.success("Batch Life cycle updated");
      }, function(error) {
        toastr.error("Something went wrong while updating the lifecycle");
      })
    };

    /**
     * Update senspr life cycle
     * @param {object} sensor
     */
    this.updateSensorLifeCycle = function(sensor) {
      var sensorData = this.sensors.find(function(singleSensor) {
        return singleSensor.deviceSerialNum === sensor.id
      });

      if (sensorData) {
        sensorData.lifeCycleState = sensor.lifeCycleState
        sensorData.$patch().then(function() {
          toastr.success("Sensor Life cycle updated");
        }, function() {
          toastr.error("Something went wrong while updating the lifecycle");
        });
      } else {
        toastr.error("Please enter correct device serial number");
      }
    };

    /**
     * create an array of object by extracting values from data based on the options object
     * @param {array} data
     * @param {object} lookup
     * @return {array}
     */
    this.createList = lodash.memoize(function(data, lookup) {

      lookup = lodash.assign(
        {
          id: "id",
          value: "value"
        },
        lookup || {}
      );

      return data.map(function(obj) {
        return {
          id : obj[lookup.id],
          value: obj[lookup.value]
        };
      });
    });
  }

}());

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('BaseStationsController', function ($scope, sysAdminService) {
    var vm = $scope;

    vm.farm;
    vm.baseStations;
    
    vm.farms                = sysAdminService.getFarms();
    vm.baseStations         = sysAdminService.getBaseStations();

    vm.baseStationAdded = function (baseStation) {
      vm.baseStations.push(baseStation);
      vm.showForm = '';
    }
});

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('RolesController', function ($scope, sysAdminService, roleService) {
    var vm = $scope;

    vm.roles     = [];

    // roleService.getRoles().then(function successCallback(response) {
    //   vm.roles = response;
    // });

    vm.roleAdded = function (/*role*/) {
      // vm.roles.push(role);
      vm.showNewRoleForm = false;
      roleService.getRoles().then(function successCallback(response) {
        vm.roles = response.sort(function (a,b) {
          if(a.name < b.name) return -1;
          return 1;
        });
      });
    }

    vm.roleAdded();

});

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('FarmsController', function ($scope, sysAdminService) {
    var vm = $scope;

    vm.farms;
    vm.customers;

    vm.farms     = sysAdminService.getFarms();
    vm.customers = sysAdminService.getCustomers();

    vm.farmAdded = function (farm) {
      vm.farms.push(farm);
      vm.showForm = '';
    }

});

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('UsersController', function ($scope, sysAdminService, userService) {
    var vm = $scope;

    vm.farms     = sysAdminService.getFarms();
    vm.customers = sysAdminService.getCustomers();
    vm.users     = [];

    vm.userAdded = function (/*user*/) {
      // vm.users.push(user);
      vm.showNewUserForm = false;
      userService.getUsers().then(function successCallback(response) {
        vm.users = response.sort(function (a, b) {
          if(a.email < b.email) return -1;
          return 1;

        });
      });
    }

    vm.userAdded();

});

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('CustomersController', function ($scope, sysAdminService, userService) {
    var vm = $scope;

    vm.farms     = sysAdminService.getFarms();
    vm.customers = sysAdminService.getCustomers();
    vm.users     = [];

    userService.getUsers().then(function successCallback(response) {
      vm.users = response;
    });

    vm.customerAdded = function (customer) {
      vm.customers.push(customer);
      vm.showForm = '';
    }

});

'use strict';

angular.module('dairyMonitorAdmin')
  .controller('CowsController', function ($scope, sysAdminService) {
    var vm = $scope;

    vm.cows       = sysAdminService.getCows();
    vm.herdGroups = sysAdminService.getHerdGroups();
    vm.farms      = sysAdminService.getFarms();
    vm.sensors    = sysAdminService.getSensors();

    vm.cowAdded = function (cows) {
      angular.forEach(cows, function (cow) {
        vm.cows.push(cow);
      });
      vm.showForm = '';
    }

});

(function () {
  "use strict";

  angular
    .module("ctraDataVisualisations.dataVariables", ["ctraDataVisualisations.contextMenu"])
    .service("dataVariablesService", dataVariablesService);

  /**
   * @param $q
   * @param $window
   * @param sessionService
   * @param insightService
   * @param lodash
   * @return {{}}
   * @ngInject
   */
  function dataVariablesService($q, $window, sessionService, insightService, lodash, contextMenuService) {
    /**
     * @type {string}
     */
    var dynamicStatsSource = "dynamicStatsWindowed"; // or "dynamicStatsUnscaled"

    /**
     * Get weather aggregation window
     * @param dayRange
     * @return {number}
     */
    function getWeatherAggregationWindow(dayRange) {
      /**
       * @type {number}
       */
      var HOUR = 3600;

      /**
       * @type {number}
       */
      var agWindow = HOUR / 2;

      if (dayRange <= 1) {
        agWindow = HOUR;
      } else {
        agWindow = HOUR * 24;
      }

      return agWindow;
    }

    /**
     * Get weather aggregation interval
     * @param dayRange
     * @return {number}
     */
    function getWeatherAggregationInterval(dayRange) {
      /**
       * @type {number}
       */
      var HOUR = 3600;

      /**
       * @type {number}
       */
      var agInterval = HOUR / 2;

      if (dayRange <= 1) {
        agInterval = HOUR;
      } else {
        agInterval = HOUR * 24;
      }

      return agInterval;
    }

    /**
     * Weather graph config
     * @type {{}}
     */
    var weather = {
      temperature: {
        name: "Temperature",
        id: "Temperature",
        dataType: "degrees",
        color: "#EECC00",
        source: "weatherInfo",
        showPredictions: true,
        getAggregationWindow: getWeatherAggregationWindow,
        getAggregationInterval: getWeatherAggregationInterval
      },
      apparentTemperature: {
        name: "Apparent Temperature",
        id: "ApparentTemperature",
        dataType: "degrees",
        color: "#EE8800",
        source: "weatherInfo",
        showPredictions: true,
        getAggregationWindow: getWeatherAggregationWindow,
        getAggregationInterval: getWeatherAggregationInterval
      },
      humidity: {
        name: "Humidity",
        id: "Humidity",
        dataType: "percentage",
        color: "#0099EE",
        source: "weatherInfo",
        showPredictions: true,
        getAggregationWindow: getWeatherAggregationWindow,
        getAggregationInterval: getWeatherAggregationInterval
      }
    };

    weather = setDefaults(weather);

    /**
     * Diet graph config
     * @type {{}}
     */
    var diet = {
      ruminating: {
        name: "Ruminating",
        id: "RuminatingDuration",
        style: "area",
        dataType: "seconds",
        color: "#FF9900",
        source: dynamicStatsSource
      },
      eating: {
        name: "Eating",
        id: "EatingDuration",
        style: "area",
        dataType: "seconds",
        color: "#228800",
        source: dynamicStatsSource
      },
      drinking: {
        name: "Drinking",
        id: "DrinkingDuration",
        style: "area",
        dataType: "seconds",
        color: "#0077FF",
        source: dynamicStatsSource
      },
      other: {
        name: "Other",
        id: "OtherDuration",
        style: "area",
        dataType: "seconds",
        color: "#999",
        source: dynamicStatsSource
      }
    };

    diet = setDefaults(diet);

    /**
     * Farm-level diet config
     * @type {{}}
     */
    var dietFarm = setProperties(diet, {
      scope: "farm",
      style: "line",
      options: {
        strokeDashed: true
      }
    });

    /**
     * Activity config
     * @type {{}}
     */
    var activity = {
      walking: {
        name: "Walking",
        id: "WalkingDuration",
        style: "area",
        dataType: "seconds",
        color: "#BB3399",
        source: dynamicStatsSource
      },
      standing: {
        name: "Standing",
        id: "StandingDuration",
        style: "area",
        dataType: "seconds",
        color: "#116699",
        source: dynamicStatsSource
      },
      laying: {
        name: "Laying",
        id: "LayingDuration",
        style: "area",
        dataType: "seconds",
        color: "#aacc22",
        source: dynamicStatsSource
      },
      idle: {
        name: "Idle",
        id: "IdleDuration",
        style: "area",
        dataType: "seconds",
        color: "#999",
        source: dynamicStatsSource
      }
    };

    activity = setDefaults(activity);

    /**
     * Farm-level activity config
     */
    var activityFarm = setProperties(activity, {
      scope: "farm",
      style: "line",
      options: {
        strokeDashed: true
      }
    });

    /**
     * Milk production config
     * @type {{}}
     */
    var production = {
      milkYield: {
        name: "Milk Yield",
        id: "MilkKgPerDay",
        style: "area",
        dataType: "kg",
        color: "#11aa88",
        source: "milkYield"
      }
    };

    production = setDefaults(production);

    /**
     * Insights config
     * @type {{}}
     */
    var insights = {
      insight: {
        name: "Insights",
        id: "GenericInsights",
        isVisible: false,
        showPredictions: false,
        style: "insight",
        source: "GenericInsights",
        api: "oDataAPI",
        colors: {
          fertility: "#BB3399",
          health: "#c40202",
          feed: "#55ac55",
          insightValidationYes: "#90c422",
          insightValidationMaybe: "#f0ad4e",
          insightValidationNo: "#f60303",
          insightValidationNA: "transparent"
        },
        filters: {
          /*
           * You may populate this to filter insights.
           * Just pick any key and value which should be present
           * in the GenericInsight object.
           */
        },
        options: {
          filtering: [
            /*
             * This shall contain all the possible filters
             * to list under the rendered DOM element.
             */
          ]
        }
      },
      label: {
        name: "Labels",
        id: "GenericLabels",
        isVisible: false,
        showPredictions: false,
        style: "insight",
        source: "GenericLabels",
        api: "oDataAPI",
        colors: {
          fertility: "#BB3399",
          health: "#c40202",
          feed: "#55ac55",
          other: "#156da5"
        }
      }
    };

    insights = setDefaults(insights);

    /**
     * Latency config
     * @type {{}}
     */
    var latency = {
      averageLatency: {
        name: "Avg. Latency",
        id: "AverageLatency",
        dataType: "seconds",
        color: "#00bbbb",
        source: dynamicStatsSource
      },
      maxLatency: {
        name: "Max. Latency",
        id: "MaxLatency",
        dataType: "seconds",
        color: "#dd0011",
        source: dynamicStatsSource
      }
    };

    latency = setDefaults(latency);

    /**
     * Farm-level latency config
     */
    var latencyFarm = setProperties(latency, {
      scope: "farm",
      style: "line",
      options: {
        strokeDashed: true
      }
    });

    /**
     * Events config
     * @type {{}}
     */
    var events = {
      stream1: {
        name: "Raw Events stream1",
        id: "stream1",
        style: "timeline",
        source: "eventsCSV",
        colors: {
          Ruminating: "#FF9000",
          Eating: "#228800",
          Idle: "#666666",
          Walking: "#BB3399",
          Gap: "#CCCCCC",
          Other: "#999999"
        }
      },
      stream2: {
        name: "Raw Events stream2",
        id: "stream2",
        style: "timeline",
        source: "eventsCSV",
        colors: {
          Walking: "#BB3399",
          Standing: "#116699",
          Laying: "#aacc22"
        }
      },
      stream3: {
        name: "Raw Events stream3",
        id: "stream3",
        style: "timeline",
        source: "eventsCSV",
        colors: {
          Ruminating: "#FF9000",
          Eating: "#228800",
          Other: "#999999"
        }
      },
      eventLatency: {
        name: "Event Latency",
        id: "EventLatency",
        style: "scatterPlot",
        dataType: "seconds",
        source: "eventsCSV",
        colors: {
          detectionTime: "#1f77b4",
          cloudRecieveTime: "#bcbd22"
        }
      }
    };

    events = setDefaults(events);

    /**
     * Chart styles
     * @type {string[]}
     */
    var generalChartStyles = ["line", "bar", "stackedBar", "area", "stackedArea"];

    /**
     * Farm settings
     * @type {*[]}
     */
    var farmSettings = [
      {
        name: "Weather",
        settings: setProperties(toArray(weather), {
          scope: "farm"
        }),
        style: "line",
        styles: generalChartStyles
      },
      {
        name: "Activity",
        settings: setProperties(toArray(activity), {
          scope: "farm"
        }),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Diet",
        settings: setProperties(toArray(diet), {
          scope: "farm"
        }),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Farm Insights",
        settings: setProperties(toArray(insights), {
          scope: "farm"
        })
      },
      {
        name: "Cow Insights",
        settings: setProperties(toArray(insights), {
          scope: "allCowsOfFarm"
        })
      },
      {
        name: "Herd Insights",
        settings: setProperties(toArray(insights), {
          scope: "herd"
        })
      },
      {
        name: "Latency",
        settings: setProperties(toArray(latency), {
          scope: "farm"
        }),
        style: "line",
        styles: generalChartStyles
      }
    ];

    /**
     * Herd group settings
     * @type {*[]}
     */
    var herdGroupSettings = [
      {
        name: "Activity",
        settings: setProperties(toArray(activity), {
          scope: "herdGroup"
        }),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Diet",
        settings: setProperties(toArray(diet), {
          scope: "herdGroup"
        }),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Insights",
        settings: setProperties(toArray(insights), {
          scope: "herdGroup"
        })
      }
    ];

    /**
     * Cow chart settings
     * @type {*[]}
     */
    var cowSettings = [
      {
        name: "Weather",
        settings: toArray(weather),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Activity",
        settings: toArray(activity),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Diet",
        settings: toArray(diet),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Production",
        settings: toArray(production),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Farm Activity",
        settings: toArray(activityFarm),
        styles: generalChartStyles
      },
      {
        name: "Farm Diet",
        settings: toArray(dietFarm),
        styles: generalChartStyles
      },
      {
        name: "Latency",
        settings: toArray(latency),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Farm Latency",
        settings: toArray(latencyFarm),
        style: "area",
        styles: generalChartStyles
      },
      {
        name: "Raw Events",
        settings: toArray(events)
      }
    ];

    var subjectTypesLoader = $q.defer();
    var insightModelsLoader = insightService.getInsightModels();
    var insightTypesLoader = insightService.getInsightTypes();

    /**
     * Subject types
     * @type {*[]}
     */
    var subjectTypes = [
      {
        id: "farm",
        title: "Farm",
        settings: farmSettings
      },
      {
        id: "herdGroup",
        title: "Herd Group",
        settings: herdGroupSettings
      }
    ];

    insightTypesLoader.then(function (insightTypes) {
      insights.insight.options.filtering = lodash.map(insightTypes, function (type) {
        return {
          insightType: lodash.pick(type, ["title", "InsightTypeID"])
        };
      });

      var asArray = toArray(insights);

      cowSettings.splice(6, 0, {
        name: "Insights",
        settings: asArray
      });

      farmSettings.splice(4, 1, {
        name: "Cow Insights",
        settings: setProperties(asArray, {
          scope: "allCowsOfFarm"
        })
      });
    });

    insightModelsLoader.then(
      function (result) {
        /**
         * @type {{}}
         */
        var insightProbabilityHBASE = {};

        /**
         * @type {{}}
         */
        var insightProbabilityKafka = {};

        result.forEach(function (value) {
          /**
           * @type {{name: *, id: *, dataType: string, source: string}}
           */
          insightProbabilityHBASE[value.modelName] = {
            name: value.modelName,
            id: value.modelName,
            dataType: "percentage",
            source: "insightsCSV"
          };

          /**
           * @type {{name: *, id: *, dataType: string, source: string}}
           */
          insightProbabilityKafka[value.modelName] = {
            name: value.modelName,
            id: value.modelName,
            dataType: "percentage",
            source: "insightOutcomesCSV"
          };
        });

        insightProbabilityHBASE = setDefaults(insightProbabilityHBASE);
        insightProbabilityKafka = setDefaults(insightProbabilityKafka);

        /**
         * Add insight models to cow settings.
         */
        cowSettings.push(
          {
            name: "Insight Probability Kafka",
            settings: toArray(insightProbabilityKafka),
            style: "line",
            styles: generalChartStyles
          },
          {
            name: "Insight Probability HBASE",
            settings: toArray(insightProbabilityHBASE),
            style: "line",
            styles: generalChartStyles
          }
        );

        /**
         * Extend subject types with "cow".
         */
        subjectTypes.push({
          id: "cow",
          title: "Cow",
          settings: cowSettings
        });

        subjectTypesLoader.resolve(subjectTypes);
      },
      function () {
        subjectTypesLoader.reject();
      }
    );

    /**
     * Set default config
     * @param obj
     * @return {*}
     */
    function setDefaults(obj) {
      /**
       * @type {{
       *   scope: string,
       *   style: string,
       *   isVisible: boolean,
       *   options: {},
       *   api: string,
       *   showPredictions: boolean,
       *   getAggregationWindow: getAggregationWindow,
       *   getAggregationInterval: getAggregationInterval,
       *   bleed: string
       * }}
       */
      var defaults = {
        scope: "cow",
        style: "line",
        isVisible: false,
        options: {},
        api: "dataAPI",
        showPredictions: false,

        /**
         * @param dayRange
         * @return {number}
         */
        getAggregationWindow: function (dayRange) {
          var HOUR = 3600;
          var agWindow;

          if (dayRange <= 1) {
            agWindow = HOUR;
          } else if (dayRange <= 3) {
            agWindow = HOUR * 2;
          } else {
            agWindow = HOUR * 24;
          }

          return agWindow;
        },

        /**
         * @param dayRange
         * @return {number}
         */
        getAggregationInterval: function (dayRange) {
          var HOUR = 3600;
          var agInterval;

          if (dayRange <= 7) {
            agInterval = HOUR;
          } else if (dayRange <= 31) {
            agInterval = HOUR * 6;
          } else {
            agInterval = HOUR * 24;
          }

          return agInterval;
        },

        bleed: "50%"
      };

      angular.forEach(obj, function (item) {
        angular.forEach(defaults, function (value, key) {
          if (!item[key]) {
            item[key] = value;
          }
        });
      });

      return obj;
    }

    /**
     * Flatten an object to an array (similar to lodash.values)
     * @param obj
     * @return {any[]}
     */
    function toArray(obj) {
      return Object.keys(obj).map(function (key) {
        return angular.copy(obj[key]);
      });
    }

    /**
     * Set properties in each of the elements of an array
     * @param array
     * @param properties
     * @return {*}
     */
    function setProperties(array, properties) {
      array = angular.copy(array);

      angular.forEach(array, function (e) {
        angular.forEach(properties, function (p, key) {
          e[key] = p;
        });
      });

      return array;
    }

    /**
     * Get subject types
     * @return {Promise<any>}
     */
    function getSubjectTypes() {
      return $q.when(subjectTypesLoader.promise);
    }

    /**
     * Set subjects
     * @param values
     * @param subjects
     * @return {[]}
     */
    function setSubjects(values, subjects) {
      values = angular.copy(values);

      angular.forEach(values, function (value) {
        value.subjectId = subjects[value.scope];
      });

      return values;
    }

    /**
     * Get cow analytics visualisations
     * @param subjects
     * @return {{charts: Array}}
     */
    function getCowAnalyticsVisualisations(subjects) {
      /**
       * @type {any[]}
       */
      var insightsArray = toArray(insights);

      /**
       * @type {{charts: Array}}
       */
      var visualisations = {
        charts: []
      };

      /**
       * @type {*[]}
       */
      var variablesDiet = [diet.ruminating, dietFarm.ruminating, diet.eating, dietFarm.eating].concat(
        insightsArray
      );

      variablesDiet = setSubjects(variablesDiet, subjects);

      visualisations.charts.push({
        scope: "cow",
        title: "HEADER_TEXT_FEED",
        displayValues: variablesDiet,
        contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
      });

      /**
       * @type {*[]}
       */
      var variablesActivity = [
        activity.standing,
        activityFarm.standing,
        activity.laying,
        activityFarm.laying,
        activity.walking,
        activityFarm.walking
      ].concat(insightsArray);

      variablesActivity = setSubjects(variablesActivity, subjects);

      visualisations.charts.push({
        scope: "cow",
        title: "HEADER_TEXT_ACTIVITY",
        displayValues: variablesActivity,
        contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
      });

      return visualisations;
    }

    /**
     * Get herd group analytics visualisations
     * @param subjects
     * @param options
     * @return {{charts: Array}}
     */
    function getHerdGroupAnalyticsVisualisations(subjects, options) {
      options = lodash.assign(
        {
          insightsIncluded: true,
          insightScope: "herdGroup"
        },
        options || {}
      );

      /**
       * @type {{charts: Array, dayRange: number}}
       */
      var visualisations = {
        charts: [],
        dayRange: $window.innerWidth <= 768 ? 7 : 31
      };

      /**
       * @type {[]}
       */
      var insightsArray = options.insightsIncluded
        ? setProperties(toArray(insights), {
            scope: options.insightScope
          })
        : [];

      /**
       * @type {*[]}
       */
      var variablesDiet = [diet.ruminating, diet.eating];

      variablesDiet = setProperties(variablesDiet, {
        scope: "herdGroup"
      });

      variablesDiet = variablesDiet.concat([dietFarm.ruminating, dietFarm.eating]);

      variablesDiet = variablesDiet.concat(insightsArray);

      variablesDiet = setSubjects(variablesDiet, subjects);

      visualisations.charts.push({
        scope: "herdGroup",
        title: "HEADER_TEXT_FEED",
        displayValues: variablesDiet
      });

      /**
       * @type {*[]}
       */
      var variablesActivity = [activity.standing, activity.laying, activity.walking];

      variablesActivity = setProperties(variablesActivity, {
        scope: "herdGroup"
      });

      variablesActivity = variablesActivity.concat([
        activityFarm.standing,
        activityFarm.laying,
        activityFarm.walking
      ]);

      variablesActivity = variablesActivity.concat(insightsArray);

      variablesActivity = setSubjects(variablesActivity, subjects);

      visualisations.charts.push({
        scope: "herdGroup",
        title: "HEADER_TEXT_ACTIVITY",
        displayValues: variablesActivity
      });

      return visualisations;
    }

    /**
     * Get farm analytics visualisations
     * @param subjects
     * @param options
     * @return {{charts: Array}}
     */
    function getFarmAnalyticsVisualisations(subjects, options) {
      options = lodash.assign(
        {
          insightsIncluded: true,
          feedInsightsIncluded: true,
          activityInsightsIncluded: true,
          insightScope: "allCowsOfFarm"
        },
        options || {}
      );

      /**
       * @type {{charts: Array}}
       */
      var visualisations = {
        charts: []
      };

      /**
       * @type {[]}
       */
      var insightsArray =
        options.insightsIncluded || options.feedInsightsIncluded || options.activityInsightsIncluded
          ? setProperties(toArray(insights), {
              scope: options.insightScope
            })
          : [];

      /**
       * @type {[]}
       */
      var variablesDiet = setProperties([diet.ruminating, diet.eating], {
        scope: "farm"
      });

      if (options.insightsIncluded || options.feedInsightsIncluded) {
        variablesDiet = variablesDiet.concat(insightsArray);
      }
      variablesDiet = setSubjects(variablesDiet, subjects);

      visualisations.charts.push({
        scope: "farm",
        title: "HEADER_TEXT_FEED",
        displayValues: variablesDiet,
        contextMenu: contextMenuService.getAddEventMenu("farm", subjects)
      });

      /**
       * @type {[]}
       */
      var variablesActivity = setProperties([activity.standing, activity.laying, activity.walking], {
        scope: "farm"
      });

      if (options.insightsIncluded || options.activityInsightsIncluded) {
        variablesActivity = variablesActivity.concat(insightsArray);
      }
      variablesActivity = setSubjects(variablesActivity, subjects);

      visualisations.charts.push({
        scope: "farm",
        title: "HEADER_TEXT_ACTIVITY",
        displayValues: variablesActivity,
        contextMenu: contextMenuService.getAddEventMenu("farm", subjects)
      });

      return visualisations;
    }

    /**
     * @return {Promise<any>}
     */
    function getEventsVariables() {
      return $q.when(toArray(events));
    }

    /**
     * Get insight visualisations
     * @param scope
     * @param insightType
     * @param subjects
     * @return {Promise<any>}
     */
    function getInsightVisualisations(scope, insightType, subjects) {
      /**
       * @type {Promise<any>}
       */
      var deferred = $q.defer();

      /* eslint-disable no-redeclare */

      /**
       * @type {{charts: Array}}
       */
      var visualisations = {
        charts: []
      };

      /**
       * @type {number}
       */
      visualisations.dayRange = $window.innerWidth <= 768 ? 7 : 31;

      /**
       * @type {any[]}
       */
      var insightsArray = toArray(insights);

      /**
       * @type {boolean}
       */
      var isEstrusType =
        [
          "fertility",
          "Estrus",
          "EstrusInsight",
          "FirstEstrusAfterCalving",
          "CowIsInEstrus",
          "PostCalvingMissedEstrus",
          "CowCanBeInseminated",
          "IrregularEstrousCycle",
          "EstrousCycleDuringPregnancy",
          "Estrus2H_01",
          "Vote_5d_2H",
          "CowInEstrus",
          "Vote_5d_2H_NDP",
          "ComposedEstrusInsight",
          "Venus"
        ].indexOf(insightType) > -1;

      /**
       * @type {boolean}
       */
      var isFeedEfficiencyType =
        ["feed", "feedEfficiency", "FeedingEfficiencyHighInsight"].indexOf(insightType) > -1;

      /**
       * Extend visualisations for estrus type insights
       */
      if (scope === "cow" && isEstrusType) {
        var variables = [diet.ruminating, diet.eating, activity.walking, activity.laying].concat(
          insightsArray
        );

        variables = setSubjects(variables, subjects);

        visualisations.charts.push({
          scope: scope,
          title: "HEADER_TEXT_ACTIVITY_FEED",
          displayValues: variables,
          contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
        });
      } else if (scope === "cow" && isFeedEfficiencyType) {
        /**
         * Extend visualisations for feed efficiency type insights
         */
        /**
         * @type {*[]}
         */
        var variables1 = [production.milkYield].concat(insightsArray);

        variables1 = setSubjects(variables1, subjects);

        visualisations.charts.push({
          scope: scope,
          title: "HEADER_TEXT_MILK_YIELD",
          displayValues: variables1,
          contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
        });

        /**
         * @type {*[]}
         */
        var variables2 = [diet.ruminating, dietFarm.ruminating, diet.eating, dietFarm.eating].concat(
          insightsArray
        );

        variables2 = setSubjects(variables2, subjects);

        visualisations.charts.push({
          scope: scope,
          title: "HEADER_TEXT_FEED",
          displayValues: variables2,
          contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
        });
      } else if (scope === "farm" && insightType === "heatStress") {
        /**
         * Extend visualisations for farm level, heat stress type insights
         */
        /**
         * @type {*[]}
         */
        var variables1 = [weather.humidity, weather.apparentTemperature, insights.heatStress];

        variables1 = setProperties(variables1, {
          scope: "farm",
          style: "area"
        });

        variables1 = setSubjects(variables1, subjects);

        visualisations.charts.push({
          scope: scope,
          title: "HEADER_TEXT_WEATHER",
          displayValues: variables1
        });

        /**
         * @type {*[]}
         */
        var variables2 = [activity.laying, activity.standing, insights.heatStress];

        variables2 = setProperties(variables2, {
          scope: "farm"
        });

        variables2 = setSubjects(variables2, subjects);

        visualisations.charts.push({
          scope: scope,
          title: "HEADER_TEXT_ACTIVITY",
          displayValues: variables2
        });

        /**
         * @type {*[]}
         */
        var variables3 = [diet.ruminating, diet.eating, insights.heatStress];

        variables3 = setProperties(variables3, {
          scope: "farm"
        });

        variables3 = setSubjects(variables3, subjects);

        visualisations.charts.push({
          scope: scope,
          title: "HEADER_TEXT_FEED",
          displayValues: variables3
        });
      } else if (scope === "cow" && insightType === "MajorHealthIssueInsight") {
        /**
         * Extend visualisations for major health issue type insights
         */
        /**
         * @type {number}
         */
        visualisations.dayRange = 3;

        /**
         * @type {*[]}
         */
        var variablesDiet = [diet.ruminating, dietFarm.ruminating, diet.eating, dietFarm.eating].concat(
          insightsArray
        );

        variablesDiet = setSubjects(variablesDiet, subjects);

        visualisations.charts.push({
          scope: "cow",
          title: "HEADER_TEXT_FEED",
          displayValues: variablesDiet,
          contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
        });

        /**
         * @type {*[]}
         */
        var variablesActivity = [
          activity.standing,
          activityFarm.standing,
          activity.laying,
          activityFarm.laying,
          activity.walking,
          activityFarm.walking
        ].concat(insightsArray);

        variablesActivity = setSubjects(variablesActivity, subjects);

        visualisations.charts.push({
          scope: "cow",
          title: "HEADER_TEXT_ACTIVITY",
          displayValues: variablesActivity,
          contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
        });
      } else if (scope === "cow" && insightType === "ObviousHealthInsight") {
        /**
         * Extend visualisations for Captain Stoop insights
         */
        /**
         * @type {number}
         */
        visualisations.dayRange = 1;

        /**
         * @type {*[]}
         */
        var variablesDiet = [diet.ruminating, dietFarm.ruminating, diet.eating, dietFarm.eating].concat(
          insightsArray
        );

        variablesDiet = setSubjects(variablesDiet, subjects);

        visualisations.charts.push({
          scope: "cow",
          title: "HEADER_TEXT_FEED",
          displayValues: variablesDiet,
          contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
        });

        /**
         * @type {*[]}
         */
        var variablesActivity = [
          activity.standing,
          activityFarm.standing,
          activity.laying,
          activityFarm.laying,
          activity.walking,
          activityFarm.walking
        ].concat(insightsArray);

        variablesActivity = setSubjects(variablesActivity, subjects);

        visualisations.charts.push({
          scope: "cow",
          title: "HEADER_TEXT_ACTIVITY",
          displayValues: variablesActivity,
          contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
        });
      } else if (scope === "cow") {
        /**
         * Extend visualisations for cow level insights
         */
        visualisations.charts = visualisations.charts.concat(getCowAnalyticsVisualisations(subjects).charts);
      } else if (scope === "herdGroup") {
        /**
         * Extend visualisations for herd group level insights
         */
        visualisations.charts = visualisations.charts.concat(
          getHerdGroupAnalyticsVisualisations(subjects).charts
        );
      } else if (scope === "farm") {
        /**
         * Extend visualisations for farm level insights
         */
        /**
         * @type {{charts: Array}}
         */
        var farmAnalytics = getFarmAnalyticsVisualisations(subjects, {
          insightScope: "farm"
        });

        visualisations.charts = visualisations.charts.concat(farmAnalytics.charts);
      }

      deferred.resolve(visualisations);

      return $q.when(deferred.promise);
    }

    /**
     * Get label visualisations
     * @param scope
     * @param category
     * @param subjects
     * @return {Promise<any>}
     */
    function getLabelVisualisations(scope, category, subjects) {
      /**
       * @type {Promise<any>}
       */
      var deferred = $q.defer();

      /* eslint-disable no-redeclare */

      /**
       * @type {{charts: Array}}
       */
      var visualisations = {
        charts: []
      };

      /**
       * @type {number}
       */
      visualisations.dayRange = $window.innerWidth <= 768 ? 7 : 31;

      /**
       * @type {any[]}
       */
      var insightsArray = toArray(insights);

      /**
       * Extend visualisations for estrus type insights
       */
      if (scope === "cow" && category === "fertility") {
        var variables = [
          diet.ruminating,
          dietFarm.ruminating,
          diet.eating,
          dietFarm.eating,
          activity.laying,
          activityFarm.laying,
          activity.walking,
          activityFarm.walking
        ].concat(insightsArray);

        variables = setSubjects(variables, subjects);

        visualisations.charts.push({
          scope: scope,
          title: "HEADER_TEXT_ACTIVITY_FEED",
          displayValues: variables,
          contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
        });
      } else if (scope === "cow" && category === "feed") {
        /**
         * Extend visualisations for feed efficiency type insights
         */
        /**
         * @type {*[]}
         */
        var variables = [diet.ruminating, dietFarm.ruminating, diet.eating, dietFarm.eating].concat(
          insightsArray
        );

        variables = setSubjects(variables, subjects);

        visualisations.charts.push({
          scope: scope,
          title: "HEADER_TEXT_FEED",
          displayValues: variables,
          contextMenu: contextMenuService.getAddEventMenu("cow", subjects)
        });
      } else if (scope === "cow") {
        /**
         * Extend visualisations for major health issue type insights
         */
        /**
         * @type {{charts: Array}}
         */
        var cowAnalytics = getCowAnalyticsVisualisations(subjects);

        visualisations.charts = visualisations.charts.concat(cowAnalytics.charts);
      } else if (scope === "farm") {
        /**
         * Extend visualisations for farm level insights
         */
        /**
         * @type {{charts: Array}}
         */
        var farmAnalytics = getFarmAnalyticsVisualisations(subjects, {
          insightScope: "farm"
        });

        visualisations.charts = visualisations.charts.concat(farmAnalytics.charts);
      }

      deferred.resolve(visualisations);

      return $q.when(deferred.promise);
    }

    /**
     * @type {{
     *   getSubjectTypes: getSubjectTypes,
     *   setSubjects: setSubjects,
     *   getCowAnalyticsVisualisations: getCowAnalyticsVisualisations,
     *   getHerdGroupAnalyticsVisualisations: getHerdGroupAnalyticsVisualisations,
     *   getFarmAnalyticsVisualisations: getFarmAnalyticsVisualisations,
     *   getEventsVariables: getEventsVariables,
     *   getInsightVisualisations: getInsightVisualisations
     *   getLabelVisualisations: getLabelVisualisations
     * }}
     */
    var intf = {
      getSubjectTypes: getSubjectTypes,
      setSubjects: setSubjects,
      getCowAnalyticsVisualisations: getCowAnalyticsVisualisations,
      getHerdGroupAnalyticsVisualisations: getHerdGroupAnalyticsVisualisations,
      getFarmAnalyticsVisualisations: getFarmAnalyticsVisualisations,
      getEventsVariables: getEventsVariables,
      getInsightVisualisations: getInsightVisualisations,
      getLabelVisualisations: getLabelVisualisations
    };

    return intf;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraDataVisualisations.contextMenu", [])
    .service("contextMenuService", contextMenuService);

  /**
   * @ngInject
   */
  function contextMenuService ($window, $translate, $state, authenticationService) {
    /**
     * Label scopes
     * @type {Object}
     */
    var SCOPES = {
      cow:  "cow", 
      farm: "farm"
    };
    
    /**
     * Label categories
     * @type {Object}
     */
    var CATEGORIES = { 
      health:    'health',
      fertility: 'fertility',
      feed:      'feed',
      system:    'system'
    };
    
    /**
     * Label durations
     * @type {Object}
     */
    var DURATIONS = {
      hour: 3600,
      halveDay: 43200,
      day: 86400
    };
    
    /**
     * Get context menu
     * @param scope
     * @param subjects
     * @return {*}
     */
    function getAddEventMenu(scope, subjects){
      var contextMenu;
      
      contextMenu = {};
      contextMenu.menu = [
        { title: $translate.instant("BUTTON_TEXT_ADD_EVENT") },
        { divider: true }]
      
      if(scope === SCOPES.cow){
        contextMenu.menu.push({
          title: $translate.instant("Estrus"),
          action: function() {
            
            var url = $state.href('newLabel', {
              scope: SCOPES.cow, 
              category: CATEGORIES.fertility,
              title:'Estrus', 
              farmID: subjects.farm,
              cowID: subjects.cow,
              startEpoch: contextMenu.epoch,
              duration: DURATIONS.hour,
              hideFields: true
            });
            
            $window.open(url,'_blank');
          }
        });
        
        contextMenu.menu.push({
          title: $translate.instant("Calving"),
          action: function() {
            var url = $state.href('newLabel', {
              scope: SCOPES.cow, 
              category: CATEGORIES.fertility,
              title:'Calving', 
              farmID: subjects.farm,
              cowID: subjects.cow,
              startEpoch: contextMenu.epoch,
              duration: DURATIONS.halveDay,
              hideFields: '["category", "farm", "scope", "subject"]'
            });
            
            $window.open(url,'_blank');
          }
        });
        
        
        // When a user is an Admin, show more options
        if(authenticationService.isAuthorized("Admin")){
          
          contextMenu.menu.push({
            title: $translate.instant("Defect sensor"),
            action: function() {
              var url = $state.href('newLabel', {
                scope: SCOPES.cow, 
                category:CATEGORIES.system,
                title:'Dead sensor', 
                farmID: subjects.farm,
                cowID: subjects.cow,
                startEpoch: contextMenu.epoch,
                duration: DURATIONS.day,
                hideFields: '["category", "farm", "scope", "subject"]'
              });
              
              $window.open(url,'_blank');
            }
          });
        }
        
        contextMenu.menu.push({
          title: $translate.instant("Other"),
          action: function() {
            var url = $state.href('newLabel', {
              scope: SCOPES.cow, 
              farmID: subjects.farm,
              cowID: subjects.cow,
              startEpoch: contextMenu.epoch
            });
            
            $window.open(url,'_blank');
          }
        })
      }
      
      
      if(scope === SCOPES.farm){
        // When a user is an Admin, show more options
        if(authenticationService.isAuthorized("Admin")){

          contextMenu.menu.push({ 
            title: $translate.instant("Outage"),
            action: function() {
              
              var url = $state.href('newLabel', {
                scope: SCOPES.farm, 
                category:'system',
                title:'Outage', 
                farmID: subjects.farm,
                startEpoch: contextMenu.epoch,
                duration: DURATIONS.day,
                hideFields: '["category", "scope"]'
              });
              
              $window.open(url,'_blank');
            }
          });  
        }
        
        contextMenu.menu.push({ 
          title: $translate.instant("Feed changed"),
          action: function() {
            
            var url = $state.href('newLabel', {
              scope: SCOPES.farm, 
              category: CATEGORIES.feed,
              title:'Feed changed',
              farmID: subjects.farm,
              startEpoch: contextMenu.epoch,
              duration: DURATIONS.day,
              hideFields: '["category", "scope", "title"]'
            });
            
            $window.open(url,'_blank');
          }
        });  

        contextMenu.menu.push({
          title: $translate.instant("Other"),
          action: function() {
            var url = $state.href('newLabel', {
              scope: SCOPES.farm,
              farmID: subjects.farm,
              startEpoch: contextMenu.epoch,
              hideFields: '["scope"]'
            });
            
            $window.open(url,'_blank');
          }
        })
      }
      
      return contextMenu;      
    }
    




    /**
     * @type {{
     *   getContextMenu: getContextMenu,
     * }}
     */
    var intf = {
      getAddEventMenu: getAddEventMenu
    };

    return intf;
  }

}());

(function () {
  "use strict";

  angular.module("ctraUIComponents").service("userService", UserService);

  /**
   * user related functionality
   * @ngInject
   * @param CachingService
   * @param lodash
   * @param appConfig
   * @param appSessionService
   * @param sessionService
   * @param $http
   * @param $q
   * @param $log
   * @return {UserService}
   */
  function UserService(CachingService, lodash, appConfig, appSessionService, $http, sessionService, $q, $log) {
    this.users = {};

    /**
     * Get all the users of a farm
     */
    this.getAllUsers = CachingService.memoize(
      function () {
        var url = appConfig.USERSURL + "connected-users";

        return $http
          .get(url, {
            params: {
              farmID: appSessionService.farm.FarmID
            }
          })
          .then(
            function (response) {
              this.users = lodash.flatMap(lodash.values(response.data)).reduce(function (acc, user) {
                acc[user.userID] = user;
                return acc;
              }, {});
            }.bind(this)
          );
      }.bind(this),
      {
        key: function () {
          return appSessionService.farm.FarmID;
        },
        link: {
          type: "topic",
          id: "connected-users"
        }
      }
    );

    /**
     * Get the full display name of the user
     * @param user
     * @return {string}
     */
    this.getDisplayName = function (user) {
      return lodash.compact([user.givenName, user.surName]).join(" ") || user.username;
    };

    /**
     * Get a user by its user id
     * @param id
     * @return {{}}
     */
    this.resolveFromUserID = function (id) {
      return this.users[id];
    };

    /**
     * Update User Locale inside UserPreference for SQL DB
     * @param locale
     * @return {Promise}
     */
    this.updateUserLocale = function (locale) {
      var user = sessionService.user;
      var userPreferences = {};

      /**
       * Edge Cases Handling:
       * 1- When User preferences are not set initally from admin portal
       *    and user.userPreferences is null
       * 2- Some other characters like extra spaces or not a valid serializable
       *    object is stored mistakenly as a preference
       */
      if (user.userPreferences && user.userPreferences !== "") {
        userPreferences = angular.fromJson(user.userPreferences);
      } else if (angular.isObject(userPreferences)) {
        userPreferences = {};
      }

      userPreferences.Locale = locale;
      user.userPreferences = angular.toJson(userPreferences);

      return $http({
        method: "POST",
        url: appConfig.LEGACYAUTHAPIURL + "Users/Update",
        headers: {
          "Content-Type": "application/json"
        },
        data: user
      });
    };

    /**
     * Fetch the localisation settings of the current user
     * @return {Promise<any>}
     */
    this.fetchLocalization = function () {
      var dfd = $q.defer();
      var url = [appConfig.accountService, "self/preferences/localization"].join("");

      $http.get(url).then(
        function (response) {
          dfd.resolve(response.data);
        },
        function (error) {
          $log.error("An error occurred while fetching localisation preferences", error);
          dfd.reject(error);
        }
      );

      return dfd.promise;
    };
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents").service("StateManagementService", StateManagementService);

  /**
   * @ngInject
   * @param localStorageService
   * @constructor
   */
  function StateManagementService(localStorageService) {
    /**
     * Routes which are considered "main pages" in navigation
     * @type {string[]}
     * @private
     */
    var _mainPageStates = [
      "insightsTimeline",
      "dashboard",
      "missingEstrus",
      "askIda",
      "analytics",
      "cows",
      "sensorAlerts.actionable",
      "sensorAlerts.resolved",
      "ranking.intro",
      "settings.account",
      "inseminations",
      "insights",
      "insight",
      "calvings",
      "insights.insightType",
      "groupInsights.actionable",
      "groupInsights.resolved",
      "cows.herdGroup",
      "gamePlans.active",
      "gamePlans.previous"
    ];

    /**
     * Get breadcrumbs from localstorage
     * @type {string[]}
     */
    this.backStack = localStorageService.get("stateManagement") || [];

    /**
     * Push a state to the backstack
     * There might be cases where going back from a nested state
     * to one of the main states will cause the main state to be added
     * to the backstack twice. This method checks that a main state
     * cannot be added mulitple times consecutively.
     * @param {string} state
     */
    this.pushState = function (state) {
      if (_mainPageStates.includes(state)) {
        if (this.backStack[this.backStack.length - 1] !== state) {
          this.backStack.push(state);
        }
      } else {
        this.backStack.push(state);
      }

      this.saveStateToLocalStorage();
    };

    /**
     * Saves the backstack state to local storage to account for page refreshes
     */
    this.saveStateToLocalStorage = function () {
      localStorageService.set("stateManagement", this.backStack);
    };

    /**
     * Returns the difference to the last main Page state
     *
     * e.g. insight-timeline -> insight -> insight -> insight
     * In this case this method will return 3 i.e. We have to go back three times in order to reach a main page state
     */
    this.getDifferenceToMainPageStates = function () {
      var count = 0;
      var index = 0;

      for (index = this.backStack.length - 1; index >= 0; index--) {
        if (_mainPageStates.includes(this.backStack[index])) {
          return count;
        }

        count++;
      }

      return count;
    };

    /**
     * Removes the last n entries from the backstack
     */
    this.clearFromBottom = function (n) {
      this.backStack.splice(this.backStack.length - n, n);
      this.saveStateToLocalStorage();
    };

    /**
     * Clears the back stack
     *
     * Use this method when reaching the home state
     */
    this.clear = function () {
      this.backStack = [];
      this.saveStateToLocalStorage();
    };

    /**
     * get back stack length
     * @return {number}
     */
    this.getBackStackLength = function () {
      return this.backStack.length;
    };

    /**
     * get back stack most recent value
     */
    this.getBackStackRecentValue = function() {
      return this.backStack[this.getBackStackLength() - 1];
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .service("sensorValidationService", sensorValidation);

  /**
   * @ngInject
   * @return {sensorValidation}
   */
  function sensorValidation () {
    /**
     * @type {number[]}
     */
    var LONG_SERIAL_LENGTH = [32, 22];

    /**
     * @type {number}
     */
    var SHORT_SERIAL_LENGTH = 6;

    /**
     * @type {RegExp}
     */
    var ALPHA_NUMERIC_REGEX = /^[0-9a-zA-Z]+$/;

    /**
     * @type {RegExp}
     */
    var HEX_REGEX = /^[0-9A-F]+$/;

    /**
     * @param val
     * @return {[]|null}
     */
    var validateHexadecimal = function (val) {
      return val.match(HEX_REGEX);
    };

    /**
     * @param val
     * @return {[]|null}
     */
    var validateAlphaNumeric = function (val) {
      return val.match(ALPHA_NUMERIC_REGEX);
    };

    /**
     * @param val
     * @return {boolean}
     */
    this.validateLongSerialNum = function (val) {
      return validateHexadecimal(val) && LONG_SERIAL_LENGTH.includes(val.length);
    };

    /**
     * Validate short serial number while being backward compatible.
     * @param val
     * @return {boolean}
     */
    this.validateShortSerialNum = function (val) {
      return this.validateLongSerialNum(val) ||
        (validateAlphaNumeric(val) && val.length === SHORT_SERIAL_LENGTH);
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents.insight")
    .service("insightCheckService", insightCheckService);

  /**
   * Insight check service. Resolve different insight by asking questions and saving the answers.
   * @param $http
   * @param $translate
   * @param appConfig
   * @param lodash
   * @param toastr
   * @returns {insightCheckService}
   * @ngInject
   */
  function insightCheckService ($http, $translate, appConfig, lodash, toastr) {
    /**
     * Endpoint URL. Staging or production.
     * @type {string}
     */
    var PROTOCOL_AND_DOMAIN = appConfig.DATAAPIURL;

    /**
     * Endpoints to call with $http in order to iterate through the insight resolution process.
     * @type {{resolutions, recommendedChecks, nextRecommendedCheck, allSeenRecommendedChecks}}
     */
    var ENDPOINTS = {
      resolutions: lodash.template("${url}/resolutions/${insightID}"), // same for GET and POST
      recommendedCheck: lodash.template("${url}/RecommendedCheck"),
      nextRecommendedCheck: lodash.template("${url}/nextRecommendedCheck/${insightID}"),
      allSeenRecommendedChecks: lodash.template("${url}/allSeenRecommendedChecks/${insightID}"),
      resetCheckProgress: lodash.template("${url}/ClearRecommendedChecks/{insightID}")
    };

    /**
     * Assume happy flow and handle all the data calls similarly.
     * @param {{before: function, after: function}} options
     * @return {Function}
     */
    function decorateServerCall (options) {
      options = lodash.assign({
        before: function () {},
        after: function () {}
      }, options || {});

      /**
       * @param {Promise<any>} dfd - Promise to resolve
       */
      return function (dfd) {
        options.before();

        return dfd
        // Fire a toastr error when something goes wrong.
          .catch(requestFailed)
          // Unset loading.
          .finally(options.after);
      };
    }

    /**
     * Callback to use when a service request is failed.
     */
    function requestFailed () {
      toastr.error($translate.instant("LABEL_TEXT_OOPS"));
    }

    /**
     * Get all the possible resolutions for the given insight.
     * @memberOf insightCheckService
     * @param {number} insightID
     * @returns {Promise<any>}
     */
    function getResolutions (insightID) {
      return $http.get(ENDPOINTS.resolutions({
        url: PROTOCOL_AND_DOMAIN,
        insightID: insightID
      }));
    }

    /**
     * Set a value on the given recommended check.
     * @memberOf insightCheckService
     * @param {Object} insightCheck - insight check object
     * @param {Object} changes - changes in insight check
     * @returns {Promise<any>}
     */
    function updateInsightCheck (insightCheck, changes) {
      var newInsightCheck = lodash.assign({}, insightCheck, changes);

      return $http.post(ENDPOINTS.recommendedCheck({
        url: PROTOCOL_AND_DOMAIN
      }), newInsightCheck);
    }

    /**
     * Set a resolution on the insight.
     * @memberOf insightCheckService
     * @param {number} insightID
     * @param {Object} resolution
     * @returns {Promise<any>}
     */
    function setResolution (insightID, resolution) {
      return $http.post(ENDPOINTS.resolutions({
        url: PROTOCOL_AND_DOMAIN,
        insightID: insightID
      }), resolution);
    }

    /**
     * Get the next recommended check based on the ones the user has alreay answered.
     * @memberOf insightCheckService
     * @param insightID
     * @returns {Promise<any>}
     */
    function getNextRecommendedCheck (insightID) {
      return $http.get(ENDPOINTS.nextRecommendedCheck({
        url: PROTOCOL_AND_DOMAIN,
        insightID: insightID
      }));
    }

    /**
     * Get the list of recommended cheks which the user has already answered.
     * @memberOf insightCheckService
     * @param insightID
     * @returns {Promise<any>}
     */
    function getAllSeenRecommendedChecks (insightID) {
      return $http.get(ENDPOINTS.allSeenRecommendedChecks({
        url: PROTOCOL_AND_DOMAIN,
        insightID: insightID
      }));
    }

    /**
     * Reset the progress of the questionnaire to 0 questions answered.
     * @memberOf insightCheckService
     * @param insightID
     * @returns {Promise<any>}
     */
    function resetCheckProgress (insightID) {
      return $http.delete(ENDPOINTS.resetCheckProgress({
        url: PROTOCOL_AND_DOMAIN,
        insightID: insightID
      }));
    }

    /**
     * Public interface of the insightCheckService module.
     * @type {{
     *  getResolutions: insightCheckService.getResolutions,
     *  updateInsightCheck: insightCheckService.updateInsightCheck,
     *  getNextRecommendedCheck: insightCheckService.getNextRecommendedCheck,
     *  getAllSeenRecommendedChecks: insightCheckService.getAllSeenRecommendedChecks,
     *  resetCheckProgress: resetCheckProgress
     *  decorateServerCall: decorateServerCall
     * }}
     */
    var intf = {
      getResolutions: getResolutions,
      setResolution: setResolution,
      updateInsightCheck: updateInsightCheck,
      getNextRecommendedCheck: getNextRecommendedCheck,
      getAllSeenRecommendedChecks: getAllSeenRecommendedChecks,
      resetCheckProgress: resetCheckProgress,
      decorateServerCall: decorateServerCall
    };

    // Assign all the data call functions to the local context to create static members.
    // eg. InsightService.getResolutions(insightID);
    lodash.forOwn(intf, function (endpointCall, key) {
      this[key] = endpointCall;
    }.bind(this));

    return this;
  }

})();

/* eslint-disable angular/module-getter */

(function () {
  "use strict";

  angular.module("ctraUIComponents.insight").service("insightService", insightService);

  /**
   * Insight service
   * @ngInject
   * @param $odata
   * @param $odataresource
   * @param appConfig
   * @param $q
   * @param $log
   * @param $translate
   * @param toastr
   * @param sessionService
   * @param lodash
   * @param dateTimeService
   * @param insightResolutionService
   * @param ValidationService
   * @param INSIGHT_CATEGORIES
   * @return {insightService}
   */
  function insightService(
    $odata,
    $odataresource,
    appConfig,
    $q,
    $log,
    $translate,
    toastr,
    sessionService,
    lodash,
    dateTimeService,
    insightResolutionService,
    ValidationService,
    INSIGHT_CATEGORIES
  ) {
    /**
     * @type {insightService}
     */
    var self = this;

    /**
     * @type {{}}
     */
    var intf = {
      getGenericInsight: getGenericInsight,
      getGenericInsights: getGenericInsights,
      getGenericInsightsBetween: getGenericInsightsBetween,
      getGenericInsightsTodos: getGenericInsightsTodos,
      updateInsight: updateInsight,
      logInsemination: logInsemination,
      logCalving: logCalving,
      logFromWorkflow: logFromWorkflow,
      updateInsightResolution: updateInsightResolution,
      isEstrusInsight: isEstrusInsight,
      isCalvingInsight: isCalvingInsight,
      newInsightValidation: newInsightValidation,
      getInsightValidations: getInsightValidations,
      validateInsight: validateInsight,
      newInsightCheck: newInsightCheck,
      getInsightChecks: getInsightChecks,
      getInsightCollections: getInsightCollections,
      getInsightTypes: getInsightTypes,
      getInsightType: getInsightType,
      newInsightType: newInsightType,
      getInsightModels: getInsightModels,
      getInsightModel: getInsightModel,
      newInsightModel: newInsightModel,
      getInsightsBefore: getInsightsBefore,
      getInsightsAfter: getInsightsAfter,
      getContext: getContext,
      isRepeatOffender: isRepeatOffender,
      getInsightResolutions: getInsightResolutions,
      getLB: getLB,
      getDim: getDim,
      isResolved: isResolved
    };

    lodash.forOwn(intf, function (method, methodName) {
      self[methodName] = method;
    });

    /**
     * Array of insight types that must be filtered out if the cows is flagged as "Do not breed"
     */
    this.CULLED_TYPE_BLACK_LIST = ["estrus", "majorhealthissueinsight", "obvioushealthinsight", "vote_5d_2h"];

    /**
     * The keys to expand most of our queries with.
     * @type {string[]}
     */
    var BASIC_EXPANSION_PACK = ["dairyCow", "insightValidations", "insightType", "genericLabels"];

    /**
     * @type {{inseminated: string, notInseminated: string}}
     */
    var INSEMINATION_VALUES = {
      inseminated: "inseminated",
      notInseminated: "not_inseminated"
    };

    /**
     * @type {{calved: string, notCalved: string}}
     */
    var CALVING_VALUES = {
      calved: "calved",
      notCalved: "not_calved"
    };

    /**
     * I have no better idea, we use "workflow" values for the insights
     * which are workflow related, this way we guarantee that the list
     * will show the proper option [cross, tick] selected.
     * @type {{approved: string, dismissed: string}}
     */
    var WORKFLOW_VALUES = (this.WORKFLOW_VALUES = {
      approved: "approved",
      dismissed: "not_approved"
    });

    /**
     * @type {{yes: string, no: string, noAnswer: string}}
     */
    var VALIDATION_TYPES = (this.VALIDATION_TYPES = insightResolutionService.VALIDATION_TYPES);

    /**
     * Create a deferred reject wrapper
     * @param dfd
     * @return {function(*=): *}
     */
    function rejectDeferred(dfd) {
      /**
       * Reject deferred
       * @param error
       * @return {*}
       */
      return function (error) {
        return dfd.reject(error);
      };
    }

    /**
     * Bulk-expand an odata query without repeating the same function
     * @param oDataQuery
     * @param expandKeys
     * @return {*}
     */
    function expandWith(oDataQuery, expandKeys) {
      /**
       * @type {string}
       */
      var withKey = lodash.first(expandKeys);

      /**
       * @type {Array|string}
       */
      var tail = lodash.tail(expandKeys);

      var expanded = oDataQuery.expand(withKey);

      return tail.length ? expandWith(expanded, tail) : expanded;
    }

    /**
     * Filter for the given insight states
     * @param query
     * @param states
     * @return {*}
     */
    function filterInsightStates(query, states) {
      if (angular.isArray(states)) {
        /**
         * @type {Array}
         */
        var predicates = [];

        angular.forEach(states, function (state) {
          predicates.push(new $odata.Predicate("insightState", state));
        });

        /**
         * @type {*|number}
         */
        var combination = $odata.Predicate.or(predicates);

        query.filter(combination);
      } else if (states) {
        query.filter("insightState", states);
      }

      return query;
    }

    /**
     * Create a filter for resolved/unresolved insight queries
     * @param query
     * @param resolved
     * @return {*}
     */
    function filterForResolved(query, resolved) {
      if (resolved) {
        query.filter(
          $odata.Predicate.and([
            new $odata.Predicate("insightResolution", "!=", null),
            new $odata.Predicate("insightResolution", "!=", "null"),
            new $odata.Predicate("insightResolution", "!=", "[]")
          ])
        );
      } else if (resolved === false) {
        query.filter(
          $odata.Predicate.or([
            new $odata.Predicate("insightResolution", null),
            new $odata.Predicate("insightResolution", "null"),
            new $odata.Predicate("insightResolution", "[]")
          ])
        );
      }

      return query;
    }

    /**
     * Create a category predicate
     * @param {string} category
     * @return {string}
     */
    function createCategoryPredicate(category) {
      return ["insightType/insightCategory", category].join(" ");
    }

    /**
     * Filter for the given insight categories
     * @param query
     * @param categories
     * @return {*}
     */
    function filterInsightCategories(query, categories) {
      if (angular.isArray(categories)) {
        /**
         * @type {Array}
         */
        var categoryPredicates = [];

        angular.forEach(categories, function (category) {
          categoryPredicates.push(new $odata.Predicate(createCategoryPredicate(category)));
        });

        /**
         * @type {*|number}
         */
        var categorycombination = $odata.Predicate.or(categoryPredicates);

        query.filter(categorycombination);
      } else if (categories) {
        query.filter("insightType/insightCategory", categories);
      }

      return query;
    }

    /**
     * Create filter for insight types (including negated ones)
     * @param query
     * @param set
     * @param options
     * @return {*}
     */
    function filterWithInsightTypes(query, set, options) {
      var predicates, combination;

      /**
       * @type {string}
       */
      var typeName = "insightType/typeName";

      /**
       * @type {{}}
       */
      options = lodash.assign(
        {
          negated: false
        },
        options || {}
      );

      if (angular.isArray(set)) {
        /**
         * @type {Array}
         */
        predicates = [];

        angular.forEach(set, function (insightType) {
          var predicate = options.negated
            ? new $odata.Predicate(typeName, "!=", insightType)
            : new $odata.Predicate(typeName, insightType);

          predicates.push(predicate);
        });

        combination = $odata.Predicate[options.negated ? "and" : "or"](predicates);

        query.filter(combination);
      } else if (options.negated) {
        query.filter(typeName, "!=", set);
      } else {
        query.filter(typeName, set);
      }

      return query;
    }

    /**
     * Generic insight oData resource
     */
    var GenericInsight = $odataresource(
      appConfig.APIURL + "odata/GenericInsights",
      {},
      {},
      {
        odatakey: "GenericInsightID"
      }
    );

    /**
     * Get all insights for the given parameters.
     * @param farmID
     * @param states
     * @param categories
     * @param limit
     * @param offset
     * @return {*}
     */
    function _getUnprocessedInsights(farmID, states, categories, limit, offset) {
      /**
       * @type {Array|*}
       */
      var query = expandWith(GenericInsight.odata(), BASIC_EXPANSION_PACK).orderBy("endEpoch", "desc");

      /* eslint-disable angular/module-getter */

      if (farmID) {
        query.filter("farmID", farmID);
      }

      if (offset) {
        query.skip(offset);
      }

      if (limit) {
        query.take(limit);
      }

      /**
       * Filter for the given insight states.
       * @type {*}
       */
      query = filterInsightStates(query, states);

      /**
       * Filter insight categories
       * @type {*}
       */
      query = filterInsightCategories(query, categories);

      $log.info(
        [
          "Fetching GenericInsight from the database",
          ", states: ",
          states,
          ", limit: ",
          limit,
          ", offset: ",
          offset
        ].join("")
      );

      return query.query().$promise;
    }

    function _getUnprocessedInsightById(genericInsightID) {
      /**
       * @type {number | null}
       */
      genericInsightID = parseInt(genericInsightID) || null;

      var baseQuery = GenericInsight.odata().filter("GenericInsightID", genericInsightID);

      $log.info("Fetching GenericInsight from the database", genericInsightID);

      return expandWith(baseQuery, BASIC_EXPANSION_PACK).orderBy("endEpoch", "desc").single().$promise;
    }

    /**
     * Get an insight by its id
     * @param genericInsightID
     * @return {*}
     */
    function getGenericInsight(genericInsightID) {
      var dfd = $q.defer();

      /**
       * Resolve the insight query
       * @param value
       */
      var resolveQuery = function (value) {
        var processedValue = processInsight(value);

        dfd.resolve(processedValue);
      };

      _getUnprocessedInsightById(genericInsightID).then(resolveQuery, rejectDeferred(dfd));

      return dfd.promise;
    }

    /**
     * Get generic insights of a farm.
     * @param farmID
     * @param states
     * @param categories
     * @param limit
     * @param offset
     */
    function getGenericInsights(farmID, states, categories, limit, offset) {
      var dfd = $q.defer();

      /**
       * Resolve the insight query
       * @param value
       */
      var resolveQuery = function (value) {
        var processedValue = processInsights(value);

        dfd.resolve(processedValue);
      };

      _getUnprocessedInsights(farmID, states, categories, limit, offset).then(
        resolveQuery,
        rejectDeferred(dfd)
      );

      return dfd.promise;
    }

    /**
     * Get insights todos (what it means, no idea ^^)
     * @param farmID
     * @param filters
     * @param countOnly
     * @param limit
     * @param offset
     * @param options
     * @return {*}
     */
    function getGenericInsightsTodos(farmID, filters, countOnly, limit, offset, options) {
      var dfd = $q.defer();

      /**
       * Set default options
       * @type {{includeStaleInsights: boolean}}
       */
      options = lodash.assign(
        {
          includeStaleInsights: false
        },
        options || {}
      );

      /**
       * Query for insights
       * @type {Array|*}
       */
      var query = expandWith(GenericInsight.odata(), BASIC_EXPANSION_PACK).orderBy("endEpoch", "desc");

      /* eslint-disable angular/module-getter */

      if (farmID) {
        query.filter("farmID", farmID);
      }

      /**
       * Filter for live insights
       * @type {*}
       */
      query = filterInsightStates(query, ["Live", "ForcedLive"]);

      /**
       * Filter for resolved/unresolved insights
       */
      query = filterForResolved(query, filters.resolved);

      /**
       * Filter insights of specific DNB values
       */
      if (lodash.isBoolean(filters.dnb)) {
        query.filter("dairyCow/DoNotBreed", filters.dnb);
      }

      /**
       * Filter out cows without sensors
       */
      if (filters.withSensor) {
        query.filter("dairyCow/nodeID", "ne", null);
      }

      if (filters.category) {
        var staleness;

        /**
         * @type {number}
         */
        var DAY = 24 * 60 * 60;

        /**
         * @type {boolean}
         */
        var isFertilityInsight = filters.category === "fertility";

        query.filter("insightType/insightCategory", filters.category);

        if (!(filters.endEpoch || options.includeStaleInsights)) {
          /**
           * @type {number}
           */
          var now = new Date().getTime();

          if (isFertilityInsight) {
            /**
             * 1 day
             * @type {number}
             */
            staleness = now / 1000 - DAY;
          } else {
            /**
             * 7 days
             * @type {number}
             */
            staleness = now / 1000 - 7 * DAY;
          }

          query.filter("endEpoch", ">", staleness);
        }
      }

      /**
       * Filter for insight scope
       */
      if (filters.insightScope) {
        query.filter("insightType/insightScope", filters.insightScope);
      }

      /**
       * Filter for insight types
       */
      if (filters.insightType) {
        query = filterWithInsightTypes(query, filters.insightType);
      }

      /**
       * Filter for negated insight types
       */
      if (filters.notInsightType) {
        query = filterWithInsightTypes(query, filters.notInsightType, {
          negated: true
        });
      }

      /**
       * Apply area id as a filter
       */
      if (lodash.isFunction(filters.areaID)) {
        /**
         * @type {number}
         */
        var aid = filters.areaID();

        if (aid) {
          query.filter("dairyCow/areaID", aid);
        }
      } else if (filters.areaID) {
        query.filter("dairyCow/areaID", filters.areaID);
      }

      /**
       * Apply herd group id as a filter
       */
      if (lodash.isFunction(filters.herdGroupID)) {
        /**
         * @type {number}
         */
        var hgid = filters.herdGroupID();

        if (hgid) {
          query.filter("dairyCow/herdGroupID", hgid);
        }
      } else if (filters.herdGroupID) {
        query.filter("dairyCow/herdGroupID", filters.herdGroupID);
      }

      /**
       * @todo I cannot really understand this one...
       */
      if (filters.hasOwnProperty("adminChecked")) {
        query.filter("notificationSent", filters.adminChecked);
      }

      /**
       * It may be open on the start.
       */
      if (filters.startEpoch) {
        query.filter("endEpoch", ">", filters.startEpoch);
      }

      /**
       * It may be open on the end.
       */
      if (filters.endEpoch) {
        query.filter("endEpoch", "<", filters.endEpoch);
      }

      if (lodash.has(filters, "seen")) {
        var operator = filters.seen ? "!=" : "=";
        query.filter("seenByUserIds", operator, null);
      }

      /**
       * Skip the first [offset] insights
       */
      if (offset) {
        query.skip(offset);
      }

      /**
       * Take the first [limit] insights
       */
      if (limit) {
        query.take(limit);
      }

      /**
       * Resolve query
       * @param value
       */
      function resolveQuery(value) {
        var result = countOnly ? value.result : processInsights(value);

        dfd.resolve(result);
      }

      /**
       * Only count insights if specified
       */
      query[countOnly ? "count" : "query"]().$promise.then(resolveQuery, rejectDeferred(dfd));

      return dfd.promise;
    }

    /**
     * Update insight
     * @param insight
     * @param showToastr
     * @return {*}
     */
    function updateInsight(insight, showToastr) {
      /**
       * The backend does not like it when the object has linked objects inside, drop them
       * @type {{}|*}
       */
      var insightClone = lodash.omit(
        angular.copy(insight), // QUESTION: do we need the angular.copy
        lodash.concat(BASIC_EXPANSION_PACK, "insightValid", "inseminated", "calved", "approved")
      );

      /**
       * @type {string}
       */
      insightClone.insightResolution = angular.toJson(insightClone.insightResolution);

      var promise = insightClone.$update();

      promise.then(
        function () {
          if (showToastr) {
            toastr.success($translate.instant("LABEL_TEXT_SAVED"));
          }
        },
        function () {
          if (showToastr) {
            toastr.error($translate.instant("LABEL_TEXT_OOPS"));
          }
        }
      );

      return promise;
    }

    /**
     * Create a hidden "approved" or "dismissed" resolution
     * @param valueVariants
     * @param category
     * @param options
     * @return {{insightCategory: string, order: number, id: *, title: *, hidden: boolean}}
     */
    var createWorkflowResolution = lodash.curry(function (valueVariants, category, options) {
      var id;

      /**
       * @type {{}}
       */
      options = lodash.assign(
        {
          negated: false
        },
        options || {}
      );

      /**
       * @type {string}
       */
      id = options.negated ? valueVariants.negative : valueVariants.positive;

      return {
        insightCategory: category,
        order: 10,
        id: id,
        title: lodash.lowerCase(id),
        hidden: true,
        validation: options.negated ? VALIDATION_TYPES.no : VALIDATION_TYPES.yes
      };
    }, 3);

    /**
     * Log a change in the insight object
     * @param key
     * @param valueVariants
     * @param createResolution
     * @param insight
     * @param value
     * @param options
     * @return {*}
     */
    function logInsightChange(key, valueVariants, createResolution, insight, value, options) {
      /**
       * Tell whether we return the insight or the promise.
       */
      options = lodash.assign(
        {
          updateInsight: true
        },
        options || {}
      );

      /**
       * Set a default Array, fucking NULL...
       * @type {*|Array}
       */
      insight.insightResolution = insight.insightResolution || [];

      insight[key] = value;

      if (insight[key] === null) {
        /**
         * Remove all resolutions by setting it to empty.
         * @type {Array}
         */
        insight.insightResolution = [];
      } else if (insight[key] === true) {
        /**
         * Remove the old resolution
         */
        insight.insightResolution = [];

        /**
         * Add positive resolution
         */
        insight.insightResolution.push(
          createResolution({
            negated: false
          })
        );
      } else if (insight[key] === false) {
        /**
         * Remove the old resolution
         */
        insight.insightResolution = [];

        /**
         * Add negative resolution
         */
        insight.insightResolution.push(
          createResolution({
            negated: true
          })
        );
      }

      if (!insight.insightResolution.length) {
        insight.insightResolution = null;
      }

      if (options.updateInsight) {
        updateInsight(insight);
      }

      return insight;
    }

    /**
     * Log insemination
     * @param insight
     * @param inseminated
     * @return {*}
     */
    function logInsemination(insight, inseminated) {
      /**
       * @type {{positive: string, negative: string}}
       */
      var valueVariants = {
        positive: INSEMINATION_VALUES.inseminated,
        negative: INSEMINATION_VALUES.notInseminated
      };

      /**
       * Create a resolution using the above variants
       */
      var createResolution = createWorkflowResolution(valueVariants, insight.insightType.insightCategory);

      /**
       * Get new insight with extra resolution
       * @type {*}
       */
      var mutatedInsight = logInsightChange(
        "inseminated",
        valueVariants,
        createResolution,
        insight,
        inseminated
      );

      updateInseminationInsightValidation(mutatedInsight);

      return mutatedInsight;
    }

    /**
     * Log calving
     * @param insight
     * @param calved
     * @return {*}
     */
    function logCalving(insight, calved) {
      /**
       * @type {{positive: string, negative: string}}
       */
      var valueVariants = {
        positive: CALVING_VALUES.calved,
        negative: CALVING_VALUES.notCalved
      };

      /**
       * Create a resolution using the above variants
       */
      var createResolution = createWorkflowResolution(valueVariants, insight.insightType.insightCategory);

      /**
       * Get new insight with updated resolutions
       * @type {*}
       */
      var mutatedInsight = logInsightChange("calved", valueVariants, createResolution, insight, calved);

      updateCalvingInsightValidation(mutatedInsight);

      return mutatedInsight;
    }

    /**
     * Log a "workflow" type insight
     * @param insight
     * @param approved
     * @return {*}
     */
    function logFromWorkflow(insight, approved) {
      /**
       * @type {{positive: string, negative: string}}
       */
      var valueVariants = {
        positive: WORKFLOW_VALUES.approved,
        negative: WORKFLOW_VALUES.dismissed
      };

      /**
       * Create a resolution using the above variants
       */
      var createResolution = createWorkflowResolution(valueVariants, insight.insightType.insightCategory);

      /**
       * Get new insight with updated resolutions
       * @type {*}
       */
      var updated = logInsightChange("approved", valueVariants, createResolution, insight, approved, {
        updateInsight: false
      });

      return updateWorkflowInsightValidation(updated).then(function () {
        return updateInsight(updated);
      });
    }

    /**
     * Update insight resolution
     * @param insight
     * @param showToastr
     */
    function updateInsightResolution(insight, showToastr) {
      if (isEstrusInsight(insight)) {
        updateInseminationInsightValidation(insight);
      } else if (isCalvingInsight(insight)) {
        updateCalvingInsightValidation(insight);
      } else if (isWorkflowInsight(insight)) {
        updateWorkflowInsightValidation(insight);
      }

      updateInsight(insight, showToastr);
    }

    /**
     * Create a new validation if it does not yet exist on the insight.
     * @param insight
     * @param alwaysCreateNewValidation - spaghetti shit
     * @return {{previousValue: {}, nextValidation: {}}}
     */
    function assignValidation(insight, alwaysCreateNewValidation) {
      /**
       * @type {[]}
       * @todo maybe not necessary, check whether the DataAPI service works on the same dataset
       */
      var sorted = insight.insightValidations.sort(function (a, b) {
        return a.InsightValidationID < b.InsightValidationID ? 1 : -1;
      });

      /**
       * @type {{}}
       */
      var validation = sorted.find(function (validation) {
        return validation.validationByID !== "Admin";
      });

      /**
       * @type {{} | null}
       */
      var originalValidation = validation ? validation.validation : null;

      // Create a new validation.
      if (!validation || alwaysCreateNewValidation) {
        /**
         * @type {Date}
         */
        var now = new Date();

        /**
         * @type {{validationByID: *, genericInsightID: *, validation: string, validationEpoch: number}}
         */
        validation = {
          validationByID: sessionService.user.id,
          genericInsightID: insight.GenericInsightID,
          validation: VALIDATION_TYPES.noAnswer,
          validationEpoch: Math.round(now.getTime() / 1000)
        };

        validation = newInsightValidation(validation);
        insight.insightValidations.push(validation);
      }

      return {
        previousValue: originalValidation,
        nextValidation: validation
      };
    }

    /**
     * Create or update a validation
     * @param validation
     * @return {*}
     */
    function updateValidation(validation) {
      var promise;

      /**
       * Are we talking about a new or existing validation?
       */
      if (validation.InsightValidationID) {
        /**
         * If we got the insightValid through the expand function of the insight,
         * it does not have the update() function yet, so we make it into an oData object.
         */
        if (validation.$update) {
          promise = validation.$update();
        } else {
          promise = newInsightValidation(validation).$update();
        }
      } else {
        promise = validation.$save();
      }

      return promise;
    }

    /**
     * Check if there is an insight validation already:
     * - if inseminated is null (unset), we don't know if the insight is valid
     * - if inseminated, the insight is valid
     * - if not inseminated:
     *   - check the resolutions, if the insight resolution ID === 'not_on_estrus', insight is not valid
     *   - check the resolutions, if the insight resolution ID === 'too_early_after_calving', insight is valid
     *   - otherwise we do not know
     * @param insight
     */
    function updateInseminationInsightValidation(insight) {
      /**
       * @type {{previousValue: {previousValue: string}, nextValidation: {validation: string}}}
       */
      var assigned = assignValidation(insight);

      var originalValidation = assigned.previousValue;
      var validation = assigned.nextValidation;

      if (lodash.isNull(insight.inseminated)) {
        validation.validation = VALIDATION_TYPES.noAnswer;
      } else if (insight.inseminated) {
        validation.validation = VALIDATION_TYPES.yes;
      } else {
        var resolutions = lodash.get(insight, ["insightResolution"], []);
        var notOnEstrus = lodash.find(resolutions, ["id", "not_on_estrus"]);
        var tooEarlyAfterCalving = lodash.find(resolutions, ["id", "too_early_after_calving"]);

        if (notOnEstrus) {
          validation.validation = VALIDATION_TYPES.no;
        } else if (tooEarlyAfterCalving) {
          validation.validation = VALIDATION_TYPES.yes;
        } else {
          validation.validation = VALIDATION_TYPES.noAnswer;
        }
      }

      insight.insightValid = validation.validation;

      /**
       * Check if we need to update the validation.
       */
      if (originalValidation !== validation.validation) {
        updateValidation(validation);
      }
    }

    /**
     * Check if there is an insight validation already:
     * - if calved is null (unset), we don't know if the insight is valid
     * - if calved, the insight is valid
     * - if not calved, insight is invalid
     * @param insight
     */
    function updateCalvingInsightValidation(insight) {
      /**
       * @type {{previousValue: {}, nextValidation: {}}}
       */
      var assigned = assignValidation(insight);

      /**
       * @type {{}}
       */
      var originalValidation = assigned.previousValue;

      /**
       * @type {{}}
       */
      var validation = assigned.nextValidation;

      if (lodash.isNull(insight.calved)) {
        /**
         * @type {string}
         */
        validation.validation = VALIDATION_TYPES.noAnswer;
      } else if (insight.calved) {
        /**
         * @type {string}
         */
        validation.validation = VALIDATION_TYPES.yes;
      } else {
        /**
         * @type {string}
         */
        validation.validation = VALIDATION_TYPES.no;
      }

      insight.insightValid = validation.validation;

      /**
       * Check if we need to update the validation.
       */
      if (originalValidation !== validation.validation) {
        updateValidation(validation);
      }
    }

    /**
     * Validate the workflow insight using the resolution
     * @param insight
     */
    function updateWorkflowInsightValidation(insight) {
      /**
       * @type {{previousValue: {}, nextValidation: {}}}
       */
      var assigned = assignValidation(insight, true);

      /**
       * @type {{}}
       */
      var originalValidation = assigned.previousValue;

      /**
       * @type {{}}
       */
      var validation = assigned.nextValidation;

      validation.validation = insightResolutionService.resolveValidation(insight.insightResolution);
      insight.insightValid = validation.validation;

      /**
       * Check if we need to update the validation.
       */
      if (originalValidation !== validation.validation) {
        return updateValidation(validation);
      }
    }

    /**
     * Create filter function for prev-next insight
     * @param insight
     * @param count
     * @return {function(*=): *}
     */
    function createPrevNextInsightFilter(insight, count) {
      /**
       * Tell whether the user is using big farm UI
       * @type {boolean}
       */
      var onBigFarm = sessionService.userRoles.indexOf("BigFarmUser") > -1;

      /**
       * Tell whether we deal with a special type of fertility insight: calving
       * @type {boolean}
       */
      var isCalving = insight.insightTypeID === 17;

      return function (query) {
        /**
         * Filter for the given insight states
         * @type {*}
         */
        query = filterInsightStates(query, ["Live", "ForcedLive"]);

        if (onBigFarm) {
          /**
           * Filter for insight category
           * @type {*}
           */
          query = filterInsightCategories(query, insight.insightType.insightCategory);

          /**
           * Filter for scope
           */
          query.filter("insightType/insightScope", insight.insightType.insightScope);

          /**
           * Fertility is split into 2 sections: calving and inseminations.
           * We query accordingly.
           */
          if (insight.insightType.insightCategory === "fertility") {
            query = filterWithInsightTypes(
              query,
              isCalving ? INSIGHT_CATEGORIES.calving : INSIGHT_CATEGORIES.heat
            );
          }
        }

        return query.take(count || 1);
      };
    }

    /**
     * Get the first N insights before the given insight.
     * @param farmID
     * @param insight
     * @param count
     * @return {*}
     */
    function getInsightsBefore(farmID, insight, count) {
      /**
       * @type {number}
       */
      var startEpoch = null;

      /**
       * @type {number}
       */
      var endEpoch = insight.endEpoch;

      /**
       * Create filters
       * @param query
       * @return {*}
       */
      var applyFilters = createPrevNextInsightFilter(insight, count);

      return getGenericInsightsBetween(farmID, startEpoch, endEpoch, applyFilters);
    }

    /**
     * Get the first N insights after the given insight.
     * @param farmID
     * @param insight
     * @param count
     * @return {*}
     */
    function getInsightsAfter(farmID, insight, count) {
      /**
       * @type {number}
       */
      var startEpoch = insight.endEpoch;

      /**
       * @type {number}
       */
      var endEpoch = null;

      /**
       * Create filters
       * @param query
       * @return {*}
       */
      var applyFilters = createPrevNextInsightFilter(insight, count);

      return getGenericInsightsBetween(farmID, startEpoch, endEpoch, applyFilters, {
        order: "asc"
      });
    }

    /**
     * Get insights between the two given epoch values
     * @param farmID
     * @param startEpoch
     * @param endEpoch
     * @param applyFilters
     * @param options
     * @return {*}
     */
    function getGenericInsightsBetween(farmID, startEpoch, endEpoch, applyFilters, options) {
      var dfd = $q.defer();

      $log.info("Fetching GenericInsight from the database");

      /**
       * {{order: string}}
       */
      options = lodash.assign(
        {
          order: "desc"
        },
        options || {}
      );

      var query = expandWith(GenericInsight.odata(), BASIC_EXPANSION_PACK);

      /**
       * Resolve the insight query
       * @param value
       */
      var resolveQuery = function (value) {
        var processedValue = processInsights(value);

        dfd.resolve(processedValue);
      };

      /**
       * Basic filtering and ordering.
       */
      query.filter("farmID", farmID).orderBy("endEpoch", options.order);

      /**
       * It may be open on the start.
       */
      if (startEpoch) {
        query.filter("endEpoch", ">", startEpoch);
      }

      /**
       * It may be open on the end.
       */
      if (endEpoch) {
        query.filter("endEpoch", "<", endEpoch);
      }

      if (angular.isFunction(applyFilters)) {
        query = applyFilters(query);
      }

      query.query().$promise.then(resolveQuery, rejectDeferred(dfd));

      return dfd.promise;
    }

    /**
     * Bundle insights into insight collections
     * @param insights
     * @return {Array}
     */
    function getInsightCollections(insights) {
      /**
       * @type {Array}
       */
      var insightCollections = [];

      angular.forEach(insights, function (insight) {
        /**
         * Start date
         * @type {Date}
         */
        var startDate = new Date(insight.startEpoch * 1000);

        startDate.setHours(0, 0, 0, 0);

        /**
         * @type {number}
         */
        var dayStart = startDate.getTime() / 1000;

        /**
         * @type {{} | undefined}
         */
        var insightCollection = insightCollections.find(function (collection) {
          return collection.epoch === dayStart && collection.insightType === insight.insightType.typeName;
        });

        /**
         * @type {Array}
         */
        var seenByUsers = insight.seenByUserIds ? insight.seenByUserIds.slice(0, -1).split(",") : [];

        if (!insightCollection) {
          /**
           * @type {{
           *   title: string,
           *   epoch: number,
           *   startEpoch: number,
           *   endEpoch: number,
           *   insightType: string,
           *   insights: Array,
           *   seenByUserIds: Array
           * }}
           */
          insightCollection = {
            title: ["INSIGHT_COLLECTION_TITLE", insight.insightType.typeName].join("_"),
            epoch: dayStart,
            startEpoch: insight.startEpoch,
            endEpoch: insight.endEpoch,
            insightType: insight.insightType.typeName,
            insights: [],
            seenByUserIds: seenByUsers
          };

          insightCollections.push(insightCollection);
        }

        if (insightCollection.startEpoch < insight.startEpoch) {
          insightCollection.startEpoch = insight.startEpoch;
        }

        if (insightCollection.endEpoch > insight.endEpoch) {
          insightCollection.endEpoch = insight.endEpoch;
        }

        insightCollection.seenByUserIds = lodash.intersection(insightCollection.seenByUserIds, seenByUsers);

        insightCollection.insights.push(insight);
      });

      insightCollections.sort(function (a, b) {
        return a.endEpoch > b.endEpoch ? -1 : 1;
      });

      return insightCollections;
    }

    /**
     * Process insights, one or many
     * @param input
     * @return {*}
     */
    function processInsights(input) {
      if (angular.isArray(input)) {
        angular.forEach(input, processInsight);
      } else if (angular.isObject(input)) {
        input = processInsight(input);
      }

      return input;
    }

    /**
     * Tell whether the given insight is an estrus insight.
     * @param insight
     * @returns {boolean}
     */
    function isEstrusInsight(insight) {
      return INSIGHT_CATEGORIES.heat.indexOf(insight.insightType.typeName) > -1;
    }

    /**
     * Tell whether the given insight is a calving insight
     * @param insight
     * @returns {boolean}
     */
    function isCalvingInsight(insight) {
      return INSIGHT_CATEGORIES.heat.indexOf(insight.insightType.typeName) > -1;
    }

    /**
     * Tell whether the given insight is part of a workflow (dry off or missing estrus so far)
     * @param insight
     * @returns {boolean}
     */
    function isWorkflowInsight(insight) {
      return INSIGHT_CATEGORIES.cycleAlertWorkflow.indexOf(insight.insightType.typeName) > -1;
    }

    /**
     * Set inseminated or calved property
     * @param insight
     * @param key
     * @param is
     * @param not
     */
    function setProp(insight, key, is, not) {
      /**
       * @type {boolean | null}
       */
      insight[key] = null;

      insight.insightResolution.forEach(function (e) {
        if (e.id === is) {
          insight[key] = true;
        } else if (e.id === not) {
          insight[key] = false;
        }
      });

      if (insight.insightValid === VALIDATION_TYPES.no) {
        insight[key] = false;
      }
    }

    /**
     * Process insight.
     * @param insight
     * @return {*}
     */
    function processInsight(insight) {
      /**
       * @type {Array}
       */
      insight.insightResolution = angular.fromJson(insight.insightResolution) || [];

      /**
       * @type {string}
       */
      insight.insightValid = ValidationService.pickValidationValue(insight.insightValidations);

      if (isEstrusInsight(insight)) {
        setProp(insight, "inseminated", INSEMINATION_VALUES.inseminated, INSEMINATION_VALUES.notInseminated);
      } else if (isCalvingInsight(insight)) {
        setProp(insight, "calved", CALVING_VALUES.calved, CALVING_VALUES.notCalved);
      } else if (isWorkflowInsight(insight)) {
        setProp(insight, "approved", WORKFLOW_VALUES.approved, WORKFLOW_VALUES.dismissed);
      }

      return insight;
    }

    /**
     * Insight validation oData resource
     */
    var InsightValidation = $odataresource(
      appConfig.APIURL + "odata/InsightValidations",
      {},
      {},
      {
        odatakey: "InsightValidationID"
      }
    );

    /**
     * Create new insight validation
     * @param details
     * @return {*}
     */
    function newInsightValidation(details) {
      var insightValidation = new InsightValidation();

      angular.forEach(
        details,
        function (value, key) {
          this[key] = value;
        },
        insightValidation
      );

      return insightValidation;
    }

    /**
     * Get insight validations for the given insight
     * @param genericInsightID
     * @return {*}
     */
    function getInsightValidations(genericInsightID) {
      return InsightValidation.odata().filter("genericInsightID", parseInt(genericInsightID)).query()
        .$promise;
    }

    /**
     * Validate an insight
     * @param insight
     * @param answer
     * @return {*}
     */
    function validateInsight(insight, answer) {
      /**
       * @type {string}
       */
      var userId = sessionService.user.id;

      return getInsightValidations(insight.GenericInsightID)
        .then(function (validations) {
          /**
           * @type {Date}
           */
          var now = new Date();

          /**
           * Find the non-admin validation
           * @type {{validationByID: string, genericInsightID: number, validation: string}}
           */
          var validation =
            validations.find(function (validation) {
              return validation.validationByID !== "Admin";
            }) || {};

          /**
           * Update validation
           * @type {{validationByID: string, genericInsightID: number, validation: string}}
           */
          var updatedValidation = lodash.assign(validation, {
            validationByID: userId,
            genericInsightID: insight.GenericInsightID,
            validation: answer,
            validationEpoch: Math.round(now.getTime() / 1000)
          });

          /**
           * @type {boolean}
           */
          var isNew = !updatedValidation.InsightValidationID;

          return isNew ? newInsightValidation(updatedValidation).$save() : updatedValidation.$update();
        })
        .then(function () {
          insight.insightValid = answer;
        });
    }

    /**
     * Insight checks oData resource
     */
    var InsightCheck = $odataresource(
      appConfig.APIURL + "odata/InsightChecks",
      {},
      {},
      {
        odatakey: "CheckID"
      }
    );

    /**
     * Create new insight check
     * @param details
     * @return {*}
     */
    function newInsightCheck(details) {
      var insightCheck = new InsightCheck();

      angular.forEach(
        details,
        function (value, key) {
          this[key] = value;
        },
        insightCheck
      );

      return insightCheck;
    }

    /**
     * Get all insight check for the given insight ID
     * @param genericInsightID
     * @return {*}
     */
    function getInsightChecks(genericInsightID) {
      return InsightCheck.odata().filter("genericInsightID", parseInt(genericInsightID)).query().$promise;
    }

    /**
     * Insight type oData resource
     */
    var InsightType = $odataresource(
      appConfig.APIURL + "odata/InsightTypes",
      {},
      {},
      {
        odatakey: "InsightTypeID"
      }
    );

    /**
     * Get insigght types
     * @return {*}
     */
    function getInsightTypes() {
      return InsightType.odata().query().$promise;
    }

    /**
     * Get single insight type
     * @param id
     * @return {*}
     */
    function getInsightType(id) {
      return InsightType.odata().get(id).$promise;
    }

    /**
     * New insight type
     * @param details
     * @return {*}
     */
    function newInsightType(details) {
      var insightType = new InsightType();

      angular.forEach(
        details,
        function (value, key) {
          this[key] = value;
        },
        insightType
      );

      return insightType;
    }

    /**
     * Insight model oData resource
     */
    var InsightModel = $odataresource(
      appConfig.APIURL + "odata/InsightModels",
      {},
      {},
      {
        odatakey: "InsightModelID"
      }
    );

    /**
     * Get insight models
     * @param insightTypeID
     * @return {*}
     */
    function getInsightModels(insightTypeID) {
      var query = InsightModel.odata();

      /* eslint-disable angular/module-getter */

      if (insightTypeID) {
        query.filter("insightTypeID", insightTypeID);
      }

      return query.query().$promise;
    }

    /**
     * Get single insight model
     * @param id
     * @return {*}
     */
    function getInsightModel(id) {
      return InsightModel.odata().get(id).$promise;
    }

    /**
     * Create new insight model
     * @param details
     * @return {*}
     */
    function newInsightModel(details) {
      var insightModel = new InsightModel();

      angular.forEach(
        details,
        function (value, key) {
          this[key] = value;
        },
        insightModel
      );

      return insightModel;
    }

    /**
     * Get insight context
     * @param insight
     * @return {*|{}}
     */
    function getContext(insight) {
      var ctx = insight ? angular.fromJson(insight.insightContext) : {};

      return ctx || {};
    }

    /**
     * Tell whether an insight is coming from a repeat offender.
     * @param insight
     * @return {boolean}
     */
    function isRepeatOffender(insight) {
      return !!getContext(insight).isRepeatOffender;
    }

    /**
     * Get the parsed insight resolutions
     * @param insight
     */
    function getInsightResolutions(insight) {
      return angular.fromJson(insight.insightResolution) || [];
    }

    /**
     * Get days in milk value
     * @param insight
     * @param fromCow
     * @return {number | "-"}
     */
    function getDim(insight, fromCow) {
      var dim;

      /**
       * @type {Date}
       */
      var now = new Date();

      if (fromCow) {
        now.setHours(23, 59, 59, 99);
        dim = dateTimeService.daysBetween(now, new Date(insight.dairyCow.lastCalvingEpoch * 1000));
      } else {
        /**
         * @type {number}
         */
        var previousCalvingEpoch = getContext(insight).previousCalvingEpoch;

        /**
         * @type {number}
         */
        var contextEpoch = getContext(insight).contextEpoch;

        dim = previousCalvingEpoch
          ? dateTimeService.daysBetween(new Date(contextEpoch * 1000), new Date(previousCalvingEpoch * 1000))
          : "-";
      }

      return dim;
    }

    /**
     * Get "last breeding"
     * @param insight
     * @param fromCow
     * @return {string}
     */
    function getLB(insight, fromCow) {
      var previousInseminationEpoch = fromCow
        ? insight.dairyCow.lastInseminationEpoch
        : getContext(insight).previousInseminationEpoch;

      /**
       * @type {string}
       */
      var result = "-";

      if (previousInseminationEpoch) {
        if (fromCow) {
          /**
           * @type {Date}
           */
          var now = new Date();

          now.setHours(23, 59, 59, 99);
          result = dateTimeService.daysBetween(now, new Date(previousInseminationEpoch * 1000));
        } else {
          /**
           * @type {number}
           */
          var contextEpoch = getContext(insight).contextEpoch;

          result = dateTimeService.daysBetween(
            new Date(contextEpoch * 1000),
            new Date(previousInseminationEpoch * 1000)
          );
        }
      }

      return result;
    }

    /**
     * Tell whether an insight is resolved
     * @param insight
     * @return {*|boolean}
     */
    function isResolved(insight) {
      return (
        (insight.insightResolution && insight.insightResolution.length > 0) ||
        (insight.insightValidations && insight.insightValidations.length > 0 && insight.insightValid !== "NA")
      );
    }

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents").service("herdGroupService", herdGroupService);

  /**
   * @param $q
   * @param $window
   * @param appConfig
   * @param appSessionService
   * @param $rootScope
   * @param $log
   * @param $odata
   * @param $odataresource
   * @param $state
   * @param lodash
   * @return {herdGroupService}
   * @ngInject
   */
  function herdGroupService(
    $q,
    $window,
    appConfig,
    appSessionService,
    $rootScope,
    $log,
    $odata,
    $odataresource,
    $state,
    lodash
  ) {
    var self = this;

    /**
     * Herd group oData endpoint
     */
    var HerdGroup = $odataresource(
      appConfig.APIURL + "odata/HerdGroups",
      {},
      {},
      {
        odatakey: "HerdGroupID"
      }
    );

    self.herdGroups = null;

    /**
     * Navigate to herd group
     * @param herdGroupID
     */
    self.goToHerdGroup = function (herdGroupID) {
      $state.go("herdGroups.herdGroup", { herdGroupID: herdGroupID });
    };

    /**
     * Get herd groups
     * @return {null|*}
     */
    self.getHerdGroups = function (farmId) {
      if (!self.herdGroups) {
        $log.info("Fetching HerdGroups from the database");

        self.herdGroups = HerdGroup.odata()
          .filter("farmID", farmId | appSessionService.farmID)
          .query();
      }

      self.herdGroups.$promise.then(
        lodash.noop,
        function (e) {
          $log.error("Herd group list could not be fetched", e);
        }
      );

      return self.herdGroups;
    };

    /**
     * Refresh herd groups
     * @return {*}
     */
    self.refreshHerdGroups = function () {
      self.herdGroups = null;

      return self.getHerdGroups();
    };

    /**
     * Get herd group by id
     * @param herdGroupID
     * @return {*}
     */
    self.getHerdGroup = lodash.memoize(function (herdGroupID) {
      herdGroupID = parseInt(herdGroupID) || null;

      if (self.herdGroups) {
        var found = lodash.find(self.herdGroups, ["HerdGroupID", herdGroupID]);

        if (found) {
          var deferred = $q.defer();
          deferred.resolve(found);

          return {
            $promise: deferred.promise
          };
        }
      }

      var herdGroup = HerdGroup.odata().filter("HerdGroupID", herdGroupID).single();

      $log.info("Fetching HerdGroup from the database", herdGroup);

      return herdGroup;
    });

    /**
     * Create new herd group
     * @param herdGroupDetails
     * @param addToGlobalArray
     * @return {*}
     */
    self.newHerdGroup = function (herdGroupDetails, addToGlobalArray) {
      var herdGroup = new HerdGroup();

      angular.forEach(
        herdGroupDetails,
        function (value, key) {
          this[key] = value;
        },
        herdGroup
      );

      if (addToGlobalArray) {
        self.herdGroups.push(herdGroup);
      }

      return herdGroup;
    };

    /**
     * Delete herd group
     * @param herdGroup
     * @param confirmed
     * @return {*}
     */
    self.deleteHerdGroup = function (herdGroup, confirmed) {
      var deferred = $q.defer();
      var question =
        "Are you sure you want to delete " + herdGroup.groupName + "?\nThis action cannot be undone!";

      confirmed = confirmed || $window.confirm(question);

      if (confirmed) {
        herdGroup.$delete().then(
          function successCallback() {
            deferred.resolve();
          },
          function errorCallback(error) {
            deferred.reject(error);
          }
        );

        self.herdGroups.forEach(function (e, i) {
          if (e.HerdGroupID === herdGroup.HerdGroupID) {
            self.herdGroups.splice(i, 1);
          }
        });
      } else {
        deferred.reject("user interrupted");
      }

      return deferred.promise;
    };

    /**
     * sort groups in such a way that digits come first and then alphabets
     * @example
     * // return [{ "gId": 626, "groupName": 1 },{ "gId": 628, "groupName": "10 Group A" }, { "gId": 629, "groupName": 11 }, { "gId": 618, "groupName": "A" }]
     * sortGroupsfilter([{ "gId": 629, "groupName": 11 }, { "gId": 628, "groupName": "10 Group A" }, { "gId": 626, "groupName": 1 }, { "gId": 618, "groupName": "A" }], {groupName: "areaName"})
     * @param groups
     * @param meta
     * @return {[]}
     */
    self.sortGroupsfilter = function (groups, meta) {
      var numericGroupNames = [];
      var stringGroupNames = [];

      lodash.each(groups, function (value) {
        if (lodash.isInteger(parseFloat(lodash.get(value, meta.groupName)))) {
          numericGroupNames.push(value);
        } else {
          stringGroupNames.push(value);
        }
      });

      numericGroupNames = lodash.orderBy(
        numericGroupNames,
        [
          function (value) {
            return parseFloat(lodash.get(value, meta.groupName));
          }
        ],
        ["asc"]
      );

      stringGroupNames = lodash.orderBy(
        stringGroupNames,
        [
          function (value) {
            return lodash.get(value, meta.groupName);
          }
        ],
        ["asc"]
      );

      return lodash.concat(numericGroupNames, stringGroupNames);
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents").service("CycleAlertService", CycleAlertService);

  /**
   * @ngInject
   * @param insightService
   * @param dateTimeService
   * @param appSessionService
   * @param lodash
   * @param GenericInsightService
   * @param INSIGHT_CATEGORIES
   * @return {CycleAlertService}
   */
  function CycleAlertService(
    insightService,
    dateTimeService,
    appSessionService,
    lodash,
    GenericInsightService,
    INSIGHT_CATEGORIES
  ) {
    var self = this;

    /**
     * @type {number}
     */
    var FALL_OFF_LIMIT = 25;

    /**
     * @type {number}
     */
    var STALENESS = 90;

    /**
     *
     * @type {{noHeatAfterCalving: string, noHeat: string, shortCycle: string}}
     */
    var insightVariants = {
      noHeat: "IS_NOT_SHOWING_HEAT",
      shortCycle: "HAS_A_SHORT_HEAT_CYCLE",
      noHeatAfterCalving: "NOT_SHOWING_HEAT_AFTER_CALVING"
    };

    /**
     * Load insights
     * @example vm.fetchData({ ...filters }, N).then(insightsLoaded);
     * @return {boolean}
     */
    self.fetchData = function (filters) {
      return insightService.getGenericInsightsTodos(
        appSessionService.farm.FarmID,
        filters,
        false,
        null,
        null,
        { includeStaleInsights: true }
      );
    };

    /**
     * Fetch missing estruses
     * @param {{}} [filters]
     * @return {Promise<any> | Promise<T>}
     */
    self.fetchMissingEstruses = function (filters) {
      /**
       * @type {{category: string, insightType: string[], areaID: *, startEpoch: *, endEpoch: *}}
       */
      var insightServiceFilters = lodash.assign(
        {
          insightType: INSIGHT_CATEGORIES.cycleAlert,
          startEpoch: dateTimeService.daysAgo(STALENESS),
          endEpoch: dateTimeService.now(),
          withSensor: true,
          dnb: false
        },
        filters || {}
      );

      return self.fetchData(insightServiceFilters);
    };

    /**
     * Fetch cows in treatment
     * @param {{}} [filters]
     * @return {Promise<any> | Promise<T>}
     */
    self.fetchInTreatment = function (filters) {
      /**
       * @type {{category: string, insightType: string[], areaID: *, resolved: boolean}}
       */
      var insightServiceFilters = lodash.assign(
        {
          insightType: ["WFMissingEstrusTreated", "WFMissingEstrusPostCalvingTreated"],
          startEpoch: dateTimeService.daysAgo(FALL_OFF_LIMIT),
          endEpoch: dateTimeService.now(),
          dnb: false
        },
        filters || {}
      );

      return self.fetchData(insightServiceFilters);
    };

    /**
     * Fetch treated, but not yet cyclic cows
     * @param {{}} [filters]
     * @return {Promise<any> | Promise<T>}
     */
    self.fetchNotYetCyclic = function (filters) {
      /**
       * @type {{category: string, insightType: string[], areaID: *, resolved: boolean}}
       */
      var insightServiceFilters = lodash.assign(
        {
          insightType: ["WFMissingEstrusResolved", "WFMissingEstrusPostCalvingResolved"],
          startEpoch: dateTimeService.daysAgo(FALL_OFF_LIMIT),
          endEpoch: dateTimeService.now(),
          dnb: false
        },
        filters || {}
      );

      return self.fetchData(insightServiceFilters);
    };

    /**
     * Filter out insights which has been resolved and older than a day,
     * leaving only freshly resolved and unresolved ones.
     * @param insights
     */
    self.filterResolved = function (insights) {
      return lodash.filter(insights, function (insight) {
        /**
         * Tell whether the insight is resolved
         * @type {boolean}
         */
        var hasResolution = insight.insightResolution !== null && insight.insightResolution.length > 0;

        /**
         * The BE sometimes use an { id: "resolved" } resolution to signal that the insight is recovered
         * @type {boolean}
         */
        var isResolvedByBackend = hasResolution && lodash.find(insight.insightResolution, ["id", "resolved"]);

        /**
         * We keep resolved insights on the list for a day id the user changes their mind
         * @type {boolean}
         */
        var olderThanADay = Math.abs(dateTimeService.since(insight.endEpoch)) > 0;

        return !isResolvedByBackend && ((hasResolution && !olderThanADay) || !hasResolution);
      });
    };

    /**
     * get last estrus value
     * @param insight
     */
    self.getLastEstrusValue = function (insight) {
      /**
       * @type {number}
       */
      var lastEstrusEpoch =
        GenericInsightService.getContext(insight).previousEstrusEpoch || insight.dairyCow.lastEstrusEpoch;

      /**
       * @type {number}
       */
      return Math.max(
        dateTimeService.daysBetween(
          insight
            ? dateTimeService.asDate(insight.startEpoch)
            : dateTimeService.asDate(dateTimeService.now()),
          dateTimeService.asDate(lastEstrusEpoch)
        ),
        0
      );
    };

    /**
     * Get title of the insight
     * @param insight
     * @return {boolean}
     */
    self.getInsightVariant = function (insight) {
      return lodash.replace(lodash.upperCase(lodash.get(insight, "insightTitle")), / /g, "_");
    };

    self.isValidInsightVariant = function (insight, variant) {
      var inightVariant = self.getInsightVariant(insight);
      var isValidVariant = false;

      if (insightVariants[variant] === inightVariant) {
        isValidVariant = true
      }

      return isValidVariant;
    };

    return self;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .service("doNotBreedService", doNotBreedService);

  /**
   * Do-not-breed related functionality
   * @ngInject
   * @param lodash
   * @param $translate
   * @param appSessionService
   * @param cowService
   * @param $q
   * @param toastr
   * @return {doNotBreedService}
   */
  function doNotBreedService (lodash, $translate, appSessionService, cowService, $q, toastr) {
    /**
     * DNB related copy keys to use anywhere
     * @type {{dnbWarning: string}}
     */
    this.copy = {
      dysonEnabledWarning: "dnb-dyson-enabled-warning",
      cowListFilter: "dnb-cow-list-filter",
      editCowCheckboxLabel: "dnb-edit-cow-checkbox-label",
      editCowDysonEnabledWarning: "dnb-edit-cow-dyson-enabled-warning",
      cowDetailsLabel: "dnb-cow-details-label",
      cowDetailsValue: "dnb-cow-details-value",
      insightDysonEnabledWarning: "dnb-insight-dyson-enabled-warning"
    };

    /**
     * Tell whether a cow is DNB
     * @param {{}} dairyCow
     * @return {boolean}
     */
    this.isDNB = function (dairyCow) {
      return !!dairyCow.DoNotBreed;
    };

    /**
     * Tell whether the given insight is resolved as "do not breed"
     * @param insight
     */
    this.resolvedAsDNB = function (insight) {
      return !!lodash.find(insight.insightResolution || [], ["id", "do_not_breed"])
    };

    /**
     * Set a cow DNB param
     * @param {number} dairyCowID
     * @param {boolean} to
     */
    this.setDNB = function (dairyCowID, to) {
      return cowService.getCow(dairyCowID).then((function (cow) {
        var deferred = $q.defer().promise;

        /**
         * Either the farm is non-dysonenabled or the user confirms
         * @type {boolean}
         */
        var maySetDNB = cow.DoNotBreed !== to && (!this.isDysonEnabled()
          || confirm($translate.instant(this.copy.dysonEnabledWarning, {}, "messageformat")));

        if (maySetDNB) {
          cow.DoNotBreed = to;

          deferred = cow.$update().then(function () {
            toastr.success(
              $translate.instant(cowService.copy.cowUpdateSuccess, {}, "messageformat")
            );
          }, function () {
            toastr.error(
              $translate.instant(cowService.copy.cowUpdateError, {}, "messageformat")
            );
          });
        } else {
          deferred.reject();
        }

        return deferred;
      }).bind(this));
    };

    /**
     * Tell whether the farm is Dyson-enabled
     * @return {boolean}
     */
    this.isDysonEnabled = function () {
      if (appSessionService.farm) {
        return !!appSessionService.farm.dysonEnabled;
      }

      throw new Error("Without a farm, I cannot tell whether Dyson is enabled or not. Use Ida, not admin.");
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents").service("dateTimeService", dateTimeService);

  /**
   * @param lodash
   * @param moment
   * @ngInject
   * @return {dateTimeService}
   */
  function dateTimeService(lodash, moment) {
    /**
     * @type {number}
     */
    this.SECOND = 1;

    /**
     * @type {number}
     */
    this.MINUTE = 60 * this.SECOND;

    /**
     * @type {number}
     */
    this.HOUR = 60 * this.MINUTE;

    /**
     * @type {number}
     */
    this.DAY = 24 * this.HOUR;

    /**
     * @type {number}
     */
    this.WEEK = 7 * this.DAY;

    /**
     * @type {number}
     */
    this.MONTH = 31 * this.DAY;

    /**
     * @type {number}
     */
    this.YEAR = 365 * this.DAY;

    /**
     * Return now as apoch
     * @return {number}
     */
    this.now = function () {
      /**
       * @type {Date}
       */
      var n = new Date();

      return Math.round(n / 1000);
    };

    /**
     * Get a midnight date of today
     * @param {{ morning: boolean }} options
     */
    this.midnight = function (options) {
      /**
       * It may be in the morning as well
       */
      options = lodash.assign(
        {
          morning: false
        },
        options || {}
      );

      var now = new Date();

      if (options.morning) {
        now.setHours(0, 0, 0, 0);
      } else {
        now.setHours(23, 59, 59, 99);
      }

      return now;
    };

    /**
     * Return the time between the given epoch an now.
     * @param epoch
     * @return {{value: string, count: string, units: string, tpl: string}}
     */
    this.until = function (epoch) {
      /**
       * @type {string}
       */
      var value = moment(epoch * 1000).fromNow(true);

      /**
       * @type {string[]}
       */
      var split = value.split(" ");

      /**
       * @type {string}
       */
      var count = lodash.first(split);

      /**
       * @type {string}
       */
      var units = lodash.last(split);

      return {
        value: value,
        count: count === "a" ? 1 : count,
        units: units,
        tpl: lodash.toUpper(lodash.snakeCase([units, "count"].join(" ")))
      };
    };

    /**
     * Get the epoch X days ago
     * @param days
     */
    this.daysAgo = function (days) {
      var dt = moment().subtract(days, "days").startOf("day");

      return Math.round(dt.valueOf() / 1000);
    };

    /**
     * Display a date as epoch
     * @param date
     * @return {number}
     */
    this.asEpoch = function (date) {
      var d = new Date(date);

      return Math.round(d / 1000);
    };

    /**
     * Display an epoch as date
     * @param epoch
     * @return {*}
     */
    this.asDate = function (epoch) {
      var date = moment(epoch * 1000);

      return date.toDate();
    };

    /**
     * Display an epoch as date string
     * @param epoch
     * @param format
     * @return {*}
     */
    this.asDateString = function (epoch, format) {
      var date = moment(epoch * 1000);

      return date.format(format);
    };

    /**
     * Get days between two dates
     * @param date1
     * @param date2
     * @return {number}
     */
    this.daysBetween = function (date1, date2, options) {
      options = lodash.assign(
        {
          useDayOfYear: false
        },
        options || {}
      );

      if (options.useDayOfYear) {
        return moment(date1).dayOfYear() - moment(date2).dayOfYear();
      } else {
        /**
         * @type {number}
         */
        var difference = (date1.getTime() - date2.getTime()) / 1000;

        return Math[difference < 0 ? "ceil" : "floor"](difference / this.DAY);
      }
    }.bind(this);

    /**
     * Tell how many days passed since the given epoch
     * @param epoch
     * @return {*}
     */
    this.since = function (epoch) {
      return this.daysBetween(moment().toDate(), this.asDate(epoch));
    }.bind(this);

    /**
     * Convert anything "epoch like" to Date objects
     * @param {{}} data
     */
    this.convertEpochs = lodash.memoize(function (data) {
      return lodash.mapValues(
        data,
        function (value, key) {
          /**
           * @type {boolean}
           */
          var maybeEpoch = /[Ee]poch/.test(key) && lodash.isNumber(value);

          return maybeEpoch ? this.asDate(value) : value;
        }.bind(this)
      );
    });

    /**
     * return which day of the month it is
     * @example
     * // return 12
     * getMonthDay(1601364300)
     * @param epoch
     */
    this.getDayOfMonth = function (epoch) {
      var day;

      if (epoch) {
        day = moment(epoch).date();
      } else {
        day = moment().date();
      }

      return day;
    };

    /**
     * Set day of the given epoch to the given number
     * @param epoch
     * @param day
     * @returns {epoch}
     */
    this.withDayOfMonth = function (epoch, day) {
      return moment(epoch).date(day).unix();
    };

    /**
     * Display an epoch as a calendar date
     * @param epoch
     * @return {string}
     */
    this.asCalendarString = function (epoch) {
      return moment(epoch * 1000).calendar(null, {
        sameElse: "DD/MM/YYYY LT"
      });
    };

    /**
     * Translate ISO Duration string ("P1M") into epoch value
     * @param {string} isoDurationString
     * @return {number}
     */
    this.isoDurationValue = function(isoDurationString) {
      return moment.duration(isoDurationString).valueOf();
    };

    /**
     * Add days to epoch
     * @param epoch
     * @param days
     * @retun {number}
     */
    this.addDaysToEpoch = function(epoch, days) {
      return moment(epoch*1000).add(days, 'days').unix()
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraUIComponents").service("calvingService", calvingService);

  /**
   * calving related functionality
   * @ngInject
   * @param labelService
   * @param lodash
   * @param dateTimeService
   * @return {calvingService}
   */
  function calvingService(labelService, lodash, dateTimeService) {
    /**
     * Create a calving label
     * @param {object} params
     * @return Promise<any>
     */
    this.createLabel = function (params) {
      var label = labelService.newLabel(
        lodash.assign(labelService.getLabelBlueprint("fertility", "calving", "cow"), params, {
          createdEpoch: dateTimeService.now(),
          tags: ["curated"]
        })
      );

      return labelService.saveLabel(label);
    };

    /**
     * Pick the proper calving label from the insight object
     * @return {GenericLabel|null}
     */
    this.getCalvingLabel = function (insight) {
      /**
       * Pick the calving labels from all the insight labels
       */
      var calvingLabels = lodash.filter(insight.genericLabels || [], ["title", "calving"]);

      return calvingLabels.length ? lodash.last(calvingLabels) : null;
    };

    /**
     * Remove calving label
     * @param insight
     * @return {Promise<any>}
     */
    this.removeCalvingLabel = function (insight) {
      var label = this.getCalvingLabel(insight);

      return labelService.getLabel(label.GenericLabelID).then(
        function (entity) {
          return entity.$delete().then(
            function () {
              /**
               * Update the insight locally as well
               */
              lodash.remove(insight.genericLabels, ["GenericLabelID", label.GenericLabelID]);
            }.bind(this)
          );
        }.bind(this)
      );
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .filter("epochsToString", function (moment, $translate) {
      /**
       * Convert epoch to string
       * @param epoch
       * @return {string}
       */
      return function (epoch) {
        /**
         * @type {Date}
         */
        var now = new Date();

        now.setHours(23, 59, 59, 99);

        /**
         * @type {Date}
         */
        var date1 = new Date(epoch * 1000);

        /**
         * @type {number}
         */
        var daysSinceStart = daysBetween(date1, now);

        /**
         * @type {string}
         */
        var dateString = "";

        if (daysSinceStart < 1) {
          dateString += $translate.instant("LABEL_TEXT_TODAY");
        } else if (daysSinceStart < 2) {
          dateString += $translate.instant("LABEL_TEXT_YESTERDAY");
        } else if (daysSinceStart < 7) {
          dateString += moment(date1).format("dddd");
        } else {
          dateString += moment(date1).format("dddd D MMM");
        }

        dateString += " " + moment(date1).format("HH:mm");

        return dateString;
      };

      /**
       * Get days between epochs
       * @param date1
       * @param date2
       * @return {number}
       */
      function daysBetween (date1, date2) {
        // The number of milliseconds in one day
        var ONE_DAY = 1000 * 60 * 60 * 24;

        // Calculate the difference in milliseconds
        var difference_ms = Math.abs(date1.getTime() - date2.getTime());

        // Convert back to days and return
        return Math.floor(difference_ms / ONE_DAY);
      }
    });
})();

"use strict";

angular
  .module("ctraUIComponents")
  .filter("epochToDayString", function (moment, $translate) {
    return function (epoch) {
      /**
       * @type {string}
       */
      var dateString = "";

      if (epoch) {
        /**
         * @type {Date}
         */
        var now = new Date();

        now.setHours(23, 59, 59, 99);

        /**
         * @type {Date}
         */
        var date = new Date(epoch * 1000);

        /**
         * @type {number}
         */
        var daysSince = daysBetween(now, date);

        if (daysSince === -1) {
          dateString = $translate.instant("LABEL_TEXT_TOMORROW");
        } else if (daysSince === 0) {
          dateString = $translate.instant("LABEL_TEXT_TODAY");
        } else if (daysSince === 1) {
          dateString = $translate.instant("LABEL_TEXT_YESTERDAY");
        } else if (daysSince > 1 && daysSince < 8) {
          dateString = moment(date).format("dddd");
        } else {
          dateString = moment(date).format("dddd D MMM");
        }
      }

      return dateString;
    };
  });

/**
 * @param date1
 * @param date2
 * @return {number}
 */
function daysBetween (date1, date2) {
  /**
   * @type {number}
   */
  var ONE_DAY = 1000 * 60 * 60 * 24;

  /**
   * @type {number}
   */
  var difference_ms = date1.getTime() - date2.getTime();

  return Math.floor(difference_ms / ONE_DAY);
}

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .filter("epochsToPeriodString", function (moment, lodash, LocoService, dateTimeService) {
      /**
       * Translate the given content while uppercasing the first letter
       * @return {string}
       */
      function translate () {
        return lodash.upperFirst(
          LocoService.translate.apply(LocoService, arguments)
        );
      }

      /**
       * Conver epochs to period string
       * @param epochs
       * @return {string}
       */
      return function (epochs) {
        /**
         * Today midnight
         * @type {Date}
         */
        var midnight = dateTimeService.midnight();

        /**
         * @type {Date}
         */
        var from = dateTimeService.asDate(lodash.first(epochs));

        /**
         * @type {Date}
         */
        var to = dateTimeService.asDate(lodash.last(epochs));

        /**
         * @type {number}
         */
        var daysSinceStart = dateTimeService.daysBetween(midnight, from, {
          useDayOfYear: true
        });

        /**
         * @type {number}
         */
        var daysSinceEnd = dateTimeService.daysBetween(midnight, to, {
          useDayOfYear: true
        });

        /**
         * @type {number}
         */
        var daysBetweenEpochs = Math.abs(dateTimeService.daysBetween(from, to, {
          useDayOfYear: true
        }));

        /**
         * @type {string}
         */
        var assetNamespace = "date-label";

        /**
         * @type {string}
         */
        var left = "";

        if (daysSinceStart === -1) {
          left += translate(assetNamespace, "tomorrow", { time: from });
        } else if (daysSinceStart === 0) {
          left += translate(assetNamespace, "today", { time: from });
        } else if (daysSinceStart === 1) {
          left += translate(assetNamespace, "yesterday", { time: from });
        } else if (daysSinceStart < 7) {
          left += translate(assetNamespace, "day", {
            day: moment(from).format("dddd"),
            time: from
          });
        } else {
          left += translate(assetNamespace, "datetime", {
            date: moment(from).format("dddd D MMM"),
            time: from
          });
        }

        /**
         * @type {string}
         */
        var right = "";

        if (daysBetweenEpochs === 0) {
          right += translate(assetNamespace, "time", {
            time: to
          });
        } else if (daysSinceEnd === -1) {
          right += translate(assetNamespace, "tomorrow", { time: to });
        } else if (daysSinceEnd === 0) {
          right += translate(assetNamespace, "today", { time: to });
        } else if (daysSinceEnd === 1) {
          right += translate(assetNamespace, "yesterday", { time: to });
        } else if (daysBetweenEpochs < 7 && daysSinceEnd < 7) {
          right += translate(assetNamespace, "day", {
            day: moment(to).format("dddd"),
            time: to
          });
        } else {
          right += translate(assetNamespace, "datetime", {
            date: moment(to).format("dddd D MMM"),
            time: to
          });
        }

        return [left, right].join(" - ");
      };
    });
})();

(function () {
  "use strict";

  angular
    .module("ctraUIComponents")
    .controller("LoaderController", LoaderController);

  /**
   * Controller for toggling loading states
   * @ngInject
   * @param vm
   * @constructor
   */
  function LoaderController (vm) {
    /**
     * Loading state
     * @type {boolean}
     */
    vm.loading = false;

    /**
     * Smoke test the component
     * @return {boolean}
     */
    vm.smokes = function () {
      return false;
    };

    /**
     * Set vm.loading to the given value
     * @param {boolean} to
     */
    vm.setLoading = function (to) {
      vm.loading = !!to;
    };
  }
})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  angular
    .module('dairyMonitorAdmin')
    .directive('baseStationSensors', baseStationSensors);

  /** @ngInject */
  function baseStationSensors() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/baseStationList/baseStationSensors/baseStationSensors.html',
      replace: true,
      scope: {
        baseStation:     "=",
        selectable:      "=",
        selectedSensors: "="
      },
      controller: baseStationSensorsController
    };

    return directive;

    /** @ngInject */
    function baseStationSensorsController($scope, sysAdminService) {
      var vm = $scope;

      vm.farm         = sysAdminService.getFarm(vm.baseStation.farmID);
      vm.sensors      = sysAdminService.getSensors(vm.baseStation);
      vm.cows         = sysAdminService.getCows(vm.baseStation.farmID);
      vm.baseStations = sysAdminService.getBaseStations(vm.baseStation.farmID);
    }
  }

})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  angular
    .module('dairyMonitorAdmin')
    .directive('baseStationDetails', baseStationDetails);

  /** @ngInject */
  function baseStationDetails() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/baseStationList/baseStationDetails/baseStationDetails.html',
      replace: true,
      scope: {
        baseStation:     "="
      },
      controller: baseStationDetailsController
    };

    return directive;

    /** @ngInject */
    function baseStationDetailsController($window, $rootScope, $scope, $state, $timeout, $log, sysAdminService) {
      var vm = $scope;
      vm.status = {};
      vm.farms  = sysAdminService.getFarms();

      vm.save = function (odataObj) {
        vm.status.saving = true;
        vm.status.saved = false;
        vm.status.failed = false;

        odataObj.$update().then(function(){
          vm.status.saving = false;
          vm.status.saved  = true;
        }, function(){
          vm.status.saving = false;
          vm.status.failed = true;
        });
      };

      vm.downloadBaseStationLog = function (/*baseStation*/) {
        $window.alert("Coming soon!");
      }
      vm.rebootBaseStation = function (/*baseStation*/) {
        var sure = $window.confirm("Are you sure you want to reboot this base station\nThe base station will be offline untill fully rebooted!");
        if(sure){
          $window.alert("Just kidding, coming soon!");
        }
      }

      vm.delete = function (odataObj) {
        var sure = $window.confirm("Are you sure you want to delete this?\nThis action cannot be undone!");
        if(sure){
          var really = $window.confirm("PLEASE DOUBLE CHECK!\nYou are deleting the following:\n"+angular.toJson(odataObj));
          if(really){
            odataObj.$delete().then(function () {
              $state.go($state.current, {}, {reload: true});
            }, function () {
              $window.alert('Something went wrong, please try again later');
            });
          }
        }
      }


    }
  }

})();

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin")
    .component("baseStationCredentials", {
      bindings: {
        baseStation: "<"
      },
      controller: BaseStationCredentialsController,
      templateUrl: "app/components/baseStationList/baseStationCredentials/baseStationCredentials.html"
    });

  /**
   * @param lodash
   * @param baseStationService
   * @param toastr
   * @constructor
   * @ngInject
   */
  function BaseStationCredentialsController (baseStationService, lodash, toastr) {
    var $ctrl = this;

    /**
     * Base station id
     * @type {null}
     */
    var bsId = null;

    /**
     * Set loading
     * @param to
     */
    function setLoading (to) {
      $ctrl.loading = !!to;
    }

    /**
     * Handle retrieve users
     * @param response
     */
    function usersRetrieved (response) {
      $ctrl.users = lodash.fromPairs(lodash.map(response.data, function (username) {
        return [username, {
          username: username,
          password: null,
          newPassword: null,
          newPasswordAgain: null
        }];
      }));
    }

    /**
     * Handle password retrieved
     * @param username
     * @param response
     */
    function onPasswordRetrieved (username, response) {
      $ctrl.users[username].password = response.data;
    }

    /**
     * Handle password changed
     * @param user
     */
    function onPasswordChanged (user) {
      user.password = user.newPassword;
      user.newPassword = null;
      user.newPasswordAgain = null;
    }

    /**
     * Handle error
     * @param reason
     */
    function handleError (reason) {
      toastr.error(reason.message);
    }

    /**
     * Show password for username
     * @param username
     */
    function showPassword (username) {
      setLoading(true);

      baseStationService.getBaseStationSecret(bsId, username)
        .then(lodash.partial(onPasswordRetrieved, username))
        .catch(handleError)
        .finally(lodash.partial(setLoading, false));
    }

    /**
     * Change password for the given user
     * @param user
     */
    function changePassword (user) {
      var passwordMatches = !!user.newPassword && user.newPassword === user.newPasswordAgain;

      if (passwordMatches) {
        setLoading(true);

        baseStationService.setBaseStationSecret(bsId, user.username, user.newPassword)
          .then(lodash.partial(onPasswordChanged, user))
          .catch(handleError)
          .finally(lodash.partial(setLoading, false));
      } else {
        toastr.error("The two passwords do not match.");
      }
    }

    $ctrl.$onInit = function () {
      bsId = $ctrl.baseStation.BaseStationID;

      setLoading(true);

      baseStationService.getBaseStationUsers(bsId)
        .then(usersRetrieved)
        .catch(handleError)
        .finally(lodash.partial(setLoading, false));
    };

    /**
     * @type {{showPassword: showPassword, changePassword: changePassword}}
     */
    var intf = {
      showPassword: showPassword,
      changePassword: changePassword
    };

    // Assign all the data call functions to the local context to create static members.
    lodash.forOwn(intf, function (endpointCall, key) {
      this[key] = endpointCall;
    }.bind(this));
  }

})();

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin")
    .component("baseStationCommands", {
      bindings: {
        baseStation: "<"
      },
      controller: BaseStationCommandsController,
      templateUrl: "app/components/baseStationList/baseStationCommands/baseStationCommands.html"
    });

  /**
   * @param baseStationService
   * @param lodash
   * @param toastr
   * @constructor
   * @ngInject
   */
  function BaseStationCommandsController (baseStationService, lodash, toastr) {
    var $ctrl = this;

    /**
     * @type {null}
     */
    $ctrl.selectedCommand = null;

    /**
     * @type {string}
     */
    $ctrl.commandResponse = "Issue a command first.";

    /**
     * Base station serial number
     * @type {null}
     */
    var bsSerial = null;

    /**
     * Set loading
     * @param to
     */
    function setLoading (to) {
      $ctrl.loading = !!to;
    }

    /**
     * Handle error
     * @param reason
     */
    function handleError (reason) {
      toastr.error(reason.message);
    }

    function onCommandProcessed (response) {
      toastr.success("Command successfully run.");
      $ctrl.commandResponse = response.data || [lodash.startCase($ctrl.selectedCommand), "successful."].join(" ");
      $ctrl.selectedCommand = null;
    }

    /**
     * Send command to base station
     */
    function sendCommand () {
      if ($ctrl.selectedCommand) {
        setLoading(true);

        baseStationService.issueCommand(bsSerial, $ctrl.selectedCommand)
          .then(lodash.partial(onCommandProcessed))
          .catch(handleError)
          .finally(lodash.partial(setLoading, false));
      }
    }

    /**
     * Handle retrieve commands
     * @param response
     */
    function commandsRetrieved (response) {
      $ctrl.commands = response.data;
    }

    $ctrl.$onInit = function () {
      bsSerial = $ctrl.baseStation.deviceSerialNum;

      setLoading(true);

      baseStationService.getAvailableCommands()
        .then(commandsRetrieved)
        .catch(handleError)
        .finally(lodash.partial(setLoading, false));
    };

    /**
     * @type {{sendCommand: sendCommand}}
     */
    var intf = {
      sendCommand: sendCommand
    };

    // Assign all the data call functions to the local context to create static members.
    lodash.forOwn(intf, function (endpointCall, key) {
      this[key] = endpointCall;
    }.bind(this));
  }

})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  angular
    .module('dairyMonitorAdmin')
    .directive('baseStationConfigDetails', baseStationConfigDetails);

  /** @ngInject */
  function baseStationConfigDetails() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/baseStationList/baseStationConfigDetails/baseStationConfigDetails.html',
      replace: true,
      scope: {
        baseStation: "="
      },
      controller: baseStationConfigDetailsController
    };

    return directive;

    /** @ngInject */
    function baseStationConfigDetailsController($document, $window, $rootScope, $scope, $state, $timeout, $log, sysAdminService) {
      var vm = $scope;
      vm.status = {};

      vm.loading = true;
      vm.baseStationConfig  = sysAdminService.getBaseStationConfigByBaseStationID(vm.baseStation.BaseStationID);
      vm.baseStationConfig.$promise.then(function successCallback() {
        vm.loading = false;
      }, function errorCallback() {
        vm.baseStationConfig = null;
        vm.loading = false;
      });


      vm.noEditVariables = [
        'configFileCreatedTime'
      ];

      vm.hiddenVariables = [
        'BaseStationConfigID',
        'UserId',
        'baseStationID',
        'customerID',
        'securityAuditUser',
        'securityGroupID'
      ];


      var download = function (filename, text) {
        /* eslint-disable angular/document-service */

        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      }


      vm.addSpaces = function (string) {
        return string.replace(/([a-z])(?=[A-Z])/g, '$1 ').trim();
      };


      vm.activateBaseStation = function (baseStation) {

        if(!baseStation) return false;

        $rootScope.loading = true;

        sysAdminService.initializeBaseStation(baseStation.BaseStationID).then(function successCallback(result) {
          sysAdminService.getBaseStationConfig = sysAdminService.getBaseStationConfig(result.BaseStationConfigID).$promise.then(function successCallback(result) {

            vm.baseStationConfig = result;
            $rootScope.loading = false;
          }, function errorCallback() {
            $window.alert('Something went wrong, unable to activate this base station at this moment...');
            $rootScope.loading = false;
          });
        }, function errorCallback() {
          $window.alert('Something went wrong, unable to activate this base station at this moment...');
          $rootScope.loading = false;
        });

      }


      vm.saveAndSendConfig = function (baseStationConfig) {
        $rootScope.loading = true;
        vm.error           = '';
        vm.success         = '';

        baseStationConfig.$update().then(function successCallback(){

        sysAdminService.sendConfigToBaseStation(baseStationConfig.baseStationID).then(function successCallback() {

            vm.success = "Successfully saved and synced the config with the base station"
            $rootScope.loading = false;

          }, function errorCallback(reason) {

            vm.error = "Failed to sync the the config with the base station, "+reason;
            $rootScope.loading = false;

          });

        }, function errorCallback() {

          vm.error = "Failed to save the config"
          $rootScope.loading = false;

        });
      };


      vm.save = function (odataObj) {
        $rootScope.loading = true;
        vm.error           = '';
        vm.success         = '';

        odataObj.$update().then(function(){
          $rootScope.loading = false;
          vm.success         = 'Saved!';
        }, function(){
          $rootScope.loading = false;
          vm.error           = 'Failed saving...';
        });
      };

      vm.sendConfig = function (baseStationConfig) {
        $rootScope.loading = true;
        vm.error           = '';
        vm.success         = '';

        sysAdminService.sendConfigToBaseStation(baseStationConfig.baseStationID).then(function successCallback() {

          vm.success = "Successfully synced the config with the base station"
          $rootScope.loading = false;

        }, function errorCallback(reason) {

          vm.error = "Failed to sync the the config with the base station, "+reason;
          $rootScope.loading = false;

        });
      }


      vm.downloadConfig = function (baseStationConfig) {
        $rootScope.loading = true;
        vm.error           = '';
        vm.success         = '';
        $rootScope.loading = false;

        sysAdminService.getBaseStationConfigFile(baseStationConfig.baseStationID).then(function successCallback(result) {
          var filename = "baseStationConfig_"+baseStationConfig.baseStationID;
          download(filename, result);

          $rootScope.loading = false;
          vm.success         = 'See you downloads folder for the config file with the name: "'+filename+'.txt"';
        }, function errorCallback() {

          $rootScope.loading = false;
          vm.error           = 'Something went wrong';

        });
      }


      vm.downloadMapping = function (baseStationID) {
        $rootScope.loading = true;
        vm.error           = '';
        vm.success         = '';
        $rootScope.loading = false;

        sysAdminService.getBaseStationMappingFile(baseStationID).then(function successCallback(result) {
          var filename = "baseStationMapping_"+baseStationID;
          download(filename, result);

          $rootScope.loading = false;
          vm.success         = 'See you downloads folder for the mapping file with the name: "'+filename+'.txt"';
        }, function errorCallback() {

          $rootScope.loading = false;
          vm.error           = 'Something went wrong';

        });
      }

    }
  }

})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  angular
    .module('dairyMonitorAdmin')
    .directive('herdGroupDetails', herdGroupDetails);

  /** @ngInject */
  function herdGroupDetails() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/herdGroupList/herdGroupDetails/herdGroupDetails.html',
      replace: true,
      scope: {
        herdGroup:     "="
      },
      controller: herdGroupDetailsController
    };

    return directive;

    /** @ngInject */
    function herdGroupDetailsController($window, $rootScope, $scope, $state) {
      var vm = $scope;
      vm.status = {};

      vm.save = function (odataObj) {
        vm.status.saving = true;
        vm.status.saved = false;
        vm.status.failed = false;

        odataObj.$update().then(function(){
          vm.status.saving = false;
          vm.status.saved  = true;
        }, function(){
          vm.status.saving = false;
          vm.status.failed = true;
        });
      };

      vm.delete = function (odataObj) {
        var sure = $window.confirm("Are you sure you want to delete this?\nThis action cannot be undone!");
        if(sure){
          var really = $window.confirm("PLEASE DOUBLE CHECK!\nYou are deleting the following:\n"+angular.toJson(odataObj));
          if(really){
            odataObj.$delete().then(function () {
              $state.go($state.current, {}, {reload: true});
            }, function () {
              $window.alert('Something went wrong, please try again later');
            });
          }
        }
      }


    }
  }

})();

/* eslint-disable angular/module-getter */

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .service('userService', userService);

  /** @ngInject */
  function userService(appConfig, $http, $q, authenticationService) {

    this.newUser = function (details) {
      return authenticationService.newUser(details);
    };


    this.getUsers = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: appConfig.LEGACYAUTHAPIURL+'Users/List',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function successCallback(response) {
        response.data = response.data.sort(function (a, b) {
          return (a.email > b.email ? 1 : -1);
        });
        deferred.resolve(response.data);
      }, function errorCallback(reason) {
        deferred.reject(reason);
      });

      return deferred.promise;
    };


    this.updateUserRole = function (user, role) {

      // {
      //   "id": "af4cc008-c711-48aa-8f82-74d9fc98645c",
      //   "email":"timo@connecterra.io",
      //   "rolesList": ["Admin"]
      // }

      user.rolesList = [role.name];
      return this.updateUser(user);
    }

    this.updateUser = function (user) {
      return authenticationService.updateUser(user)
    }

    this.deleteUser = function (user) {
      var deferred = $q.defer();

      //POST Users/Delete/{id}
      $http({
        method: 'POST',
        url: appConfig.LEGACYAUTHAPIURL+'Users/Delete/'+user.id
      }).then(function successCallback(response) {
          deferred.resolve(response);
        }, function errorCallback(reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    this.resetUserPassword = function (email) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        url: appConfig.LEGACYAUTHAPIURL+'Account/ForgotPassword',
        data: {
          email: email
        }
      }).then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .factory('trafficCop', trafficCop);

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  /** @ngInject */
  function trafficCop($q, appStatusService, $log) {
    var trafficCop = {
      requestError: function(rejectReason) {
        $log.info('rejectReason',rejectReason);
        appStatusService.logError('Failed AJAX call '+rejectReason.status, '', rejectReason.data, '0', false);
        return $q.reject(rejectReason);
      },
      responseError: function(rejectReason) {
        //If we can't get the farms or basestations there is something seriously wrong and we need to do a refresh.
        if(
          rejectReason.config.url.indexOf('Farms') > -1 ||
          rejectReason.config.url.indexOf('BaseStations') > -1 ||
          rejectReason.config.url.indexOf('Customers') > -1
        ){
          appStatusService.logError('Failed AJAX call '+rejectReason.status, '', rejectReason.config.url, '4', true);
        }else{
          appStatusService.logError('Failed AJAX call '+rejectReason.status, '', rejectReason.config.url, '0', false);
        }

        return $q.reject(rejectReason);
      }
    };
    return trafficCop;
  }

})();

/* eslint-disable angular/module-getter */

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .service('roleService', roleService);

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  /** @ngInject */
  function roleService(appConfig, $http, $q) {
    // AngularJS will instantiate a singleton by calling "new" on this function

    this.newRole = function (details) {

      // details = {
      //   "name":"test",
      //   "description":"test role."
      // };

      var deferred = $q.defer();

      $http({
        method: 'POST',
        url: appConfig.LEGACYAUTHAPIURL+'Roles/Create',
        headers: {
          'Content-Type': 'application/json'
        },
        data: details
      }).then(function successCallback(response) {
          deferred.resolve(response.data);
        }, function errorCallback(reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };


    this.getRoles = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: appConfig.LEGACYAUTHAPIURL+'Roles/List',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function successCallback(response) {
          deferred.resolve(response.data);
        }, function errorCallback(reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };


    this.deleteRole = function (role) {
      var deferred = $q.defer();

      //POST Roles/Delete/{id}
      $http({
        method: 'GET',
        url: appConfig.LEGACYAUTHAPIURL+'Roles/Delete/'+role.id
      }).then(function successCallback(response) {
          deferred.resolve(response);
        }, function errorCallback(reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .service('systemMonitorService', systemMonitorService);

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services
  /* global d3: false */

  /** @ngInject */
  function systemMonitorService($q, $http, $log, appConfig) {

    this.getMonitoringStates = getMonitoringStates;
    this.getMonitorHistory   = getMonitorHistory;
    this.processDataForChart = processDataForChart;

    function getMonitoringStates(parent) {
      var deferred = $q.defer();

      var dateTill = new Date();
      var dateFrom = new Date();
      dateFrom.setDate(dateTill.getDate()-1);

      var fromEpoch = Math.round(dateFrom.getTime()/1000),
          tillEpoch = Math.round(dateTill.getTime()/1000);


      // AngularJS will instantiate a singleton by calling "new" on this function
      $http({
        method: 'GET',
        // url: 'http://ctradataapi.azurewebsites.net/api/getmonitoringstatesex/'+parent
        url: appConfig.DATAAPIURL+'MonitorStates/Rollup/'+parent+'/'+fromEpoch+'/'+tillEpoch
      }).then(function successCallback(response) {
          deferred.resolve(response.data);
        }, function errorCallback(response) {
          deferred.reject(response);
        });

      return deferred.promise;
    }


    function getMonitorHistory(monitorId, dateFrom, dateTill) {

      var deferred = $q.defer();

      $log.info('Fetching History for monitor: '+monitorId);

      var fromEpoch = Math.round(dateFrom.getTime()/1000),
          tillEpoch = Math.round(dateTill.getTime()/1000);

      $http({
        method: 'GET',
        // url: 'http://ctradataapi.azurewebsites.net/api/monitorHistory/'+monitorId+'/'+fromEpoch+'/'+tillEpoch
        url: appConfig.DATAAPIURL+'monitorHistoryCSV/monitor/'+monitorId+'/'+fromEpoch+'/'+tillEpoch
        //url: 'http://ctradataapi.azurewebsites.net/api/1/00000112/EventsSummary/1462791600/1462984412'
      }).then(function successCallback(response) {

        var result = d3.csvParse(response.data);

        deferred.resolve(result);
      }, function errorCallback(reason) {
        deferred.reject(reason);
      });

      return deferred.promise;
    }

    function processDataForChart(data) {
      var reportData = {};

      var nowEpoch = new Date().getTime()/1000;

      angular.forEach(data, function (interval) {
          var dataPoint = {};
          dataPoint.Epoch = parseInt(interval.Timestamp);
          dataPoint.date  = new Date(dataPoint.Epoch*1000);
          dataPoint.value = +interval.PassRate;
          dataPoint.interval = 300;

          var key = interval.ReferenceID;

          if(!reportData[key]) reportData[key] = [];

          if(dataPoint.Epoch <= nowEpoch){
            reportData[key].push(dataPoint);
          }

      });

      angular.forEach(reportData, function (report) {
        report.sort(function (a,b) {
          if (a.Epoch > b.Epoch) { return 1; }
          if (a.Epoch === b.Epoch && a.value < b.value) { return 1; }
          return -1;
        });
      });

      return reportData;
    }

    return this;
  }


})();

/* eslint-disable angular/module-getter */

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .service('sysAdminService', sysAdminService);

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  /** @ngInject */
  function sysAdminService(appConfig, $odata, $log, $odataresource, $http, $q) {
    // AngularJS will instantiate a singleton by calling "new" on this function



    var Customer = $odataresource(appConfig.APIURL+'odata/Customers', {}, {}, {odatakey : 'CustomerID'});
    this.getCustomers = function () {
      // TODO: only request when we aren't already making the request
      return Customer.odata().orderBy("customerName","asc").query();
    };


    this.newCustomer = function(details){
      var customer = new Customer();

      angular.forEach(details, function(value, key){
        this[key] = value;
      }, customer);

      return customer;
    };





    var Farm = $odataresource(appConfig.APIURL+'odata/Farms', {}, {}, {odatakey : 'FarmID'});
    this.getFarms = function (options) {
      var farms = Farm.odata().orderBy("farmName","asc")

      if(options){
        if(options.select){
          farms.select(options.select);
        }
      }


      return farms.query();
    };

    this.getFarm = function (farmID) {
      if(!farmID){
        $log.error("farmID is required to get a farm");
        return false;
      }

      return Farm.odata()
        .filter("FarmID", parseInt(farmID))
        .single();
    };


    this.newFarm = function(details){
      var farm = new Farm();

      angular.forEach(details, function(value, key){
        this[key] = value;
      }, farm);

      return farm;
    };





    var HerdGroup = $odataresource(appConfig.APIURL+'odata/HerdGroups', {}, {}, {odatakey : 'HerdGroupID'});
    this.getHerdGroups = function (farmID, options) {

      // TODO: only request when we aren't already making the request
      var herdGroups = HerdGroup.odata();

      if(farmID){
        herdGroups.orderBy("groupName","asc").filter("farmID",farmID);
      }else{
        herdGroups.orderBy("farmID","asc");
      }

      if(options){
        if(options.select){
          herdGroups.select(options.select);
        }
      }

      return herdGroups.query();
    };

    this.newHerdGroup = function(details){
      var herdGroup = new HerdGroup();

      angular.forEach(details, function(value, key){
        this[key] = value;
      }, herdGroup);

      return herdGroup;
    };





    var Cow = $odataresource(appConfig.APIURL+'odata/DairyCows', {}, {}, {odatakey : 'DairyCowID'});
    this.getCows = function (farmIDs, options) {

      // TODO: only request when we aren't already making the request
      var cows = Cow.odata();

      if(farmIDs){
        farmIDs = (angular.isArray(farmIDs) ? farmIDs : [farmIDs]);
        var predicates = [];
        angular.forEach(farmIDs, function(value){
          predicates.push(new $odata.Predicate("farmID", value));
        });

        $log.info('Fetching DairyMonitors from the database');
        cows.filter($odata.Predicate.or(predicates))
      }

      if(options){
        if(options.select){
          cows.select(options.select);
        }
      }

      return cows.query();
      };

    this.getCow = function (cowID) {
      var cow = Cow.odata()
        .filter("DairyCowID",parseInt(cowID))
        .single();

      $log.info('Fetching DairyCow from the database', cow);

      return cow.$promise;
    };

    this.newCow = function(details){
      var cow = new Cow();

      angular.forEach(details, function(value, key){
        this[key] = value;
      }, cow);

      return cow;
    };




    var BaseStation = $odataresource(appConfig.APIURL+'odata/BaseStations', {}, {}, {odatakey : 'BaseStationID'});
    this.getBaseStations = function (farmID, options) {

      // TODO: only request when we aren't already making the request
      // var baseStation = BaseStation.odata().expand("baseStationConfig");
      var baseStation = BaseStation.odata();

      if(farmID){
        baseStation.filter("farmID",farmID);
      }

      if(options){
        if(options.select){
          baseStation.select(options.select);
        }
      }

      return baseStation.orderBy("farmID","asc").query();
    };


    this.newBaseStation = function(details){
      var baseStation = new BaseStation();

      angular.forEach(details, function(value, key){
        this[key] = value;
      }, baseStation);

      return baseStation;
    };




    var BaseStationConfig = $odataresource(appConfig.ADMINAPIURL+'odata/BaseStationConfigs', {}, {}, {odatakey : 'BaseStationConfigID'});
    this.getBaseStationConfig = function (baseStationConfigID) {

      // TODO: only request when we aren't already making the request
      var baseStationConfig = BaseStationConfig.odata();

      baseStationConfig.filter("BaseStationConfigID",baseStationConfigID);


      return baseStationConfig.single();
    };


    this.getBaseStationConfigByBaseStationID = function (baseStationID) {

      var baseStationConfig = BaseStationConfig.odata();
      baseStationConfig.filter("baseStationID",baseStationID);


      return baseStationConfig.single();
    };


    this.initializeBaseStation = function(baseStationID){
      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: appConfig.ADMINAPIURL+'odata/InitializeBaseStation(BaseStationID='+baseStationID+')',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function successCallback(response) {
        deferred.resolve(response.data.value);
      }, function errorCallback(reason) {
        deferred.reject(reason);
      });

      return deferred.promise;
    };



    // https://admin.connecterra.io/odata/SendConfigToDevice(BaseStationID=1)
    this.sendConfigToBaseStation = function(baseStationID) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: appConfig.ADMINAPIURL+'odata/SendConfigToDevice(BaseStationID='+baseStationID+')',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function successCallback(response) {
          if(response.data.value){
            deferred.resolve();
          }else{
            deferred.reject('No confirmation received');
          }
        }, function errorCallback(reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    }

    this.getBaseStationConfigFile = function (BaseStationID) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: appConfig.ADMINAPIURL+'odata/GetBaseStationConfigFile(BaseStationID='+BaseStationID+')',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function successCallback(response) {
        deferred.resolve(response.data.value);
      }, function errorCallback(reason) {
        deferred.reject(reason);
      });

      return deferred.promise;
    };


    this.getBaseStationMappingFile = function (BaseStationID) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: appConfig.ADMINAPIURL+'odata/GetBaseStationMappingFile(BaseStationID='+BaseStationID+')',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function successCallback(response) {
        deferred.resolve(response.data.value);
      }, function errorCallback(reason) {
        deferred.reject(reason);
      });

      return deferred.promise;
    };



    var Sensor = $odataresource(
      appConfig.APIURL+'odata/DairyMonitors',
      {},
      { patch: { method: "PATCH" } },
      {odatakey : 'NodeID'}
    );

    this.getSensors = function(baseStations, options){
      var sensors = Sensor.odata();

      if(baseStations){

        baseStations = (angular.isArray(baseStations) ? baseStations : [baseStations]);

        var predicates = [];
        angular.forEach(baseStations, function(value){
          predicates.push(new $odata.Predicate("baseStationID", value.BaseStationID));
        });

        $log.info('Fetching DairyMonitors from the database');
        sensors.filter($odata.Predicate.or(predicates))
      }

      if(options){
        if(options.select){
          sensors.select(options.select);
        }
      }

      return sensors.query();

    };

    this.newSensor = function(details){
      var sensor = new Sensor();

      angular.forEach(details, function(value, key){
        this[key] = value;
      }, sensor);

      return sensor;
    };

    this.changeDairyMonitorToCow = function(dairyCowID, nodeID){

      var deferred = $q.defer();

      $http({
        method: 'POST',
        url: appConfig.APIURL+'odata/ChangeDairyMonitorNode(dairyCowID='+dairyCowID+',newNodeID='+nodeID+')',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function successCallback(response) {
        deferred.resolve(response);
      }, function errorCallback(reason) {
        deferred.reject(reason);
      });

      return deferred.promise;

    }

  }
})();

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin")
    .service("boxService", boxService);

  /**
   * @ngInject
   */
  function boxService ($http, appConfig, lodash, sessionService) {

    /**
     * Update a base station life cycle
     * @param boxID
     * @param lifeCycleState
     * @return {HttpPromise}
     */
    this.updateLifeCycle = function(boxID, lifeCycleState) {
      /**
       * @type {string}
       */
      var api = appConfig.APIURL + "odata/SetBoxSensorsLifeCycleState";

      /**
       * @type {string}
       */
      var params = "(boxName='" + boxID + "',lifeCycleState='" + lifeCycleState + "')";

      /**
       * @type {string}
       */
      var url = api + params;

      return $http({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
          'Authorization': 'Bearer '+sessionService.token.access_token
        }
      });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .service('appStatusService', appStatusService);

  /** @ngInject */
  function appStatusService() {
    /*
    // QUESTION: Should I only use factories?!
    I don’t want to do multiple angular calls and keep ties between the places where the data is displayed (when I update it somewhere, it should update everywhere I use that data)

    I first wrote it this way, to use the Factory strategy: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services
    var errors = [];

    var service = {
      errors: errors,
      clearErrors: clearErrors,
      logError: logError
    };

    return service;

    */

    this.errors = [];
    this.clearErrors = clearErrors,
    this.logError = logError


    function clearErrors(){
      this.errors.length = 0;
    }

    function logError(title, message, details, priority, refreshRequired){
      var newError              = {};
      newError.title            = title;
      newError.message          = message;
      newError.details          = details;
      newError.priority         = priority || 0;
      newError.refreshRequired  = refreshRequired;

      this.errors.push(newError);
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin")
    .service("baseStationService", baseStationService);

  /**
   * @ngInject
   */
  function baseStationService ($http, appConfig, lodash, sessionService) {
    /**
     * Endpoint URL. Staging or production.
     * @type {string}
     */
    var PROTOCOL_AND_DOMAIN = appConfig.DATAAPIURL;

    /**
     * Api endpoints
     * @type {{baseStationUsers, getSecret, setSecret, availableCommands, issueCommand}}
     */
    var ENDPOINTS = {
      baseStationUsers: lodash.template("${url}BaseStationUsers"),
      getSecret: lodash.template("${url}BSC/${bsId}/${username}"),
      setSecret: lodash.template("${url}BSC"),
      availableCommands: lodash.template("${url}BaseStationCommands"),
      issueCommand: lodash.template("${url}IssueCommand/${commandName}/${bsId}")
    };

    /**
     * Get all the users of a base station
     * @param bsId
     */
    function getBaseStationUsers (bsId) {
      return $http.get(ENDPOINTS.baseStationUsers({
        url: PROTOCOL_AND_DOMAIN,
        bsId: bsId
      }));
    }

    /**
     * Get base station password for the given id and username
     * @param bsId
     * @param username
     */
    function getBaseStationSecret (bsId, username) {
      return $http.get(ENDPOINTS.getSecret({
        url: PROTOCOL_AND_DOMAIN,
        bsId: bsId,
        username: username
      }));
    }

    /**
     * Set base station password
     * @param bsId
     * @param username
     * @param secret
     */
    function setBaseStationSecret (bsId, username, secret) {
      return $http.post(ENDPOINTS.setSecret({
        url: PROTOCOL_AND_DOMAIN
      }), {
        bsid: bsId,
        user: username,
        value: secret
      });
    }

    /**
     * Get available base station commands
     */
    function getAvailableCommands () {
      return $http.get(ENDPOINTS.availableCommands({
        url: PROTOCOL_AND_DOMAIN
      }));
    }

    /**
     * Issues a base station command
     * @param bsId
     * @param commandName
     */
    function issueCommand (bsId, commandName) {
      return $http.post(ENDPOINTS.issueCommand({
        url: PROTOCOL_AND_DOMAIN,
        bsId: bsId,
        commandName: commandName
      }));
    }

    /**
     * Update a base station life cycle
     * @param baseStationId
     * @param lifeCycleState
     * @return {HttpPromise}
     */
    function updateLifeCycle(baseStationId, lifeCycleState) {
      /**
       * @type {string}
       */
      var api = appConfig.APIURL + "odata/SetBSSensorsLifeCycleState";

      /**
       * @type {string}
       */
      var params = "(baseStationID=" + baseStationId + ",lifeCycleState='" + lifeCycleState + "')";

      /**
       * @type {string}
       */
      var url = api + params;

      return $http({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
          'Authorization': 'Bearer '+sessionService.token.access_token
        }
      });
    }

    /**
     * @type {{
     *   getBaseStationUsers: getBaseStationUsers,
     *   getBaseStationSecret: getBaseStationSecret,
     *   setBaseStationSecret: setBaseStationSecret,
     *   getAvailableCommands: getAvailableCommands,
     *   issueCommand: issueCommand
     * }}
     */
    var intf = {
      getBaseStationUsers: getBaseStationUsers,
      getBaseStationSecret: getBaseStationSecret,
      setBaseStationSecret: setBaseStationSecret,
      getAvailableCommands: getAvailableCommands,
      issueCommand: issueCommand,
      updateLifeCycle: updateLifeCycle
    };

    // Assign all the data call functions to the local context to create static members.
    lodash.forOwn(intf, function (endpointCall, key) {
      this[key] = endpointCall;
    }.bind(this));
  }

})();

(function () {
  "use strict";

  /**
   * Oh man, this is so bad! Since tintash made the insight
   * component app session service dependent, it will not work
   * with the admin. This hack is supposed to patch that by creating
   * the service locally and enabling a NULL farmId.
   */
  angular
    .module("dairyMonitorAdmin")
    .service("appSessionService", function () {
      this.farmId = null;
    });
})();

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin.insights", [
      "ui.router",
      "ctraAuthentication",
      "dairyMonitorAdmin.insights.insightTypes",
      "dairyMonitorAdmin.insights.insightAccuracy",
      "dairyMonitorAdmin.insights.insightModels",
      "dairyMonitorAdmin.insights.estrusInsights",
      "dairyMonitorAdmin.insights.estrusInsightCurating",
      "dairyMonitorAdmin.insights.labelsExplorer",
      "dairyMonitorAdmin.insights.labelCurating",
      "dairyMonitorAdmin.insights.estrusLabelCurating",
      "dairyMonitorAdmin.insights.healthLabelCurating"
    ]);

}());

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin.insights").config(routerConfig);

  /**
   * @param USER_ROLES
   * @return {{authorizedRoles: *[]}}
   */
  function getRouteData (USER_ROLES) {
    return {
      authorizedRoles: [USER_ROLES.admin]
    };
  }

  /**
   * @param insightService
   * @return {*}
   */
  function getInsightTypes (insightService) {
    return insightService.getInsightTypes();
  }

  /**
   * @param insightService
   * @return {*}
   */
  function getInsightModels (insightService) {
    return insightService.getInsightModels();
  }

  /**
   * @param $stateProvider
   * @param USER_ROLES
   */
  function routerConfig ($stateProvider, USER_ROLES) {
    $stateProvider
      .state("insights", {
        url: "/insights",
        component: "insights",
        resolve: {
          insightTypes: getInsightTypes
        },
        data: getRouteData(USER_ROLES)
      })
      .state("insights.insightTypes", {
        url: "/types",
        component: "insightTypes",
        resolve: {
          insightTypes: getInsightTypes
        },
        data: getRouteData(USER_ROLES)
      })
      .state("insights.insightTypes.new", {
        url: "/new",
        component: "newInsightType",
        data: getRouteData(USER_ROLES)
      })
      .state("insights.insightModels", {
        url: "/models",
        component: "insightModels",
        resolve: {
          insightModels: getInsightModels
        },
        data: getRouteData(USER_ROLES)
      })
      .state("insights.insightModels.new", {
        url: "/new?insightTypeID",
        component: "newInsightModel",
        resolve: {
          insightTypes: getInsightTypes
        },
        data: getRouteData(USER_ROLES)
      })
      .state("insights.insightAccuracy", {
        url: "/accuracy",
        component: "insightAccuracy",
        resolve: {},
        data: getRouteData(USER_ROLES)
      })
      .state("insights.estrusInsights", {
        url: "/estrusInsights",
        component: "estrusInsights",
        resolve: {},
        data: getRouteData(USER_ROLES)
      })
      .state("insights.estrusInsightCurating", {
        url: "/estrusInsightCurating",
        component: "estrusInsightCurating",
        resolve: {},
        data: getRouteData(USER_ROLES)
      })
      .state("insights.labelsExplorer", {
        url: "/labelsExplorer",
        component: "labelsExplorer",
        resolve: {},
        data: getRouteData(USER_ROLES)
      })
      .state("insights.labelCurating", {
        url: "/labelCurating",
        component: "labelCurating",
        resolve: {},
        data: getRouteData(USER_ROLES)
      })
      .state("insights.estrusLabelCurating", {
        url: "/estrusLabelCurating",
        component: "estrusLabelCurating",
        resolve: {},
        data: getRouteData(USER_ROLES)
      })
      .state("insights.healthLabelCurating", {
        url: "/healthLabelCurating",
        component: "healthLabelCurating",
        resolve: {},
        data: getRouteData(USER_ROLES)
      });
  }

}());

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin.insights")
    .component("insights", {
      bindings: {
        insightTypes: "<"
      },
      controller: insightsCtrl,
      templateUrl: "app/views/insights/insights.html"
    });

  /** @ngInject */
  function insightsCtrl () {
    var $ctrl = this;

    $ctrl.$onInit = onInit;

    function onInit () {
      $ctrl.subnavItems = [{
        state: "insights.insightTypes",
        title: "Types"
      }, {
        state: "insights.insightModels",
        title: "Models"
      }, {
        state: "insights.insightAccuracy",
        title: "Accuracy"
      }, {
        state: "insights.estrusInsights",
        title: "Estrus Insights"
      }, {
        state: "insights.estrusInsightCurating",
        title: "Estrus Insight Curating"
      }, {
        state: "insights.labelsExplorer",
        title: "labels"
      }, {
        state: "insights.labelCurating",
        title: "label curation"
      }, {
        state: "insights.estrusLabelCurating",
        title: "Estrus Label Curating"
      }, {
        state: "insights.healthLabelCurating",
        title: "Health Label Curating"
      }];
    }
  }

}());

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin").config(routerConfig);

  function routerConfig($stateProvider, USER_ROLES) {
    $stateProvider
      .state("labels", {
        url: "/labels",
        component: "labels",
        resolve: {
          labels: function (labelService) {
            return labelService.getLabels();
          }
        },
        data: { authorizedRoles: [USER_ROLES.farmer, USER_ROLES.farmEmployee, USER_ROLES.admin] }
      })
      .state("newLabel", {
        url: "/newLabel?hideFields&category&title&scope&farmID&cowID&startEpoch&endEpoch&duration",
        component: "newLabel",
        resolve: {
          label: function ($stateParams) {
            var label = {};
            label.farmID = parseInt($stateParams.farmID);
            label.category = $stateParams.category;
            label.title = $stateParams.title;
            label.labelScope = $stateParams.scope || ($stateParams.cowID ? "cow" : null);
            label.dairyCowID = parseInt($stateParams.cowID);
            label.startEpoch = parseInt($stateParams.startEpoch);
            label.endEpoch = parseInt($stateParams.endEpoch);
            label.duration = parseInt($stateParams.duration);
            return label;
          },
          hideFields: function ($stateParams) {
            if (!$stateParams.hideFields) return [];
            return angular.fromJson($stateParams.hideFields);
          },
          farms: function (sysAdminService) {
            return sysAdminService.getFarms();
          }
        },
        data: { authorizedRoles: [USER_ROLES.farmer, USER_ROLES.farmEmployee, USER_ROLES.admin] }
      })
      .state("estrusLabelCurating", {
        url: "/estrusLabelCurating?hideFields&category&title&scope&farmID&cowID&startEpoch&endEpoch&duration",
        component: "estrusLabelCurating",
        data: { authorizedRoles: [USER_ROLES.farmer, USER_ROLES.farmEmployee, USER_ROLES.admin] }
      })
      .state("label", {
        url: "/label/:genericLabelID?markAsChecked",
        component: "editLabel",
        resolve: {
          label: function ($stateParams, labelService) {
            var labelLoader = labelService.getLabel($stateParams.genericLabelID);

            if ($stateParams.markAsChecked === "true") {
              labelLoader.then(function (label) {
                if (label.tags.indexOf("checked") <= -1) {
                  label.tags.push("checked");
                  label.tags.push(labelService.makeUserTag());
                  labelLoader = labelService.updateLabel(label);
                }
              });
            }
            return labelLoader;
          }
        },
        data: { authorizedRoles: [USER_ROLES.farmer, USER_ROLES.farmEmployee, USER_ROLES.admin] }
      });
  }
})();

(function () {
  'use strict';

  angular.module('dairyMonitorAdmin').config(routerConfig);

  function routerConfig($stateProvider, USER_ROLES) {

    $stateProvider
      .state('insight', {
        url: '/insight/:genericInsightID',
        component: "insightFactory",
        resolve: {
          /**
           * Get insight from insight service
           * @param GenericInsightService
           * @param $stateParams
           * @returns {*}
           * @ngInject
           */
          insight: function (GenericInsightService, $stateParams) {
            return GenericInsightService.fetchSingleInsight(parseFloat($stateParams.genericInsightID));
          }
        },
        data: { authorizedRoles: [USER_ROLES.admin] }
      })
      .state('insight.edit', {
        url: '/edit',
        component: 'editInsight',
        data: { authorizedRoles: [USER_ROLES.admin] }
      });

  }

}());

(function () {
  "use strict";

  angular.module("ctraAuthentication").service("sessionService", function ($log, localStorageService) {
    var self = this;

    this.user = null;
    this.userRoles = null;
    this.token = null;

    this.create = create;
    this.destroy = destroy;
    this.isValidSession = isValidSession;

    init();

    /**
     * Initialise
     */
    function init() {
      if (isValidSession()) {
        start();
      } else {
        destroy();
      }
    }

    /**
     * Check user role
     * @param role
     * @return {boolean}
     */
    this.hasRole = function (role) {
      return this.userRoles.indexOf(role) > -1 || this.userRoles.indexOf("Admin") > -1;
    };

    /**
     * Tell whether the session is still valid
     * @return {boolean}
     */
    function isValidSession() {
      var session = localStorageService.get("session");

      if (session && session.user && session.userRoles && session.token && session.expireEpoch) {
        /**
         * @type {Date}
         */
        var now = new Date();

        if (session.expireEpoch > now.getTime()) {
          return true;
        } else {
          $log.info("Session is expired");

          return false;
        }
      } else {
        return false;
      }
    }

    /**
     * Create session
     * @param user
     * @param token
     */
    function create(user, token) {
      /**
       * @type {{user: *, userRoles: *, token: *, expireEpoch: number}}
       */
      var session = {
        user: user,
        userRoles: user.rolesList,
        token: token,
        expireEpoch: +new Date(token.expires)
      };

      localStorageService.set("session", session);

      $log.info("Session created: ", session);
      $log.info("Session will be valid till: ", new Date(token.expires));

      start();
    }

    /**
     * Start a session
     */
    function start() {
      var session = localStorageService.get("session");

      $log.info("Session started", session);

      self.user = session.user;
      self.userRoles = session.userRoles;
      self.token = session.token;
    }

    /**
     * Destroy session
     */
    function destroy() {
      $log.info("Session ended");

      self.user = null;
      self.userRoles = null;
      self.token = null;

      localStorageService.remove("session", "expireEpoch");
    }

    return this;
  });
})();

(function () {
  "use strict";

  angular.module("ctraAuthentication").service("authenticationService", authenticationService);

  /**
   * @param $window
   * @param $http
   * @param $location
   * @param $state
   * @param $stateParams
   * @param $rootScope
   * @param $q
   * @param $log
   * @param $timeout
   * @param $odataresource
   * @param appConfig
   * @param localStorageService
   * @param sessionService
   * @param AUTH_EVENTS
   * @param lodash
   * @return {authenticationService}
   * @ngInject
   */
  function authenticationService(
    $window,
    $http,
    $location,
    $state,
    $stateParams,
    $rootScope,
    $q,
    $log,
    $timeout,
    $odataresource,
    appConfig,
    localStorageService,
    sessionService,
    AUTH_EVENTS,
    lodash
  ) {
    var self = this;
    this.loadUserLoader = null;

    this.login = login;
    this.isAuthenticated = isAuthenticated;
    this.isAuthorized = isAuthorized;
    this.autoLogin = autoLogin;
    this.logout = logout;
    this.clearCredentials = clearCredentials;
    this.newUser = newUser;
    this.updateUser = updateUser;
    this.changePassword = changePassword;
    this.forgotPassword = forgotPassword;
    this.resetPassword = resetPassword;
    this.verifyEmail = verifyEmail;
    this.getUserByID = getUserByID;

    if (!localStorageService.isSupported) {
      $log.warn("Warning, localStorage is not supported");

      $window.alert(
        "Warning, localStorage is not supported, this may affect the efficiency of this " +
          "app \n Please update your browser, or download a more modern browser..."
      );
    }

    /**
     * Login
     * @param email
     * @param password
     * @param stayLoggedIn
     * @return {*}
     */
    function login(email, password, stayLoggedIn) {
      var deferred = $q.defer();

      /**
       * @type {{username: *, password: *, grant_type: string}}
       */
      var loginData = {
        username: email,
        password: password
      };

      $log.info("Logging in with the follwing credentials: ", loginData);

      $http({
        method: "POST",
        url: appConfig.AUTHAPIURL + "token",
        headers: {
          "content-type": "application/json"
        },
        /**
         * @param obj
         * @return {string}
         */
        transformRequest: function (obj) {
          return angular.toJson(obj);
        },
        data: loginData
      }).then(
        function (response) {
          $log.info("Logged in sucessfully! :-)", response.data);

          var token = {
            access_token: response.data.token,
            expires: response.data.expirationDate,
            token_type: "bearer"
          };

          sessionService.token = token;

          if (stayLoggedIn) {
            localStorageService.set("credentials", loginData);
          }

          // Load the user by emailAddress
          loadUser(email).then(
            function (user) {
              // Set the user data
              sessionService.create(user, token);
              $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
            },
            function (reason) {
              // For some reason the user is not yet ready to log in, could be an activation or setup issue.
              clearCredentials();
              $rootScope.$broadcast(AUTH_EVENTS.loginFailed);

              deferred.reject({
                code: null,
                message: reason
              });
            }
          );
        },
        function (reason) {
          if (reason.data && reason.data.error === "invalid_grant") {
            $log.error("Wrong password/email combination");

            deferred.reject({
              code: "wrongPassword",
              message: "WrongPassword"
            });
          } else if (reason.data && reason.data.error === "1") {
            $log.error("User is locked out");

            deferred.reject({
              code: "lockedOut",
              message: "ERROR_MESSAGE_LOCKED_OUT"
            });
          } else {
            $log.error("Unexpected response from server when loggin in");

            deferred.reject({
              code: null,
              message: "LABEL_TEXT_OOPS"
            });
          }
        }
      );

      return deferred.promise;
    }

    /**
     * Load user
     * @param email
     * @return {*}
     */
    function loadUser(email) {
      self.loadUserLoader = $q.defer();
      $rootScope.loading = true;

      self.loadUserLoader.promise.then(function successCallback() {
        $rootScope.loading = false;
      });

      getUserByEmail(email).then(
        function successCallback(user) {
          self.loadUserLoader.resolve(user);
        },
        function errorCallback() {
          $log.error("User can't be loaded... logging out the user");

          $rootScope.loading = false;
          self.loadUserLoader.reject("LABEL_TEXT_OOPS");
        }
      );

      return self.loadUserLoader.promise;
    }

    /**
     * Check if the user is authenticated
     * @return {boolean}
     */
    function isAuthenticated() {
      return !!sessionService.user;
    }

    /**
     * Check if the user is authorized to access the next route.
     * This function can be also used on element level.
     * @example <p ng-if="isAuthorized(authorizedRoles)">show this only to admins</p>
     * @param authorizedRoles
     * @return {boolean}
     */
    function isAuthorized(authorizedRoles) {
      if (!angular.isArray(authorizedRoles)) {
        authorizedRoles = [authorizedRoles];
      }

      if (authorizedRoles.indexOf("guest") !== -1) {
        return true;
      }

      if (self.isAuthenticated()) {
        /**
         * @type {boolean}
         */
        var hasRole = false;

        authorizedRoles.forEach(function (value) {
          if (hasRole || sessionService.userRoles.indexOf(value) > -1) {
            hasRole = true;
          }
        });

        return hasRole;
      }

      return false;
    }

    /**
     * Log out
     * @todo broadcast the logoutSuccess event
     */
    function logout() {
      sessionService.destroy();
      localStorageService.clearAll();
      $state.go("login");

      $timeout(function () {
        $window.location.reload();
      }, 200);
    }

    /**
     * Clear the credentials so it does not automatically log in next time
     */
    function clearCredentials() {
      sessionService.destroy();
      localStorageService.clearAll();
    }

    /**
     * Log in automatically
     * @return {*}
     */
    function autoLogin() {
      var deferred = $q.defer();
      var credentials = localStorageService.get("credentials");

      if (credentials) {
        login(credentials.username, credentials.password).then(
          function () {
            deferred.resolve();
          },
          function () {
            deferred.resolve();
          }
        );
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    /**
     * Add new user
     * @param user
     * @return {*}
     */
    function newUser(user) {
      var deferred = $q.defer();

      if (user.password.indexOf("&") > -1) {
        deferred.reject("Please choose a password without an '&' character");
      } else {
        $http({
          method: "POST",
          url: appConfig.LEGACYAUTHAPIURL + "Account/Register",
          headers: {
            "Content-Type": "application/json"
          },
          data: user
        }).then(
          function successCallback(response) {
            deferred.resolve(response.data);
          },
          function errorCallback(reason) {
            /**
             * @type {string}
             */
            var error = "";

            if (!reason.data.modelState) {
              error = "Something went wrong with changing your password";
            } else {
              error = "";
              angular.forEach(reason.data.modelState, function (value) {
                error += value + " \n";
              });
            }

            deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    /**
     * Update user
     * @param user
     * @return {*}
     */
    function updateUser(user) {
      var deferred = $q.defer();

      $http({
        method: "POST",
        url: appConfig.LEGACYAUTHAPIURL + "Users/Update",
        headers: {
          "Content-Type": "application/json"
        },
        data: user
      }).then(
        function successCallback(response) {
          deferred.resolve(response.data);
        },
        function errorCallback(reason) {
          deferred.reject(reason);
          $log.error("Update user call failed... ", reason);
        }
      );

      return deferred.promise;
    }

    /**
     * Change password
     * @param details
     * @return {*}
     */
    function changePassword(details) {
      var deferred = $q.defer();

      $http({
        method: "POST",
        url: appConfig.LEGACYAUTHAPIURL + "Manage/ChangePassword",
        headers: {
          "Content-Type": "application/json"
        },
        data: details
      }).then(
        function successCallback(response) {
          deferred.resolve(response.data);
        },
        function errorCallback(reason) {
          deferred.reject(reason);
          $log.error("Change password call failed... ", reason);
        }
      );

      return deferred.promise;
    }

    /**
     * Handle forgot password
     * @param emailAddress
     * @return {*}
     */
    function forgotPassword(emailAddress) {
      var deferred = $q.defer();

      $http({
        method: "POST",
        url: appConfig.LEGACYAUTHAPIURL + "Account/ForgotPassword",
        headers: {
          "Content-Type": "application/json"
        },
        data: { Email: emailAddress }
      }).then(
        function successCallback(response) {
          deferred.resolve(response.data);
        },
        function errorCallback(reason) {
          deferred.reject(reason);
          $log.error("Forgot password call failed... ", reason);
        }
      );

      return deferred.promise;
    }

    /**
     * Reset password
     * @param details
     * @return {*}
     */
    function resetPassword(details) {
      var deferred = $q.defer();

      $http({
        method: "POST",
        url: appConfig.LEGACYAUTHAPIURL + "Account/ResetPassword",
        headers: {
          "Content-Type": "application/json"
        },
        data: details
      }).then(
        function successCallback(response) {
          deferred.resolve(response.data);
        },
        function errorCallback(reason) {
          deferred.reject(reason);
          $log.error("Reset password failed... ", reason);
        }
      );

      return deferred.promise;
    }

    /**
     * Get user by email
     * @param email
     * @return {Promise<any>}
     */
    function getUserByEmail(email) {
      var deferred = $q.defer();

      var legacy = $http({
        method: "GET",
        url: appConfig.LEGACYAUTHAPIURL + "Users/Find/EmailSimple/" + encodeURIComponent(email),
        headers: {
          "Content-Type": "application/json"
        }
      });

      var azure = $http({
        method: "GET",
        url: appConfig.accountService + "self/user-info",
        headers: {
          "Content-Type": "application/json"
        }
      });

      $q.all([legacy, azure]).then(
        function success(response) {
          var legacyResponse = response[0].data;
          var azureResponse = response[1].data;
          var azureValues = lodash.pick(azureResponse, ["farmAccess", "userGroups"]);

          deferred.resolve(lodash.assign({}, legacyResponse, azureValues));
        },
        function error(reason) {
          $log.error("Unable to retrieve the user through the API", reason);
          deferred.reject("LABEL_TEXT_OOPS");
        }
      );

      return deferred.promise;
    }

    /**
     * Verify email
     * @param userId
     * @param code
     * @return {*}
     */
    function verifyEmail(userId, code) {
      var request = $http({
        method: "GET",
        url: appConfig.LEGACYAUTHAPIURL + "Account/ConfirmEmail",
        params: {
          userId: userId,
          code: code
        },
        headers: {
          "Content-Type": "application/json"
        }
      });

      request.then(
        function () {
          $log.info(
            "Successfully verified the email with the following credentials, userId: " +
              userId +
              ", code: " +
              code
          );
        },
        function () {
          $log.error(
            "Unable to verify email with the following credentials, userId: " + userId + ", code: " + code
          );
        }
      );

      return request;
    }

    /**
     * Get user by id
     * @param id
     * @return {*}
     */
    function getUserByID(id) {
      var deferred = $q.defer();

      $http({
        method: "GET",
        url: appConfig.LEGACYAUTHAPIURL + "Users/Find/IDSimple/" + id,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(
        function success(response) {
          deferred.resolve(response.data);
        },
        function error(reason) {
          $log.error("Unable to retrieve the user through the API", reason);
          deferred.reject("LABEL_TEXT_OOPS");
        }
      );

      return deferred.promise;
    }

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("ctraAuthentication")
    .run(function ($rootScope, $state, authenticationService, AUTH_EVENTS) {
      /**
       * Before each state change, check if the user is logged in
       * and authorized to move onto the next state
       * @type {*|(function())|o|g}
       */
      var stateChangeStart = $rootScope.$on("$stateChangeStart", function (event, toState, toParams) {
        /**
         * @type {string[]}
         */
        var authorizedRoles = toState.data.authorizedRoles;

        if (!authenticationService.isAuthorized(authorizedRoles)) {
          event.preventDefault();

          if (authenticationService.isAuthenticated()) {
            // User is not allowed
            $rootScope.$broadcast(AUTH_EVENTS.notAuthorized, { toState: toState, toParams: toParams });
          } else {
            // User is not logged in
            $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated, { toState: toState, toParams: toParams });
          }
        }
      });

      $rootScope.$on("$destroy", stateChangeStart);
    });
})();

(function () {
  "use strict";

  angular.module("ctraAuthentication")
    .config(routerConfig);

  /**
   * @param $stateProvider
   * @param USER_ROLES
   * @ngInject
   */
  function routerConfig ($stateProvider, USER_ROLES) {
    $stateProvider
      .state("login", {
        url: "/login?redirect",
        templateUrl: "app/shared-components/angular-authentication/views/login/login.html",
        resolve: {
          /**
           * @param authenticationService
           * @return {*}
           */
          login: function (authenticationService) {
            return authenticationService.autoLogin();
          }
        },
        data: {
          authorizedRoles: [USER_ROLES.guest]
        }
      })
      .state("forgotPassword", {
        url: "/forgotPassword?emailAddress",
        templateUrl: "app/shared-components/angular-authentication/views/forgotPassword/forgotPassword.html",
        params: {
          emailAddress: null
        },
        data: {
          authorizedRoles: [USER_ROLES.guest]
        }
      })
      .state("resetPassword", {
        url: "/resetPassword?userEmail&code&userId",
        templateUrl: "app/shared-components/angular-authentication/views/resetPassword/resetPassword.html",
        params: {
          userEmail: null,
          code: null,
          userId: null
        },
        data: {
          authorizedRoles: [USER_ROLES.guest]
        }
      })
      .state("confirmEmail", {
        url: "/confirmEmail?userId&code",
        templateUrl: "app/shared-components/angular-authentication/views/confirmEmail/confirmEmail.html",
        params: {
          userId: null,
          code: null
        },
        data: {
          authorizedRoles: [USER_ROLES.guest]
        }
      })
      .state("register", {
        url: "/register",
        templateUrl: "app/shared-components/angular-authentication/views/register/register.html",
        data: {
          authorizedRoles: [USER_ROLES.guest]
        }
      })
      .state("account", {
        url: "/account",
        templateUrl: "app/shared-components/angular-authentication/views/account/account.html",
        data: {
          authorizedRoles: [USER_ROLES.admin, USER_ROLES.farmer, USER_ROLES.farmEmployee]
        },
        /**
         * @param $scope
         * @param sessionService
         */
        controller: function ($scope, sessionService) {
          var vm = $scope;

          vm.user = sessionService.user;
        },
        controllerAs: "vm"
      })
      .state("logout", {
        url: "/logout",
        /**
         * @param authenticationService
         */
        onEnter: function (authenticationService) {
          authenticationService.logout();
        },
        data: {
          authorizedRoles: [USER_ROLES.guest]
        }
      })
      .state("alert", {
        url: "/alert?message&level",
        templateUrl: "app/shared-components/angular-authentication/views/alert/alert.html",
        params: {
          message: "LABEL_TEXT_OOPS",
          level: "warning"
        },
        data: {
          authorizedRoles: [USER_ROLES.guest]
        },
        /**
         * @param $scope
         * @param $stateParams
         * @param sessionService
         */
        controller: function ($scope, $stateParams, sessionService) {
          var vm = $scope;

          vm.level = $stateParams.level;
          vm.message = $stateParams.message;
          vm.user = sessionService.user;
        },
        controllerAs: "vm"
      });
  }
})();

(function () {
  "use strict";

  angular.module("ctraAuthentication")
    .constant("USER_ROLES", {
      guest: "guest",
      internal: "Internal",
      admin: "Admin",
      farmer: "Farmer",
      farmEmployee: "FarmEmployee",
      betaUser: "BetaUser"
    })
    .constant("AUTH_EVENTS", {
      loginSuccess: "auth-login-success",
      loginFailed: "auth-login-failed",
      logoutSuccess: "auth-logout-success",
      sessionTimeout: "auth-session-timeout",
      notAuthenticated: "auth-not-authenticated",
      notAuthorized: "auth-not-authorized",
      notConfirmed: "auth-not-confirmed"
    });
})();

(function () {
  "use strict";

  angular.module("ctraAuthentication")
    .config(function ($httpProvider) {
      $httpProvider.interceptors.push([
        "$injector",
        function ($injector) {
          return $injector.get("authInterceptorService");
        }
      ]);
    });
})();

(function () {
  "use strict";

  /**
   * This interceptor will make sure that, after each $http request
   * if the user doesn't have access to something runs the according
   * event, given the response status codes from the server.
   */

  angular.module("ctraAuthentication")
    .factory("authInterceptorService", function ($rootScope, $q, $log, AUTH_EVENTS, sessionService) {
      return {
        /**
         * @param config
         * @return {*|Promise}
         */
        request: function (config) {
          var token = sessionService.token;

          if (token && !config.simple) {
            config.headers.Authorization = "Bearer " + token.access_token;
          }

          return config || $q.when(config);
        },
        /**
         * @param response
         * @return {Promise}
         */
        responseError: function (response) {
          $rootScope.$broadcast({
            401: AUTH_EVENTS.notAuthenticated,
            403: AUTH_EVENTS.notAuthorized,
            419: AUTH_EVENTS.sessionTimeout,
            440: AUTH_EVENTS.sessionTimeout
          }[response.status], response);

          return $q.reject(response);
        }
      };
    });
})();

(function() {
  'use strict';
  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  angular
    .module('dairyMonitorAdmin')
    .directive('pingLegend', pingLegend);

  /** @ngInject */
  function pingLegend() {
    return {
      restrict: 'E',
      replace: true,
      template: ''
        +'<div class="small">'
          +'<h6>Legend</h6>'
          +'<span><i class="fa fa-check-circle color-success"></i> last ping &lt; 5 minutes ago</span><br/>'
          +'<span><i class="fa fa-exclamation-triangle color-warning"></i> last ping &gt; 5 minutes ago</span><br/>'
          +'<span><i class="fa fa-exclamation-triangle color-danger"></i> last ping &gt; 1 hour ago</span><br/>'
          +'<span class="gray"> last ping &gt; 1 week ago</span>'
        +'</div>'
      +''
    };
  }
})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  angular
    .module('dairyMonitorAdmin')
    .directive('sensorList', sensorList);

  /** @ngInject */
  function sensorList() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/sensorList/sensorList.html',
      controller: ['$q', '$window', '$element', '$scope', '$timeout', '$log', 'sessionService', 'sysAdminService', '$translate', 'toastr', 'sensorBatchService', sensorListController],
      scope:{
        cows:            "=",
        sensors:         "=",
        baseStations:    "=",
        farm:            "=",
        selectable:      "=",
        selectedSensors: "=",
        details:         "="
      }
    };

    return directive;

    /** @ngInject */
    function sensorListController($q, $window, $element, $scope, $timeout, $log, sessionService, sysAdminService, $translate, toastr, sensorBatchService){
      var vm = $scope;

      vm.loading = true;
      vm.sensors.$promise.then(function () {
        vm.loading = false;
        vm.sortBy(vm.sensors, vm.sortDefault);
        vm.pageChanged();
      })

      vm.currentListItem = 0;
      vm.selectedSensors = vm.selectedSensors || [];

      vm.status = {};

      vm.sortVar        = 'NodeID';
      vm.sortDefault    = 'NodeID';
      vm.sortDescending = false;
      vm.currentPage    = 1;

      vm.sensorsBatchOptions = sensorBatchService.sensorsBatchOptions;
      vm.sensorsBatchFilters = {};
      vm.shortSerialNum = '';
      vm.longSerialNum = '';

      vm.updateFilter = function () {
        if(!vm.sensors) return false;

        vm.filteredSensors = vm.sensors.filter(function (e) {
          var _return = true;
          var searchString = vm.searchString || '';
          if(searchString) {
            _return = false;
            if(e.deviceSerialNum.toLowerCase().indexOf(searchString.toLowerCase()) >= 0)
              _return = true;
            if(e.shortSerialNum && e.shortSerialNum.toLowerCase().indexOf(searchString.toLowerCase()) >= 0)
              _return = true;
          }

          if(vm.longSerialNum) {
            _return = false;
            if(e.deviceSerialNum.toLowerCase().indexOf(vm.longSerialNum.toLowerCase()) >= 0)
              _return = true;
          }

          if(vm.shortSerialNum) {
            _return = false;
            if(e.shortSerialNum && e.shortSerialNum.toLowerCase().indexOf(vm.shortSerialNum.toLowerCase()) >= 0)
              _return = true;
          }

          if(vm.sensorsFilterBaseStationLinkedYes && _return){
            if(!e.baseStationID) _return = false;
          }

          if(vm.sensorsFilterBaseStationLinkedNo && _return){
            if(e.baseStationID) _return = false;
          }

          if(vm.sensorsBatchFilters && _return){
            var batchDetails = vm.getBatchDetails(e);
            angular.forEach(vm.sensorsBatchFilters, function (value, key) {
              if(value !== "0" && batchDetails[key] !== value){
                _return = false;
              }
            });
          }

          if(vm.sensorsFiltersBoxNumber && _return){
            if(!e.deviceName){
              _return = false
            }else if(e.deviceName !== vm.sensorsFiltersBoxNumber){
              _return = false
            }
          }
          return _return;
        });

      }

      vm.updateBatchProperties = function () {

        if(vm.showBatchOptions === true){
          vm.showBatchOptions = false;
          return false;
        }

        // Set default
        vm.batch = {
          pcb: "not set",
          frequency: "not set",
          casing: "not set",
          manuallySealed: "not set",
          charged: "not set",
          deployedEpoch: "not set"
        };
        vm.boxNumber = "not set"

        // Get selected sensors
        var sensors = vm.sensors.filter(function(e){
          return (vm.selectedSensors.indexOf(e.NodeID) > -1)
        });

        // find the commenalities and set vm.batch params
        sensors.forEach(function (e) {
          var sensorBatchProperties = vm.getBatchDetails(e);

          angular.forEach(vm.batch, function (v, key) {
            if(vm.batch[key] === "not set"){
              vm.batch[key] = sensorBatchProperties[key];
            }else if(v !== sensorBatchProperties[key]){
              vm.batch[key] = null;
            }
          });

          if(vm.boxNumber === "not set"){
            vm.boxNumber = e.deviceName;
          }else if(vm.boxNumber !== e.deviceName){
            vm.boxNumber = '';
          }
        });

        // show batch options
        vm.showBatchOptions = true;

      }

      vm.applyBatchUpdate = function () {

        vm.loading = true;
        var loaders = [];


        var sensors = vm.sensors.filter(function(e){
          return (vm.selectedSensors.indexOf(e.NodeID) > -1)
        });


        sensors.forEach(function (e) {
          var sensorBatchProperties = vm.getBatchDetails(e)

          angular.forEach(vm.batch, function (v, key) {
            if(v !== null){
              sensorBatchProperties[key] = v;
            }
          })

          e.deviceDescription = angular.toJson(sensorBatchProperties);

          if(vm.boxNumber !== ""){
            e.deviceName = vm.boxNumber;
          }
          loaders.push(e.$update());
        });

        $q.all(loaders).then(function () {
          vm.loading = false;
          vm.showBatchOptions = false;
          toastr.success($translate.instant('LABEL_TEXT_SAVED'));
        }, function errorCallback() {
          toastr.error($translate.instant('LABEL_TEXT_OOPS'));
          vm.loading = false;
        })

      }

      vm.pageChanged = function() {
        /* eslint-disable angular/angularelement */
        /* global $:false */
        $timeout(function () {
          $('[data-toggle="tooltip"]').tooltip();
          var lastChecked = null;

          var $chkboxes = $('.chkbox');
          $chkboxes.click(function(e) {
            if(!lastChecked) {
              lastChecked = this;
              return;
            }

            if(e.shiftKey) {
              var start = $chkboxes.index(this);
              var end = $chkboxes.index(lastChecked);

              $.each($chkboxes.slice(Math.min(start,end), Math.max(start,end)+ 1), function(){
                if($(this).prop('checked') !== lastChecked.checked){
                  $(this).click();
                }
              });

            }
            lastChecked = this;
          });
        }, 300);
      };

      vm.sortBy = function (data, variable) {

        if(vm.sortVar === variable && vm.sortDescending){
          vm.sortDescending = false;
          vm.sortVar = vm.sortDefault;
        }else if(vm.sortVar === variable){
          vm.sortDescending = true;
          vm.sortVar = variable;
        }else{
          vm.sortDescending = false;
          vm.sortVar = variable;
        }

        data.sort(function(a,b) {

          // First sort
          if (a[vm.sortVar] < b[vm.sortVar]){
            return (vm.sortDescending ? 1 : -1);
          }
          if (a[vm.sortVar] > b[vm.sortVar]){
            return (vm.sortDescending ? -1 : 1);
          }

          // Else go to the 2nd item
          if (a[vm.sortDefault] < b[vm.sortDefault]) {
            return -1;
          } else if (a[vm.sortDefault] > b[vm.sortDefault]) {
            return 1
          } else { // nothing to split them
            return 0;
          }
        });

        vm.pageChanged();
        vm.updateFilter();
      };

      vm.$watch('currentListItem', function() {
        vm.status.saving = false;
        vm.status.saved  = false;
        vm.status.failed = false;
      });

      vm.minutesSince= function(past){
        var diff = Math.abs(new Date() - new Date(past));
        var minutes = Math.floor((diff/1000)/60);
        return minutes;
      };

      vm.save = function (odataObj) {
        vm.status.saving = true;
        vm.status.saved = false;
        vm.status.failed = false;

        odataObj.$update().then(function(){
          vm.status.saving = false;
          vm.status.saved  = true;
        }, function(){
          vm.status.saving = false;
          vm.status.failed = true;
        });
      };

      var changeDairyMonitorToCow = function (dairyCowID, nodeID){
        vm.status.saving = true;
        vm.status.saved = false;
        vm.status.failed = false;

        sysAdminService.changeDairyMonitorToCow(dairyCowID, nodeID).then(function(){
          vm.status.saving = false;
          vm.status.saved  = true;
        }, function(){
          vm.status.saving = false;
          vm.status.failed = true;
        });
      }

      vm.linkCowToSensor = function(cow, sensor){
        if(cow){
          angular.forEach(vm.cows, function(value) {
            if(value.nodeID === sensor.NodeID){
              value.nodeID=0;
            }
          });

          cow.nodeID = sensor.NodeID;

          changeDairyMonitorToCow(cow.DairyCowID, sensor.NodeID);

        }else{
          // Unlink the sensor from the cow that is was attached to
          angular.forEach(vm.cows, function(value) {
            if(value.nodeID === sensor.NodeID){
              value.nodeID=0;
              changeDairyMonitorToCow(value.DairyCowID, 0);
            }
          });
        }
      }

      vm.rowClicked = function(NodeID){
        if(vm.selectable){
          vm.toggleSelection(NodeID, vm.selectedSensors);
        }else{
          vm.toggleDetails(NodeID);
        }
      }

      vm.toggleSelection = function(id, array) {
         var idx = array.indexOf(id);

         // is currently selected
         if (idx > -1) {
           array.splice(idx, 1);
         }else {
           array.push(id);
         }
      };

      vm.toggleDetails = function (NodeID) {
        vm.currentListItem = (vm.currentListItem === NodeID ? vm.currentListItem = null : vm.currentListItem = NodeID);
      }

      vm.getBatchDetails = function (sensor) {

        // First check if it's even JSON
        if(!sensor.deviceDescription || sensor.deviceDescription[0] !== "{") return {};

        return angular.fromJson(sensor.deviceDescription) || {};
      }

      vm.deleteSensor = function (sensor) {
        var really = $window.confirm("Are you sure you want to delete this sensors?\nThis action cannot be undone!");
        if(really){
          vm.sensors.forEach(function(e, i){
            if(e.NodeID === sensor.NodeID){
              e.$delete();
              vm.sensors.splice(i, 1);
            }
          });
        }
      }

      vm.disableSensor = function (sensor) {
        var really = $window.confirm("Are you sure you want to disable this sensors?\nThis sensor will be unlinked from the cow and stop recording data");
        if(really){
          sensor.dairyCowID = "";
          vm.save(sensor);
        }
      }

      vm.returnSensor = function (sensor) {
        var really = $window.confirm("Please contact Connecterra to return and replace sensors\nWould you like to disable this sensor already?");
        if(really){
          sensor.dairyCowID = "";
          vm.save(sensor);
        }
      }

      vm.selectAll = function(source, dest, key){
        source.forEach(function (obj) {
          if(dest.indexOf(obj[key]) < 0){
            dest.push(obj[key]);
          }
        });
      };

      vm.toggleAll = function(source, dest, key){
        if(source.length === dest.length){
          dest.splice(0, dest.length);
        }else{
          vm.selectAll(source, dest, key);
        }
      };

      vm.unlinkSelectedSensors = function(){
        vm.selectedSensors.forEach(function (id) {
          vm.cows.forEach(function(cow){
            if(cow.nodeID === id){
              cow.nodeID = 0;
              changeDairyMonitorToCow(cow.DairyCowID, 0);
            }
          });
        });
      };

      vm.moveSelectedSensorsToBaseStation = function (baseStation) {
        vm.loading = true;
        var loaders = [];

        vm.selectedSensors.forEach(function (id) {
          var sensor = vm.sensors.find(function(e){
            return e.NodeID === id;
          });
          sensor.baseStationID = (baseStation ? baseStation.BaseStationID : null);
          loaders.push(sensor.$update());
        });

        $q.all(loaders).then(function () {
          vm.loading = false;
          toastr.success($translate.instant('LABEL_TEXT_SAVED'));
        }, function () {
          toastr.error($translate.instant('LABEL_TEXT_OOPS'));
        })
      }

      vm.deleteSelectedSensors = function(){
        var really = $window.confirm("Are you sure you want to delete "+vm.selectedSensors.length+" sensors?\nThis action cannot be undone!");
        if(really){
          vm.selectedSensors.forEach(function (id) {
            vm.sensors.forEach(function(e, i){
              if(e.NodeID === id){
                e.$delete();
                vm.sensors.splice(i, 1);
              }
            });
          });
          vm.selectedSensors = [];
        }
      };


    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.systemMonitorChart', [
      'rt.debounce',
      'ctraDataVisualisations.dataVisualisation.graph'
    ]);

}());

(function () {
  'use strict';

  angular
    .module('dairyMonitorAdmin.systemMonitorChart')
    .component('systemMonitorChart', {
      bindings: {
        displayValues:    '<',
        subjectId:        '<',
        startDate:        '<',
        endDate:          '<',
        onDateChange:     '&'
      },
      controller: systemMonitorChartCtrl,
      templateUrl: 'app/components/system-monitor-chart/system-monitor-chart.html'
    });

    function systemMonitorChartCtrl($window, $q, systemMonitorService, debounce) {
      var $ctrl = this;

      $ctrl.$onInit             = onInit;
      $ctrl.$onChanges          = onChanges;

      $ctrl.onChartDomainChange = onChartDomainChange;

      var loadDataDebounced = debounce(200, getData);
      var dataLoader = null;

      function onInit() {
        updateChartDomain();
      }

      function onChanges(change) {
        if( change.hasOwnProperty('displayValues') ||
            change.hasOwnProperty('subjectId') ||
            change.hasOwnProperty('startDate') ||
            change.hasOwnProperty('endDate') ) {
          loadDataDebounced();
        }

        if(change.hasOwnProperty('startDate') ||
           change.hasOwnProperty('endDate')){
          updateChartDomain();
        }
      }

      function updateChartDomain(){
        $ctrl.chartDomain = [$ctrl.startDate.getTime(), $ctrl.endDate.getTime()];
      }

      function onChartDomainChange(domain) {
        if($ctrl.onDateChange){
          $ctrl.onDateChange({startDate: domain[0], endDate: domain[1]})
        }else{
          $ctrl.startDate = domain[0];
          $ctrl.endDate   = domain[1];
          loadDataDebounced();
        }
      }

      function getData(){
        $ctrl.error = '';
        $ctrl.info = '';
        $ctrl.showChart = true;

        if(!$ctrl.startDate){ $ctrl.showChart = false; return $ctrl.error = "No start date selected";}
        if(!$ctrl.endDate){ $ctrl.showChart = false; return $ctrl.error = "No start date selected";}
        if(!$ctrl.subjectId){ $ctrl.showChart = false; return $ctrl.info = "Please select a subject";}
        if(!$ctrl.displayValues.length){ $ctrl.info = "Please select display variables";}


        if(dataLoader){
          // Cancel current
          dataLoader.reject();
        }

        $ctrl.showChart = true;
        $ctrl.loading = true;

        var dataBleed = daysBetween($ctrl.startDate, $ctrl.endDate);
        var queryStartDate = new Date($ctrl.startDate.getTime());
        queryStartDate.setHours(0,0,0,0);
        queryStartDate.setDate(queryStartDate.getDate()-dataBleed);

        var queryEndDate = new Date($ctrl.endDate.getTime());
        queryEndDate.setHours(23,59,59,99);
        queryEndDate.setDate(queryEndDate.getDate()+dataBleed);


        var displayValues = getDisplayValues();

        var dataQueriesAdded = [];
        var dataQueries = [];


        angular.forEach($ctrl.displayValues, function (dataPoint) {
          if(dataQueriesAdded.indexOf(dataPoint) < 0){
            // Get the data from source
            dataQueriesAdded.push(dataPoint);
            dataQueries.push(systemMonitorService.getMonitorHistory(dataPoint.id, queryStartDate, queryEndDate));
          }
        });

        dataLoader = $q.defer();
        $q.all(dataQueries).then(function (results) {
          dataLoader.resolve(results);
        });

        dataLoader.promise.then(function successCallback(results) {
          var allData = {};

          angular.forEach(results, function (result, i) {
            var data = systemMonitorService.processDataForChart(result, dataQueriesAdded[i].type);
            angular.merge(allData, data);
          });

          angular.forEach(displayValues, function (dataType) {
            dataType.data = allData[dataType.id] || [];
          });

          $ctrl.displayData = displayValues;
          $ctrl.loading = false;

        }, function errorCallback(){
          $ctrl.loading = false;
        });


        return false;
      }

      function daysBetween(date1, date2) {
        // The number of milliseconds in one day
        var ONE_DAY = 1000 * 60 * 60 * 24

        // Calculate the difference in milliseconds
        var difference_ms = Math.abs(date1.getTime() - date2.getTime())

        // Convert back to days and return
        return Math.floor(difference_ms/ONE_DAY)

      }

      function getDisplayValues(){
        return $ctrl.displayValues.reduce(function (prev, value) {
          //return prev.concat(value);
          return prev.concat(angular.copy(value));
        }, []);
      }

    }

}());

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services
  /* global $:false */
  /* eslint-disable angular/angularelement */

  angular
    .module('dairyMonitorAdmin')
    .directive('mainNav', mainNav);

  /** @ngInject */
  function mainNav() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/mainNav/mainNav.html',
      scope: {
      },
      controller: MainNavController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function MainNavController($scope, sessionService, $element) {
      var vm = $scope;

      vm.user = sessionService.user

      $($element).find('a').not('.navbar-brand, .dropdown-toggle').on('click', function(){
        $('.navbar-toggle:visible').click() //bootstrap 3.x by Richard
      });

    }
  }

})();

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin").service("localeService", localeService);

  /**
   * @param $document
   * @param $translate
   * @param LOCALES
   * @param $rootScope
   * @param $log
   * @param amMoment
   * @param lodash
   * @ngInject
   * @return {{getLocaleDisplayName: (function(): *),
   * setLocaleByDisplayName: setLocaleByDisplayName, getLocalesDisplayNames: (function(): Array)}}
   */
  function localeService($document, $translate, LOCALES, $rootScope, $log, amMoment, lodash) {
    var localesObj = LOCALES.locales;

    /**
     * @type {string[]}
     * @private
     */
    var _LOCALES = Object.keys(localesObj);

    if (!_LOCALES || _LOCALES.length === 0) {
      $log.error("There are no _LOCALES provided");
    }

    /**
     * @type {Array}
     * @private
     */
    var _LOCALES_DISPLAY_NAMES = [];

    _LOCALES.forEach(function (locale) {
      _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
    });

    /**
     * @type {string|l}
     */
    var currentLocale = $translate.proposedLanguage(); // async loading

    /**
     * Check if locale is valid
     * @param locale
     * @return {boolean}
     */
    var checkLocaleIsValid = function (locale) {
      return _LOCALES.indexOf(locale) !== -1;
    };

    /**
     * Set locale
     * @param locale
     */
    var setLocale = function (locale) {
      if (checkLocaleIsValid(locale)) {
        /**
         * Update current locale
         */
        currentLocale = locale;

        /**
         * Ask angular-translate to load and apply proper translations.
         */
        return $translate.use(locale);
      }

      $log.error('Locale name "' + locale + '" is invalid');
    };

    /**
     * On successfully applying translations by angular-translate
     * @type {*|(function())|o|g}
     */
    var translateChangeSuccess = $rootScope.$on("$translateChangeSuccess", function (event, data) {
      $document[0].documentElement.setAttribute("lang", data.language); // sets "lang" attribute to html
      amMoment.changeLocale(data.language.toLowerCase().replace(/_/g, "-"));
    });

    $rootScope.$on("$destroy", translateChangeSuccess);

    return {
      /**
       * @return {string}
       */
      getLocaleFromDisplayName: function (displayName) {
        return lodash.find(Object.keys(localesObj), function (key) {
          return localesObj[key] === displayName;
        });
      },

      /**
       * @return {string}
       */
      getCurrentLocale: function () {
        return lodash.find(Object.keys(localesObj), function (key) {
          return localesObj[key] === localesObj[currentLocale];
        });
      },

      /**
       * @return {*}
       */
      getLocaleDisplayName: function () {
        return localesObj[currentLocale];
      },

      /**
       * @return {string}
       */
      getLocaleAbbreviatedName: function () {
        return currentLocale;
      },

      /**
       * @param localeDisplayName
       */
      setLocaleByDisplayName: function (localeDisplayName) {
        return setLocale(
          _LOCALES[
            _LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName) // get locale index
            ]
        );
      },

      /**
       * @return {Array}
       */
      getLocalesDisplayNames: function () {
        return _LOCALES_DISPLAY_NAMES;
      }
    };
  }
})();

(function() {
  'use strict';
  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  angular
    .module('dairyMonitorAdmin')
    .directive('languageSelect', languageSelect);

  /** @ngInject */
  function languageSelect(localeService) {
    return {
      restrict: 'A',
      replace: true,
      template: ''+
      '<div class="language-select" ng-if="visible">'+
        '<select ng-model="currentLocaleDisplayName"'+
          'ng-options="localesDisplayName for localesDisplayName in localesDisplayNames"'+
          'ng-change="changeLanguage(currentLocaleDisplayName)">'+
        '</select>'+
      '</div>'+
      '',
      controller: function ($scope) {
        $scope.currentLocaleDisplayName = localeService.getLocaleDisplayName();
        $scope.localesDisplayNames = localeService.getLocalesDisplayNames();
        $scope.visible = $scope.localesDisplayNames &&
        $scope.localesDisplayNames.length > 1;

        $scope.changeLanguage = function (locale) {
          localeService.setLocaleByDisplayName(locale);
        };
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dairyMonitorAdmin")
    .directive("baseStationList", baseStationList);

  /** @ngInject */
  function baseStationList () {
    var directive = {
      restrict: "E",
      templateUrl: "app/components/baseStationList/baseStationList.html",
      scope: {
        farms: "=",
        baseStations: "=",
        sensors: "=",
        selectable: "=",
        selectedSensors: "=",
        details: "=",
        showFilters: "="
      },
      controller: baseStationListController
    };

    return directive;

    /**
     * @param $window
     * @param $scope
     * @ngInject
     */
    function baseStationListController ($window, $scope, $q) {
      var vm = $scope;

      /**
       * @type {boolean}
       */
      vm.loading = true;

      if(vm.showFilters){
        vm.hideRobotFarms = true;
      }


      // If we have have an async call for Farms and Basestations,
      // wait for both to complete so we can sort by farm name
      // otherwise only wait for the BaseStation call to complete
      if(vm.farms && vm.farms.$promise && vm.baseStations.$promise){
        $q.all([vm.farms.$promise, vm.baseStations.$promise]).then(function () {
          vm.loading = false;
          vm.sortBaseStations();
          vm.filterBaseStations();
        })
      }else{
        vm.baseStations.$promise.then(function () {
          vm.loading = false;
          vm.sortBaseStations();
          vm.filterBaseStations();
        })
      }

      vm.sortBaseStations = function(){
        vm.baseStations.sort(function (a, b) {
          var farmA = vm.farms.find(function (e) {
            return e.FarmID === a.farmID;
          })
          var farmB = vm.farms.find(function (e) {
            return e.FarmID === b.farmID;
          })

          if (farmA.farmName < farmB.farmName) {
            return -1;
          }
          if (farmA.farmName > farmB.farmName) {
            return 1;
          }

          // names must be equal
          return 0;

        });
      }

      vm.filterBaseStations = function(){
        if(vm.hideRobotFarms){
          vm.filteredBaseStations = vm.baseStations.filter(function (e) {
            return e.farmID !== 1;
          })
        }else{
          vm.filteredBaseStations = vm.baseStations;
        }
      }


      /**
       * @type {Array}
       */
      vm.expandedBaseStations = [];

      /**
       * @type {{
       *   details: {sectionID: string, title: string},
       *   config: {sectionID: string, title: string},
       *   sensors: {sectionID: string, title: string}
       * }}
       */
      var sections = {
        details: {
          sectionID: "baseStationDetails",
          title: "Details"
        },
        config: {
          sectionID: "baseStationConfigDetails",
          title: "Config"
        },
        sensors: {
          sectionID: "baseStationSensors",
          title: "Sensors"
        },
        credentials: {
          sectionID: "baseStationCredentials",
          title: "Credentials"
        },
        commands: {
          sectionID: "baseStationCommands",
          title: "Commands"
        }
      };

      /**
       * @type {Array}
       */
      vm.sectionNavItems = [
        [vm.details.showBaseStationDetails, sections.details],
        [vm.details.showBaseStationConfigDetails, sections.config],
        [vm.details.showBaseStationSensors, sections.sensors],
        [vm.details.showBaseStationCredentials, sections.credentials],
        [vm.details.showBaseStationCommands, sections.commands]
      ].map(function (pair) {
        var condition = pair[0];
        var config = pair[1];

        return condition ? config : null;
      }).filter(function (config) {
        return !!config;
      });

      /**
       * @type {string}
       */
      vm.currentSection = sections.details.sectionID;

      /**
       * Minutes passed since the given time.
       * @param past
       * @return {number}
       */
      vm.minutesSince = function (past) {
        var diff = Math.abs(new Date() - new Date(past));
        var minutes = Math.floor((diff / 1000) / 60);

        return minutes;
      };

      /**
       * Get base station status
       * @param baseStation
       * @return {String}
       */
      vm.getBaseStationStatus = function (baseStation) {
        var status = "";

        var MINUTE = 1;
        var HOUR = 60 * MINUTE;
        var DAY = 24 * HOUR;

        if (baseStation) {
          var sinceLastPingTime = vm.minutesSince(baseStation.deviceBSLastPingTime + " GMT");

          if (sinceLastPingTime >= DAY && sinceLastPingTime < HOUR * 180) {
            status = "item-danger";
          } else if (sinceLastPingTime >= 5 && sinceLastPingTime < DAY) {
            status = "item-warning";
          } else if (sinceLastPingTime < 5) {
            status = "item-success";
          }
        }

        return status;
      };

      /**
       * @param source
       * @param dest
       * @param key
       */
      vm.selectAll = function (source, dest, key) {
        source.forEach(function (obj) {
          if (dest.indexOf(obj[key]) < 0) {
            dest.push(obj[key]);
          }
        });
      };

      /**
       * Unlink selected sensors
       */
      vm.unlinkSelectedSensors = function () {
        vm.selectedSensors.forEach(function (id) {
          vm.sensors.forEach(function (e) {
            if (e.NodeID === id) {
              e.dairyCowID = 0;
              e.$update();
            }
          });
        });
      };

      /**
       * Delete selected sensors
       */
      vm.deleteSelectedSensors = function () {
        /**
         * @type {string}
         */
        var question = [
          "Are you sure you want to delete",
          vm.selectedSensors.length,
          "sensors?\nThis action cannot be undone!"].join("");

        /**
         * @type {boolean}
         */
        var confirmed = $window.confirm(question);

        if (confirmed) {
          vm.selectedSensors.forEach(function (id) {
            vm.sensors.forEach(function (sensor, idx) {
              if (sensor.NodeID === id) {
                sensor.$delete();

                vm.sensors.splice(idx, 1);
              }
            });
          });

          vm.selectedSensors = [];
        }
      };

      /**
       * Toggle selection or base station details
       * @param id
       * @param array
       */
      vm.toggleSelection = vm.toggleDetails = function (id, array) {
        var idx = array.indexOf(id);

        // is currently selected
        if (idx > -1) {
          array.splice(idx, 1);
        } else {
          array.push(id);
        }
      };

      /**
       * Handle click on a row
       * @param BaseStationID
       */
      vm.rowClicked = function (BaseStationID) {
        vm.toggleDetails(BaseStationID, vm.expandedBaseStations);
      };
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .directive('herdGroupList', herdGroupList);

  /** @ngInject */
  function herdGroupList() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/herdGroupList/herdGroupList.html',
      scope: {
        farms:        "=",
        herdGroups:   "=",
        cows:         "=",
        sensors:      "=",
        selectedCows: "=",
        details:      "="
      },
      controller: herdGroupListController
    };

    return directive;

    /** @ngInject */
    function herdGroupListController($scope) {
      var vm = $scope;

      vm.loading = true;
      vm.herdGroups.$promise.then(function () { vm.loading = false; })

      vm.expandedHerdGroups = [];

      vm.sectionNavItems = [];

      if(vm.details.showHerdGroupDetails) vm.sectionNavItems.push({ sectionID: 'herdGroupDetails',       title: 'Details' });
      if(vm.details.showHerdGroupCows)    vm.sectionNavItems.push({ sectionID: 'herdGroupCows',       title: 'Cows' });

      vm.currentSection = vm.sectionNavItems[0].sectionID;

      // vm.refreshData = function() {
      //   if(vm.farmId){
      //     vm.herdGroups = sysAdminService.getHerdGroups(vm.farmId);
      //   }else{
      //     vm.herdGroups = sysAdminService.getHerdGroups();
      //   }
      //
      //   vm.herdGroups.$promise.then(function successCallback() {
      //     vm.cows = sysAdminService.getCows(vm.herdGroups)
      //   })
      // };
      //
      //
      // vm.loadData = function () {
      //   if(vm.farmId){
      //     vm.farm     = sysAdminService.getFarm(vm.farmId);
      //     vm.farm.then(function successCallback() {
      //       vm.farms = [vm.farm];
      //     })
      //   }else{
      //     vm.farms     = sysAdminService.getFarms();
      //   }
      //   vm.refreshData();
      // };
      //
      // vm.loadData();
      //

      vm.rowClicked = function(HerdGroupID){
        vm.toggleDetails(HerdGroupID, vm.expandedHerdGroups);
      }

      vm.toggleDetails = function(id, array) {
         var idx = array.indexOf(id);

         // is currently selected
         if (idx > -1) {
           array.splice(idx, 1);
         }else {
           array.push(id);
         }
      };


      // vm.deleteSelectedCows = function(){
      //   var really = $window.confirm("Are you sure you want to delete "+vm.selectedCows.length+" cows?\nThis action cannot be undone!");
      //   if(really){
      //     vm.selectedCows.forEach(function (cowID) {
      //       vm.cows.forEach(function(e,i){
      //         if(e.DairyCowID === cowID){
      //           cowService.deleteCow(e);
      //           vm.cows.splice(i, 1);
      //         }
      //       });
      //     });
      //     vm.selectedCows = [];
      //   }
      // };
      //
      // vm.watchSelectedCows = function(){
      //   vm.selectedCows.forEach(function (cowID) {
      //     vm.cows.forEach(function(e){
      //       if(e.DairyCowID === cowID){
      //         e.watchEnabled = true;
      //         e.$update();
      //       }
      //     });
      //   });
      // };
      //
      // vm.unwatchSelectedCows = function(){
      //   vm.selectedCows.forEach(function (cowID) {
      //     vm.cows.forEach(function(e){
      //       if(e.DairyCowID === cowID){
      //         e.watchEnabled = false;
      //         e.$update();
      //       }
      //     });
      //   });
      // };
      //
      // vm.selectAll = function(source, dest, key){
      //   source.forEach(function (obj) {
      //     if(dest.indexOf(obj[key]) < 0){
      //       dest.push(obj[key]);
      //     }
      //   });
      // };
      //
      //
      // vm.unlinkSelectedCows = function(){
      //   vm.selectedCows.forEach(function (id) {
      //     vm.cows.forEach(function(e){
      //       if(e.NodeID === id){
      //         e.dairyCowID = 0;
      //         e.$update();
      //       }
      //     });
      //   });
      // };
      //
      //
      // vm.deleteSelectedCows = function(){
      //   var really = $window.confirm("Are you sure you want to delete "+vm.selectedCows.length+" cows?\nThis action cannot be undone!");
      //   if(really){
      //     vm.selectedCows.forEach(function (id) {
      //       vm.cows.forEach(function(e, i){
      //         if(e.NodeID === id){
      //           e.$delete();
      //           vm.cows.splice(i, 1);
      //         }
      //       });
      //     });
      //     vm.selectedCows = [];
      //   }
      // };


      // vm.toggleSelection = function(id, array) {
      //   var idx = array.indexOf(id);
      //
      //   // is currently selected
      //   if (idx > -1) {
      //     array.splice(idx, 1);
      //   }else {
      //     array.push(id);
      //   }
      // };
    }
  }

})();

(function() {
  'use strict';

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  angular
    .module('dairyMonitorAdmin')
    .directive('cowList', cowList);

  /** @ngInject */
  function cowList() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cowList/cowList.html',
      controller: cowListController,
      scope:{
        cows:         "=",
        herdGroups:   "=",
        farms:        "=",
        sensors:      "=",
        selectable:   "=",
        selectedCows: "=",
        details:      "=",
        status:       "="
      }
    };

    return directive;

    /** @ngInject */
    function cowListController($window, $scope, $log, $state, sessionService, sysAdminService){
      var vm = $scope;

      vm.loading = true;
      vm.cows.$promise.then(function () {
        vm.loading = false;
        vm.sortBy(vm.cows, vm.sortDefault);
      })

      vm.currentListItem = 0;
      vm.selectedCows = vm.selectedCows || [];

      vm.status = {};

      vm.sortVar        = '';
      vm.sortDefault    = 'DairyCowID';
      vm.sortDescending = false;

      vm.sortBy = function (data, variable) {

        if(vm.sortVar === variable && vm.sortDescending){
          vm.sortDescending = false;
          vm.sortVar = vm.sortDefault;
        }else if(vm.sortVar === variable){
          vm.sortDescending = true;
          vm.sortVar = variable;
        }else{
          vm.sortDescending = false;
          vm.sortVar = variable;
        }

        data.sort(function(a,b) {

          // First sort
          if (a[vm.sortVar] < b[vm.sortVar]){
            return (vm.sortDescending ? 1 : -1);
          }
          if (a[vm.sortVar] > b[vm.sortVar]){
            return (vm.sortDescending ? -1 : 1);
          }

          // Else go to the 2nd item
          if (a[vm.sortDefault] < b[vm.sortDefault]) {
            return -1;
          } else if (a[vm.sortDefault] > b[vm.sortDefault]) {
            return 1
          } else { // nothing to split them
            return 0;
          }
        });

      };

      vm.$watch('currentListItem', function() {
        vm.status.saving = false;
        vm.status.saved  = false;
        vm.status.failed = false;
      });

      vm.minutesSince= function(past){
        var diff = Math.abs(new Date() - new Date(past));
        var minutes = Math.floor((diff/1000)/60);
        return minutes;
      };

      vm.save = function (odataObj) {
        vm.status.saving = true;
        vm.status.saved  = false;
        vm.status.failed = false;


        odataObj.$update().then(function(){
          vm.status.saving = false;
          vm.status.saved  = true;
        }, function(){
          vm.status.saving = false;
          vm.status.failed = true;
        });
      };


      var changeDairyMonitorToCow = function (dairyCowID, nodeID){
        vm.status.saving = true;
        vm.status.saved = false;
        vm.status.failed = false;

        sysAdminService.changeDairyMonitorToCow(dairyCowID, nodeID).then(function(){
          vm.status.saving = false;
          vm.status.saved  = true;
        }, function(){
          vm.status.saving = false;
          vm.status.failed = true;
        });
      }

      vm.linkCowToSensor = function(cow, sensor){
        if(sensor){
          angular.forEach(vm.cows, function(value) {
            if(value.nodeID === sensor.NodeID){
              value.nodeID=0;
            }
          });

          cow.nodeID = sensor.NodeID;

          changeDairyMonitorToCow(cow.DairyCowID, sensor.NodeID);

        }else{
          // Unlink the sensor from the cow that is was attached to
          // angular.forEach(vm.cows, function(value) {
          //   if(value.nodeID === sensor.NodeID){
          //     value.nodeID=0;
          //     changeDairyMonitorToCow(value.DairyCowID, 0);
          //   }
          // });
          cow.nodeID=0;
          changeDairyMonitorToCow(cow.DairyCowID, 0);
        }
      }

      vm.rowClicked = function(dairyCowID){
        if(vm.selectable){
          vm.toggleSelection(dairyCowID, vm.selectedCows);
        }else{
          vm.toggleDetails(dairyCowID);
        }
      }

      vm.toggleSelection = function(id, array) {
         var idx = array.indexOf(id);

         // is currently selected
         if (idx > -1) {
           array.splice(idx, 1);
         }else {
           array.push(id);
         }
      };

      vm.toggleAll = function(source, dest, key){
        if(dest.length === source.length){// Deselect All
          dest.splice(0, dest.length);
        }else {// Deselect All
          source.forEach(function (obj) {
            if(dest.indexOf(obj[key]) < 0){
              dest.push(obj[key]);
            }
          });
        }
      };


      vm.toggleDetails = function (id) {
        vm.currentListItem = (vm.currentListItem === id ? vm.currentListItem = null : vm.currentListItem = id);
      }

      vm.deleteCows = function(cows){
        var really = $window.confirm("Are you sure you want to delete "+cows.length+" cows?\nThis action cannot be undone!");
        if(really){
          cows.forEach(function (cowID) {
            vm.cows.forEach(function(e,i){
              if(e.DairyCowID === cowID){
                vm.cows.splice(i, 1);
                e.$delete();
              }
            });
          });
          cows = [];
        }
      };

      vm.watchCows = function(cows){
        cows.forEach(function (cowID) {
          vm.cows.forEach(function(e){
            if(e.DairyCowID === cowID){
              e.watchEnabled = true;
              e.$update();
            }
          });
        });
      };

      vm.unwatchCows = function(cows){
        cows.forEach(function (cowID) {
          vm.cows.forEach(function(e){
            if(e.DairyCowID === cowID){
              e.watchEnabled = false;
              e.$update();
            }
          });
        });
      };


      vm.delete = function (odataObj) {
        var sure = $window.confirm("Are you sure you want to delete this?\nThis action cannot be undone!");
        if(sure){
          var really = $window.confirm("PLEASE DOUBLE CHECK!\nYou are deleting the following:\n"+angular.toJson(odataObj));
          if(really){
            odataObj.$delete().then(function () {
              $state.go($state.current, {}, {reload: true});
            }, function () {
              $window.alert('Something went wrong, please try again later');
            });
          }
        }
      }

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .service('sensorBatchService', sensorBatch);


  /** @ngInject */
  function sensorBatch() {
    this.sensorsBatchOptions = {
      pcb: [
        '-',
        '1 (GEN 1)',
        '2.1 (869Mhz)',
        '2.1 glued (869Mhz)',
        '2.2 (869Mhz)',
        '2.3 (915Mhz)',
        '2.5 (869MHz)',
        '2.5 (916MHz)',
        '3.0 (869Mhz)',
        '3.0 (916MHz)',
        '3.1 (869Mhz)',
        '3.1 (916MHz)',
        '3.2 (869Mhz)',
        '3.2 (916MHz)'
      ],
      frequency: [
        '-',
        'EU (434Mhz)',
        'EU (869Mhz)',
        'US (915Mhz)'
      ],
      casing: [
        '-',
        'Gen 1',
        'Gen 2 - 3D Printed',
        'Gen 2 - Red',
        'Gen 2 - Orange',
        'Gen 2 - Orange, no holes',
        'Gen 3 - Snappable'
      ],
      manuallySealed: [
        '-',
        'no',
        'yes'
      ],
      charged: [
        '-',
        'no',
        'yes'
      ],
      deployedEpoch: null
    };

    return this;
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .service('farmService', farmService);

  // TODO: $inject
  // TODO: apply johnpapa guidelines: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#services

  /** @ngInject */
  function farmService($odataresource, appConfig) {

    // TODO: put all farm calls in here from sysAdminService
    var self = this;
    self.getFarm = function (farmID) {
      farmID = parseInt(farmID);

      var Farm = $odataresource(appConfig.APIURL+'odata/Farms', {}, {}, {odatakey : 'FarmID'});
      var farm = Farm.odata()
        .filter("FarmID",farmID)
        .single();

      return farm;
    };

    return this;
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .service('cowService', cowService);


  /** @ngInject */
  function cowService($window, $q, $odataresource, $state, $log, appConfig) {
    var self = this;

    var Cow = $odataresource(appConfig.APIURL+'odata/DairyCows', {}, {}, {odatakey : 'DairyCowID'});


    self.getCow = function (cowID) {
      var cow = Cow.odata()
        .filter("DairyCowID",parseInt(cowID))
        .single();

      $log.info('Fetching DairyCow from the database', cow);
      return cow.$promise;
    };

    self.getCows = function (farmID) {

      if(farmID){
        $log.info('Fetching DairyCows for FarmID'+farmID+' from the database');
        return Cow.odata().filter("farmID",parseInt(farmID)).query();

      }else{
        $log.info('Fetching DairyCows from the database')
        self.cows = Cow.odata()
          .query();

        return self.cows;
      }



    };

    self.getCowsByIDs = function (cowIDs, farmID) {
      var deferred = $q.defer();


      self.getCows(farmID).$promise.then(function successCallback(cows) {
        var resultCows = cows.filter(function (e) {
          return cowIDs.indexOf(e.DairyCowID) > -1;
        });
        deferred.resolve(resultCows);
      }, function errorCallback(error){

        deferred.reject(error);

      });


      return deferred.promise;

    };



    self.newCow = function (cowDetails) {
      var cow = new Cow();

      angular.forEach(cowDetails, function(value, key){
        this[key] = value;
      }, cow);

      self.cows.push(cow);

      return cow;
    };


    self.deleteCow = function (cow, confirmed) {

      confirmed = (confirmed ? true : $window.confirm("Are you sure you want to delete "+cow.cowName+"?\nThis action cannot be undone!"));

      if(confirmed){

        // Delete the cow from the database
        cow.$delete();

        // Remove the cow from the global Cows array
        self.cows.forEach(function(e,i){
          if(e.DairyCowID === cow.DairyCowID){
            self.cows.splice(i, 1);
          }
        });

        // return true since we deleted the cow
        return true;
      }else{
        return false;
      }

    };

    /**
     * Muting does not make sense in this context.
     * @return {boolean}
     */
    self.isMuted = function () {
      return false;
    };

    return self;  //return the cow object that is service bound to the backend and the hub
  }
})();

'use strict';
angular.module('dairyMonitorAdmin')
  .filter('split', function () {
    return function(input, splitChar) {
      // do some bounds checking here to ensure it has that index
      return input.split(splitChar);
    };
  });

'use strict';
angular.module('dairyMonitorAdmin')
  .filter('range', function () {
    return function(input, min, max) {
        min = parseInt(min); //Make string input int
        max = parseInt(max);
        for (var i=min; i<=max; i++)
          input.push(i);
        return input;
      };
  });

'use strict';
angular.module('dairyMonitorAdmin')
  .filter('num', function () {
    return function(input) {
      return parseInt(input, 10);
    };
  });

'use strict';
angular.module('dairyMonitorAdmin')
  .filter('minutesFromNow', function () {
    return function(past) {
      var diff = new Date(past) - new Date();
      var minutes = Math.floor((diff/1000)/60);
      return minutes;
    };
  });

(function () {
  "use strict";

  angular.module("dairyMonitorAdmin").run(addBodyClass).run(enableScrollToTop).run(enablePageLoader);

  /** @ngInject */
  function addBodyClass($rootScope) {
    var stateChangeSuccess = $rootScope.$on("$stateChangeSuccess", function (e, toState) {
      $rootScope.bodyClass = "view-" + toState.name;
      $rootScope.currentPage = toState.name;
    });

    $rootScope.$on("$destroy", stateChangeSuccess);
  }

  /** @ngInject */
  function enableScrollToTop($rootScope, $document) {
    var stateChangeSuccess = $rootScope.$on("$stateChangeSuccess", function () {
      $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
    });

    $rootScope.$on("$destroy", stateChangeSuccess);
  }

  /** @ngInject */
  function enablePageLoader($rootScope) {
    var stateChangeStart = $rootScope.$on("$stateChangeStart", function (event, toState) {
      if (toState.resolve) {
        $rootScope.loading = true;
      }
    });

    var stateChangeSuccess = $rootScope.$on("$stateChangeSuccess", function (event, toState) {
      if (toState.resolve) {
        $rootScope.loading = false;
      }
    });

    $rootScope.$on("$destroy", stateChangeStart);
    $rootScope.$on("$destroy", stateChangeSuccess);
  }
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider

      .state('main', {
        url: '/',
        templateUrl: 'app/views/main/main.html',
        data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] }
        //resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
      })



      .state('dataExplorer', {
        url: '/data-explorer',
        templateUrl: 'app/views/dataExplorer/dataExplorer.html',
        data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
        controller: function ($scope) {
          $scope.subnavItems = [
            {state: 'dataExplorer.reports', url: '#!/data-explorer/reports', title: 'Reports'},
            {state: 'dataExplorer.sensorData', url: '#!/data-explorer/sensor-data', title: 'Sensor Data'},
            {state: 'dataExplorer.apiTest', url: '#!/data-explorer/api-test', title: 'API Test'}
          ];
        },
        controllerAs: 'vm'
        // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
      })
        .state('dataExplorer.sensorData', {
          url: '/sensor-data',
          templateUrl: 'app/views/dataExplorer/sensorData/sensorData.html',
          data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
          controller: 'SensorDataController',
          controllerAs: 'vm'
          // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
        })
        // .state('dataExplorer.reports', {
        //   url: '/reports',
        //   templateUrl: 'app/views/dataExplorer/reports/reports.html',
        //   data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
        //   controller: 'ReportsController',
        //   controllerAs: 'vm'
        //   // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
        // })
        .state('dataExplorer.insights', {
          url: '/insights',
          templateUrl: 'app/views/dataExplorer/insights/insights.html',
          data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
          controller: 'InsightsController',
          controllerAs: 'vm'
          // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
        })
        .state('dataExplorer.apiTest', {
          url: '/api-test',
          templateUrl: 'app/views/dataExplorer/apiTest/apiTest.html',
          data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
          controller: 'ApiTestController',
          controllerAs: 'vm'
          // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
        })



        .state('hardware', {
          url: '/hardware',
          templateUrl: 'app/views/hardware/hardware.html',
          data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
          controller: function ($scope) {
            $scope.subnavItems = [
              {state: 'hardware.baseStations', url: '#!/hardware/base-stations', title: 'Base Stations'},
              {state: 'hardware.sensors', url: '#!/hardware/sensors', title: 'Sensors'},
              {state: 'hardware.lifeCycle', url: '#!/hardware/lifeCycle', title: 'Life Cycle'}
            ];
          },
          controllerAs: 'vm'
          // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
        })
          .state('hardware.baseStations', {
            url: '/base-stations',
            templateUrl: 'app/views/hardware/baseStations/baseStations.html',
            data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
            controller: 'BaseStationsController',
            controllerAs: 'vm'
            // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
          })
          .state('hardware.sensors', {
            url: '/sensors',
            templateUrl: 'app/views/hardware/sensors/sensors.html',
            data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
            controller: 'SensorsController',
            controllerAs: 'vm'
            // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
          })
            .state('hardware.newSensor', {
              url: '/new-sensor',
              templateUrl: 'app/views/hardware/sensors/newSensor/newSensor.html',
              data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
              controller: 'NewSensorController',
              controllerAs: 'vm'
              // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
            })
      .state("hardware.lifeCycle", {
        url: "/lifeCycle",
        component: "lifeCycle",
      })


      .state('accountManagement', {
        url: '/account-management',
        templateUrl: 'app/views/accountManagement/accountManagement.html',
        data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
        controller: function ($scope) {
          $scope.subnavItems = [
            {state: 'accountManagement.customers', url: '#!/account-management/customers', title: 'Customers'},
            {state: 'accountManagement.farms', url: '#!/account-management/farms', title: 'Farms'},
            {state: 'accountManagement.users', url: '#!/account-management/users', title: 'Users'},
            {state: 'accountManagement.roles', url: '#!/account-management/roles', title: 'Roles'},
            {state: 'accountManagement.cows',  url: '#!/account-management/cows',  title: 'Cows'}
          ];
        },
        controllerAs: 'vm'
        // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
      })
        .state('accountManagement.users', {
          url: '/users',
          controller: 'UsersController',
          controllerAs: 'vm',
          templateUrl: 'app/views/accountManagement/users/users.html',
          data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] }
          // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
        })
        .state('accountManagement.roles', {
          url: '/roles',
          controller: 'RolesController',
          controllerAs: 'vm',
          templateUrl: 'app/views/accountManagement/roles/roles.html',
          data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] }
          // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
        })
        .state('accountManagement.customers', {
          url: '/customers',
          templateUrl: 'app/views/accountManagement/customers/customers.html',
          controller: 'CustomersController',
          controllerAs: 'vm',
          data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] }
          // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
        })
        .state('accountManagement.farms', {
          url: '/farms',
          templateUrl: 'app/views/accountManagement/farms/farms.html',
          controller: 'FarmsController',
          controllerAs: 'vm',
          data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] }
          // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
        })
          .state('accountManagement.farms.farm', {
            url: '/farm?farmID',
            templateUrl: 'app/views/accountManagement/farms/farm/farm.html',
            controller: 'FarmController',
            controllerAs: 'vm',
            data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
            // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
            params: {
              farmID: '1'
            }
          })
            .state('accountManagement.farms.farm.baseStations', {
              url: '/base-stations',
              templateUrl: 'app/views/accountManagement/farms/farms.html',
              data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] },
              // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
              params: {
                farmID: '1'
              }
            })
          .state('accountManagement.cows', {
            url: '/cows',
            templateUrl: 'app/views/accountManagement/cows/cows.html',
            controller: 'CowsController',
            controllerAs: 'vm',
            data: { authorizedRoles: [USER_ROLES.admin, USER_ROLES.internal] }
            // resolve : { data: function(authenticationService){ return authenticationService.loadUserInfo().promise; }}
          });


    $urlRouterProvider.otherwise('/');
  }

})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .controller('IndexController', function($scope, $rootScope, $state, $stateParams, $window, $location, $log, AUTH_EVENTS, USER_ROLES, ENVIRONMENT, authenticationService, sessionService){
      var vm = $scope;
      // this is the parent controller for all controllers.
      // Manages auth login functions and each controller
      // inherits from this controller


      var showNotAuthorized = function(){
        $log.warn("User is not authorized");
        alert("Not Authorized");
        $state.go('logout');
      }

      var showNotConfirmed = function(){
        alert("Your email is not confirmed yet, please check your email");
      }

      var showNotAuthenticated = function(event, args){
        $log.warn("User is not authenticated");
        vm.redirectTo = args;
        $state.go('login');
      }

      var showSessionTimeout = function(){
        alert("Session Timeout");
      }

      var showLogoutSuccess = function(){
        alert("Logout Success");
      }

      var showLoginSuccess = function(){
        // if(sessionService.userRole.name === 'Farmer' || sessionService.userRole.name === 'FarmEmployee'){
        //   if(ENVIRONMENT === 'local'){
        //     $window.location.href = 'http://localhost:3000';
        //   }else{
        //     $window.location.href = 'https://cloud.connnecterra.io';
        //   }
        // }else{
        //   $state.go($stateParams.redirect);
        // }

        if(vm.redirectTo && vm.redirectTo.toState){
          $state.go(vm.redirectTo.toState.name, vm.redirectTo.toParams);
        }else{
          $state.go('main');
        }
      }

      vm.isAuthenticated = authenticationService.isAuthenticated;
      vm.currentUser     = sessionService.user;
      vm.userRole        = sessionService.userRole;

      //listen to events of unsuccessful logins, to run the login dialog
      var onNotConfirmed     = $rootScope.$on(AUTH_EVENTS.notConfirmed, showNotConfirmed);
      var onNotAuthorized    = $rootScope.$on(AUTH_EVENTS.notAuthorized, showNotAuthorized);
      var onNotAuthenticated = $rootScope.$on(AUTH_EVENTS.notAuthenticated, showNotAuthenticated);
      var onSessionTimeout   = $rootScope.$on(AUTH_EVENTS.sessionTimeout, showSessionTimeout);
      var onLogoutSuccess    = $rootScope.$on(AUTH_EVENTS.logoutSuccess, showLogoutSuccess);
      var onLoginSuccess     = $rootScope.$on(AUTH_EVENTS.loginSuccess, showLoginSuccess);

      $rootScope.$on('$destroy', onNotConfirmed);
      $rootScope.$on('$destroy', onNotAuthorized);
      $rootScope.$on('$destroy', onNotAuthenticated);
      $rootScope.$on('$destroy', onSessionTimeout);
      $rootScope.$on('$destroy', onLogoutSuccess);
      $rootScope.$on('$destroy', onLoginSuccess);


    });
})();

/* eslint-disable angular/window-service */

(function () {
  "use strict";

  /**
   * Tell if the value is present in the array
   * @param arr
   * @param value
   * @return {boolean}
   */
  var inArray = function (arr, value) {
    return arr.indexOf(value) > -1;
  };

  /**
   * Are we staging?
   * @param hostname
   * @return {boolean}
   */
  var isStaging = function (hostname) {
    return inArray(["localhost", "0.0.0.0", "10.23.108.66", "staging-admin.connecterra.io"], hostname);
  };

  /**
   * Are we demo?
   * @param hostname
   * @return {boolean}
   */
  var isDemo = function (hostname) {
    return inArray(["demo-admin.connecterra.io"], hostname);
  };

  /**
   * Are we production
   * @param hostname
   * @return {boolean}
   */
  var isProduction = function (hostname) {
    return !(isStaging(hostname) || isDemo(hostname));
  };

  /**
   * Make a Connecterra API url
   * @param api
   * @param options
   * @return {string}
   */
  var makeCtraURL = function (api, options) {
    options = Object.assign({ env: "staging" }, options || {});

    return ["https://", options.env ? [options.env, "-"].join("") : "", api, ".connecterra.io/"].join("");
  };

  /**
   * Make a Connecterra Azure url
   * @param api
   * @param options
   * @return {string}
   */
  var makeAzureURL = function (api, options) {
    options = Object.assign({ env: "staging" }, options || {});

    return ["https://", api, options.env ? ["-", options.env].join("") : "", ".azurewebsites.net/"].join("");
  };

  angular
    .module("dairyMonitorAdmin")
    .constant("LOCALES", {
      locales: {
        "nl-NL": "Nederlands",
        "en-US": "English",
        "es-ES": "Español"
      },
      preferredLocale: "en-US"
    })
    .constant(
      "appConfig",
      (function () {
        var data,
          auth,
          legacyAuth,
          api,
          scorecard,
          dataDictionary,
          gamePlans,
          notifications,
          users,
          accountService,
          recommendations,
          salesForceSync;

        var hostname = window.location.hostname;
        var base = "/";

        if (isStaging(hostname)) {
          auth = makeAzureURL("acf-auth");
          data = makeCtraURL("data");
          legacyAuth = makeCtraURL("auth");
          api = makeCtraURL("api");
          scorecard = makeAzureURL("idaenterprise-scorecard");
          dataDictionary = makeAzureURL("acf-datadictionary");
          gamePlans = makeAzureURL("idaenterprise-gameplans");
          notifications = makeAzureURL("ctra-hermes");
          users = makeAzureURL("acf-consentregistry");
          accountService = makeAzureURL("acf-accountsservice");
          recommendations = makeAzureURL("ctra-recommendations");
          salesForceSync = makeAzureURL("ctra-salesforce-sync");
        } else if (isDemo(hostname)) {
          auth = makeAzureURL("acf-auth", { env: null });
          data = makeCtraURL("data", { env: "demo" });
          legacyAuth = makeCtraURL("auth", { env: null });
          api = makeCtraURL("api", { env: "demo" });
          scorecard = makeAzureURL("idaenterprise-scorecard", { env: null });
          dataDictionary = makeAzureURL("acf-datadictionary", { env: null });
          gamePlans = makeAzureURL("idaenterprise-gameplans", { env: "staging" });
          notifications = makeAzureURL("ctra-hermes", { env: "staging" });
          users = makeAzureURL("acf-consentregistry", { env: null });
          accountService = makeAzureURL("acf-accountsservice", { env: null });
          recommendations = makeAzureURL("ctra-recommendations", { env: "staging" });
          salesForceSync = makeAzureURL("ctra-salesforce-sync", { env: "staging" });
        } else if (isProduction(hostname)) {
          auth = makeAzureURL("acf-auth", { env: null });
          data = makeCtraURL("data", { env: null });
          legacyAuth = makeCtraURL("auth", { env: null });
          api = makeCtraURL("api", { env: null });
          scorecard = makeAzureURL("idaenterprise-scorecard", { env: null });
          dataDictionary = makeAzureURL("acf-datadictionary", { env: null });
          gamePlans = makeAzureURL("idaenterprise-gameplans", { env: null });
          notifications = makeAzureURL("ctra-hermes", { env: null });
          users = makeAzureURL("acf-consentregistry", { env: null });
          accountService = makeAzureURL("acf-accountsservice", { env: null });
          recommendations = makeAzureURL("ctra-recommendations", { env: null });
          salesForceSync = makeAzureURL("ctra-salesforce-sync", { env: null });
        } else {
          throw new Error(["I cannot tell which env '", hostname, "' belongs to."].join(""));
        }

        return {
          /**
           * @todo refactor to camelCased
           */
          DATAAPIURL: data,
          AUTHAPIURL: auth,
          LEGACYAUTHAPIURL: legacyAuth,
          APIURL: api,
          BASEURL: base,
          SCORECARDURL: scorecard,
          DATADICTIONARYURL: dataDictionary,
          GAMEPLANSURL: gamePlans,
          NOTIFICATIONURL: notifications,
          USERSURL: users,
          RECOMMENDATIONSURL: recommendations,
          /**
           * @todo use camelCased from now on
           */
          accountService: accountService,
          salesForceSync: salesForceSync
        };
      })()
    )
    .constant(
      "ENVIRONMENT",
      /**
       * Make env
       * @return {*|string}
       */ (function makeEnv() {
        /**
         * @type {string[]}
         */
        var localHostnames = ["localhost", "0.0.0.0", "10.23.108.66"];

        /**
         * @type {string[]}
         */
        var debugHostnames = ["dev-admin.connecterra.io"];

        /**
         * @type {string[]}
         */
        var demoHostnames = ["demo-admin.connecterra.io"];

        /**
         * @type {string[]}
         */
        var productionHostnames = ["admin.connecterra.io"];

        /**
         * @type {*[]}
         */
        var envs = [
          {
            key: "local",
            hostnames: localHostnames
          },
          {
            key: "debug",
            hostnames: debugHostnames
          },
          {
            key: "demo",
            hostnames: demoHostnames
          },
          {
            key: "production",
            hostnames: productionHostnames
          }
        ];

        return envs.reduce(function (result, env) {
          if (env.hostnames.indexOf(window.location.hostname) > -1) {
            result = env.key;
          }

          return result;
        }, window.location.hostname);
      })()
    );
})();

(function() {
  'use strict';

  angular
    .module('dairyMonitorAdmin')
    .config(config)
    .config(cfpLoadingBarConfig)
    .config(localStorageServiceConfig)
    .config(translateConfig)
    .config(tmhDynamicLocaleConfig)
    .config(trafficCopConfig)
    .config(gravatarServiceProvider);


  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
  }


  /** @ngInject */
  function cfpLoadingBarConfig(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
  }


  /** @ngInject */
  function localStorageServiceConfig(localStorageServiceProvider) {
    localStorageServiceProvider
      .setPrefix('ctra')
      .setStorageType('localStorage')
      .setNotify(true, true);
  }

  /**
   * @param $translateProvider
   * @param $translateMessageFormatInterpolationProvider
   * @param LOCALES
   * @ngInject
   */
  function translateConfig ($translateProvider, $translateMessageFormatInterpolationProvider, LOCALES) {
    /**
     * Enable functions like date and time in Loco
     */
    $translateMessageFormatInterpolationProvider.messageFormatConfigurer(function (mf) {
      mf.setIntlSupport(true);

      mf.addFormatters({
        /**
         * "Day of year" loco formatter
         * @param {string} date
         * @param {string} locale
         * @return {string}
         */
        dayofyear: function (date, locale) {
          /**
           * @type {{month: string, weekday: string, day: string}}
           */
          var options = {
            weekday: "long",
            month: "long",
            day: "numeric"
          };

          return (new Date(date)).toLocaleDateString(locale, options);
        }
      });
    });

    $translateProvider.addInterpolation("$translateMessageFormatInterpolation");
    $translateProvider.useMissingTranslationHandlerLog();
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.useLoader("locoLoader");
    $translateProvider.preferredLanguage(LOCALES.preferredLocale); // is applied on first load
    $translateProvider.fallbackLanguage(LOCALES.preferredLocale);
    $translateProvider.useLocalStorage(); // saves selected language to localStorage
  }


  /** @ngInject */
  function tmhDynamicLocaleConfig(tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');
  }


  /** @ngInject */
  function trafficCopConfig($httpProvider) {
    $httpProvider.interceptors.push('trafficCop');
  }

  function gravatarServiceProvider(gravatarServiceProvider) {
    gravatarServiceProvider.defaults = {
      size     : 50,
      "default": 'mm'  // Mystery man as default for missing avatars
    };

    // Use https endpoint
    // gravatarServiceProvider.secure = true;
    //
    // // Force protocol
    // gravatarServiceProvider.protocol = 'my-protocol';
    //
    // // Override URL generating function
    // gravatarServiceProvider.urlFunc = function(options) {
    //   // Code to generate custom URL
    // };
  }

})();

angular.module("dairyMonitorAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/baseStationList/baseStationList.html","<div class=text-right><label for=filterBaseStations ng-show=showFilters><input type=checkbox id=filterBaseStations ng-model=hideRobotFarms ng-change=filterBaseStations()> Hide RobotFarm\'s Base Stations</label></div><div class=\"table-list table-list-md\"><div class=\"alert alert-info alert-sm\" ng-show=\"filteredBaseStations.length === 0 && !loading\">No base stations found</div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div><div class=table-list-heading ng-hide=\"!filteredBaseStations.length && !loading\" ng-class=\"(details.headingMinimal ? \'table-list-heading-minimal\' : \'\')\"><div class=row><div class=col-xs-6>Farm &amp; Base Station</div><div class=\"col-sm-3 col-xs-6\">Sensors</div><div class=\"col-sm-3 hidden-xs\">Last Ping</div></div></div><div class=table-list-items><div class=table-list-item dir-paginate=\"baseStation in filteredBaseStations | itemsPerPage: itemsPerPage\" pagination-id=\"\'id-\'+$id\" ng-init=\"baseStationStatus = getBaseStationStatus(baseStation)\" ng-class=\"baseStationStatus + (expandedBaseStations.indexOf(baseStation.BaseStationID) > -1 ? \' active\' : \'\')\"><div class=row ng-click=rowClicked(baseStation.BaseStationID); role=button><div class=col-xs-6><span ng-if=baseStation.farmID ng-repeat=\"farm in farms | filter : {FarmID : baseStation.farmID} : true\">{{farm.farmName}} - </span><small ng-if=!baseStation.farmID>no farm - </small><small class=gray>{{ baseStation.deviceName }} - SN: <code class=gray>{{ baseStation.deviceSerialNum }}</code></small></div><div class=\"col-sm-3 col-xs-6 bullets bullets-sm\"><span ng-repeat=\"sensor in sensors | filter : {baseStationID : baseStation.BaseStationID} : true\" class=bullet ng-class=\"minutesSince(sensor.deviceDMLastPingTime) < 60 ? \'bullet-success\' : (minutesSince(sensor.deviceDMLastPingTime) < 1440 ? \'bullet-warning\' : (minutesSince(sensor.deviceDMLastPingTime) < 10800 ? \'bullet-danger\' : \'\'))\"></span></div><div class=\"col-sm-3 hidden-xs\"><span ng-if=\"baseStationStatus === \'item-success\'\"><i class=\"fa fa-check-circle color-success\"></i></span> <span ng-if=\"baseStationStatus === \'item-warning\'\"><i class=\"fa fa-exclamation-triangle color-warning\"></i></span> <span ng-if=\"baseStationStatus === \'item-danger\'\"><i class=\"fa fa-exclamation-triangle color-danger\"></i></span> <span ng-if=baseStation.deviceBSLastPingTime am-time-ago=\"baseStation.deviceBSLastPingTime + \' GMT\'\" class=small ng-class=\"(baseStationStatus === \'\' ? \'gray\' : \'\')\"></span></div><div class=table-list-item-expand-btn role=button tabindex=0></div></div><!-- .row --><div class=\"row table-list-detail table-list-detail-light\" ng-if=\"(expandedBaseStations.indexOf(baseStation.BaseStationID) > -1)\"><div class=col-sm-12><div class=section-nav role=navigation ng-show=\"sectionNavItems.length > 1\"><ul class=\"nav navbar-nav\"><li ng-class=\"($parent.currentSection === item.sectionID ? \'active\' : \'\')\" ng-repeat=\"item in sectionNavItems\"><a ng-click=\"$parent.currentSection = item.sectionID\">{{item.title}}</a></li></ul></div><!-- .subnav --><!-- <div ng-if=\"details.showBaseStationDetails && currentSection === \'baseStationStatus\'\">\n              <base-station-status base-station-status=\"baseStation\"></base-station-status>\n            </div> --><div ng-if=\"details.showBaseStationDetails && currentSection === \'baseStationDetails\'\"><base-station-details base-station=baseStation></base-station-details></div><div ng-if=\"details.showBaseStationConfigDetails && currentSection === \'baseStationConfigDetails\'\"><base-station-config-details base-station=baseStation></base-station-config-details></div><div ng-if=\"details.showBaseStationSensors && currentSection === \'baseStationSensors\'\"><base-station-sensors base-station=baseStation selectable=true selected-sensors=selectedSensors></base-station-sensors></div><div ng-if=\"details.showBaseStationCredentials && currentSection === \'baseStationCredentials\'\"><base-station-credentials base-station=baseStation></base-station-credentials></div><div ng-if=\"details.showBaseStationCommands && currentSection === \'baseStationCommands\'\"><base-station-commands base-station=baseStation></base-station-commands></div></div><!-- .col-sm-12 --></div><!-- .row table-list-detail table-list-detail-lights --></div><!-- .table-list-item ng-repeat=\"farm in farms --></div><!-- .table-list-items --><div class=text-center><dir-pagination-controls pagination-id=\"\'id-\'+$id\" auto-hide=false></dir-pagination-controls><div class=form-group><label for=itemsPerPage>Items per page</label><select ng-model=itemsPerPage id=itemsPerPage ng-init=\"itemsPerPage=\'\'\"><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=\"\">show all</option></select></div></div><!-- .table-list-md --><ping-legend></ping-legend></div>");
$templateCache.put("app/components/cowList/cowList.html","<div class=table-list><div class=\"alert alert-info alert-sm\" ng-show=\"cows.length === 0 && !loading\">No cows found</div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div><div class=form-group ng-hide=\"!cows.length && !loading\"><input type=text name=searchString class=\"form-control input-sm\" ng-model=searchString placeholder=\"Search by cow tag number\"></div><div class=table-list-heading ng-hide=\"!cows.length && !loading\" ng-class=\"(details.headingMinimal ? \'table-list-heading-minimal\' : \'\')\"><div class=row ng-hide=selectedCows.length><div ng-class=details.DairyCowID ng-if=details.DairyCowID ng-click=\"sortBy(cows, \'DairyCowID\')\" role=button>{{\"LABEL_TEXT_ID\" | translate}}<span ng-if=\"(sortVar === \'DairyCowID\' ? \'strong\' : \'\')\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=\"details.cowTagNumber || details.cowTagNumberInput\" ng-if=\"details.cowTagNumber || details.cowTagNumberInput\" ng-click=\"sortBy(cows, \'cowTagNumber\')\" role=button>{{\"LABEL_TEXT_TAGNUMBER\" | translate}}<span ng-if=\"(sortVar === \'cowTagNumber\' ? \'strong\' : \'\')\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=details.cowStatus ng-if=details.cowStatus ng-click=\"sortBy(cows, \'cowStatus\')\" role=button>{{\"currentStatus\" | translate}}</div><div ng-class=details.lactationNumber ng-if=details.lactationNumber ng-click=\"sortBy(cows, \'lactationNumber\')\" role=button>{{\"lactationNumber\" | translate}}</div><div ng-class=\"details.farm || details.farmSelect\" ng-if=\"details.farm || details.farmSelect\" ng-click=\"sortBy(cows, \'farmID\')\" role=button>{{\"LABEL_TEXT_FARM\" | translate}}<span ng-if=\"(sortVar === \'farmID\' ? \'strong\' : \'\')\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=\"details.herdGroup || details.herdGroupSelect\" ng-if=\"details.herdGroup || details.herdGroupSelect\" ng-click=\"sortBy(cows, \'herdGroupID\')\" role=button>{{\"LABEL_TEXT_HERD_GROUP\" | translate}}<span ng-if=\"(sortVar === \'herdGroupID\' ? \'strong\' : \'\')\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=\"details.sensor || details.sensorSelect\" ng-if=\"details.sensor || details.sensorSelect\" ng-click=\"sortBy(cows, \'nodeID\')\" role=button>{{\"LABEL_TEXT_SENSOR\" | translate}}<span ng-if=\"(sortVar === \'nodeID\' ? \'strong\' : \'\')\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=details.watchEnabled ng-if=details.watchEnabled ng-click=\"sortBy(cows, \'watchEnabled\')\" role=button>{{\"watching\" | translate}}<span ng-if=\"(sortVar === \'watchEnabled\' ? \'strong\' : \'\')\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div></div><div class=row ng-if=selectedCows.length><div class=col-sm-6><input type=checkbox ng-if=selectable ng-click=\"toggleAll(cows, selectedCows, \'DairyCowID\')\" ng-checked=\"(selectedCows.length === cows.length)\"></div><div class=\"col-sm-6 text-right\"><div class=btn-group><button type=button class=\"btn btn-xs btn-default dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-disabled=\"selectedCows.length<1\">{{\"actions\" | translate}} {{selectedCows.length ? \'(\'+selectedCows.length+\' cow\'+(selectedCows.length > 1 ? \'s\' : \'\')+\')\' : \'\'}} <span class=caret></span></button><ul class=dropdown-menu><li><a ng-click=watchCows(selectedCows)><i class=\"fa fa-eye\"></i> {{\"watch\" | translate}}</a></li><li><a ng-click=unwatchCows(selectedCows)><i class=\"fa fa-eye-slash\"></i> {{\"unwatch\" | translate}}</a></li><li role=separator class=divider></li><li><a ng-click=deleteCows(selectedCows)><i class=\"fa fa-trash-o\"></i> {{\"delete\" | translate}}</a></li></ul></div></div></div></div><div class=table-list-items><div class=table-list-item dir-paginate=\"cow in (cows | filter: {cowTagNumber: searchString} : false) | itemsPerPage: itemsPerPage\" pagination-id=\"\'id-\'+$id\"><div class=row><div ng-class=details.DairyCowID ng-if=details.DairyCowID ng-click=rowClicked(cow.DairyCowID);><input id={{cow.DairyCowID}} type=checkbox value={{cow.DairyCowID}} ng-checked=\"selectedCows.indexOf(cow.DairyCowID) > -1\" ng-if=selectable> <code>#{{cow.DairyCowID}}</code></div><div ng-class=details.cowTagNumber ng-if=details.cowTagNumber ng-click=rowClicked(cow.DairyCowID);><input id={{cow.DairyCowID}} type=checkbox value={{cow.DairyCowID}} ng-checked=\"selectedCows.indexOf(cow.DairyCowID) > -1\" ng-if=\"selectable && !details.DairyCowID\"> <strong>{{ cow.cowTagNumber }}</strong> {{ cow.cowName }}</div><div ng-class=details.cowTagNumberInput ng-if=details.cowTagNumberInput><div class=row><div class=col-sm-6><input type=text class=\"form-control input-sm\" placeholder=\"Cow Tag Number\" ng-model=cow.cowTagNumber id=cowTagNumber ng-blur=save(cow)></div><div class=\"col-sm-6 alpha\"><input type=text class=\"col-sm-6 form-control input-sm\" placeholder=\"Cow Name\" ng-model=cow.cowName id=cowName ng-blur=save(cow)></div></div></div><div ng-class=details.farm ng-if=details.farm ng-click=rowClicked(cow.DairyCowID);>{{(farms | filter : {FarmID : (cow.farmID | num)} : true)[0].farmName }}</div><div ng-class=details.farmSelect ng-if=details.farmSelect><select class=\"form-control input-sm\" id=farmID ng-model=cow.farmID ng-options=\"farm.FarmID as (farm.farmName) for farm in farms\" ng-change=save(cow)></select></div><div ng-class=details.herdGroup ng-if=details.herdGroup ng-click=rowClicked(cow.DairyCowID);>{{((herdGroups | filter : {HerdGroupID : (cow.herdGroupID | num)} : true) | filter : {farmID : (cow.farmID | num)} : true)[0].groupName }}</div><div ng-class=details.herdGroupSelect ng-if=details.herdGroupSelect><select class=\"form-control input-sm\" id=herdGroupID ng-model=cow.herdGroupID ng-options=\"herdGroup.HerdGroupID as (herdGroup.groupName) for herdGroup in (herdGroups | filter: {farmID : cow.farmID} : true)\" ng-change=save(cow)><option value=\"\">None</option></select></div><div ng-class=details.sensor ng-if=details.sensor ng-click=rowClicked(cow.DairyCowID);><code ng-if=cow.nodeID>#{{cow.nodeID}}</code> <span ng-if=cow.nodeID ng-repeat=\"sensor in sensors | filter : {NodeID : cow.nodeID} : true\">[{{sensor.deviceSerialNum}}] - {{sensor.deviceName}}</span></div><div ng-class=details.sensorSelect ng-if=details.sensorSelect><dairy-monitor-dropdown dairy-monitors=sensors selected-dairy-monitor=selectedSensor on-change=\"linkCowToSensor(cow, selectedSensor)\" ng-init=\"selectedSensor=(sensors | filter : {NodeID : (cow.nodeID | num)} : true)[0]\"></dairy-monitor-dropdown></div><div ng-class=details.cowStatus ng-if=details.cowStatus ng-click=rowClicked(cow.DairyCowID);>{{ cow.cowStatus }}</div><div ng-class=details.watchEnabled ng-if=details.watchEnabled ng-click=toggleWatch(cow)><i class=\"fa fa-eye\" ng-if=cow.watchEnabled></i> <i class=\"fa fa-eye-slash gray\" ng-if=!cow.watchEnabled></i></div><div class=table-list-item-expand-btn role=button ng-click=toggleDetails(cow.DairyCowID)></div></div><div class=\"row table-list-detail\" ng-if=\"$parent.currentListItem === cow.DairyCowID\"><div class=col-sm-12><cow-details-form-fields cow=cow on-blur=save(cow) herd-groups=herdGroups farms=farms></cow-details-form-fields><div class=row><div class=col-sm-6><div class=form-group><label for=nodeID>{{\"LABEL_TEXT_SENSOR\" | translate}}</label><dairy-monitor-dropdown dairy-monitors=sensors selected-dairy-monitor=selectedSensor on-change=\"linkCowToSensor(cow, selectedSensor)\" ng-init=\"selectedSensor=(sensors | filter : {NodeID : (cow.nodeID | num)} : true)[0]\"></dairy-monitor-dropdown></div></div></div><save-status-inline status=status></save-status-inline></div><div class=col-sm-12><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=delete(cow)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button></p></div></div></div></div></div><div class=text-center><dir-pagination-controls pagination-id=\"\'id-\'+$id\" auto-hide=false></dir-pagination-controls><div class=form-group><label for=itemsPerPage>Items per page</label><select ng-model=itemsPerPage id=itemsPerPage ng-init=\"itemsPerPage=\'25\'\"><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=\"\">show all</option></select></div></div></div>");
$templateCache.put("app/components/herdGroupList/herdGroupList.html","<div><div class=\"table-list table-list-md\"><div class=\"alert alert-info alert-sm\" ng-show=\"herdGroup.length === 0 && !loading\">No herd groups found</div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div><div class=table-list-heading ng-hide=\"!herdGroup.length && !loading\" ng-class=\"(details.headingMinimal ? \'table-list-heading-minimal\' : \'\')\"><div class=row><div class=col-xs-6>{{\"LABEL_TEXT_NAME\" | translate}}</div><div class=\"col-sm-6 hidden-xs\">cows</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"herdGroup in herdGroups\" ng-class=\"(expandedHerdGroups.indexOf(herdGroup.HerdGroupID) > -1 ? \'active\' : \'\')\"><div class=row ng-click=rowClicked(herdGroup.HerdGroupID); role=button><div class=col-xs-6>{{herdGroup.groupName}}</div><div class=\"col-sm-3 hidden-xs bullets\"><span ng-repeat=\"cow in cows | filter : {herdGroupID : herdGroup.HerdGroupID} : true\" class=bullet></span></div><div class=table-list-item-expand-btn role=button tabindex=0></div></div><!-- .row --><div class=\"row table-list-detail table-list-detail-light\" ng-if=\"(expandedHerdGroups.indexOf(herdGroup.HerdGroupID) > -1)\"><div class=col-sm-12><div class=section-nav role=navigation ng-show=\"sectionNavItems.length > 1\"><ul class=\"nav navbar-nav\"><li ng-class=\"($parent.currentSection === item.sectionID ? \'active\' : \'\')\" ng-repeat=\"item in sectionNavItems\"><a ng-click=\"$parent.currentSection = item.sectionID\">{{item.title}}</a></li></ul></div><!-- .subnav --><div ng-if=\"details.showHerdGroupDetails && currentSection === \'herdGroupDetails\'\"><herd-group-details herd-group=herdGroup></herd-group-details></div><div ng-if=\"details.showHerdGroupCows && currentSection === \'herdGroupCows\'\"><div class=text-right><save-status-inline status=status style=\"display: inline-block\"></save-status-inline><a class=\"btn btn-sm btn-info\" ng-click=\"inlineEdit=!inlineEdit\">inline edit</a></div><cow-list cows=cows herd-groups=herdGroups sensors=sensors selectable=true selected-cows=selectedCows status=status details=\"(inlineEdit ? editDetails : details)\" ng-init=\"details={\n                headingMinimal: true,\n                DairyCowID:     \'col-sm-1\',\n                cowTagNumber:   \'col-sm-5\',\n                sensor:         \'col-sm-5\',\n                watchEnabled:   \'col-sm-1\'}; editDetails={\n                  headingMinimal:       true,\n                  DairyCowID:           \'col-sm-1 omega\',\n                  cowTagNumberInput:    \'col-sm-5 alpha\',\n                  sensorSelect:         \'col-sm-5\',\n                  watchEnabled:         \'col-sm-1\'}\"></cow-list></div></div><!-- .col-sm-12 --></div><!-- .row table-list-detail table-list-detail-lights --></div><!-- .table-list-item ng-repeat=\"farm in farms --></div><!-- .table-list-items --></div><!-- .table-list-md --></div>");
$templateCache.put("app/components/mainNav/mainNav.html","<div class=header ng-cloak><div class=\"navbar navbar-default\" role=navigation><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=.navbar-collapse><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand href=#!/dashboard><img src=assets/images/co-white.svg alt=\"\"></a></div><div class=\"collapse navbar-collapse navbar-left\"><ul class=\"nav navbar-nav small-caps\"><li ui-sref-active=active><a ui-sref=main>Overview</a></li><li ui-sref-active=active><a ui-sref=dataExplorer.reports>Data Explorer</a></li><li ui-sref-active=active><a ui-sref=insights.insightTypes>Insights</a></li><li ui-sref-active=active><a ui-sref=hardware.baseStations>Hardware</a></li><li ui-sref-active=active><a ui-sref=accountManagement.customers>Account Management</a></li></ul></div><div class=\"collapse navbar-collapse navbar-right small-caps\"><ul class=\"nav navbar-nav\"><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown role=button aria-expanded=false><img gravatar-src=user.email gravatar-size=50 class=gravatar-sm> {{ user.email}} <span class=caret></span></a><ul class=dropdown-menu><li><a ng-href=#!/account>{{\"BUTTON_TEXT_ACCOUNT\" | translate}}</a></li><li><a ng-href=#!/logout>{{\"BUTTON_TEXT_LOGOUT\" | translate}}</a></li></ul></li></ul></div></div></div>");
$templateCache.put("app/components/sensorList/sensorList.html","<div class=table-list><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div><div class=form-group ng-hide=\"!sensors.length && !loading\"><input type=text name=searchString class=\"form-control input-sm\" ng-model=searchString placeholder=\"Search by sensor serial\" ng-change=updateFilter()></div><div class=form-group ng-hide=\"!sensors.length && !loading\"><div ng-class=\"(showFilters ? \'panel panel-default\' : \'\')\"><div ng-class=\"(showFilters ? \'panel-heading\' : \'\')\"><label for=showFilters><input type=checkbox id=showFilters ng-model=showFilters ng-change=updateFilter()> Filters</label></div><div class=panel-body ng-show=showFilters><div class=row><div class=col-sm-3><h6>Base Station Linked</h6><p><input type=checkbox ng-model=sensorsFilterBaseStationLinkedYes ng-change=\"(sensorsFilterBaseStationLinkedNo && sensorsFilterBaseStationLinkedYes ? sensorsFilterBaseStationLinkedNo = false : \'\'); updateFilter()\"> Yes <input type=checkbox ng-model=sensorsFilterBaseStationLinkedNo ng-change=\"(sensorsFilterBaseStationLinkedYes && sensorsFilterBaseStationLinkedNo ? sensorsFilterBaseStationLinkedYes = false : \'\'); updateFilter()\"> No</p></div><div class=col-sm-3><h6>Batch Number</h6><input type=text class=\"form-control input-sm\" id=sensorsFiltersBoxNumber ng-model=sensorsFiltersBoxNumber ng-change=updateFilter()></div><div class=col-sm-3><h6>Long Serial Number</h6><input type=text class=\"form-control input-sm\" id=longSerialNum ng-model=longSerialNum ng-change=updateFilter()></div><div class=col-sm-3><h6>Short Serial Number</h6><input type=text class=\"form-control input-sm\" id=shortSerialNum ng-model=shortSerialNum ng-change=updateFilter()></div><div class=col-sm-3 ng-repeat=\"(key, value) in sensorsBatchOptions\"><h6>{{key}}</h6><select ng-if=sensorsBatchOptions[key] class=\"form-control input-sm\" ng-options=\"key2 as value2 for (key2, value2) in value\" ng-model=sensorsBatchFilters[key] ng-change=updateFilter()></select><input ng-if=!sensorsBatchOptions[key] class=\"form-control input-sm\" id={{key}} ng-model=batchDetails[key]></div></div><!-- .row --></div></div></div><p ng-if=filteredSensors.length><strong>{{ (filteredSensors.length ? filteredSensors.length : \'\') }} Sensors</strong>, {{ (filteredSensors | filter: {baseStationID : null} : true).length }} in stock</p><div class=\"alert alert-info alert-sm\" ng-show=\"filteredSensors.length === 0 && !loading\">No sensors found</div><div class=table-list-heading ng-hide=\"!filteredSensors.length && !loading\" ng-class=\"(details.headingMinimal ? \'table-list-heading-minimal\' : \'\')\"><div class=row ng-hide=selectedSensors.length><div ng-class=details.NodeID ng-if=details.NodeID ng-click=\"sortBy(sensors, \'NodeID\')\" role=button>{{\"LABEL_TEXT_ID\" | translate}}<span ng-if=\"sortVar === \'NodeID\'\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=\"details.deviceSerialNum || details.deviceSerialNumInput\" ng-if=\"details.deviceSerialNum || details.deviceSerialNumInput\" ng-click=\"sortBy(sensors, \'deviceSerialNum\')\" role=button>{{\"LABEL_TEXT_SERIALNUMBER\" | translate}}<span ng-if=\"sortVar === \'deviceSerialNum\'\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><!-- <div ng-class=\"details.transmissionAddress || details.transmissionAddressInput\" ng-if=\"details.transmissionAddress || details.transmissionAddressInput\"                   ng-click=\"sortBy(sensors, \'transmissionAddress\')\"  role=\"button\">{{\"LABEL_TEXT_TRANSMISSION_ADDRESS\" | translate}}<span ng-if=\"sortVar === \'transmissionAddress\'\"> <i class=\"fa\" ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=\"true\"></i></span></div> --><div ng-class=\"details.baseStation || details.baseStationSelect\" ng-if=\"details.baseStation || details.baseStationSelect\" ng-click=\"sortBy(sensors, \'baseStationID\')\" role=button>{{\"LABEL_TEXT_BASESTATION\" | translate}}<span ng-if=\"sortVar === \'baseStationID\'\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=\"details.DairyCowIDTagNumber || details.cowTagNumber || details.cowSelect\" ng-if=\"details.DairyCowIDTagNumber || details.cowTagNumber || details.cowSelect\">{{\"LABEL_TEXT_LINKED_TO_COW\" | translate}}</div><div ng-class=details.deviceDMLastEvent ng-if=details.deviceDMLastEvent ng-click=\"sortBy(sensors, \'deviceDMLastEvent\')\" role=button>{{\"LABEL_TEXT_STATUS\" | translate}}<span ng-if=\"sortVar === \'deviceDMLastEvent\'\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=details.deviceName ng-if=details.deviceName ng-click=\"sortBy(sensors, \'deviceName\')\" role=button>Batch number<span ng-if=\"sortVar === \'deviceName\'\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=details.deviceDMLastPingTime ng-if=details.deviceDMLastPingTime ng-click=\"sortBy(sensors, \'deviceDMLastPingTime\')\" role=button>{{\"LABEL_TEXT_LAST_PING_TIME\" | translate}}<span ng-if=\"sortVar === \'deviceDMLastPingTime\'\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><div ng-class=details.lifeCycleState ng-if=details.lifeCycleState>Life Cycle State</div><div ng-class=details.deployed ng-if=details.deployed ng-click=\"sortBy(sensors, \'baseStationID\')\" role=button>Deployed<span ng-if=\"sortVar === \'baseStationID\'\"> <i class=fa ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=true></i></span></div><!-- <div ng-class=\"details.deviceDMLastEventTime\"                                   ng-if=\"details.deviceDMLastEventTime\"                                                     ng-click=\"sortBy(sensors, \'deviceDMLastEventTime\')\"role=\"button\">{{\"LABEL_TEXT_LAST_EVENT_TIME\" | translate}}<span      ng-if=\"sortVar === \'deviceDMLastEventTime\'\"> <i class=\"fa\" ng-class=\"(sortDescending ? \'fa-caret-up\' : \'fa-caret-down\')\" aria-hidden=\"true\"></i></span></div> --></div><div class=row ng-show=selectedSensors.length><div class=col-sm-6><input type=checkbox ng-click=\"toggleAll(filteredSensors, selectedSensors, \'NodeID\')\" ng-checked=\"(selectedSensors.length === filteredSensors.length)\"></div><div class=\"col-sm-6 text-right\"><div class=btn-group><button type=button class=\"btn btn-xs btn-default\" data-toggle=dropdown ng-click=\"selectAll(filteredSensors, selectedSensors, \'NodeID\')\">select all</button> <button type=button class=\"btn btn-xs btn-warning\" data-toggle=dropdown ng-disabled=\"selectedSensors.length<1\" ng-click=\"selectedSensors=[]\">clear selection</button> <button type=button class=\"btn btn-xs btn-default\" ng-click=updateBatchProperties()>batch properties</button><div class=btn-group><button type=button class=\"btn btn-xs btn-default dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-disabled=\"selectedSensors.length<1\">move to <span class=caret></span></button><ul class=dropdown-menu><li ng-repeat=\"baseStation in baseStations | orderBy:\'BaseStationID\'\"><a ng-click=moveSelectedSensorsToBaseStation(baseStation)>#{{baseStation.BaseStationID}} {{baseStation.deviceName}}</a></li><li role=separator class=divider></li><li><a ng-click=moveSelectedSensorsToBaseStation()><i class=\"fa fa-chain-broken\"></i> no base station</a></li></ul></div><div class=btn-group><button type=button class=\"btn btn-xs btn-default dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-disabled=\"selectedSensors.length<1\">actions {{selectedSensors.length ? \'(\'+selectedSensors.length+\' sensor\'+(selectedSensors.length > 1 ? \'s\' : \'\')+\')\' : \'\'}} <span class=caret></span></button><ul class=dropdown-menu><li><a ng-click=unlinkSelectedSensors()><i class=\"fa fa-chain-broken\"></i> Unlink from cow</a></li><li role=separator class=divider></li><li><a ng-click=deleteSelectedSensors()><i class=\"fa fa-trash-o\"></i> Delete</a></li></ul></div></div></div></div><!-- .row ng-show=\"selectedSensors.length\" --></div><!-- .table-list-heading --><div class=\"panel panel-default\" ng-show=\"showBatchOptions && selectedSensors.length\"><div class=panel-heading><h2>Batch Properties</h2></div><div class=panel-body><div class=row><div class=col-sm-4 ng-repeat=\"(key, value) in sensorsBatchOptions\"><div class=form-group><label for={{key}}>{{key}}</label><select ng-if=sensorsBatchOptions[key] class=form-control id={{key}} ng-model=batch[key] ng-options=\"key2 as (value2) for (key2, value2) in sensorsBatchOptions[key]\"></select><input ng-if=!sensorsBatchOptions[key] class=form-control id={{key}} ng-model=batch[key]></div></div><div class=col-sm-4><div class=form-group><label for=boxNumber>Batch number</label><input type=text class=form-control id=boxNumber ng-model=boxNumber></div></div><div class=col-sm-12><a class=\"btn btn-success btn-sm\" ng-click=applyBatchUpdate()>apply changes to {{selectedSensors.length}} sensor{{(selectedSensors.length > 1 ? \'s\' : \'\')}}</a></div></div></div></div><div class=table-list-items><div class=table-list-item dir-paginate=\"sensor in filteredSensors| itemsPerPage: itemsPerPage \" pagination-id=\"\'id-\'+$id\" ng-class=\"($parent.currentListItem === sensor.NodeID ? \'active\' : (selectable && selectedSensors.indexOf(sensor.NodeID) > -1 ? \'selected\' : \'\'))\"><div class=row role=button><div ng-class=details.NodeID ng-if=details.NodeID ng-click=rowClicked(sensor.NodeID);><input ng-if=selectable type=checkbox class=chkbox ng-checked=\"selectedSensors.indexOf(sensor.NodeID) > -1\"> <code>#{{ sensor.NodeID }}</code></div><div ng-class=details.deviceSerialNum ng-if=details.deviceSerialNum ng-click=rowClicked(sensor.NodeID);><strong>{{sensor.deviceSerialNum }}{{(sensor.shortSerialNum !== sensor.deviceSerialNum ? \" - \"+sensor.shortSerialNum :\"\")}}</strong></div><div ng-class=details.deviceSerialNumInput ng-if=details.deviceSerialNumInput ng-click=rowClicked(sensor.NodeID);><input type=text class=\"form-control input-sm\" id=deviceSerialNum ng-model=sensor.deviceSerialNum ng-blur=save(sensor)></div><!-- <div ng-class=\"details.transmissionAddress\" ng-if=\"details.transmissionAddress\"  ng-click=\"rowClicked(sensor.NodeID);\">{{sensor.transmissionAddress}}</div>\n        <div ng-class=\"details.transmissionAddressInput\" ng-if=\"details.transmissionAddressInput\">\n          <input type=\"text\" class=\"form-control input-sm\" id=\"transmissionAddress\" ng-model=\"sensor.transmissionAddress\" ng-blur=\"save(sensor)\">\n        </div> --><div ng-class=details.baseStation ng-if=details.baseStation ng-click=rowClicked(sensor.NodeID);><span ng-repeat=\"baseStation in baseStations | filter: {BaseStationID: sensor.baseStationID} : true\"><code>{{\'#\'+baseStation.BaseStationID }}</code> {{baseStation.deviceName}}</span></div><div ng-class=details.baseStationSelect ng-if=details.baseStationSelect><select class=\"form-control input-sm\" id=baseStationID ng-model=sensor.baseStationID ng-change=save(sensor) ng-options=\"baseStation.BaseStationID as (\'#\'+baseStation.BaseStationID + \' \' + baseStation.deviceName) for baseStation in baseStations\"></select></div><div ng-class=details.DairyCowIDTagNumber ng-if=details.DairyCowIDTagNumber ng-click=rowClicked(sensor.NodeID);><span ng-repeat=\"cow in cows | filter : {nodeID : (sensor.NodeID | num)} : true\"><code>#{{ cow.DairyCowID }}</code> [ {{ cow.cowTagNumber }} ] {{ cow.cowName }}</span></div><div ng-class=details.cowTagNumber ng-if=details.cowTagNumber ng-click=rowClicked(sensor.NodeID);><span ng-repeat=\"cow in cows | filter : {nodeID : (sensor.NodeID | num)} : true\">[ {{ cow.cowTagNumber }} ] {{ cow.cowName }}</span></div><div ng-class=details.cowSelect ng-if=details.cowSelect><select class=\"form-control input-sm\" id=dairyCowID ng-model=selectedCow ng-change=\"linkCowToSensor(selectedCow, sensor)\" ng-options=\"cow as (\'#\'+cow.DairyCowID +\' - [ \'+ cow.cowTagNumber + \' ] \' + cow.cowName) for cow in cows\" ng-init=\"selectedCow=(cows | filter : {nodeID : (sensor.NodeID | num)} : true)[0]\"><option value=\"\">Not linked</option></select></div><div ng-class=details.deviceDMLastEvent ng-if=details.deviceDMLastEvent ng-click=rowClicked(sensor.NodeID);><span class=status ng-class=\"\'status-\'+sensor.deviceDMLastEvent\">{{ sensor.deviceDMLastEvent }}</span></div><div ng-class=details.deviceName ng-if=details.deviceName ng-click=rowClicked(sensor.NodeID);>{{ sensor.deviceName }}</div><div ng-class=details.deviceDMLastPingTime ng-if=details.deviceDMLastPingTime ng-click=rowClicked(sensor.NodeID);><span ng-if=\"minutesSince(sensor.deviceDMLastPingTime) < 60\"><i class=\"fa fa-check-circle color-success\"></i></span> <span ng-if=\"minutesSince(sensor.deviceDMLastPingTime) >= 60 && minutesSince(sensor.deviceDMLastPingTime) < 1440 \"><i class=\"fa fa-exclamation-triangle color-warning\"></i></span> <span ng-if=\"minutesSince(sensor.deviceDMLastPingTime) >= 1440 && minutesSince(sensor.deviceDMLastPingTime) < 10800\"><i class=\"fa fa-exclamation-triangle color-danger\"></i></span> <span ng-if=\"sensor.deviceDMLastPingTime !== \'0001-01-01T00:00:00Z\'\" am-time-ago=sensor.deviceDMLastPingTime class=small ng-class=\"(minutesSince(sensor.deviceDMLastPingTime) >= 10800 ? \'gray\' : \'\')\"></span> <span ng-if=\"sensor.deviceDMLastPingTime === \'0001-01-01T00:00:00Z\'\">-</span></div><div ng-class=details.lifeCycleState ng-if=details.lifeCycleState ng-click=rowClicked(sensor.NodeID);>{{ sensor.lifeCycleState }}</div><div ng-class=details.deployed ng-if=details.deployed ng-click=rowClicked(sensor.NodeID);><div ng-if=sensor.baseStationID><i class=\"fa fa-link\" aria-hidden=true ng-repeat=\"baseStation in baseStations | filter: {BaseStationID: sensor.baseStationID} : true\" data-toggle=tooltip data-placement=top title=\"{{\'#\'+baseStation.BaseStationID }} {{baseStation.deviceName}}\"></i> <i class=\"fa fa-cow\" aria-hidden=true ng-repeat=\"cow in cows | filter : {nodeID : (sensor.NodeID | num)} : true\" data-toggle=tooltip data-placement=top title=\"{{\'#\'+cow.DairyCowID }} [{{cow.cowTagNumber}}]\"></i> <span ng-show=\"sensor.deviceDMLastPingTime !== \'0001-01-01T00:00:00Z\'\"><span ng-if=\"minutesSince(sensor.deviceDMLastPingTime) < 60\"><i class=\"fa fa-check-circle color-success\"></i></span> <span ng-if=\"minutesSince(sensor.deviceDMLastPingTime) >= 60 && minutesSince(sensor.deviceDMLastPingTime) < 1440 \"><i class=\"fa fa-exclamation-triangle color-warning\"></i></span> <span ng-if=\"minutesSince(sensor.deviceDMLastPingTime) >= 1440 && minutesSince(sensor.deviceDMLastPingTime) < 10800\"><i class=\"fa fa-exclamation-triangle color-danger\"></i></span> </span><span am-time-ago={{getBatchDetails(sensor).deployedEpoch*1000}}><span></span></span></div></div><div class=table-list-item-expand-btn role=button ng-click=toggleDetails(sensor.NodeID)></div></div><div class=\"row table-list-detail\" ng-if=\"$parent.currentListItem === sensor.NodeID\" ng-init=\"batchDetails = getBatchDetails(sensor)\"><div class=col-sm-6><div class=row><div class=col-sm-6><div class=form-group><label for=deviceDescription>{{\"LABEL_TEXT_LINKED_TO_COW\" | translate}}</label><select class=form-control id=dairyCowID ng-model=selectedCow ng-change=\"linkCowToSensor(selectedCow, sensor)\" ng-options=\"cow as (\'#\'+cow.DairyCowID +\' - [ \'+ cow.cowTagNumber + \' ] \' + cow.cowName) for cow in cows\" ng-init=\"selectedCow=(cows | filter : {nodeID : (sensor.NodeID | num)} : true)[0]\"><option value=\"\">Not linked</option></select></div></div><div class=col-sm-6><div class=form-group><label for=deviceDescription>{{\"LABEL_TEXT_BASESTATION\" | translate}}</label><select class=form-control id=baseStationID ng-model=sensor.baseStationID ng-change=save(sensor) ng-options=\"baseStation.BaseStationID as (\'#\'+baseStation.deviceSerialNum + \' \' + baseStation.deviceName) for baseStation in baseStations\"><option value=\"\">Not linked</option></select></div></div><div class=col-sm-6><div class=form-group><label for=deviceDescription>Long Serial Number</label><input type=text class=form-control ng-model=sensor.deviceSerialNum disabled></div></div><div class=col-sm-6><div class=form-group><label for=deviceDescription>Short Serial Number</label><input type=text class=form-control ng-model=sensor.shortSerialNum disabled></div></div></div><save-status-inline status=status></save-status-inline></div><div class=col-sm-6><div class=row><div class=\"col-sm-4 col-xs-6\" ng-repeat=\"(key, value) in sensorsBatchOptions\"><div class=form-group><label for={{key}}>{{key}}</label><select ng-if=sensorsBatchOptions[key] class=form-control id={{key}} ng-model=batchDetails[key] disabled ng-options=\"key2 as (value2) for (key2, value2) in sensorsBatchOptions[key]\"></select><input ng-if=!sensorsBatchOptions[key] class=form-control id={{key}} ng-model=batchDetails[key] disabled></div></div><div class=\"col-sm-4 col-xs-6\"><div class=form-group><label for=deviceDescription>Batch number</label><input type=text class=form-control id=deviceDescription ng-model=sensor.deviceName disabled></div></div><div class=\"col-sm-4 col-xs-6\"><div class=form-group><label for=lifeCycle>Life Cycle</label><input type=text class=form-control id=lifeCycle ng-model=sensor.lifeCycleState disabled></div></div></div><div class=row><div class=col-sm-4><div class=form-group><label>{{\"LABEL_TEXT_LAST_PING_TIME\" | translate}}</label><p ng-show=\"sensor.deviceDMLastPingTime !== \'0001-01-01T00:00:00Z\'\"><span ng-if=\"minutesSince(sensor.deviceDMLastPingTime) < 60\"><i class=\"fa fa-check-circle color-success\"></i></span> <span ng-if=\"minutesSince(sensor.deviceDMLastPingTime) >= 60 && minutesSince(sensor.deviceDMLastPingTime) < 1440 \"><i class=\"fa fa-exclamation-triangle color-warning\"></i></span> <span ng-if=\"minutesSince(sensor.deviceDMLastPingTime) >= 1440 && minutesSince(sensor.deviceDMLastPingTime) < 10800\"><i class=\"fa fa-exclamation-triangle color-danger\"></i></span> <span am-time-ago=sensor.deviceDMLastPingTime class=small ng-class=\"(minutesSince(sensor.deviceDMLastPingTime) >= 10800 ? \'gray\' : \'\')\"></span></p><p ng-hide=\"sensor.deviceDMLastPingTime !== \'0001-01-01T00:00:00Z\'\">N/A</p></div></div></div><div class=row><div class=col-sm-12><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><!-- <button type=\"button\" class=\"btn btn-sm btn-wide btn-gray\" ng-click=\"disableSensor(sensor)\"><i class=\"fa fa-power-off\" aria-hidden=\"true\"></i> Disable</button> --><!-- <button type=\"button\" class=\"btn btn-sm btn-wide btn-warning\" ng-click=\"returnSensor(sensor)\"><i class=\"fa fa-truck\" aria-hidden=\"true\"></i> Return</button> --> <button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=deleteSensor(sensor)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button></p></div></div></div></div></div></div></div><div class=text-center><dir-pagination-controls pagination-id=\"\'id-\'+$id\" auto-hide=false on-page-change=pageChanged() current-page=currentPage></dir-pagination-controls><div class=form-group><label for=itemsPerPage>Items per page</label><select ng-model=itemsPerPage id=itemsPerPage ng-init=\"itemsPerPage=\'25\'\"><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=\"\">show all</option></select></div></div></div>");
$templateCache.put("app/components/system-monitor-chart/system-monitor-chart.html","<graph display-data=$ctrl.displayData domain=$ctrl.chartDomain on-domain-change=$ctrl.onChartDomainChange(domain) class=\"graph no-animation\"></graph><div class=\"alert alert-info\" ng-if=$ctrl.info>{{$ctrl.info}}</div><div class=\"alert alert-info\" ng-if=$ctrl.error>{{$ctrl.error}}</div><div class=loading-hover ng-show=$ctrl.loading><loading-bar></loading-bar></div>");
$templateCache.put("app/views/accountManagement/accountManagement.html","<sub-nav items=subnavItems></sub-nav><ui-view class=content></ui-view>");
$templateCache.put("app/views/dataExplorer/dataExplorer.html","<sub-nav items=subnavItems></sub-nav><ui-view class=content></ui-view>");
$templateCache.put("app/views/hardware/hardware.html","<sub-nav items=subnavItems></sub-nav><ui-view class=\"content container-fluid\"></ui-view>");
$templateCache.put("app/views/insights/insights.html","<sub-nav items=$ctrl.subnavItems></sub-nav><ui-view class=\"content container\"><h1>Insights</h1></ui-view>");
$templateCache.put("app/views/main/main.html","<div class=\"content container-fluid\"><system-monitors-panel></system-monitors-panel></div>");
$templateCache.put("app/components/baseStationList/baseStationCommands/baseStationCommands.html","<div class=base-station-commands><div class=loading-cover ng-if=$ctrl.loading><loading-bar></loading-bar></div><section class=table-list><div class=row><div class=col-sm-6><div class=form-group><label>Command</label><form class=block-row ng-submit=$ctrl.sendCommand()><select name=command ng-model=$ctrl.selectedCommand class=\"form-control input-sm\"><option ng-value=command ng-repeat=\"command in $ctrl.commands\">{{command}}</option></select><button class=\"btn btn-sm btn-default\" type=submit>Issue command</button></form></div></div><div class=col-sm-6><div class=form-group><label>Response</label><pre class=input-sm><samp>{{ $ctrl.commandResponse }}</samp></pre></div></div></div></section></div>");
$templateCache.put("app/components/baseStationList/baseStationCredentials/baseStationCredentials.html","<div class=base-station-credentials><div class=loading-spacer ng-if=\"$ctrl.loading && !$ctrl.users\"></div><div class=loading-cover ng-if=$ctrl.loading><loading-bar></loading-bar></div><section class=table-list><div class=\"table-list-heading table-list-heading-minimal\"><div class=row><div class=col-xs-3>Username</div><div class=col-xs-3>Password</div><div class=col-xs-6>Change password</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"(key, user) in $ctrl.users\"><div class=row><div class=\"col-xs-3 username\">{{user.username}}</div><div class=col-xs-3 ng-if=!user.password><button class=\"btn btn-xs btn-default\" ng-click=$ctrl.showPassword(user.username)>Show password</button></div><div class=\"col-xs-3 password\" ng-if=user.password>{{user.password}}</div><div class=col-xs-6><form class=block-row ng-submit=$ctrl.changePassword(user)><input type=password name=password ng-model=user.newPassword class=\"form-control input-sm\" placeholder=\"New password\"> <input type=password name=password-again ng-model=user.newPasswordAgain class=\"form-control input-sm\" placeholder=\"Repeat password\"> <button class=\"btn btn-xs btn-default\" type=submit>Change password</button></form></div></div></div></div></section></div>");
$templateCache.put("app/components/baseStationList/baseStationConfigDetails/baseStationConfigDetails.html","<div style=position:relative><div class=loading-spacer ng-show=loading></div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div><div ng-if=baseStationConfig ng-hide=loading><div class=row><div class=col-sm-12><div class=row><div class=col-sm-4 ng-repeat=\"(key, value) in baseStationConfig\" ng-if=\"hiddenVariables.indexOf(key) < 0\"><div class=form-group><label for={{key}}>{{addSpaces(key)}}</label><input type=text class=form-control id={{key}} ng-model=baseStationConfig[key] ng-disabled=\"noEditVariables.indexOf(key) > -1\"></div></div></div><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><!-- <button type=\"button\" class=\"btn btn-sm btn-wide btn-success\" ng-click=\"saveAndSendConfig(baseStationConfig)\"><i class=\"fa fa-exchange\" aria-hidden=\"true\"></i> Save &amp; Sync Config</button> --> <button type=button class=\"btn btn-sm btn-wide btn-success\" ng-click=save(baseStationConfig)><i class=\"fa fa-floppy-o\" aria-hidden=true></i> Save</button> <button type=button class=\"btn btn-sm btn-wide btn-info\" ng-click=sendConfig(baseStationConfig)><i class=\"fa fa-exchange\" aria-hidden=true></i> Sync Config</button> <button type=button class=\"btn btn-sm btn-wide btn-default\" ng-click=downloadConfig(baseStationConfig)><i class=\"fa fa-download\" aria-hidden=true></i> Download Config</button> <button type=button class=\"btn btn-sm btn-wide btn-default\" ng-click=downloadMapping(baseStation.BaseStationID)><i class=\"fa fa-download\" aria-hidden=true></i> Download Mapping</button></p><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div></div></div><!-- .col-sm-6 --></div><!-- .row --></div><!-- .ng-if=\"baseStationConfig\" --><div ng-if=!baseStationConfig ng-hide=loading><div class=\"alert alert-info\" role=alert>This base station is not active yet</div><button type=button class=\"btn btn-sm btn-wide btn-success\" ng-click=activateBaseStation(baseStation)><i class=\"fa fa-power-off\" aria-hidden=true></i> Activate base station</button></div></div>");
$templateCache.put("app/components/baseStationList/baseStationDetails/baseStationDetails.html","<div><div class=row><div class=col-sm-6><div class=form-group><label for=deviceName>{{\"LABEL_TEXT_NAME\" | translate}}</label><input type=text class=form-control id=deviceName ng-model=baseStation.deviceName ng-blur=save(baseStation)></div><div class=form-group><label for=deviceDescription>{{\"LABEL_TEXT_DESCRIPTION\" | translate}}</label><input type=text class=form-control id=deviceDescription ng-model=baseStation.deviceDescription ng-blur=save(baseStation)></div><div class=form-group><label for=farmID>{{\"LABEL_TEXT_FARM\" | translate}}</label><select class=form-control id=farmID ng-model=baseStation.farmID ng-change=save(baseStation) ng-options=\"farm.FarmID as (farm.farmName) for farm in farms\" required><option value=\"\">Select farm</option></select></div><save-status-inline status=status></save-status-inline></div><!-- .row --><div class=col-sm-6><div class=row><div class=col-sm-4><div class=form-group ng-dblclick=\"editSerialNumber=!editSerialNumber\" ng-hide=editSerialNumber><label>{{\"LABEL_TEXT_SERIALNUMBER\" | translate}}</label><p>{{ baseStation.deviceSerialNum }}</p></div><div class=form-group ng-show=editSerialNumber><label for=deviceSerialNum>{{\"LABEL_TEXT_SERIALNUMBER\" | translate}}</label><input type=text class=\"form-control input-sm\" id=deviceSerialNum ng-model=baseStation.deviceSerialNum ng-blur=save(baseStation)></div></div><div class=col-sm-4><div class=form-group><label>{{\"LABEL_TEXT_IP_ADDRESS\" | translate}}</label><p>{{ baseStation.deviceBSIPAddress }}</p></div></div><div class=col-sm-4><div class=form-group><label>{{\"LABEL_TEXT_FIRMWARE\" | translate}}</label><p>unknown</p></div></div></div><div class=row><div class=col-sm-4><div class=form-group><label>{{\"LABEL_TEXT_LAST_PING_TIME\" | translate}}</label><p><span am-time-ago=baseStation.deviceBSLastPingTime></span><span ng-if=!baseStation.deviceBSLastPingTime>-</span></p></div></div><div class=col-sm-4><div class=form-group><label>{{\"LABEL_TEXT_INSTALLATION_DATE\" | translate}}</label><p>{{ baseStation.deviceInstallationDate | amDateFormat:\'D MMM, YYYY\' }}</p></div></div></div><!-- .row --><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-default\" ng-click=downloadBaseStationLog(baseStation)><i class=\"fa fa-cloud-download\" aria-hidden=true></i> Download Log</button> <button type=button class=\"btn btn-sm btn-wide btn-warning\" ng-click=rebootBaseStation(baseStation)><i class=\"fa fa-refresh\" aria-hidden=true></i> Reboot</button> <button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=delete(baseStation)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button></p></div></div><!-- .col-sm-6 --></div><!-- .row --></div>");
$templateCache.put("app/components/baseStationList/baseStationSensors/baseStationSensors.html","<div style=position:relative><div class=text-right><save-status-inline status=status style=\"display: inline-block\"></save-status-inline><a class=\"btn btn-sm btn-info\" ng-click=\"inlineEdit=!inlineEdit\">inline edit</a></div><sensor-list sensors=sensors cows=cows base-stations=baseStations farm=farm selectable=selectable selected-sensors=selectedSensors details=\"(inlineEdit ? editDetails : details)\" ng-init=\"details={\n    headingMinimal:       true,\n    NodeID:               \'col-xs-1\',\n    deviceSerialNum:      \'col-xs-5\',\n    DairyCowIDTagNumber:  \'col-xs-2\',\n    deviceDMLastPingTime: \'col-xs-2\',\n    deployed:             \'col-xs-1\'}; editDetails={\n      headingMinimal:           true,\n      NodeID:                   \'col-xs-1\',\n      deviceSerialNumInput:     \'col-xs-3\',\n      cowSelect:                \'col-xs-3\',\n      deviceDMLastPingTime:     \'col-xs-2\'}\"></sensor-list></div>");
$templateCache.put("app/components/herdGroupList/herdGroupDetails/herdGroupDetails.html","<div><div class=row><div class=col-sm-6><div class=form-group><label for=groupName>Name</label><input type=text class=form-control id=herdGroup ng-model=herdGroup.groupName accept=\"\" ng-blur=save(herdGroup)></div></div><div class=col-sm-6><div class=form-group><label for=groupDescription>Description</label><input type=text class=form-control id=groupDescription ng-model=herdGroup.groupDescription ng-blur=save(herdGroup)></div></div><div class=col-sm-12><save-status-inline status=status></save-status-inline></div><div class=col-sm-12><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=delete(herdGroup)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button></p></div></div><!-- .col-sm-12 --></div><!-- .row --></div>");
$templateCache.put("app/views/accountManagement/cows/cows.html","<ui-view><div class=container-fluid><div class=\"panel panel-with-section-nav\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>{{ (cows.length ? cows.length : \'\') }} Cows</h2></div><div class=\"col-sm-6 text-right\"><a class=\"btn btn-sm btn-primary\" ng-click=\"showForm = (showForm === \'cow\' ? \'\' : \'cow\')\">Create new cow</a><save-status-inline status=status style=\"display: inline-block\"></save-status-inline><a class=\"btn btn-sm btn-info\" ng-click=\"inlineEdit=!inlineEdit\">inline edit</a></div></div></div><div class=panel-body><div class=\"panel panel-default\" ng-show=\"showForm===\'cow\'\"><div class=panel-heading><h2>Create new cow</h2></div><div class=panel-body><new-cow-form success-callback=cowAdded(cows)></new-cow-form></div></div><cow-list cows=cows herd-groups=herdGroups farms=farms sensors=sensors selectable=true selected-cows=selectedCows details=\"(inlineEdit ? editDetails : details)\" status=status ng-init=\"details={\n        headingMinimal: true,\n        DairyCowID:     \'col-sm-1\',\n        cowTagNumber:   \'col-sm-3\',\n        farm:           \'col-sm-3\',\n        herdGroup:      \'col-sm-2\',\n        sensor:         \'col-sm-2\',\n        watchEnabled:   \'col-sm-1\'}; editDetails={headingMinimal:       true,\n          DairyCowID:           \'col-sm-1 omega\',\n          cowTagNumberInput:    \'col-sm-3 alpha\',\n          farmSelect:           \'col-sm-3\',\n          herdGroupSelect:      \'col-sm-2\',\n          sensorSelect:         \'col-sm-2\',\n          watchEnabled:         \'col-sm-1\'}\"></cow-list></div></div></div></ui-view>");
$templateCache.put("app/views/accountManagement/customers/customers.html","<div class=container-fluid><div class=\"panel panel-with-section-nav\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>{{(customers.length ? customers.length : \'\')}} Customers</h2></div><div class=\"col-sm-6 text-right\"><a class=\"btn btn-sm btn-primary\" ng-click=\"showForm = (showForm === \'customer\' ? \'\' : \'customer\')\">Add new customer</a></div></div></div><div class=panel-body><div class=\"panel panel-default\" ng-show=\"showForm === \'customer\'\"><div class=panel-heading><h2>Create new customer</h2></div><div class=panel-body><new-customer-form success-callback=customerAdded(customer)></new-customer-form></div></div><customer-list customers=customers farms=farms users=users></customer-list></div></div></div>");
$templateCache.put("app/views/accountManagement/farms/farms.html","<ui-view><div class=container-fluid><div class=\"panel panel-with-section-nav\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>{{(farms.length ? farms.length : \'\')}} Farms</h2></div><div class=\"col-sm-6 text-right\"><a class=\"btn btn-sm btn-primary\" ng-click=\"showForm = (showForm === \'farm\' ? \'\' : \'farm\')\">Create new farm</a></div></div></div><div class=panel-body><div class=\"panel panel-default\" ng-show=\"showForm===\'farm\'\"><div class=panel-heading><h2>Create new farm</h2></div><div class=panel-body><new-farm-form success-callback=farmAdded(farm)></new-farm-form></div></div><farm-list farms=farms customers=customers></farm-list></div></div></div></ui-view>");
$templateCache.put("app/views/accountManagement/roles/roles.html","<div class=container-fluid><div class=\"panel panel-with-section-nav\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>{{(roles.length ? roles.length : \'\')}} Roles</h2></div><div class=\"col-sm-6 text-right\"><a class=\"btn btn-sm btn-primary\" ng-click=\"showForm = (showForm === \'role\' ? \'\' : \'role\')\">Add new role</a></div></div></div><div class=panel-body><div class=\"panel panel-default\" ng-if=\"showForm===\'role\'\"><div class=panel-heading><h2>Create new role</h2></div><div class=panel-body><new-role-form success-callback=roleAdded(role)></new-role-form></div></div><role-list roles=roles customers=customers farms=farms></role-list></div></div></div>");
$templateCache.put("app/views/accountManagement/users/users.html","<div class=container-fluid><div class=\"panel panel-with-section-nav\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>{{ (users.length ? users.length : \'\') }} Users</h2></div><div class=\"col-sm-6 text-right\"><a class=\"btn btn-sm btn-primary\" ng-click=\"showForm = (showForm === \'user\' ? \'\' : \'user\')\">Create new user</a></div></div></div><div class=panel-body><div class=\"panel panel-default\" ng-if=\"showForm === \'user\'\"><div class=panel-heading><h2>Create new user</h2></div><div class=panel-body><new-user-form success-callback=userAdded(user)></new-user-form></div></div><user-list users=users customers=customers farms=farms></user-list></div></div></div>");
$templateCache.put("app/views/dataExplorer/apiTest/apiTest.html","<div class=container-full><div class=row><div class=col-sm-3><div class=\"panel panel-default\"><div class=panel-heading><h2>Test Options</h2></div><!-- .panel-heading --><div class=panel-body><label>Select APIs</label><div class=row><div class=col-sm-6><div class=checkbox><label><input type=checkbox ng-model=showCharts.dailyStatisticsFixed value=true ng-init=\"showCharts.dailyStatisticsFixed=true\"> dailyStatisticsFixed</label></div><div class=checkbox><label><input type=checkbox ng-model=showCharts.eventsCSV value=true> eventsCSV</label></div><div class=checkbox><label><input type=checkbox ng-model=showCharts.filtersCSV value=true> filtersCSV</label></div></div><!-- col-sm-6 --><div class=col-sm-6><div class=checkbox><label><input type=checkbox ng-model=showCharts.insightsCSV value=true> insightsCSV</label></div><div class=checkbox><label><input type=checkbox ng-model=showCharts.insightContainers value=true> insightContainers</label></div><div class=checkbox><label><input type=checkbox ng-model=showCharts.summaryCSV value=true> summaryCSV</label></div></div><!-- col-sm-6 --></div><!-- .row --><div class=form-group><select class=form-control ng-model=selectedFarms multiple size=10 ng-options=\"farm as farm.farmName for farm in farms\"></select></div><div class=form-group><label>Select cow</label><select class=form-control ng-model=searchParam ng-change=\"selectedFarm=\'\'; DairyCowID=\'\'; cowName=\'\'; cowTagNumber=\'\';\" ng-init=\"searchParam = \'farm\'\"><option value=farm>Farm</option><option value=DairyCowID>Cow ID</option><option value=cowTagNumber>Tag Number</option><option value=cowName>Cow Name</option></select></div><div class=form-group><select class=\"form-control no-animate\" ng-model=$parent.selectedFarm ng-options=\"farm as farm.farmName for farm in farms\" ng-if=\"searchParam === \'farm\'\"></select><input class=\"form-control no-animate\" ng-model=$parent.DairyCowID type=text placeholder=\"Cow ID\" ng-if=\"searchParam === \'DairyCowID\'\"> <input class=\"form-control no-animate\" ng-model=$parent.cowTagNumber type=text placeholder=\"Tag Number\" ng-if=\"searchParam === \'cowTagNumber\'\"> <input class=\"form-control no-animate\" ng-model=$parent.cowName type=text placeholder=\"Cow Name\" ng-if=\"searchParam === \'cowName\'\"></div><div class=form-group><div class=checkbox><label><input type=checkbox ng-model=nodeID value=true ng-init=\"nodeID=true\"> Hide cows without sensor</label></div><select class=form-control ng-model=selectedCows multiple size=10 ng-options=\"cow as \'[#\'+cow.DairyCowID+\'] \'+cow.cowTagNumber+\' \'+cow.cowName +\' \'+(cow.nodeID ? \'\' : \'(no sensor)\') for cow in cows | filter : {farmID: selectedFarm.FarmID, DairyCowID: DairyCowID, cowName: cowName, cowTagNumber: cowTagNumber, nodeID: (nodeID ? \'\' : \'!null\')} : false\"></select></div></div></div></div><div class=col-sm-9><div class=\"panel panel-default\"><div class=panel-heading><date-period-selector start-date=startDate end-date=endDate day-range=dayRange day-options=[1,3,7,31] max-date=maxDate class=small></date-period-selector></div><div class=panel-body style=position:relative ng-if=\"(!selectedFarms.length && !selectedCows.length)\"><div class=\"alert alert-info\">Please select a farm and/or cows</div></div><div class=panel-body style=position:relative ng-if=\"(selectedFarms.length || selectedCows.length) && apiTestStatus !== \'running\'\"><button class=\"btn btn-block btn-warning btn-lg\" ng-click=runApitest()>Run API test</button></div><div class=panel-body style=position:relative ng-if=\"(selectedFarms.length || selectedCows.length) && apiTestStatus === \'running\'\"><button class=\"btn btn-block btn-danger btn-sm\" ng-click=cancelApitest()>Cancel API test</button></div><div class=panel-body style=position:relative ng-if=\"apiTestStatus !== \'inactive\'\"><rzslider rz-slider-model=slider.min rz-slider-high=slider.max rz-slider-options=slider.options></rzslider><table class=table><tr><th>Type</th><th>ID</th><th>Name</th><th>API</th><th>Size Est.</th><th>Response Time (ms)</th></tr><tr ng-repeat=\"query in queries\" ng-class=\"(query.completed && query.successful ? (query.responseTime < slider.min ? \'success\' : (query.responseTime < slider.max ? \'warning\' : \'danger\' )) : (query.completed && !query.successful ? \'danger color-danger strong\' : \'\') )\"><td>{{query.type}}</td><td>{{query.id}}</td><td>{{query.title}}</td><td>{{query.dataType}}</td><td>{{query.sizeEstimation}}</td><td>{{query.responseTime + (query.responseTime ? \'ms\' : \'\')}}<loading-spinner ng-if=query.loading></loading-spinner><span ng-if=\"!query.loading && !query.responseTime && apiTestStatus===\'cancelled\'\">cancelled</span> <span ng-if=\"query.completed && !query.successful\">FAILED!</span></td></tr></table></div></div></div><!-- .col-sm-9 --></div><!-- .row --></div>");
$templateCache.put("app/views/dataExplorer/partner/partner.html","<div class=\"content container-full\">{{$ctrl.partners}} {{$ctrl.farms}}<farms-map farms=$ctrl.farms color-key=customerID selected-farm=$ctrl.selectedFarm></farms-map><!-- <leaflet width=\"100%\" height=\"480px\"></leaflet> --><!-- <report ng-repeat=\"report in $ctrl.reports\"\n            subject-types=\"$ctrl.subjectTypes\"\n            farms=\"$ctrl.farms\"\n            herd-groups=\"$ctrl.herdGroups\"\n            cows=\"$ctrl.cows\"\n            start-date=\"$ctrl.startDate\"\n            end-date=\"$ctrl.endDate\"\n            day-range=\"$ctrl.dayRange\"\n            max-date=\"$ctrl.maxDate\"></report> --><!-- <p>\n      <a class=\"btn btn-default btn-block btn-lg\" ng-click=\"$ctrl.addVisualisation()\">add visualisation</a>\n    </p> --></div>");
$templateCache.put("app/views/dataExplorer/reports/reports.html","<div class=\"content container-full\"><report ng-repeat=\"report in $ctrl.reports\" subject-types=$ctrl.subjectTypes farms=$ctrl.farms cows=$ctrl.cows start-date=$ctrl.startDate end-date=$ctrl.endDate day-range=$ctrl.dayRange max-date=$ctrl.maxDate></report></div>");
$templateCache.put("app/views/dataExplorer/sensorData/sensorData.html","<div class=container-full><div class=row><div class=col-sm-6><div class=\"panel panel-default\"><div class=panel-heading><div class=row><h2 class=col-xs-6>Sensors</h2><div class=\"col-xs-6 text-right\"><h6><span ng-click=\"autoRefresh=!autoRefresh\" ng-class=\"(autoRefresh ? \'color-primary\' : \'gray\')\"><input type=checkbox ng-checked=autoRefresh> auto refresh<span ng-show=autoRefresh> ({{autoRefreshSeconds}})</span></span></h6></div></div></div><!-- .panel-heading --><div class=panel-body><div class=\"p text-right hidden\"><button type=button class=\"btn btn-xs btn-default\" data-toggle=dropdown ng-click=\"selectAll(sensors, selectedSensors, \'NodeID\')\">select all</button> <button type=button class=\"btn btn-xs btn-warning\" data-toggle=dropdown ng-disabled=\"selectedSensors.length<1\" ng-click=\"selectedSensors=[]\">clear selection</button><div class=btn-group><button type=button class=\"btn btn-xs btn-default dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-disabled=\"selectedSensors.length<1\">actions {{selectedSensors.length ? \'(\'+selectedSensors.length+\' sensor\'+(selectedSensors.length > 1 ? \'s\' : \'\')+\')\' : \'\'}} <span class=caret></span></button><ul class=dropdown-menu><li><a ng-click=unlinkSelectedSensors()><i class=\"fa fa-chain-broken\"></i> Unlink from cow</a></li><li role=separator class=divider></li><li><a ng-click=deleteSelectedSensors()><i class=\"fa fa-trash-o\"></i> Delete</a></li></ul></div></div><base-station-list farms=farms base-stations=baseStations sensors=sensors cows=cows selectable=true selected-sensors=selectedSensors details=\"{\n            headingMinimal: true,\n            showBaseStationDetails: false,\n            showBaseStationSensors: true\n          }\"></base-station-list></div></div></div><div class=col-sm-6><div class=\"panel panel-default\"><div class=panel-heading><date-period-selector start-date=startDate end-date=endDate day-range=dayRange day-options=[1,3,7,31] max-date=maxDate class=small></date-period-selector></div><div class=panel-body style=position:relative><div class=\"alert alert-info\" ng-if=!selectedCows.length>Please select a sensor/cow</div><div ng-repeat=\"visualisation in visualisations\"><h3><code>#{{visualisation.id}}</code> {{visualisation.title}}</h3><ctra-data-visualisation display-values=visualisation.displayValues start-date=startDate end-date=endDate on-date-change=\"onDateChange(startDate, endDate)\" class=graph></ctra-data-visualisation><hr></div></div></div><!-- <detections-timeline-panel ng-class=\"\'panel-default detection-timeline-panel\'\" cows=\"[125]\" autoload=\"true\" zoomable=\"true\" show-datepicker=\"true\" show-csv-download=\"true\" show-data-aggregations=\"true\"></detections-timeline-panel> --></div><!-- .col-sm-6 --></div><!-- .row --></div>");
$templateCache.put("app/views/hardware/baseStations/baseStations.html","<div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>{{ (baseStations.length ? baseStations.length : \'\') }} Base Stations</h2></div><div class=\"col-sm-6 text-right\"><a class=\"btn btn-sm btn-primary\" ng-click=\"showForm = (showForm === \'baseStation\' ? \'\' : \'baseStation\')\">Create new base station</a></div></div></div><div class=panel-body><div class=\"panel panel-default\" ng-if=\"showForm===\'baseStation\'\"><div class=panel-heading><h2>Add new base station</h2></div><div class=panel-body><new-base-station-form farm-id=farmId success-callback=baseStationAdded(baseStation)></new-base-station-form></div></div><base-station-list farms=farms base-stations=baseStations base-station-statusses=baseStationStatusses details=\"{\n      headingMinimal: false,\n      showBaseStationDetails: true,\n      showBaseStationConfigDetails: true,\n      showBaseStationSensors: true,\n      showBaseStationCredentials: true,\n      showBaseStationCommands: true\n    }\" show-filters=true></base-station-list></div></div>");
$templateCache.put("app/views/hardware/lifeCycle/lifeCycle.html","<div class=life-cycle ng-hide=\"$ctrl.isSensorListLoading || $ctrl.isBaseStationListLoading\"><div class=sensor><form ng-submit=$ctrl.updateSensorLifeCycle(sensor)><h4>Change the life cycle for a specific sensor</h4><div class=\"x-flex x-align-center sensor-number\"><p>Input LSN</p><input type=text class=form-control ng-model=sensor.id placeholder=LSN></div><div class=\"x-flex life-cycle-container\"><life-cycle-drop-down class=life-cycle-drop-down title=\"Change life cycle state to\" list=$ctrl.lifeCycleState form-data=sensor form-data-key=lifeCycleState></life-cycle-drop-down><button type=submit class=\"btn btn-dark\">update sensor</button></div></form></div><div class=base-station><form ng-submit=$ctrl.updateBaseStationLifeCycle(baseStation)><h4>Change the life cycle for a specific base station</h4><life-cycle-drop-down class=base-station-drop-down title=\"Select Base Station\" list=$ctrl.baseStations form-data=baseStation form-data-key=id></life-cycle-drop-down><div class=\"x-flex life-cycle-container\"><life-cycle-drop-down class=life-cycle-drop-down title=\"Change life cycle state to\" list=$ctrl.lifeCycleState form-data=baseStation form-data-key=lifeCycleState></life-cycle-drop-down><button type=submit class=\"btn btn-dark\">update base station</button></div></form></div><hr><div class=box><form ng-submit=$ctrl.updateBoxLifeCycle(box)><h4>Change the life cycle for a specific batch number</h4><div class=\"x-flex x-align-center box-number\"><p>Select batch number</p><input type=text class=form-control id=box-name ng-model=box.id placeholder=\"batch number\"></div><div class=\"x-flex life-cycle-container\"><life-cycle-drop-down class=life-cycle-drop-down title=\"Change life cycle state to\" list=$ctrl.lifeCycleState form-data=box form-data-key=lifeCycleState></life-cycle-drop-down><button type=submit class=\"btn btn-dark\">update base station</button></div></form></div></div><div class=loading-cover ng-show=\"$ctrl.isSensorListLoading || $ctrl.isBaseStationListLoading\"><loading-bar></loading-bar></div>");
$templateCache.put("app/views/hardware/sensors/sensors.html","<ui-view><div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>Sensors</h2></div><div class=\"col-sm-6 text-right\"><!-- <a class=\"btn btn-sm btn-primary\" ng-click=\"showForm = (showForm === \'sensor\' ? \'\' : \'sensor\')\">Add new sensor</a> --> <a class=\"btn btn-sm btn-primary\" ui-sref=hardware.newSensor>Add new sensor</a><save-status-inline status=status style=\"display: inline-block\"></save-status-inline><a class=\"btn btn-sm btn-info\" ng-click=\"inlineEdit=!inlineEdit\">inline edit</a></div></div></div><div class=panel-body><sensor-list sensors=sensors cows=cows base-stations=baseStations farms=farms selectable=true selectable=true selected-sensors=selectedSensors details=\"(inlineEdit ? editDetails : details)\" ng-init=\"details={\n        headingMinimal:       false,\n        NodeID:               \'col-xs-1\',\n        deviceSerialNum:      \'col-xs-3\',\n        deviceName:           \'col-xs-1\',\n        baseStation:          \'col-xs-2\',\n        deployed:             \'col-xs-2\',\n        lifeCycleState: \'col-xs-3\'}; editDetails={\n          headingMinimal:           false,\n          NodeID:                   \'col-xs-1\',\n          deviceSerialNumInput:     \'col-xs-3\',\n          baseStationSelect:        \'col-xs-3\',\n          cowSelect:                \'col-xs-3\',\n          deviceDMLastPingTime:     \'col-xs-2\'}\"></sensor-list></div></div></ui-view>");
$templateCache.put("app/views/insight/editInsight/editInsight.html","<div class=\"content container\"><div class=\"panel panel-default\"><div class=panel-heading><h2>Edit Insight</h2></div><div class=panel-body><insight-details-form insight=$ctrl.insight></insight-details-form><!-- <div class=\"row\"> --><!-- <div class=\"form-group col-sm-6\">\n          <p>\n            <button type=\"submit\" class=\"btn btn-block btn-danger\" ng-click=\"$ctrl.delete()\">delete</button>\n          </p>\n        </div> --><!-- <div class=\"form-group col-sm-6\"> --><p><button type=submit class=\"btn btn-block btn-success\" ng-click=$ctrl.update()>update</button></p><!-- </div>\n      </div> --><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div></div></div>");
$templateCache.put("app/views/insights/estrusInsightCurating/estrusInsightCurating.html","<div class=page-panel><div ng-if=\"$ctrl.insightsOffset === null\"><div class=\"container text-center\"><div class=row><div class=\"col-sm-6 col-sm-offset-3\"><div ng-show=$ctrl.progress><h2>{{$ctrl.progress.percentageDone}}% complete!</h2>{{$ctrl.progress.done}} are checked, another {{$ctrl.progress.todo}} estrus insights to go</div><h3>Select you name to start</h3><div class=form-group><select class=\"form-control no-animate\" ng-model=$ctrl.insightsOffset ng-options=\"player.id as player.name for player in $ctrl.players track by player.id\" ng-change=$ctrl.nextLabel()></select></div></div></div><div class=small><a class=no-animate ng-if=!$ctrl.advancedSettings ng-click=\"$ctrl.advancedSettings=true\">filter</a></div><div class=row ng-if=$ctrl.advancedSettings><div class=\"col-sm-6 col-sm-offset-3\"><select class=\"form-control no-animate\" placeholder=\"Select farm\" ng-model=$ctrl.farm ng-options=\"farm.FarmID as farm.farmName for farm in $ctrl.farms track by farm.FarmID\" ng-change=$ctrl.getToDoStatus()><option value=\"\">filter on farm</option></select></div></div></div></div><section ng-if=\"$ctrl.label && $ctrl.insightsOffset !== null\"><label-details-form label=$ctrl.label limited-tags=$ctrl.tags themed-header=$ctrl.themedHeader hide-fields=$ctrl.hideFields form-style=$ctrl.formStyle class=text-center></label-details-form><div class=container><div class=page-panel-content><div class=\"alert alert-info\" role=alert ng-if=\"$ctrl.label.labelScope === \'cow\' && !$ctrl.label.dairyCowID\">{{\'Please select a cow\' | translate}}</div><div class=form-group><div class=row><div class=col-sm-2><button type=submit class=\"btn btn-block btn-danger\" ng-click=$ctrl.exit()>exit</button></div><div class=\"col-sm-2 col-sm-offset-2\"><button type=submit class=\"btn btn-block btn-warning\" ng-click=$ctrl.noEstrusFound()>no estrus found</button></div><div class=col-sm-2><button type=submit class=\"btn btn-block btn-gray\" ng-click=$ctrl.skipLabel()>skip</button></div><div class=col-sm-4><button type=submit class=\"btn btn-block btn-success\" ng-click=$ctrl.saveAndNext()>save &amp; next</button></div></div></div></div></div></section><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div>");
$templateCache.put("app/views/insights/estrusInsights/estrusInsights.html","<div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>Recent estrus insights without an admin validation</h2></div><div class=col-sm-3><select class=\"form-control no-animate\" placeholder=\"Select farm\" ng-model=$ctrl.farm ng-options=\"farm.FarmID as farm.farmName for farm in $ctrl.farms track by farm.FarmID\" ng-change=$ctrl.getInsights()><option value=\"\">filter on farm</option></select></div><div class=col-sm-3><select class=\"form-control no-animate\" ng-model=$ctrl.insightsPerPage ng-options=\"\'check last \'+option+\' insights\' for option in $ctrl.insightsPerPageOptions\" ng-change=$ctrl.getInsights()></select></div></div></div><div class=panel-body><div><div class=\"table-list table-list-md\"><div class=\"alert alert-info alert-sm\" ng-show=\"$ctrl.insights.length === 0 && !$ctrl.loading\">No insights found</div><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div><div class=table-list-heading ng-hide=\"!$ctrl.insights.length && !$ctrl.loading\"><div class=row><div class=\"col-sm-3 col-xs-6\" ng-click=\"$ctrl.sortBy(\'farmID\')\" ng-class=\"($ctrl.sortedBy === \'farmID\' ? \'strong\' : \'\')\">Farm</div><div class=col-xs-6 ng-click=\"$ctrl.sortBy(\'insightTitle\')\" ng-class=\"($ctrl.sortedBy === \'insightTitle\' ? \'strong\' : \'\')\">Title</div><div class=\"col-sm-3 hidden-xs\" ng-click=\"$ctrl.sortBy(\'createdEpoch\')\" ng-class=\"($ctrl.sortedBy === \'createdEpoch\' ? \'strong\' : \'\')\">Created</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"insight in $ctrl.insights\"><div class=row ng-click=$ctrl.onInsightClicked(insight.GenericInsightID) role=button><div class=\"col-sm-3 col-xs-6\"><span ng-repeat=\"farm in $ctrl.farms | filter : {FarmID : insight.farmID} : true\">{{farm.farmName}}</span></div><div class=\"col-sm-6 col-xs-6\"><span ng-if=insight.dairyCowID>#{{insight.dairyCow.cowTagNumber}} </span>{{insight.insightTitle | translate}}</div><div class=\"col-sm-3 hidden-xs\"><span am-time-ago=insight.createdEpoch*1000 class=small></span></div></div><!-- .row --></div><!-- .table-list-item ng-repeat=\"farm in $ctrl.farms --></div><!-- .table-list-items --></div><!-- .table-list-md --></div></div></div>");
$templateCache.put("app/views/insights/estrusLabelCurating/estrusLabelCurating.html","<div class=page-panel><div ng-if=\"$ctrl.labelsOffset === null\"><div class=\"container text-center\"><div class=row><div class=\"col-sm-6 col-sm-offset-3\"><div ng-show=$ctrl.progress><h2>{{$ctrl.progress.percentageDone}}% complete!</h2>{{$ctrl.progress.done}} are checked, another {{$ctrl.progress.todo}} labels to go</div><h3>Select you name to start</h3><div class=form-group><select class=\"form-control no-animate\" ng-model=$ctrl.labelsOffset ng-options=\"player.id as player.name for player in $ctrl.players track by player.id\" ng-change=$ctrl.nextLabel()></select></div></div><div class=\"col-sm-12 small\"><a class=no-animate ng-if=!$ctrl.advancedSettings ng-click=\"$ctrl.advancedSettings=true\">filters</a></div></div><div class=row ng-if=$ctrl.advancedSettings><div class=\"col-xs-6 col-xs-offset-3\"><select class=\"form-control no-animate\" placeholder=\"Select farm\" ng-model=$ctrl.farm ng-options=\"farm.FarmID as farm.farmName for farm in $ctrl.farms track by farm.FarmID\" ng-change=$ctrl.getToDoStatus()><option value=\"\">filter on farm</option></select></div><div class=\"col-xs-3 hidden\"><input class=\"form-control no-animate\" placeholder=\"Search title\" ng-model=$ctrl.title ng-change=$ctrl.getToDoStatus()></div></div></div></div><section ng-if=\"$ctrl.label && $ctrl.labelsOffset !== null\"><label-details-form label=$ctrl.label limited-tags=$ctrl.tags themed-header=$ctrl.themedHeader hide-fields=$ctrl.hideFields form-style=$ctrl.formStyle class=text-center></label-details-form><div class=container><div class=page-panel-content><div class=\"alert alert-info\" role=alert ng-if=\"$ctrl.label.labelScope === \'cow\' && !$ctrl.label.dairyCowID\">{{\'Please select a cow\' | translate}}</div><div class=form-group><div class=row><div class=col-sm-2><button type=submit class=\"btn btn-block btn-danger\" ng-click=$ctrl.exit()>exit</button></div><div class=\"col-sm-2 col-sm-offset-2\"><button type=submit class=\"btn btn-block btn-warning\" ng-click=$ctrl.noEstrusFound()>no estrus found</button></div><div class=col-sm-2><button type=submit class=\"btn btn-block btn-gray\" ng-click=$ctrl.skipLabel()>skip</button></div><div class=col-sm-4><button type=submit class=\"btn btn-block btn-success\" ng-click=$ctrl.saveAndNext()>save &amp; next</button></div></div></div></div></div></section><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div>");
$templateCache.put("app/views/insights/healthLabelCurating/healthLabelCurating.html","<div class=page-panel><div ng-if=\"$ctrl.labelsOffset === null\"><div class=\"container text-center\"><div class=row><div class=\"col-sm-6 col-sm-offset-3\"><div ng-show=$ctrl.progress><h2>{{$ctrl.progress.percentageDone}}% complete!</h2>{{$ctrl.progress.done}} are checked, another {{$ctrl.progress.todo}} labels to go</div><h3>Select you name to start</h3><div class=form-group><select class=\"form-control no-animate\" ng-model=$ctrl.labelsOffset ng-options=\"player.id as player.name for player in $ctrl.players track by player.id\" ng-change=$ctrl.nextLabel()></select></div></div><div class=\"col-sm-12 small\"><a class=no-animate ng-if=!$ctrl.advancedSettings ng-click=\"$ctrl.advancedSettings=true\">filters</a></div></div><div class=row ng-if=$ctrl.advancedSettings><div class=\"col-xs-6 col-xs-offset-3\"><select class=\"form-control no-animate\" placeholder=\"Select farm\" ng-model=$ctrl.farm ng-options=\"farm.FarmID as farm.farmName for farm in $ctrl.farms track by farm.FarmID\" ng-change=$ctrl.getToDoStatus()><option value=\"\">filter on farm</option></select></div><div class=\"col-xs-3 hidden\"><input class=\"form-control no-animate\" placeholder=\"Search title\" ng-model=$ctrl.title ng-change=$ctrl.getToDoStatus()></div></div></div></div><section ng-if=\"$ctrl.label && $ctrl.labelsOffset !== null\"><label-details-form label=$ctrl.label limited-tags=$ctrl.tags themed-header=$ctrl.themedHeader hide-fields=$ctrl.hideFields form-style=$ctrl.formStyle class=text-center></label-details-form><div class=container><div class=page-panel-content><div class=\"alert alert-info\" role=alert ng-if=\"$ctrl.label.labelScope === \'cow\' && !$ctrl.label.dairyCowID\">{{\'Please select a cow\' | translate}}</div><div class=form-group><div class=row><div class=col-sm-2><button type=submit class=\"btn btn-block btn-danger\" ng-click=$ctrl.exit()>exit</button></div><div class=\"col-sm-2 col-sm-offset-2\"><button type=submit class=\"btn btn-block btn-warning\" ng-click=$ctrl.noBehaviourChangeFound()>No behavior change found</button></div><div class=col-sm-2><button type=submit class=\"btn btn-block btn-gray\" ng-click=$ctrl.skipLabel()>skip</button></div><div class=col-sm-4><button type=submit class=\"btn btn-block btn-success\" ng-click=$ctrl.saveAndNext()>save &amp; next</button></div></div></div></div></div></section><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div>");
$templateCache.put("app/views/insights/insightAccuracy/insightAccuracy.html","<div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-sm-12><h2>Insight Accuracy</h2></div></div></div><ui-view class=panel-body><iframe class=iframe-accuracy ng-src=https://insights.connecterra.io/accuracy frameborder=0></iframe></ui-view></div>");
$templateCache.put("app/views/insights/insightModels/insightModels.html","<div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>Insight Models</h2></div><div class=\"col-sm-6 text-right\"><a class=\"btn btn-sm btn-primary\" ui-sref=insights.insightModels.new>new insight model</a></div></div></div><ui-view class=panel-body><insight-models-list insight-models=$ctrl.insightModels insight-types=$ctrl.insightTypes></insight-models-list></ui-view></div>");
$templateCache.put("app/views/insights/insightTypes/insightTypes.html","<div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>Insight Types</h2></div><div class=\"col-sm-6 text-right\"><a class=\"btn btn-sm btn-primary\" ui-sref=insights.insightTypes.new>new insight type</a></div></div></div><ui-view class=panel-body><insight-types-list insight-types=$ctrl.insightTypes></insight-types-list></ui-view></div>");
$templateCache.put("app/views/insights/labelCurating/labelCurating.html","<div class=page-panel><div ng-if=\"$ctrl.labelsOffset === null\"><div class=\"container text-center\"><div class=row><div class=\"col-sm-6 col-sm-offset-3\"><div ng-show=$ctrl.progress><h2>{{$ctrl.progress.percentageDone}}% complete!</h2>{{$ctrl.progress.done}} are checked, another {{$ctrl.progress.todo}} labels to go</div><h3>Select you name to start</h3><div class=form-group><select class=\"form-control no-animate\" ng-model=$ctrl.labelsOffset ng-options=\"player.id as player.name for player in $ctrl.players track by player.id\" ng-change=$ctrl.nextLabel()></select></div></div><div class=\"col-sm-12 small\"><a class=no-animate ng-if=!$ctrl.advancedSettings ng-click=\"$ctrl.advancedSettings=true\">filters</a></div></div><div class=row ng-if=$ctrl.advancedSettings><div class=\"col-xs-6 col-xs-offset-3\"><select class=\"form-control no-animate\" placeholder=\"Select farm\" ng-model=$ctrl.farm ng-options=\"farm.FarmID as farm.farmName for farm in $ctrl.farms track by farm.FarmID\" ng-change=$ctrl.getToDoStatus()><option value=\"\">filter on farm</option></select></div><div class=\"col-xs-3 hidden\"><input class=\"form-control no-animate\" placeholder=\"Search title\" ng-model=$ctrl.title ng-change=$ctrl.getToDoStatus()></div></div></div></div><section ng-if=\"$ctrl.label && $ctrl.labelsOffset !== null\"><label-details-form label=$ctrl.label limited-tags=$ctrl.tags themed-header=$ctrl.themedHeader hide-fields=$ctrl.hideFields form-style=$ctrl.formStyle class=text-center></label-details-form><div class=container><div class=page-panel-content><div class=\"alert alert-info\" role=alert ng-if=\"$ctrl.label.labelScope === \'cow\' && !$ctrl.label.dairyCowID\">{{\'Please select a cow\' | translate}}</div><div class=form-group><div class=row><div class=col-sm-2><button type=submit class=\"btn btn-block btn-danger\" ng-click=$ctrl.exit()>exit</button></div><div class=\"col-sm-2 col-sm-offset-2\"><button type=submit class=\"btn btn-block btn-warning\" ng-click=$ctrl.noEstrusFound()>no estrus found</button></div><div class=col-sm-2><button type=submit class=\"btn btn-block btn-gray\" ng-click=$ctrl.skipLabel()>skip</button></div><div class=col-sm-4><button type=submit class=\"btn btn-block btn-success\" ng-click=$ctrl.saveAndNext()>save &amp; next</button></div></div></div></div></div></section><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div>");
$templateCache.put("app/views/insights/labelsExplorer/labelsExplorer.html","<div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-xs-3><select class=\"form-control no-animate\" placeholder=\"Select farm\" ng-model=$ctrl.farm ng-options=\"farm.FarmID as farm.farmName for farm in $ctrl.farms track by farm.FarmID\" ng-change=$ctrl.getLabels()><option value=\"\">filter on farm</option></select></div><div class=col-xs-3><input class=\"form-control no-animate\" placeholder=\"Search title\" ng-model=$ctrl.title ng-change=$ctrl.getLabelsDebounce()></div><div class=col-xs-2><select class=\"form-control no-animate\" placeholder=\"Select tag\" ng-model=$ctrl.tag ng-options=\"tag for tag in $ctrl.tags\" ng-change=$ctrl.getLabels()><option value=\"\">filter on tag</option></select></div><div class=col-xs-2><select class=\"form-control no-animate\" ng-model=$ctrl.labelsPerPage ng-options=\"\'query for \'+option+\' labels\' for option in $ctrl.labelsPerPageOptions\" ng-change=$ctrl.getLabels()></select></div><div class=col-xs-2><button class=\"btn btn-primary btn-block\" ng-click=$ctrl.getLabels()><span class=\"glyphicon glyphicon-refresh\" aria-hidden=true></span> <span ng-show=$ctrl.autoRefresh>{{$ctrl.refreshTimer}}...</span></button><label for=autoRefresh><input type=checkbox id=autoRefresh ng-model=$ctrl.autoRefresh>auto refresh</label></div></div></div><div class=pull-right><strong ng-if=$ctrl.labels.length>{{$ctrl.labels.length}} Labels returned</strong></div><div class=panel-body><div style=\"position: relative\"><div class=\"table-list table-list-md\"><div class=\"alert alert-info alert-sm\" ng-show=\"$ctrl.labels.length === 0 && !$ctrl.loading\">No labels found</div><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div><div class=table-list-heading ng-hide=\"!$ctrl.labels.length && !$ctrl.loading\"><div class=row><div class=\"col-sm-3 col-xs-4\" ng-click=\"$ctrl.sortBy(\'farmID\')\" ng-class=\"($ctrl.sortedBy === \'farmID\' ? \'strong\' : \'\')\">Farm</div><div class=\"col-sm-3 col-xs-4\" ng-click=\"$ctrl.sortBy(\'title\')\" ng-class=\"($ctrl.sortedBy === \'title\' ? \'strong\' : \'\')\">Title</div><div class=\"col-sm-3 col-xs-2\" ng-click=\"$ctrl.sortBy(\'tags\')\" ng-class=\"($ctrl.sortedBy === \'tags\' ? \'strong\' : \'\')\">Tags</div><div class=\"col-sm-2 hidden-xs\" ng-click=\"$ctrl.sortBy(\'createdEpoch\')\" ng-class=\"($ctrl.sortedBy === \'createdEpoch\' ? \'strong\' : \'\')\">Created</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"label in $ctrl.labels\"><div class=row ng-click=$ctrl.onLabelClicked(label.GenericLabelID) role=button><div class=\"col-sm-3 col-xs-4\"><span ng-repeat=\"farm in $ctrl.farms | filter : {FarmID : label.farmID} : true\">{{farm.farmName}}</span></div><div class=\"col-sm-3 col-xs-4\"><span ng-if=label.dairyCowID>#{{label.dairyCow.cowTagNumber}} </span>{{label.title}}</div><div class=\"col-sm-3 col-xs-2\" style=padding-bottom:0px><span class=pil ng-repeat=\"tag in label.tags\">{{tag}}</span></div><div class=\"col-sm-2 hidden-xs\"><span am-time-ago=label.createdEpoch*1000 class=small data-toggle=tooltip data-placement=top title=\"createdEpoch: {{label.createdEpoch}}\"></span></div></div><!-- .row --></div><!-- .table-list-item ng-repeat=\"farm in $ctrl.farms --></div><!-- .table-list-items --></div><!-- .table-list-md --></div></div></div>");
$templateCache.put("app/views/main/sensorsSummary/sensorsSummary.html","<div class=gray><div ng-if=$ctrl.sensors.length><span ng-if=$ctrl.liveConnectedSensors class=color-success data-toggle=tooltip data-placement=top title=\"Sensors linked to cows that pinged in the past 24 hours\">{{$ctrl.liveConnectedSensors.length}}</span> <span ng-if=$ctrl.offlineConnectedSensors.length>| <span class=color-danger data-toggle=tooltip data-placement=top title=\"Sensors linked to cows that haven\'t pinged the past 24 hours\">{{$ctrl.offlineConnectedSensors.length}}</span></span> <span ng-if=$ctrl.unconnectedSensors.length>| <span data-toggle=tooltip data-placement=top title=\"Sensors not linked to a cow\">{{$ctrl.unconnectedSensors.length}}</span></span> <span ng-if=\"$ctrl.showTotal && ($ctrl.offlineConnectedSensors.length || $ctrl.unconnectedSensors.length)\">| <span class=color-primary data-toggle=tooltip data-placement=top title=\"Total sensors on farms\">{{$ctrl.sensors.length}}</span></span></div><loading-spinner ng-if=$ctrl.loading class=inline-block></loading-spinner></div>");
$templateCache.put("app/views/main/systemMonitorsPanel/systemMonitorsPanel.html","<div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-xs-8><h2>System Status</h2></div><div class=\"col-xs-4 text-right\"><h6><a ng-click=refreshMonitorStates()>refresh <span class=\"glyphicon glyphicon-refresh\" aria-hidden=true></span></a></h6></div></div></div><div class=panel-body><system-monitors-map farms=farms monitors=monitors></system-monitors-map><div class=table-list><div class=table-list-heading><div class=row><div class=col-xs-6>Monitor</div><div class=col-xs-3><a ng-click=\"showAllSensors=true\">load all sensor pings</a></div><div class=\"col-xs-3 text-right\">Passrate</div></div></div><div class=table-list-items><system-monitor-parent ng-repeat=\"mainMonitor in monitors\" monitor=mainMonitor success-threshold=successThreshold warning-threshold=warningThreshold></system-monitor-parent></div></div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div></div><div class=small><h6>Legend</h6><span class=\"bullet bullet-success\"></span> Success rate &gt;= {{successThreshold}}%<br><span class=\"bullet bullet-warning\"></span> Success rate &gt;= {{warningThreshold}}%<br><span class=\"bullet bullet-danger\"></span> Success rate &lt; {{warningThreshold}}%</div><br><div class=small><h6>Ignored/Retired Farms</h6><ul><li ng-repeat=\"farm in ignoredFarms\">{{farm.farmName}}</li></ul></div></div><!-- .panel -->");
$templateCache.put("app/views/accountManagement/cowSensorBatch/cowSensorBatchForm/cowSensorBatchForm.html","<form ng-submit=newCow() data-toggle=validator><cow-details-form-fields cow=newCowObj herd-groups=herdGroups farms=farms></cow-details-form-fields><div class=row><div class=col-sm-6><div class=form-group ng-show=!batchCreate><label for=batchSize>Create a batch of cows?</label><select class=form-control id=batchSize ng-model=batchSize ng-options=\"n for n in [] | range:1:100\"></select></div></div><div class=col-sm-6><div class=form-group><label>&nbsp;</label><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_CREATE\" | translate}}</button></div></div></div><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div></form>");
$templateCache.put("app/views/accountManagement/cows/newCowForm/newCowForm.html","<form ng-submit=newCow() data-toggle=validator><cow-details-form-fields cow=newCowObj herd-groups=herdGroups farms=farms></cow-details-form-fields><div class=row><div class=col-sm-6><div class=form-group ng-show=!batchCreate><label for=batchSize>Create a batch of cows?</label><select class=form-control id=batchSize ng-model=batchSize ng-options=\"n for n in [] | range:1:100\"></select></div></div><div class=col-sm-6><div class=form-group><label>&nbsp;</label><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_CREATE\" | translate}}</button></div></div></div><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div></form>");
$templateCache.put("app/views/accountManagement/customers/customerList/customerList.html","<div class=\"table-list table-list-md\"><div class=\"alert alert-info alert-sm\" ng-show=\"customers.length === 0 && !loading\">No customers found</div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div><div class=\"table-list-heading table-list-heading-minimal\" ng-hide=\"!customers.length && !loading\"><div class=row><div class=\"col-xs-6 col-sm-4\">Customer</div><div class=\"col-xs-6 col-sm-8\">Farm(s)</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"customer in customers\" ng-class=\"($parent.currentListItem === customer.CustomerID ? \'active\' : \'\')\"><div class=row ng-click=\"($parent.currentListItem === customer.CustomerID ? $parent.currentListItem = null : $parent.currentListItem = customer.CustomerID )\" role=button><div class=\"col-xs-6 col-sm-4\"><code>#{{customer.CustomerID}}</code> <strong>{{customer.customerName}}</strong></div><div class=\"col-xs-6 col-sm-8\"><span ng-repeat=\"farm in farms | filter : {customerID : customer.CustomerID} : true\">{{farm.farmName}}</span></div><div class=table-list-item-expand-btn role=button ng-click=toggleDetails(sensor.NodeID)></div></div><div class=\"row table-list-detail\" ng-if=\"$parent.currentListItem === customer.CustomerID\"><div class=col-sm-12><customer-details-form-fields customer=customer users=users></customer-details-form-fields><customer-users-form customer=customer users=users status=status></customer-users-form></div><div class=col-sm-12><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=delete(customer)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button> <button type=button class=\"btn btn-sm btn-wide btn-success\" ng-click=update(customer)><i class=\"fa fa-floppy-o\" aria-hidden=true></i> Save</button><save-status-inline status=status></save-status-inline></p></div></div><!-- <div class=\"col-sm-4\" ng-repeat=\"(key, value) in customer\">\n          <div class=\"form-group\">\n            <label>{{key}}</label>\n            <p>{{value}}</p>\n          </div>\n        </div> --></div><!-- .table-list-detail --></div><!-- .table-list-item --></div><!-- .table-list-items --></div>");
$templateCache.put("app/views/accountManagement/customers/newCustomerForm/newCustomerForm.html","<form ng-submit=newCustomer() data-toggle=validator><customer-details-form-fields customer=newCustomerObj users=users></customer-details-form-fields><div class=form-group><label for=primaryUserID class=control-label>Primary User*</label><select class=form-control id=primaryUserID ng-model=primaryUser ng-options=\"user as (user.email) for user in users\" required><option value=\"\">Select user</option></select></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_CREATE\" | translate}}</button></div><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div></form>");
$templateCache.put("app/views/accountManagement/farms/farm/farm.html","<div class=container-fluid><div class=\"panel panel-with-section-nav\"><div class=panel-heading><h2><a href=#!/account-management/farms class=back-arrow></a> {{farm.farmName}}</h2><div class=section-nav role=navigation><ul class=\"nav navbar-nav\"><li ng-class=\"($parent.currentSection === item.sectionID ? \'active\' : \'\')\" ng-repeat=\"item in sectionNavItems\"><a ng-click=\"$parent.currentSection = item.sectionID\">{{item.title}}</a></li></ul></div><!-- .subnav --></div><div class=panel-body><farm-details-panel ng-if=\"currentSection === \'farmDetails\'\" farm=farm></farm-details-panel><hardware-panel ng-if=\"currentSection === \'hardware\'\" farm-id=farm.FarmID></hardware-panel><livestock-panel ng-if=\"currentSection === \'livestock\'\" farm-id=farm.FarmID></livestock-panel></div></div></div>");
$templateCache.put("app/views/accountManagement/farms/farmList/farmList.html","<div class=\"table-list table-list-md\"><div class=\"alert alert-info alert-sm\" ng-show=\"farms.length === 0 && !loading\">No farms found</div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div><div class=\"table-list-heading table-list-heading-minimal\" ng-hide=\"!farms.length && !loading\"><div class=row><div class=\"col-xs-6 col-sm-4\">Farm</div><div class=\"col-xs-6 col-sm-8\">Customer</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"farm in farms\" ng-class=\"($parent.currentListItem === farm.FarmID ? \'active\' : \'\')\"><div class=row role=button><div ng-click=goToFarm(farm.FarmID) class=\"col-xs-5 col-sm-4\"><code>#{{farm.FarmID}}</code> <strong>{{farm.farmName}}</strong></div><div ng-click=goToFarm(farm.FarmID) class=\"col-xs-5 col-sm-7\"><span ng-repeat=\"customer in customers | filter : {CustomerID : farm.customerID} : true\">{{ customer.customerName }} <span></span></span></div><div class=table-list-item-expand-btn ng-click=\"($parent.currentListItem === farm.FarmID ? $parent.currentListItem = null : $parent.currentListItem = farm.FarmID )\"></div></div><div class=\"row table-list-detail\" ng-if=\"$parent.currentListItem === farm.FarmID\"><div class=col-sm-4 ng-repeat=\"(key, value) in farm\"><div class=form-group><label>{{key}}</label><p>{{value}}</p></div></div><div class=col-sm-12><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=delete(farm)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button></p></div></div></div><!-- .table-list-detail --></div><!-- .table-list-item --></div><!-- .table-list-items --></div>");
$templateCache.put("app/views/accountManagement/farms/newFarmForm/newFarmForm.html","<form ng-submit=newFarm() data-toggle=validator><farm-details-form-fields farm=newFarmObj></farm-details-form-fields><div class=form-group><label for=customerID>Customer*</label><select class=form-control id=customerID ng-model=newFarmObj.customerID ng-options=\"customer.CustomerID as (customer.customerName) for customer in customers\" required></select></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_CREATE\" | translate}}</button></div><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div></form>");
$templateCache.put("app/views/accountManagement/roles/newRoleForm/newRoleForm.html","<form ng-submit=newRole() data-toggle=validator><div class=form-group><label for=name>Name</label><input type=text class=form-control id=name ng-model=newRoleObj.name required></div><div class=form-group><label for=description>Description</label><input type=text class=form-control id=description ng-model=newRoleObj.description required></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_CREATE\" | translate}}</button></div><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div></form>");
$templateCache.put("app/views/accountManagement/roles/roleList/roleList.html","<div class=\"table-list table-list-md\"><div class=loading-cover ng-show=!roles.length><loading-bar></loading-bar></div><div class=\"table-list-heading table-list-heading-minimal\" ng-hide=!roles.length><div class=row><div class=col-xs-4>Name</div><div class=col-xs-8>Description</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"role in roles\" ng-class=\"($parent.currentListItem === role.id ? \'active\' : \'\')\"><div class=row ng-click=\"($parent.currentListItem === role.id ? $parent.currentListItem = null : $parent.currentListItem = role.id )\" role=button><div class=col-xs-4><strong>{{role.name}}</strong></div><div class=col-xs-8>{{role.description}}</div><div class=table-list-item-expand-btn></div></div><div class=\"row table-list-detail\" ng-if=\"$parent.currentListItem === role.id\"><div class=col-sm-4 ng-repeat=\"(key, value) in role\"><div class=form-group><label>{{key}}</label><p>{{value}}</p></div></div><div class=col-sm-12><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=deleteRole(role)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button></p></div></div></div><!-- .table-list-detail --></div><!-- .table-list-item --></div></div>");
$templateCache.put("app/views/accountManagement/users/newUserForm/newUserForm.html","<form ng-submit=newUser() data-toggle=validator><user-details-form user=newUserObj on-change=updateUser(user)></user-details-form><div class=form-group><label for=password>{{\"LABEL_TEXT_PASSWORD\" | translate}}*</label><input ng-hide=showPassword type=password class=\"no-animate form-control\" id=password name=password placeholder=\"{{\'LABEL_TEXT_PASSWORD\' | translate}}\" ng-model=newUserObj.password ng-blur=updateUser(newUserObj) required> <input ng-show=showPassword type=text class=\"no-animate form-control\" id=password name=password placeholder=\"{{\'LABEL_TEXT_PASSWORD\' | translate}}\" ng-model=newUserObj.password ng-blur=updateUser(newUserObj) required><div ng-init=\"showPassword=true\" ng-click=\"showPassword=!showPassword\" class=text-right><a><i class=fa ng-class=\"(showPassword ? \'fa-eye-slash\' : \'fa-eye\')\" aria-hidden=true></i> {{(showPassword ? \"BUTTON_TEXT_HIDE_PASSWORD\" : \"BUTTON_TEXT_SHOW_PASSWORD\") | translate}}</a></div></div><password-strength password=newUserObj.password password-passed=passwordChecksPassed></password-strength><div class=form-group><button type=submit class=\"btn btn-primary btn-block btn-lg\" ng-disabled=!allUserChecksPassed>Create user</button></div></form>");
$templateCache.put("app/views/accountManagement/users/userDetailsForm/userDetailsForm.html","<div class=row><div class=col-sm-6><div class=form-group><label for=firstName>First Name</label><input type=text class=form-control id=firstName name=firstName ng-model=$ctrl.user.givenName ng-blur=$ctrl.updateUser()></div></div><div class=col-sm-6><div class=form-group><label for=lastName>Last Name</label><input type=text class=form-control id=lastName name=lastName ng-model=$ctrl.user.surName ng-blur=$ctrl.updateUser()></div></div></div><div class=row><div class=col-sm-6><div class=form-group><label for=email>{{\"LABEL_TEXT_EMAIL\" | translate}}*</label><input type=email class=form-control id=email name=email placeholder=\"{{\'LABEL_TEXT_EMAIL\' | translate}}\" ng-model=$ctrl.user.email ng-blur=$ctrl.updateUser() required><label for=emailConfirmed><input type=checkbox name=emailConfirmed id=emailConfirmed ng-model=$ctrl.user.emailConfirmed ng-change=$ctrl.updateUser()> Email Confirmed</label></div></div><div class=col-sm-6><div class=form-group><label for=phoneNumber>Phone Number</label><input type=tel class=form-control id=phoneNumber name=phoneNumber ng-model=$ctrl.user.phoneNumber ng-blur=$ctrl.updateUser()></div></div></div><div class=row><div class=col-sm-6><user-roles-form roles-list=$ctrl.user.rolesList on-change=$ctrl.updateUserRoles(rolesList)></user-roles-form></div><div class=col-sm-6><div class=form-group><label for=userPreferences>User Preferences</label><textarea class=form-control id=userPreferences name=userPreferences ng-model=$ctrl.user.userPreferences ng-blur=$ctrl.updateUser() rows=6></textarea></div></div></div><div class=form-group><label for=customerID>Customer<span ng-if=$ctrl.needsCustomer()>*</span></label><select class=form-control id=customerID ng-model=$ctrl.user.customerID ng-options=\"customer.CustomerID as (customer.customerName) for customer in $ctrl.customers\" ng-change=$ctrl.updateUser() ng-required=$ctrl.needsCustomer()></select></div>");
$templateCache.put("app/views/accountManagement/users/userList/userList.html","<div class=\"table-list table-list-md\"><div class=loading-cover ng-show=!users.length><loading-bar></loading-bar></div><div class=form-group ng-hide=!users.length><input type=text class=\"form-control input-sm\" ng-model=searchString placeholder=\"Search by email address\"></div><p ng-if=searchString class=appear><strong>{{(users | filter: {email: searchString}).length}} users found</strong></p><div class=\"table-list-heading table-list-heading-minimal\" ng-hide=!users.length><div class=row><div class=col-sm-4>Email</div><div class=\"col-sm-3 hidden-xs\">Name</div><div class=\"col-sm-3 hidden-xs\">Customer</div><div class=\"col-sm-2 hidden-xs\">Role</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"user in users | filter: {email: searchString} : false\" ng-class=\"($parent.currentListItem === user.id ? \'active\' : \'\')\"><div class=row ng-click=\"($parent.currentListItem === user.id ? $parent.currentListItem = null : $parent.currentListItem = user.id )\" role=button><div class=col-sm-4><strong>{{user.email}}</strong></div><div class=\"col-sm-3 hidden-xs\">{{user.givenName}} {{user.surName}}</div><div class=\"col-sm-3 hidden-xs\"><span ng-repeat=\"customer in customers | filter : {CustomerID : user.customerID} : true\">{{ customer.customerName }}</span></div><div class=\"col-sm-1 hidden-xs\"><span ng-repeat=\"role in user.rolesList\" data-toggle=tooltip data-placement=top title={{role}}><i class=\"fa fa-user-o\" aria-hidden=true ng-if=\"role === \'Farmer\'\"></i> <i class=\"fa fa-user-o\" aria-hidden=true ng-if=\"role === \'FarmerEmployee\'\"></i> <i class=\"fa fa-star\" aria-hidden=true ng-if=\"role === \'BetaUser\'\"></i> <i class=\"fa fa-user\" aria-hidden=true ng-if=\"role === \'Admin\'\"></i> <i class=\"fa fa-server\" aria-hidden=true ng-if=\"role === \'Internal\'\"></i> </span><span ng-if=\"(user.LockoutEndDateUtc | minutesFromNow) > 0\" data-toggle=tooltip data-placement=top title=\"User locked out\"><i class=\"fa fa-lock color-danger\"></i> <span am-time-ago=user.LockoutEndDateUtc class=small></span> </span><i class=\"fa fa-envelope-o color-warning\" ng-if=!user.emailConfirmed data-toggle=tooltip data-placement=top title=\"Email unconfirmed\"></i></div><div class=table-list-item-expand-btn></div></div><div class=\"row table-list-detail\" ng-if=\"$parent.currentListItem === user.id\"><div class=col-sm-12><user-details-form user=user></user-details-form></div><div class=col-sm-12><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=deleteUser(user)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button> <button type=button class=\"btn btn-sm btn-wide btn-success\" ng-click=update(user)><i class=\"fa fa-floppy-o\" aria-hidden=true></i> save</button> <button type=button class=\"btn btn-sm btn-wide btn-info\" ng-click=resetPassword(user.email)><i class=\"fa fa-undo\" aria-hidden=true></i> Reset Password</button><save-status-inline status=status class=inline-block></save-status-inline></p></div></div></div><!-- .table-list-detail --></div><!-- .table-list-item --></div></div>");
$templateCache.put("app/views/accountManagement/users/userRolesForm/userRolesForm.html","<div class=\"form-group role-form\"><label for=selectedRole>Roles*</label><div class=role-form-container><label ng-repeat=\"role in $ctrl.roles\" class=role-container><input id=selectedRole type=checkbox name=selectedRoles[] value={{role.name}} ng-checked=\"$ctrl.rolesList.indexOf(role.name) > -1\" ng-click=$ctrl.updateRoles(role.name)> <span>{{role.name}}</span></label></div></div>");
$templateCache.put("app/views/dataExplorer/reports/report/report.html","<div><div class=row><div class=col-sm-3><div class=\"panel panel-default\"><div class=panel-heading><h2>Report options</h2></div><!-- .panel-heading --><div class=panel-body><form class=form><div class=form-group><div class=\"btn-group btn-group-justified\"><a ng-click=$ctrl.onSubjectTypeChange(subjectType) class=\"btn btn-xs\" ng-class=\"($ctrl.subjectType.id === subjectType.id ? \'btn-default\' : \'btn-white\')\" ng-repeat=\"subjectType in $ctrl.subjectTypes\">{{subjectType.title}}</a></div></div><div class=form-group><label>Farm</label><small class=pull-right ng-if=\"$ctrl.subjectType.id === \'farm\'\" class=no-animate><label for=compareFarms><input type=checkbox id=compareFarms ng-model=$ctrl.compareFarms ng-init=\"$ctrl.compareFarms=true\" ng-change=\"$ctrl.selectedFarms=[]; $ctrl.farm=null;\"> compare farms</label></small><select class=\"form-control no-animate\" placeholder=\"Select farm\" multiple size=10 ng-show=\"$ctrl.compareFarms && $ctrl.subjectType.id === \'farm\'\" ng-model=$ctrl.selectedFarms ng-options=\"farm.farmName for farm in $ctrl.farms track by farm.FarmID\" ng-change=$ctrl.setVisualisations()></select><select class=\"form-control no-animate\" placeholder=\"Select farm\" ng-show=\"!$ctrl.compareFarms || $ctrl.subjectType.id !== \'farm\'\" ng-model=$ctrl.farm ng-options=\"farm.farmName for farm in $ctrl.farms track by farm.FarmID\" ng-change=$ctrl.onFarmSelected($ctrl.farm)><option value=\"\">All farms</option></select></div><div class=form-group><div ng-if=\"$ctrl.subjectType.id === \'herdGroup\'\" class=no-animate><label>Group</label><small class=pull-right><label for=compareHerdGroups><input type=checkbox id=compareHerdGroups ng-model=$ctrl.compareHerdGroups ng-init=\"$ctrl.compareHerdGroups=true\" ng-change=\"$ctrl.selectedHerdGroups=[]; $ctrl.herdGroup=null;\"> compare groups</label></small><select class=\"form-control no-animate\" placeholder=\"Select group\" multiple size=10 ng-show=$ctrl.compareHerdGroups ng-model=$ctrl.selectedHerdGroups ng-options=\"herdGroup.groupName for herdGroup in $ctrl.herdGroups track by herdGroup.HerdGroupID\" ng-change=$ctrl.setVisualisations()></select><select class=\"form-control no-animate\" placeholder=\"Select group\" ng-show=!$ctrl.compareHerdGroups ng-model=$ctrl.herdGroup ng-options=\"herdGroup.groupName for herdGroup in $ctrl.herdGroups track by herdGroup.HerdGroupID\" ng-change=$ctrl.onHerdGroupSelected($ctrl.herdGroup)></select></div></div><div class=form-group><div ng-if=\"$ctrl.subjectType.id === \'cow\'\" class=no-animate><label>Cows</label><small class=pull-right><label for=compareCows><input type=checkbox id=compareCows ng-model=$ctrl.compareCows ng-init=\"$ctrl.compareCows=true\" ng-change=\"$ctrl.selectedCows=[]; $ctrl.cow=null;\"> compare cows</label></small><div class=form-group class=no-animate><input type=text name=searchString class=\"form-control input-sm\" ng-model=$ctrl.searchString placeholder=\"Search by cow ID or tag number\" ng-change=$ctrl.updateCowsFilter()></div><select class=\"form-control no-animate\" placeholder=\"Select cow\" multiple size=10 ng-show=$ctrl.compareCows ng-model=$ctrl.selectedCows ng-options=\"cow.cowTagNumber+\' (#\'+cow.DairyCowID+\')\' for cow in $ctrl.filteredCows track by cow.DairyCowID\" ng-change=$ctrl.setVisualisations()></select><select class=\"form-control no-animate\" placeholder=\"Select cow\" ng-show=!$ctrl.compareCows ng-model=$ctrl.cow ng-options=\"cow.cowTagNumber+\' (#\'+cow.DairyCowID+\')\' for cow in $ctrl.filteredCows track by cow.DairyCowID\" ng-change=$ctrl.onCowSelected($ctrl.cow)></select><div class=form-group><label>{{\"Filters\" | translate}}</label><br><label><input type=checkbox id=onlyCowsWithNodes ng-model=$ctrl.onlyCowsWithNodes ng-change=$ctrl.updateCowsFilter() ng-true-value=true ng-false-value=false> {{\"Hide cows without sensor\" | translate}}</label><br><label>{{\"LABEL_TEXT_STATUS\" | translate}}</label><select class=form-control id=cowStatus ng-model=$ctrl.cowStatus ng-options=\"cowStatus.value as (cowStatus.title | translate) for cowStatus in $ctrl.cowStatuses\" ng-change=$ctrl.updateCowsFilter()><option value=\"\" selected>{{\"LABEL_TEXT_SELECT_STATUS\" | translate}}</option></select></div></div></div><div><label><input type=checkbox id=useWindowedStats ng-model=$ctrl.useUnscaledStats ng-change=$ctrl.updateVisualisations()> Use unscaled stats</label></div><div><label><input type=checkbox id=useCustomAggWindow ng-model=$ctrl.useCustomAggWindow ng-change=$ctrl.updateVisualisations()> Custom Agg. Window</label><rzslider ng-if=$ctrl.useCustomAggWindow rz-slider-model=$ctrl.customAgWindow rz-slider-options=$ctrl.agSliderOptions></rzslider></div><div ng-if=$ctrl.useCustomAggWindow><label><input type=checkbox id=useCustomAggInterval ng-model=$ctrl.useCustomAggInterval ng-change=$ctrl.updateVisualisations()> Custom Agg. Interval</label><rzslider ng-if=$ctrl.useCustomAggInterval rz-slider-model=$ctrl.customAgInterval rz-slider-options=$ctrl.agSliderOptions></rzslider></div><div class=form-group ng-repeat=\"group in $ctrl.subjectType.settings\"><label><input type=checkbox ng-model=group.isVisible ng-change=$ctrl.toggleGroup(group) ng-init=\"group.isVisible = $ctrl.isWholeGroupVisible(group)\"> {{ group.name }}</label><select ng-if=group.styles class=input-sm ng-options=\"style for style in group.styles\" ng-model=group.style ng-change=$ctrl.groupStyleChanged(group);></select><div class=checkbox ng-repeat=\"setting in group.settings\"><label><input type=checkbox ng-model=setting.isVisible ng-change=\"$ctrl.updateVisualisations(); group.isVisible = $ctrl.isWholeGroupVisible(group);\"> {{ setting.name }}</label>{{ \" \" }} <a ng-repeat=\"style in setting.styles\" ng-class=\"(setting.style === style ? \'strong\' : \'\')\" ng-click=\"setting.style = style; $ctrl.setVisualisations();\">{{style}}</a> {{ \" \" }}<select ng-if=setting.options.filtering.length class=input-sm ng-options=\"filter as filter.insightType.title for filter in setting.options.filtering\" ng-model=filter ng-change=\"$ctrl.settingFiltersChanged(setting, filter);\"><option value=\"\">Choose an insight type</option></select></div><!-- .checkbox --></div><!-- .form-group --></form></div><!-- .panel-body --></div><!-- .panel --></div><!-- .col-sm-2 --><div class=col-sm-9><div class=\"panel panel-default\"><div class=panel-heading><date-period-selector start-date=$ctrl.startDate end-date=$ctrl.endDate day-range=$ctrl.dayRange day-options=[1,3,7,31,92,183] max-date=$ctrl.maxDate on-date-change=\"$ctrl.onDateChange(startDate, endDate)\" in-view-epoch=$ctrl.nowEpoch></date-period-selector></div><!-- .panel-heading --><div class=panel-body ng-repeat=\"visualisation in $ctrl.visualisations\"><h3><code>#{{visualisation.id}}</code> {{visualisation.title}} <span ng-if=\"visualisation.scope === \'cow\'\" class=\"small gray\"><span ng-if=visualisation.subject.cowStatus>{{ \"COW_STATUS_\"+visualisation.subject.cowStatus | translate}}</span> <span ng-repeat=\"farm in $ctrl.farms | filter: {FarmID: visualisation.subject.farmID} : true\">| {{farm.farmName}}</span></span></h3><ctra-data-visualisation display-values=visualisation.displayValues context-menu=visualisation.contextMenu on-insight-clicked=$ctrl.onInsightClicked(insight) start-date=$ctrl.startDate end-date=$ctrl.endDate on-date-change=\"$ctrl.onDateChange(startDate, endDate)\" class=graph></ctra-data-visualisation></div><!-- .panel-body --></div><!-- .panel --></div></div></div>");
$templateCache.put("app/views/hardware/sensors/newSensor/newSensor.html","<div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>New Sensor</h2></div><div class=\"col-sm-6 text-right\"><save-status-inline status=status style=\"display: inline-block\"></save-status-inline></div></div></div><div class=panel-body><new-sensor-form farm-id=farmId success-callback=sensorAdded(sensors)></new-sensor-form></div></div>");
$templateCache.put("app/views/insight/editInsight/insightDetailsForm/insightDetailsForm.html","<form class=row><!-- <div class=\"col-sm-4\" ng-repeat=\"(key, value) in $ctrl.insight\" ng-if=\"$ctrl.hiddenVariables.indexOf(key) < 0\">\n    <div class=\"form-group\">\n      <label for=\"{{key}}\">{{$ctrl.addSpaces(key)}}</label>\n      <input type=\"text\" class=\"form-control\" id=\"{{key}}\" ng-model=\"$ctrl.insight[key]\" ng-disabled=\"$ctrl.noEditVariables.indexOf(key) > -1\">\n    </div>\n  </div> --><div class=col-sm-12><div class=form-group><label for=insightTitle>Title</label><input type=text class=form-control id=insightTitle ng-model=$ctrl.insight.insightTitle></div><div class=form-group><label for=insightDescription>Description</label><textarea type=text class=form-control id=insightDescription ng-model=$ctrl.insight.insightDescription></textarea></div></div><div class=col-sm-6><div class=form-group><label for=insightState>State</label><select type=text class=form-control id=insightState ng-model=$ctrl.insight.insightState ng-options=\"s as s for s in $ctrl.insightStates\"></select></div></div><div class=col-sm-6><div class=form-group><label for=insightPriority>Priority</label><select type=text class=form-control id=insightPriority ng-model=$ctrl.insight.insightPriority ng-options=\"s as s for s in [1,2,3]\"></select></div></div><div class=col-sm-6><div class=form-group><label for=startEpoch>Start Epoch</label><input type=number class=form-control id=startEpoch ng-model=$ctrl.insight.startEpoch> <small>{{$ctrl.insight.startEpoch | epochsToString}}</small></div></div><div class=col-sm-6><div class=form-group><label for=endEpoch>End Epoch</label><input type=number class=form-control id=endEpoch ng-model=$ctrl.insight.endEpoch> <small>{{$ctrl.insight.endEpoch | epochsToString}}</small></div></div><div class=col-sm-12><div class=form-group><label for=seenByUserIds>Description (comma seperated)</label><textarea type=text class=form-control id=seenByUserIds ng-model=$ctrl.insight.seenByUserIds></textarea></div></div><div class=col-sm-12><div class=form-group><label for=notificationSent><input type=checkbox id=notificationSent ng-model=$ctrl.insight.notificationSent ng-true-value=true ng-false-value=false> Notification sent</label></div></div></form>");
$templateCache.put("app/views/insights/insightModels/insightModelDetailsForm/insightModelDetailsForm.html","<form class=row><div class=col-sm-6><div class=form-group><label for=modelName>Model Name</label><input type=text class=form-control id=insightModelTitle ng-model=$ctrl.insightModel.modelName></div></div><div class=col-sm-6><div class=form-group><label for=version>Version</label><input type=text class=form-control id=version ng-model=$ctrl.insightModel.version></div></div><div class=col-sm-6><div class=form-group><label for=insightTypeID>Insight Type</label><select type=text class=form-control id=insightTypeID ng-model=$ctrl.insightModel.insightTypeID ng-options=\"i.InsightTypeID as i.title for i in $ctrl.insightTypes\"></select></div></div><div class=col-sm-6><div class=form-group><label for=releaseState>Release State</label><select type=text class=form-control id=releaseState ng-model=$ctrl.insightModel.releaseState ng-options=\"releaseState as releaseState for releaseState in $ctrl.releaseStates\"></select></div></div><div class=col-sm-6><div class=form-group><label for=dataQualityThreshold>Data Quality Threshold <small>(0,1 - 1,0)</small></label><input type=number class=form-control id=dataQualityThreshold ng-model=$ctrl.insightModel.dataQualityThreshold></div></div><div class=col-sm-6><div class=form-group><label for=probabilityThreshold>Probability Threshold <small>(0,1 - 1,0)</small></label><input type=number class=form-control id=probabilityThreshold ng-model=$ctrl.insightModel.probabilityThreshold></div></div><div class=col-sm-6><div class=form-group><label for=notificationEnabled><input type=checkbox id=notificationEnabled ng-model=$ctrl.insightModel.notificationEnabled ng-true-value=true ng-false-value=false> Notification Enabled</label></div></div></form>");
$templateCache.put("app/views/insights/insightModels/insightModelsList/insightModelsList.html","<div class=\"table-list table-list-md\"><div class=\"table-list-heading table-list-heading-minimal\"><div class=row><div class=col-xs-3>Model Name</div><div class=col-xs-3>Release State</div><div class=col-xs-3>Version</div><div class=col-xs-3>Insight Type</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"insightModel in $ctrl.insightModels\" ng-class=\"($ctrl.currentListItem === insightModel.InsightModelID ? \'active\' : \'\')\"><div class=row ng-click=\"($ctrl.currentListItem === insightModel.InsightModelID ? $ctrl.currentListItem = null : $ctrl.currentListItem = insightModel.InsightModelID )\" role=button><div class=\"col-xs-3 strong\">{{insightModel.modelName}}</div><div class=col-xs-3>{{insightModel.releaseState}}</div><div class=col-xs-3>{{insightModel.version}}</div><div class=col-xs-3>{{($ctrl.insightTypes | filter : {InsightTypeID: insightModel.insightTypeID})[0].title}}</div><div class=table-list-item-expand-btn></div></div><div class=\"row table-list-detail\" ng-if=\"$ctrl.currentListItem === insightModel.InsightModelID\"><div class=col-sm-12><insight-model-details-form insight-model=insightModel insight-types=$ctrl.insightTypes></insight-model-details-form></div><div class=col-sm-12><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=$ctrl.delete(insightModel)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button> <button type=submit class=\"btn btn-sm btn-wide btn-success\" ng-click=$ctrl.update(insightModel)><i class=\"fa fa-floppy-o\" aria-hidden=true></i> Save</button></p></div></div><div class=col-sm-12><save-status-inline status=status></save-status-inline></div></div><!-- .table-list-detail --></div><!-- .table-list-item --><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div></div>");
$templateCache.put("app/views/insights/insightModels/newInsightModel/newInsightModel.html","<div class=\"panel panel-default\"><div class=panel-heading><h2>Add new insight model</h2></div><div class=panel-body><insight-model-details-form insight-model=$ctrl.insightModel insight-types=$ctrl.insightTypes></insight-model-details-form><div class=form-group><p><button type=submit class=\"btn btn-block btn-success\" ng-click=$ctrl.save($ctrl.insightModel)>create</button></p></div><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div></div>");
$templateCache.put("app/views/insights/insightTypes/insightTypeDetailsForm/insightTypeDetailsForm.html","<form class=row><!-- <div class=\"col-sm-4\" ng-repeat=\"(key, value) in $ctrl.insightType\" ng-if=\"$ctrl.hiddenVariables.indexOf(key) < 0\">\n    <div class=\"form-group\">\n      <label for=\"{{key}}\">{{$ctrl.addSpaces(key)}}</label>\n      <input type=\"text\" class=\"form-control\" id=\"{{key}}\" ng-model=\"$ctrl.insightType[key]\" ng-disabled=\"$ctrl.noEditVariables.indexOf(key) > -1\">\n    </div>\n  </div> --><div class=col-sm-6><div class=form-group><label for=insightTypeTitle>Title</label><input type=text class=form-control id=insightTypeTitle ng-model=$ctrl.insightType.title></div></div><div class=col-sm-6><div class=form-group><label for=typeName>Type Name</label><input type=text class=form-control id=typeName ng-model=$ctrl.insightType.typeName></div></div><div class=col-sm-6><div class=form-group><label for=insightScope>Scope</label><select type=text class=form-control id=insightScope ng-model=$ctrl.insightType.insightScope ng-options=\"scope as scope for scope in $ctrl.insightScopes\"></select></div></div><div class=col-sm-6><div class=form-group><label for=insightCategory>Category</label><select type=text class=form-control id=insightCategory ng-model=$ctrl.insightType.insightCategory ng-options=\"categorie as categorie for categorie in $ctrl.categories\"></select></div></div><div class=col-sm-12><div class=form-group><label for=slidingWindowInterval>Sliding Window <small>(in seconds)</small></label><input type=number class=form-control id=slidingWindowInterval ng-model=$ctrl.insightType.slidingWindowInterval> <small>Current: {{$ctrl.insightType.slidingWindowInterval / 3600 | number : 1}} hours.<br>Set to <a ng-click=\"$ctrl.insightType.slidingWindowInterval = 21600;\">6 hours</a>, <a ng-click=\"$ctrl.insightType.slidingWindowInterval = 43200;\">12 hours</a>, <a ng-click=\"$ctrl.insightType.slidingWindowInterval = 86400;\">24 hours</a>, <a ng-click=\"$ctrl.insightType.slidingWindowInterval = 604800;\">1 week</a></small></div></div><div class=col-sm-6><div class=form-group><label for=lowerBoundInterval>Minimum insight duration <small>(in seconds)</small></label><input type=number class=form-control id=lowerBoundInterval ng-model=$ctrl.insightType.lowerBoundInterval> <small>Current: <span ng-if=$ctrl.insightType.lowerBoundInterval>{{$ctrl.insightType.lowerBoundInterval / 3600 | number : 1}} hours</span><span ng-if=!$ctrl.insightType.lowerBoundInterval>no minimum</span><br>Set to <a ng-click=\"$ctrl.insightType.lowerBoundInterval = 3600;\">1 hour</a>, <a ng-click=\"$ctrl.insightType.lowerBoundInterval = 21600;\">6 hours</a>, <a ng-click=\"$ctrl.insightType.lowerBoundInterval = 43200;\">12 hours</a>, <a ng-click=\"$ctrl.insightType.lowerBoundInterval = 86400;\">24 hours</a>, <a ng-click=\"$ctrl.insightType.lowerBoundInterval = 604800;\">1 week</a></small></div></div><div class=col-sm-6><div class=form-group><label for=upperBoundInterval>Maximum insight duration <small>(in seconds)</small></label><input type=number class=form-control id=upperBoundInterval ng-model=$ctrl.insightType.upperBoundInterval> <small>Current: <span ng-if=$ctrl.insightType.upperBoundInterval>{{$ctrl.insightType.upperBoundInterval / 3600 | number : 1}} hours</span><span ng-if=!$ctrl.insightType.upperBoundInterval>infinite</span><br>Set to <a ng-click=\"$ctrl.insightType.upperBoundInterval = 3600;\">1 hour</a>, <a ng-click=\"$ctrl.insightType.upperBoundInterval = 21600;\">6 hours</a>, <a ng-click=\"$ctrl.insightType.upperBoundInterval = 43200;\">12 hours</a>, <a ng-click=\"$ctrl.insightType.upperBoundInterval = 86400;\">24 hours</a>, <a ng-click=\"$ctrl.insightType.upperBoundInterval = 604800;\">1 week</a></small></div></div></form>");
$templateCache.put("app/views/insights/insightTypes/insightTypesList/insightTypesList.html","<div class=\"table-list table-list-md\"><div class=\"table-list-heading table-list-heading-minimal\"><div class=row><div class=col-xs-3>Title</div><div class=col-xs-3>Type</div><div class=col-xs-3>Scope</div><div class=col-xs-3>Category</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"insightType in $ctrl.insightTypes\" ng-class=\"($ctrl.currentListItem === insightType.InsightTypeID ? \'active\' : \'\')\"><div class=row ng-click=$ctrl.rowClicked(insightType) role=button><div class=\"col-xs-3 strong\">{{insightType.title}}</div><div class=col-xs-3>{{insightType.typeName}}</div><div class=col-xs-3>{{insightType.insightScope}}</div><div class=col-xs-3>{{insightType.insightCategory}}</div><div class=table-list-item-expand-btn></div></div><div class=\"row table-list-detail\" ng-if=\"$ctrl.currentListItem === insightType.InsightTypeID\"><div class=col-sm-12><div class=section-nav role=navigation ng-show=\"$ctrl.sectionNavItems.length > 1\"><ul class=\"nav navbar-nav\"><li ng-class=\"($ctrl.currentSection === item.sectionID ? \'active\' : \'\')\" ng-repeat=\"item in $ctrl.sectionNavItems\"><a ng-click=$ctrl.switchSection(item)>{{item.title}}</a></li></ul></div><!-- .subnav --><div ng-if=\"$ctrl.currentSection === \'insightTypeDetails\'\"><insight-type-details-form insight-type=insightType></insight-type-details-form><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-danger\" ng-click=$ctrl.delete(insightType)><i class=\"fa fa-trash\" aria-hidden=true></i> Delete</button> <button type=submit class=\"btn btn-sm btn-wide btn-success\" ng-click=$ctrl.update(insightType)><i class=\"fa fa-floppy-o\" aria-hidden=true></i> Save</button></p></div></div><div ng-if=\"$ctrl.currentSection === \'insightModels\'\"><div class=row><div class=\"col-sm-12 text-right\"><a class=\"btn btn-xs btn-primary\" ui-sref=insights.insightModels.new({insightTypeID:insightType.InsightTypeID})>new insight model</a></div></div><insight-models-list insight-models=$ctrl.insightModels></insight-models-list></div></div><!-- row --></div><!-- .table-list-detail --></div><!-- .table-list-item --><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div></div>");
$templateCache.put("app/views/insights/insightTypes/newInsightType/newInsightType.html","<div class=\"panel panel-default\"><div class=panel-heading><h2>Add new insight type</h2></div><div class=panel-body><insight-type-details-form insight-type=$ctrl.insightType></insight-type-details-form><div class=form-group><p><button type=submit class=\"btn btn-block btn-success\" ng-click=$ctrl.save($ctrl.insightType)>create</button></p></div><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div></div>");
$templateCache.put("app/views/main/systemMonitorsPanel/systemMonitorChartPanel/systemMonitorChartPanel.html","<div><div class=row><div class=col-sm-3><h6>Pass Rate History</h6></div><div class=col-sm-9><date-period-selector start-date=startDate end-date=endDate day-range=dayRange day-options=dayOptions max-date=maxDate class=small></date-period-selector></div></div><system-monitor-chart display-values=displayValues subject-id=monitorId start-date=startDate end-date=endDate on-date-change=\"onDateChange(startDate, endDate)\"></system-monitor-chart></div>");
$templateCache.put("app/views/main/systemMonitorsPanel/systemMonitorParent/systemMonitorParent.html","<div class=table-list-item ng-class=\"monitor.passRate >= successThreshold/100 ? \'item-success\' : (monitor.passRate >= warningThreshold/100 ? \'item-warning\' : \'item-danger\')\"><!-- <system-monitor-td ng-click=\"toggleMonitorDetails(monitor);\" monitor=\"monitor\"></system-monitor-td> --><div class=row ng-click=toggleMonitorDetails()><div class=col-xs-6><span ng-if=monitor.farmID><code>#{{monitor.farmID}}</code> {{monitor.farmName}}</span> <span ng-if=!monitor.farmID>{{monitor.monitorName}}</span></div><div class=col-xs-3><span ng-hide=\"showSensors || $parent.showAllSensors\" ng-mouseover=\"showSensors=true\" class=\"gray small\">[load]</span><sensors-summary ng-if=\"showSensors || $parent.showAllSensors\" farm-id=monitor.farmID show-total=\"(monitor.farmID ? false : true)\"></sensors-summary></div><div class=\"col-xs-3 text-right\">{{monitor.passRate*100 | number : 0}}%<!-- <span ng-show=\"monitor.passRate < 1\" class=\"small\">\n        <small>(passed <span am-time-ago=\"monitor.lastSuccessfulRunTime\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"{{ monitor.lastSuccessfulRunTime | date : \'medium\' }}\"></span>)</small>\n      </span> --></div><!-- <div class=\"col-xs-6 col-sm-3\">\n      <span am-time-ago=\"monitor.lastRunTime\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"{{ monitor.lastRunTime | date : \'medium\' }}\" class=\"small\"></span>\n    </div> --></div><!-- .row --><div class=\"row table-list-detail table-list-detail-light\" ng-if=expanded><div class=col-sm-12><div class=table-list><div class=\"table-list-heading table-list-heading-minimal\"><div class=row><div class=col-xs-6>Monitor</div><div class=\"col-xs-6 col-sm-3\">Status</div><div class=\"col-sm-3 hidden-xs\">Last check</div></div></div><div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div><div class=table-list-items><system-monitor-child ng-repeat=\"monitor in monitors\" monitor=monitor ng-init=\"singleMonitor = (monitors.length === 1)\" expanded=singleMonitor success-threshold=successThreshold warning-threshold=warningThreshold></system-monitor-child></div></div></div></div><!--\n\n\n    <a ng-click=\"showMonitorDetailsTable=!showMonitorDetailsTable\" ng-show=\"monitors.length>0\">Details</a>\n    <system-monitor-details-table monitor=\"monitor\" ng-if=\"monitors.length===0 || showMonitorDetailsTable===true\"></system-monitor-details-table>\n    <div ng-if=\"monitors.length>0\">\n      <ul class=\"child-monitors\">\n        <system-monitor-child ng-repeat=\"childMonitor in monitors\" monitor=\"childMonitor\"></system-monitor-child>\n      </ul>\n    </div> --></div><!-- .monitor-details --></div>");
$templateCache.put("app/shared-components/angular-authentication/components/changePasswordForm/changePasswordForm.html","<form ng-submit=changePassword()><div class=row><div class=col-sm-6><div class=form-group><label for=OldPassword>{{\"CurrentPassword\" | translate}}</label><input type=password class=form-control id=OldPassword ng-model=changePasswordDetails.OldPassword required></div></div><div class=col-sm-6><div class=form-group><label for=NewPassword>{{\"NewPassword\" | translate}}</label><input type=password class=form-control id=NewPassword ng-model=changePasswordDetails.NewPassword required></div><password-strength password=changePasswordDetails.NewPassword password-passed=passwordChecksPassed></password-strength></div><div class=col-sm-12><div class=form-group><button type=submit class=\"btn btn-primary\" ng-disabled=!passwordChecksPassed>{{\"UpdatePassword\" | translate}}</button></div></div></div><div class=\"alert alert-danger\" role=alert ng-if=error>{{error | translate}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success | translate}}</div><save-status-inline status=status></save-status-inline></form>");
$templateCache.put("app/shared-components/angular-authentication/components/confirmEmailPanel/confirmEmailPanel.html","<div class=\"panel panel-default panel-page text-center\"><div class=panel-body><figure class=logo><img src=assets/images/dairymonitor-logo.svg></figure><div class=\"alert alert-danger\" role=alert ng-if=error>{{error | translate}}</div><div ng-show=success><h3>{{\"confirmSuccessTitle\" | translate}}</h3><p class=lead>{{\"confirmSuccessText\" | translate}}</p><a ui-sref=login class=\"btn btn-primary btn-block\">{{\"BUTTON_TEXT_LOGIN\" | translate}}</a></div><div ng-if=loading><loading-bar></loading-bar><h6>{{\"verifying\" | translate}}</h6></div></div></div><!-- .panel -->");
$templateCache.put("app/shared-components/angular-authentication/components/forgotPasswordPanel/forgotPasswordPanel.html","<div class=\"panel panel-default text-center panel-page\" ng-class=\"error ? \'invalid\' : \'\'\"><div class=panel-body><figure class=logo><img src=assets/images/dairymonitor-logo.svg></figure><h4 class=modal-title id=forgotPasswordLabel>{{\"ForgotPassword\" | translate}}</h4><p>{{\"ForgotPasswordIntro\" | translate}}</p><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div><form ng-hide=success ng-submit=forgotPassword()><div class=form-group><label for=email class=sr-only>{{\"LABEL_TEXT_EMAIL\" | translate}}</label><input type=email class=form-control id=email name=email placeholder=\"{{\'LABEL_TEXT_EMAIL\' | translate}}\" ng-model=emailAddress></div><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_SEND_RESET_EMAIL\" | translate}}</button></form><button ng-show=success class=\"no-animate btn btn-primary btn-block btn-lg\" ui-sref=login>{{\"BUTTON_TEXT_BACK\" | translate}}</button></div><div class=panel-footer><div class=row><div class=\"col-xs-4 text-left\"><span language-select></span></div><div class=\"col-xs-8 text-right\"><a ui-sref=login class=panel-footer-btn>{{\"BUTTON_TEXT_LOGIN\" | translate}}</a></div></div></div></div><!-- .panel -->");
$templateCache.put("app/shared-components/angular-authentication/components/loginPanel/loginPanel.html","<div class=\"panel panel-default text-center panel-page\" ng-class=\"error ? \'invalid\' : \'\'\"><div class=panel-body><figure class=logo><img src=assets/images/dairymonitor-logo.svg></figure><div class=\"alert alert-danger\" role=alert ng-if=error>{{error | translate}}</div><form ng-hide=lockedOut ng-submit=login() action=#!/login onsubmit=\"return false\" form-autofill-fix><div class=form-group><label for=email class=sr-only>{{\"LABEL_TEXT_EMAIL\" | translate}}</label><input type=email class=form-control id=email name=email placeholder=\"{{\'LABEL_TEXT_EMAIL\' | translate}}\" ng-model=emailAddress required></div><div class=form-group><label for=password class=sr-only>{{\"LABEL_TEXT_PASSWORD\" | translate}}</label><input ng-hide=showPassword type=password class=\"no-animate form-control\" id=password name=password placeholder=\"{{\'LABEL_TEXT_PASSWORD\' | translate}}\" ng-model=password required> <input ng-show=showPassword type=text class=\"no-animate form-control\" id=password name=password placeholder=\"{{\'LABEL_TEXT_PASSWORD\' | translate}}\" ng-model=password required><div ng-click=\"showPassword=!showPassword\" class=text-right><a><i class=fa ng-class=\"(showPassword ? \'fa-eye-slash\' : \'fa-eye\')\" aria-hidden=true></i> {{(showPassword ? \"BUTTON_TEXT_HIDE_PASSWORD\" : \"BUTTON_TEXT_SHOW_PASSWORD\") | translate}}</a></div></div><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_LOGIN\" | translate}}</button></form><button ng-show=lockedOut class=\"no-animate btn btn-primary btn-block btn-lg\" ng-click=\"lockedOut=false; error= \'\'\">{{\"BUTTON_TEXT_BACK\" | translate}}</button></div><div class=panel-footer><div class=row><div class=\"col-xs-6 text-left\"><a ui-sref=\"forgotPassword({emailAddress: emailAddress})\" class=panel-footer-btn>{{\"ForgotPassword\" | translate}}</a></div><div class=\"col-xs-6 text-right\"><label for=stayLoggedIn class=panel-footer-btn><input type=checkbox id=stayLoggedIn ng-model=stayLoggedIn value=true> {{ \"LABEL_TEXT_STAY_LOGGED_IN\" | translate }}</label></div></div><div class=row><div class=col-xs-12><span language-select></span></div></div></div></div><!-- .panel -->");
$templateCache.put("app/shared-components/angular-authentication/components/passwordStrength/passwordStrength.html","<div class=\"form-group row text-left small gray\"><div class=col-sm-6 ng-repeat=\"(key, value) in passwordChecks\" ng-class=\"(value.passed ? \'color-success\' : \'\')\"><span class=glyphicon aria-hidden=true ng-class=\"(value.passed ? \'glyphicon-ok\' : \'glyphicon-remove\')\"></span> {{value.title | translate}}</div></div><!-- .form-group.row -->");
$templateCache.put("app/shared-components/angular-authentication/components/registrationPanel/registrationPanel.html","<div class=\"panel panel-default text-center panel-page\" ng-class=\"error ? \'invalid\' : \'\'\"><div class=panel-body><figure class=logo><img src=assets/images/dairymonitor-logo.svg></figure><div class=\"alert alert-danger\" role=alert ng-if=error>{{ error }}</div><div ng-show=success><!-- Translate --><p>{{\"successMessage\" | translate}}</p><p></p><a ui-sref=login class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_GOLOGIN\" | translate}}</a></div><form ng-hide=success ng-submit=register() data-toggle=validator><div class=form-group><label for=email class=sr-only>{{\"LABEL_TEXT_EMAIL\" | translate}}</label><input type=email class=form-control id=email name=email placeholder=\"{{\'LABEL_TEXT_EMAIL\' | translate}}\" ng-model=emailAddress required><div class=\"help-block with-errors small\"></div></div><div class=form-group><label for=password class=sr-only>{{\"LABEL_TEXT_PASSWORD\" | translate}}</label><input type=password class=form-control id=password name=password placeholder=\"{{\'LABEL_TEXT_PASSWORD\' | translate}}\" ng-model=password required><div ng-password-strength=password strength=passStrength inner-class=progress-bar inner-class-prefix=progress-bar- ng-class=\"\'progress-bar-password\'\"></div><div class=\"help-block with-errors small\"></div></div><div class=form-group><label for=confirmPassword class=sr-only>{{\"ConfirmPassword\" | translate}}</label><input type=password class=form-control id=confirmPassword name=confirmPassword placeholder=\"{{\'ConfirmPassword\' | translate}}\" ng-model=confirmPassword data-match=#password required><div ng-password-strength=\"(password === confirmPassword  ? password : null)\" strength=passStrength2 inner-class=progress-bar inner-class-prefix=progress-bar- ng-class=\"\'progress-bar-password\'\"></div><div class=\"help-block with-errors small\"></div></div><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_REGISTER\" | translate}}</button></form></div><div class=\"panel-footer text-left\"><span class=\"small-caps x-small gray\">{{\"AlreadyHaveAnAccount\" | translate}} <a ui-sref=login>{{\"BUTTON_TEXT_LOGIN\" | translate}}</a></span></div></div>");
$templateCache.put("app/shared-components/angular-authentication/components/resetPasswordPanel/resetPasswordPanel.html","<div class=\"panel panel-default text-center\" ng-class=\"error ? \'invalid\' : \'\'\"><div class=panel-body><figure class=logo><img src=assets/images/dairymonitor-logo.svg></figure><h4 class=modal-title id=resetPasswordLabel>{{\"ResetPassword\" | translate}}</h4><p>{{\"ResetPasswordIntro\" | translate}}</p><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div><form ng-hide=success ng-submit=resetPassword()><div class=form-group><label for=newPassword class=sr-only>{{\"NewPassword\" | translate}}</label><input ng-show=!showPassword type=password class=\"form-control no-animate text-center\" id=newPassword ng-model=newPassword ng-change=checkPassword(newPassword) placeholder=\"{{\'NewPassword\' | translate}}\" ng-blur=checkPassword(newPassword) required> <input ng-show=showPassword type=text class=\"form-control no-animate text-centet\" id=newPassword ng-model=newPassword ng-change=checkPassword(newPassword) placeholder=\"{{\'NewPassword\' | translate}}\" ng-blur=checkPassword(newPassword) required><div ng-click=\"showPassword=!showPassword\" class=text-right><a><i class=fa ng-class=\"(showPassword ? \'fa-eye-slash\' : \'fa-eye\')\" aria-hidden=true></i> {{(showPassword ? \"BUTTON_TEXT_HIDE_PASSWORD\" : \"BUTTON_TEXT_SHOW_PASSWORD\") | translate}}</a></div></div><password-strength password=newPassword password-passed=passwordChecksPassed></password-strength><button type=submit class=\"btn btn-primary btn-block btn-lg\" ng-disabled=!passwordChecksPassed>{{\"BUTTON_TEXT_RESET_PASSWORD\" | translate}}</button></form><button ng-show=success class=\"no-animate btn btn-primary btn-block btn-lg\" ui-sref=login>{{\"BUTTON_TEXT_LOGIN\" | translate}}</button></div><div class=panel-footer><div class=row><div class=\"col-xs-4 text-left\"><span language-select></span></div><div class=\"col-xs-8 text-right\"><a ui-sref=login class=panel-footer-btn>{{\"BUTTON_TEXT_LOGIN\" | translate}}</a></div></div></div></div><!-- .panel -->");
$templateCache.put("app/shared-components/angular-authentication/components/userProfileForm/userProfileForm.html","<form><div class=row><div class=col-sm-6><div class=form-group><label for=givenName>{{\"FirstName\" | translate}}</label><input type=text class=form-control id=givenName ng-model=user.givenName></div></div><div class=col-sm-6><div class=form-group><label for=surName>{{\"LastName\" | translate}}</label><input type=text class=form-control id=surName ng-model=user.surName></div></div></div><div class=row><div class=col-sm-6><div class=form-group><label for=email>{{\"EmailAddress\" | translate}}</label><input type=text class=form-control id=email ng-model=user.email disabled></div></div><div class=col-sm-6><div class=form-group><label for=phoneNumber>{{\"PhoneNumber\" | translate}}</label><input type=text class=form-control id=phoneNumber ng-model=user.phoneNumber></div></div></div><div class=row><div class=col-sm-12><div class=form-group><label for=address>{{\"Address\" | translate}}</label><input type=text class=form-control id=address ng-model=user.address></div></div><div class=col-sm-6><div class=form-group><label for=city>{{\"City\" | translate}}</label><input type=text class=form-control id=city ng-model=user.city></div></div><div class=col-sm-6><div class=form-group><label for=postalCode>{{\"PostalCode\" | translate}}</label><input type=text class=form-control id=postalCode ng-model=user.postalCode></div></div></div><save-status-inline status=status></save-status-inline></form>");
$templateCache.put("app/shared-components/angular-authentication/views/account/account.html","<div class=container-fluid><h2 class=page-header>{{\"AccountSettings\" | translate}}</h2><div class=\"panel panel-default\"><div class=panel-heading><h2>{{\"BasicInformation\" | translate}}</h2></div><!-- .panel-heading --><div class=panel-body><user-profile-form user=user></user-profile-form></div><!-- .panel-body --></div><!-- .panel --><div class=\"panel panel-default\"><div class=panel-heading><h2>{{\"ChangeYourPassword\" | translate}}</h2></div><!-- .panel-heading --><div class=panel-body><change-password-form></change-password-form></div><!-- .panel-body --></div><!-- .panel --></div>");
$templateCache.put("app/shared-components/angular-authentication/views/alert/alert.html","<div class=container-fluid><div class=row><div class=\"col-sm-4 col-sm-offset-4\"><div class=\"panel panel-minimal panel-page text-center invalid\"><div class=panel-body><div class=alert role=alert ng-class=\"\'alert-\'+level\">{{message | translate}}</div><div class=row><div class=col-xs-6><a ng-if=user class=\"btn btn-sm btn-block btn-gray\" ui-sref=logout>{{\'BUTTON_TEXT_LOGOUT\' | translate}}</a></div><div class=col-xs-6><a class=\"btn btn-sm btn-block btn-default\" href=/ >{{\'BUTTON_TEXT_BACK\' | translate}}</a></div></div></div><!-- .panel --></div></div></div></div>");
$templateCache.put("app/shared-components/angular-authentication/views/confirmEmail/confirmEmail.html","<div class=container-fluid><div class=row><div class=\"col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"><confirm-email-panel></confirm-email-panel></div></div></div>");
$templateCache.put("app/shared-components/angular-authentication/views/forgotPassword/forgotPassword.html","<div class=container-fluid><div class=row><div class=\"col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"><forgot-password-panel></forgot-password-panel></div></div></div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div>");
$templateCache.put("app/shared-components/angular-authentication/views/login/login.html","<div class=container-fluid><div class=row><div class=\"col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"><login-panel></login-panel></div></div></div>");
$templateCache.put("app/shared-components/angular-authentication/views/resetPassword/resetPassword.html","<div class=container-fluid><div class=row><div class=\"col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"><reset-password-panel></reset-password-panel></div></div></div><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div>");
$templateCache.put("app/shared-components/angular-authentication/views/register/register.html","<div class=container-fluid><div class=row><div class=\"col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"><registration-panel></registration-panel></div></div></div>");
$templateCache.put("app/shared-components/angular-data-visualisations/components/data-visualisation/data-visualisation.html","<div class=\"alert alert-danger\" style=margin-bottom:0 ng-if=$ctrl.error>{{$ctrl.error}}</div><div class=\"alert alert-info\" style=margin-bottom:0 ng-if=$ctrl.info>{{$ctrl.info}}</div><graph display-data=$ctrl.displayData on-insight-clicked=\"$ctrl.onInsightClicked({insight: insight})\" range-picker=$ctrl.rangePicker on-range-picker-changed=\"$ctrl.onRangePickerChanged({rangePicker: rangePicker})\" graph-legend=$ctrl.legend domain=$ctrl.chartDomain on-domain-change=$ctrl.onChartDomainChange(domain) highlighted-data=$ctrl.highlightedData hidden-data=$ctrl.hiddenData context-menu=$ctrl.contextMenu class=\"graph no-animation\"></graph><div class=loading-hover ng-show=$ctrl.loading><loading-bar></loading-bar></div>");
$templateCache.put("app/shared-components/angular-data-visualisations/components/insightsTimeline/insightsTimeline.html","<div style=\"position: relative\"><div ng-repeat=\"insightsGroup in reportData\"><div class=row><h4 class=col-xs-8>{{insightsGroup.farm.farmName}}</h4><div class=\"col-xs-4 text-right\"><div class=\"btn-group btn-group-sm\" role=group ng-init=\"mode=\'timeline\'\"><button type=button class=btn ng-click=\"mode=\'list\'\" ng-class=\"(mode===\'list\' ? \'btn-primary\' : \'btn-white\')\"><i class=\"fa fa-list-ul\" aria-hidden=true></i> List</button> <button type=button class=btn ng-click=\"mode=\'timeline\'\" ng-class=\"(mode===\'timeline\' ? \'btn-primary\' : \'btn-white\')\"><i class=\"fa fa-ellipsis-h\" aria-hidden=true></i> Timeline</button></div></div></div><insights-timeline-chart ng-if=\"mode===\'timeline\'\" class=no-animate report-data=[insightsGroup] start-date=startDate end-date=endDate farms=[farm] cows=cows current-insight=$parent.$parent.currentInsight show-x-axis=true></insights-timeline-chart><insight-list ng-if=\"mode===\'list\'\" class=no-animate insights=insightsGroup.insights current-insight=$parent.$parent.currentInsight farms=[farm] cows=cows selectable=true details=\"{\n      headingMinimal:       true,\n      insightTitle:  \'col-xs-5\',\n      cow:           \'col-xs-3\',\n      epoch: \'col-xs-3\'}\"></insight-list><hr></div><div class=summary ng-show=\"insights && !loading && showSummary\"><h5>Summary <small>(click to filter)</small></h5><table class=table><tr ng-repeat=\"(key, value) in insights\" class={{value.class}} ng-click=filterBy(key) role=button ng-class=\"(filteredBy === key ? \'strong\' : \'\')\"><td>{{value.title}}</td><td>{{value.insights.length || 0}}</td></tr></table></div><insight-panel cows=cows insight=currentInsight close-insight=closeInsight() ng-if=currentInsight insight-updated=insightUpdated()></insight-panel><div class=loading-cover ng-show=loading><loading-bar></loading-bar></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/cowDetailsFormFields/cowDetailsFormFields.html","<div class=row><div class=col-sm-6><div class=form-group><label for=cowTagNumber>{{\"LABEL_TEXT_TAGNUMBER\" | translate}}*</label><input type=text class=form-control id=cowTagNumber ng-model=cow.cowTagNumber required></div><div class=form-group><label for=cowName>{{\"LABEL_TEXT_NAME\" | translate}}</label><input type=text class=form-control id=cowName ng-model=cow.cowName></div><div class=form-group><label for=cowBirthDate>{{\"LABEL_TEXT_BIRTHDATE\" | translate}}</label><date-picker date=cow.cowBirthDate></date-picker></div></div><div class=col-sm-6><div class=form-group><label for=farmID>{{\"LABEL_TEXT_FARM\" | translate}}*</label><select class=form-control id=farmID ng-model=cow.farmID ng-options=\"farm.FarmID as (farm.farmName) for farm in farms\" required></select></div><div class=form-group><label for=herdGroupID>{{\"LABEL_TEXT_HERD_GROUP\" | translate}}*</label><select class=form-control id=herdGroupID ng-model=cow.herdGroupID ng-options=\"herdGroup.HerdGroupID as (herdGroup.groupName) for herdGroup in (herdGroups | filter: {farmID : cow.farmID} : true)\" required><option value=\"\">None</option></select></div><div class=form-group><label for=lactationNumber>{{\"LABEL_TEXT_LACTATION\" | translate}}</label><input type=text class=form-control id=lactationNumber ng-model=cow.lactationNumber></div><div class=form-group><label for=watchEnabled><input type=checkbox id=watchEnabled ng-model=cow.watchEnabled> {{\"LABEL_TEXT_WATCHING\" | translate}}</label></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/customerDetailsFormFields/customerDetailsFormFields.html","<div><div class=row><div class=col-sm-6><div class=form-group><label for=customerName>{{\"CustomerName\" | translate}}</label><input type=text class=form-control id=customerName ng-model=customer.customerName required></div><div class=form-group><label for=customerType>{{\"CustomerType\" | translate}}</label><input type=text class=form-control id=customerType ng-model=customer.customerType></div></div><div class=col-sm-6><div class=form-group><label for=streetAddress>{{\"StreetAddress\" | translate}}</label><input type=text class=form-control id=streetAddress ng-model=customer.streetAddress></div><div class=row><div class=col-sm-6><div class=form-group><label for=postCode>{{\"PostCode\" | translate}}</label><input type=text class=form-control id=farmCity ng-model=customer.postCode></div></div><div class=col-sm-6><div class=form-group><label for=city>{{\"City\" | translate}}</label><input type=text class=form-control id=city ng-model=customer.city></div></div></div><div class=form-group><label for=country>{{\"Country\" | translate}}</label><input type=text class=form-control id=country ng-model=customer.country></div></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/customerUsersForm/customerUsersForm.html","<div><div class=form-group><label for=primaryUser class=control-label>Primary User*</label><select class=form-control id=primaryUser ng-model=primaryUser ng-options=\"user as (user.email) for user in users\" ng-change=changedPrimaryUserID(primaryUser) ng-init=\"primaryUser = (users | filter : {id: customer.primaryUserID} : true)[0]\" required><option value=\"\">Select user</option></select></div><div class=form-group><label class=control-label>Additional Users</label><p ng-show=additionalUsersList.length><span ng-repeat=\"user in additionalUsersList\">{{user.email}} <a ng-click=removeAdditonalUser(user) class=\"color-danger small\">(remove)</a><br></span></p><label for=selectedAdditionalUser class=control-label>Add additional Users</label><select class=form-control id=selectedAdditionalUser ng-model=selectedAdditionalUser ng-options=\"user as (user.email) for user in users | filter: {customerID: null} : true\" ng-change=addAdditonalUser(selectedAdditionalUser)></select><div class=\"help-block with-errors small\"></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/datePeriodSelector/datePeriodSelector.html","<div class=\"row date-period-selector\"><div class=col-sm-6><div class=period-navigator><a ng-click=previousPeriod()><i class=\"fa fa-angle-left\"></i></a> <span>{{ startDate | amDateFormat:\'DD MMM YYYY\' }}</span><span ng-if=\"dayRange > 1\"> - {{ endDate | amDateFormat:\'DD MMM YYYY\' }}</span> <a ng-click=nextPeriod() ng-class=\"(nextBtnVisible ? \'\' : \'disabled\')\"><i class=\"fa fa-angle-right\"></i></a></div></div><div class=col-sm-6><div class=\"period-selector btn-group btn-group-justified\"><a ng-repeat=\"dayOption in dayOptions\" ng-click=\"$parent.dayRange = dayOption\" class=btn ng-class=\"(dayRange == dayOption ? \'active\' : \'\')\">{{\"LABEL_TEXT_DAY_OPTION_\"+dayOption | translate}}</a></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/dateTimeWidget/dateTimeWidget.html","<div class=date-time-picker><div class=\"input-group datePicker\"><input type=time class=form-control ng-required=required ng-model=$ctrl.time ng-change=$ctrl.submitDateTime() ng-disabled=$ctrl.disabled id=calving-time step=1800><label for=calving-time class=input-group-addon><span class=\"glyphicon glyphicon-time\"></span></label></div><div class=\"input-group datePicker\"><input required type=date class=form-control ng-model=$ctrl.date ng-change=$ctrl.submitDateTime() ng-disabled=$ctrl.disabled id=calving-date max=\"{{ $ctrl.today | date:\'yyyy-MM-dd\' }}\" ng-max=\"{{ $ctrl.today }}\"><label for=calving-date class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></label></div><button type=button class=\"btn btn-sm\" ng-class=\"($ctrl.disabled === true ? \'color-white bg-tango\' : \'bg-white color-emperor i-dont-know\')\" ng-click=$ctrl.toggleDisabledFlag()>{{$ctrl.getTranslatedContent(\"i-dont-know-button\")}}</button></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/dryOffFormFields/dryOffFormFields.html","<div class=row><div class=col-sm-6><div class=form-group><label for=rationChangePeriod>{{\"DRY_OFF_SETTINGS_RATION_CHANGE_PERIOD\" | translate}}</label><input type=number class=form-control id=rationChangePeriod ng-model=farm.rationChangePeriod required></div><div class=form-group><label for=farOffPeriod>{{\"DRY_OFF_SETTINGS_FAR_OFF_PERIOD\" | translate}}</label><input type=number class=form-control id=farOffPeriod ng-model=farm.farOffPeriod required></div><div class=form-group><label for=closeUpPeriod>{{\"DRY_OFF_SETTINGS_CLOSE_UP_PERIOD\" | translate}}</label><input type=number class=form-control id=closeUpPeriod ng-model=farm.closeUpPeriod required></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/fancySlider/sliderGroup.html","<section class=slider-group><section ng-repeat=\"slider in $ctrl.sliders\" ng-class=slider.id><label>{{slider.label}}</label><rzslider rz-slider-model=$ctrl.values[slider.id] rz-slider-options=slider.options></rzslider></section></section>");
$templateCache.put("app/shared-components/angular-ui-components/components/farmDetailsFormFields/farmDetailsFormFields.html","<div class=row><div class=col-sm-6><div class=form-group><label for=farmName>{{\"FarmName\" | translate}}</label><input type=text class=form-control id=farmName ng-model=farm.farmName required></div><div class=form-group><label for=farmName>{{\"FarmDescription\" | translate}}</label><textarea class=form-control id=farmDescription ng-model=farm.farmDescription style=height:118px></textarea></div><div class=form-group><label for=farmType>{{\"FarmType\" | translate}}</label><input type=text class=form-control id=farmType ng-model=farm.farmType></div></div><div class=col-sm-6><div class=form-group><label for=farmAddress>{{\"StreetAddress\" | translate}}</label><input type=text class=form-control id=farmAddress ng-model=farm.farmAddress></div><div class=row><div class=col-sm-6><div class=form-group><label for=farmAddress>{{\"City\" | translate}}</label><input type=text class=form-control id=farmCity ng-model=farm.farmCity></div></div><div class=col-sm-6><div class=form-group><label for=farmPostCode>{{\"PostCode\" | translate}}</label><input type=text class=form-control id=farmPostCode ng-model=farm.farmPostCode></div></div></div><div class=form-group><label for=farmCountry>{{\"Country\" | translate}}</label><input type=text class=form-control id=farmCountry ng-model=farm.farmCountry></div><div class=form-group><label for=farmWebSite>{{\"Website\" | translate}}</label><input type=text class=form-control id=farmWebsite ng-model=farm.farmWebSite></div><div class=form-group><label for=farmGPSCoordinates>{{\"GPSCoordinates\" | translate}}</label><input type=text class=form-control id=farmGPSCoordinates ng-model=farm.farmGPSCoordinates></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insight.html","<ui-view><insight-admin-details insight=$ctrl.insight ng-if=\"$ctrl.isAuthorized(\'Admin\')\"></insight-admin-details><!-- Insight information and graph. --><div class=\"page-panel insight-{{ $ctrl.insight.insightType.insightCategory }}\" id=insight-panel><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div><insight-ribbon ng-if=\"$ctrl.insight.insightScope === \'cow\' && $ctrl.isMuted()\" text=$ctrl.getRibbonText()><mute-repeat-offender ng-click=$ctrl.handleUnmute() class-name=\"btn-white btn-xs\" insight=$ctrl.insight></mute-repeat-offender></insight-ribbon><share-ribbon ng-if=$ctrl.farmName class=screenshot-visible>{{$ctrl.farmName}}</share-ribbon><!-- Event description. --><div class=\"row no-gutters page-panel-header text-center bg-{{ $ctrl.insight.insightType.insightCategory | lowercase}}\" ng-class=\"($ctrl.insight.insightValid === \'No\' ? \'bg-gray\' : \'\')\"><div class=col-sm-12><h3 ng-if=\"$ctrl.isResolved() && $ctrl.resolveFMS($ctrl.insight)\"><fms-resolution-title insight=$ctrl.insight></fms-resolution-title></h3><h3 ng-if=\"$ctrl.isResolved() && !$ctrl.resolveFMS($ctrl.insight)\"><insight-resolution-title insight=$ctrl.insight show-cow-tag=false update=$ctrl.rejectDysonResolutions($ctrl.insight.insightResolution).length pick-resolutions=$ctrl.rejectDysonResolutions></insight-resolution-title></h3><h3 ng-class=\"($ctrl.isResolved() ? \'small\' : \'\')\"><a ng-if=$ctrl.insight.dairyCowID go-forward ui-sref=\"cow({cowID: $ctrl.insight.dairyCow.DairyCowID})\">#{{$ctrl.insight.dairyCow.cowTagNumber}} </a>{{$ctrl.getInsightTitle($ctrl.insight, { legacy: true })}}</h3><p>{{ [$ctrl.insight.startEpoch, $ctrl.insight.endEpoch] | epochsToPeriodString }}</p></div><a ng-if=$ctrl.previousInsightID ui-sref=insight({genericInsightID:$ctrl.previousInsightID}) class=\"fa fa-angle-left previous-insight\"></a> <a ng-if=$ctrl.nextInsightID ui-sref=insight({genericInsightID:$ctrl.nextInsightID}) class=\"fa fa-angle-right next-insight\"></a></div><share-insight-button data=$ctrl.getShareData() target=insight-panel loading=$ctrl.loadingGraphs></share-insight-button><!-- Insight description, validation, resolution options and graphs. --><div class=container><!-- Add 75px to page length to make sure that the intercom widget does not cover anything. --><div class=page-panel-content style=\"padding-bottom: 75px\"><!-- Insight description. --><section ng-if=$ctrl.insight.insightDescription><p>{{$ctrl.getInsightDescription($ctrl.insight, { legacy: true })}}</p></section><!-- Sire selection. --><section class=sire-selection ng-if=$ctrl.getSires()><svg-icon icon=sire></svg-icon><div>{{$ctrl.copy.sireSelection | translate}} <strong>{{$ctrl.getSires()}}</strong></div></section><!-- Cow details. --><cow-details-bar ng-if=$ctrl.insight.dairyCowID insight=$ctrl.insight cow=$ctrl.insight.dairyCow options=$ctrl.cowDetailBarOptions></cow-details-bar><!-- Does this cow has a health problem? --><section ng-if=\"$ctrl.insight.insightType.insightCategory !== \'fertility\'\"><div ng-if=!$ctrl.resolveFMS($ctrl.insight)><insight-validation update-insight-validation=$ctrl.updateInsightValidation(insightValidation) insight=$ctrl.insight></insight-validation><insight-resolution update-insight-resolution=$ctrl.updateInsightResolution(insightResolution) insight-resolution=$ctrl.insight.insightResolution insight=$ctrl.insight insight-is-valid=$ctrl.insight.insightValid options=$ctrl.insightResolutionOptions></insight-resolution></div><div ng-if=$ctrl.resolveFMS($ctrl.insight)><fms-validation insight=$ctrl.insight></fms-validation></div></section><!-- Diagnose button when applicable. --><section class=offer-diagnostics ng-if=\"$ctrl.isAuthorized(\'BetaUser\') && $ctrl.mayHelpDiagnose()\"><h3 class=font-brand>{{$ctrl.copy.diagnoseHeader | translate}}</h3><p>{{$ctrl.copy.diagnoseContent | translate}}</p><a class=\"btn btn-white\" ui-sref=insight.checks>{{$ctrl.copy.diagnoseButton | translate}}</a></section><!-- Insemination validation and resolutions on estrus insight. --><section ng-if=$ctrl.isEstrusInsight($ctrl.insight)><div ng-if=!$ctrl.resolveFMS($ctrl.insight)><h3 class=font-brand>{{$ctrl.copy.inseminationQuestion | translate}}</h3><!-- Insemination buttons and resolutions if answer is no. --><insight-insemination class=\"btn-group btn-group-justified\" updateinsightinsemination=$ctrl.updateInsemination(insight) insight=$ctrl.insight></insight-insemination></div><div ng-if=$ctrl.resolveFMS($ctrl.insight)><fms-validation insight=$ctrl.insight></fms-validation></div><div ng-show=\"$ctrl.insight.inseminated === false\"><h5>{{$ctrl.notInseminateTitle | translate: $ctrl.insight.dairyCow}}</h5><insight-resolution update-insight-resolution=$ctrl.updateInsightResolution(insightResolution) insight-resolution=$ctrl.insight.insightResolution insight=$ctrl.insight insight-is-valid=$ctrl.insight.insightValid><section class=\"dnb-info alert-info small\" ng-if=\"$ctrl.isDysonEnabled() && $ctrl.resolvedAsDNB($ctrl.insight)\">{{$ctrl.copy.dnbWarning | translate}}</section></insight-resolution></div></section><!-- Graphs. --><section ng-if=$ctrl.visualisations.charts.length><date-period-selector start-date=$ctrl.startDate end-date=$ctrl.endDate day-range=$ctrl.visualisations.dayRange day-options=[1,3,7,31] max-date=$ctrl.maxDate center-epoch=$ctrl.centerEpoch on-date-change=\"$ctrl.onDateChange(startDate, endDate)\"></date-period-selector><div ng-repeat=\"chart in $ctrl.visualisations.charts\"><h3 class=font-brand>{{ chart.title | translate }}</h3><ctra-data-visualisation display-values=chart.displayValues context-menu=chart.contextMenu on-insight-clicked=$ctrl.onInsightClicked(insight) start-date=$ctrl.startDate end-date=$ctrl.endDate on-date-change=\"$ctrl.onDateChange(startDate, endDate)\" highlighted-data=[$ctrl.insight.GenericInsightID] is-loading=$ctrl.setLoadingGraphs(loading) class=block></ctra-data-visualisation></div></section></div></div><!--.container --></div></ui-view>");
$templateCache.put("app/shared-components/angular-ui-components/components/labels/labels.html","<ui-view><div class=\"content container\"><div class=\"panel panel-minimal\"><div class=panel-heading><div class=row><div class=col-sm-6><h2>Labels</h2></div><div class=\"col-sm-6 text-right\"><a class=\"btn btn-sm btn-primary\" ui-sref=newLabel>new label</a></div></div></div><div class=panel-body><labels-list labels=$ctrl.labels></labels-list></div></div></div></ui-view>");
$templateCache.put("app/shared-components/angular-ui-components/components/lastBreedingPicker/lastBreedingPicker.html","<div class=last-estrus-picker><h4>{{ $ctrl.getHeaderText() }}</h4><date-picker id=lastEstrusEpoch date-change=$ctrl.onChange($value) date=$ctrl.insight.dairyCow.lastEstrusEpoch format=\"\'dddd D MMMM\'\" epoch=true></date-picker></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/lastEstrusPicker/lastEstrusPicker.html","<div class=last-estrus-picker><h4>{{ $ctrl.getHeaderText() }}</h4><date-picker id=lastEstrusEpoch date-change=$ctrl.onChange($value) date=$ctrl.insight.dairyCow.lastEstrusEpoch format=\"\'dddd D MMMM\'\" epoch=true></date-picker></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/loadingBottle/loadingBottle.html","<div class=loading-bottle><svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 21 51\" enable-background=\"new 0 0 21 51\" xml:space=preserve><defs><mask id=milk-mask><path class=milk-mask d=\"M85.033,7.986c-5.669,3.568-11.338-3.568-17.007,0c-5.668,3.568-11.337-3.568-17.006,0\n	s-10.475-1.485-17.007,0c-6.679,1.519-10.309,0-17.007,0c-9.893,0-9.893,0-17.006,0c0,8.495,0,36.99,0,45.485\n	c5.669-3.568,11.338,3.568,17.006,0c5.669-3.568,11.338,3.568,17.007,0s11.338,3.568,17.007,0s11.338,3.568,17.006,0\n	c5.669-3.568,11.338,3.568,17.007,0s11.338,3.568,17.007,0c0-8.495,0-36.99,0-45.485C96.371,11.554,90.702,4.418,85.033,7.986z\"/></mask></defs><path id=bottle d=\"M18.817,44.817c0,2.039-1.658,3.697-3.697,3.697H5.879c-2.039,0-3.697-1.658-3.697-3.697V21.713\n      	c0-1.125,1.017-3.35,2.092-5.705C5.748,12.784,7.4,9.169,7.684,6.002h5.632c0.285,3.167,1.936,6.782,3.408,10.006\n      	c1.076,2.355,2.093,4.58,2.093,5.705V44.817z M5.879,2.306h9.242v1.848H5.879V2.306z M15.183,6.002h0.862\n      	c0.511,0,0.924-0.414,0.924-0.924V1.381c0-0.51-0.413-0.924-0.924-0.924H4.955c-0.51,0-0.924,0.414-0.924,0.924v3.697\n      	c0,0.51,0.414,0.924,0.924,0.924h0.861c-0.298,2.815-1.837,6.206-3.223,9.238c-1.262,2.763-2.259,4.946-2.259,6.473v23.104\n      	c0,3.058,2.487,5.545,5.545,5.545h9.242c3.058,0,5.545-2.487,5.545-5.545V21.713c0-1.527-0.997-3.709-2.259-6.473\n      	C17.021,12.208,15.481,8.817,15.183,6.002\"/><polygon id=milk mask=url(#milk-mask) points=\"5.172,49.474 2.73,48.364 1.287,44.368 1.287,21.388 7.057,5.447 14.238,5.447\n      	19.713,21.388 19.713,45.589 17.826,48.697 15.162,49.474 \"/></svg></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/loadingUdder/loadingUdder.html","<div class=loading-udder><svg version=1.1 class=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 211.845 400\" enable-background=\"new 0 0 211.845 213.55\" xml:space=preserve><path class=teat-left fill=#FF6600 d=\"M92.922,146.775h-40v46.776c0,0.001,0,0.002,0,0.002c0,10.971,8.999,19.866,19.971,19.866\n  		s19.918-8.784,19.918-19.755c0,0,0.052,0.11,0.052,0.11h0.058V146.775z\"/><path class=utter-top fill=#FF6600 d=\"M105.828,127.868c-36.444,0-66.095-30.093-66.095-66.093l-0.144-62H-0.078v62\n  		c0,58,47.514,105.826,105.867,105.826s105.845-47.939,105.845-105.939l0.21-61.887h-39.589l-0.335,61.887\n  		C171.921,97.662,142.272,127.868,105.828,127.868z\"/><path class=teat-right fill=#FF6600 d=\"M157.922,146.775h-40v46.769c0,0.003,0,0.006,0,0.01c0,10.971,9.111,19.866,20.083,19.866\n  		c10.972,0,19.974-8.784,19.974-19.755c0,0,0.108,0.11,0.108,0.11h-0.165V146.775z\"/><path class=milk-right fill=#FF6600 d=\"M138.559,203.123L138.559,203.123c-2.463,0-4.478-2.015-4.478-4.478v-29.496\n    	c0-2.463,2.015-4.478,4.478-4.478l0,0c2.463,0,4.478,2.015,4.478,4.478v29.496C143.038,201.107,141.022,203.123,138.559,203.123z\"/><path class=milk-left fill=#FF6600 d=\"M72.922,203.123L72.922,203.123c-2.463,0-4.478-2.015-4.478-4.478v-29.496c0-2.463,2.015-4.478,4.478-4.478\n    	h0c2.463,0,4.478,2.015,4.478,4.478v29.496C77.4,201.107,75.385,203.123,72.922,203.123z\"/></svg></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/localSearch/localSearch.html","<input type=text class=form-control id=main-search placeholder=\"{{\'EnterFarmName\' | translate}}\" ng-model=$ctrl.searchStr ng-change=$ctrl.filterResult($ctrl.searchStr)>");
$templateCache.put("app/shared-components/angular-ui-components/components/missingEstrusFormFields/missingEstrusFormFields.html","<div class=\"row missing-estrus-form-fields\"><div class=col-sm-6><div class=form-group><label for=after-treatment>{{\"cycle-alerts-days-to-scan-after-treatment\" | translate}}</label><input type=number min=1 class=form-control id=after-treatment ng-model=$ctrl.farmPreferences.missingEstrus.daysToScan.afterTreatment required></div><div class=form-group><label for=after-calving-heifer>{{\"cycle-alerts-days-to-scan-after-calving-heifer\" | translate}}</label><input type=number min=1 class=form-control id=after-calving-heifer ng-model=$ctrl.farmPreferences.missingEstrus.daysToScan.afterCalving.heifer required></div><div class=form-group><label for=after-calving-mature>{{\"cycle-alerts-days-to-scan-after-calving-mature\" | translate}}</label><input type=number min=1 class=form-control id=after-calving-mature ng-model=$ctrl.farmPreferences.missingEstrus.daysToScan.afterCalving.mature required></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/pageAlert/pageAlert.html","<div class=page-alert><ng-transclude></ng-transclude></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/progressBar/progressbar.html","<section class=\"colored-progress-bar {{$ctrl.className}}\"><div class=progress-label>{{$ctrl.label}}</div><div class=\"outer block-row\"><div class=inner style=\"width: {{$ctrl.value}}%\"></div></div></section>");
$templateCache.put("app/shared-components/angular-ui-components/components/ranking/cowEntry.html","<label for=checkbox-{{$ctrl.cow.CowID}} ng-if=!$ctrl.heading class=\"cow-entry block-column\" ng-class=$ctrl.getClassName()><input type=checkbox class=hidden id=checkbox-{{$ctrl.cow.CowID}}><section class=block-row><div class=cow-id>{{$ctrl.cow.Tag}}</div><div class=cow-status>{{($ctrl.getCowState())}}</div><div class=arrow>Details</div></section><div class=cow-details><h4>{{\"RANKING_COW_HEADER\" | translate}}</h4><colored-progress-bar ng-repeat=\"bar in $ctrl.getProgressbars() | orderBy: \'className\'\" label={{$ctrl.getLabel(bar.className)}} class-name={{bar.className}} value=\"bar.values.Score * 100 | number:0\"></colored-progress-bar><p class=go-to-details><a href=#!/cow/{{$ctrl.cow.CowID}} ng-click=$ctrl.goToCow($event)>{{\"RANKING_BTN_TEXT_COW_PROFILE\" | translate}}</a></p></div></label><section class=\"cow-entry heading block-column\" ng-class=$ctrl.getHeadingClassName() ng-if=$ctrl.heading><h3>{{$ctrl.heading.title}}</h3><p>{{$ctrl.heading.description}}</p></section>");
$templateCache.put("app/shared-components/angular-ui-components/components/scrollingStackedBars/scrollingStackedBars.html","<section class=scrolling-stacked-bars><section class=\"block-row bars\"><div class=section ng-repeat=\"section in $ctrl.sections\" ng-style=$ctrl.getInlineStyle(section) ng-class=section.name></div></section><section class=scroll-indicator><rzslider rz-slider-model=$ctrl.scrollPosition rz-slider-options=$ctrl.sliderOptions></rzslider></section></section>");
$templateCache.put("app/shared-components/angular-ui-components/components/sectionNav/sectionNav.html","<div class=section-nav role=navigation><ul class=\"nav navbar-nav\"><li ng-class=\"($root.currentPage === item.state ? \'active\' : \'\')\" ng-repeat=\"item in items\"><a ng-href={{item.url}}>{{item.title}}</a></li></ul></div><!-- .subnav -->");
$templateCache.put("app/shared-components/angular-ui-components/components/subNav/subNav.html","<div class=\"navbar subnav navbar-inverse no-border\" role=navigation><div class=\"collapse navbar-collapse small-caps\"><ul class=\"nav navbar-nav\"><li ng-class=\"($root.currentPage === item.state ? \'active\' : \'\')\" ng-repeat=\"item in items\"><a ui-sref={{item.state}}>{{item.title}}</a></li></ul></div></div><!-- .subnav -->");
$templateCache.put("app/views/accountManagement/farms/farm/farmDetailsPanel/farmDetailsPanel.html","<div><farm-details-form-fields farm=farm></farm-details-form-fields><div class=form-group><label for=customerID>Customer*</label><select class=form-control id=customerID ng-model=farm.customerID ng-options=\"customer.CustomerID as (customer.customerName) for customer in customers\" required></select></div><div class=form-group><label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label><p><button type=button class=\"btn btn-sm btn-wide btn-success\" ng-click=updateFarm()><i class=\"fa fa-floppy-o\" aria-hidden=true></i> Save</button><save-status-inline status=status class=inline-block></save-status-inline></p></div></div>");
$templateCache.put("app/views/accountManagement/farms/farm/farmUsersPanel/farmUsersPanel.html","<div><farm-details-form-fields farm=farm on-blur=updateFarm()></farm-details-form-fields><save-status-inline status=status></save-status-inline></div>");
$templateCache.put("app/views/accountManagement/farms/farm/livestockPanel/livestockPanel.html","<div><herd-group-list farms=farms herd-groups=herdGroups sensors=sensors cows=cows details=\"{\n     headingMinimal: true,\n     showHerdGroupDetails: true,\n     showHerdGroupCows: true\n   }\"></herd-group-list><br><br><div class=text-right><a class=\"btn btn-primary btn-sm\" ng-click=\"showForm = (showForm === \'herdGroup\' ? \'\' : \'herdGroup\')\">Add new herd group</a> <a class=\"btn btn-primary btn-sm\" ng-click=\"showForm = (showForm === \'cow\' ? \'\' : \'cow\')\">Add new cow</a></div><br><div class=\"panel panel-default\" ng-if=\"showForm===\'herdGroup\'\"><div class=panel-heading><h2>Add new herd group</h2></div><div class=panel-body><new-herd-group-form farm-id=farmId success-callback=herdGroupAdded(herdGroup)></new-herd-group-form></div></div><div class=\"panel panel-default\" ng-if=\"showForm===\'cow\'\"><div class=panel-heading><h2>Add new cow</h2></div><div class=panel-body><new-cow-form farm-id=farmId success-callback=cowAdded(cow)></new-cow-form></div></div></div>");
$templateCache.put("app/views/accountManagement/farms/farm/hardwarePanel/hardwarePanel.html","<div><base-station-list farms=farms base-stations=baseStations sensors=sensors cows=cows details=\"{\n     headingMinimal: true,\n     showBaseStationDetails: true,\n     showBaseStationConfigDetails: true,\n     showBaseStationSensors: true\n   }\"></base-station-list><br><br><!-- <div class=\"text-right\">\n     <a class=\"btn btn-primary btn-sm\" ng-click=\"showForm = (showForm === \'baseStation\' ? \'\' : \'baseStation\')\">Add new base station</a>\n     <a class=\"btn btn-primary btn-sm\" ng-click=\"showForm = (showForm === \'sensor\' ? \'\' : \'sensor\')\">Add new sensor</a>\n   </div>\n\n   <br>\n\n   <div class=\"panel panel-default\" ng-if=\"showForm===\'baseStation\'\">\n     <div class=\"panel-heading\">\n       <h2>Add new base station</h2>\n     </div>\n     <div class=\"panel-body\">\n       <new-base-station-form farm-id=\"farmId\" success-callback=\"baseStationAdded(baseStation)\"></new-base-station-form>\n     </div>\n   </div>\n\n   <div class=\"panel panel-default\" ng-if=\"showForm===\'sensor\'\">\n     <div class=\"panel-heading\">\n       <h2>Add new sensor</h2>\n     </div>\n     <div class=\"panel-body\">\n       <new-sensor-form farm-id=\"farmId\" success-callback=\"sensorAdded(sensors)\"></new-sensor-form>\n     </div>\n   </div> --></div>");
$templateCache.put("app/views/hardware/lifeCycle/components/dropDown/dropDown.html","<div class=\"life-cycle-drop-down x-flex x-align-center\"><p>{{$ctrl.title}}</p><div class=form-group><select type=select class=form-control ng-options=\"obj.id as obj.value for obj in $ctrl.list\" ng-model=$ctrl.formData[$ctrl.formDataKey]></select></div></div>");
$templateCache.put("app/views/main/systemMonitorsPanel/systemMonitorParent/systemMonitorChild/systemMonitorChild.html","<div class=table-list-item ng-class=\"monitor.passRate >= successThreshold/100 ? \'item-success\' : (monitor.passRate >= warningThreshold/100 ? \'item-warning\' : \'item-danger\')\"><!-- <system-monitor-td ng-click=\"toggleMonitorDetails(monitor);\" monitor=\"monitor\"></system-monitor-td> --><div class=row ng-click=\"expanded=!expanded\"><div class=col-xs-6>{{monitor.monitorName}}</div><div class=\"col-xs-6 col-sm-3 bullets\"><span ng-repeat=\"monitor in monitors\" class=bullet ng-class=\"monitor.passRate >= successThreshold/100 ? \'bullet-success\' : (monitor.passRate >= warningThreshold/100 ? \'bullet-warning\' : \'bullet-danger\')\"></span><loading-spinner ng-if=loading class=inline-block></loading-spinner></div><div class=\"col-sm-3 hidden-xs\"><span am-time-ago=monitor.lastRunTime data-toggle=tooltip data-placement=top title=\"{{ monitor.lastRunTime | date : \'medium\' }}\" class=small></span></div></div><!-- .row --><div class=\"row table-list-detail table-list-detail-white\" ng-if=expanded><!-- <div class=\"col-sm-4\">\n      <div ng-repeat=\"monitor in monitors | filter : {monitorName: \'![Cow]\'}\">\n        <span class=\"bullet\" ng-class=\"monitor.passRate === 1 ? \'bullet-success\' : (monitor.passRate > 0 ? \'bullet-warning\' : \'bullet-danger\')\"></span> {{monitor.monitorName}}\n      </div>\n    </div> --><div class=col-sm-12><system-monitor-chart-panel monitor-id=monitor.referenceID day-options=[1,3,7,31]></system-monitor-chart-panel></div></div><div class=\"row table-list-detail table-list-detail-white\" ng-if=\"expanded && monitors.length\"><div class=col-sm-12><div class=table-list><div class=\"table-list-heading table-list-heading-minimal\"><div class=row><div class=col-xs-12>Sensors</div></div></div><div class=table-list-items><system-monitor-grand-child ng-repeat=\"monitor in monitors\" monitor=monitor ng-init=\"singleMonitor = (monitors.length === 1)\" expanded=singleMonitor success-threshold=successThreshold warning-threshold=warningThreshold></system-monitor-grand-child></div></div></div><!--\n\n\n    <a ng-click=\"showMonitorDetailsTable=!showMonitorDetailsTable\" ng-show=\"monitors.length>0\">Details</a>\n    <system-monitor-details-table monitor=\"monitor\" ng-if=\"monitors.length===0 || showMonitorDetailsTable===true\"></system-monitor-details-table>\n    <div ng-if=\"monitors.length>0\">\n      <ul class=\"child-monitors\">\n        <system-monitor-child ng-repeat=\"childMonitor in monitors\" monitor=\"childMonitor\"></system-monitor-child>\n      </ul>\n    </div> --></div><!-- .monitor-details --></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/calvingValidation/calvingValidation.html","<div ng-class=\"($ctrl.buttonStyle === \'simple\' ? \'insight-calving-form-simple\' : \'insight-calving-form\')\"><div ng-if=\"$ctrl.buttonStyle === \'simple\'\" ng-class=\"($ctrl.insight.calved === null ? \'untouched\' : \'touched\')\"><a class=no-animate ng-click=\"$ctrl.toggleCowHasCalved($ctrl.insight, true)\" ng-if=\"$ctrl.insight.calved !== false\" ng-class=\"($ctrl.insight.calved === true  ? \'color-success\' : \'\')\"><span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span><insight-resolution-title insight=$ctrl.insight update=$ctrl.insight.insightResolution.length ng-show=\"$ctrl.insight.calved === true && $ctrl.showResolutions\"></insight-resolution-title><span ng-show=\"$ctrl.insight.calved === true && !$ctrl.showResolutions\">{{\'LABEL_TEXT_CALVED\' | translate}}</span> </a><a class=no-animate ng-click=\"$ctrl.toggleCowHasCalved($ctrl.insight, false)\" ng-if=\"$ctrl.insight.calved !== true\" ng-class=\"($ctrl.insight.calved === false ? \'color-danger\'  : \'\')\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span><insight-resolution-title insight=$ctrl.insight update=$ctrl.insight.insightResolution.length ng-show=\"$ctrl.insight.calved === false\"></insight-resolution-title></a></div><div ng-if=\"$ctrl.buttonStyle !== \'simple\'\" class=\"btn-group btn-group-justified\"><a class=\"no-animate btn\" ng-click=\"$ctrl.toggleCowHasCalved($ctrl.insight, true)\" ng-class=\"($ctrl.insight.calved === true ? \'btn-default\' : ($ctrl.insight.calved === null ? \'btn-default\' : \'btn-white\'))\"><!-- ng-class=\"($ctrl.insight.calved === true  ? \'color-success\' : \'\')\" --> <span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-show=\"$ctrl.insight.calved === true\">{{\'LABEL_TEXT_CALVED\' | translate}}</span> </a><a class=\"no-animate btn\" ng-click=\"$ctrl.toggleCowHasCalved($ctrl.insight, false)\" ng-class=\"($ctrl.insight.calved === false ? \'btn-default\' : ($ctrl.insight.calved === null ? \'btn-default\' : \'btn-white\'))\"><!-- ng-class=\"($ctrl.insight.calved === false ? \'color-danger\'  : \'\')\" --> <span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> <span ng-show=\"$ctrl.insight.calved === false\">{{\'LABEL_TEXT_NOT_CALVED\' | translate}}</span></a></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/adminInsightValidations/adminInsightValidations.html","<div class=validation-btns><div ng-show=$ctrl.adminValidation class=no-animate><a class=\"validation-btn validation-invalid\" ng-click=\"$ctrl.validateInsight($ctrl.adminValidation, \'No\')\" ng-class=\"($ctrl.adminValidation.validation === \'No\'    ? \'active\' : ($ctrl.adminValidation.validation ? \'inactive\' : \'\'))\"></a> <a class=\"validation-btn validation-maybe\" ng-click=\"$ctrl.validateInsight($ctrl.adminValidation, \'Maybe\')\" ng-class=\"($ctrl.adminValidation.validation === \'Maybe\' ? \'active\' : ($ctrl.adminValidation.validation ? \'inactive\' : \'\'))\"></a> <a class=\"validation-btn validation-valid\" ng-click=\"$ctrl.validateInsight($ctrl.adminValidation, \'Yes\')\" ng-class=\"($ctrl.adminValidation.validation === \'Yes\'   ? \'active\' : ($ctrl.adminValidation.validation ? \'inactive\' : \'\'))\"></a></div><p>admin validation</p></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/cowDetailsBar/cowDetailsBar.html","<div ng-show=$ctrl.details class=row ng-class=$ctrl.mainClass><div ng-class=\"$ctrl.detailsClass + ($first ? \' \'+$ctrl.detailsClassFirst : \'\')\" ng-repeat=\"(key, value) in $ctrl.details\"><h6>{{ value.title | translate }}</h6><p ng-if=value.value>{{ value.value }} <small ng-if=value.addition class=inline-block>{{ value.addition }}</small></p><svg-icon ng-if=!value.value icon=missing-data></svg-icon></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightAdminDetails/insightAdminDetails.html","<div><div class=text-right style=\"position:absolute; right: 15px; padding: 0.5em; z-index: 1\"><a ng-click=\"showAdminDetails=!showAdminDetails\" style=\"color: #fff; padding: 0.5em; font-size: 1.5em\"><span class=\"glyphicon glyphicon-list-alt\" aria-hidden=true></span></a></div><!-- Insight details. --><div class=\"bg-system color-white text-center\" style=\"padding: 0.5em\" ng-if=showAdminDetails class=container><h3>Insight Details</h3><!-- Farm information. --> <samp><p><span>Farm: <strong>{{$ctrl.farm.farmName}}</strong><br></span><span>Farm ID: <strong>{{$ctrl.insight.farmID}}</strong><br></span><span ng-if=$ctrl.insight.herdGroupID>Herd Group ID: <strong>{{$ctrl.insight.herdGroupID}}</strong><br></span><span ng-if=$ctrl.insight.dairyCowID>Cow ID: <strong>{{$ctrl.insight.dairyCowID}}</strong><br></span></p><p><span>Data quality: <strong>{{$ctrl.insight.dataQuality}}</strong><br></span><span>Insight Type ID: <strong>{{$ctrl.insight.insightTypeID}}</strong><br></span><span>Insight Type Name: <strong>{{$ctrl.insight.insightType.typeName}}</strong><br></span><span>Model Sources: <strong>{{$ctrl.insight.modelSources}}</strong><br></span></p><p><span>Start Epoch: <strong>{{$ctrl.insight.startEpoch}}</strong><br></span><span>End Epoch: <strong>{{$ctrl.insight.endEpoch}}</strong><br></span><span>Created Epoch: <strong>{{$ctrl.insight.createdEpoch}}</strong><br></span></p><p><span>Start Date: <strong>{{ $ctrl.insight.startEpoch*1000 | date:\'medium\' }}</strong><br></span><span>End Date: <strong>{{ $ctrl.insight.endEpoch*1000 | date:\'medium\' }}</strong><br></span><span>Created Date: <strong>{{ $ctrl.insight.createdEpoch*1000 | date:\'medium\' }}</strong><br></span></p><p><span>Creation Latency: <strong ng-init=\"$ctrl.latency = $ctrl.timeBetween($ctrl.insight.startEpoch, $ctrl.insight.createdEpoch)\"><span ng-repeat=\"(key, value) in $ctrl.latency\" ng-if=\"value != 0\">{{value}}{{key[0]}}</span></strong></span></p><!-- Insight state selector. --><div class=form-inline><div class=form-group ng-class=\"($ctrl.insight.insightState !== \'live\' && $ctrl.insight.insightState !== \'archive\' ? \'has-warning\' : \'has-success\')\">Insight state<select class=\"form-control input-sm\" ng-options=\"state for state in $ctrl.insightStates\" ng-model=$ctrl.insight.insightState ng-change=\"$ctrl.updateInsight($ctrl.insight, true)\"></select></div></div></samp><p style=\"margin-top: 1em\"><a class=\"btn btn-xs btn-info\" ng-click=\"showJson=!showJson\">Full JSON Bourne</a><pre ng-if=showJson class=slide-down>\n        <code>{{ $ctrl.insight | json}}</code>\n      </pre></p><!-- Insight admin validation. --><admin-insight-validations generic-insight-id=$ctrl.insight.GenericInsightID></admin-insight-validations></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightChecks/insightChecks.html","<!-- Insight check wizard. --><section class=insight-checks-wizard ng-class=$ctrl.getClassName()><div class=insight-checks-wizard-questions ng-cloak ng-show=!$ctrl.isLoading><section class=wizard-header><h3 class=insight-checks-title>Diagnosing cow #{{ $ctrl.insight.dairyCow.cowTagNumber }}</h3><a class=toggle-history ng-show=$ctrl.history.length ng-click=$ctrl.onHistoryClicked() ng-class=\"($ctrl.currentViewState === $ctrl.viewStates.history ? \'icon-question\' : \'icon-history\')\"></a></section><!-- Insight check history. --><section class=insight-checks-history ng-show=\"$ctrl.currentViewState === $ctrl.viewStates.history\"><question ng-repeat=\"insightCheck in $ctrl.history\" value=insightCheck.checkState option-selected=\"$ctrl.onSelectOption(insightCheck, value)\" variant=compact>{{ insightCheck.check | loco | translate }}</question></section><!-- Show current question. --><section class=insight-check-questions-container ng-show=\"$ctrl.currentViewState === $ctrl.viewStates.question\"><a class=insight-check-questions-prev ng-class=\"{ invisible: !$ctrl.mayGoBackInTime }\" ng-click=$ctrl.onPreviousCheckClicked()></a><question value=$ctrl.currentInsightCheck.checkState option-selected=\"$ctrl.onSelectOption($ctrl.currentInsightCheck, value)\">{{ $ctrl.currentInsightCheck.check | loco | translate }}</question><a class=insight-check-questions-next ng-class=\"{ invisible: !$ctrl.mayGoForwardInTime }\" ng-click=$ctrl.onNextCheckClicked()></a></section><!-- Show results. --><section class=insight-check-results-container ng-show=\"$ctrl.currentViewState === $ctrl.viewStates.results\"><h4>{{\"insight-diagnostics.header.results\" | translate}}</h4><p ng-if=$ctrl.hasResolutions()>{{\"insight-diagnostics.description.most-likely\" | translate}}</p><p ng-if=!$ctrl.hasResolutions()>{{\"insight-diagnostics.description.no-results\" | translate}}</p></section></div><!-- Possible resolutions. --><resolution-list insight=$ctrl.insight resolutions=$ctrl.possibleResolutions variant=$ctrl.resolutionVariants[$ctrl.currentViewState] resolution-selected=$ctrl.onResolutionSelected(insightResolution)></resolution-list><div class=loading-cover ng-show=$ctrl.isLoading><loading-bar></loading-bar></div></section>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightInsemination/insightInsemination.html","<div ng-class=\"($ctrl.buttonStyle === \'simple\' ? \'insight-insemination-form-simple\' : \'insight-insemination-form\')\"><div ng-if=\"$ctrl.buttonStyle === \'simple\'\" ng-class=$ctrl.getTouchedClassName()><a class=no-animate ng-click=\"$ctrl.inseminationToggle($ctrl.insight, true)\" ng-if=$ctrl.showTick() ng-class=$ctrl.getToggleColor()><span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-show=\"$ctrl.insight.inseminated === true\">{{\'inseminated\' | translate}}</span> </a><a class=no-animate ng-click=\"$ctrl.inseminationToggle($ctrl.insight, false)\" ng-if=$ctrl.showCross() ng-class=$ctrl.getToggleColor()><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span><insight-resolution-title max-length=1 insight=$ctrl.insight update=$ctrl.insight.insightResolution.length></insight-resolution-title></a></div><div ng-if=\"$ctrl.buttonStyle !== \'simple\'\" class=\"btn-group btn-group-justified\"><a class=\"no-animate btn\" ng-click=\"$ctrl.inseminationToggle($ctrl.insight, true)\" ng-class=\"($ctrl.insight.inseminated === true   ? \'btn-default\' : ($ctrl.insight.inseminated === null ? \'btn-default\' : \'btn-white\'))\"><!-- ng-class=\"($ctrl.insight.inseminated === true  ? \'color-success\' : \'\')\" --> <span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-show=\"$ctrl.insight.inseminated === true\">{{\'inseminated\' | translate}}</span> </a><a class=\"no-animate btn\" ng-click=\"$ctrl.inseminationToggle($ctrl.insight, false)\" ng-class=\"($ctrl.insight.inseminated === false   ? \'btn-default\' : ($ctrl.insight.inseminated === null ? \'btn-default\' : \'btn-white\'))\"><!-- ng-class=\"($ctrl.insight.inseminated === false ? \'color-danger\'  : \'\')\" --> <span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> <span ng-show=\"$ctrl.insight.inseminated === false\">{{\'not inseminated\' | translate}}</span></a></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightResolution/insightResolution.html","<div class=insight-resolution-form><script type=text/ng-template id=/resolution-row-template.html><div class=\"angucomplete-holder\" ng-class=\"{\'angucomplete-dropdown-visible\': showDropdown}\">\n      <div class=\"input-group\">\n        <div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span></div>\n        <input ng-model=\"searchStr\"\n          ng-disabled=\"disableInput\"\n          type=\"text\"\n          placeholder=\"{{placeholder}}\"\n          ng-focus=\"onFocusHandler()\"\n          class=\"{{inputClass}}\"\n          ng-focus=\"resetHideResults()\"\n          ng-blur=\"hideResults($event)\"\n          autocapitalize=\"off\"\n          autocorrect=\"off\"\n          autocomplete=\"off\"\n          ng-change=\"inputChangeHandler(searchStr)\"/>\n        </div>\n      </div>\n      <div class=\"angucomplete-dropdown\" ng-show=\"showDropdown\">\n        <div class=\"angucomplete-searching\" ng-show=\"searching\" ng-bind=\"textSearching\"></div>\n        <!-- <div class=\"angucomplete-searching\" ng-show=\"!searching && (!results || results.length == 0)\" ng-bind=\"textNoResults\"></div> -->\n        <div class=\"angucomplete-row\" ng-repeat=\"result in results\" ng-click=\"selectResult(result)\" ng-mouseenter=\"hoverRow($index)\" ng-class=\"{\'angucomplete-selected-row\': $index == currentIndex}\">\n          <div class=\"angucomplete-title\" ng-if=\"matchClass\" ng-bind-html=\"result.title\"></div>\n          <div class=\"angucomplete-title\" ng-if=\"!matchClass\">{{ result.translation }}</div>\n        </div>\n        <div class=\"angucomplete-row\" ng-show=\"searchStr\" ng-click=\"selectResult({title: searchStr, originalObject: { title:searchStr, custom: true, translation:searchStr }})\" ng-mouseenter=\"hoverRow(results.length)\" ng-class=\"{\'angucomplete-selected-row\': results.length == currentIndex}\">\n          <div class=\"angucomplete-title\">{{\"LABEL_TEXT_ADD_CUSTOM_LABEL\" | translate : {label: searchStr} }}</div>\n        </div>\n      </div>\n    </div></script><section ng-if=$ctrl.showResolutions class=slide-down><ng-transclude></ng-transclude><p><a class=\"pil pil-default active no-animate\" ng-repeat=\"resolution in $ctrl.insightResolution | filter: {hidden: \'!true\'}\" ng-click=$ctrl.removeResolution(resolution)>{{resolution.title | translate}} <span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a> <a class=\"btn btn-xs btn-white no-animate\" ng-hide=$ctrl.editingResolutions ng-click=\"$ctrl.editingResolutions=true\">{{\'add more\' | translate}}</a></p><div ng-show=$ctrl.editingResolutions><div ng-show=$ctrl.showingOtherResolutionForm><h6>{{ \"search & add\" | translate }}</h6><form ng-submit=$ctrl.resolutionFormSubmitted()><div class=resolution-input angucomplete-alt id=resolutionAutocomplete placeholder=\"{{\'LABEL_TEXT_START_TYPING\' | translate}}\" pause=100 selected-object=$ctrl.resolutionSelected input-changed=$ctrl.resolutionInputChanged clear-selected=true focus-first=true local-data=$ctrl.resolutionsFiltered title-field=translation search-fields=translation minlength=0 input-class=\"form-control form-control-small\" template-url=/resolution-row-template.html match-class=strong auto-match=true></div></form><!-- <a\n          ng-click=\"$ctrl.hideOtherResolutionForm()\"\n        >{{\'show suggestions\' | translate}}</a> --></div><div ng-hide=$ctrl.showingOtherResolutionForm><!-- <h6>{{ \"top suggestions\" | translate }}</h6> --><p><a class=\"pil pil-default no-animate\" ng-repeat=\"resolution in $ctrl.resolutionsFiltered | limitTo:$ctrl.visibleResolutionLimit || 8\" ng-click=\"$ctrl.addResolution(resolution, true)\" ng-class=\"($ctrl.inResolutionList(resolution) ? \'hidden\' : \'\')\">{{resolution.title | translate}}</a> <a class=\"btn btn-xs btn-white\" ng-click=$ctrl.showOtherResolutionForm()>{{\'add other\' | translate}}</a></p></div></div></section><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightResolutionTitle/insightResolutionTitle.html","<div class=inline-block><span><span ng-if=\"$ctrl.showCowTag && $ctrl.insight.dairyCow\">#{{$ctrl.insight.dairyCow.cowTagNumber}} </span>{{$ctrl.resolutionTitle}}</span><div ng-show=$ctrl.subTitle class=\"gray small strong\"><span class=capitalize>{{ $ctrl.subTitle }}</span></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightResolutionModal/insightResolutionModal.html","<div ng-class=\"($ctrl.modalVisible ? \'in\' : \'\')\" id=resolutionModal class=\"modal fade\" tabindex=-1 role=dialog><div class=modal-dialog role=document><div class=modal-content><div class=modal-body><h4 ng-if=$ctrl.title class=modal-title>{{$ctrl.title | translate: $ctrl.insight.dairyCow }}</h4><insight-resolution insight-is-valid=$ctrl.insight.insightValid ng-if=$ctrl.modalVisible update-insight-resolution=$ctrl.updateInsightResolution(insightResolution) insight-resolution=$ctrl.insight.insightResolution insight=$ctrl.insight><section class=\"dnb-info alert-info small\" ng-if=\"$ctrl.isDysonEnabled() && $ctrl.resolvedAsDNB($ctrl.insight)\">{{$ctrl.copy.dnbWarning | translate}}</section></insight-resolution><ng-transclude></ng-transclude></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$ctrl.hideModal()>Close</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal -->");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightRibbon/insightRibbon.html","<div class=insight-ribbon><div class=ribbon-text>{{$ctrl.text}}</div><div class=children ng-class=$ctrl.getAdminClassName()><ng-transclude></ng-transclude></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightValidation/insightValidation.html","<div class=insight-validation-form><section><legacy-validation-question insight=$ctrl.insight><mute-repeat-offender ng-if=$ctrl.isRepeatOffender($ctrl.insight) class-name=\"btn-white btn-sm\" ng-click=$ctrl.onMuteClicked() insight=$ctrl.insight></mute-repeat-offender></legacy-validation-question><div class=\"btn-group btn-group-justified\" ng-class=\"$ctrl.insightValidation.validation !== \'NA\' ? \'btn-group-xs\' : \'\'\"><a class=btn ng-click=\"$ctrl.validateInsight($ctrl.insightValidation, \'Yes\')\" ng-class=\"$ctrl.getButtonClassName(\'Yes\')\">{{\"yes\" | translate}}</a> <a class=btn ng-click=\"$ctrl.validateInsight($ctrl.insightValidation, \'Maybe\')\" ng-class=\"$ctrl.getButtonClassName(\'Maybe\')\">{{\"maybe\" | translate}}</a> <a class=btn ng-click=\"$ctrl.validateInsight($ctrl.insightValidation, \'No\')\" ng-class=\"$ctrl.getButtonClassName(\'No\')\">{{\"no\" | translate}}</a></div></section><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div><mute-repeat-offender-modal insight=$ctrl.insight modal-visible=$ctrl.repeatOffenderModalVisible hide-modal=$ctrl.hideRepeatOffenderModal()></mute-repeat-offender-modal>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/muteRepeatOffenderModal/muteRepeatOffenderModal.html","<div ng-class=\"($ctrl.modalVisible ? \'in\' : \'\')\" id=muteRepeatOffenderModal class=\"modal fade\" tabindex=-1 role=dialog><div ng-if=$ctrl.modalVisible class=modal-dialog role=document><div class=modal-content><div class=modal-body><h4 class=modal-title>{{$ctrl.getTitle()}}</h4><div><a class=\"pil pil-default no-animate\" ng-repeat=\"interval in $ctrl.intervals\" ng-click=$ctrl.presetClicked(interval)>{{interval.label}}</a></div><label for=customMuteInterval class=control-label>{{\'custom mute period\' | translate}}</label><div class=mute-interval-input><input id=customMuteInterval type=number ng-model=$ctrl.customMutePeriod ng-change=$ctrl.customMutePeriodChanged() placeholder=\"{{\'number of\' | translate}}\" class=\"form-control input-s\"> <span>{{\'days\' | translate}}</span></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$ctrl.onClose()>{{$ctrl.closeButtonText}}</button></div></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/muteRepeatOffender/muteRepeatOffender.html","<button ng-class=$ctrl.getClassName()>{{$ctrl.getButtonText()}}</button>");
$templateCache.put("app/shared-components/angular-ui-components/components/labels/editLabel/editLabel.html","<div class=page-panel><section><label-details-form label=$ctrl.label simple-header=true hide-fields=$ctrl.hideFields themed-header=$ctrl.themedHeader></label-details-form><div class=container><div class=page-panel-content><div class=row><div class=col-sm-6><div class=form-group><button type=submit class=\"btn btn-block btn-danger\" ng-click=$ctrl.delete($ctrl.label)>{{\"BUTTON_TEXT_DELETE\" | translate}}</button></div></div><div class=col-sm-6><div class=form-group><button type=submit class=\"btn btn-block btn-success\" ng-click=$ctrl.update($ctrl.label)>{{\"BUTTON_TEXT_UPDATE\" | translate}}</button></div></div></div></div></div></section></div><!--.container --><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/validationQuestion/validationQuestion.html","<div class=validation-question><h3 class=font-brand>{{$ctrl.getQuestion()}}</h3><div class=children><ng-transclude></ng-transclude></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/labels/labelDetailsForm/labelDetailsForm.html","<form class=label-detail-form><!-- DEFAULT HEADER --><div ng-if=\"!$ctrl.themedHeader && $ctrl.hideFields.indexOf(\'header\') === -1\" class=page-panel-header ng-class=\"\'bg-\'+$ctrl.label.category\"><div class=container><div class=row><div class=\"col-sm-12 text-center\"><h3>{{ \"PAGE_TITLE_RegisterEvent\" | translate }}</h3><p>{{ \"RegisterEventIntro\" | translate }}</p></div></div></div></div><!-- SIMPLE (THEMED) HEADER --><div ng-if=\"$ctrl.themedHeader && $ctrl.hideFields.indexOf(\'header\') === -1\" class=page-panel-header ng-class=\"\'bg-\'+$ctrl.label.category\"><div class=container><div class=row><div class=\"col-sm-12 text-center\"><h3><a ng-if=\"$ctrl.label.labelScope === \'cow\' && $ctrl.label.dairyCowID\" ng-repeat=\"cow in $ctrl.cows | filter : {DairyCowID : $ctrl.label.dairyCowID}\" go-forward ui-sref=\"cow({cowID: $ctrl.label.dairyCowID})\" class=no-animate>#{{cow.cowTagNumber}} </a>{{ $ctrl.label.title | translate }}</h3><p ng-if=$ctrl.label.description>{{ $ctrl.label.description | translate }}</p><div ng-show=\"$ctrl.hideFields || $ctrl.hideFields.indexOf(\'subject\') === -1\"><div class=form-group ng-show=\"$ctrl.label.labelScope  === \'cow\'\"><select type=select class=form-control id=cowID ng-model=$ctrl.label.dairyCowID ng-options=\"cow.DairyCowID as (cow.cowTagNumber+\' \'+ (cow.cowName ? cow.cowName : \'\')) for cow in $ctrl.cows\" ng-change=$ctrl.changeLabelSubject()><option value=\"\" disabled selected>{{ \'Select a cow\' | translate }}</option></select></div></div></div></div></div></div><!-- PAGE CONTENT  --><div class=container><div class=page-panel-content><!-- ADMIN CONTROLS --><div ng-if=\"$ctrl.isAuthorized(\'Admin\')\"><!-- CUSTOMER VISIBLE TRUE/FALSE --><div class=form-group ng-if=\"$ctrl.hideFields.indexOf(\'visibility\') === -1\"><label>Visibility</label><div class=\"btn-group btn-group-justified\"><a class=\"no-animate btn\" ng-click=\"$ctrl.label.customerVisible = false\" ng-class=\"($ctrl.label.customerVisible === false   ? \'btn-default\' : \'btn-white\')\">Admin only </a><a class=\"no-animate btn\" ng-click=\"$ctrl.label.customerVisible = true\" ng-class=\"($ctrl.label.customerVisible === true   ? \'btn-default\' : \'btn-white\')\">Farmers</a></div></div><!-- TAGS (CURATED, etc) --><div class=form-group><label>Tags</label><p ng-show=$ctrl.label.tags.length><a class=\"pil pil-default active no-animate\" ng-repeat=\"tag in $ctrl.label.tags\" ng-click=$ctrl.removeTagFromLabel(tag)>{{tag}} <span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></p><!-- SUGGESTIONS --><p ng-show=$ctrl.tags.length><a class=\"pil pil-default no-animate\" ng-repeat=\"tag in $ctrl.tags\" ng-click=$ctrl.addTagToLabel(tag) ng-class=\"($ctrl.label.tags.indexOf(tag) > -1 ? \'hidden\' : \'\')\">{{tag}}</a></p></div><div class=form-group><label for=showMarkers><input type=checkbox id=showMarkers ng-model=$ctrl.showMarkers ng-change=$ctrl.toggleMarkers()> Markers</label></div></div><div ng-if=\"$ctrl.hideFields !== true\"><!-- FARM SELECT --><div ng-show=\" $ctrl.isAuthorized(\'Admin\') && $ctrl.hideFields.indexOf(\'farm\') === -1\" ng-if=$ctrl.farms class=form-group><label for=farmID>{{\"LABEL_TEXT_FARM\" | translate}}*</label><select type=select class=form-control id=farmID ng-model=$ctrl.label.farmID ng-options=\"farm.FarmID as (farm.farmName) for farm in $ctrl.farms\" ng-change=$ctrl.loadFarmData()></select></div><!-- LABEL SCOPE --><div ng-show=\"$ctrl.hideFields.indexOf(\'scope\') === -1\" class=form-group><label for=labelCategory>{{\"LABEL_TEXT_What is the event for\" | translate}}*</label><div class=\"btn-group btn-group-justified\"><a class=btn ng-repeat=\"option in $ctrl.labelScopes\" ng-click=$ctrl.changeLabelScope(option) ng-class=\"($ctrl.label.labelScope  === option ? \'btn-default\' : \'btn-white\')\">{{\"SELECT_TEXT_\"+option | translate}}</a></div></div><!-- SUBJECT (COW/FARM) --><div ng-show=\"$ctrl.hideFields.indexOf(\'subject\') === -1\"><div class=form-group ng-show=\"$ctrl.label.labelScope  === \'cow\' && $ctrl.cows\"><select type=select class=form-control id=cowID ng-model=$ctrl.label.dairyCowID ng-options=\"cow.DairyCowID as (cow.cowTagNumber+\' \'+ (cow.cowName ? cow.cowName : \'\')) for cow in $ctrl.cows\" ng-change=$ctrl.changeLabelSubject()></select></div></div><div ng-show=\"$ctrl.hideFields.indexOf(\'herdGroups\') === -1\"><div class=form-group ng-show=\"$ctrl.label.labelScope  === \'herd\' && $ctrl.herdGroups\"><select type=select class=form-control ng-model=$ctrl.label.herdGroupID ng-options=\"herdGroup.HerdGroupID as herdGroup.groupName for herdGroup in $ctrl.herdGroups\"></select></div></div><!-- @TODO: cow and herd drop down being triggered at the start so need to rely on these. Check if these create any problems --><div ng-if=\"$ctrl.label.dairyCowID || $ctrl.label.herdGroupID || $ctrl.label.labelScope === \'farm\'\"><div ng-show=\"$ctrl.label.labelScope  === \'herd\'\"><label-events update-event=$ctrl.updateEvent(events) label-event-type=group_event selected-event-ids=$ctrl.events></label-events></div><!-- CATEGORY (HEALTH, FERTILITY, etc) --><div ng-show=\"$ctrl.hideFields.indexOf(\'category\') === -1\" class=form-group><label for=labelCategory>{{\"LABEL_TEXT_CATEGORY\" | translate}}*</label><div class=label-types><a ng-repeat=\"labelCategory in $ctrl.labelCategories\" role=button ng-click=$ctrl.changeLabelCategory(labelCategory.id) class=\"label-button text-center\" ng-class=\"\'label-button-\'+labelCategory.id+\' \'+($ctrl.label.category === labelCategory.id ? \'active\': \'\')\"><figure></figure><span>{{\'SELECT_TEXT_\'+labelCategory.name | translate}}</span></a></div></div><!-- TITLE --><div ng-show=\"$ctrl.hideFields.indexOf(\'title\') === -1 && $ctrl.label.labelScope  !== \'herd\'\" class=form-group><label for=title>{{\"LABEL_TEXT_TITLE\" | translate}}*</label><input type=text class=form-control id=title ng-model=$ctrl.label.title required></div><!-- DESCRIPTION --><div ng-show=\"$ctrl.hideFields.indexOf(\'description\') === -1\" class=form-group><label for=description>{{\"LABEL_TEXT_SHORT_DESCRIPTION\" | translate}}</label><textarea class=form-control id=description ng-model=$ctrl.label.description></textarea></div></div></div><!-- ng-if=\"!$ctrl.hideForm\" --><div ng-if=$ctrl.isDatePickerEnabled() ng-show=\"$ctrl.hideFields.indexOf(\'startEndDate\') === -1\"><h3 class=font-brand>{{ \'When did this event occur?\' | translate }}</h3><div class=form-group><label for=manual-start>{{\"LABEL_TEXT_START_DATE_TIME\" | translate}}</label><input class=form-control type=datetime-local id=manual-start name=manual-start ng-model=$ctrl._label.startEpoch ng-model-options=\"{ getterSetter: true }\" ng-change=$ctrl.manualStartChanged()></div><div class=form-group><label for=manual-end>{{\"LABEL_TEXT_END_DATE_TIME\" | translate}}</label><input class=form-control type=datetime-local id=manual-end name=manual-end ng-model=$ctrl._label.endEpoch ng-model-options=\"{ getterSetter: true }\" ng-change=$ctrl.manualEndChanged()></div></div><!-- INSEMINATED TRUE/FALSE --><div ng-if=$ctrl.isEstrusLabel($ctrl.label) ng-show=$ctrl.label.dairyCowID class=form-group><h3 class=font-brand>{{ \'Have you inseminated this cow?\' | translate }}</h3><div class=\"btn-group btn-group-justified\"><a class=\"no-animate btn\" ng-click=\"$ctrl.label.description = \'inseminated\';\" ng-class=\"($ctrl.label.description === \'inseminated\' ? \'btn-default\' : \'btn-white\')\"><span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> <span ng-show=\"$ctrl.label.description === \'inseminated\'\">{{\'inseminated\' | translate}}</span> </a><a class=\"no-animate btn\" ng-click=\"$ctrl.label.description = \'not inseminated\'\" ng-class=\"($ctrl.label.description === \'not inseminated\'   ? \'btn-default\' : \'btn-white\')\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> <span ng-show=\"$ctrl.label.description === \'not inseminated\'\">{{\'not inseminated\' | translate}}</span></a></div></div><!-- VISUALISATIONS/CHARTS --><div ng-if=$ctrl.visualisations><date-period-selector start-date=$ctrl.startDate end-date=$ctrl.endDate day-range=$ctrl.dayRange day-options=[1,3,7,31,183] on-date-change=\"$ctrl.onDateChange(startDate, endDate)\"></date-period-selector><div ng-repeat=\"chart in $ctrl.visualisations.charts\"><h3 class=font-brand>{{ chart.title | translate }}</h3><ctra-data-visualisation display-values=chart.displayValues context-menu=chart.contextMenu on-insight-clicked=$ctrl.onInsightClicked(insight) range-picker=$ctrl.rangePickerObj on-range-picker-changed=$ctrl.onRangePickerChanged(rangePicker) start-date=$ctrl.startDate end-date=$ctrl.endDate on-date-change=\"$ctrl.onDateChange(startDate, endDate)\" hidden-data=[$ctrl.label.GenericLabelID] class=block></ctra-data-visualisation></div></div></div></div></form>");
$templateCache.put("app/shared-components/angular-ui-components/components/labels/labelEvents/labelEvents.html","<div class=\"form-group label-event-form\"><label>{{\"LABEL_TEXT_herd_event\" | translate}}*</label><div><!-- selected tags --> <a class=\"pil pil-default active no-animate\" ng-repeat=\"event in $ctrl.activeEvents\" ng-click=$ctrl.removeEvent(event) ng-class=\"(event.active == false ? \'hidden\' : \'\')\">{{event.title}} <span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a><div class=input-group ng-show=$ctrl.showAddOtherForm><div class=input-group-addon><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></div><input ng-model=$ctrl.customEvent type=text placeholder=\"Start Typing\" ng-keyup=\"$event.keyCode == 13 ? $ctrl.saveCustomEvent() : null\"></div><!-- SUGGESTIONS --><div ng-hide=$ctrl.showAddOtherForm><!-- <h6>{{ \"top suggestions\" | translate }}</h6> --><p><a class=\"pil pil-default no-animate\" ng-repeat=\"event in $ctrl.activeEvents\" ng-click=$ctrl.addEvent(event) ng-class=\"(event.active ? \'hidden\' : \'\')\">{{event.title}}</a> <a class=\"btn btn-xs btn-white\" ng-click=$ctrl.toggleAddOtherForm()>{{\'add other\' | translate}}</a></p></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/labels/labelsList/labelsList.html","<div class=\"table-list table-list-md\"><div class=\"table-list-heading table-list-heading-minimal\"><div class=row><div class=col-xs-2>Scope</div><div class=col-xs-2>Subject</div><div class=col-xs-5>Title</div><div class=col-xs-2>Category</div></div></div><div class=table-list-items><div class=table-list-item ng-repeat=\"label in $ctrl.labels\" ng-class=\"($ctrl.currentListItem === label.GenericLabelID ? \'active\' : \'\')\"><div class=row ng-click=$ctrl.rowClicked(label) role=button><div class=col-xs-2>{{\"SELECT_TEXT_\"+label.labelScope | translate}}</div><div class=\"col-xs-2 strong\">{{(label.labelScope === \'cow\' ? \'#\'+($ctrl.cows | filter : {DairyCowID: label.dairyCowID}: true)[0].cowTagNumber : \'\')}} {{(label.labelScope === \'herdGroup\' ? ($ctrl.herdGroups | filter : {HerdGroupID: label.herdGroupID})[0].groupName : \'\')}}</div><div class=col-xs-5>{{label.title}}</div><div class=col-xs-2>{{label.category}}</div><div class=table-list-item-expand-btn></div></div><div class=\"row table-list-detail\" ng-if=\"$ctrl.currentListItem === label.GenericLabelID\"><div class=col-sm-12>{{label | json}}<!-- <label-details-form label=\"label\"></label-details-form>\n\n          <div class=\"form-group\">\n            <label>{{\"LABEL_TEXT_ACTIONS\" | translate}}</label>\n            <p>\n              <button type=\"button\" class=\"btn btn-sm btn-wide btn-danger\" ng-click=\"$ctrl.delete(label)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i> Delete</button>\n              <button type=\"submit\" class=\"btn btn-sm btn-wide btn-success\" ng-click=\"$ctrl.update(label)\"><i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Save</button>\n            </p>\n          </div> --></div><!-- row --></div><!-- .table-list-detail --></div><!-- .table-list-item --><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/labels/newLabel/newLabel.html","<div class=page-panel><section ng-if=!$ctrl.success><label-details-form label=$ctrl.label themed-header=$ctrl.themedHeader hide-fields=$ctrl.hideFields form-style=$ctrl.formStyle farms=$ctrl.farms></label-details-form><div class=container><div class=page-panel-content><div class=form-group><p><button type=submit class=\"btn btn-block btn-success\" ng-show=$ctrl.labelFormValid() ng-click=$ctrl.save($ctrl.label) main-page-button>{{\"BUTTON_TEXT_SAVE\" | translate}}</button></p></div></div></div></section><section ng-if=$ctrl.success><div class=container><div class=page-panel-content><div class=\"alert alert-success\" role=alert ng-if=$ctrl.success>{{$ctrl.success}}</div><div class=row><div class=col-sm-6><div class=form-group><button type=submit class=\"btn btn-block btn-default\" ng-click=\"$ctrl.success = \'\'\">{{\"BUTTON_TEXT_ADD_ANOTHER_EVENT\" | translate}}</button></div></div><div class=col-sm-6><div class=form-group><button type=submit class=\"btn btn-block btn-success\" back-button go-back>{{\"BUTTON_TEXT_DONE\" | translate}}</button></div></div></div></div></div></section></div><!--.container --><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div>");
$templateCache.put("app/views/accountManagement/farms/farm/livestockPanel/newHerdGroupForm/newHerdGroupForm.html","<form ng-submit=newHerdGroup() data-toggle=validator><div class=form-group><label for=groupName>{{\"LABEL_TEXT_NAME\" | translate}}</label><input type=text class=form-control id=groupName ng-model=newHerdGroupObj.groupName></div><div class=form-group><label for=groupDescription>{{\"LABEL_TEXT_DESCRIPTION\" | translate}}</label><textarea class=form-control id=groupDescription ng-model=newHerdGroupObj.groupDescription style=height:118px></textarea></div><div class=form-group><label for=farmID>{{\"LABEL_TEXT_FARM\" | translate}}</label><select class=form-control id=farmID ng-model=newHerdGroupObj.farmID ng-options=\"farm.FarmID as (farm.farmName) for farm in farms\" required></select></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_CREATE\" | translate}}</button></div><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div></form>");
$templateCache.put("app/views/accountManagement/farms/farm/hardwarePanel/newBaseStationForm/newBaseStationForm.html","<form ng-submit=newBaseStation() data-toggle=validator><div class=form-group><label for=farmName>{{\"LABEL_TEXT_SERIALNUMBER\" | translate}}</label><input type=text class=form-control id=deviceSerialNum ng-model=newBaseStationObj.deviceSerialNum required></div><div class=form-group><label for=deviceName>{{\"LABEL_TEXT_NAME\" | translate}}</label><input type=text class=form-control id=deviceName ng-model=newBaseStationObj.deviceName></div><div class=form-group><label for=deviceDescription>{{\"LABEL_TEXT_DESCRIPTION\" | translate}}</label><textarea class=form-control id=deviceDescription ng-model=newBaseStationObj.deviceDescription style=height:118px></textarea></div><div class=form-group><label for=deviceInstallationDate>{{\"LABEL_TEXT_INSTALLATION_DATE\" | translate}}</label><date-picker date=deviceInstallationDate required></date-picker></div><div class=form-group><label for=deviceManufactureDate>{{\"LABEL_TEXT_MANUFACTURE_DATE\" | translate}}</label><date-picker date=deviceManufactureDate required></date-picker></div><div class=form-group><label for=farmID>{{\"LABEL_TEXT_FARM\" | translate}}</label><select class=form-control id=farmID ng-model=newBaseStationObj.farmID ng-options=\"farm.FarmID as (farm.farmName) for farm in farms\" required></select></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_CREATE\" | translate}}</button></div><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div></form>");
$templateCache.put("app/views/accountManagement/farms/farm/hardwarePanel/newSensorForm/newSensorForm.html","<form ng-submit=newSensor() data-toggle=validator><div class=form-group><label for=batchCreate><input type=checkbox ng-model=batchCreate id=batchCreate value=true> Create a batch of sensors</label></div><div ng-hide=batchCreate><div class=\"form-group no-animate\"><label for=farmName>{{\"LABEL_TEXT_SERIALNUMBER\" | translate}}*</label><input type=text class=form-control id=deviceSerialNum ng-model=newSensorObj.deviceSerialNum placeholder=\"long serial number\"></div><div class=\"form-group no-animate\"><label for=farmName>{{\"LABEL_TEXT_SHORTSERIALNUMBER\" | translate}}*</label><input type=text class=form-control id=shortSerialNum ng-model=newSensorObj.shortSerialNum placeholder=\"short serial number\"></div></div><div class=\"form-group no-animate\" ng-show=batchCreate><label for=farmName>{{\"LABEL_TEXT_SERIALNUMBERS\" | translate}}</label><textarea rows=5 class=\"form-control no-animate\" id=deviceSerialNum ng-model=deviceSerialNumbers placeholder=\"One serial number per line\"></textarea></div><!-- <div class=\"form-group\">\n    <label for=\"transmissionAddress\">{{\"LABEL_TEXT_TRANSMISSION_ADDRESS\" | translate}}*</label>\n    <input type=\"text\" class=\"form-control\" id=\"transmissionAddress\" ng-model=\"newSensorObj.transmissionAddress\" required>\n  </div> --><div class=row><div class=col-sm-4 ng-repeat=\"(key, value) in sensorsBatchOptions\"><div class=form-group><label for={{key}}>{{key}}</label><select class=form-control id={{key}} ng-model=batch[key] ng-options=\"key2 as (value2) for (key2, value2) in sensorsBatchOptions[key]\" required></select></div></div><div class=col-sm-4><div class=form-group><label for=deviceDescription>Batch number</label><input type=text class=form-control id=deviceDescription ng-model=newSensorObj.deviceName></div></div></div><!-- <div class=\"form-group\">\n    <label for=\"deviceInstallationDate\">{{\"LABEL_TEXT_INSTALLATION_DATE\" | translate}}</label>\n    <date-picker date=\"deviceInstallationDate\" required=\"true\"></date-picker>\n  </div> --><div class=form-group><label for=deviceManufactureDate>{{\"LABEL_TEXT_MANUFACTURE_DATE\" | translate}}</label><date-picker date=deviceManufactureDate required></date-picker></div><div class=form-group><label for=baseStationID>{{\"LABEL_TEXT_BASESTATION\" | translate}}</label><select class=form-control id=baseStationID ng-model=newSensorObj.baseStationID ng-options=\"baseStation.BaseStationID as (\'#\'+baseStation.BaseStationID + \' - \' + baseStation.deviceName) for baseStation in (baseStations | filter: {farmID : newCowObj.farmID} : true) | orderBy:\'deviceName\'\"></select></div><div class=form-group><label for=createAndConnectToCows><input type=checkbox ng-model=createAndConnectToCows id=createAndConnectToCows value=true> Create a cow and pre-link sensor(s)</label></div><div ng-show=createAndConnectToCows><div class=form-group><label for=farmID>{{\"LABEL_TEXT_FARM\" | translate}}*</label><select class=form-control id=farmID ng-model=newCowObj.farmID ng-options=\"farm.FarmID as (farm.farmName) for farm in farms\"></select></div><div class=form-group><label for=herdGroupID>{{\"LABEL_TEXT_HERD_GROUP\" | translate}}*</label><select class=form-control id=herdGroupID ng-model=newCowObj.herdGroupID ng-options=\"herdGroup.HerdGroupID as (herdGroup.groupName) for herdGroup in (herdGroups | filter: {farmID : newCowObj.farmID} : true)\"></select></div></div><div class=form-group><label>&nbsp;</label><button type=submit class=\"btn btn-primary btn-block btn-lg\">{{\"BUTTON_TEXT_CREATE\" | translate}}</button></div><div class=\"alert alert-danger\" role=alert ng-if=error>{{error}}</div><div class=\"alert alert-success\" role=alert ng-if=success>{{success}}</div><!-- <sensor-list sensors=\"sensors\" cows=\"cows\" base-stations=\"baseStations\" farms=\"farms\" selectable=\"true\" selectable=\"true\" selected-sensors=\"selectedSensors\" details=\"(inlineEdit ? editDetails : details)\" ng-init=\"details={\n    headingMinimal:       false,\n    NodeID:               \'col-xs-1\',\n    transmissionAddress:  \'col-xs-3\',\n    baseStation:          \'col-xs-3\',\n    DairyCowIDTagNumber:  \'col-xs-3\',\n    deviceDMLastPingTime: \'col-xs-2\'}; editDetails={\n      headingMinimal:           false,\n      NodeID:                   \'col-xs-1\',\n      transmissionAddressInput: \'col-xs-3\',\n      baseStationSelect:        \'col-xs-3\',\n      cowSelect:                \'col-xs-3\',\n      deviceDMLastPingTime:     \'col-xs-2\'}\"></sensor-list> --></form>");
$templateCache.put("app/views/main/systemMonitorsPanel/systemMonitorParent/systemMonitorChild/systemMonitorGrandChild/systemMonitorGrandChild.html","<div class=table-list-item ng-class=\"monitor.passRate >= successThreshold/100 ? \'item-success\' : (monitor.passRate >= warningThreshold/100 ? \'item-warning\' : \'item-danger\')\"><!-- <system-monitor-td ng-click=\"toggleMonitorDetails(monitor);\" monitor=\"monitor\"></system-monitor-td> --><div class=row ng-click=\"expanded=!expanded\"><div class=col-xs-6>{{monitor.monitorName}}</div><div class=\"col-xs-6 col-sm-3 bullets\"><span ng-repeat=\"monitor in monitors\" class=bullet ng-class=\"monitor.passRate >= successThreshold/100 ? \'bullet-success\' : (monitor.passRate >= warningThreshold/100 ? \'bullet-warning\' : \'bullet-danger\')\"></span><loading-spinner ng-if=loading class=inline-block></loading-spinner></div><div class=\"col-xs-6 col-sm-3\"><span am-time-ago=monitor.lastRunTime data-toggle=tooltip data-placement=top title=\"{{ monitor.lastRunTime | date : \'medium\' }}\" class=small></span></div></div><!-- .row --><div class=\"row table-list-detail table-list-detail-white\" ng-if=expanded><div class=col-sm-4><h6>Current Status</h6><p></p><div ng-repeat=\"monitor in monitors\"><span class=bullet ng-class=\"monitor.passRate >= successThreshold/100 ? \'bullet-success\' : (monitor.passRate >= warningThreshold/100 ? \'bullet-warning\' : \'bullet-danger\')\"></span> {{monitor.monitorName}} <small class=gray>{{monitor.passRate*100 | number : 2}}%</small></div><p></p></div><div class=col-sm-8><system-monitor-chart-panel monitor-id=monitor.referenceID child-monitors=monitors day-options=[1,3]></system-monitor-chart-panel></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightChecks/question/question.html","<!-- Question component with possible answers. --><div class=insight-check-question ng-class=$ctrl.className><h4 class=insight-check-question-title><ng-transclude></h4><!-- YES/NO/MAYBE --><yes-no-maybe variant=$ctrl.variant option-selected=$ctrl.onSelectOption(value) value=$ctrl.value></yes-no-maybe></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightChecks/resolutions/resolutions.html","<div class=insight-checks-wizard-resolutions><div ng-if=$ctrl.insight.insightResolution.length class=selected-resolutions><h5>{{\"insight-diagnostics.header.your-selection\" | translate}}</h5><span ng-repeat=\"resolution in $ctrl.insight.insightResolution\" class=pil ng-click=$ctrl.onSelectResolution(resolution)>{{ resolution.title | lowercase |translate }} <span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></span></div><!-- Show the most likely suggestions. --><div ng-show=$ctrl.resolutions.likely.length><h5>{{\"insight-diagnostics.header.most-likely\" | translate}}</h5><span ng-repeat=\"resolution in $ctrl.resolutions.likely\" class=pil ng-click=$ctrl.onSelectResolution(resolution)>{{ resolution.title | lowercase | translate }}</span></div><!-- Show top suggestions. --><div ng-show=$ctrl.resolutions.possible.length><h5>{{\"insight-diagnostics.header.top-suggestions\" | translate}}</h5><p>{{\"insight-diagnostics.description.based-on-answers\" | translate}}</p><span ng-repeat=\"resolution in $ctrl.resolutions.possible\" class=pil ng-click=$ctrl.onSelectResolution(resolution)>{{ resolution.title | lowercase | translate }}</span></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/askIda/components/askIdaChange/askIdaChange.html","<div class=\"row bg-lightgray ask-ida-change-wrapper\"><div class=col-sm-12><p class=\"lead text-center\"><strong>{{$ctrl.getSummary()}}</strong></p></div></div><div ng-if=!$ctrl.isAnalysed() class=row><div class=\"col-sm-12 ask-ida-analysing-icon-wrapper\"><svg-icon icon=magnifying-ellipsis></svg-icon></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/askIda/components/chartDescription/chartDescription.html","<p class=\"ask-ida-chart-description lead\"><span>{{$ctrl.getBaseDescription()}} </span><span>{{$ctrl.getShortDescription()}} </span><span ng-if=\"$ctrl.verbose && $ctrl.isSignificant()\">{{$ctrl.getExtendedDescription()}}</span></p>");
$templateCache.put("app/shared-components/angular-ui-components/modules/askIda/components/base/base.html","<div id=ask-ida-panel><share-ribbon ng-if=$ctrl.farmName class=screenshot-visible>{{$ctrl.farmName}}</share-ribbon><div class=container><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div><ask-ida-header ida-question=$ctrl.idaQuestion></ask-ida-header><ask-ida-change ida-question=$ctrl.idaQuestion></ask-ida-change><ask-ida-chart ida-question=$ctrl.idaQuestion></ask-ida-chart><div class=row><div class=col-sm-12><p class=\"text-center ask-ida-panel-button\"><button class=\"btn btn-danger btn-wide\" ng-click=$ctrl.deleteQuestion()>{{\'delete question\' | translate}}</button></p></div></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/askIda/components/chart/chart.html","<div ng-if=$ctrl.isAnalysed() ng-repeat=\"visualisation in $ctrl.visualisations\" class=ask-ida-visualisation-container><div class=row><div class=\"col-sm-6 col-sm-offset-3\"><div class=\"x-flex x-direction-row\"><div class=ask-ida-header-icon-container><svg-icon ng-if=visualisation.significant icon=magnifying-graph></svg-icon><svg-icon ng-if=!visualisation.significant icon=magnifying-question-mark></svg-icon></div><h2>{{visualisation.title}}<div ng-if=$ctrl.getTooltip(visualisation) tooltips tooltip-template={{$ctrl.getTooltip(visualisation)}} tooltip-side=left class=ask-ida-header-tooltip-container><span class=\"glyphicon glyphicon-question-sign\" aria-hidden=true></span></div></h2></div><p ng-if=visualisation.error class=\"alert alert-warning\">{{visualisation.error}}</p><p ng-if=visualisation.description>{{visualisation.description}}</p></div></div><div ng-repeat=\"chart in visualisation.charts\" class=row><div class=\"col-sm-6 col-sm-offset-3\"><header><h3 ng-if=\"visualisation.charts.length > 1\">{{chart.title}}</h3><chart-description chart=chart></chart-description></header><canvas height=50px width=100px ng-id=chart.title class=\"chart chart-bar\" chart-data=chart.data chart-dataset-override=chart.datasetOverride chart-labels=chart.labels chart-series=chart.series chart-colors=chart.chartColors chart-options=chart.chartOptions></canvas></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlan/components/base/gamePlan.html","<div class=game-plan><section class=bg-gray><game-plan-title game-plan=$ctrl.gamePlan partner=$ctrl.partner></game-plan-title></section><section class=\"bg-white container\"><game-plan-section ng-if=$ctrl.gamePlan.description title=\"{{$ctrl.getTranslatedContent(\'label\', \'description\')}}\"><game-plan-description content=$ctrl.gamePlan.description truncate-word-count=20></game-plan-description></game-plan-section><game-plan-section ng-hide=true inline title=\"{{$ctrl.getTranslatedContent(\'label\', \'cows-to-track\')}}\">{{$ctrl.getTranslatedContent(\"label\", \"all-cows\")}}</game-plan-section><game-plan-task-list tasks=$ctrl.getTasks() disabled collapsed-view-task-limit=3 options=$ctrl.getOptions()></game-plan-task-list></section><section class=\"bg-gray container\"><game-plan-meta title=\"$ctrl.getTranslatedContent(\'label\', \'kpi-to-target\')\" value=\"$ctrl.getTranslatedKpiContent(\'displayName\', $ctrl.dataDescriptor.dataTypeName)\"></game-plan-meta><div class=\"x-flex x-direction-row x-grow-1 metadata\"><game-plan-meta numeric=true title=\"$ctrl.getTranslatedContent(\'label\', \'current-average\')\" value=$ctrl.getHumanReadableMeta($ctrl.kpiAverage) description=\"$ctrl.getTranslatedContent(\'label\', \'monthly-average\')\"></game-plan-meta><game-plan-meta numeric=true title=\"$ctrl.getTranslatedContent(\'label\', \'kpi-goal\')\" value=$ctrl.getHumanReadableMeta($ctrl.gamePlan.goal.value)></game-plan-meta></div><game-plan-graph ng-if=$ctrl.mongoChart url=$ctrl.mongoChart></game-plan-graph></section></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlan/components/description/gamePlanDescription.html","<div class=game-plan-description ng-class=$ctrl.getClassName()><p>{{$ctrl.getTruncatedContent()}}<span ng-if=\"$ctrl.mayTruncate() && !$ctrl.expanded\">...</span> <button class=btn-link ng-if=$ctrl.mayTruncate() ng-click=$ctrl.toggle()>{{$ctrl.getButtonText()}}</button></p></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/askIda/components/header/header.html","<header class=text-center><div class=row><div class=col-sm-12><h2 ng-hide=$ctrl.isAnalysed()>{{$ctrl.translateContent(\'no-results-yet\')}}</h2><h2 ng-show=$ctrl.isAnalysed()>{{$ctrl.translateContent(($ctrl.idaQuestion.active ? \'intermediate-results\' : \'final-results\' ))}}</h2></div></div><div class=row><div class=col-sm-12><p class=lead>{{$ctrl.getQuestionTitle($ctrl.idaQuestion)}}</p></div></div></header>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlan/components/graph/gamePlanGraph.html","<div class=game-plan-graph><h4>{{ \"game-plan-label-kpi-trend\" | translate }}</h4><iframe ng-src={{$ctrl.url}} frameborder=0></iframe></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlan/components/meta/meta.html","<div class=\"game-plan-meta x-flex x-direction-column\" ng-class=$ctrl.getClassName()><h4>{{$ctrl.title}}</h4><p class=value>{{$ctrl.value}}</p><p class=small ng-if=$ctrl.description>{{$ctrl.description}}</p></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlan/components/section/gamePlanSection.html","<div class=\"game-plan-section x-flex\" ng-class=$ctrl.getClassName()><div class=section-title>{{$ctrl.title}}</div><div class=section-content><ng-transclude></ng-transclude></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlan/components/title/gamePlanTitle.html","<div class=game-plan-title><h2>{{ $ctrl.gamePlan.title }}</h2><p class=date-range>{{ $ctrl.getDateRange() }}</p><p class=created-by ng-if=!!$ctrl.user>{{ $ctrl.getCreatedBy() }}</p></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlan/components/task/task.html","<div class=\"game-plan-task x-flex\" ng-class=getClassName() ng-click=handleClick()><div class=\"x-flex game-plan-task-desktop-view\"><div class=checkbox-outer><div class=checkbox-inner><svg-icon icon=tail-spin ng-if=fetching></svg-icon><svg-icon icon=tick ng-if=\"!fetching && task.status === 1\"></svg-icon><svg-icon icon=close ng-if=\"!fetching && task.status === 2\"></svg-icon></div></div><div class=\"metadata x-flex x-direction-column task-container\" ng-class=\"options.showInlineMobileView ? \'\' : \'task-container-mobile-view\'\" ng-if=extended><div class=\"task-label x-flex x-space-between\"><div class=task-text>{{task.label}}</div><div class=\"x-flex x-space-between task-meta-info\" ng-class=\"options.showInlineMobileView ? \'\' : \'task-meta-info-desktop-view\'\"><div class=\"x-flex user-info\" ng-if=showUserName()><span>{{getUserName()}}</span></div><div class=\"x-flex due-date due-date-color\" ng-if=showDueDate() ng-class=\"isTaskValid() ? \'\' : \'invalid\'\"><svg-icon icon=calendar></svg-icon><span class=text>{{formatDueDate()}}</span></div></div></div><div class=last-updated ng-class=\"!$ctrl.isTaskValid() && task.status === 0 ? \'color-thunderbird\' : \'\'\">{{getLastModifiedDate()}}</div></div></div><!-- In case of detail page we need to show something totally different on mobile for the for meta --><!-- in case of mobile we have a separate --><div ng-if=options.showSeparateMetaViewForMobile class=\"x-flex task-meta-info-mobile-view\" ng-class=\"(showUserName() || showDueDate()) ? \'task-meta-info-border\' : \'\'\"><div class=user-info ng-if=showUserName()><div class=section-content>{{$ctrl.translateContent(\'tasks\', \'assigned\')}}</div><span>{{getUserName()}}</span></div><div class=due-date ng-if=showDueDate()><div class=section-content>{{$ctrl.translateContent(\'tasks\', \'due-date\')}}</div><div class=\"x-flex x-align-center due-date-color\" ng-class=\"isTaskValid() ? \'\' : \'color-thunderbird\'\"><svg-icon icon=calendar></svg-icon><span class=text>{{formatDueDate()}}</span></div></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlan/components/taskList/taskList.html","<div ng-class=$ctrl.getClassName() class=\"game-plan-task-list x-flex\"><div class=\"task-list-header x-flex x-space-between\" ng-if=$ctrl.options.showHeader><div class=task-title>{{$ctrl.translateContent(\'tasks\', \'title\', {onlyLoggedInUserTasks: !!$ctrl.options.onlyLoggedInUserTasks})}}</div><div class=\"x-flex x-space-between task-meta-header\" ng-class=\"$ctrl.options.showInlineMobileView ? \'task-meta-header-mobile-view\' : \'\'\" ng-if=$ctrl.tasks.length><div class=section-content ng-if=$ctrl.options.showUser>{{$ctrl.translateContent(\'tasks\', \'assigned\')}}</div><div class=\"section-content due-date\" ng-if=$ctrl.options.showDate>{{$ctrl.translateContent(\'tasks\', \'due-date\')}}</div></div></div><div ng-hide=\"$ctrl.options.hideEmptyStateMessage || $ctrl.tasks.length\"><i class=empty-list>{{$ctrl.translateContent(\'tasks\', \'empty-state\')}}</i></div><game-plan-task fetching=$ctrl.isFetching(task.id) task=task extended=!$ctrl.inline on-state-change=$ctrl.updateTask class=item ng-repeat=\"task in $ctrl.tasks | limitTo: $ctrl.getListLimit()\" disabled options=$ctrl.options ng-if=$ctrl.tasks.length></game-plan-task><button type=button class=\"btn btn-dark\" ng-click=$ctrl.toggleShowMore() ng-if=$ctrl.tasks.length ng-show=\"$ctrl.tasks.length > $ctrl.collapsedViewTaskLimit\">{{$ctrl.getTranslatedContent()}}</button></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlanList/components/emptyList/emptyList.html","<div class=game-plan-empty-list-container><div class=compass-icon-container><svg-icon icon=compass></svg-icon></div><div class=title>{{$ctrl.getTranslatedContent(\"empty-list\", \"title\", { variant: $ctrl.variant })}}</div><div class=description>{{$ctrl.getTranslatedContent(\"empty-list\", \"description\", { variant: $ctrl.variant })}}</div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlanList/components/listEntry/listEntry.html","<div class=\"game-plan-entry x-flex x-direction-row x-grow-1\" ng-click=$ctrl.goToGamePlan()><div class=\"x-box x-shrink-0 icon-gameplan\"><svg-icon icon=compass></svg-icon></div><div class=\"x-box x-grow-1 game-plan-entry-detail-container\"><div class=title-description-container><h1 class=title>{{$ctrl.gamePlan.title}}</h1><p class=description>{{$ctrl.getTranslatedContent(\"label\", \"kpi-to-target\")}}: {{$ctrl.getTranslatedKpiContent(\"displayName\",$ctrl.dataDescriptor.dataTypeName) }}</p><p class=date-range>{{ $ctrl.getDateRange() }}</p><!-- For desktop view --><p class=partner-info ng-if=!!$ctrl.user>{{ $ctrl.getCreatedBy() }}</p></div><game-plan-task-list inline=true tasks=$ctrl.gamePlan.taskList disabled options=$ctrl.getOptions()></game-plan-task-list><div class=\"x-flex x-direction-row x-grow-1 metadata\"><game-plan-meta numeric=true title=\"$ctrl.getTranslatedContent(\'label\', \'current-average\')\" value=$ctrl.getHumanReadableMeta($ctrl.kpiAverage) description=\"$ctrl.getTranslatedContent(\'label\', \'monthly-average\')\"></game-plan-meta><game-plan-meta numeric=true title=\"$ctrl.getTranslatedContent(\'label\', \'kpi-goal\')\" value=$ctrl.getHumanReadableMeta($ctrl.gamePlan.goal.value) class=kpi-goal></game-plan-meta></div><!-- For mobile view --><div class=created-by ng-if=!!$ctrl.user>{{ $ctrl.getCreatedBy() }}</div></div><div class=\"x-box x-shrink-0 icon-navigation\"><svg-icon icon=arrow></svg-icon></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/gamePlanList/components/listWrapper/listWrapper.html","<div class=\"game-plan-list x-flex x-direction-column\"><div class=loading-cover ng-show=$ctrl.fetching><loading-bar></loading-bar></div><game-plan-list-empty-state variant=$ctrl.variant ng-if=\"!$ctrl.fetching && !$ctrl.gamePlans.length\"></game-plan-list-empty-state><game-plan-entry game-plan=gamePlan ng-repeat=\"gamePlan in $ctrl.gamePlans\"></game-plan-entry></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/genericInsight/components/base/genericInsight.html","<div class=GenericInsight ng-class=$ctrl.getWrapperClassName()><!-- If you are admin, you may take a look at the insight JSON. Handy for debugging. --><insight-admin-details insight=$ctrl.insight ng-if=\"$ctrl.isAuthorized(\'Admin\')\"></insight-admin-details><!-- Page wrapper with category class name --><div class=page-panel id=insight-page-panel ng-class=$ctrl.getCategoryClassName()><!-- Loading indicator --><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div><!-- Insight title with resolution (if applicable) --><insight-headline-factory insight=$ctrl.insight is-graph-loading=$ctrl.isGraphLoading></insight-headline-factory><!-- Insight description, validation, resolution options and graphs --><div class=container><div class=page-panel-content><!-- Insight description --><insight-description-factory insight=$ctrl.insight></insight-description-factory><!-- Create and instance of the insight subclass --><ng-include src=$ctrl.resolveFromInsightType()></ng-include><!-- Each insight may have validation options, get their own --><insight-validation-factory insight=$ctrl.insight></insight-validation-factory><!-- Insight extensions --><insight-extension-factory insight=$ctrl.insight></insight-extension-factory><!-- Each insight may have charts, get their own --><insight-chart-factory insight=$ctrl.insight set-loading-graphs=$ctrl.setLoadingGraphs(loading)></insight-chart-factory></div></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/genericInsight/components/baseStationIsOffline/baseStationIsOffline.html","<!-- nothingness -->");
$templateCache.put("app/shared-components/angular-ui-components/modules/genericInsight/components/contextDetails/contextDetails.html","<div class=\"row context-details\"><div class=\"alpha omega\" ng-class=$ctrl.getItemClassName() ng-repeat=\"(key, meta) in $ctrl.state\"><h6>{{ meta.title | translate }}</h6><p>{{ $ctrl.translateValue(meta.value) }} <small ng-if=meta.addition class=inline-block><span ng-if=meta.showAdditionBracket>(</span> {{ $ctrl.translateValue(meta.addition) }} <span ng-if=meta.showAdditionBracket>)</span></small></p></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/genericInsight/components/calvingInsight/calvingInsight.html","<cow-details-bar ng-if=$ctrl.insight.dairyCowID insight=$ctrl.insight cow=$ctrl.insight.dairyCow></cow-details-bar>");
$templateCache.put("app/shared-components/angular-ui-components/modules/genericInsight/components/factory/insightFactory.html","<ng-include src=$ctrl.resolve()></ng-include>");
$templateCache.put("app/shared-components/angular-ui-components/modules/genericInsight/components/herdInsight/herdInsight.html","<div class=herd-insight><h4 class=resolution-question>{{$ctrl.translateResolutionQuestion()}}</h4><insight-resolution update-insight-resolution=$ctrl.updateInsightResolution(insightResolution) insight-resolution=$ctrl.insight.insightResolution insight=$ctrl.insight insight-is-valid=$ctrl.insight.insightValid visible-resolution-limit=9></insight-resolution></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/genericInsight/components/missingEstrus/missingEstrus.html","<div class=missing-estrus-container><context-details insight=$ctrl.insight params=$ctrl.contextParams cow=$ctrl.insight.dairyCow></context-details></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/genericInsight/components/noSensorOnCow/noSensorOnCowInsight.html","<context-details insight=$ctrl.insight params=$ctrl.contextParams cow=$ctrl.insight.dairyCow></context-details>");
$templateCache.put("app/shared-components/angular-ui-components/modules/genericInsight/components/sensorOffCow/sensorOffCowInsight.html","<!-- Formerly known as cow-details-bar --><context-details insight=$ctrl.insight params=$ctrl.contextParams></context-details>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightChart/components/calvingInsight/calvingInsightChart.html","<!-- Graphs. --><section ng-if=$ctrl.visualisations.charts.length><date-period-selector start-date=$ctrl.startDate end-date=$ctrl.endDate day-range=$ctrl.visualisations.dayRange day-options=[1,3,7,31] max-date=$ctrl.maxDate center-epoch=$ctrl.centerEpoch on-date-change=\"$ctrl.onDateChange(startDate, endDate)\"></date-period-selector><div ng-repeat=\"chart in $ctrl.visualisations.charts\"><h3 class=font-brand>{{ chart.title | translate }}</h3><ctra-data-visualisation display-values=chart.displayValues context-menu=chart.contextMenu on-insight-clicked=$ctrl.onInsightClicked(insight) start-date=$ctrl.startDate end-date=$ctrl.endDate on-date-change=\"$ctrl.onDateChange(startDate, endDate)\" highlighted-data=[$ctrl.insight.GenericInsightID] is-loading=$ctrl.setLoadingGraphs(loading) class=block></ctra-data-visualisation></div></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightChart/components/factory/insightChartFactory.html","<ng-include src=$ctrl.resolve($ctrl.insight)></ng-include>");
$templateCache.put("app/shared-components/angular-ui-components/modules/icons/components/icon/icon.html","<div class=svg-icon ng-class=$ctrl.getClassName() ng-include=$ctrl.getTemplate()></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightChart/components/herdInsight/herdInsightChart.html","<div class=\"container herd-insight-chart\"><div class=row><div class=\"panel panel-default\"><div class=panel-heading><date-period-selector start-date=$ctrl.startDate end-date=$ctrl.endDate day-range=$ctrl.dayRange day-options=[1,3,7,31,92] max-date=$ctrl.maxDate on-date-change=\"$ctrl.onDateChange(startDate, endDate)\" in-view-epoch=$ctrl.nowEpoch></date-period-selector></div><div class=panel-body><div ng-repeat=\"chart in $ctrl.visualisations.charts\"><h4 class=font-brand>{{ chart.title | translate }}</h4><ctra-data-visualisation display-values=chart.displayValues context-menu=chart.contextMenu start-date=$ctrl.startDate end-date=$ctrl.endDate on-date-change=\"$ctrl.onDateChange(startDate, endDate)\" class=block is-loading=\"$ctrl.setLoadingGraphs({loading: loading})\"></ctra-data-visualisation></div></div></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightChart/components/missingEstrus/missingEstrusInsightChart.html","<div class=missing-estrus-chart ng-if=$ctrl.visualisations.charts.length><date-period-selector start-date=$ctrl.startDate end-date=$ctrl.endDate day-range=$ctrl.visualisations.dayRange day-options=[1,3,7,31] max-date=$ctrl.maxDate center-epoch=$ctrl.centerEpoch on-date-change=\"$ctrl.onDateChange(startDate, endDate)\"></date-period-selector><div ng-repeat=\"chart in $ctrl.visualisations.charts\"><h3 class=font-brand>{{ chart.title | translate }}</h3><ctra-data-visualisation display-values=chart.displayValues context-menu=chart.contextMenu on-insight-clicked=$ctrl.onInsightClicked(insight) start-date=$ctrl.startDate end-date=$ctrl.endDate on-date-change=\"$ctrl.onDateChange(startDate, endDate)\" highlighted-data=[$ctrl.insight.GenericInsightID] is-loading=$ctrl.setLoadingGraphs(loading) class=block></ctra-data-visualisation></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightDescription/components/factory/insightDescriptionFactory.html","<ng-include src=$ctrl.resolve()></ng-include>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightDescription/components/baseStationIsOfflineDescription/baseStationIsOfflineDescription.html","<section ng-if=$ctrl.insight.insightDescription class=\"{{$ctrl.insight.insightScope+\'-description\'}}\"><p>{{$ctrl.getInsightDescription($ctrl.insight, { resolved: $ctrl.isResolved(\"base_station_is_back_online\") || null })}}</p></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightDescription/components/genericDescription/genericInsightDescription.html","<section ng-if=$ctrl.insight.insightDescription class=\"{{$ctrl.insight.insightScope+\'-description\'}}\"><p>{{$ctrl.getInsightDescription($ctrl.insight)}}</p></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightDescription/components/missingEstrusDescription/missingEstrusDescription.html","<div class=\"row x-flex missing-estrus-description-container\"><div class=\"x-flex x-align-center\"><div class=missing-estrus-description-icon><svg-icon ng-if=\"$ctrl.isValidInsightVariant($ctrl.insight, \'noHeat\')\" icon=long-cycle></svg-icon><svg-icon ng-if=\"$ctrl.isValidInsightVariant($ctrl.insight,\'shortCycle\')\" icon=short-cycle></svg-icon><svg-icon ng-if=\"$ctrl.isValidInsightVariant($ctrl.insight,\'noHeatAfterCalving\')\" icon=not-cycling></svg-icon></div><p class=missing-estrus-description-text>{{$ctrl.getInsightDescription()}}</p></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightExtensions/components/calvingInsight/calvingInsightExtension.html","<div ng-if=$ctrl.isEnabled() class=calving-insight-extension><div ng-if=$ctrl.loading class=loading-cover><loading-bar></loading-bar></div><div class=\"row bolus-recommendation\"><svg-icon icon=capsule></svg-icon><p>{{\"insight-recommendation-kersiaBolus-description\" | translate}}</p></div><div class=\"bolus-interaction x-align-center row x-flex\"><div class=x-box><p><strong class=visible-lg>{{\"insight-recommendation-kersiaBolus-question\" | translate}}</strong> <span class=hidden-lg>{{\"insight-recommendation-kersiaBolus-question\" | translate}}</span></p></div><div class=\"x-box buttons\" ng-if=\"$ctrl.status === \'open\'\"><div class=btn-group role=group><button type=button class=\"btn btn-sm btn-link\" ng-click=\"$ctrl.respond(\'applied\')\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-sm btn-link\" ng-click=\"$ctrl.respond(\'not-applied\')\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=\"x-box response\" ng-if=\"$ctrl.status === \'applied\'\" ng-class=$ctrl.getInteractionContainerClassname()><button type=button class=\"btn btn-sm btn-link\" ng-click=\"$ctrl.respond(\'open\')\"><span class=\"glyphicon glyphicon-ok\"></span> <span>{{\"insight-recommendation-kersiaBolus-response-applied\" | translate}}</span></button></div><div class=\"x-box response\" ng-if=\"$ctrl.status === \'not-applied\'\" ng-class=$ctrl.getInteractionContainerClassname()><button type=button class=\"btn btn-sm btn-link\" ng-click=\"$ctrl.respond(\'open\')\"><span class=\"glyphicon glyphicon-remove\"></span> <span>{{\"insight-recommendation-kersiaBolus-response-notApplied\" | translate}}</span></button></div></div><div ng-if=$ctrl.mayRemind() class=\"row bolus-reminder\"><svg-icon icon=clock></svg-icon><p><strong>{{\"insight-recommendation-kersiaBolus-reminder\" | translate}}</strong></p></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightExtensions/components/calciumBolusDialog/calciumBolusDialog.html","<div id=calcium-bolus-dialog class=\"modal fade\" tabindex=-1 role=dialog><div class=modal-dialog role=document><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div><div class=modal-content><div class=modal-header><button type=button class=\"close btn-sm\" data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h5 class=modal-title>{{\"insight-recommendation-kersiaBolus-modal-title\" | translate}}</h5></div><div ng-if=$ctrl.insight class=modal-body><calving-insight-extension callback=$ctrl.callback insight=$ctrl.insight></calving-insight-extension></div></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightExtensions/components/factory/insightExtensionFactory.html","<ng-include src=$ctrl.resolve()></ng-include>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadline/components/baseStationIsOfflineInsight/baseStationIsOfflineInsightHeadline.html","<h3 ng-class=\"$ctrl.isResolved($ctrl.insight) ? \'small\' : \'\'\">{{$ctrl.getInsightTitle($ctrl.insight, { resolved: $ctrl.isResolved(\"base_station_is_back_online\") || null })}}</h3><p>{{[$ctrl.insight.startEpoch, $ctrl.insight.endEpoch] | epochsToPeriodString}}</p>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadline/components/calvingInsight/calvingInsightHeadline.html","<h3 ng-class=\"$ctrl.isResolved($ctrl.insight) ? \'small\' : \'\'\"><a ng-if=$ctrl.insight.dairyCowID go-forward ui-sref=\"cow({cowID: $ctrl.insight.dairyCow.DairyCowID})\">#{{$ctrl.insight.dairyCow.cowTagNumber}} </a>{{$ctrl.getInsightTitle($ctrl.insight, { legacy: true })}}</h3><p ng-if=!$ctrl.hasCalvingLabel()>{{ [$ctrl.insight.startEpoch, $ctrl.insight.endEpoch] | epochsToPeriodString }}</p><p class=calving-label ng-if=$ctrl.hasCalvingLabel()><svg-icon icon=time-validated></svg-icon>{{ $ctrl.getUserDefinedCalvingTime() }}</p>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadline/components/factory/insightHeadlineFactory.html","<share-ribbon ng-if=$ctrl.farmName class=screenshot-visible>{{$ctrl.farmName}}</share-ribbon><div class=\"row no-gutters page-panel-header text-center insight-headline\" ng-class=$ctrl.getWrapperClassName($ctrl.insight)><div class=col-sm-12><insight-headline-resolution-factory insight=$ctrl.insight></insight-headline-resolution-factory><a ng-if=$ctrl.getPreviousInsightID() ui-sref=\"insight({ genericInsightID: $ctrl.getPreviousInsightID() })\" class=\"fa fa-angle-left previous-insight\"></a> <a ng-if=$ctrl.getNextInsightID() ui-sref=\"insight({ genericInsightID: $ctrl.getNextInsightID() })\" class=\"fa fa-angle-right next-insight\"></a><ng-include src=$ctrl.resolve()></ng-include><div class=share-button-container><share-insight-button data=$ctrl.getShareButtonData() target=insight-page-panel loading=$ctrl.isGraphLoading></share-insight-button></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadline/components/herdInsight/herdInsightHeadline.html","<h3 ng-class=\"$ctrl.isResolved($ctrl.insight) ? \'small\' : \'\'\">{{\"group-herd-insight\" | translate}} <a class=herd-name ng-href=#!/cows/{{$ctrl.insight.herdGroupID}} ng-if=$ctrl.herdGroup>{{$ctrl.herdGroup.groupName}} </a>{{$ctrl.getInsightTitle($ctrl.insight)}}</h3><p>{{[$ctrl.insight.startEpoch, $ctrl.insight.endEpoch] | epochsToPeriodString}}</p>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadline/components/missingEstrusInsight/missingEstrusInsightHeadline.html","<h3><a ng-if=$ctrl.insight.dairyCowID go-forward ui-sref=\"cow({cowID: $ctrl.insight.dairyCow.DairyCowID})\">#{{$ctrl.insight.dairyCow.cowTagNumber}} </a>{{$ctrl.getTitle()}}</h3><h3 ng-if=$ctrl.parentInsight><insight-resolution-title insight=$ctrl.parentInsight show-cow-tag=false update=$ctrl.parentInsight.insightResolution.length options=\"{ filterAllHiddenResolutions: true }\"></insight-resolution-title></h3><p>{{ $ctrl.startDate }}</p>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadline/components/sensorInsight/sensorInsightHeadline.html","<h3 ng-class=\"$ctrl.isResolved($ctrl.insight) ? \'small\' : \'\'\"><a ng-if=$ctrl.insight.dairyCowID go-forward ui-sref=\"cow({cowID: $ctrl.insight.dairyCow.DairyCowID})\">#{{$ctrl.insight.dairyCow.cowTagNumber}} </a>{{$ctrl.getInsightTitle($ctrl.insight)}}</h3><!-- Show in case of sensor is not on cow --><p ng-if=\"$ctrl.getTypeName($ctrl.insight) == \'SensorIsNotOnCow\'\">{{[$ctrl.insight.startEpoch, $ctrl.insight.endEpoch] | epochsToPeriodString}}</p><!-- Show in case of sensor is offline --><p ng-if=\"$ctrl.getTypeName($ctrl.insight) == \'SensorIsOffline\' || $ctrl.getTypeName($ctrl.insight) == \'SensorIsNotTurnedOn\'\">{{\"since\" | translate}} {{$ctrl.sensorOfflineDuration}}</p>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadlineResolution/components/factory/insightHeadlineResolutionFactory.html","<ng-include src=$ctrl.resolve()></ng-include>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadlineResolution/components/fmsResolutionTitle/fmsResolutionTitle.html","<div class=inline-block><span>{{$ctrl.getResolutions() | translate}}</span></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadlineResolution/components/genericInsightHeadlineResolution/genericInsightHeadlineResolution.html","<h3 ng-if=$ctrl.isResolved($ctrl.insight)><insight-resolution-title insight=$ctrl.insight show-cow-tag=false update=$ctrl.insight.insightResolution.length></insight-resolution-title></h3>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightHeadlineResolution/components/missingEstrusHeadlineResolution/missingEstrusHeadlineResolution.html","<h3 ng-if=$ctrl.isResolved($ctrl.activeInsight)><insight-resolution-title insight=$ctrl.activeInsight show-cow-tag=false update=$ctrl.activeInsight.insightResolution.length options=\"{ filterAllHiddenResolutions: true }\"></insight-resolution-title></h3>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/fmsTag/fmsTag.html","<div class=\"x-inline-flex fms-tag\" ng-if=$ctrl.resolveFMSFromValidation($ctrl.insight)><svg-icon icon=arrow-coming-from></svg-icon>{{$ctrl.resolveFMSFromValidation($ctrl.insight)}}</div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/listHeader/listHeader.html","<div class=\"x-flex x-direction-row x-align-center insight-list-header\"><div class=\"x-box icon\" ng-if=!!$ctrl.icon ng-class=\"{\'disabled\': $ctrl.disabled}\"><svg-icon icon={{$ctrl.icon}}></svg-icon></div><div class=\"x-box text\"><h3 class=insight-list-header-title>{{$ctrl.title}}</h3><p class=insight-list-header-description>{{$ctrl.description}}</p></div><ng-transclude></ng-transclude></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/listEntry/listEntry.html","<section class=insight-list-entry ng-click=$ctrl.handleClick() ng-transclude></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/listWrapper/listWrapper.html","<section class=insight-list-wrapper><ng-include src=$ctrl.resolveFromContentType()></ng-include><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div><div class=\"text-center load-more-container\" ng-if=$ctrl.options.includeLoadMoreButton><div class=\"btn btn-white btn-wide btn-sm load-more\" ng-click=$ctrl.loadMore() ng-hide=$ctrl.hideLoadMoreButton()>{{\'Load more\' | translate}}</div><div ng-show=$ctrl.loading><loading-spinner ng-class=\"\'inline-block\'\"></loading-spinner>{{\"HEADER_TEXT_LOADING\" | translate}}</div></div></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/listStatus/listStatus.html","<div class=alert ng-class=$ctrl.getClassName() ng-transclude></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightResolution/components/calvingInsightResolution/calvingInsightResolution.html","<div class=calving-insight-resolution ng-show=\"$ctrl.insight.calved === true\"><h3 class=font-brand>{{$ctrl.getTranslatedContent(\"date-time-picker-heading\")}}</h3><div class=\"x-inline-flex x-direction-row pil pil-default active\" ng-click=$ctrl.removeCalvingLabel() ng-if=$ctrl.hasCalvingLabel()><svg-icon class=x-box icon=time-validated></svg-icon><span class=x-box>{{ $ctrl.getUserDefinedCalvingTime() }}</span> <span class=\"x-box glyphicon glyphicon-remove\" aria-hidden=true></span></div><date-time-widget on-date-time-change=$ctrl.onDateTimeChange(dateTime) date-time=$ctrl.getDatepickerValue() widget-disabled=$ctrl.isDateTimePickerDisabled()></date-time-widget></div><h3 ng-if=$ctrl.insight.calved class=font-brand>{{$ctrl.getTranslatedContent(\"resolution-heading\")}}</h3><insight-resolution update-insight-resolution=$ctrl.updateInsightResolution(insightResolution) insight-resolution=$ctrl.insight.insightResolution ng-show=\"$ctrl.insight.calved === true || $ctrl.insight.calved === false\" insight=$ctrl.insight insight-is-valid=$ctrl.insight.insightValid></insight-resolution>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightResolution/components/missingEstrusInsightResolution/missingEstrusInsightResolution.html","<insight-resolution insight-is-valid=$ctrl.insight.insightValid update-insight-resolution=$ctrl.updateInsightResolution(insightResolution) insight-resolution=$ctrl.insight.insightResolution insight=$ctrl.insight><section class=\"dnb-info alert-info small\" ng-if=\"$ctrl.isDysonEnabled() && $ctrl.resolvedAsDNB($ctrl.insight)\">{{$ctrl.copy.dnbWarning | translate}}</section></insight-resolution><!--\n  We use ng-include again to pass on another widget when necessary. Eg.\n  <last-estrus-picker insight=\"$ctrl.currentInsight\"></last-estrus-picker>\n  --><ng-include ng-if=$ctrl.mayShowMissingEstrusResolutionExtension() src=$ctrl.getMissingEstrusResolutionExtension()></ng-include>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/calvingInsightValidation/calvingInsightValidation.html","<h3 class=font-brand>{{$ctrl.getTranslatedContent(\"validation-heading\")}}</h3><calving-validation class=\"btn-group btn-group-justified\" update-calving-validation=$ctrl.onUpdateValidation() insight=$ctrl.insight></calving-validation><calving-insight-resolution insight=$ctrl.insight></calving-insight-resolution>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/baseStationIsOffline/baseStationIsOffline.html","<div ng-if=\"!$ctrl.isResolved(\'base_station_is_back_online\')\" class=\"insight-validation base-station-is-offline-validation\"><h3 class=font-brand>{{\"base-station-reboot-sequence-title\" | translate}}</h3><div ng-bind-html=\"\'base-station-reboot-sequence\' | translate | htmlSafe\"></div><validation-question insight=$ctrl.insight></validation-question><div class=\"btn-group btn-group-justified\"><validation-button active=\"$ctrl.isValidated(\'yes\')\" variant=yes ng-click=\"$ctrl.validate(\'yes\')\"></validation-button><validation-button active=\"$ctrl.isValidated(\'no\')\" variant=no ng-click=\"$ctrl.validate(\'no\')\"></validation-button></div><div ng-if=\"$ctrl.isValidated(\'yes\')\"><h3 class=font-brand>{{\"base-station-rebooted-title\" | translate}}</h3><p>{{\"base-station-rebooted-description\" | translate}}</p></div><div ng-if=\"$ctrl.isValidated(\'no\')\"><h3 class=font-brand>{{\"base-station-request-assistance-title\" | translate}}</h3><p>{{\"base-station-request-assistance-description\" | translate}}</p><div class=\"btn-group btn-group-justified\"><a ng-click=$ctrl.showIntercom() class=\"btn insight-validation-button btn-default\">{{\"base-station-request-assistance-button\" | translate}}</a></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/actionButton/actionButton.html","<a class=\"action-button btn btn-default btn-block\" ng-class=$ctrl.getClassName()>{{$ctrl.getTranslatedContent()}} </a>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/factory/insightValidationFactory.html","<ng-include src=$ctrl.resolve($ctrl.insight)></ng-include>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/fmsValidation/fmsValidation.html","<div class=\"row fms-validation\"><div class=col-sm-22><div class=\"alert alert-warning\" role=alert><h5>{{$ctrl.getTitle()}}</h5><p>{{$ctrl.getDescription()}}</p></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/pairSensorWidget/pairSensorWidget.html","<section><p class=align-center><strong>{{ $ctrl.getContent(\"label\") }}</strong><br>{{ $ctrl.getShortSerialNumber() }}</p><a class=\"btn btn-white btn-block\" ng-click=$ctrl.handlePairSensorClicked()>{{ $ctrl.getContent(\"button\") }}</a></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/noSensorOnCow/noSensorOnCow.html","<div class=no-sensor-on-cow><action-button suffix=pair variant=dark-green ng-click=$ctrl.redirectToSensorPairingPage()></action-button><div class=\"archive-dismiss-container x-flex x-space-between\"><action-button suffix=dismiss variant=white ng-click=$ctrl.handleDismissInsight()></action-button><action-button suffix=archive variant=gray ng-click=$ctrl.handleArchiveCowClicked()></action-button></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/sensorIsNotTurnedOn/sensorIsNotTurnedOn.html","<div class=sensorIsNotTurnedOn><validation-question insight=$ctrl.insight suffix=turn-sensor-on></validation-question><validation-description insight=$ctrl.insight suffix=turn-sensor-on></validation-description><validation-description insight=$ctrl.insight suffix=start-sensor></validation-description><!-- If the sensor has never been resolved --><action-button suffix=turn-on-sensor variant=white ng-if=!$ctrl.isResolvedInsight($ctrl.insight) ng-click=$ctrl.turnOnSensor()></action-button><!-- If the insight has been resolved --><div ng-if=$ctrl.isResolvedInsight($ctrl.insight)><action-button suffix=turn-on-sensor variant=gray disabled></action-button><!-- If the insight resolution is in connecting phase --><div ng-if=\"$ctrl.isResolved(\'connecting\')\"><validation-question insight=$ctrl.insight suffix=connecting-sensor></validation-question><validation-description insight=$ctrl.insight suffix=connecting-sensor></validation-description></div><!-- If the insight resolution is in replace sensor phase --><div ng-if=\"$ctrl.isResolved(\'replace_sensor\')\"><validation-question insight=$ctrl.insight suffix=replace-sensor></validation-question><validation-description insight=$ctrl.insight suffix=replace-sensor></validation-description><action-button suffix=pair-cow-to-other-sensor variant=dark-green ng-click=$ctrl.redirectToSensorPairingPage()></action-button></div><!-- If the insight resolution is in turned on phase --><div ng-if=\"$ctrl.isResolved(\'turned_on\')\"><validation-question insight=$ctrl.insight suffix=turned-on></validation-question><validation-description insight=$ctrl.insight suffix=turned-on></validation-description></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/missingEstrus/missingEstrusValidation.html","<div class=\"insight-validation missing-estrus-insight-validation\"><validation-question insight=$ctrl.insight></validation-question><!-- Offer yes or no options --><div class=\"btn-group btn-group-justified\"><validation-button active=$ctrl.isValid() variant=yes ng-click=$ctrl.handleYesValidation()></validation-button><validation-button active=$ctrl.isInvalid() variant=no ng-click=$ctrl.handleNoValidation()></validation-button></div><div ng-if=$ctrl.isValid()><validation-question insight=$ctrl.insight suffix=missing-estrus-yes-validation></validation-question></div><div ng-if=$ctrl.isInvalid()><validation-question insight=$ctrl.insight suffix=missing-estrus-no-validation></validation-question></div></div><missing-estrus-insight-resolution ng-if=\"$ctrl.isValid() || $ctrl.isInvalid()\" insight=$ctrl.insight options=$ctrl.getOptions()></missing-estrus-insight-resolution>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/sensorIsOffline/sensorIsOffline.html","<div ng-if=$ctrl.insightValidation class=\"insight-validation sensor-is-offline\"><!-- Ask if the sensor is offline --><validation-question insight=$ctrl.insight></validation-question><!-- Offer yes or no options --><div class=\"btn-group btn-group-justified\"><validation-button active=\"$ctrl.maybeValidated(\'yes\')\" variant=yes ng-click=$ctrl.sensorOutOfRange()></validation-button><validation-button active=\"$ctrl.maybeValidated(\'no\')\" variant=no ng-click=$ctrl.replaceSensor()></validation-button></div><!-- If the sensor is on the out of range --><div ng-if=\"$ctrl.isValidated(\'yes\')\"><validation-question insight=$ctrl.insight suffix=out-of-range></validation-question><validation-description insight=$ctrl.insight suffix=out-of-range></validation-description><validation-description insight=$ctrl.insight suffix=data-storage></validation-description></div><!-- If the sensor needs to be replaced --><div ng-if=\"$ctrl.isValidated(\'no\')\"><validation-question insight=$ctrl.insight suffix=replace-sensor></validation-question><validation-description insight=$ctrl.insight suffix=replace-sensor></validation-description><validation-description insight=$ctrl.insight suffix=button-pair-sensor></validation-description><action-button suffix=replace variant=dark-green ng-click=$ctrl.redirectToSensorPairingPage()></action-button></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/validationButton/validationButton.html","<a class=\"btn insight-validation-button\" ng-class=$ctrl.getClassName()>{{$ctrl.getContent()}} </a>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/validationQuestion/validationQuestion.html","<div class=validation-question><h3 class=font-brand>{{$ctrl.getTranslatedQuestion()}}</h3><div class=children><ng-transclude></ng-transclude></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/sensorOffCow/sensorOffCowValidation.html","<div ng-if=$ctrl.insightValidation class=\"insight-validation sensor-off-cow-validation\"><!-- Ask if the sensor is on the floor --><validation-question insight=$ctrl.insight></validation-question><!-- Offer yes or no options --><div class=\"btn-group btn-group-justified\"><validation-button active=\"$ctrl.maybeValidated(\'yes\')\" variant=yes ng-click=$ctrl.sensorRemoved()></validation-button><validation-button active=\"$ctrl.maybeValidated(\'no\')\" variant=no ng-click=$ctrl.sensorOnCow()></validation-button></div><!-- If the sensor is on the floor, tell that Ida has unpaired it, then ffer pairing a new sensor --><div ng-if=\"$ctrl.isValidated(\'yes\') && $ctrl.getNodeIdFromContext()\"><validation-question insight=$ctrl.insight suffix=unpaired></validation-question><pair-sensor-widget node-id=$ctrl.getNodeIdFromContext()></pair-sensor-widget></div><!-- If the sensor is NOT on the floor, ask the user if they know what happened, then offer some resolutions --><div ng-if=\"$ctrl.isValidated(\'no\')\"><validation-question insight=$ctrl.insight suffix=resolution></validation-question><!-- TODO write a new insight resolution widget --><insight-resolution update-insight-resolution=$ctrl.runResolutionFlow(insightResolution) on-before-remove-resolution=$ctrl.onBeforeRemoveResolution(insightResolution) insight-resolution=$ctrl.insight.insightResolution insight=$ctrl.insight insight-is-valid=$ctrl.insight.insightValid></insight-resolution></div><!-- If the user verifies that the sensor has fell off the cow. --><div ng-if=\"$ctrl.isResolved(\'sensor_fell_off\')\"><validation-question insight=$ctrl.insight suffix=sensor-fell-off></validation-question><validation-description insight=$ctrl.insight suffix=sensor-fell-off></validation-description><action-button ng-if=$ctrl.hasSensor() suffix=unpair variant=yellow ng-click=$ctrl.handleUnpairClicked()></action-button><action-button suffix=pair-to-another variant=green ng-click=$ctrl.handlePairToOtherClicked()></action-button></div><!-- If the user verifies that the cow died. --><div ng-if=\"$ctrl.isResolved(\'cow_died\')\"><validation-question insight=$ctrl.insight suffix=cow-died></validation-question><validation-description insight=$ctrl.insight suffix=cow-died></validation-description><action-button ng-if=!$ctrl.isCowArchived() suffix=archive variant=gray ng-click=$ctrl.handleArchiveCowClicked()></action-button><action-button ng-if=$ctrl.isCowArchived() suffix=restore variant=gray ng-click=$ctrl.handleRestoreCowClicked()></action-button></div><div class=loading-cover ng-show=$ctrl.loading><loading-bar></loading-bar></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightValidation/components/validationDescription/validationDescription.html","<p class=validation-description>{{$ctrl.getTranslatedContent()}}</p>");
$templateCache.put("app/shared-components/angular-ui-components/modules/modal/components/base/genericModal.html","<div ng-class=\"($ctrl.modalVisible ? \'in\' : \'\')\" class=\"modal fade\" tabindex=-1 role=dialog id=resolutionModal><div class=modal-dialog role=document ng-class=$ctrl.modalContentType><div class=modal-content><div class=modal-body><ng-include src=$ctrl.resolveFromContentType()></ng-include></div><div class=modal-footer><button type=button class=\"btn btn-default\" ng-click=$ctrl.hideModal()>{{\"BUTTON_TEXT_CLOSE\" | translate}}</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal -->");
$templateCache.put("app/shared-components/angular-ui-components/modules/modal/components/calvingModal/calvingModal.html","<calving-insight-resolution insight=$ctrl.insight></calving-insight-resolution>");
$templateCache.put("app/shared-components/angular-ui-components/modules/modal/components/missingEstrusModal/missingEstrusModal.html","<h3 class=missing-estru-modal-heading>{{$ctrl.getHeading()}}</h3><missing-estrus-insight-resolution insight=$ctrl.insight options=$ctrl.options></missing-estrus-insight-resolution>");
$templateCache.put("app/shared-components/angular-ui-components/modules/navigation/components/mainNavItem/mainNavItem.html","<li ui-sref-active=active class=main-nav-item><a ng-if=to ui-sref={{to}}><div class=\"x-flex x-direction-row x-align-center\"><div class=x-box ng-transclude></div><div class=\"x-box badge-container\" ng-if=count><badge size=medium color=mojo value={{count}}></badge></div></div></a><a ng-if=href ng-href={{href}} target=_blank><div class=\"x-flex x-direction-row x-align-center\"><div class=x-box ng-transclude></div><div class=\"x-box badge-container\" ng-if=count><badge size=medium color=mojo value={{count}}></badge></div></div></a><a ng-if=onClick ng-click=onClick()><div class=\"x-flex x-direction-row x-align-center\"><div class=x-box ng-transclude></div><div class=\"x-box badge-container\" ng-if=count><badge size=medium color=mojo value={{count}}></badge></div></div></a><a ng-if=toggles data-toggle=modal data-target={{toggles}}><div class=\"x-flex x-direction-row x-align-center\"><div class=x-box ng-transclude></div><div class=\"x-box badge-container\" ng-if=count><badge size=medium color=mojo value={{count}}></badge></div></div></a></li>");
$templateCache.put("app/shared-components/angular-ui-components/modules/notification/components/badge/badge.html","<span ng-class=$ctrl.getBadgeClassNames() class=navbar-badge>{{ $ctrl.value }}</span>");
$templateCache.put("app/shared-components/angular-ui-components/modules/sharing/components/shareInsightButton/shareInsightButton.html","<section class=share-container ng-class=$ctrl.getWrapperClassName()><section class=share-toggle><a class=toggle-btn ng-click=$ctrl.toggle()><svg-icon icon=share></svg-icon><span class=toggle-text>{{$ctrl.getToggleText()}} </span></a><a class=close-btn ng-click=$ctrl.toggle()><svg-icon icon=close></svg-icon></a></section><section class=share-content ng-show=$ctrl.isOpen()><section class=externals><a class=\"share-btn whatsapp\" ng-click=$ctrl.onShareScreenshotClick($ctrl.MEDIUMS.whatsapp)><svg-icon icon=whatsapp></svg-icon>{{$ctrl.getLabel($ctrl.MEDIUMS.whatsapp)}} </a><a class=\"share-btn email\" ng-click=$ctrl.onShareScreenshotClick($ctrl.MEDIUMS.email)><svg-icon icon=email></svg-icon>{{$ctrl.getLabel($ctrl.MEDIUMS.email)}}</a></section><div class=\"input-group share-link\"><input type=text class=\"form-control input-sm input-link\" ng-value=$ctrl.screenshotURL ng-if=$ctrl.screenshotURL></div></section><div class=loading-cover ng-show=$ctrl.isLoading()><loading-bar></loading-bar></div></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/sharing/components/shareRibbon/shareRibbon.html","<div class=screenshot-ribbon><header class=\"h3 farm-info\"><!-- TODO replace with an <svg-icon>, but we have not Ida logo in real SVG --> <img alt=\"ida logo\" src=assets/images/ida-white.png width=35px><div class=content><ng-transclude></ng-transclude></div></header><time><img src=/assets/images/icons/png/screenshot.png class=icon-screenshot> <span class=time-taken>{{$ctrl.getContent()}}</span></time></div>");
$templateCache.put("app/shared-components/angular-ui-components/components/insight/insightChecks/question/yesNoMaybe/yesNoMaybe.html","<!--  YES, NO, MAYBE tri-state check component for answering insights. --><div class=check-container ng-class=$ctrl.variant><a class=\"check-btn check-true\" ng-class=\"{ active: $ctrl.value === $ctrl.possibleValues.True }\" ng-click=$ctrl.onSelectOption($ctrl.possibleValues.True)></a> <a class=\"check-btn check-maybe\" ng-class=\"{ active: $ctrl.value === $ctrl.possibleValues.Maybe }\" ng-click=$ctrl.onSelectOption($ctrl.possibleValues.Maybe)></a> <a class=\"check-btn check-false\" ng-class=\"{ active: $ctrl.value === $ctrl.possibleValues.False }\" ng-click=$ctrl.onSelectOption($ctrl.possibleValues.False)></a></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/calvingInsights/entry/calvingInsightEntry.html","<div class=\"row calving-list-entry\"><div ng-if=$ctrl.herdList.length class=\"col-xs-3 area-name area-container badge-container\" ng-class=\"$ctrl.showBullet($ctrl.insight) ? \'\' : \'badge-not-visible\'\"><badge ng-if=$ctrl.showBullet($ctrl.insight) size=x-tiny color=curious-blue></badge><span class=area-name>{{$ctrl.getHerdGroupName()}}</span></div><div ui-sref=insight({genericInsightID:$ctrl.insight.GenericInsightID}) role=button go-forward ng-class=$ctrl.getClassNamesForCowColumn($ctrl.insight) class=\"cow-tag-number badge-container\"><badge ng-if=\"$ctrl.showBullet($ctrl.insight) && !$ctrl.herdList.length\" size=x-tiny color=curious-blue></badge>{{$ctrl.insight.dairyCow.cowTagNumber}}</div><div ng-click=$ctrl.showCalciumBolusModal() ng-if=$ctrl.hasRecommendation() ng-class=$ctrl.getBolusContainerClassname()><svg-icon icon={{$ctrl.getIconVariant()}}></svg-icon>{{value.title | translate}}</div><div ng-class=\"$ctrl.hasRecommendation() ? \'col-xs-5\' : \'col-xs-7\'\" class=\"calving-buttons text-right x-flex x-direction-column\"><calving-validation update-calving-validation=$ctrl.onUpdateValidation() show-resolutions=true insight=$ctrl.insight button-style=\"\'simple\'\" disabled></calving-validation><div class=\"user-defined-calving-time x-inline-flex\" ng-if=$ctrl.hasCalvingLabel()><svg-icon class=x-box icon=time-validated></svg-icon><span class=x-box>{{$ctrl.getCalvingTime()}}</span></div><fms-tag insight=$ctrl.insight></fms-tag></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/calvingInsights/list/calvingInsightList.html","<div class=calving-list><list-header icon={{$ctrl.icon}} title=\"{{$ctrl.getHeaderContent($ctrl.variant+\'-title\')}}\" description=\"{{$ctrl.getHeaderContent($ctrl.variant+\'-description\')}}\"></list-header><div class=\"table-list table-list-lg\" ng-if=$ctrl.insightList.length><div class=\"table-list-heading table-list-heading-minimal\"><div class=row><div ng-if=$ctrl.herdList.length class=\"col-xs-3 badge-space\">{{\"LABEL_TEXT_HERD_GROUP\" | translate}}</div><div ng-class=\"$ctrl.herdList.length ? \'col-xs-2\' : \'col-xs-5 badge-space\'\">{{\"LABEL_TEXT_COW\" | translate}}</div><div class=\"col-xs-7 text-right\">{{\"LABEL_TEXT_CALVED\" | translate}}</div></div></div><div class=table-list-items><div ng-repeat=\"insightGroup in $ctrl.insightList\" class=insight-group><div ng-if=$ctrl.withGroupHeaders class=table-list-item><div class=row><div class=\"col-xs-12 insight-group-date\">{{insightGroup[0]}}</div></div></div><div class=table-list-item ng-repeat=\"insight in insightGroup[1]\"><calving-insight-entry insight=insight herd-list=$ctrl.herdList update-calving=$ctrl.updateCalving(insight) recommendation=$ctrl.bolusRecommendations[insight.GenericInsightID]></calving-insight-entry></div></div></div></div></div><generic-modal modal-content-type=calving-modal data=$ctrl.currentActiveInsight ng-if=$ctrl.currentActiveInsight modal-visible=$ctrl.showModal hide-modal=$ctrl.toggleCalvingModal()></generic-modal>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/groupInsights/list/groupInsightList.html","<section class=group-insight-list ng-if=!$ctrl.fetching><div class=list-header-container ng-if=\"$ctrl.variant === \'actionable\'\"><list-header icon=icon-group-insights title=\"{{$ctrl.getHeaderContent(\'title\')}}\" description=\"{{$ctrl.getHeaderContent(\'description\')}}\"></list-header><svg-icon class=beta-label icon=beta-label></svg-icon></div><section class=list-entries><group-insight-entry ng-repeat=\"insight in $ctrl.insights\" first=$first insight=insight></group-insight-entry></section><list-status variant=info ng-if=!$ctrl.insights.length>{{$ctrl.getTranslatedContent($ctrl.variant+\'-list-status\', \'empty\')}}</list-status></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/groupInsights/entry/groupInsightEntry.html","<div class=\"list insights-list group-insights list\"><div ui-sref=insight({genericInsightID:$ctrl.insight.GenericInsightID}) go-forward class=\"list-item insight-item\" role=button><div class=badge-container><badge ng-if=($ctrl.showBullet($ctrl.insight)) size=x-tiny color=curious-blue></badge></div><div><div class=title ng-if=!$ctrl.insight.insightResolution.length><span class=\"capitalize herd-entry-name\">{{\"group-herd-insight\" | translate}} {{$ctrl.herdGroup.groupName}},</span> <span class=herd-entry-title-detail>{{$ctrl.getInsightTitle($ctrl.insight)}}</span></div><div class=title ng-if=$ctrl.insight.insightResolution.length><insight-resolution-title insight=$ctrl.insight show-cow-tag=true show-sub-title=true></insight-resolution-title><div class=\"gray small strong\"><span class=\"capitalize herd-entry-name\">{{\"group-herd-insight\" | translate}}{{$ctrl.herdGroup.groupName}},</span> <span class=herd-entry-title-detail>{{$ctrl.getInsightTitle($ctrl.insight)}}</span></div></div><time><span>{{ [$ctrl.insight.startEpoch, $ctrl.insight.endEpoch] | epochsToPeriodString }}</span></time></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/healthInsight/entry/healthInsightEntry.html","<!-- Using old translations way because of legacy insights --><div class=\"list insights-list health-insight-list list\"><div ng-class=$ctrl.getContainerClasses($ctrl.insight) ui-sref=insight({genericInsightID:$ctrl.insight.GenericInsightID}) go-forward class=\"list-item insight-item\" role=button><div class=badge-container><badge ng-if=($ctrl.showBullet($ctrl.insight)) size=x-tiny color=curious-blue></badge></div><div><div class=title ng-if=!$ctrl.insight.insightResolution.length><span ng-if=$ctrl.insight.dairyCow>#{{$ctrl.insight.dairyCow.cowTagNumber}}</span> <span>{{$ctrl.insight.insightTitle | translate | trim}}</span></div><div class=title ng-if=$ctrl.insight.insightResolution.length><insight-resolution-title insight=$ctrl.insight show-cow-tag=true show-sub-title=true></insight-resolution-title></div><time><span class=capitalize ng-if=$ctrl.insight.dairyCow.herdGroupID>{{\"herd-group\" | translate}} {{$ctrl.getHerdGroupName()}} - </span><span class=capitalize ng-if=\"$ctrl.insight.dairyCow.cowStatus !== \'dry\' && $ctrl.insight.dairyCow.lastCalvingEpoch && $ctrl.getDIM($ctrl.insight)\">{{$ctrl.getDIM($ctrl.insight)}} {{\"d.i.m\" | translate}}</span><br ng-if=$ctrl.insight.dairyCow.lastCalvingEpoch><span style=\"display: inline-block\">{{ [$ctrl.insight.startEpoch, $ctrl.insight.endEpoch] | epochsToPeriodString }}</span></time><div><fms-tag insight=$ctrl.insight></fms-tag></div></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/healthInsight/list/healthInsightList.html","<section class=health-insight-list ng-if=!$ctrl.fetching><list-header icon={{$ctrl.icon}} title=\"{{$ctrl.getHeaderContent($ctrl.variant+\'-title\')}}\" description=\"{{$ctrl.getHeaderContent($ctrl.variant+\'-description\')}}\"></list-header><section class=list-entries><health-insight-entry ng-repeat=\"insight in $ctrl.insights\" area-list=$ctrl.areaList variant=$ctrl.variant insight=insight ng-click=$ctrl.updateInsightCollection()></health-insight-entry></section><list-status variant=info ng-if=!$ctrl.insights.length>{{$ctrl.getTranslatedContent(\'list-status\', \'empty\')}}</list-status></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/healthInsightBeta/entry/healthInsightEntry.html","<!-- Using old translations way because of legacy insights --><div class=\"list insights-list health-insight-list list\"><div ng-class=$ctrl.getContainerClasses($ctrl.insight) ui-sref=insight({genericInsightID:$ctrl.insight.GenericInsightID}) go-forward class=\"list-item insight-item\" role=button><div class=badge-container><badge ng-if=($ctrl.showBullet($ctrl.insight)) size=x-tiny color=curious-blue></badge></div><div><div class=title ng-if=!$ctrl.insight.insightResolution.length><span ng-if=$ctrl.insight.dairyCow>#{{$ctrl.insight.dairyCow.cowTagNumber}}</span> <span>{{$ctrl.insight.insightTitle | translate | trim}}</span></div><div class=title ng-if=$ctrl.insight.insightResolution.length><insight-resolution-title insight=$ctrl.insight show-cow-tag=true show-sub-title=true></insight-resolution-title></div><time><span class=capitalize ng-if=$ctrl.insight.dairyCow.herdGroupID>{{\"herd-group\" | translate}} {{$ctrl.getHerdGroupName()}} </span><span class=capitalize ng-if=\"$ctrl.insight.dairyCow.cowStatus !== \'dry\' && $ctrl.insight.dairyCow.lastCalvingEpoch && $ctrl.getDIM($ctrl.insight)\">- {{$ctrl.getDIM($ctrl.insight)}} {{\"d.i.m\" | translate}}</span><br ng-if=$ctrl.insight.dairyCow.lastCalvingEpoch><span style=\"display: inline-block\">{{ [$ctrl.insight.startEpoch, $ctrl.insight.endEpoch] | epochsToPeriodString }}</span></time></div></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/healthInsightBeta/list/healthInsightList.html","<section class=health-insight-list ng-if=!$ctrl.fetching><list-header icon={{$ctrl.icon}} title={{$ctrl.title}} description={{$ctrl.description}}></list-header><section class=list-entries><div class=sorting-header><div class=row><div class=\"col-xs-12 sorting-container\">sort insight by<div class=btn-group><button class=\"btn btn-default btn-xs dropdown-toggle\" type=button data-toggle=dropdown aria-expanded=false>{{$ctrl.sortingMechanism}} <span class=caret></span></button><ul class=dropdown-menu role=menu><li role=presentation ng-click=\"$ctrl.updateSortingMechanism(\'priority\')\">priority</li><li role=presentation ng-click=\"$ctrl.updateSortingMechanism(\'date\')\">date</li><li role=presentation ng-click=\"$ctrl.updateSortingMechanism(\'d.i.m\')\">d.i.m</li><li role=presentation ng-click=\"$ctrl.updateSortingMechanism(\'group\')\">group</li></ul></div></div></div></div><health-insight-entry-beta ng-repeat=\"insight in $ctrl.insights\" area-list=$ctrl.areaList variant=$ctrl.variant insight=insight ng-click=$ctrl.updateInsightCollection()></health-insight-entry-beta></section><list-status variant=info ng-if=!$ctrl.insights.length>{{$ctrl.getTranslatedContent(\'list-status\', \'empty\')}}</list-status></section>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/missingEstrusInsights/entry/missingEstrusInsightEntry.html","<div class=\"row missing-estrus-entry-container\"><div ui-sref=insight({genericInsightID:$ctrl.insight.GenericInsightID}) ng-if=$ctrl.herdList.length ng-class=\"$ctrl.showBullet($ctrl.insight) ? \'\' : \'badge-not-visible\'\" class=\"col-xs-3 area-name badge-container\"><badge ng-if=$ctrl.showBullet($ctrl.insight) size=x-tiny color=curious-blue></badge><span>{{$ctrl.getHerdGroupName()}}</span></div><div ui-sref=insight({genericInsightID:$ctrl.insight.GenericInsightID}) role=button go-forward ng-class=$ctrl.getClassNamesForCowColumn(insight) class=\"cow-tag-number badge-container\"><badge ng-if=\"$ctrl.showBullet($ctrl.insight) && !$ctrl.herdList.length\" size=x-tiny color=curious-blue></badge>{{$ctrl.insight.dairyCow.cowTagNumber}}</div><div ng-class=$ctrl.getDIMColumnClassName() ui-sref=insight({genericInsightID:$ctrl.insight.GenericInsightID}) class=text-center>{{$ctrl.getDim($ctrl.insight, {useFallback: true})}}</div><div class=\"col-xs-2 non-cyclic-icon x-flex x-center\"><div tooltips tooltip-template={{$ctrl.getTooltipText()}} tooltip-side=bottom><svg-icon ng-if=\"$ctrl.isValidInsightVariant($ctrl.insight, \'noHeat\')\" icon=long-cycle></svg-icon><svg-icon ng-if=\"$ctrl.isValidInsightVariant($ctrl.insight,\'shortCycle\')\" icon=short-cycle></svg-icon><svg-icon ng-if=\"$ctrl.isValidInsightVariant($ctrl.insight,\'noHeatAfterCalving\')\" icon=not-cycling></svg-icon></div></div><!-- TODO figure out how to add custom columns, like \"last estrus\". --><div ng-if=$ctrl.validationWidget class=\"col-xs-3 insemination-buttons text-right\"><!--\n    Pass the name of the previously cached validation widget name so\n    a new widget can be used per instance. Like a render prop in React,\n    but a crappy way. ^^ Note that ng-include has access to the local\n    scope so \"insight\" will be available automagically in the widget.\n    --><ng-include src=$ctrl.validationWidget></ng-include></div></div>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/missingEstrusInsights/list/missingEstrusInsightList.html","<div class=\"non-cyclic-list workflow-section\"><list-header icon={{$ctrl.icon}} title=\"{{$ctrl.getHeaderContent($ctrl.variant+\'-title\')}}\" description=\"{{$ctrl.getHeaderContent($ctrl.variant+\'-description\')}}\" disabled></list-header><div class=loading-hover ng-show=$ctrl.fetching><loading-bar></loading-bar></div><div class=\"table-list table-list-lg\"><div class=\"table-list-heading table-list-heading-minimal\"><div class=row><div ng-if=$ctrl.herdList.length class=\"col-xs-3 badge-not-visible truncate-text\">{{\"LABEL_TEXT_HERD_COW\" | translate}}</div><div ng-class=$ctrl.getCowHeaderColumnClassNames()>{{\"LABEL_TEXT_COW\" | translate}}</div><div ng-class=$ctrl.getDIMColumnClassName() class=text-center>{{\"d.i.m\" | translate}}</div><div class=col-xs-2></div><div ng-if=$ctrl.validationWidget class=\"col-xs-3 text-right truncate-text\">{{\"LABEL_TEXT_VALIDATION_WIDGET\" | translate}}</div></div></div><!-- .table-list-heading --><div class=table-list-items><div class=table-list-item ng-if=!$ctrl.insightList.length><div class=row><div class=\"col-xs-12 align-center no-cows\">{{\"LABEL_TEXT_NO_COWS\" | translate}}...</div></div></div><div class=table-list-item ng-if=$ctrl.insightList.length ng-repeat=\"insight in $ctrl.insightList\"><missing-estrus-insight-entry insight=insight herd-list=$ctrl.herdList validation-widget=$ctrl.validationWidget validate-and-resolve=$ctrl.validateAndResolve></missing-estrus-insight-entry></div><!-- .table-list-item --></div><!-- .table-list-items --></div><!-- .table-list --></div><generic-modal modal-content-type=missing-estrus-modal data=$ctrl.currentActiveInsight ng-if=$ctrl.currentActiveInsight modal-visible=$ctrl.showModal hide-modal=$ctrl.toggleModal() options=\"{valid: $ctrl.currentlyValid}\"></generic-modal>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/sensorAlerts/entry/sensorAlertEntry.html","<div class=\"x-flex x-direction-row sensor-alert-column-headers\" ng-if=$ctrl.first><div ng-if=$ctrl.withHerdGroup class=\"x-box x-shrink-0 insight-list-column column-area badge-space\">{{$ctrl.getTranslatedContent(\'column-title\', \'area\')}}</div><div class=\"x-box x-shrink-0 insight-list-column column-cow\" ng-class=\"($ctrl.withHerdGroup ? \'\' : \'badge-space\')\">{{$ctrl.getTranslatedContent(\'column-title\', \'cow\')}}</div><div class=\"x-box insight-list-column column-alert\" ng-if=\"$ctrl.isMainListInsight() || $ctrl.isSecondaryListInsight()\">{{$ctrl.getTranslatedContent(\'column-title\', \'alert\')}}</div><div class=\"x-box insight-list-column column-resolution\" ng-if=\"!$ctrl.isMainListInsight() && !$ctrl.isSecondaryListInsight()\">{{$ctrl.getTranslatedContent(\'column-title\', \'resolution\')}}</div></div><list-entry class=sensor-alert-entry insight=$ctrl.insight><div class=\"x-flex x-direction-row x-align-center\"><div class=badge-container><badge ng-if=($ctrl.showBullet($ctrl.insight)) size=x-tiny color=curious-blue></badge></div><div ng-if=$ctrl.withHerdGroup class=\"x-box x-shrink-0 insight-list-column column-area\" ng-class=\"($ctrl.showBullet($ctrl.insight) ? null : \'area-container\')\"><strong>{{$ctrl.getHerdGroupName()}}</strong></div><div class=\"x-box x-shrink-0 insight-list-column column-cow text-truncate\"><strong>{{$ctrl.insight.dairyCow.cowTagNumber}}</strong></div><!-- main sensor insights list --><div class=\"x-box insight-list-column column-alert\" ng-if=\"$ctrl.isMainListInsight() || $ctrl.isSecondaryListInsight()\"><div class=\"x-flex x-direction-row x-align-center x-space-between\"><div class=flex><div class=x-box><svg-icon ng-class=$ctrl.getTypeName($ctrl.insight) icon=sensor-inverted></svg-icon></div><div ng-if=$ctrl.isResolved() class=\"x-box resolution\">{{$ctrl.getResolutions()}}</div><div class=x-box ng-if=!$ctrl.isResolved()>{{$ctrl.getTranslatedTitle()}}</div></div><div class=x-box><svg-icon icon=arrow></svg-icon></div></div></div><!-- resolved sensor insights --><div class=\"x-box insight-list-column column-resolution\" ng-if=\"!$ctrl.isMainListInsight() && !$ctrl.isSecondaryListInsight()\"><div class=\"x-flex x-direction-row x-align-center x-space-between\"><div class=\"x-flex x-direction-column\"><div ng-if=$ctrl.isResolved() class=\"x-box resolution\">{{$ctrl.getResolutions()}}</div><div class=\"x-box small\">{{$ctrl.getTranslatedTitle()}}</div></div><div class=x-box><svg-icon icon=arrow></svg-icon></div></div></div></div></list-entry>");
$templateCache.put("app/shared-components/angular-ui-components/modules/insightList/components/sensorAlerts/list/sensorAlertList.html","<section class=sensor-alert-list><list-header ng-if=\"$ctrl.variant === \'main-list\' || $ctrl.variant === \'secondary-list\'\" icon=sensor title=\"{{$ctrl.getHeaderContent($ctrl.variant + \'-title\', { count: $ctrl.insightList.length })}}\" description=\"{{$ctrl.getHeaderContent($ctrl.variant + \'-description\', { count: $ctrl.insightList.length })}}\"></list-header><section class=list-entries><sensor-alert-entry ng-repeat=\"insight in $ctrl.insightList\" first=$first insight=insight variant=$ctrl.variant with-herd-group=$ctrl.withHerdGroups></sensor-alert-entry></section><list-status variant=info ng-if=!$ctrl.insightList.length>{{$ctrl.getTranslatedContent(\'list-status\', \'empty\')}}</list-status></section>");}]);